const { useState, useEffect, useMemo, useRef, useCallback } = React;
        const BASE_PATH = '';
        const API_BASE = '/api';
        const MODERATOR_ID = '345967666';
        const OWN_PROJECT_MANAGER_IDS = new Set([MODERATOR_ID, '89907227']);
        const MOSPRIYUT_STYLE_PROJECT_IDS = new Set(['mospriyut', 'parents']);
        const BATCH_IMPORT_PROJECT_IDS = new Set(['mospriyut', 'parents']);
        const LIGHT_CATALOG_PROJECT_IDS = new Set(['mospriyut', 'parents']);
        const STRUCTURED_PARTICIPANTS_PROJECT_IDS = new Set(['parents']);
        const CATALOG_PAGE_SIZE = 100;
        const SUMMARY_TABLE_PAGE_SIZE = 200;
        const PARENTS_DASHBOARD_PAGE_SIZE = 100;
        const SEARCH_INPUT_DEBOUNCE_MS = 320;
        const FACET_OPTION_RENDER_LIMIT_DEFAULT = 120;
        const FACET_OPTION_RENDER_LIMIT_SEARCH = 200;
        const PARENTS_STATS_RESPONSE_VERSION = 'occupations_v5_statistics_quality_v2_event_date_guard';
        const PARENTS_CHAINS_RESPONSE_VERSION = 'chains_v16_conservative_rospis_v4';
        const PARENTS_CHAINS_PAGE_SIZE = 50;
        const PARENTS_ANCESTRY_RESPONSE_VERSION = 'ancestry_v21_conservative_rospis_v4';
        const PARENTS_ANCESTRY_PAGE_SIZE = 80;
        const PARENTS_DATA_UPDATED_EVENT = 'yarchiver:parents-data-updated';
        const GOOGLE_IDENTITY_SCRIPT_SRC = 'https://accounts.google.com/gsi/client';
        const ECHARTS_SCRIPT_SRC = 'https://cdn.jsdelivr.net/npm/echarts@5/dist/echarts.min.js';
        const DEFAULT_AUTH_PROVIDERS = {
            telegram: { enabled: true },
            google: { enabled: false, client_id: '', hosted_domain: '' }
        };
        let echartsLoaderPromise = null;
        const parentsDashboardStateCache = new Map();
        const parentsStatsStateCache = new Map();
        const parentsStatsDrilldownStateCache = new Map();
        const parentsStatsLookupStateCache = new Map();
        const parentsAncestryListStateCache = new Map();
        const parentsAncestryDetailStateCache = new Map();

        // === UTILS ===
        const rememberBoundedCacheValue = (cache, key, value, maxEntries = 80) => {
            if (!(cache instanceof Map)) return;
            if (cache.has(key)) cache.delete(key);
            cache.set(key, value);
            while (cache.size > maxEntries) {
                const oldestKey = cache.keys().next().value;
                if (oldestKey === undefined) break;
                cache.delete(oldestKey);
            }
        };

        const invalidateParentsScopedCache = (cache, projectId, parishId = '') => {
            if (!(cache instanceof Map)) return;
            const normalizedProjectId = String(projectId || '').trim();
            const normalizedParishId = String(parishId || '').trim();
            for (const key of Array.from(cache.keys())) {
                try {
                    const params = new URLSearchParams(String(key || ''));
                    if (String(params.get('pid') || '').trim() !== normalizedProjectId) continue;
                    if (String(params.get('parish_id') || '').trim() !== normalizedParishId) continue;
                    cache.delete(key);
                } catch (error) {}
            }
        };

        const normalizeText = (t) => {
            if (!t) return '';
            const r = {'ѣ':'е','ѳ':'ф','і':'и','ѵ':'и','ъ':'','ё':'е'};
            let s = t.toLowerCase();
            for(let k in r) s = s.split(k).join(r[k]);
            return s;
        };

        const STRUCTURED_ENTRY_TYPE_LABELS = {
            BIRTH: 'Рождение',
            MARRIAGE: 'Брак',
            WEDDING: 'Брак',
            DEATH: 'Смерть'
        };

        const STRUCTURED_PERSON_STATUS_LABELS = {
            BORN: 'Ребёнок',
            FATHER: 'Отец',
            MOTHER: 'Мать',
            GODFATHER: 'Крёстный отец',
            GODMOTHER: 'Крёстная мать',
            OTHER: 'Другой участник',
            BRIDE: 'Невеста',
            GROOM: 'Жених',
            DECEASED: 'Умерший',
            WITNESS: 'Свидетель'
        };
        const STRUCTURED_PERSON_STATUS_OPTIONS = [
            { value: '', label: 'Не указана' },
            { value: 'BORN', label: 'Ребёнок' },
            { value: 'FATHER', label: 'Отец' },
            { value: 'MOTHER', label: 'Мать' },
            { value: 'GODFATHER', label: 'Крёстный отец' },
            { value: 'GODMOTHER', label: 'Крёстная мать' },
            { value: 'GROOM', label: 'Жених' },
            { value: 'BRIDE', label: 'Невеста' },
            { value: 'WITNESS', label: 'Свидетель / поручитель' },
            { value: 'DECEASED', label: 'Умерший' },
            { value: 'OTHER', label: 'Другой участник' }
        ];
        const STRUCTURED_PERSON_SEX_OPTIONS = [
            { value: '', label: 'Не указан' },
            { value: 'MALE', label: 'Мужской' },
            { value: 'FEMALE', label: 'Женский' }
        ];
        const STRUCTURED_PERSON_FIELD_CONFIG = [
            { key: 'status', label: 'Роль', type: 'select', options: STRUCTURED_PERSON_STATUS_OPTIONS },
            { key: 'sex', label: 'Пол', type: 'select', options: STRUCTURED_PERSON_SEX_OPTIONS },
            { key: 'name', label: 'Имя', placeholder: 'Анна' },
            { key: 'second_name', label: 'Отчество', placeholder: 'Иванова' },
            { key: 'surname', label: 'Фамилия', placeholder: 'Соколова' },
            { key: 'age', label: 'Возраст', placeholder: '24 года' },
            { key: 'info', label: 'Статус / занятие', placeholder: 'крестьянская девица' },
            { key: 'geo', label: 'География', placeholder: 'деревни Макшина, Завидовской волости' },
            { key: 'other_status', label: 'Примечание / роль', placeholder: 'отец умершего' }
        ];

        const formatStructuredEntryType = (type) => STRUCTURED_ENTRY_TYPE_LABELS[String(type || '').toUpperCase()] || (type ? String(type) : 'Событие');
        const formatStructuredPersonStatus = (status) => STRUCTURED_PERSON_STATUS_LABELS[String(status || '').toUpperCase()] || (status ? String(status) : 'Участник');
        const formatStructuredPersonName = (person) => [person?.name, person?.second_name, person?.surname].map(part => String(part || '').trim()).filter(Boolean).join(' ');
        const cleanStructuredValue = (value) => String(value ?? '').trim();
        const splitParentsGeoPartsClient = (geo) => cleanStructuredValue(geo).split(/\s*,\s*/).map(part => part.trim()).filter(Boolean);
        const isParentSamePlaceLabelClient = (value) => {
            const normalized = normalizeText(value || '').trim();
            return normalized.startsWith('та же ') || normalized.startsWith('то же ') || normalized.startsWith('тот же ');
        };
        const normalizeParentsLocalityLabelClient = (value) => {
            const text = cleanStructuredValue(value).replace(/^[\s,.;:]+|[\s,.;:]+$/g, '');
            if (!text) return '';
            const lowered = normalizeText(text);
            const replacements = [
                [/^(?:города|город|гор\.)\s+/i, 'город '],
                [/^(?:деревни|деревня|дер\.|д\.)\s+/i, 'деревня '],
                [/^(?:села|село|с\.)\s+/i, 'село '],
                [/^(?:слободы|слобода)\s+/i, 'слобода '],
                [/^(?:сельца|сельцо)\s+/i, 'сельцо '],
                [/^(?:посада|посад)\s+/i, 'посад '],
            ];
            for (const [pattern, prefix] of replacements) {
                if (pattern.test(lowered)) {
                    const remainder = text.replace(pattern, '').trim();
                    return cleanStructuredValue(`${prefix}${remainder}`);
                }
            }
            return text;
        };
        const extractParentLocalitiesFromGeoClient = (geo) => {
            const parts = splitParentsGeoPartsClient(geo);
            const localities = [];
            for (const part of parts) {
                const normalized = normalizeText(part);
                if (
                    normalized.startsWith('город ')
                    || normalized.startsWith('гор. ')
                    || normalized.startsWith('города ')
                    || normalized.startsWith('деревня ')
                    || normalized.startsWith('деревни ')
                    || normalized.startsWith('дер. ')
                    || normalized.startsWith('д. ')
                    || normalized.startsWith('село ')
                    || normalized.startsWith('села ')
                    || normalized.startsWith('с. ')
                    || normalized.startsWith('слобода ')
                    || normalized.startsWith('слободы ')
                    || normalized.startsWith('сельцо ')
                    || normalized.startsWith('сельца ')
                    || normalized.startsWith('посад ')
                    || normalized.endsWith(' посад')
                ) {
                    const label = normalizeParentsLocalityLabelClient(part);
                    if (label) localities.push(label);
                }
            }
            if (!localities.length && parts.length) {
                const lastPart = parts[parts.length - 1];
                const label = normalizeParentsLocalityLabelClient(lastPart);
                if (label && normalizeText(label) !== normalizeText(lastPart)) {
                    localities.push(label);
                }
            }
            const result = [];
            const seen = new Set();
            localities.forEach((label) => {
                const key = normalizeText(label);
                if (!key || seen.has(key)) return;
                seen.add(key);
                result.push({ key, label });
            });
            return result;
        };
        const extractParentGovernorateLabelFromGeoClient = (geo) => {
            for (const part of splitParentsGeoPartsClient(geo)) {
                if (normalizeText(part).includes('губ')) return cleanStructuredValue(part);
            }
            return '';
        };
        const extractParentUyezdLabelFromGeoClient = (geo) => {
            for (const part of splitParentsGeoPartsClient(geo)) {
                if (normalizeText(part).includes('уезд')) return cleanStructuredValue(part);
            }
            return '';
        };
        const extractParentStatsLocalityLabelFromGeoClient = (geo) => {
            const localityEntries = extractParentLocalitiesFromGeoClient(geo);
            if (localityEntries.length) return cleanStructuredValue(localityEntries[localityEntries.length - 1]?.label || '');
            const geoParts = splitParentsGeoPartsClient(geo);
            if (geoParts.length === 1 && !isParentSamePlaceLabelClient(geoParts[0])) {
                return cleanStructuredValue(geoParts[0]);
            }
            return '';
        };
        const doesStructuredPersonMatchEditorField = (person, field, groupKey, groupLabel = '') => {
            const normalizedField = cleanStructuredValue(field).toLowerCase();
            const normalizedGroupKey = cleanStructuredValue(groupKey);
            const normalizedGroupLabel = normalizeText(cleanStructuredValue(groupLabel));
            if (!normalizedField || !normalizedGroupKey) return false;
            if (!person || typeof person !== 'object') return false;
            if (normalizedField === 'locality') {
                const localityEntries = extractParentLocalitiesFromGeoClient(person.geo);
                const localityLabel = extractParentStatsLocalityLabelFromGeoClient(person.geo);
                return localityEntries.some(entry => (
                    entry.key === normalizedGroupKey
                    || (normalizedGroupLabel && normalizeText(entry.label) === normalizedGroupLabel)
                )) || normalizeText(localityLabel) === normalizedGroupKey || (normalizedGroupLabel && normalizeText(localityLabel) === normalizedGroupLabel);
            }
            if (normalizedField === 'governorate' || normalizedField === 'groom_governorate' || normalizedField === 'bride_governorate') {
                const valueKey = normalizeText(extractParentGovernorateLabelFromGeoClient(person.geo));
                return valueKey === normalizedGroupKey || (normalizedGroupLabel && valueKey === normalizedGroupLabel);
            }
            if (normalizedField === 'uyezd') {
                const valueKey = normalizeText(extractParentUyezdLabelFromGeoClient(person.geo));
                return valueKey === normalizedGroupKey || (normalizedGroupLabel && valueKey === normalizedGroupLabel);
            }
            if (normalizedField === 'occupation') {
                const valueKey = normalizeText(cleanStructuredValue(person.info));
                return valueKey === normalizedGroupKey || (normalizedGroupLabel && valueKey === normalizedGroupLabel);
            }
            if (normalizedField === 'name') {
                const valueKey = normalizeText(cleanStructuredValue(person.name));
                return valueKey === normalizedGroupKey || (normalizedGroupLabel && valueKey === normalizedGroupLabel);
            }
            if (normalizedField === 'surname') {
                const valueKey = normalizeText(cleanStructuredValue(person.surname));
                return valueKey === normalizedGroupKey || (normalizedGroupLabel && valueKey === normalizedGroupLabel);
            }
            return false;
        };
        const resolveStructuredPersonIndexForEditorTarget = (entryPeople, target) => {
            const people = Array.isArray(entryPeople) ? entryPeople : [];
            if (!people.length) return -1;
            const preferredStatuses = (target?.preferredStatuses || [])
                .map(value => cleanStructuredValue(value).toUpperCase())
                .filter(Boolean);
            const matchField = cleanStructuredValue(target?.matchField).toLowerCase();
            const matchGroupKey = cleanStructuredValue(target?.matchGroupKey);
            const matchLabel = cleanStructuredValue(target?.matchLabel);

            if (matchField && matchGroupKey) {
                const matchingIndices = people
                    .map((person, index) => ({ person, index }))
                    .filter(({ person }) => doesStructuredPersonMatchEditorField(person, matchField, matchGroupKey, matchLabel))
                    .map(({ index }) => index);
                if (matchingIndices.length) {
                    const preferredMatch = matchingIndices.find(index => preferredStatuses.includes(cleanStructuredValue(people[index]?.status).toUpperCase()));
                    return Number.isInteger(preferredMatch) ? preferredMatch : matchingIndices[0];
                }
            }

            let personIndex = Number(target?.personIndex);
            if (!Number.isInteger(personIndex) || personIndex < 0) {
                personIndex = people.findIndex(person => preferredStatuses.includes(cleanStructuredValue(person?.status).toUpperCase()));
            }
            if (personIndex < 0) {
                personIndex = 0;
            }
            return people[personIndex] ? personIndex : -1;
        };
        const createEmptyStructuredPersonDraft = () => Object.fromEntries(
            STRUCTURED_PERSON_FIELD_CONFIG.map(field => [field.key, ''])
        );
        const normalizeStructuredPersonDraft = (draft) => {
            const normalized = createEmptyStructuredPersonDraft();
            if (!draft || typeof draft !== 'object') return normalized;
            STRUCTURED_PERSON_FIELD_CONFIG.forEach(field => {
                normalized[field.key] = String(draft[field.key] || '').trim();
            });
            return normalized;
        };
        const getStructuredPersonOriginal = (person) => normalizeStructuredPersonDraft(person?.original || person);
        const isStructuredPersonEdited = (person) => {
            if (!person) return false;
            if (person.edited_at || person.edited_by) return true;
            const current = normalizeStructuredPersonDraft(person);
            const original = getStructuredPersonOriginal(person);
            return STRUCTURED_PERSON_FIELD_CONFIG.some(field => current[field.key] !== original[field.key]);
        };
        const hasStructuredEntryManualDeathCause = (entry) => {
            const source = entry || {};
            return Object.prototype.hasOwnProperty.call(source, 'death_cause')
                || Object.prototype.hasOwnProperty.call(source, 'death_cause_original')
                || Boolean(source?.death_cause_edited_at || source?.death_cause_edited_by);
        };
        const normalizeStructuredEntryDeathCauseValue = (value) => String(value ?? '').trim();
        const getStructuredEntryResolvedDeathCause = (entry) => {
            const source = entry || {};
            if (Object.prototype.hasOwnProperty.call(source, 'resolved_death_cause')) {
                return normalizeStructuredEntryDeathCauseValue(source.resolved_death_cause);
            }
            if (Object.prototype.hasOwnProperty.call(source, 'death_cause')) {
                return normalizeStructuredEntryDeathCauseValue(source.death_cause);
            }
            return '';
        };
        const getStructuredEntryOriginalDeathCause = (entry) => {
            const source = entry || {};
            if (Object.prototype.hasOwnProperty.call(source, 'death_cause_original')) {
                return normalizeStructuredEntryDeathCauseValue(source.death_cause_original);
            }
            return getStructuredEntryResolvedDeathCause(source);
        };
        const isStructuredEntryDeathCauseEdited = (entry) => hasStructuredEntryManualDeathCause(entry);
        const STRUCTURED_ENTRY_PRIMARY_DATE_KINDS = {
            BIRTH: 'birth',
            WEDDING: 'marriage',
            MARRIAGE: 'marriage',
            DEATH: 'death',
        };
        const getStructuredEntryPrimaryDateKind = (entry) => (
            STRUCTURED_ENTRY_PRIMARY_DATE_KINDS[String(entry?.type || '').trim().toUpperCase()] || ''
        );
        const getStructuredEntryPrimaryDateRecord = (entry) => {
            const kind = getStructuredEntryPrimaryDateKind(entry);
            const record = kind ? entry?.event_dates?.[kind] : null;
            return record && typeof record === 'object' ? record : null;
        };
        const getStructuredEntryPrimaryDateValue = (entry) => (
            String(getStructuredEntryPrimaryDateRecord(entry)?.date || '').trim()
        );
        const getStructuredEntryOriginalDateRecord = (entry) => {
            const record = getStructuredEntryPrimaryDateRecord(entry);
            return record?.original && typeof record.original === 'object' ? record.original : record;
        };
        const isStructuredEntryEventDateEdited = (entry) => {
            const record = getStructuredEntryPrimaryDateRecord(entry);
            return Boolean(record && (
                record.original
                || record.edited_at
                || String(record.source || '').trim().toLowerCase() === 'manual'
            ));
        };
        const getStructuredEntryDateFieldLabel = (entryType) => {
            const type = String(entryType || '').trim().toUpperCase();
            if (type === 'BIRTH') return 'Точная дата рождения';
            if (type === 'WEDDING' || type === 'MARRIAGE') return 'Точная дата брака';
            if (type === 'DEATH') return 'Точная дата смерти';
            return 'Точная дата события';
        };
        const getStructuredPersonStatus = (person) => String(person?.status || '').toUpperCase();
        const getStructuredPersonRoleText = (person) => normalizeText([person?.other_status, person?.info].filter(Boolean).join(' '));
        const isDeceasedFatherRole = (person) => {
            const roleText = getStructuredPersonRoleText(person);
            return /^отец\s*умерш/.test(roleText);
        };
        const isDeceasedMotherRole = (person) => {
            const roleText = getStructuredPersonRoleText(person);
            return /^мать\s*умерш/.test(roleText);
        };
        const getStructuredPersonSortPriority = (entryType, person) => {
            const type = String(entryType || '').toUpperCase();
            const status = getStructuredPersonStatus(person);
            if (type === 'BIRTH') {
                if (status === 'BORN') return 10;
                if (status === 'FATHER') return 20;
                if (status === 'MOTHER') return 30;
                if (status === 'GODFATHER' || status === 'GODMOTHER') return 40;
                return 90;
            }
            if (type === 'WEDDING' || type === 'MARRIAGE') {
                if (status === 'GROOM') return 10;
                if (status === 'BRIDE') return 20;
                if (status === 'WITNESS') return 30;
                return 90;
            }
            if (type === 'DEATH') {
                if (status === 'DECEASED') return 10;
                if (status === 'FATHER' || isDeceasedFatherRole(person)) return 20;
                if (status === 'MOTHER' || isDeceasedMotherRole(person)) return 21;
                return 90;
            }
            return 90;
        };
        const orderStructuredPeopleWithMeta = (entryType, people) => (Array.isArray(people) ? people : [])
            .map((person, index) => ({ person, index }))
            .sort((a, b) => {
                const priorityDelta = getStructuredPersonSortPriority(entryType, a.person) - getStructuredPersonSortPriority(entryType, b.person);
                return priorityDelta || a.index - b.index;
            });
        const orderStructuredPeople = (entryType, people) => orderStructuredPeopleWithMeta(entryType, people).map(({ person }) => person);
        const PARENTS_DASHBOARD_EVENT_TABS = ['BIRTH', 'WEDDING', 'DEATH'];
        const joinLabels = (values) => (Array.isArray(values) ? values.filter(Boolean).join(', ') : '');

        // Имя + занятие на отдельной строке (приглушённый курсив).
        // Используется в колонках «Отец»/«Мать» дашборда рождений.
        const renderParentsPersonWithOccupation = (highlight, name, occupation) => {
            const cleanName = String(name || '').trim();
            const cleanOcc = String(occupation || '').trim();
            if (!cleanName && !cleanOcc) return highlight('');
            if (!cleanOcc) return highlight(cleanName);
            return (
                <div className="flex flex-col gap-0.5 leading-tight">
                    <span>{highlight(cleanName)}</span>
                    <span className="text-[10px] italic text-[#9b7a52] tracking-[0.01em]">{highlight(cleanOcc)}</span>
                </div>
            );
        };

        // Имя ребёнка + сведения о связанных смертях. Каждая смерть кликабельна —
        // по клику открывается оверлей каталога с этой записью.
        const renderParentsChildWithDeaths = (highlight, row, onOpenRecord) => {
            const cleanName = String(row?.childName || '').trim();
            const deaths = Array.isArray(row?.linkedDeathRows) ? row.linkedDeathRows.filter(d => d && (d.label || d.itemId)) : [];
            if (!cleanName && !deaths.length) return highlight('');
            return (
                <div className="flex flex-col gap-0.5 leading-tight">
                    {cleanName && <span>{highlight(cleanName)}</span>}
                    {deaths.map((d, i) => {
                        const label = String(d.label || d.deceasedName || '').trim();
                        if (!label) return null;
                        const clickable = Boolean(onOpenRecord && d.itemId);
                        const props = clickable ? {
                            role: 'button',
                            tabIndex: 0,
                            onClick: (e) => {
                                e.stopPropagation();
                                onOpenRecord({
                                    itemId: d.itemId,
                                    itemUrl: d.itemUrl,
                                    parishId: row?.parishId,
                                    label,
                                    personLabel: d.deceasedName,
                                });
                            },
                            onKeyDown: (e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onOpenRecord({
                                        itemId: d.itemId,
                                        itemUrl: d.itemUrl,
                                        parishId: row?.parishId,
                                        label,
                                        personLabel: d.deceasedName,
                                    });
                                }
                            },
                            className: 'text-[10px] italic text-[#8b0000] tracking-[0.01em] cursor-pointer hover:underline decoration-dotted underline-offset-2',
                            title: 'Открыть запись о смерти',
                        } : {
                            className: 'text-[10px] italic text-[#9b7a52] tracking-[0.01em]',
                        };
                        return (
                            <span key={`death-${i}-${d.rowId || d.itemId || label}`} {...props}>
                                † {highlight(label)}
                            </span>
                        );
                    })}
                </div>
            );
        };
        const renderParentsDashboardEventDate = (highlight, row) => {
            const primary = String(row?.eventDateLabel || row?.eventYearLabel || row?.year || '—').trim();
            const secondary = String(row?.secondaryEventDateLabel || '').trim();
            const secondaryType = String(row?.secondaryEventDateTypeLabel || '').trim();
            if (!secondary) return highlight(primary);
            return (
                <div className="flex flex-col gap-0.5 leading-tight">
                    <span>{highlight(primary)}</span>
                    <span className="text-[10px] italic text-[#9b7a52] tracking-[0.01em]">
                        {secondaryType ? `${secondaryType}: ` : ''}{highlight(secondary)}
                    </span>
                </div>
            );
        };
        const PARENTS_DATA_QUALITY_WARNING_LABELS = {
            death_cause_adjacent_row_value_ignored: 'Рядом обнаружена другая причина смерти, относящаяся к соседней строке. Она не использована автоматически.',
            death_cause_merged_ocr_rows_split: 'OCR склеил причины смерти из соседних строк. Для этой записи выбрана часть, совпадающая с её строкой.',
            death_cause_multiple_categories_detected: 'OCR-фрагмент содержит несколько разных причин смерти. Нужно сверить строку с оригиналом.',
            death_cause_multiple_explicit_values: 'OCR содержит несколько оборотов «от …»: возможна склейка строк или составная причина.',
            death_cause_long_noisy_fragment: 'В причину смерти мог попасть длинный текст из соседней колонки.',
            death_cause_old_age_child_conflict: 'Причина «старость» не согласуется с детским возрастом. Возможна ошибка OCR, возраста или привязки строки.',
            death_cause_fallback_without_direct_ocr_candidate: 'Причина найдена резервным поиском, но не привязана к чёткому OCR-фрагменту этой строки.',
            death_cause_non_cause_text_rejected: 'OCR-фрагмент похож на имя, титул или служебный текст, а не на причину смерти. Автоматическое значение отброшено.',
            death_cause_ocr_spelling_uncertain: 'Причина смерти распознана по неуверенному OCR-варианту. Сверьте её с оригиналом.',
            manual_death_cause_conflicts_with_row_ocr: 'Ручная причина смерти не совпадает с OCR этой строки.',
        };
        const ParentsDataQualityWarning = ({ row, onEdit = null }) => {
            const reasonKeys = Array.isArray(row?.deathCauseWarningKeys) ? row.deathCauseWarningKeys : [];
            if (!row?.deathCauseWarning && !reasonKeys.length) return null;
            const messages = reasonKeys.map(key => PARENTS_DATA_QUALITY_WARNING_LABELS[key] || key);
            const ocrRaw = String(row?.deathCauseOcrRaw || '').trim();
            const adjacentCause = String(row?.deathCauseAdjacentCandidate || '').trim();
            const title = [
                ...messages,
                ocrRaw ? `OCR: ${ocrRaw}` : '',
                adjacentCause ? `Соседняя строка: ${adjacentCause}` : '',
                row?.deathCause ? `Сейчас показано: ${row.deathCause}` : '',
                onEdit ? 'Нажмите, чтобы проверить и исправить запись.' : '',
            ].filter(Boolean).join('\n');
            const className = 'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-amber-400 bg-amber-50 text-[14px] font-bold text-amber-800 shadow-sm';
            if (onEdit) {
                return (
                    <button type="button" className={`${className} hover:bg-amber-100`} title={title} aria-label="Причина смерти требует проверки" onClick={onEdit}>
                        ⚠
                    </button>
                );
            }
            return <span className={className} title={title} aria-label="Причина смерти требует проверки">⚠</span>;
        };
        const PARENTS_DASHBOARD_EVENT_CONFIG = {
            BIRTH: {
                tabLabel: 'Рождения',
                title: 'Дашборд рождений',
                description: 'Здесь можно собирать детей одной пары родителей, смотреть найденные сведения о смерти и объединять рождения по одному населенному пункту.',
                totals: { rows: 'Рождений', primary: 'Пар родителей', secondary: 'Смертей', localities: 'Локальностей' },
                facetPrimary: { title: 'Пара родителей', subtitle: 'Собирает детей одной семьи по отцу и матери.', chipLabel: 'Родители', previewTitle: 'Дети выбранной пары' },
                facetSecondary: { title: 'Сведения о смерти', subtitle: 'Можно найти всех детей, для которых уже вычислена вероятная запись о смерти.', chipLabel: 'Смерть' },
                facetLocality: { title: 'Населённый пункт', subtitle: 'Объединяет записи по деревне, селу, городу или посаду.', chipLabel: 'Населённый пункт' },
                searchHelp: 'Ищет по ребенку, родителям, сведениям о смерти, населенному пункту, шифру дела и странице.',
                previewLabel: (row) => row?.childName || 'Без имени',
                columns: [
                    { key: 'cipher', label: 'Шифр дела', render: (row, highlight) => highlight(row?.cipherLabel) },
                    { key: 'page', label: 'Страница', render: (row, highlight) => highlight(row?.pageLabel), className: 'font-bold text-[#8b0000] whitespace-nowrap min-w-[64px]' },
                    { key: 'eventYear', label: 'Дата рождения', render: (row, highlight) => renderParentsDashboardEventDate(highlight, row), className: 'whitespace-nowrap min-w-[128px]' },
                    { key: 'child', label: 'Ребёнок', render: (row, highlight, helpers) => renderParentsChildWithDeaths(highlight, row, helpers?.onOpenRecord), className: 'min-w-[200px]' },
                    { key: 'father', label: 'Отец', render: (row, highlight) => renderParentsPersonWithOccupation(highlight, row?.fatherName, row?.fatherOccupation) },
                    { key: 'mother', label: 'Мать', render: (row, highlight) => renderParentsPersonWithOccupation(highlight, row?.motherName, row?.motherOccupation) },
                    { key: 'locality', label: 'Населённый пункт', render: (row, highlight) => highlight(row?.primaryLocalityLabel || joinLabels(row?.localityLabels)), className: 'min-w-[180px]' },
                ]
            },
            WEDDING: {
                tabLabel: 'Браки',
                title: 'Дашборд браков',
                description: 'Здесь можно собирать записи одной пары супругов, искать по свидетелям и смотреть браки по одному населенному пункту.',
                totals: { rows: 'Браков', primary: 'Пар супругов', secondary: 'Свидетелей', localities: 'Локальностей' },
                facetPrimary: { title: 'Пара супругов', subtitle: 'Собирает записи по одной паре жениха и невесты.', chipLabel: 'Пара супругов', previewTitle: 'Записи выбранной пары' },
                facetSecondary: { title: 'Свидетель', subtitle: 'Можно найти все браки, где участвовал один и тот же свидетель.', chipLabel: 'Свидетель' },
                facetLocality: { title: 'Населённый пункт', subtitle: 'Объединяет записи по деревне, селу, городу или посаду.', chipLabel: 'Населённый пункт' },
                searchHelp: 'Ищет по жениху, невесте, свидетелям, населенному пункту, шифру дела и странице.',
                previewLabel: (row) => row?.previewLabel || row?.spousePairLabel || 'Без пары',
                columns: [
                    { key: 'cipher', label: 'Шифр дела', render: (row, highlight) => highlight(row?.cipherLabel) },
                    { key: 'page', label: 'Страница', render: (row, highlight) => highlight(row?.pageLabel), className: 'font-bold text-[#8b0000] whitespace-nowrap min-w-[64px]' },
                    { key: 'eventYear', label: 'Дата брака', render: (row, highlight) => renderParentsDashboardEventDate(highlight, row), className: 'whitespace-nowrap min-w-[128px]' },
                    { key: 'groom', label: 'Жених', render: (row, highlight) => renderParentsPersonWithOccupation(highlight, row?.groomName, row?.groomOccupation) },
                    { key: 'groomAge', label: 'Возраст жениха', render: (row, highlight) => highlight(row?.groomAge), className: 'whitespace-nowrap min-w-[92px]' },
                    { key: 'bride', label: 'Невеста', render: (row, highlight) => renderParentsPersonWithOccupation(highlight, row?.brideName, row?.brideOccupation) },
                    { key: 'brideAge', label: 'Возраст невесты', render: (row, highlight) => highlight(row?.brideAge), className: 'whitespace-nowrap min-w-[98px]' },
                    { key: 'secondary', label: 'Свидетели', render: (row, highlight) => highlight(joinLabels(row?.secondaryLabels)), className: 'min-w-[220px]' },
                    { key: 'locality', label: 'Населённый пункт', render: (row, highlight) => highlight(row?.primaryLocalityLabel || joinLabels(row?.localityLabels)), className: 'min-w-[190px]' },
                ]
            },
            DEATH: {
                tabLabel: 'Смерти',
                title: 'Дашборд смертей',
                description: 'Здесь можно собирать записи об одном умершем, искать по связанным лицам и смотреть смерти по одному населенному пункту.',
                totals: { rows: 'Смертей', primary: '', secondary: 'Связанных лиц', localities: 'Локальностей' },
                facetPrimary: { title: 'Умерший', subtitle: 'Собирает записи по одному умершему.', chipLabel: 'Умерший', previewTitle: 'Записи выбранного умершего' },
                facetSecondary: { title: 'Связанное лицо', subtitle: 'Можно найти смерти, где фигурирует один и тот же родственник или участник записи.', chipLabel: 'Связанное лицо' },
                facetLocality: { title: 'Населённый пункт', subtitle: 'Объединяет записи по деревне, селу, городу или посаду.', chipLabel: 'Населённый пункт' },
                searchHelp: 'Ищет по умершему, связанным лицам, населенному пункту, шифру дела и странице.',
                previewLabel: (row) => row?.deceasedName || 'Без имени',
                columns: [
                    { key: 'cipher', label: 'Шифр дела', render: (row, highlight) => highlight(row?.cipherLabel) },
                    { key: 'page', label: 'Страница', render: (row, highlight) => highlight(row?.pageLabel), className: 'font-bold text-[#8b0000] whitespace-nowrap min-w-[64px]' },
                    { key: 'eventYear', label: 'Дата смерти', render: (row, highlight) => renderParentsDashboardEventDate(highlight, row), className: 'whitespace-nowrap min-w-[128px]' },
                    { key: 'deceased', label: 'Умерший', render: (row, highlight) => renderParentsPersonWithOccupation(highlight, row?.deceasedName, row?.deceasedOccupation) },
                    { key: 'secondary', label: 'Связанные лица', render: (row, highlight) => highlight(joinLabels(row?.secondaryLabels)), className: 'min-w-[220px]' },
                    { key: 'age', label: 'Возраст', render: (row, highlight) => highlight(row?.deceasedAge), className: 'whitespace-nowrap min-w-[72px]' },
                    { key: 'locality', label: 'Населённый пункт', render: (row, highlight) => highlight(row?.primaryLocalityLabel || joinLabels(row?.localityLabels)), className: 'min-w-[190px]' },
                ]
            }
        };
        const PARENTS_LINK_TYPE_FILTERS = [
            { key: '', label: 'Все связи' },
            { key: 'MARRIAGE_TO_BIRTH', label: 'Брак родителей -> рождение' },
            { key: 'BIRTH_TO_DEATH', label: 'Рождение -> смерть' },
            { key: 'BIRTH_TO_WEDDING_PERSON', label: 'Рождение -> брак' },
            { key: 'BIRTH_TO_BIRTH_PARENT', label: 'Рождение -> рождение его ребёнка' },
            { key: 'BIRTH_TO_MOTHER_VIA_MARRIAGE', label: 'Рождение -> мать через её брак' },
        ];
        const PARENTS_LINK_PAGE_SIZE = 60;

        const highlightText = (text, query, options = {}) => {
            if (!text || !query) return text;
            const nQuery = normalizeText(query);
            const words = nQuery.split(/\s+/).filter(w => w.length > 0);
            let res = [text];
            let markSeq = 0;
            words.forEach(w => {
                let next = [];
                res.forEach(p => {
                    if (typeof p !== 'string') { next.push(p); return; }
                    const nPart = normalizeText(p);
                    let last = 0, idx = nPart.indexOf(w);
                    if (idx === -1) { next.push(p); } else {
                        while (idx !== -1) {
                            next.push(p.substring(last, idx));
                            next.push(<mark className="highlight-mark" key={`hl-${markSeq++}`}>{p.substring(idx, idx + w.length)}</mark>);
                            last = idx + w.length;
                            idx = nPart.indexOf(w, last);
                        }
                        next.push(p.substring(last));
                    }
                });
                res = next;
            });
            return <span className={options.preserveLineBreaks ? 'whitespace-pre-line' : undefined}>{res}</span>;
        };

        const DebouncedSearchField = React.memo(({
            value,
            onChange,
            delay = SEARCH_INPUT_DEBOUNCE_MS,
            placeholder = 'Найти...',
            className = ''
        }) => {
            const normalizedValue = String(value || '');
            const [draft, setDraft] = useState(normalizedValue);
            const lastCommittedRef = useRef(normalizedValue);
            const isFocusedRef = useRef(false);

            useEffect(() => {
                if (!isFocusedRef.current && normalizedValue !== lastCommittedRef.current) {
                    lastCommittedRef.current = normalizedValue;
                    setDraft(normalizedValue);
                }
            }, [normalizedValue]);

            useEffect(() => {
                const timer = window.setTimeout(() => {
                    const normalizedDraft = String(draft || '');
                    if (normalizedDraft !== normalizedValue) {
                        lastCommittedRef.current = normalizedDraft;
                        onChange(normalizedDraft);
                    }
                }, delay);
                return () => window.clearTimeout(timer);
            }, [draft, normalizedValue, onChange, delay]);

            return (
                <input
                    type="text"
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    onFocus={() => { isFocusedRef.current = true; }}
                    onBlur={() => { isFocusedRef.current = false; }}
                    placeholder={placeholder}
                    autoComplete="off"
                    spellCheck={false}
                    className={className}
                />
            );
        });

        const useDebouncedValue = (value, delay = SEARCH_INPUT_DEBOUNCE_MS) => {
            const [debouncedValue, setDebouncedValue] = useState(value);

            useEffect(() => {
                const timeoutId = window.setTimeout(() => {
                    setDebouncedValue(value);
                }, delay);
                return () => window.clearTimeout(timeoutId);
            }, [value, delay]);

            return debouncedValue;
        };

        const loadEcharts = () => {
            if (typeof window === 'undefined') {
                return Promise.reject(new Error('window is undefined'));
            }
            if (window.echarts) {
                return Promise.resolve(window.echarts);
            }
            if (echartsLoaderPromise) {
                return echartsLoaderPromise;
            }
            echartsLoaderPromise = new Promise((resolve, reject) => {
                const existing = document.querySelector(`script[data-echarts-loader="true"]`);
                if (existing) {
                    existing.addEventListener('load', () => resolve(window.echarts), { once: true });
                    existing.addEventListener('error', () => reject(new Error('echarts_load_failed')), { once: true });
                    return;
                }
                const script = document.createElement('script');
                script.src = ECHARTS_SCRIPT_SRC;
                script.async = true;
                script.defer = true;
                script.dataset.echartsLoader = 'true';
                script.onload = () => resolve(window.echarts);
                script.onerror = () => reject(new Error('echarts_load_failed'));
                document.head.appendChild(script);
            }).catch((error) => {
                echartsLoaderPromise = null;
                throw error;
            });
            return echartsLoaderPromise;
        };

        const ParentsDashboardFacetCard = React.memo(({
            title,
            subtitle,
            options,
            hiddenCount = 0,
            totalCount = 0,
            activeKey,
            onToggle,
            searchValue,
            onSearchChange,
            emptyText = 'Ничего не найдено',
            extraContent = null
        }) => (
            <div className="rounded-[26px] border border-stone-300 bg-white/95 shadow-[0_18px_55px_rgba(45,34,20,0.1)] overflow-hidden">
                <div className="border-b border-stone-200 bg-[#fdf8f0] px-5 py-4">
                    <div className="text-[10px] uppercase tracking-[0.18em] text-[#8b0000] font-bold">{title}</div>
                    <div className="mt-1 text-[11px] text-stone-500">{subtitle}</div>
                    <DebouncedSearchField
                        value={searchValue}
                        onChange={onSearchChange}
                        delay={SEARCH_INPUT_DEBOUNCE_MS}
                        placeholder="Найти..."
                        className="mt-3 w-full rounded-2xl border border-stone-200 bg-white px-3 py-2 text-[12px] text-stone-700 outline-none transition-colors placeholder:text-stone-400 focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                    />
                    {hiddenCount > 0 && (
                        <div className="mt-2 text-[11px] text-stone-400">
                            Показаны первые {options.length} из {totalCount || (options.length + hiddenCount)}. Уточни поиск, чтобы сузить список.
                        </div>
                    )}
                </div>
                <div className="max-h-[320px] overflow-y-auto p-3 space-y-2">
                    {options.length > 0 ? options.map(option => {
                        const active = activeKey === option.key;
                        return (
                            <button
                                key={option.key}
                                onClick={() => onToggle(active ? '' : option.key)}
                                className={`w-full text-left rounded-2xl border px-3 py-3 transition-colors ${active ? 'bg-[#8b0000] text-white border-[#8b0000]' : 'bg-[#fcfaf5] text-stone-700 border-stone-200 hover:border-[#8b0000] hover:bg-[#fff8f4]'}`}
                            >
                                <div className="flex items-start justify-between gap-3">
                                    <div className="text-[12px] leading-5 min-w-0">{option.label}</div>
                                    <div className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold ${active ? 'bg-white/15 text-white' : 'bg-stone-100 text-stone-500'}`}>{option.count}</div>
                                </div>
                            </button>
                        );
                    }) : (
                        <div className="rounded-2xl border border-dashed border-stone-300 bg-[#fcfaf5] px-4 py-6 text-center text-[12px] text-stone-400">
                            {emptyText}
                        </div>
                    )}
                </div>
                {extraContent}
            </div>
        ));

        const applyMospriyutOrthographyRules = (value) => {
            if (!value) return '';
            let text = String(value);
            text = text.replace(/[ѣ]/g, 'е').replace(/[Ѣ]/g, 'Е');
            text = text.replace(/[іi]/g, 'и').replace(/[ІI]/g, 'И');
            text = text.replace(/([А-Яа-яЁёѢѣІі]+)[Ъъ](?=(?:[\s.,;:!?()[\]{}"«»]|$))/g, '$1');
            return text;
        };

        const normalizeMospriyutSummaryValue = (value) => (
            applyMospriyutOrthographyRules(value).replace(/\s+/g, ' ').trim()
        );

        const MOSPRIYUT_SERVICE_ROW_VALUES = new Set([
            'лета',
            'какая беременность'
        ]);

        const isMospriyutOrderMarkerValue = (value) => {
            const normalized = normalizeText(normalizeMospriyutSummaryValue(value))
                .replace(/[^a-zа-я0-9№]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
            if (!normalized) return false;
            if (!normalized.includes('порядку')) return false;
            const residue = normalized
                .replace(/№+/g, ' ')
                .replace(/\d+/g, ' ')
                .replace(/\bпо\b/g, ' ')
                .replace(/\bпорядку\b/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
            return residue === '';
        };

        const isMospriyutServiceSnippetText = (value) => {
            const raw = normalizeMospriyutSummaryValue(value);
            if (!raw) return true;

            const lowered = raw.toLowerCase();
            const normalized = normalizeText(lowered)
                .replace(/[^a-zа-я0-9№]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();

            if (!normalized) return true;
            if (/^[№\s\d]+$/.test(raw)) return true;
            if (/^\d+$/.test(normalized)) return true;
            if (normalized.includes('имена и звание женщин')) return true;
            if (normalized.includes('имя и звание женщин')) return true;
            if (/^№+\s*по\s*порядку$/.test(lowered)) return true;
            if (normalized === 'по порядку') return true;
            if (isMospriyutOrderMarkerValue(raw)) return true;
            if (MOSPRIYUT_SERVICE_ROW_VALUES.has(normalized)) return true;
            return false;
        };

        const MONTH_NAME_TO_NUMBER = {
            'января': '01', 'февраля': '02', 'марта': '03', 'апреля': '04',
            'мая': '05', 'июня': '06', 'июля': '07', 'августа': '08',
            'сентября': '09', 'октября': '10', 'ноября': '11', 'декабря': '12'
        };
        const MONTH_SHORT_NAMES = ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];
        const MONTH_FULL_NAMES = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

        const parseItemDateParts = (item) => {
            const text = ((item?.date_label || '') + ' ' + (item?.issue || '')).trim();
            const dateMatch = text.match(/(\d{1,2})\s+(января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря)\s+(\d{4})/i);
            if (dateMatch) {
                return {
                    text,
                    day: dateMatch[1],
                    month: MONTH_NAME_TO_NUMBER[dateMatch[2].toLowerCase()] || null,
                    year: dateMatch[3]
                };
            }
            const yearMatch = text.match(/(\d{4})/);
            return {
                text,
                day: null,
                month: null,
                year: yearMatch ? yearMatch[1] : null
            };
        };

        const getCatalogTimelineDateParts = (item, pid) => {
            if (pid === 'parents') {
                const eventYear = item?.event_year || item?.eventYear;
                if (eventYear) {
                    return {
                        text: item?.event_year_label || String(eventYear),
                        day: null,
                        month: null,
                        year: String(eventYear)
                    };
                }
                return { text: item?.case_year_label || item?.date_label || '', day: null, month: null, year: null };
            }
            return parseItemDateParts(item);
        };

        const getCatalogTimelineYears = (item, pid) => {
            if (pid === 'parents') {
                const rawYears = Array.isArray(item?.event_years) ? item.event_years : Array.isArray(item?.eventYears) ? item.eventYears : [];
                const normalizedYears = rawYears
                    .map(value => String(value || '').trim())
                    .filter(Boolean);
                if (normalizedYears.length) return Array.from(new Set(normalizedYears));
                const { year } = getCatalogTimelineDateParts(item, pid);
                return year ? [year] : [];
            }
            const { year } = getCatalogTimelineDateParts(item, pid);
            return year ? [year] : [];
        };

        const formatDateFilterLabel = (filter, totalCount) => {
            if (filter === '0') return `Все годы (${totalCount})`;
            if (filter.includes('-')) {
                const [year, month] = filter.split('-');
                return `${MONTH_FULL_NAMES[parseInt(month, 10) - 1]} ${year}`;
            }
            return filter;
        };

        const DEFAULT_PARENTS_PARISH = {
            id: 'taininskoe',
            title: 'Приход с. Тайнинское',
            subtitle: 'Московский уезд, Московская губерния'
        };

        const normalizeParentsParishId = (value) => String(value || '').trim().toLowerCase();

        const getParentsProjectParishes = (project) => {
            const source = Array.isArray(project?.parishes) ? project.parishes : [];
            const normalized = source
                .map((entry, index) => {
                    if (!entry || typeof entry !== 'object') return null;
                    const id = normalizeParentsParishId(entry.id || '');
                    const title = String(entry.title || '').trim();
                    if (!id || !title) return null;
                    return {
                        id,
                        title,
                        subtitle: String(entry.subtitle || '').trim(),
                        index
                    };
                })
                .filter(Boolean);
            return normalized.length ? normalized : [DEFAULT_PARENTS_PARISH];
        };

        const getParentsParishStorageKey = (projectId) => `yarchiver:parents:parish:${projectId || ''}`;
        const getParentsParishIdFromLocation = (projectId) => {
            if (typeof window === 'undefined' || projectId !== 'parents') return '';
            try {
                // Сначала path: /parents/<parish>/<section>[/<id>] — берём 2-й сегмент,
                // если 3-й похож на известную секцию (тогда точно это parish, а не legacy card_id).
                const pathParts = window.location.pathname.replace(BASE_PATH, '').split('/').filter(Boolean);
                if (pathParts[0] === 'parents' && pathParts[1] && pathParts.length >= 3
                    && Array.isArray(PARENTS_SECTIONS) && PARENTS_SECTIONS.includes(pathParts[2])) {
                    return normalizeParentsParishId(pathParts[1]);
                }
                // Иначе старый формат — query ?parish_id=
                const params = new URLSearchParams(window.location.search || '');
                return normalizeParentsParishId(params.get('parish_id') || '');
            } catch (error) {
                return '';
            }
        };

        // URL для parents: /parents/<parish>/<section>[/<id>]
        // section: catalog | dashboard | families | stats | ocr | logic | audit. 'families' маппится на workspacePage='chains'.
        // Старая ссылка /parents/<card_id> поддерживается: если 2-й сегмент не известный parish, считаем его card_id.
        const PARENTS_SECTIONS = ['catalog', 'dashboard', 'families', 'stats', 'ocr', 'logic', 'audit'];
        const PARENTS_SECTION_TO_WORKSPACE = { catalog: 'catalog', dashboard: 'dashboard', families: 'chains', stats: 'stats', ocr: 'ocr', logic: 'logic', audit: 'audit' };
        const PARENTS_WORKSPACE_TO_SECTION = { catalog: 'catalog', dashboard: 'dashboard', chains: 'families', stats: 'stats', ocr: 'ocr', logic: 'logic', audit: 'audit' };
        function decodeParentsRouteSegment(value) {
            try { return decodeURIComponent(String(value || '')); }
            catch (error) { return String(value || ''); }
        }
        function encodeParentsRouteSegment(value) {
            return encodeURIComponent(String(value || ''));
        }
        const parseParentsPath = (pathname, knownParishIds = []) => {
            const parts = String(pathname || '').replace(BASE_PATH, '').split('/').filter(Boolean);
            if (parts[0] !== 'parents') return null;
            const second = parts[1] || '';
            if (!second) return { parishId: '', section: 'catalog', recordId: '', legacyCardId: '' };
            const isKnownParish = knownParishIds.includes(second);
            if (!isKnownParish) {
                // legacy /parents/<card_id>
                return { parishId: '', section: 'catalog', recordId: '', legacyCardId: second };
            }
            const sectionRaw = parts[2] || 'catalog';
            const section = PARENTS_SECTIONS.includes(sectionRaw) ? sectionRaw : 'catalog';
            const recordId = decodeParentsRouteSegment(parts[3] || '');
            return { parishId: second, section, recordId, legacyCardId: '' };
        };
        const buildParentsPath = ({ parishId, section = 'catalog', recordId = '' }) => {
            const parts = ['parents'];
            if (parishId) parts.push(parishId);
            const sec = PARENTS_SECTIONS.includes(section) ? section : 'catalog';
            if (parishId && (sec !== 'catalog' || recordId)) parts.push(sec);
            if (parishId && recordId) parts.push(encodeParentsRouteSegment(recordId));
            return `${BASE_PATH}/${parts.join('/')}`;
        };

        const isAllSnippetsMode = (mode) => mode === 'all_snippets';

        const getSnippetWorkbenchPlans = (fragments = []) => {
            if (!fragments.length) return { short: [], numeric: [], headers: [], duplicates: [] };

            const ys = fragments.map(f => Number(f?.y || 0));
            const minY = Math.min(...ys);
            const maxY = Math.max(...ys);
            const topCutoff = minY + ((maxY - minY) * 0.18);

            const short = [];
            const numeric = [];
            const headers = [];
            const duplicates = [];
            const seenText = new Map();

            fragments.forEach((fragment, index) => {
                const text = (fragment?.text || '').trim();
                const normalized = normalizeText(text).replace(/[^a-zа-я0-9]/g, '');
                const words = text.split(/\s+/).filter(Boolean);
                const letters = (text.match(/[A-Za-zА-Яа-яЁёІіѢѣѲѳ]/g) || []).length;
                const upperLetters = (text.match(/[A-ZА-ЯЁІѢѲ]/g) || []).length;
                const digits = (text.match(/\d/g) || []).length;
                const upperRatio = letters ? upperLetters / letters : 0;

                if (normalized.length > 0 && normalized.length <= 4 && words.length <= 2) {
                    short.push(index);
                }
                if (digits > 0 && letters === 0) {
                    numeric.push(index);
                }
                if ((fragment?.y || 0) <= topCutoff && (upperRatio > 0.45 || text.length <= 42)) {
                    headers.push(index);
                }

                if (normalized) {
                    if (seenText.has(normalized)) {
                        duplicates.push(index);
                    } else {
                        seenText.set(normalized, index);
                    }
                }
            });

            return { short, numeric, headers, duplicates };
        };

        const getSnippetColumnThreshold = (imageWidth = 0) => {
            return Math.max(48, Math.min(72, Math.round((imageWidth || 0) * 0.0095)));
        };

        const buildSnippetColumnAnchors = (fragments = [], imageWidth = 0) => {
            if (!fragments.length) return [];
            const threshold = getSnippetColumnThreshold(imageWidth);
            const groups = [];

            fragments
                .map((fragment, index) => ({
                    index,
                    x: Number(fragment?.x || 0),
                    width: Number(fragment?.width || 0)
                }))
                .sort((a, b) => a.x - b.x)
                .forEach(entry => {
                    const current = groups[groups.length - 1];
                    if (!current || Math.abs(entry.x - current.anchorX) > threshold) {
                        groups.push({
                            id: `c${groups.length + 1}`,
                            anchorX: entry.x,
                            xs: [entry.x],
                            widths: [entry.width]
                        });
                    } else {
                        current.xs.push(entry.x);
                        current.widths.push(entry.width);
                        current.anchorX = Math.round(current.xs.reduce((sum, value) => sum + value, 0) / current.xs.length);
                    }
                });

            return groups.map(group => ({
                id: group.id,
                anchorX: group.anchorX
            }));
        };

        const mapSnippetColumns = (fragments = [], anchors = [], imageWidth = 0) => {
            if (!fragments.length) return { columns: [], fragmentColumns: [], threshold: getSnippetColumnThreshold(imageWidth) };

            const threshold = getSnippetColumnThreshold(imageWidth);
            const baseAnchors = anchors.length ? anchors : buildSnippetColumnAnchors(fragments, imageWidth);
            const columnsMap = new Map(baseAnchors.map(anchor => [anchor.id, { ...anchor, indices: [] }]));
            const fragmentColumns = Array(fragments.length).fill(null);
            const extraAnchors = [];

            fragments.forEach((fragment, index) => {
                const x = Number(fragment?.x || 0);
                let closest = null;

                [...baseAnchors, ...extraAnchors].forEach(anchor => {
                    const diff = Math.abs(x - anchor.anchorX);
                    if (diff <= threshold && (!closest || diff < closest.diff)) {
                        closest = { anchor, diff };
                    }
                });

                if (!closest) {
                    const nextAnchor = { id: `c${baseAnchors.length + extraAnchors.length + 1}`, anchorX: x };
                    extraAnchors.push(nextAnchor);
                    columnsMap.set(nextAnchor.id, { ...nextAnchor, indices: [index] });
                    fragmentColumns[index] = nextAnchor.id;
                    return;
                }

                columnsMap.get(closest.anchor.id)?.indices.push(index);
                fragmentColumns[index] = closest.anchor.id;
            });

            const columns = [...columnsMap.values()]
                .filter(column => column.indices.length > 0)
                .sort((a, b) => parseInt(a.id.slice(1), 10) - parseInt(b.id.slice(1), 10))
                .map(column => ({
                    ...column,
                    label: column.id,
                    count: column.indices.length,
                    indices: column.indices.sort((left, right) => {
                        const a = fragments[left] || {};
                        const b = fragments[right] || {};
                        return Number(a.y || 0) - Number(b.y || 0) || Number(a.x || 0) - Number(b.x || 0);
                    })
                }));

            return { columns, fragmentColumns, threshold };
        };

        const formatColumnSelectionLabel = (columnIds = []) => {
            const numbers = [...new Set(
                columnIds
                    .map(id => parseInt(String(id).replace(/[^0-9]/g, ''), 10))
                    .filter(Boolean)
            )].sort((a, b) => a - b);

            if (!numbers.length) return '';

            const ranges = [];
            let start = numbers[0];
            let prev = numbers[0];

            for (let i = 1; i < numbers.length; i += 1) {
                const value = numbers[i];
                if (value === prev + 1) {
                    prev = value;
                    continue;
                }
                ranges.push(start === prev ? `c${start}` : `c${start}-c${prev}`);
                start = value;
                prev = value;
            }

            ranges.push(start === prev ? `c${start}` : `c${start}-c${prev}`);
            return ranges.join(', ');
        };

        const isSnippetFragmentEdited = (fragment) => {
            if (!fragment) return false;
            if (fragment.edited_at || fragment.edited_by) return true;
            const currentText = (fragment.text || '').trim();
            const originalText = (fragment.original_text || '').trim();
            return !!originalText && currentText !== originalText;
        };

        const formatSnippetEditTimestamp = (timestamp) => {
            if (!timestamp) return '';
            const date = new Date(timestamp);
            if (Number.isNaN(date.getTime())) return '';
            return new Intl.DateTimeFormat('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(date);
        };

        const getSnippetImageCropBox = (fragment, imageWidth, imageHeight) => {
            if (!fragment || !imageWidth || !imageHeight) return null;

            const padX = Math.max(72, Number(fragment.width || 0) * 0.4);
            const padY = Math.max(82, Number(fragment.height || 0) * 1.02);
            const x = Math.max(0, Math.floor(Number(fragment.x || 0) - padX));
            const y = Math.max(0, Math.floor(Number(fragment.y || 0) - padY));
            const right = Math.min(Number(imageWidth || 0), Math.ceil(Number(fragment.x || 0) + Number(fragment.width || 0) + padX));
            const bottom = Math.min(Number(imageHeight || 0), Math.ceil(Number(fragment.y || 0) + Number(fragment.height || 0) + padY));

            return {
                x,
                y,
                width: Math.max(1, right - x),
                height: Math.max(1, bottom - y)
            };
        };

        const clampNumber = (value, min, max) => Math.min(max, Math.max(min, value));

        const getSnippetPreviewViewport = (cropBox, zoom = 1, pan = { x: 0, y: 0 }) => {
            if (!cropBox) return null;

            const safeZoom = clampNumber(zoom || 1, 1, 3.5);
            const width = cropBox.width / safeZoom;
            const height = cropBox.height / safeZoom;
            const centerX = cropBox.x + cropBox.width / 2 + Number(pan?.x || 0);
            const centerY = cropBox.y + cropBox.height / 2 + Number(pan?.y || 0);
            const minCenterX = cropBox.x + width / 2;
            const maxCenterX = cropBox.x + cropBox.width - width / 2;
            const minCenterY = cropBox.y + height / 2;
            const maxCenterY = cropBox.y + cropBox.height - height / 2;
            const clampedCenterX = clampNumber(centerX, minCenterX, maxCenterX);
            const clampedCenterY = clampNumber(centerY, minCenterY, maxCenterY);

            return {
                x: clampedCenterX - width / 2,
                y: clampedCenterY - height / 2,
                width,
                height
            };
        };

        const getStructuredEntryCropBox = (entry, imageWidth, imageHeight) => {
            const bbox = entry?.bbox;
            if (!bbox || !imageWidth || !imageHeight) return null;
            const width = Number(bbox.width || 0);
            const height = Number(bbox.height || 0);
            if (width <= 0 || height <= 0) return null;

            const padX = Math.max(120, width * 0.2);
            const padY = Math.max(120, height * 0.28);
            const x = Math.max(0, Math.floor(Number(bbox.x || 0) - padX));
            const y = Math.max(0, Math.floor(Number(bbox.y || 0) - padY));
            const right = Math.min(Number(imageWidth || 0), Math.ceil(Number(bbox.x || 0) + width + padX));
            const bottom = Math.min(Number(imageHeight || 0), Math.ceil(Number(bbox.y || 0) + height + padY));

            return {
                x,
                y,
                width: Math.max(1, right - x),
                height: Math.max(1, bottom - y)
            };
        };

        const extractViewerImageId = (payload, fallbackUrl = '') => {
            const explicitId = String(payload?.imageId || payload?.image_id || '').trim();
            if (explicitId) return explicitId;
            const source = String(fallbackUrl || payload?.originalUrl || payload?.imageUrl || '').trim();
            const match = source.match(/[?&]id=([^&#]+)/i);
            if (!match) return '';
            try {
                return decodeURIComponent(match[1]);
            } catch (e) {
                return match[1];
            }
        };

        const toAbsoluteViewerImageUrl = (url) => {
            const raw = String(url || '').trim();
            if (!raw) return '';
            if (/^https?:\/\//i.test(raw)) return raw;
            return `${API_BASE}/${raw.replace(/^\/+/, '')}`;
        };

        const buildViewerThumbUrl = (imageId) => {
            const normalized = String(imageId || '').trim();
            if (!normalized) return '';
            return `https://ya.ru/archive/api/image?id=${encodeURIComponent(normalized)}&type=thumb`;
        };

        const buildViewerPlainUrl = (imageId) => {
            const normalized = String(imageId || '').trim();
            if (!normalized) return '';
            return `https://ya.ru/archive/api/image?id=${encodeURIComponent(normalized)}`;
        };

        const buildViewerScreenUrl = (imageId) => {
            const normalized = String(imageId || '').trim();
            if (!normalized) return '';
            return `https://ya.ru/archive/api/image?id=${encodeURIComponent(normalized)}&type=screen`;
        };

        const buildViewerHiresUrl = (payload, options = {}) => {
            const explicit = toAbsoluteViewerImageUrl(payload?.hiresUrl || payload?.hires_url || '');
            if (explicit) return explicit;
            const hasHiresImage = Boolean(String(payload?.hires_image || '').trim());
            if (!hasHiresImage) return '';
            const pid = String(options.pid || '').trim();
            const itemId = String(options.itemId || payload?.id || '').trim();
            if (!pid || !itemId) return '';
            const params = new URLSearchParams({
                pid,
                item_id: itemId
            });
            const ownerId = String(options.ownerId || payload?.owner_id || '').trim();
            if (ownerId) params.set('owner_id', ownerId);
            return `${API_BASE}/hires_image?${params.toString()}`;
        };

        const isSignedYandexOriginalUrl = (url) => {
            const raw = String(url || '').trim();
            return /\/archive\/api\/image\?/i.test(raw)
                && /[?&]type=original(?:&|$)/i.test(raw)
                && /[?&]exp=/i.test(raw)
                && /[?&]sig=/i.test(raw);
        };

        const shouldUseNoReferrerForViewerImage = (url) => {
            const raw = String(url || '').trim();
            return /^https?:\/\/ya\.ru\/archive\/api\/image\?/i.test(raw);
        };

        const buildViewerImageCandidates = (payload) => {
            const seen = new Set();
            const signedOriginalUrl = isSignedYandexOriginalUrl(payload?.originalUrl) ? payload.originalUrl : '';
            return [
                { stage: 'hires', url: payload?.hiresImageUrl || payload?.hiresUrl },
                { stage: 'proxy-preview', url: payload?.proxyPreviewUrl },
                { stage: 'proxy-original', url: payload?.proxyImageUrl },
                { stage: 'signed-original', url: signedOriginalUrl },
                { stage: 'proxy-best', url: payload?.proxyBestUrl || payload?.imageUrl },
                { stage: 'thumb', url: payload?.thumbUrl },
            ].filter((candidate) => {
                const normalized = String(candidate?.url || '').trim();
                if (!normalized || seen.has(normalized)) return false;
                seen.add(normalized);
                candidate.url = normalized;
                return true;
            });
        };

        const getNextViewerImageCandidate = (payload, currentStage, currentUrl) => {
            const candidates = buildViewerImageCandidates(payload);
            if (!candidates.length) return null;
            const currentIndex = candidates.findIndex((candidate) => (
                candidate.stage === currentStage || candidate.url === String(currentUrl || '').trim()
            ));
            if (currentIndex === -1) return candidates[0] || null;
            return candidates[currentIndex + 1] || null;
        };

        const normalizeViewerData = (payload, options = {}) => {
            if (!payload) return null;
            const imageId = payload.image_id;
            const imageParams = new URLSearchParams();
            if (imageId) imageParams.set('id', String(imageId));
            if (options.pid) imageParams.set('pid', String(options.pid));
            if (options.itemId || payload.id) imageParams.set('item_id', String(options.itemId || payload.id));
            if (options.ownerId || payload.owner_id) imageParams.set('owner_id', String(options.ownerId || payload.owner_id));
            const proxyBestUrl = imageId ? `proxy_image?${imageParams.toString()}` : '';
            const proxyOriginalParams = new URLSearchParams(imageParams);
            if (imageId) proxyOriginalParams.set('variant', 'original');
            const proxyOriginalUrl = imageId ? `proxy_image?${proxyOriginalParams.toString()}` : '';
            const proxyPreviewParams = new URLSearchParams(imageParams);
            if (imageId) proxyPreviewParams.set('variant', 'preview2k');
            const proxyPreviewUrl = imageId ? `proxy_image?${proxyPreviewParams.toString()}` : '';
            const imageUrl = proxyBestUrl || payload.imageUrl || null;
            const originalUrl = payload.originalUrl || null;
            const normalizedImageId = extractViewerImageId(payload, originalUrl || imageUrl || '');
            const hiresImageUrl = buildViewerHiresUrl(payload, options);
            return {
                imageUrl,
                originalUrl,
                imageId: normalizedImageId,
                hiresImageUrl,
                hiresUrl: hiresImageUrl,
                proxyImageUrl: toAbsoluteViewerImageUrl(proxyOriginalUrl || imageUrl),
                proxyBestUrl: toAbsoluteViewerImageUrl(proxyBestUrl || payload.imageUrl || ''),
                proxyPreviewUrl: toAbsoluteViewerImageUrl(proxyPreviewUrl),
                plainUrl: '',
                screenUrl: '',
                thumbUrl: buildViewerThumbUrl(normalizedImageId),
                originalWidth: payload.originalWidth ?? payload.image_width,
                originalHeight: payload.originalHeight ?? payload.image_height,
                hiresImage: payload.hiresImage || payload.hires_image || '',
                hiresImageMime: payload.hiresImageMime || payload.hires_image_mime || '',
                hiresImageWidth: payload.hiresImageWidth ?? payload.hires_image_width ?? null,
                hiresImageHeight: payload.hiresImageHeight ?? payload.hires_image_height ?? null,
                hiresImageSource: payload.hiresImageSource || payload.hires_image_source || '',
                hiresImageUpdatedAt: payload.hiresImageUpdatedAt || payload.hires_image_updated_at || '',
                hiresPageUrl: payload.hiresPageUrl || payload.hires_page_url || '',
                highlights: payload.highlights || [],
                highlightFragments: payload.highlightFragments || payload.highlight_fragments || [],
                deletedHighlightFragments: payload.deletedHighlightFragments || payload.deleted_highlight_fragments || [],
                highlightMode: payload.highlightMode || payload.highlight_mode || null,
                structuredEntries: payload.structuredEntries || payload.structured_entries || [],
                structuredSummary: payload.structuredSummary || payload.structured_summary || '',
                structuredSearchText: payload.structuredSearchText || payload.structured_search_text || '',
                structuredHasManualEdits: Boolean(payload.structuredHasManualEdits || payload.structured_has_manual_edits),
                snippet: payload.snippet || '',
                text: payload.text || ''
            };
        };

        const readFileAsDataUrl = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => reject(reader.error || new Error('read_failed'));
            reader.readAsDataURL(file);
        });

        const loadImageDimensionsFromUrl = (url) => new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve({ width: img.naturalWidth || img.width || 0, height: img.naturalHeight || img.height || 0 });
            img.onerror = () => reject(new Error('image_meta_failed'));
            img.src = url;
        });

        const escapeForJsDoubleQuotedString = (value) => JSON.stringify(String(value || ''));

        const normalizeSignedYandexOriginalUrl = (value) => {
            const raw = String(value || '').trim().replace(/&amp;/gi, '&');
            if (!raw) return '';
            try {
                const parsed = new URL(raw, window.location.origin);
                if (!/\/archive\/api\/image$/i.test(parsed.pathname || '')) return '';
                if (String(parsed.searchParams.get('type') || '').toLowerCase() !== 'original') return '';
                if (!String(parsed.searchParams.get('exp') || '').trim()) return '';
                if (!String(parsed.searchParams.get('sig') || '').trim()) return '';
                parsed.hash = '';
                return parsed.toString();
            } catch (error) {
                return '';
            }
        };

        const buildYandexHiresConsoleScript = ({ uploadUrl, token, expectedWidth, expectedHeight, manualSignedUrl = '' }) => `;(async () => {
  const uploadUrl = ${escapeForJsDoubleQuotedString(uploadUrl)};
  const uploadToken = ${escapeForJsDoubleQuotedString(token)};
  const expectedWidth = Number(${Number(expectedWidth || 0)});
  const expectedHeight = Number(${Number(expectedHeight || 0)});
  const manualSignedUrl = ${escapeForJsDoubleQuotedString(normalizeSignedYandexOriginalUrl(manualSignedUrl))};
  const node = window.__NEXT_DATA__?.props?.pageProps?.currentNode || {};
  const imageId = String(node.id || '').trim();
  const pageUrl = String(location.href || '');
  const blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = String(reader.result || '');
      const commaIndex = result.indexOf(',');
      resolve(commaIndex >= 0 ? result.slice(commaIndex + 1) : result);
    };
    reader.onerror = () => reject(reader.error || new Error('blob_read_failed'));
    reader.readAsDataURL(blob);
  });
  const readBlobMeta = async (blob) => {
    if (typeof createImageBitmap === 'function') {
      const bitmap = await createImageBitmap(blob);
      const meta = { width: bitmap.width || 0, height: bitmap.height || 0 };
      if (typeof bitmap.close === 'function') bitmap.close();
      return meta;
    }
    const url = URL.createObjectURL(blob);
    try {
      const img = await new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error('meta_image_failed'));
        image.src = url;
      });
      return { width: img.naturalWidth || img.width || 0, height: img.naturalHeight || img.height || 0 };
    } finally {
      URL.revokeObjectURL(url);
    }
  };
  const isAspectRatioAcceptable = (width, height) => {
    if (!expectedWidth || !expectedHeight || !width || !height) return true;
    const base = expectedWidth / expectedHeight;
    return Math.abs((width / height) - base) / base <= 0.03;
  };
  const isQualityAcceptable = (width) => {
    if (!width) return false;
    if (!expectedWidth) return width >= 2500;
    const minWidth = Math.min(expectedWidth, Math.max(2500, Math.floor(expectedWidth * 0.45)));
    return width >= minWidth;
  };
  const normalizeSignedUrlCandidate = (value) => {
    const raw = String(value || '').trim().replace(/&amp;/gi, '&');
    if (!raw) return '';
    try {
      const parsed = new URL(raw, location.origin);
      if (!/\\/archive\\/api\\/image$/i.test(parsed.pathname || '')) return '';
      if (String(parsed.searchParams.get('type') || '').toLowerCase() !== 'original') return '';
      if (!String(parsed.searchParams.get('exp') || '').trim()) return '';
      if (!String(parsed.searchParams.get('sig') || '').trim()) return '';
      parsed.hash = '';
      return parsed.toString();
    } catch (error) {
      return '';
    }
  };
  const collectSignedUrlCandidates = () => {
    const seen = new Set();
    const result = [];
    const push = (source, value) => {
      const normalized = normalizeSignedUrlCandidate(value);
      if (!normalized || seen.has(normalized)) return;
      seen.add(normalized);
      result.push({ source, url: normalized });
    };
    push('manual', manualSignedUrl);
    push('location', location.href);
    try {
      const resourceEntries = performance?.getEntriesByType ? performance.getEntriesByType('resource') : [];
      for (const entry of resourceEntries || []) {
        push('resource', entry?.name || '');
      }
    } catch (error) {}
    try {
      const nodes = document.querySelectorAll('[href*="/archive/api/image"], [src*="/archive/api/image"], [data-href*="/archive/api/image"]');
      nodes.forEach((node) => {
        push('href', node.getAttribute('href'));
        push('src', node.getAttribute('src'));
        push('data-href', node.getAttribute('data-href'));
      });
    } catch (error) {}
    return result;
  };
  const loadImageAndResolveCurrentSrc = (src, timeoutMs = 12000) => new Promise((resolve) => {
    if (!src) {
      resolve(null);
      return;
    }
    const image = new Image();
    let done = false;
    const finish = (payload) => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      image.onload = null;
      image.onerror = null;
      resolve(payload);
    };
    const timer = setTimeout(() => finish(null), timeoutMs);
    image.onload = () => {
      finish({
        requestedSrc: src,
        currentSrc: String(image.currentSrc || image.src || ''),
        width: Number(image.naturalWidth || image.width || 0),
        height: Number(image.naturalHeight || image.height || 0)
      });
    };
    image.onerror = () => finish(null);
    image.referrerPolicy = 'no-referrer';
    image.decoding = 'async';
    image.src = src;
  });
  const resolveSignedUrlFromImageLoad = async () => {
    if (!imageId) return '';
    const directCandidates = [
      'https://ya.ru/archive/api/image?id=' + encodeURIComponent(imageId) + '&type=original',
      'https://ya.ru/archive/api/image?id=' + encodeURIComponent(imageId) + '&type=screen',
      'https://ya.ru/archive/api/image?id=' + encodeURIComponent(imageId)
    ];
    for (const candidate of directCandidates) {
      try {
        const loaded = await loadImageAndResolveCurrentSrc(candidate);
        if (!loaded) continue;
        console.log('[hires] image currentSrc probe', candidate, loaded.currentSrc, loaded.width, loaded.height);
        const signed = normalizeSignedUrlCandidate(loaded.currentSrc);
        if (signed) return signed;
      } catch (error) {
        console.warn('[hires] image currentSrc probe failed', candidate, error);
      }
    }
    return '';
  };
  const tryFetchCandidate = async (name, url) => {
    try {
      const response = await fetch(url, { credentials: 'include' });
      if (!response.ok) return null;
      const blob = await response.blob();
      if (!String(blob.type || '').toLowerCase().startsWith('image/')) return null;
      const meta = await readBlobMeta(blob);
      console.log('[hires] candidate', name, meta.width, meta.height, blob.size);
      if (!isAspectRatioAcceptable(meta.width, meta.height)) return null;
      if (!isQualityAcceptable(meta.width)) return null;
      return { blob, meta, source: 'browser_fetch:' + name };
    } catch (error) {
      console.warn('[hires] candidate failed', name, error);
      return null;
    }
  };
  let result = null;
  const signedCandidates = collectSignedUrlCandidates();
  for (const candidate of signedCandidates) {
    result = await tryFetchCandidate('signed:' + candidate.source, candidate.url);
    if (result) break;
  }
  if (!result) {
    const resolvedSigned = await resolveSignedUrlFromImageLoad();
    if (resolvedSigned) {
      result = await tryFetchCandidate('signed:image-currentSrc', resolvedSigned);
    }
  }
  if (imageId) {
    const candidates = [
      { name: 'plain', url: 'https://ya.ru/archive/api/image?id=' + encodeURIComponent(imageId) },
      { name: 'screen', url: 'https://ya.ru/archive/api/image?id=' + encodeURIComponent(imageId) + '&type=screen' },
      { name: 'original', url: 'https://ya.ru/archive/api/image?id=' + encodeURIComponent(imageId) + '&type=original' }
    ];
    for (const candidate of candidates) {
      if (result) break;
      result = await tryFetchCandidate(candidate.name, candidate.url);
    }
  }
  let canvasAttempt = null;
  if (!result) {
    const canvases = Array.from(document.querySelectorAll('.konvajs-content canvas'));
    const canvas = canvases.sort((left, right) => (right.width * right.height) - (left.width * left.height))[0];
    if (canvas) {
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      if (blob) {
        const meta = { width: canvas.width || 0, height: canvas.height || 0 };
        canvasAttempt = meta;
        console.log('[hires] canvas fallback', meta.width, meta.height, blob.size);
        if (isAspectRatioAcceptable(meta.width, meta.height) && isQualityAcceptable(meta.width)) {
          result = { blob, meta, source: 'browser_canvas' };
        }
      }
    }
  }
  if (!result) {
    const canvasHint = canvasAttempt
      ? '\\n\\nНа странице нашелся только canvas ' + canvasAttempt.width + '×' + canvasAttempt.height + ', этого мало для хорошего hi-res.'
      : '';
    const signedHint = manualSignedUrl
      ? '\\n\\nВ скрипт уже подставлена signed-ссылка. Если она не сработала, скорее всего, срок её действия истек и нужно получить новую.'
      : '\\n\\nЕсли у тебя уже есть ссылка вида ...type=original&exp=...&sig=..., вставь её в Yarchiver в поле signed URL и скопируй helper заново.';
    alert('Не удалось получить достаточно качественный снимок.' + canvasHint + signedHint + '\\n\\nМожно также открыть оригинал в новой вкладке Яндекса и выполнить этот код уже там.');
    return;
  }
  const imageData = await blobToBase64(result.blob);
  const response = await fetch(uploadUrl + '?token=' + encodeURIComponent(uploadToken), {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
    body: JSON.stringify({
      token: uploadToken,
      image_data: imageData,
      mime_type: result.blob.type || 'image/png',
      width: result.meta.width || 0,
      height: result.meta.height || 0,
      source: result.source,
      page_url: pageUrl
    })
  });
  const text = await response.text();
  let payload = {};
  try { payload = JSON.parse(text); } catch (error) {}
  if (!response.ok || !payload.ok) {
    throw new Error(payload.error || text || ('HTTP ' + response.status));
  }
  alert('Hi-res снимок сохранён в Yarchiver. Вернитесь в каталог и переключитесь обратно на страницу записи.');
})().catch(error => {
  console.error('[hires] upload failed', error);
  alert('Не удалось сохранить hi-res: ' + (error?.message || error));
});`;

        const buildYandexHiresCaptureConsoleScript = ({ uploadUrl, token }) => `;(function () {
  if (window.__yarchiverHiresCaptureInstalled) {
    console.log('[yarchiver-hires] auto capture already installed');
    return;
  }
  window.__yarchiverHiresCaptureInstalled = true;
  const uploadUrl = ${escapeForJsDoubleQuotedString(uploadUrl)};
  const uploadToken = ${escapeForJsDoubleQuotedString(token)};
  const seenKeys = new Set();
  const normalizeOriginalRequest = (value) => {
    const raw = String(value || '').trim().replace(/&amp;/gi, '&');
    if (!raw) return null;
    try {
      const parsed = new URL(raw, location.origin);
      if (!/\\/archive\\/api\\/image$/i.test(parsed.pathname || '')) return null;
      if (String(parsed.searchParams.get('type') || '').toLowerCase() !== 'original') return null;
      const exp = String(parsed.searchParams.get('exp') || '').trim();
      const sig = String(parsed.searchParams.get('sig') || '').trim();
      const imageId = String(parsed.searchParams.get('id') || '').trim();
      if (!exp || !sig || !imageId) return null;
      parsed.hash = '';
      return {
        imageId,
        exp,
        sig,
        url: parsed.toString(),
        key: imageId + ':' + exp + ':' + sig,
      };
    } catch (error) {
      return null;
    }
  };
  const blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = String(reader.result || '');
      const commaIndex = result.indexOf(',');
      resolve(commaIndex >= 0 ? result.slice(commaIndex + 1) : result);
    };
    reader.onerror = () => reject(reader.error || new Error('blob_read_failed'));
    reader.readAsDataURL(blob);
  });
  const readBlobMeta = async (blob) => {
    if (typeof createImageBitmap === 'function') {
      const bitmap = await createImageBitmap(blob);
      const meta = { width: bitmap.width || 0, height: bitmap.height || 0 };
      if (typeof bitmap.close === 'function') bitmap.close();
      return meta;
    }
    const url = URL.createObjectURL(blob);
    try {
      const img = await new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error('meta_image_failed'));
        image.src = url;
      });
      return { width: img.naturalWidth || img.width || 0, height: img.naturalHeight || img.height || 0 };
    } finally {
      URL.revokeObjectURL(url);
    }
  };
  const uploadCapturedBlob = async (requestInfo, blob, source) => {
    if (!requestInfo || !blob || seenKeys.has(requestInfo.key)) return;
    seenKeys.add(requestInfo.key);
    try {
      const meta = await readBlobMeta(blob);
      const imageData = await blobToBase64(blob);
      const response = await fetch(uploadUrl + '?token=' + encodeURIComponent(uploadToken), {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({
          token: uploadToken,
          image_id: requestInfo.imageId,
          image_data: imageData,
          mime_type: blob.type || 'image/jpeg',
          width: meta.width || 0,
          height: meta.height || 0,
          source,
          page_url: location.href,
          request_url: requestInfo.url,
        })
      });
      const text = await response.text();
      let payload = {};
      try { payload = JSON.parse(text); } catch (error) {}
      if (!response.ok || !payload.ok) {
        throw new Error(payload.error || text || ('HTTP ' + response.status));
      }
      console.log('[yarchiver-hires] saved', requestInfo.imageId, payload.updated_count || 0, source);
    } catch (error) {
      console.warn('[yarchiver-hires] upload failed', requestInfo.imageId, error);
      seenKeys.delete(requestInfo.key);
    }
  };
  const originalFetch = window.fetch.bind(window);
  const probeExistingOriginalRequests = async () => {
    try {
      const entries = performance?.getEntriesByType ? performance.getEntriesByType('resource') : [];
      const candidates = [];
      const seenCandidateKeys = new Set();
      for (const entry of entries || []) {
        const requestInfo = normalizeOriginalRequest(entry?.name || '');
        if (!requestInfo || seenCandidateKeys.has(requestInfo.key)) continue;
        seenCandidateKeys.add(requestInfo.key);
        candidates.push(requestInfo);
      }
      for (const requestInfo of candidates) {
        if (seenKeys.has(requestInfo.key)) continue;
        try {
          const response = await originalFetch(requestInfo.url, { credentials: 'include' });
          if (!response.ok) continue;
          const blob = await response.blob();
          if (!String(blob?.type || '').toLowerCase().startsWith('image/')) continue;
          await uploadCapturedBlob(requestInfo, blob, 'yandex_resource_probe');
        } catch (error) {
          console.warn('[yarchiver-hires] existing resource probe failed', requestInfo.imageId, error);
        }
      }
    } catch (error) {
      console.warn('[yarchiver-hires] failed to scan existing resources', error);
    }
  };
  window.fetch = async (...args) => {
    const requestUrl = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const requestInfo = normalizeOriginalRequest(requestUrl);
    const response = await originalFetch(...args);
    if (requestInfo && response?.ok && typeof response.clone === 'function') {
      response.clone().blob().then((blob) => {
        if (String(blob?.type || '').toLowerCase().startsWith('image/')) {
          uploadCapturedBlob(requestInfo, blob, 'yandex_fetch_intercept');
        }
      }).catch((error) => {
        console.warn('[yarchiver-hires] fetch clone failed', error);
      });
    }
    return response;
  };
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__yarchiverHiresRequestInfo = normalizeOriginalRequest(url);
    return originalXHROpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (this.__yarchiverHiresRequestInfo) {
      this.addEventListener('loadend', () => {
        if (this.status !== 200) return;
        try {
          let blob = null;
          if (this.responseType === 'blob' && this.response instanceof Blob) {
            blob = this.response;
          } else if (this.responseType === 'arraybuffer' && this.response) {
            blob = new Blob([this.response], { type: this.getResponseHeader('content-type') || 'image/jpeg' });
          }
          if (blob && String(blob.type || '').toLowerCase().startsWith('image/')) {
            uploadCapturedBlob(this.__yarchiverHiresRequestInfo, blob, 'yandex_xhr_intercept');
          }
        } catch (error) {
          console.warn('[yarchiver-hires] xhr intercept failed', error);
        }
      }, { once: true });
    }
    return originalXHRSend.apply(this, args);
  };
  setTimeout(() => {
    probeExistingOriginalRequests().catch((error) => {
      console.warn('[yarchiver-hires] delayed probe failed', error);
    });
  }, 800);
  console.log('[yarchiver-hires] auto capture installed');
})();`;

        const supportsPageMarkupToggle = (pid) => STRUCTURED_PARTICIPANTS_PROJECT_IDS.has(pid);
        const shouldShowPageMarkupByDefault = (pid) => !supportsPageMarkupToggle(pid);

        const MOSPRIYUT_RECORD_FIELD_CONFIG = [
            { key: 'name', label: 'Имя', placeholder: 'Авдотья Федосеева' },
            { key: 'governorate', label: 'Губерния', placeholder: 'Калужской губернии' },
            { key: 'uyezd', label: 'Уезд', placeholder: 'Боровскаго уезда' },
            { key: 'volost', label: 'Волость', placeholder: 'Бородинской волости' },
            { key: 'locality', label: 'Деревня / село', placeholder: 'Деревни Инина' },
            { key: 'occupation', label: 'Занятие', placeholder: 'башмашница' }
        ];

        const createEmptySnippetRecordFields = () => Object.fromEntries(
            MOSPRIYUT_RECORD_FIELD_CONFIG.map(field => [field.key, ''])
        );

        const normalizeSnippetRecordFields = (fields) => {
            const normalized = createEmptySnippetRecordFields();
            if (!fields || typeof fields !== 'object') return normalized;
            MOSPRIYUT_RECORD_FIELD_CONFIG.forEach(field => {
                normalized[field.key] = String(fields[field.key] || '').trim();
            });
            return normalized;
        };

        const normalizeMospriyutSummaryFields = (fields) => {
            const normalized = normalizeSnippetRecordFields(fields);
            MOSPRIYUT_RECORD_FIELD_CONFIG.forEach(field => {
                normalized[field.key] = normalizeMospriyutSummaryValue(normalized[field.key]);
            });
            return normalized;
        };

        const filterSummaryTableRows = (rows, query) => {
            const normalizedQuery = normalizeText(query);
            if (!normalizedQuery) return rows;

            return rows.filter(row => (
                [
                    row.cipherLabel,
                    row.pageLabel,
                    row.name,
                    row.governorate,
                    row.uyezd,
                    row.volost,
                    row.locality,
                    row.occupation,
                    row.snippetText
                ].some(value => normalizeText(String(value || '')).includes(normalizedQuery))
            ));
        };

        const buildStatisticsValueDescriptor = (fieldKey, rawValue) => {
            const cleaned = normalizeMospriyutSummaryValue(rawValue);
            if (!cleaned) return { groupKey: '', label: '' };

            if (fieldKey === 'occupation') {
                const label = cleaned.toLowerCase();
                return {
                    groupKey: normalizeText(label),
                    label
                };
            }

            if (fieldKey === 'volost') {
                const directMatch = cleaned.match(/^(волости|волость|вол\.)\s+(.+)$/i);
                const reverseMatch = cleaned.match(/^(.+)\s+(волости|волость|вол\.)$/i);
                let label = cleaned;
                if (directMatch) {
                    label = `волости ${directMatch[2]}`.replace(/\s+/g, ' ').trim();
                } else if (reverseMatch) {
                    label = `волости ${reverseMatch[1]}`.replace(/\s+/g, ' ').trim();
                }
                return {
                    groupKey: normalizeText(label),
                    label
                };
            }

            return {
                groupKey: normalizeText(cleaned),
                label: cleaned
            };
        };

        const isMospriyutServiceRecordValue = (value) => {
            const normalized = normalizeText(normalizeMospriyutSummaryValue(value));
            return MOSPRIYUT_SERVICE_ROW_VALUES.has(normalized) || isMospriyutOrderMarkerValue(value);
        };

        const shouldExcludeMospriyutSummaryRow = (row) => (
            isMospriyutServiceRecordValue(row?.snippetText) ||
            isMospriyutServiceRecordValue(row?.name) ||
            isMospriyutServiceRecordValue(row?.occupation)
        );

        const areSnippetRecordFieldsEqual = (left, right) => (
            MOSPRIYUT_RECORD_FIELD_CONFIG.every(field => (
                String(left?.[field.key] || '').trim() === String(right?.[field.key] || '').trim()
            ))
        );

        const getDateTimestamp = (item) => {
            const { year, month, day } = parseItemDateParts(item);
            if (year && month) return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day || '1', 10)).getTime();
            return year ? new Date(parseInt(year, 10), 0, 1).getTime() : 0;
        };

        const getIssueSortNumber = (item) => {
            const match = String(item?.issue || '').match(/№\s*(\d+)|выпуск\s*(\d+)|номер\s*(\d+)|(\d+)/i);
            return match ? parseInt(match[1] || match[2] || match[3] || match[4], 10) : 0;
        };

        const getArchiveDocumentSortMeta = (item) => {
            const url = String(item?.url || '').trim();
            const urlMatch = url.match(/^(https:\/\/ya\.ru\/archive\/catalog\/[^/?#]+)\/(\d+)(?:[/?#].*)?$/i);
            if (urlMatch) {
                return {
                    docKey: urlMatch[1],
                    pageNumber: parseInt(urlMatch[2], 10) || null
                };
            }

            const cipher = String(item?.cipher || '').trim();
            const pageMatch = cipher.match(/(?:стр\.?|лист(?:а|ъ)?|л\.)\s*(\d+)/i);
            const docKey = cipher
                .replace(/(?:стр\.?|лист(?:а|ъ)?|л\.)\s*\d+.*$/i, '')
                .replace(/\s+/g, ' ')
                .trim();

            return {
                docKey: docKey || null,
                pageNumber: pageMatch ? parseInt(pageMatch[1], 10) || null : null
            };
        };

        const compareCatalogItems = (left, right, projectId) => {
            const dateA = getDateTimestamp(left);
            const dateB = getDateTimestamp(right);
            if (dateA !== dateB) return dateA - dateB;

            if (MOSPRIYUT_STYLE_PROJECT_IDS.has(projectId)) {
                const metaA = getArchiveDocumentSortMeta(left);
                const metaB = getArchiveDocumentSortMeta(right);
                if (metaA.docKey && metaB.docKey) {
                    const docKeyCompare = metaA.docKey.localeCompare(metaB.docKey, 'ru');
                    if (docKeyCompare !== 0) return docKeyCompare;

                    const pageA = metaA.pageNumber ?? Number.MAX_SAFE_INTEGER;
                    const pageB = metaB.pageNumber ?? Number.MAX_SAFE_INTEGER;
                    if (pageA !== pageB) return pageA - pageB;
                }
            }

            return getIssueSortNumber(left) - getIssueSortNumber(right);
        };

        const getCatalogCardSnippetText = (item, projectId) => {
            if (MOSPRIYUT_STYLE_PROJECT_IDS.has(projectId)) {
                const fragmentLines = (item?.highlight_fragments || [])
                    .map(fragment => String(fragment?.text || '').trim())
                    .filter(Boolean);
                if (fragmentLines.length) return fragmentLines.join('\n');
                return String(item?.snippet || '').replace(/\s*…\s*/g, '\n');
            }
            return String(item?.snippet || '');
        };

        const getCatalogItemDocumentCipher = (item) => {
            const cipher = String(item?.cipher || '').trim();
            if (!cipher) return '—';
            const trimmed = cipher.replace(/\s+(?:стр\.?|Стр\.?|лист(?:а|ъ)?|Лист(?:а|ъ)?|л\.)\s*\d+.*$/i, '').trim();
            return trimmed || cipher;
        };

        const getCatalogItemPageLabel = (item) => {
            const meta = getArchiveDocumentSortMeta(item);
            if (meta.pageNumber) return String(meta.pageNumber);
            const match = String(item?.cipher || '').match(/(?:стр\.?|Стр\.?|лист(?:а|ъ)?|Лист(?:а|ъ)?|л\.)\s*(\d+)/i);
            return match ? match[1] : '—';
        };

        const buildSummaryRowsForCatalogItem = (item, projectId) => {
            if (projectId !== 'mospriyut' || !item) return [];
            const fieldsForItem = item.highlight_fragments || [];
            if (!fieldsForItem.length) return [];

            const columnLayout = mapSnippetColumns(
                fieldsForItem,
                buildSnippetColumnAnchors(fieldsForItem, item.image_width),
                item.image_width
            );

            for (const candidateColumnId of ['c4', 'c3', 'c5']) {
                const candidateColumn = columnLayout.columns.find(column => column.id === candidateColumnId);
                if (!candidateColumn) continue;

                const selectedIndices = (candidateColumn.indices || []).filter(index => (
                    !isMospriyutServiceSnippetText(fieldsForItem[index]?.text)
                ));
                if (!selectedIndices.length) continue;

                const rows = selectedIndices
                    .map(index => {
                        const fragment = fieldsForItem[index];
                        const parsedFields = normalizeMospriyutSummaryFields(fragment?.parsed_fields || fragment?.parsed_fields_original);
                        return {
                            id: `${item.id}:${index}`,
                            itemId: item.id,
                            itemUrl: item.url,
                            fragmentIndex: index,
                            cipherLabel: getCatalogItemDocumentCipher(item),
                            pageLabel: getCatalogItemPageLabel(item),
                            snippetText: normalizeMospriyutSummaryValue(fragment?.text || ''),
                            sourceColumn: candidateColumnId,
                            ...parsedFields
                        };
                    })
                    .filter(row => !shouldExcludeMospriyutSummaryRow(row));

                if (rows.length) {
                    return rows;
                }
            }

            return [];
        };

        const getStoredSnippetColumnAnchors = (projectId, itemId) => {
            if (typeof window === 'undefined' || !window.localStorage || !projectId || !itemId) return [];
            try {
                const raw = window.localStorage.getItem(`snippet-columns:${projectId}:${itemId}`);
                const parsed = raw ? JSON.parse(raw) : [];
                if (!Array.isArray(parsed)) return [];
                return parsed
                    .filter(anchor => anchor && typeof anchor.id === 'string' && Number.isFinite(Number(anchor.anchorX)))
                    .map(anchor => ({ id: anchor.id, anchorX: Number(anchor.anchorX) }));
            } catch {
                return [];
            }
        };

        // Определение типа документа
        const getDocType = (item) => {
            // Используем сохранённый тип если есть
            if (item.doc_type === 'periodical') {
                return { type: 'periodical', label: '📰 Периодика', className: 'doc-type-periodical' };
            }
            if (item.doc_type === 'archive') {
                return { type: 'archive', label: '📋 Архив', className: 'doc-type-archive' };
            }
            
            // Fallback для старых записей
            const text = (item.periodical + ' ' + item.issue + ' ' + (item.cipher || '')).toLowerCase();
            if (item.cipher && (text.includes('ф.') || text.includes('оп.'))) {
                return { type: 'archive', label: '📋 Архив', className: 'doc-type-archive' };
            }
            if (text.includes('газет') || text.includes('№') || text.includes('ведомост')) {
                return { type: 'periodical', label: '📰 Периодика', className: 'doc-type-periodical' };
            }
            
            return { type: 'document', label: '📄 Документ', className: 'doc-type-archive' };
        };

        // === GLOBAL SEARCH ACTION ===
        // Cross-tab "find this value in catalog" — MVP.
        // SearchableValue emits {value, type}; the workspace component subscribes,
        // switches to the catalog tab and sets the search field.
        const searchActionEvents = {
            listeners: [],
            subscribe(fn) {
                this.listeners.push(fn);
                return () => { this.listeners = this.listeners.filter(l => l !== fn); };
            },
            emit(payload) { this.listeners.forEach(fn => fn(payload)); },
        };
        const requestGlobalSearch = (value, type = 'name') => {
            const trimmed = String(value || '').trim();
            if (!trimmed) return;
            searchActionEvents.emit({ value: trimmed, type });
        };

        const SearchableValue = ({ value, type = 'name', children, className = '', display = 'inline' }) => {
            const text = String(value ?? children ?? '').trim();
            if (!text) return children || null;
            const handleClick = (event) => {
                event.preventDefault();
                event.stopPropagation();
                requestGlobalSearch(text, type);
            };
            const containerStyle = display === 'block'
                ? { display: 'inline-flex', alignItems: 'baseline', gap: '4px', maxWidth: '100%' }
                : { display: 'inline-flex', alignItems: 'baseline', gap: '4px' };
            return (
                <span className={`searchable-value ${className}`} style={containerStyle}>
                    <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {children ?? text}
                    </span>
                    <button
                        type="button"
                        onClick={handleClick}
                        title={`Найти «${text}» в каталоге`}
                        aria-label={`Найти «${text}» в каталоге`}
                        className="searchable-value__lens"
                        style={{
                            flexShrink: 0,
                            width: '16px',
                            height: '16px',
                            padding: 0,
                            border: '1px solid rgba(139,0,0,0.18)',
                            borderRadius: '999px',
                            background: 'rgba(255,250,242,0.92)',
                            color: '#8b0000',
                            fontSize: '9px',
                            lineHeight: 1,
                            cursor: 'pointer',
                            opacity: 0,
                            transition: 'opacity 0.15s ease',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        ⌕
                    </button>
                </span>
            );
        };

        // === TOAST SYSTEM ===
        const toastEvents = { listeners: [], subscribe(fn) { this.listeners.push(fn); return () => { this.listeners = this.listeners.filter(l => l !== fn); }; }, emit(t) { this.listeners.forEach(fn => fn(t)); } };
        let toastIdSeq = 0;
        const nextToastId = () => {
            toastIdSeq = (toastIdSeq + 1) % Number.MAX_SAFE_INTEGER;
            return `toast-${Date.now()}-${toastIdSeq}`;
        };
        const showToast = (message, type = 'success', duration = 3000) => {
            toastEvents.emit({ id: nextToastId(), message, type, duration });
        };

        const ToastContainer = () => {
            const [toasts, setToasts] = useState([]);
            useEffect(() => {
                const pendingTimers = new Set();
                const schedule = (fn, ms) => {
                    const handle = setTimeout(() => {
                        pendingTimers.delete(handle);
                        fn();
                    }, ms);
                    pendingTimers.add(handle);
                    return handle;
                };
                const unsubscribe = toastEvents.subscribe((t) => {
                    setToasts(prev => [...prev, t]);
                    schedule(() => {
                        setToasts(prev => prev.map(x => x.id === t.id ? {...x, exit: true} : x));
                        schedule(() => setToasts(prev => prev.filter(x => x.id !== t.id)), 300);
                    }, t.duration);
                });
                return () => {
                    unsubscribe();
                    pendingTimers.forEach(clearTimeout);
                    pendingTimers.clear();
                };
            }, []);
            const icons = { success: '✓', error: '✕', info: 'ℹ', warning: '⚠' };
            return (
                <div className="toast-container">
                    {toasts.map(t => (
                        <div key={t.id} className={`toast toast-${t.type} ${t.exit ? 'toast-exit' : ''}`}>
                            <span>{icons[t.type] || '•'}</span>
                            <span>{t.message}</span>
                        </div>
                    ))}
                </div>
            );
        };

        // === CONFIRM DIALOG ===
        const confirmEvents = { queue: [], trigger: null };
        const showConfirm = (message) => {
            return new Promise((resolve) => {
                confirmEvents.queue.push({ message, resolve });
                confirmEvents.trigger?.();
            });
        };

        const ConfirmDialog = () => {
            const [current, setCurrent] = useState(null);
            const currentRef = useRef(null);
            useEffect(() => { currentRef.current = current; }, [current]);
            useEffect(() => {
                const pump = () => {
                    if (currentRef.current) return;
                    const next = confirmEvents.queue.shift();
                    if (next) setCurrent(next);
                };
                confirmEvents.trigger = pump;
                pump();
                return () => {
                    if (confirmEvents.trigger === pump) confirmEvents.trigger = null;
                };
            }, []);
            const handle = (val) => {
                const entry = current;
                setCurrent(null);
                entry?.resolve?.(val);
                // Поднимаем следующий из очереди после того, как state обновится
                Promise.resolve().then(() => {
                    if (!currentRef.current) {
                        const next = confirmEvents.queue.shift();
                        if (next) setCurrent(next);
                    }
                });
            };
            if (!current) return null;
            return (
                <div className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-xl shadow-2xl p-6 max-w-sm w-full border border-stone-200">
                        <div className="text-sm text-stone-700 mb-6 leading-relaxed">{current.message}</div>
                        <div className="flex gap-3 justify-end">
                            <button onClick={() => handle(false)} className="px-4 py-2 text-sm text-stone-500 hover:text-stone-700 rounded-lg hover:bg-stone-100 transition-colors">Отмена</button>
                            <button onClick={() => handle(true)} className="px-4 py-2 text-sm bg-[#8b0000] text-white rounded-lg hover:bg-red-900 transition-colors font-bold">Подтвердить</button>
                        </div>
                    </div>
                </div>
            );
        };

        // === PROJECT STATS MODAL ===
        const ProjectStatsModal = ({ catalog, project, onClose }) => {
            const stats = useMemo(() => {
                const totalDocs = catalog.length;
                const favs = catalog.filter(c => c.is_favorite).length;
                
                // По годам
                const byYear = {};
                catalog.forEach(item => {
                    const m = ((item.date_label || '') + ' ' + item.issue).match(/(\d{4})/);
                    const year = m ? m[1] : 'Н/Д';
                    byYear[year] = (byYear[year] || 0) + 1;
                });
                
                // По типам
                const byType = {};
                catalog.forEach(item => {
                    const dt = item.doc_type || 'document';
                    const labels = { periodical: 'Периодика', archive: 'Архив', document: 'Документ' };
                    const label = labels[dt] || dt;
                    byType[label] = (byType[label] || 0) + 1;
                });
                
                // По изданиям (топ-8)
                const byPeriodical = {};
                catalog.forEach(item => {
                    byPeriodical[item.periodical] = (byPeriodical[item.periodical] || 0) + 1;
                });
                
                // Теги (топ-8)
                const byTag = {};
                catalog.forEach(item => {
                    (item.tags || []).forEach(t => { byTag[t] = (byTag[t] || 0) + 1; });
                });
                
                // Диапазон дат
                const years = Object.keys(byYear).filter(y => y !== 'Н/Д').map(Number).sort((a,b) => a-b);
                const dateRange = years.length > 0 ? `${years[0]} — ${years[years.length-1]}` : 'Н/Д';
                
                return { totalDocs, favs, byYear, byType, byPeriodical, byTag, dateRange, years };
            }, [catalog]);
            
            const renderBars = (data, maxItems = 8) => {
                const sorted = Object.entries(data).sort((a,b) => b[1] - a[1]).slice(0, maxItems);
                const maxVal = Math.max(...sorted.map(s => s[1]), 1);
                return sorted.map(([label, count]) => (
                    <div key={label} className="stats-bar-row">
                        <div className="stats-bar-label" title={label}>{label}</div>
                        <div className="stats-bar-track">
                            <div className="stats-bar-fill" style={{width: `${(count / maxVal) * 100}%`}}></div>
                        </div>
                        <div className="stats-bar-count">{count}</div>
                    </div>
                ));
            };
            
            // Мини-график по годам
            const renderYearChart = () => {
                const years = stats.years;
                if (years.length === 0) return <div className="text-xs text-stone-400 italic">Нет данных о годах</div>;
                const minY = years[0], maxY = years[years.length - 1];
                const allYears = [];
                for (let y = minY; y <= maxY; y++) allYears.push({ year: y, count: stats.byYear[y.toString()] || 0 });
                const maxCount = Math.max(...allYears.map(y => y.count), 1);
                return (
                    <div>
                        <div className="flex items-end gap-[2px] h-16 mb-2">
                            {allYears.map(y => (
                                <div key={y.year} className="flex-1 rounded-t-sm transition-all" style={{
                                    height: y.count > 0 ? `${Math.max(8, (y.count / maxCount) * 100)}%` : '2px',
                                    background: y.count > 0 ? 'linear-gradient(to top, #8b0000, #c41e3a)' : '#e0dcd3'
                                }} title={`${y.year}: ${y.count}`} />
                            ))}
                        </div>
                        <div className="flex justify-between text-[9px] text-stone-400">
                            <span>{minY}</span>
                            <span>{maxY}</span>
                        </div>
                    </div>
                );
            };
            
            const tagCount = Object.keys(stats.byTag).length;
            
            return (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={onClose}>
                    <div className="bg-[#fdfbf7] rounded-xl shadow-2xl w-full max-w-lg border border-stone-300 overflow-hidden max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
                        <div className="p-6 border-b bg-white flex justify-between items-center sticky top-0 z-10">
                            <div>
                                <h2 className="font-display font-black uppercase tracking-wider text-stone-800 text-sm">Статистика</h2>
                                <div className="text-[10px] text-stone-400 mt-1">{project.title}</div>
                            </div>
                            <button onClick={onClose} className="text-2xl text-stone-300 hover:text-stone-600 transition-colors">×</button>
                        </div>
                        <div className="p-6 space-y-6">
                            <div className="stats-grid">
                                <div className="stats-card">
                                    <div className="stats-card-value">{stats.totalDocs}</div>
                                    <div className="stats-card-label">Документов</div>
                                </div>
                                <div className="stats-card">
                                    <div className="stats-card-value">{stats.favs}</div>
                                    <div className="stats-card-label">В избранном</div>
                                </div>
                                <div className="stats-card">
                                    <div className="stats-card-value">{tagCount}</div>
                                    <div className="stats-card-label">Тегов</div>
                                </div>
                            </div>
                            
                            <div className="stats-card" style={{gridColumn: 'span 3'}}>
                                <div className="text-left mb-1">
                                    <span className="text-[10px] uppercase tracking-wider text-stone-400 font-bold">Период: </span>
                                    <span className="text-sm font-bold text-stone-700">{stats.dateRange}</span>
                                </div>
                            </div>
                            
                            <div className="stats-section">
                                <div className="stats-section-title">📊 Распределение по годам</div>
                                {renderYearChart()}
                            </div>
                            
                            {Object.keys(stats.byType).length > 1 && (
                                <div className="stats-section">
                                    <div className="stats-section-title">📋 По типам</div>
                                    {renderBars(stats.byType)}
                                </div>
                            )}
                            
                            <div className="stats-section">
                                <div className="stats-section-title">📰 По изданиям</div>
                                {renderBars(stats.byPeriodical)}
                            </div>
                            
                            {Object.keys(stats.byTag).length > 0 && (
                                <div className="stats-section">
                                    <div className="stats-section-title">🏷 Популярные теги</div>
                                    {renderBars(stats.byTag)}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        };

        // === ICONS ===
        const IconMenu = () => <svg viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>;
        const IconHeart = ({ active }) => <svg className={`w-[14px] h-[14px] transition-all ${active ? 'fill-[#8b0000] stroke-[#8b0000] scale-110' : 'fill-transparent stroke-stone-300'}`} viewBox="0 0 24 24" strokeWidth="2"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>;
        const IconShare = ({ active }) => <svg viewBox="0 0 24 24" width="16" height="16" className={active ? 'text-blue-600' : 'text-stone-300'}><path fill="currentColor" d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/></svg>;
        const IconHome = () => <svg viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>;
        const IconGear = () => <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.56-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22l-1.92 3.32c-.12.22-.07.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.04.64.09.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.04.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.03-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>;
        const IconExternal = () => <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>;

        // === LANDING PAGE ===
        const LandingPage = ({ user, onSelect, authProviders }) => {
            const googleButtonRef = useRef(null);
            const [googleError, setGoogleError] = useState('');
            const [googleLoading, setGoogleLoading] = useState(false);
            const googleEnabled = !!authProviders?.google?.enabled;

            useEffect(() => {
                if (!user && !document.getElementById('landing-tg')?.hasChildNodes()) {
                    const s = document.createElement('script');
                    s.src = "https://telegram.org/js/telegram-widget.js?22";
                    s.setAttribute('data-telegram-login', 'YaArchive_bot');
                    s.setAttribute('data-size', 'large');
                    s.setAttribute('data-radius', '5');
                    s.setAttribute('data-auth-url', API_BASE + '/auth/telegram');
                    document.getElementById('landing-tg').appendChild(s);
                }
            }, [user]);

            useEffect(() => {
                if (user) return;
                const googleConfig = authProviders?.google;
                if (!googleConfig?.enabled || !googleConfig.client_id || !googleButtonRef.current) return;

                let cancelled = false;

                const handleCredentialResponse = async (response) => {
                    if (!response?.credential) {
                        setGoogleError('Google не вернул credential для входа.');
                        return;
                    }
                    setGoogleLoading(true);
                    setGoogleError('');
                    try {
                        const res = await fetch(`${API_BASE}/auth/google`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            credentials: 'same-origin',
                            body: JSON.stringify({
                                credential: response.credential,
                                client_id: googleConfig.client_id,
                                select_by: response.select_by || ''
                            })
                        });
                        const data = await res.json().catch(() => ({}));
                        if (!res.ok) {
                            throw new Error(data?.error || `HTTP ${res.status}`);
                        }
                        window.location.assign(data?.redirect || BASE_PATH || '/');
                    } catch (error) {
                        console.error(error);
                        setGoogleError(error?.message || 'Не удалось войти через Google.');
                        setGoogleLoading(false);
                    }
                };

                const renderGoogleButton = () => {
                    if (cancelled || !window.google?.accounts?.id || !googleButtonRef.current) return;
                    googleButtonRef.current.innerHTML = '';
                    window.google.accounts.id.initialize({
                        client_id: googleConfig.client_id,
                        callback: handleCredentialResponse,
                        auto_select: false,
                        cancel_on_tap_outside: true,
                        hd: googleConfig.hosted_domain || 'famiry.ru',
                        context: 'signin',
                        use_fedcm_for_button: true
                    });
                    window.google.accounts.id.renderButton(googleButtonRef.current, {
                        type: 'standard',
                        theme: 'outline',
                        size: 'large',
                        text: 'signin_with',
                        shape: 'rectangular',
                        logo_alignment: 'left',
                        width: 320,
                        locale: 'ru'
                    });
                };

                if (window.google?.accounts?.id) {
                    renderGoogleButton();
                    return () => {
                        cancelled = true;
                    };
                }

                const existing = document.getElementById('google-identity-client');
                if (existing) {
                    existing.addEventListener('load', renderGoogleButton, { once: true });
                    return () => {
                        cancelled = true;
                    };
                }

                const script = document.createElement('script');
                script.id = 'google-identity-client';
                script.src = GOOGLE_IDENTITY_SCRIPT_SRC;
                script.async = true;
                script.defer = true;
                script.onload = renderGoogleButton;
                document.head.appendChild(script);

                return () => {
                    cancelled = true;
                };
            }, [user, authProviders]);

            // Если залогинен — сразу в workspace
            useEffect(() => {
                if (user) onSelect(null);
            }, [user]);

            return (
                <div className="h-screen w-full flex items-center justify-center font-serif bg-stone-900">
                    <div className="text-center fade-in px-6">
                        <div className="rounded-[28px] border border-white/10 bg-white/5 backdrop-blur-sm px-8 py-8 shadow-2xl min-w-[320px] max-w-[380px]">
                            <div className="text-[10px] uppercase tracking-[0.28em] text-stone-400 font-bold">Вход в архив</div>
                            <div className="mt-2 font-display text-3xl text-white">yarchiver</div>
                            <div className="mt-3 text-[13px] leading-6 text-stone-300">
                                {googleEnabled ? (
                                    <>Войти можно через Telegram или через Google-аккаунт домена <span className="text-white font-semibold">famiry.ru</span>.</>
                                ) : (
                                    <>Войти можно через Telegram. Google-вход для домена <span className="text-white font-semibold">famiry.ru</span> появится после добавления client ID.</>
                                )}
                            </div>
                            <div className="mt-6 flex flex-col items-center gap-4">
                                <div id="landing-tg" className="min-h-[40px]"></div>
                                {googleEnabled && (
                                    <>
                                        <div className="flex items-center gap-3 w-full text-stone-500 text-[11px] uppercase tracking-[0.18em]">
                                            <div className="h-px bg-white/10 flex-1" />
                                            <span>или</span>
                                            <div className="h-px bg-white/10 flex-1" />
                                        </div>
                                        <div ref={googleButtonRef} className="min-h-[44px] flex items-center justify-center" />
                                    </>
                                )}
                                {googleLoading && (
                                    <div className="text-[12px] text-stone-400">Проверяем Google-аккаунт...</div>
                                )}
                                {!!googleError && (
                                    <div className="w-full rounded-2xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-[12px] leading-5 text-red-100">
                                        {googleError}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        // === TIMELINE ===
        const Timeline = ({ stats, monthStats, currentFilter, onYearClick, onMonthClick, onReset, disableMonths = false, centerLabel = 'Шкала времени' }) => {
            const years = Object.keys(stats).map(Number).sort((a,b) => a-b);
            if (years.length === 0) return null;

            const selectedYear = currentFilter === '0' ? null : currentFilter.split('-')[0];
            const activeMonthKey = currentFilter.includes('-') ? currentFilter : null;

            if (selectedYear && !disableMonths) {
                const monthsForSelectedYear = Array.from({ length: 12 }, (_, idx) => {
                    const month = idx + 1;
                    const key = `${selectedYear}-${String(month).padStart(2, '0')}`;
                    return { key, month, count: monthStats?.[key] || 0 };
                });
                const maxMonthCount = Math.max(...monthsForSelectedYear.map(item => item.count).filter(c => c > 0), 1);
                const hasMonthData = monthsForSelectedYear.some(item => item.count > 0);

                return (
                    <div className="px-6 py-4 bg-white border-b border-stone-200 shrink-0">
                        <div className="flex items-center justify-between gap-3 mb-3">
                            <button
                                onClick={onReset}
                                className="shrink-0 rounded-full border border-stone-200 bg-stone-50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-500 hover:border-stone-300 hover:bg-white hover:text-[#8b0000] transition-colors"
                            >
                                ← Годы
                            </button>
                            <div className="min-w-0 text-center">
                                <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Месяцы {selectedYear}</div>
                                <div className="mt-1 text-[10px] text-stone-400">
                                    {hasMonthData ? 'Выберите месяц' : 'Нет точной разбивки по месяцам'}
                                </div>
                            </div>
                            {activeMonthKey ? (
                                <button
                                    onClick={() => onYearClick(selectedYear)}
                                    className="shrink-0 rounded-full border border-stone-200 bg-stone-50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-500 hover:border-stone-300 hover:bg-white hover:text-[#8b0000] transition-colors"
                                >
                                    Весь год
                                </button>
                            ) : (
                                <div className="w-[74px] shrink-0" />
                            )}
                        </div>
                        <div className="flex items-end gap-[2px] h-10">
                            {monthsForSelectedYear.map(({ key, month, count }) => {
                                const isActive = key === activeMonthKey;
                                const tooltip = count > 0 ? `${MONTH_FULL_NAMES[month - 1]} ${selectedYear}: ${count} док.` : `${MONTH_FULL_NAMES[month - 1]} ${selectedYear}: нет документов`;
                                return (
                                    <div
                                        key={key}
                                        onClick={() => count > 0 && onMonthClick(key)}
                                        className={`timeline-bar flex-1 rounded-t-[1px] transition-all ${count > 0 ? 'has-docs cursor-pointer' : ''} ${isActive ? 'bg-[#8b0000] scale-y-110' : count > 0 ? 'bg-stone-300 hover:bg-stone-500' : 'bg-stone-200'}`}
                                        style={{ height: count ? `${Math.max(15, (count / maxMonthCount) * 100)}%` : '2px' }}
                                        data-tooltip={tooltip}
                                    />
                                );
                            })}
                        </div>
                        <div className="flex justify-between mt-2 text-[9px] font-bold text-stone-400 uppercase tracking-[0.1em]">
                            <span>Янв</span>
                            <span>{activeMonthKey ? 'Фильтр по месяцам' : 'По месяцам'}</span>
                            <span>Дек</span>
                        </div>
                    </div>
                );
            }

            const minYear = years[0], maxYear = years[years.length-1];
            const maxCount = Math.max(...Object.values(stats));
            const allYears = [];
            for(let y = minYear; y <= maxYear; y++) allYears.push({ year: y, count: stats[y] || 0 });

            return (
                <div className="px-6 py-4 bg-white border-b border-stone-200 shrink-0">
                    <div className="relative">
                        <div className="flex items-end gap-[2px] h-10">
                            {allYears.map(item => {
                                const isActive = String(item.year) === selectedYear;
                                return (
                                <div 
                                    key={item.year} 
                                    onClick={() => item.count > 0 && onYearClick(item.year.toString())} 
                                    className={`timeline-bar flex-1 rounded-t-[1px] transition-all ${item.count > 0 ? 'has-docs cursor-pointer' : ''} ${isActive ? 'bg-[#8b0000] scale-y-110' : item.count > 0 ? 'bg-stone-300 hover:bg-stone-500' : 'bg-stone-200'}`} 
                                    style={{ height: item.count ? `${Math.max(15, (item.count / maxCount) * 100)}%` : '2px' }} 
                                    data-tooltip={item.count > 0 ? `${item.year}: ${item.count} док.` : `${item.year}: пусто`}
                                />
                                );
                            })}
                        </div>
                        <div className="flex justify-between mt-2 text-[9px] font-bold text-stone-400 uppercase tracking-[0.1em]">
                            <span>{minYear}</span>
                            <span>{selectedYear && disableMonths ? `Выбран ${selectedYear}` : centerLabel}</span>
                            <span>{maxYear}</span>
                        </div>
                    </div>
                </div>
            );
        };

        // === USER BADGE (компактный) ===
        const UserBadge = ({ user, onHome }) => null; // Перенесено в хедер

        const PaginationControls = ({ page, totalPages, totalItems, pageSize, label, onChange }) => {
            if (totalPages <= 1) return null;

            const safePage = Math.min(Math.max(page, 1), totalPages);
            const start = totalItems === 0 ? 0 : ((safePage - 1) * pageSize) + 1;
            const end = Math.min(totalItems, safePage * pageSize);
            const pages = [];

            for (let value = Math.max(1, safePage - 2); value <= Math.min(totalPages, safePage + 2); value += 1) {
                pages.push(value);
            }

            return (
                <div className="flex flex-col flex-wrap gap-3 rounded-2xl border border-stone-200 bg-white/90 px-3 py-3 shadow-sm md:flex-row md:flex-wrap md:items-center md:justify-between min-w-0 max-w-full">
                    <div className="text-[11px] text-stone-500 min-w-0 break-words">
                        <span className="font-bold text-stone-700">{label || 'Страницы'}</span>
                        <span className="ml-2">{start}–{end} из {totalItems}</span>
                    </div>
                    <div className="flex flex-wrap items-center justify-center gap-1.5 min-w-0 max-w-full">
                        <button
                            onClick={() => onChange(safePage - 1)}
                            disabled={safePage <= 1}
                            className="rounded-full border border-stone-200 bg-stone-50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-500 transition-colors hover:border-stone-300 hover:bg-white hover:text-[#8b0000] disabled:cursor-not-allowed disabled:opacity-40"
                        >
                            ←
                        </button>
                        {pages[0] > 1 && (
                            <>
                                <button
                                    onClick={() => onChange(1)}
                                    className="rounded-full px-2 py-1 text-[11px] font-bold text-stone-500 transition-colors hover:bg-stone-100 hover:text-[#8b0000]"
                                >
                                    1
                                </button>
                                {pages[0] > 2 && <span className="px-0.5 text-stone-300">…</span>}
                            </>
                        )}
                        {pages.map(pageNumber => (
                            <button
                                key={pageNumber}
                                onClick={() => onChange(pageNumber)}
                                className={`rounded-full px-2 py-1 text-[11px] font-bold transition-colors ${pageNumber === safePage ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:bg-stone-100 hover:text-[#8b0000]'}`}
                            >
                                {pageNumber}
                            </button>
                        ))}
                        {pages[pages.length - 1] < totalPages && (
                            <>
                                {pages[pages.length - 1] < totalPages - 1 && <span className="px-0.5 text-stone-300">…</span>}
                                <button
                                    onClick={() => onChange(totalPages)}
                                    className="rounded-full px-2 py-1 text-[11px] font-bold text-stone-500 transition-colors hover:bg-stone-100 hover:text-[#8b0000]"
                                >
                                    {totalPages}
                                </button>
                            </>
                        )}
                        <button
                            onClick={() => onChange(safePage + 1)}
                            disabled={safePage >= totalPages}
                            className="rounded-full border border-stone-200 bg-stone-50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-500 transition-colors hover:border-stone-300 hover:bg-white hover:text-[#8b0000] disabled:cursor-not-allowed disabled:opacity-40"
                        >
                            →
                        </button>
                    </div>
                </div>
            );
        };

        const SummaryTableView = ({
            project,
            rows,
            allRows,
            currentPage,
            totalPages,
            onPageChange,
            canEdit,
            onEditRow,
            searchQuery,
            onSearchChange,
            embedded = false,
            badgeLabel = 'Внутренняя страница проекта',
            title = 'Общая таблица',
            description = 'Сюда собираются записи только из рабочих колонок c3, c4 и c5. Приоритет у c4, затем c3 и c5. Если колонка формально есть, но после фильтров в ней не остается строк, таблица автоматически берет следующую рабочую колонку.',
            resultsLabel = 'Строки таблицы',
            emptyTitle = 'Пока нечего показывать',
            emptyDescription = 'Таблица заполнится, когда в проекте появятся активные записи со сниппетами.',
            onClose = null
        }) => {
            const rowCount = allRows.length;
            const pageCount = new Set(allRows.map(row => row.itemId)).size;
            const caseCount = new Set(allRows.map(row => row.cipherLabel)).size;
            const rowOffset = (currentPage - 1) * SUMMARY_TABLE_PAGE_SIZE;
            const hasSearch = String(searchQuery || '').trim().length > 0;
            const renderCellText = (value) => {
                const text = String(value || '').trim();
                if (!text) return '—';
                return searchQuery ? highlightText(text, searchQuery) : text;
            };
            const card = (
                <div className="parents-table-shell">
                    <div className="parents-table-header">
                        <div className="flex flex-col gap-6 xl:flex-row xl:items-end xl:justify-between">
                            <div className="min-w-0 max-w-2xl">
                                <span className="parents-eyebrow">{badgeLabel}</span>
                                <h2 className="parents-page-title" style={{ fontSize: 'clamp(24px, 2.6vw, 32px)', marginTop: '10px' }}>{title}</h2>
                                <span className="parents-page-rule" style={{ marginTop: '12px', width: '72px' }} />
                                <p className="parents-page-lede" style={{ fontSize: '13px', marginTop: '12px' }}>{description}</p>
                                {project?.title && (
                                    <div className="mt-3 text-[10px] uppercase tracking-[0.18em] text-[var(--parents-ink-soft)]">
                                        {project.title}
                                    </div>
                                )}
                            </div>
                            <div className="flex items-start gap-3 shrink-0">
                                <div className="grid grid-cols-3 gap-2.5">
                                    <div className="parents-stat-tile">
                                        <div className="parents-stat-tile__label">Строк</div>
                                        <div className="parents-stat-tile__value">{rowCount}</div>
                                    </div>
                                    <div className="parents-stat-tile">
                                        <div className="parents-stat-tile__label">Страниц</div>
                                        <div className="parents-stat-tile__value">{pageCount}</div>
                                    </div>
                                    <div className="parents-stat-tile">
                                        <div className="parents-stat-tile__label">Дел</div>
                                        <div className="parents-stat-tile__value">{caseCount}</div>
                                    </div>
                                </div>
                                {typeof onClose === 'function' && (
                                    <button
                                        onClick={onClose}
                                        className="parents-table-action-btn parents-table-action-btn--primary"
                                        style={{ width: '34px', height: '34px', fontSize: '16px' }}
                                        title="Закрыть выборку"
                                    >
                                        ×
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="parents-table-toolbar">
                        <div className="min-w-0">
                            <span className="parents-eyebrow parents-eyebrow--copper">Поиск по таблице</span>
                            <div className="mt-1.5 text-[11px] text-[var(--parents-ink-soft)]">
                                По шифру дела, странице и любым полям записи.
                            </div>
                            {hasSearch && (
                                <div className="mt-1.5 text-[11px] text-[var(--parents-ink-soft)]">
                                    Найдено: <span className="font-bold text-[var(--parents-ink)]">{rowCount}</span>
                                </div>
                            )}
                        </div>
                        <label className="parents-table-search">
                            <span className="parents-table-search__icon">⌕</span>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => onSearchChange?.(e.target.value)}
                                placeholder="Введите слово…"
                                className="parents-table-search__input"
                            />
                        </label>
                    </div>

                    {rowCount > 0 ? (
                        <>
                        <div className="parents-table-toolbar parents-table-toolbar--pagination">
                            <PaginationControls
                                page={currentPage}
                                totalPages={totalPages}
                                totalItems={rowCount}
                                pageSize={SUMMARY_TABLE_PAGE_SIZE}
                                label={resultsLabel}
                                onChange={onPageChange}
                            />
                        </div>
                        <div className="parents-table-scroll">
                            <table className="parents-table min-w-[1220px]">
                                <thead>
                                    <tr>
                                        {[
                                            '',
                                            '№',
                                            'Шифр дела',
                                            'Страница',
                                            'Имя',
                                            'Губерния',
                                            'Уезд',
                                            'Волость',
                                            'Деревня / село',
                                            'Занятие'
                                        ].map(label => (
                                            <th key={label}>{label}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={row.id} title={row.snippetText || ''}>
                                            <td className="parents-cell--actions">
                                                {canEdit && typeof onEditRow === 'function' ? (
                                                    <button
                                                        onClick={() => onEditRow(row)}
                                                        className="parents-table-action-btn parents-table-action-btn--primary"
                                                        title="Редактировать запись"
                                                    >
                                                        ✎
                                                    </button>
                                                ) : null}
                                            </td>
                                            <td className="parents-cell--num">{rowOffset + index + 1}</td>
                                            <td style={{ minWidth: '170px' }}>{renderCellText(row.cipherLabel)}</td>
                                            <td className="parents-cell--meta" style={{ minWidth: '64px' }}>{renderCellText(row.pageLabel)}</td>
                                            <td style={{ minWidth: '145px' }}>{renderCellText(row.name)}</td>
                                            <td style={{ minWidth: '150px' }}>{renderCellText(row.governorate)}</td>
                                            <td style={{ minWidth: '150px' }}>{renderCellText(row.uyezd)}</td>
                                            <td style={{ minWidth: '150px' }}>{renderCellText(row.volost)}</td>
                                            <td style={{ minWidth: '170px' }}>{renderCellText(row.locality)}</td>
                                            <td style={{ minWidth: '145px' }}>{renderCellText(row.occupation)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="parents-table-toolbar parents-table-toolbar--pagination">
                            <PaginationControls
                                page={currentPage}
                                totalPages={totalPages}
                                totalItems={rowCount}
                                pageSize={SUMMARY_TABLE_PAGE_SIZE}
                                label={resultsLabel}
                                onChange={onPageChange}
                            />
                        </div>
                        </>
                    ) : (
                        <div className="px-8 py-20 text-center">
                            <div className="font-display text-2xl text-[var(--parents-ink)]" style={{ fontFamily: "'Playfair Display', serif" }}>{hasSearch ? 'Ничего не найдено' : emptyTitle}</div>
                            <div className="mt-2 text-sm text-[var(--parents-ink-soft)]" style={{ fontFamily: "'Lora', serif" }}>
                                {hasSearch ? 'Попробуйте изменить поисковый запрос или очистить фильтр.' : emptyDescription}
                            </div>
                        </div>
                    )}
                </div>
            );

            if (embedded) {
                return card;
            }

            return (
                <div className="flex-1 min-h-0 overflow-hidden bg-[#e8e4dc] bg-texture">
                    <div className="h-full overflow-auto">
                        <div className="max-w-[1880px] mx-auto px-6 py-6">
                            {card}
                        </div>
                    </div>
                </div>
            );
        };

        const buildStatisticsFrequency = (rows, key, limit = Infinity) => {
            const counter = new Map();
            rows.forEach(row => {
                const descriptor = buildStatisticsValueDescriptor(key, row?.[key] || '');
                if (!descriptor.groupKey) return;
                const current = counter.get(descriptor.groupKey) || { name: descriptor.label, value: 0 };
                counter.set(descriptor.groupKey, {
                    name: current.name || descriptor.label,
                    value: current.value + 1
                });
            });
            const sorted = [...counter.values()]
                .sort((left, right) => right.value - left.value || left.name.localeCompare(right.name, 'ru'));
            return Number.isFinite(limit) ? sorted.slice(0, limit) : sorted;
        };

        const StatisticsLookupPanel = ({
            placeholder = '',
            query = '',
            onQueryChange = null,
            loading = false,
            results = [],
            selectedResult = null,
            onSelectResult = null,
            onClearSelection = null,
            accentColor = '#8b0000',
        }) => {
            const hasQuery = String(query || '').trim().length > 0;
            const visibleResults = Array.isArray(results) ? results.slice(0, 8) : [];

            return (
                <div
                    style={{
                        marginBottom: '14px',
                        padding: '14px',
                        borderRadius: '20px',
                        background: 'rgba(255,255,255,0.78)',
                        border: '1px solid rgba(92, 61, 38, 0.1)',
                        boxShadow: '0 8px 20px rgba(45,34,20,0.05)',
                    }}
                >
                    <div className="flex flex-col gap-3">
                        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                            <div style={{ fontSize: '10px', fontWeight: 800, letterSpacing: '0.16em', textTransform: 'uppercase', color: accentColor, opacity: 0.82 }}>
                                Поиск по полной выборке
                            </div>
                            {selectedResult?.name ? (
                                <div
                                    className="flex flex-wrap items-center gap-2"
                                    style={{
                                        padding: '7px 10px',
                                        borderRadius: '999px',
                                        background: `${accentColor}10`,
                                        border: `1px solid ${accentColor}1f`,
                                        color: '#5f5247',
                                        fontSize: '11px',
                                        fontWeight: 700,
                                    }}
                                >
                                    <span style={{ color: accentColor }}>Показано:</span>
                                    <span>{selectedResult.name}</span>
                                    <span style={{ opacity: 0.72 }}>·</span>
                                    <span>{Number(selectedResult.value || 0).toLocaleString('ru-RU')}</span>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (typeof onClearSelection === 'function') onClearSelection();
                                        }}
                                        className="rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.08em] transition-colors"
                                        style={{
                                            background: 'rgba(255,255,255,0.85)',
                                            border: `1px solid ${accentColor}22`,
                                            color: accentColor,
                                        }}
                                    >
                                        Сбросить
                                    </button>
                                </div>
                            ) : null}
                        </div>

                        <div>
                            <input
                                type="search"
                                value={query}
                                onChange={(event) => {
                                    if (typeof onQueryChange === 'function') onQueryChange(event.target.value || '');
                                }}
                                placeholder={placeholder}
                                className="w-full rounded-[16px] border bg-white px-4 py-3 text-sm outline-none transition-shadow"
                                style={{
                                    borderColor: 'rgba(92, 61, 38, 0.16)',
                                    color: '#35271e',
                                    boxShadow: 'inset 0 1px 2px rgba(45,34,20,0.04)',
                                }}
                            />
                        </div>

                        {hasQuery ? (
                            <div
                                style={{
                                    borderRadius: '16px',
                                    background: 'rgba(252,248,242,0.85)',
                                    border: '1px solid rgba(92, 61, 38, 0.08)',
                                    overflow: 'hidden',
                                }}
                            >
                                {loading ? (
                                    <div style={{ padding: '12px 14px', fontSize: '12px', color: '#786b5f' }}>
                                        Ищем по полному списку значений…
                                    </div>
                                ) : visibleResults.length > 0 ? (
                                    <div className="flex flex-col">
                                        {visibleResults.map((result) => (
                                            <button
                                                key={`${result?.groupKey || result?.name || 'lookup'}:${result?.value || 0}`}
                                                type="button"
                                                onClick={() => {
                                                    if (typeof onSelectResult === 'function') onSelectResult(result);
                                                }}
                                                className="flex items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-white"
                                                style={{
                                                    borderTop: '1px solid rgba(92, 61, 38, 0.06)',
                                                }}
                                            >
                                                <div className="min-w-0">
                                                    <div style={{ fontSize: '14px', fontWeight: 700, color: '#35271e', lineHeight: 1.2 }}>
                                                        {result?.name || 'Без названия'}
                                                    </div>
                                                    <div style={{ marginTop: '3px', fontSize: '11px', color: '#786b5f' }}>
                                                        Найдено записей: {Number(result?.value || 0).toLocaleString('ru-RU')}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        padding: '6px 9px',
                                                        borderRadius: '999px',
                                                        background: `${accentColor}10`,
                                                        border: `1px solid ${accentColor}1f`,
                                                        color: accentColor,
                                                        fontSize: '10px',
                                                        fontWeight: 800,
                                                        letterSpacing: '0.08em',
                                                        textTransform: 'uppercase',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    Показать
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                ) : (
                                    <div style={{ padding: '12px 14px', fontSize: '12px', color: '#786b5f' }}>
                                        По этому запросу ничего не нашлось.
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div style={{ fontSize: '12px', color: '#786b5f', lineHeight: 1.5 }}>
                                Можно ввести любое имя или фамилию, даже если этого значения нет в текущем топе. После выбора значение появится на графике и откроет свою выборку.
                            </div>
                        )}
                    </div>
                </div>
            );
        };

        const StatsSparkline = ({ series = [], color = '#f6b26b', width = 116, height = 30, highlightFrom = null, highlightTo = null }) => {
            const points = useMemo(() => {
                const values = (series || []).map(item => Number(item?.value || 0));
                if (values.length < 2) return '';
                const maxValue = Math.max(...values, 1);
                const stepX = width / (values.length - 1);
                return values
                    .map((value, index) => `${(index * stepX).toFixed(1)},${(height - 2 - (value / maxValue) * (height - 6)).toFixed(1)}`)
                    .join(' ');
            }, [series, width, height]);
            const highlightRect = useMemo(() => {
                if (highlightFrom === null || highlightTo === null || (series || []).length < 2) return null;
                const firstYear = Number(series[0]?.year);
                const lastYear = Number(series[series.length - 1]?.year);
                if (!Number.isFinite(firstYear) || !Number.isFinite(lastYear) || lastYear <= firstYear) return null;
                const clamp = (year) => Math.min(Math.max(year, firstYear), lastYear);
                const x1 = ((clamp(highlightFrom) - firstYear) / (lastYear - firstYear)) * width;
                const x2 = ((clamp(highlightTo) - firstYear) / (lastYear - firstYear)) * width;
                if (x2 <= x1) return null;
                return { x: x1, w: x2 - x1 };
            }, [series, highlightFrom, highlightTo, width]);
            if (!points) return null;
            return (
                <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block', overflow: 'visible' }} aria-hidden="true">
                    {highlightRect && (
                        <rect x={highlightRect.x} y="0" width={highlightRect.w} height={height} rx="3" fill={color} opacity="0.16" />
                    )}
                    <polyline points={points} fill="none" stroke={color} strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" opacity="0.9" />
                </svg>
            );
        };

        const StatsYearRangeBrush = ({ timeline = [], value = null, onChange }) => {
            const svgRef = useRef(null);
            const dragStateRef = useRef(null);
            const [draftRange, setDraftRange] = useState(null);
            const [hoverYear, setHoverYear] = useState(null);
            const years = useMemo(() => timeline.map(item => Number(item?.year)).filter(Number.isFinite), [timeline]);
            const firstYear = years.length ? years[0] : null;
            const lastYear = years.length ? years[years.length - 1] : null;
            const maxTotal = useMemo(() => Math.max(1, ...timeline.map(item => Number(item?.total || 0))), [timeline]);
            const yearItemMap = useMemo(() => {
                const map = new Map();
                timeline.forEach(item => {
                    const year = Number(item?.year);
                    if (Number.isFinite(year)) map.set(year, item);
                });
                return map;
            }, [timeline]);
            const snapToDataYear = useCallback((year) => {
                if (!years.length || year === null) return null;
                return years.reduce((best, candidate) => (
                    Math.abs(candidate - year) < Math.abs(best - year) ? candidate : best
                ), years[0]);
            }, [years]);
            const decadeChips = useMemo(() => {
                if (firstYear === null || lastYear === null) return [];
                const chips = [];
                for (let decade = Math.floor(firstYear / 10) * 10; decade <= lastYear; decade += 10) {
                    chips.push({
                        label: `${decade}-е`,
                        from: Math.max(decade, firstYear),
                        to: Math.min(decade + 9, lastYear),
                    });
                }
                return chips;
            }, [firstYear, lastYear]);
            const activeRange = draftRange || (value && Number.isFinite(Number(value.from)) && Number.isFinite(Number(value.to))
                ? { from: Number(value.from), to: Number(value.to) }
                : null);

            const BRUSH_W = 1000;
            const BRUSH_H = 92;
            const yearToX = useCallback((year) => {
                if (firstYear === null || lastYear === null || lastYear === firstYear) return 0;
                return ((year - firstYear) / (lastYear - firstYear)) * BRUSH_W;
            }, [firstYear, lastYear]);
            const eventToYear = useCallback((event) => {
                const node = svgRef.current;
                if (!node || firstYear === null || lastYear === null) return null;
                const rect = node.getBoundingClientRect();
                const ratio = Math.min(Math.max((event.clientX - rect.left) / (rect.width || 1), 0), 1);
                return Math.round(firstYear + ratio * (lastYear - firstYear));
            }, [firstYear, lastYear]);

            const handlePointerDown = useCallback((event) => {
                const year = eventToYear(event);
                if (year === null) return;
                event.preventDefault();
                try { event.currentTarget.setPointerCapture(event.pointerId); } catch (e) { /* noop */ }
                dragStateRef.current = { anchorYear: year };
                setDraftRange({ from: year, to: year });
            }, [eventToYear]);
            const handlePointerMove = useCallback((event) => {
                const year = eventToYear(event);
                if (year === null) return;
                setHoverYear(snapToDataYear(year));
                const dragState = dragStateRef.current;
                if (!dragState) return;
                setDraftRange({
                    from: Math.min(dragState.anchorYear, year),
                    to: Math.max(dragState.anchorYear, year),
                });
            }, [eventToYear, snapToDataYear]);
            const handlePointerLeave = useCallback(() => {
                if (!dragStateRef.current) setHoverYear(null);
            }, []);
            const handlePointerUp = useCallback(() => {
                const dragState = dragStateRef.current;
                dragStateRef.current = null;
                setDraftRange(prev => {
                    if (dragState && prev) {
                        const isSingleYearClick = prev.from === prev.to;
                        const currentFrom = Number(value?.from);
                        const currentTo = Number(value?.to);
                        if (firstYear !== null && lastYear !== null && prev.from <= firstYear && prev.to >= lastYear) {
                            // Протяжка через весь ряд = «показать все годы».
                            onChange?.(null);
                        } else if (isSingleYearClick && currentFrom === prev.from && currentTo === prev.to) {
                            // Повторный клик по уже выбранному году снимает фильтр.
                            onChange?.(null);
                        } else {
                            onChange?.({ from: prev.from, to: prev.to });
                        }
                    }
                    return null;
                });
            }, [onChange, value, firstYear, lastYear]);

            if (!timeline.length || firstYear === null || lastYear === null || lastYear <= firstYear) return null;
            const barWidth = Math.max(2, (BRUSH_W / timeline.length) * 0.72);
            return (
                <div
                    className="mb-5 rounded-[28px] border border-stone-300 bg-[#fffaf2]/95 shadow-[0_12px_32px_rgba(45,34,20,0.06)]"
                    style={{ padding: '16px 20px 12px' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginBottom: '8px', flexWrap: 'wrap' }}>
                        <div style={{ fontSize: '10px', fontWeight: 800, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#8a7a66' }}>
                            Фильтр по годам · клик — один год · протяжка — диапазон · повторный клик — сброс
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {activeRange ? (
                                <span
                                    style={{
                                        display: 'inline-flex', alignItems: 'center', gap: '8px',
                                        padding: '5px 11px', borderRadius: '999px',
                                        background: 'rgba(122,31,31,0.09)', border: '1px solid rgba(122,31,31,0.26)',
                                        color: '#7a1f1f', fontSize: '12px', fontWeight: 800,
                                        fontVariantNumeric: 'tabular-nums'
                                    }}
                                >
                                    {activeRange.from === activeRange.to ? activeRange.from : `${activeRange.from} — ${activeRange.to}`}
                                    {value && !draftRange && (
                                        <button
                                            onClick={() => onChange?.(null)}
                                            title="Сбросить фильтр по годам"
                                            style={{ border: 'none', background: 'transparent', color: '#7a1f1f', cursor: 'pointer', fontSize: '13px', lineHeight: 1, padding: 0, fontWeight: 900 }}
                                        >
                                            ✕
                                        </button>
                                    )}
                                </span>
                            ) : (
                                <span style={{ fontSize: '12px', color: '#9b8b76', fontVariantNumeric: 'tabular-nums' }}>
                                    {firstYear} — {lastYear} · все годы
                                </span>
                            )}
                        </div>
                    </div>
                    <div style={{ position: 'relative' }}>
                    {(hoverYear !== null || draftRange) && (() => {
                        const labelRange = draftRange || null;
                        const labelYear = labelRange ? null : hoverYear;
                        const hoverItem = labelYear !== null ? yearItemMap.get(labelYear) : null;
                        const anchorYear = labelRange ? labelRange.to : labelYear;
                        if (anchorYear === null) return null;
                        const ratio = Math.min(Math.max(yearToX(anchorYear) / BRUSH_W, 0), 1);
                        const labelText = labelRange
                            ? (labelRange.from === labelRange.to ? `${labelRange.from}` : `${labelRange.from} — ${labelRange.to}`)
                            : [
                                `${labelYear} · ${Number(hoverItem?.total || 0).toLocaleString('ru-RU')} соб.`,
                                Number(hoverItem?.births || 0) ? `▲ ${Number(hoverItem.births).toLocaleString('ru-RU')}` : '',
                                Number(hoverItem?.weddings || 0) ? `⚭ ${Number(hoverItem.weddings).toLocaleString('ru-RU')}` : '',
                                Number(hoverItem?.deaths || 0) ? `✝ ${Number(hoverItem.deaths).toLocaleString('ru-RU')}` : '',
                            ].filter(Boolean).join('  ');
                        return (
                            <div style={{
                                position: 'absolute',
                                top: '-6px',
                                left: `${ratio * 100}%`,
                                transform: `translate(${ratio > 0.86 ? '-100%' : ratio < 0.14 ? '0' : '-50%'}, -100%)`,
                                padding: '4px 9px',
                                borderRadius: '8px',
                                background: '#3a2620',
                                color: '#ffeeda',
                                fontSize: '11px',
                                fontWeight: 700,
                                whiteSpace: 'nowrap',
                                pointerEvents: 'none',
                                fontVariantNumeric: 'tabular-nums',
                                boxShadow: '0 6px 16px rgba(45,30,20,0.28)',
                                zIndex: 5
                            }}>
                                {labelText}
                            </div>
                        );
                    })()}
                    <svg
                        ref={svgRef}
                        viewBox={`0 0 ${BRUSH_W} ${BRUSH_H}`}
                        preserveAspectRatio="none"
                        style={{ width: '100%', height: '72px', display: 'block', cursor: 'pointer', touchAction: 'none' }}
                        onPointerDown={handlePointerDown}
                        onPointerMove={handlePointerMove}
                        onPointerUp={handlePointerUp}
                        onPointerCancel={handlePointerUp}
                        onPointerLeave={handlePointerLeave}
                    >
                        {timeline.map((item) => {
                            const year = Number(item?.year);
                            if (!Number.isFinite(year)) return null;
                            const total = Number(item?.total || 0);
                            const barHeight = Math.max(2, (total / maxTotal) * (BRUSH_H - 16));
                            const inRange = !activeRange || (year >= activeRange.from && year <= activeRange.to);
                            const isHovered = hoverYear === year && !draftRange;
                            return (
                                <rect
                                    key={year}
                                    x={yearToX(year) - barWidth / 2}
                                    y={BRUSH_H - 12 - barHeight}
                                    width={barWidth}
                                    height={barHeight}
                                    rx="1.5"
                                    fill={isHovered ? '#7a1f1f' : inRange ? '#a03b2d' : '#d8cbb8'}
                                    opacity={isHovered ? 1 : inRange ? 0.82 : 0.55}
                                    style={{ pointerEvents: 'none' }}
                                />
                            );
                        })}
                        {hoverYear !== null && !draftRange && (
                            <line
                                x1={yearToX(hoverYear)} y1="0" x2={yearToX(hoverYear)} y2={BRUSH_H - 11}
                                stroke="#7a1f1f" strokeWidth="1" strokeDasharray="3 3" opacity="0.55"
                                style={{ pointerEvents: 'none' }}
                            />
                        )}
                        <line x1="0" y1={BRUSH_H - 11} x2={BRUSH_W} y2={BRUSH_H - 11} stroke="#cdbfa9" strokeWidth="1" />
                        {activeRange && (
                            <>
                                <rect
                                    x={yearToX(activeRange.from)}
                                    y="0"
                                    width={Math.max(2, yearToX(activeRange.to) - yearToX(activeRange.from))}
                                    height={BRUSH_H - 11}
                                    fill="rgba(122,31,31,0.07)"
                                    stroke="rgba(122,31,31,0.38)"
                                    strokeWidth="1"
                                    rx="3"
                                    style={{ pointerEvents: 'none' }}
                                />
                                {[activeRange.from, activeRange.to].map((year, index) => (
                                    <line
                                        key={`handle-${index}`}
                                        x1={yearToX(year)} y1="0" x2={yearToX(year)} y2={BRUSH_H - 11}
                                        stroke="#7a1f1f" strokeWidth="2.4"
                                        style={{ pointerEvents: 'none' }}
                                    />
                                ))}
                            </>
                        )}
                    </svg>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px', fontSize: '10px', fontWeight: 700, color: '#a08e77', fontVariantNumeric: 'tabular-nums' }}>
                        <span>{firstYear}</span>
                        <span>{lastYear}</span>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '10px', alignItems: 'center' }}>
                        <button
                            onClick={() => onChange?.(null)}
                            style={{
                                padding: '5px 12px', borderRadius: '999px', cursor: 'pointer',
                                fontSize: '11px', fontWeight: 800, letterSpacing: '0.04em',
                                background: !value ? 'linear-gradient(135deg, #7a1f1f 0%, #a03b2d 100%)' : 'rgba(255,255,255,0.85)',
                                color: !value ? '#fffaf4' : '#6b5c4c',
                                border: !value ? '1px solid rgba(122,31,31,0.5)' : '1px solid rgba(84,61,43,0.16)',
                                transition: 'all 140ms ease'
                            }}
                        >
                            Все годы
                        </button>
                        {decadeChips.map((chip) => {
                            const isActive = Boolean(value) && Number(value.from) === chip.from && Number(value.to) === chip.to;
                            return (
                                <button
                                    key={chip.label}
                                    onClick={() => onChange?.(isActive ? null : { from: chip.from, to: chip.to })}
                                    style={{
                                        padding: '5px 12px', borderRadius: '999px', cursor: 'pointer',
                                        fontSize: '11px', fontWeight: 800, letterSpacing: '0.04em',
                                        fontVariantNumeric: 'tabular-nums',
                                        background: isActive ? 'linear-gradient(135deg, #7a1f1f 0%, #a03b2d 100%)' : 'rgba(255,255,255,0.85)',
                                        color: isActive ? '#fffaf4' : '#6b5c4c',
                                        border: isActive ? '1px solid rgba(122,31,31,0.5)' : '1px solid rgba(84,61,43,0.16)',
                                        transition: 'all 140ms ease'
                                    }}
                                >
                                    {chip.label}
                                </button>
                            );
                        })}
                    </div>
                </div>
            );
        };

        const StatisticsChartCard = ({ title, subtitle, option, height = 340, onChartClick = null, onLegendSelectChange = null, icon = null, accentColor = '#8b0000', badges = [], searchPanel = null, controls = null, replaceOption = false }) => {
            const chartRef = useRef(null);
            const chartInstanceRef = useRef(null);
            const onChartClickRef = useRef(onChartClick);
            const onLegendSelectChangeRef = useRef(onLegendSelectChange);
            const [echartsReady, setEchartsReady] = useState(Boolean(window.echarts));
            const [echartsError, setEchartsError] = useState('');

            useEffect(() => { onChartClickRef.current = onChartClick; }, [onChartClick]);
            useEffect(() => { onLegendSelectChangeRef.current = onLegendSelectChange; }, [onLegendSelectChange]);

            useEffect(() => {
                let cancelled = false;
                if (window.echarts) {
                    setEchartsReady(true);
                    return undefined;
                }
                loadEcharts()
                    .then(() => {
                        if (cancelled) return;
                        setEchartsReady(true);
                        setEchartsError('');
                    })
                    .catch((error) => {
                        if (cancelled) return;
                        console.error(error);
                        setEchartsError('Не удалось загрузить библиотеку графиков');
                    });
                return () => {
                    cancelled = true;
                };
            }, []);

            // Single effect: init instance on first run, then on subsequent option changes
            // just call setOption — keeps animations alive (no dispose/recreate flicker).
            useEffect(() => {
                if (!chartRef.current || !echartsReady || !window.echarts) return undefined;
                let chart = chartInstanceRef.current;
                const isFirstInit = !chart;
                if (isFirstInit) {
                    chart = window.echarts.init(chartRef.current, null, {
                        renderer: 'canvas',
                        devicePixelRatio: Math.min(window.devicePixelRatio || 1, 1.75),
                    });
                    chartInstanceRef.current = chart;
                    chart.on('click', (params) => {
                        const handler = onChartClickRef.current;
                        if (typeof handler === 'function') handler(params);
                    });
                    chart.on('legendselectchanged', (params) => {
                        const handler = onLegendSelectChangeRef.current;
                        if (typeof handler === 'function') handler(params);
                    });
                }
                if (option) {
                    // Some ECharts components (notably visualMap/dataZoom) survive a normal
                    // option merge. Charts that radically change those controls can request a
                    // clean replacement while retaining the same canvas instance.
                    chart.setOption(option, { lazyUpdate: true, notMerge: replaceOption });
                }
                return undefined;
            }, [echartsReady, option, replaceOption]);

            // Resize + dispose once on mount.
            useEffect(() => {
                if (!chartRef.current) return undefined;
                let resizeFrame = 0;
                const scheduleResize = () => {
                    if (resizeFrame) cancelAnimationFrame(resizeFrame);
                    resizeFrame = requestAnimationFrame(() => {
                        if (chartInstanceRef.current) chartInstanceRef.current.resize();
                    });
                };
                let resizeObserver = null;
                if (typeof ResizeObserver !== 'undefined') {
                    resizeObserver = new ResizeObserver(scheduleResize);
                    resizeObserver.observe(chartRef.current);
                } else {
                    window.addEventListener('resize', scheduleResize);
                }
                return () => {
                    if (resizeFrame) cancelAnimationFrame(resizeFrame);
                    if (resizeObserver) resizeObserver.disconnect();
                    else window.removeEventListener('resize', scheduleResize);
                    if (chartInstanceRef.current) {
                        chartInstanceRef.current.dispose();
                        chartInstanceRef.current = null;
                    }
                };
            }, []);

            const isClickable = typeof onChartClick === 'function';

            return (
                <div
                    className="group rounded-[28px] overflow-hidden statistics-chart-card"
                    style={{
                        background: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(252,248,242,0.98) 100%)',
                        border: '1px solid rgba(92, 61, 38, 0.12)',
                        boxShadow: '0 6px 18px rgba(60,40,18,0.05), 0 18px 40px rgba(60,40,18,0.06)',
                        transition: 'border-color 0.24s ease, box-shadow 0.24s ease',
                        position: 'relative',
                        contain: 'layout paint style',
                        // Браузер пропускает рендер/композитинг карточки, пока она далеко от viewport.
                        // Канвас echarts уже инициализирован (как раньше), но не тратит ресурсы вне экрана.
                        contentVisibility: 'auto',
                        containIntrinsicSize: `auto ${height + 240}px`,
                        '--accent-color': accentColor,
                    }}
                >
                    <div style={{
                        position: 'absolute',
                        inset: '0 0 auto 0',
                        height: '120px',
                        background: `radial-gradient(circle at top right, ${accentColor}18 0%, transparent 58%)`,
                        pointerEvents: 'none'
                    }} />
                    <div style={{ height: '4px', background: `linear-gradient(90deg, ${accentColor}, ${accentColor}55)` }} />

                    <div
                        className="px-6 py-5"
                        style={{
                            borderBottom: '1px solid rgba(92, 61, 38, 0.09)',
                            background: 'linear-gradient(180deg, rgba(253,248,240,0.88) 0%, rgba(255,255,255,0.36) 100%)',
                            position: 'relative'
                        }}
                    >
                        <div className="flex items-start justify-between gap-3">
                            <div className="min-w-0 flex-1">
                                <div className="flex items-center gap-2.5">
                                    {icon && (
                                        <span
                                            style={{
                                                width: '30px',
                                                height: '30px',
                                                borderRadius: '999px',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '14px',
                                                background: `${accentColor}12`,
                                                border: `1px solid ${accentColor}22`
                                            }}
                                        >
                                            {icon}
                                        </span>
                                    )}
                                    <div>
                                        <div style={{ fontSize: '10px', fontWeight: 800, letterSpacing: '0.18em', textTransform: 'uppercase', color: accentColor, opacity: 0.86 }}>
                                            Карта данных
                                        </div>
                                        <div style={{ marginTop: '3px', fontFamily: 'Playfair Display, serif', fontSize: '22px', fontWeight: 700, color: '#35271e', lineHeight: 1.08 }}>
                                            {title}
                                        </div>
                                    </div>
                                </div>
                                {subtitle && <div className="mt-3" style={{ fontSize: '12px', color: '#695b4d', lineHeight: '1.55', maxWidth: '38rem' }}>{subtitle}</div>}
                                {controls ? <div className="mt-4">{controls}</div> : null}
                            </div>
                            <div className="flex shrink-0 flex-col items-end gap-2.5">
                                {Array.isArray(badges) && badges.filter(Boolean).map((badge, index) => (
                                    <div
                                        key={`${title}-badge-${index}`}
                                        style={{
                                            maxWidth: '200px',
                                            padding: '7px 11px',
                                            borderRadius: '999px',
                                            background: `${accentColor}10`,
                                            border: `1px solid ${accentColor}1f`,
                                            fontSize: '10px',
                                            fontWeight: 700,
                                            lineHeight: 1.2,
                                            color: '#5f5247',
                                            textAlign: 'right'
                                        }}
                                    >
                                        <span style={{ color: accentColor }}>{badge.label}:</span>{' '}
                                        <span>{badge.value}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div style={{ padding: '18px 14px 14px', background: 'linear-gradient(180deg, rgba(255,255,255,0.22) 0%, rgba(246,239,229,0.34) 100%)' }}>
                        {searchPanel}
                        {!echartsReady ? (
                            <div
                                className="flex items-center justify-center rounded-[22px] border border-dashed border-stone-200 bg-[#fcfaf5]"
                                style={{ height: `${height}px` }}
                            >
                                <div className="text-center">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">Загружаем график</div>
                                    <div className="mt-2 text-sm text-stone-500">
                                        {echartsError || 'Подключаем библиотеку визуализации только для открытой вкладки статистики.'}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div
                                ref={chartRef}
                                style={{ height: `${height}px`, width: '100%', cursor: isClickable ? 'pointer' : 'default' }}
                            />
                        )}
                    </div>
                </div>
            );
        };

        const StatisticsSectionShell = ({ eyebrow, title, description, accentColor = '#8b0000', side = null, children, extraClassName = '' }) => (
            <section
                className={`rounded-[34px] overflow-hidden statistics-section-shell ${extraClassName}`}
                style={{
                    position: 'relative',
                    border: '1px solid rgba(84,61,43,0.12)',
                    background: 'linear-gradient(180deg, rgba(255,252,247,0.98) 0%, rgba(250,243,232,0.96) 100%)',
                    boxShadow: '0 14px 36px rgba(45,34,20,0.06), inset 0 1px 0 rgba(255,255,255,0.65)',
                    contain: 'layout paint style',
                    '--section-accent': accentColor,
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        inset: '0 0 auto 0',
                        height: '180px',
                        background: `radial-gradient(circle at top right, ${accentColor}1a 0%, transparent 62%)`,
                        pointerEvents: 'none'
                    }}
                />
                <div
                    aria-hidden="true"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '3px',
                        background: `linear-gradient(90deg, ${accentColor} 0%, ${accentColor}88 45%, transparent 100%)`,
                        pointerEvents: 'none',
                    }}
                />
                <div className="relative px-7 py-6 md:px-8" style={{ borderBottom: '1px solid rgba(84,61,43,0.08)' }}>
                    <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
                        <div className="min-w-0 flex-1">
                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{
                                    width: '22px',
                                    height: '1px',
                                    background: accentColor,
                                    opacity: 0.45,
                                    display: 'inline-block',
                                }} />
                                <span style={{ fontSize: '10px', fontWeight: 800, letterSpacing: '0.22em', textTransform: 'uppercase', color: accentColor, opacity: 0.86 }}>
                                    {eyebrow}
                                </span>
                            </div>
                            <div style={{ marginTop: '10px', fontFamily: 'Playfair Display, serif', fontSize: 'clamp(24px, 2.4vw, 34px)', lineHeight: 1.05, color: '#35271e', letterSpacing: '-0.005em' }}>
                                {title}
                            </div>
                            {description && (
                                <div style={{ marginTop: '12px', fontSize: '13px', lineHeight: 1.6, color: '#6d604f', maxWidth: '62rem' }}>
                                    {description}
                                </div>
                            )}
                        </div>
                        {side ? <div className="shrink-0">{side}</div> : null}
                    </div>
                </div>
                <div className="relative px-5 py-5 md:px-6 md:py-6">
                    {children}
                </div>
            </section>
        );

        const ServicePageLoaderCard = ({ title, description }) => (
            <div className="rounded-[30px] border border-stone-300 bg-white/95 px-8 py-10 text-center shadow-[0_18px_55px_rgba(45,34,20,0.1)]">
                <div className="flex flex-col items-center">
                    <div className="scale-[0.85] origin-center">
                        <div className="loader-paper"></div>
                    </div>
                    <div className="mt-5 text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">{title}</div>
                    <div className="mt-3 text-sm text-stone-500 max-w-md">{description}</div>
                </div>
            </div>
        );

        // UI #3: skeleton ghost-таблица вместо большого ServicePageLoaderCard при cold load дашборда.
        // Сохраняет лейаут (hero + filter-bar + table) чтобы переход loaded → loaded был без скачка.
        const DashboardSkeletonTable = ({ columns = 6, rows = 9, title = 'Подготавливаем подборку…' }) => {
            const widths = ['72%', '56%', '88%', '46%', '80%', '60%', '74%', '52%', '66%'];
            return (
                <div className="rounded-[30px] border border-stone-300 bg-[#fffdf8]/95 shadow-[0_18px_55px_rgba(45,34,20,0.1)] overflow-hidden">
                    <div className="parents-table-header" style={{ paddingTop: 16, paddingBottom: 14 }}>
                        <div className="flex items-center gap-3">
                            <span className="inline-flex h-2 w-2 rounded-full bg-[#8b0000]/70 animate-pulse"></span>
                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">{title}</div>
                        </div>
                        <div className="mt-3 h-3 w-[180px] rounded bg-stone-200/80 skeleton-shimmer"></div>
                    </div>
                    <div className="parents-table-toolbar" style={{ padding: '12px 28px' }}>
                        <div className="h-8 w-[280px] rounded-full bg-stone-200/70 skeleton-shimmer"></div>
                        <div className="flex gap-2">
                            <div className="h-7 w-[88px] rounded bg-stone-200/70 skeleton-shimmer"></div>
                            <div className="h-7 w-[88px] rounded bg-stone-200/70 skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="parents-table-scroll">
                        <table className="parents-table min-w-[1360px]">
                            <thead>
                                <tr>
                                    <th style={{ width: 88 }}>
                                        <div className="h-3 w-12 rounded bg-stone-200/80 skeleton-shimmer"></div>
                                    </th>
                                    <th style={{ width: 48 }}>
                                        <div className="h-3 w-6 rounded bg-stone-200/80 skeleton-shimmer"></div>
                                    </th>
                                    {Array.from({ length: columns }).map((_, idx) => (
                                        <th key={idx}>
                                            <div className="h-3 w-[60%] rounded bg-stone-200/80 skeleton-shimmer"></div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from({ length: rows }).map((_, rowIdx) => (
                                    <tr key={rowIdx} style={{ animationDelay: `${rowIdx * 70}ms` }} className="skeleton-row">
                                        <td className="parents-cell--actions">
                                            <div className="flex gap-1.5">
                                                <div className="h-6 w-6 rounded-full bg-stone-200/70 skeleton-shimmer"></div>
                                                <div className="h-6 w-6 rounded-full bg-stone-200/60 skeleton-shimmer"></div>
                                            </div>
                                        </td>
                                        <td className="parents-cell--num">
                                            <div className="h-3 w-5 rounded bg-stone-200/70 skeleton-shimmer"></div>
                                        </td>
                                        {Array.from({ length: columns }).map((_, colIdx) => (
                                            <td key={colIdx} style={{ minWidth: 150 }}>
                                                <div
                                                    className="h-3 rounded bg-stone-200/70 skeleton-shimmer"
                                                    style={{ width: widths[(rowIdx + colIdx) % widths.length] }}
                                                ></div>
                                                {colIdx === 1 ? (
                                                    <div
                                                        className="mt-1.5 h-2.5 rounded bg-stone-200/50 skeleton-shimmer"
                                                        style={{ width: widths[(rowIdx + colIdx + 3) % widths.length] }}
                                                    ></div>
                                                ) : null}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        };

        const StatisticsView = ({ project, rows, canEdit, onEditRow }) => {
            const drilldownRef = useRef(null);
            const [activeDrilldown, setActiveDrilldown] = useState(null);
            const [detailSearch, setDetailSearch] = useState('');
            const [detailPage, setDetailPage] = useState(1);

            const stats = useMemo(() => {
                const governorates = buildStatisticsFrequency(rows, 'governorate', 15);
                const uyezds = buildStatisticsFrequency(rows, 'uyezd', 15);
                const volosts = buildStatisticsFrequency(rows, 'volost', 15);
                const occupations = buildStatisticsFrequency(rows, 'occupation', 14);

                const getFilledCount = (key) => rows.filter(row => normalizeMospriyutSummaryValue(row?.[key] || '')).length;

                return {
                    totalRows: rows.length,
                    governorates,
                    uyezds,
                    volosts,
                    occupations,
                    filledGovernorates: getFilledCount('governorate'),
                    filledUyezds: getFilledCount('uyezd'),
                    filledVolosts: getFilledCount('volost'),
                    filledOccupations: getFilledCount('occupation'),
                    uniqueGovernorates: new Set(governorates.map(item => item.name)).size,
                    uniqueUyezds: new Set(uyezds.map(item => item.name)).size,
                    uniqueVolosts: new Set(volosts.map(item => item.name)).size,
                    uniqueOccupations: new Set(occupations.map(item => item.name)).size
                };
            }, [rows]);

            const getBarChartHeight = useCallback((count) => (
                Math.max(380, 110 + (Math.max(count, 1) * 28))
            ), []);

            useEffect(() => {
                setDetailSearch('');
                setDetailPage(1);
            }, [activeDrilldown?.key, activeDrilldown?.groupKey]);

            const buildHorizontalBarOption = useCallback((data, color, options = {}) => ({
                animationDuration: 500,
                textStyle: {
                    fontFamily: 'Cormorant Garamond, serif'
                },
                grid: { left: 16, right: 22, top: 18, bottom: 12, containLabel: true },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    backgroundColor: 'rgba(41, 33, 24, 0.92)',
                    borderWidth: 0,
                    textStyle: { color: '#fdfbf7', fontFamily: 'Cormorant Garamond, serif', fontSize: 14 }
                },
                xAxis: {
                    type: 'value',
                    axisLabel: { color: '#7c6f64', fontSize: 12, fontFamily: 'Cormorant Garamond, serif' },
                    splitLine: { lineStyle: { color: 'rgba(124,111,100,0.16)' } }
                },
                yAxis: {
                    type: 'category',
                    inverse: !!options.inverse,
                    data: data.map(item => item.name),
                    axisLabel: {
                        color: '#4d4036',
                        fontSize: 13,
                        fontFamily: 'Cormorant Garamond, serif',
                        width: 160,
                        overflow: 'truncate'
                    },
                    axisTick: { show: false },
                    axisLine: { show: false }
                },
                series: [{
                    type: 'bar',
                    data: data.map(item => item.value),
                    barMaxWidth: 22,
                    itemStyle: {
                        color,
                        borderRadius: [0, 8, 8, 0]
                    },
                    label: {
                        show: true,
                        position: 'right',
                        color: '#4d4036',
                        fontWeight: 'bold',
                        fontSize: 13,
                        fontFamily: 'Cormorant Garamond, serif'
                    }
                }]
            }), []);

            const buildDonutOption = useCallback((data) => {
                const total = data.reduce((sum, item) => sum + item.value, 0);
                return {
                    animationDuration: 600,
                    textStyle: {
                        fontFamily: 'Cormorant Garamond, serif'
                    },
                    color: ['#8b0000', '#b3422b', '#d07b43', '#e8a14b', '#d7c37a', '#8f7053', '#c98d83', '#b8a799'],
                    tooltip: {
                        trigger: 'item',
                        backgroundColor: 'rgba(41, 33, 24, 0.92)',
                        borderWidth: 0,
                        textStyle: { color: '#fdfbf7', fontFamily: 'Cormorant Garamond, serif', fontSize: 14 },
                        formatter: (params) => `${params.name}<br/>${params.value} записей (${params.percent}%)`
                    },
                    legend: {
                        bottom: 0,
                        left: 'center',
                        textStyle: { color: '#5f5247', fontSize: 13, fontFamily: 'Cormorant Garamond, serif' },
                        itemWidth: 10,
                        itemHeight: 10
                    },
                    graphic: total ? [{
                        type: 'text',
                        left: 'center',
                        top: 'middle',
                        style: {
                            text: `${total}\nзаписей`,
                            textAlign: 'center',
                            fill: '#4d4036',
                            fontFamily: 'Cormorant Garamond, serif',
                            fontSize: 18,
                            fontWeight: 700,
                            lineHeight: 22
                        }
                    }] : [],
                    series: [{
                        type: 'pie',
                        radius: ['48%', '70%'],
                        center: ['50%', '42%'],
                        avoidLabelOverlap: true,
                        label: {
                            show: true,
                            formatter: ({ name, value }) => `${name}\n${value}`,
                            color: '#4d4036',
                            fontSize: 13,
                            fontFamily: 'Cormorant Garamond, serif',
                            lineHeight: 16
                        },
                        labelLine: {
                            show: true,
                            length: 14,
                            length2: 12,
                            lineStyle: {
                                color: '#a89787'
                            }
                        },
                        emphasis: {
                            scale: true,
                            label: {
                                show: true,
                                formatter: '{b}\n{c}',
                                color: '#3d3027',
                                fontSize: 13,
                                fontFamily: 'Cormorant Garamond, serif',
                                fontWeight: 'bold'
                            }
                        },
                        itemStyle: {
                            borderColor: '#fffdf8',
                            borderWidth: 2
                        },
                        data: data.map(item => ({ name: item.name, value: item.value }))
                    }]
                };
            }, []);

            const governoratesOption = useMemo(() => buildHorizontalBarOption(stats.governorates, '#8b0000', { inverse: true }), [buildHorizontalBarOption, stats.governorates]);
            const uyezdsOption = useMemo(() => buildHorizontalBarOption(stats.uyezds, '#9f2d22', { inverse: true }), [buildHorizontalBarOption, stats.uyezds]);
            const volostsOption = useMemo(() => buildHorizontalBarOption(stats.volosts, '#a86f37', { inverse: true }), [buildHorizontalBarOption, stats.volosts]);
            const occupationsOption = useMemo(() => buildDonutOption(stats.occupations.slice(0, 8)), [buildDonutOption, stats.occupations]);

            const openDrilldown = useCallback((key, label, rawValue) => {
                const descriptor = buildStatisticsValueDescriptor(key, rawValue);
                if (!descriptor.groupKey) return;
                setActiveDrilldown({
                    key,
                    label,
                    value: descriptor.label,
                    groupKey: descriptor.groupKey
                });
            }, []);

            useEffect(() => {
                if (!activeDrilldown) return;
                const node = drilldownRef.current;
                if (!node) return;
                const frame = requestAnimationFrame(() => {
                    try {
                        node.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } catch (e) {
                        node.scrollIntoView();
                    }
                });
                return () => cancelAnimationFrame(frame);
            }, [activeDrilldown?.key, activeDrilldown?.groupKey]);

            const drilldownRows = useMemo(() => {
                if (!activeDrilldown) return [];
                return rows.filter(row => (
                    buildStatisticsValueDescriptor(activeDrilldown.key, row?.[activeDrilldown.key] || '').groupKey === activeDrilldown.groupKey
                ));
            }, [rows, activeDrilldown]);

            const filteredDrilldownRows = useMemo(() => (
                filterSummaryTableRows(drilldownRows, detailSearch)
            ), [drilldownRows, detailSearch]);

            const detailPageCount = Math.max(1, Math.ceil(filteredDrilldownRows.length / SUMMARY_TABLE_PAGE_SIZE));

            useEffect(() => {
                setDetailPage(prev => Math.min(prev, detailPageCount));
            }, [detailPageCount]);

            const paginatedDrilldownRows = useMemo(() => {
                const start = (detailPage - 1) * SUMMARY_TABLE_PAGE_SIZE;
                return filteredDrilldownRows.slice(start, start + SUMMARY_TABLE_PAGE_SIZE);
            }, [filteredDrilldownRows, detailPage]);

            return (
                <div className="flex-1 min-h-0 overflow-hidden bg-[#e8e4dc] bg-texture">
                    <div className="h-full overflow-auto">
                        <div className="max-w-[1880px] mx-auto px-6 py-6 space-y-6">
                            <div className="rounded-[30px] border border-stone-300 bg-[#fffdf8]/95 shadow-[0_22px_70px_rgba(45,34,20,0.12)] overflow-hidden">
                                <div className="border-b border-stone-200 bg-white/90 px-6 py-5">
                                    <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
                                        <div className="min-w-0">
                                            <div className="text-[10px] uppercase tracking-[0.24em] text-[#8b0000] font-bold">Внутренняя страница проекта</div>
                                            <div className="mt-2 font-display text-3xl text-stone-800 leading-tight">Статистика</div>
                                            <div className="mt-2 text-sm text-stone-500 max-w-3xl">
                                                Apache ECharts анализирует уже очищенные строки рабочей таблицы и показывает, как распределяются записи по губерниям, уездам, волостям и занятиям.
                                            </div>
                                            {project?.title && (
                                                <div className="mt-3 text-[11px] uppercase tracking-[0.16em] text-stone-400">
                                                    {project.title}
                                                </div>
                                            )}
                                        </div>
                                        <div className="grid grid-cols-2 xl:grid-cols-5 gap-3 shrink-0">
                                            <div className="rounded-2xl border border-stone-200 bg-[#faf6ee] px-4 py-3 min-w-[128px]">
                                                <div className="text-[10px] uppercase tracking-[0.16em] text-stone-400 font-bold">Всего строк</div>
                                                <div className="mt-1 text-2xl font-black text-stone-800">{stats.totalRows}</div>
                                            </div>
                                            <div className="rounded-2xl border border-stone-200 bg-[#faf6ee] px-4 py-3 min-w-[128px]">
                                                <div className="text-[10px] uppercase tracking-[0.16em] text-stone-400 font-bold">Губерний</div>
                                                <div className="mt-1 text-2xl font-black text-stone-800">{stats.uniqueGovernorates}</div>
                                                <div className="mt-1 text-[10px] text-stone-400">{stats.filledGovernorates} заполнено</div>
                                            </div>
                                            <div className="rounded-2xl border border-stone-200 bg-[#faf6ee] px-4 py-3 min-w-[128px]">
                                                <div className="text-[10px] uppercase tracking-[0.16em] text-stone-400 font-bold">Уездов</div>
                                                <div className="mt-1 text-2xl font-black text-stone-800">{stats.uniqueUyezds}</div>
                                                <div className="mt-1 text-[10px] text-stone-400">{stats.filledUyezds} заполнено</div>
                                            </div>
                                            <div className="rounded-2xl border border-stone-200 bg-[#faf6ee] px-4 py-3 min-w-[128px]">
                                                <div className="text-[10px] uppercase tracking-[0.16em] text-stone-400 font-bold">Волостей</div>
                                                <div className="mt-1 text-2xl font-black text-stone-800">{stats.uniqueVolosts}</div>
                                                <div className="mt-1 text-[10px] text-stone-400">{stats.filledVolosts} заполнено</div>
                                            </div>
                                            <div className="rounded-2xl border border-stone-200 bg-[#faf6ee] px-4 py-3 min-w-[128px]">
                                                <div className="text-[10px] uppercase tracking-[0.16em] text-stone-400 font-bold">Занятий</div>
                                                <div className="mt-1 text-2xl font-black text-stone-800">{stats.uniqueOccupations}</div>
                                                <div className="mt-1 text-[10px] text-stone-400">{stats.filledOccupations} заполнено</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {stats.totalRows > 0 ? (
                                    <div className="p-6 grid gap-6 xl:grid-cols-2">
                                        <StatisticsChartCard
                                            title="Губернии"
                                            subtitle="Топ-15 значений по полю «Губерния»"
                                            option={governoratesOption}
                                            height={getBarChartHeight(stats.governorates.length)}
                                            onChartClick={(params) => openDrilldown('governorate', 'Губерния', params?.name)}
                                        />
                                        <StatisticsChartCard
                                            title="Уезды"
                                            subtitle="Топ-15 значений по полю «Уезд»"
                                            option={uyezdsOption}
                                            height={getBarChartHeight(stats.uyezds.length)}
                                            onChartClick={(params) => openDrilldown('uyezd', 'Уезд', params?.name)}
                                        />
                                        <StatisticsChartCard
                                            title="Волости"
                                            subtitle="Топ-15 значений по полю «Волость»"
                                            option={volostsOption}
                                            height={getBarChartHeight(stats.volosts.length)}
                                            onChartClick={(params) => openDrilldown('volost', 'Волость', params?.name)}
                                        />
                                        <StatisticsChartCard
                                            title="Занятия"
                                            subtitle="Самые частые занятия в таблице"
                                            option={occupationsOption}
                                            height={380}
                                            onChartClick={(params) => openDrilldown('occupation', 'Занятие', params?.name)}
                                        />
                                    </div>
                                ) : (
                                    <div className="px-8 py-20 text-center">
                                        <div className="text-lg font-display text-stone-700">Пока нет данных для статистики</div>
                                        <div className="mt-2 text-sm text-stone-400">
                                            Добавьте и разметьте записи в каталоге, и графики появятся автоматически.
                                        </div>
                                    </div>
                                )}
                            </div>

                            {activeDrilldown && (
                                <div ref={drilldownRef} style={{ scrollMarginTop: '88px' }}>
                                <SummaryTableView
                                    embedded={true}
                                    project={project}
                                    rows={paginatedDrilldownRows}
                                    allRows={filteredDrilldownRows}
                                    currentPage={detailPage}
                                    totalPages={detailPageCount}
                                    onPageChange={(nextPage) => setDetailPage(Math.min(Math.max(nextPage, 1), detailPageCount))}
                                    canEdit={canEdit}
                                    onEditRow={onEditRow}
                                    searchQuery={detailSearch}
                                    onSearchChange={setDetailSearch}
                                    badgeLabel="Фильтр по статистике"
                                    title={`${activeDrilldown.label}: ${activeDrilldown.value}`}
                                    description={`Ниже показаны строки общей таблицы, где поле «${activeDrilldown.label}» совпадает с выбранным значением.`}
                                    resultsLabel="Строки выборки"
                                    emptyTitle="По этой выборке строк пока нет"
                                    emptyDescription="Попробуйте очистить поиск внутри выборки или выбрать другое значение на графике."
                                    onClose={() => setActiveDrilldown(null)}
                                />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsPatronymicMismatchesView = ({ projectId, parishId = '', canEdit = false, onOpenRow }) => {
            const [page, setPage] = useState(1);
            const [pageSize] = useState(20);
            const [data, setData] = useState(null);
            const [loading, setLoading] = useState(true);
            const [error, setError] = useState('');
            const [drafts, setDrafts] = useState({}); // { 'itemId|entry|pi': { patronymic, fatherName } }
            const [savedKeys, setSavedKeys] = useState(new Set());
            const [savingKey, setSavingKey] = useState('');

            const fetchData = useCallback(async () => {
                if (!projectId) return;
                setLoading(true);
                setError('');
                try {
                    const params = new URLSearchParams({
                        pid: projectId,
                        parish_id: parishId || '',
                        page: String(page),
                        page_size: String(pageSize),
                    });
                    const res = await fetch(`${API_BASE}/parents_patronymic_mismatches?${params.toString()}`, {
                        credentials: 'same-origin'
                    });
                    const json = await res.json().catch(() => ({}));
                    if (!res.ok || json.error) throw new Error(json.error || `HTTP ${res.status}`);
                    setData(json);
                } catch (e) {
                    console.error(e);
                    setError(e?.message || 'Не удалось загрузить выборку');
                } finally {
                    setLoading(false);
                }
            }, [projectId, parishId, page, pageSize]);

            useEffect(() => { fetchData(); }, [fetchData]);

            const items = Array.isArray(data?.items) ? data.items : [];
            const total = Number(data?.total || 0);
            const totalPages = Number(data?.total_pages || 1);

            const itemKey = (it) => `${it.item_id}|${it.entry_index}|${it.child_person_index}`;
            const getDraft = (it) => {
                const k = itemKey(it);
                return drafts[k] || { childPatronymic: it.child_patronymic, fatherName: it.father_name };
            };
            const setDraftField = (it, field, value) => {
                const k = itemKey(it);
                setDrafts(prev => ({ ...prev, [k]: { ...getDraft(it), [field]: value } }));
            };

            const savePersonField = useCallback(async (it, personIndex, fieldsPatch) => {
                if (!canEdit) {
                    showToast('Нужны права на редактирование проекта', 'warning');
                    return;
                }
                const k = itemKey(it);
                setSavingKey(k);
                try {
                    const res = await fetch(`${API_BASE}/structured/person/update`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        credentials: 'same-origin',
                        body: JSON.stringify({
                            pid: projectId,
                            parish_id: parishId || '',
                            item_id: it.item_id,
                            entry_index: it.entry_index,
                            person_index: personIndex,
                            fields: fieldsPatch,
                        }),
                    });
                    const json = await res.json().catch(() => ({}));
                    if (!res.ok || json.error) throw new Error(json.error || `HTTP ${res.status}`);
                    setSavedKeys(prev => {
                        const next = new Set(prev);
                        next.add(k);
                        return next;
                    });
                    showToast('Сохранено', 'success', 1800);
                } catch (e) {
                    console.error(e);
                    showToast(e?.message || 'Не удалось сохранить', 'error');
                } finally {
                    setSavingKey('');
                }
            }, [canEdit, projectId, parishId]);

            const saveChildPatronymic = (it) => {
                const draft = getDraft(it);
                const value = String(draft.childPatronymic || '').trim();
                if (!value) { showToast('Заполните отчество ребёнка', 'warning'); return; }
                savePersonField(it, it.child_person_index, {
                    name: it.child_name,
                    second_name: value,
                    surname: it.child_surname,
                    sex: '',
                    status: 'BORN',
                });
            };
            const saveFatherName = (it) => {
                const draft = getDraft(it);
                const value = String(draft.fatherName || '').trim();
                if (!value) { showToast('Заполните имя отца', 'warning'); return; }
                savePersonField(it, it.father_person_index, {
                    name: value,
                    second_name: it.father_patronymic,
                    surname: it.father_surname,
                    sex: 'MALE',
                    status: 'FATHER',
                });
            };

            return (
                <div style={{ marginTop: '20px' }}>
                    <div className="parents-table-shell">
                        <div className="parents-table-header">
                            <div className="flex items-end justify-between gap-4 flex-wrap">
                                <div className="min-w-0 max-w-2xl">
                                    <span className="parents-eyebrow">Проверка отчеств</span>
                                    <h2 className="parents-page-title" style={{ fontSize: 'clamp(22px, 2.4vw, 30px)', marginTop: '10px' }}>
                                        Записи с <em>несоответствием</em> отчества и имени отца
                                    </h2>
                                    <span className="parents-page-rule" style={{ marginTop: '12px', width: '72px' }} />
                                    <p className="parents-page-lede" style={{ fontSize: '13px', marginTop: '12px' }}>
                                        Здесь собраны рождения, где отчество ребёнка не выводится из имени отца. Откройте источник, прочитайте оригинал и поправьте нужное поле — отчество ребёнка или имя отца.
                                    </p>
                                </div>
                                <div className="parents-stat-tile shrink-0" style={{ minWidth: '180px' }}>
                                    <div className="parents-stat-tile__label">Несоответствий</div>
                                    <div className="parents-stat-tile__value">{total}</div>
                                </div>
                            </div>
                        </div>

                        <div className="parents-table-toolbar parents-table-toolbar--pagination">
                            <PaginationControls
                                page={page}
                                totalPages={totalPages}
                                totalItems={total}
                                pageSize={pageSize}
                                label="Записи"
                                onChange={setPage}
                            />
                        </div>

                        <div style={{ background: 'linear-gradient(180deg, rgba(255,253,247,0.6) 0%, rgba(245,236,216,0.4) 100%)' }}>
                            {loading ? (
                                <div className="py-16 text-center">
                                    <div className="text-xl" style={{ fontFamily: "'Playfair Display', serif", color: 'var(--parents-ink)' }}>Загружаем выборку…</div>
                                </div>
                            ) : error ? (
                                <div className="py-16 text-center">
                                    <div className="text-xl" style={{ fontFamily: "'Playfair Display', serif", color: 'var(--parents-scarlet)' }}>{error}</div>
                                </div>
                            ) : items.length === 0 ? (
                                <div className="py-16 text-center">
                                    <div className="text-xl" style={{ fontFamily: "'Playfair Display', serif", color: 'var(--parents-ink)' }}>В этом приходе несоответствий не найдено. ✓</div>
                                </div>
                            ) : (
                                <div className="parents-table-scroll">
                                    <table className="parents-table min-w-[1280px]">
                                        <thead>
                                            <tr>
                                                <th>Год · дело · стр.</th>
                                                <th>Ребёнок (полное ФИО)</th>
                                                <th style={{ minWidth: '180px' }}>Отчество ребёнка</th>
                                                <th>Отец (полное ФИО)</th>
                                                <th style={{ minWidth: '180px' }}>Имя отца</th>
                                                <th>Мать (полное ФИО)</th>
                                                <th>Ожидается</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map((it) => {
                                                const k = itemKey(it);
                                                const draft = getDraft(it);
                                                const isSaved = savedKeys.has(k);
                                                const isSaving = savingKey === k;
                                                const rowStyle = isSaved ? { background: 'rgba(238,248,232,0.55)', opacity: 0.75 } : undefined;
                                                const childPatChanged = draft.childPatronymic !== it.child_patronymic && String(draft.childPatronymic || '').trim();
                                                const fatherNameChanged = draft.fatherName !== it.father_name && String(draft.fatherName || '').trim();
                                                const inputBase = {
                                                    width: '100%',
                                                    padding: '6px 8px',
                                                    borderRadius: '8px',
                                                    border: '1px solid rgba(228,216,191,0.85)',
                                                    background: '#fffefb',
                                                    fontSize: '13px',
                                                    fontFamily: "'Lora', serif",
                                                    color: 'var(--parents-ink)',
                                                    outline: 'none',
                                                };
                                                const inputChanged = {
                                                    ...inputBase,
                                                    borderColor: 'var(--parents-copper)',
                                                    background: '#fff5e3',
                                                };
                                                const saveBtnStyle = (enabled) => ({
                                                    padding: '4px 8px',
                                                    borderRadius: '8px',
                                                    border: '1px solid rgba(122,14,14,0.40)',
                                                    background: enabled ? 'linear-gradient(180deg, #7a0e0e 0%, #5c0a0a 100%)' : 'rgba(255,247,238,0.5)',
                                                    color: enabled ? '#fffaf2' : 'rgba(122,14,14,0.30)',
                                                    fontFamily: "'Lora', serif",
                                                    fontSize: '10px',
                                                    fontWeight: 700,
                                                    letterSpacing: '0.10em',
                                                    textTransform: 'uppercase',
                                                    cursor: enabled ? 'pointer' : 'not-allowed',
                                                    marginLeft: '6px',
                                                    flexShrink: 0,
                                                });
                                                return (
                                                    <tr key={k} style={rowStyle}>
                                                        {/* Год · дело · стр. */}
                                                        <td style={{ whiteSpace: 'nowrap' }}>
                                                            <div className="parents-cell--meta" style={{ padding: 0, marginBottom: '2px' }}>
                                                                {it.year || it.event_year_label || '—'}
                                                            </div>
                                                            <div style={{ fontSize: '11px', color: 'var(--parents-ink-soft)', fontFamily: "'Lora', serif", lineHeight: 1.3 }}>
                                                                {it.cipher_label}
                                                            </div>
                                                            <div style={{ fontSize: '11px', color: 'var(--parents-ink-soft)', fontFamily: "'Lora', serif" }}>
                                                                стр. {it.page_label}
                                                            </div>
                                                        </td>
                                                        {/* Ребёнок */}
                                                        <td style={{ minWidth: '200px', maxWidth: '260px' }}>
                                                            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: '14px', fontWeight: 600, color: 'var(--parents-ink)' }}>
                                                                {it.child_label}
                                                            </div>
                                                        </td>
                                                        {/* Отчество ребёнка — редакт. */}
                                                        <td>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <input
                                                                    type="text"
                                                                    value={draft.childPatronymic}
                                                                    onChange={(e) => setDraftField(it, 'childPatronymic', e.target.value)}
                                                                    disabled={isSaving || !canEdit}
                                                                    style={childPatChanged ? inputChanged : inputBase}
                                                                />
                                                                <button
                                                                    onClick={() => saveChildPatronymic(it)}
                                                                    disabled={!canEdit || isSaving || !childPatChanged}
                                                                    style={saveBtnStyle(canEdit && !isSaving && childPatChanged)}
                                                                    title="Сохранить отчество ребёнка"
                                                                >
                                                                    ✓
                                                                </button>
                                                            </div>
                                                        </td>
                                                        {/* Отец */}
                                                        <td style={{ minWidth: '200px', maxWidth: '260px' }}>
                                                            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: '14px', fontWeight: 600, color: 'var(--parents-ink)' }}>
                                                                {it.father_label}
                                                            </div>
                                                        </td>
                                                        {/* Имя отца — редакт. */}
                                                        <td>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <input
                                                                    type="text"
                                                                    value={draft.fatherName}
                                                                    onChange={(e) => setDraftField(it, 'fatherName', e.target.value)}
                                                                    disabled={isSaving || !canEdit}
                                                                    style={fatherNameChanged ? inputChanged : inputBase}
                                                                />
                                                                <button
                                                                    onClick={() => saveFatherName(it)}
                                                                    disabled={!canEdit || isSaving || !fatherNameChanged}
                                                                    style={saveBtnStyle(canEdit && !isSaving && fatherNameChanged)}
                                                                    title="Сохранить имя отца"
                                                                >
                                                                    ✓
                                                                </button>
                                                            </div>
                                                        </td>
                                                        {/* Мать */}
                                                        <td style={{ minWidth: '200px', maxWidth: '260px' }}>
                                                            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: '14px', fontWeight: 600, color: 'var(--parents-ink)' }}>
                                                                {it.mother_label || '—'}
                                                            </div>
                                                        </td>
                                                        {/* Ожидается */}
                                                        <td style={{ whiteSpace: 'nowrap' }}>
                                                            <div style={{ fontSize: '12px', color: 'var(--parents-ink-soft)', fontFamily: "'Lora', serif", lineHeight: 1.3 }}>
                                                                из отчества:
                                                            </div>
                                                            <div style={{ fontFamily: "'Playfair Display', serif", fontWeight: 600, color: 'var(--parents-scarlet)', fontSize: '13px' }}>
                                                                {it.expected_father_name_from_patronymic}
                                                            </div>
                                                        </td>
                                                        {/* Действия */}
                                                        <td className="parents-cell--actions">
                                                            <button
                                                                onClick={() => onOpenRow?.({ itemId: it.item_id })}
                                                                className="parents-table-action-btn parents-table-action-btn--primary"
                                                                title="Открыть страницу источника"
                                                            >
                                                                ↗
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                        <div className="parents-table-toolbar parents-table-toolbar--pagination">
                            <PaginationControls
                                page={page}
                                totalPages={totalPages}
                                totalItems={total}
                                pageSize={pageSize}
                                label="Записи"
                                onChange={setPage}
                            />
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsDashboardView = ({ project, projectId, parish = null, parishId = '', onOpenRow, onEditRow = null, canEdit = false, dataVersion = 0, refreshToken = 0 }) => {
            const [eventType, setEventType] = useState('BIRTH');
            const [patronymicCheckActive, setPatronymicCheckActive] = useState(false);
            const [resultSearch, setResultSearch] = useState('');
            const [caseYearFrom, setCaseYearFrom] = useState('');
            const [caseYearTo, setCaseYearTo] = useState('');
            const [pairSearch, setPairSearch] = useState('');
            const [godparentSearch, setGodparentSearch] = useState('');
            const [localitySearch, setLocalitySearch] = useState('');
            const [currentPage, setCurrentPage] = useState(1);
            // Сортировка таблицы. По умолчанию — порядок каталога (дата дела → шифр → стр.).
            // Клик по заголовку даты циклит: off → asc → desc → off.
            const [sortState, setSortState] = useState({ key: '', dir: '' });
            const [filters, setFilters] = useState({
                parentPairKey: '',
                godparentKey: '',
                localityKey: ''
            });
            const tableRef = useRef(null);
            const handleFacetSelect = useCallback((key, value) => {
                setFilters(prev => ({ ...prev, [key]: value }));
                if (!value) return;
                const node = tableRef.current;
                if (!node) return;
                const frame = requestAnimationFrame(() => {
                    try {
                        node.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } catch (e) {
                        node.scrollIntoView();
                    }
                });
                return () => cancelAnimationFrame(frame);
            }, []);
            const [dashboardData, setDashboardData] = useState(null);
            const [dashboardLoading, setDashboardLoading] = useState(true);
            const [dashboardLoaded, setDashboardLoaded] = useState(false);
            const dashboardRequestSeq = useRef(0);
            const dashboardCacheRef = useRef(parentsDashboardStateCache);
            const dashboardConfig = PARENTS_DASHBOARD_EVENT_CONFIG[eventType] || PARENTS_DASHBOARD_EVENT_CONFIG.BIRTH;
            const dashboardRefreshRevision = Number(refreshToken || 0);
            const [liveRefreshNonce, setLiveRefreshNonce] = useState(0);

            useEffect(() => {
                const handleParentsDataUpdated = (event) => {
                    const detail = event?.detail || {};
                    if (String(detail.projectId || '').trim() !== String(projectId || '').trim()) return;
                    invalidateParentsScopedCache(dashboardCacheRef.current, projectId, parishId);
                    setLiveRefreshNonce(prev => prev + 1);
                };
                window.addEventListener(PARENTS_DATA_UPDATED_EVENT, handleParentsDataUpdated);
                return () => window.removeEventListener(PARENTS_DATA_UPDATED_EVENT, handleParentsDataUpdated);
            }, [projectId, parishId]);

            const getDefaultDashboardCacheKey = useCallback((tabType) => {
                return new URLSearchParams({
                    pid: projectId || '',
                    parish_id: parishId || '',
                    v: `${dataVersion || 0}:${dashboardRefreshRevision}:${liveRefreshNonce}`,
                    event_type: tabType,
                    result_search: '',
                    year_from: caseYearFrom,
                    year_to: caseYearTo,
                    primary_search: '',
                    secondary_search: '',
                    locality_search: '',
                    primary_key: '',
                    secondary_key: '',
                    locality_key: '',
                    page: '1',
                    page_size: String(PARENTS_DASHBOARD_PAGE_SIZE)
                }).toString();
            }, [projectId, parishId, caseYearFrom, caseYearTo, dataVersion, dashboardRefreshRevision, liveRefreshNonce]);

            useEffect(() => {
                setCurrentPage(1);
            }, [eventType, resultSearch, caseYearFrom, caseYearTo, filters.parentPairKey, filters.godparentKey, filters.localityKey, sortState.key, sortState.dir]);

            // На смену таба событий сбрасываем сортировку.
            useEffect(() => {
                setSortState({ key: '', dir: '' });
            }, [eventType, parishId]);

            useEffect(() => {
                setEventType('BIRTH');
                setResultSearch('');
                setCaseYearFrom('');
                setCaseYearTo('');
                setPairSearch('');
                setGodparentSearch('');
                setLocalitySearch('');
                setFilters({ parentPairKey: '', godparentKey: '', localityKey: '' });
                setCurrentPage(1);
            }, [parishId]);

            useEffect(() => {
                if (!projectId) return;
                const requestSeq = ++dashboardRequestSeq.current;
                const controller = new AbortController();
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    v: `${dataVersion || 0}:${dashboardRefreshRevision}:${liveRefreshNonce}`,
                    event_type: eventType,
                    result_search: resultSearch,
                    year_from: caseYearFrom,
                    year_to: caseYearTo,
                    primary_search: pairSearch,
                    secondary_search: godparentSearch,
                    locality_search: localitySearch,
                    primary_key: filters.parentPairKey,
                    secondary_key: filters.godparentKey,
                    locality_key: filters.localityKey,
                    page: String(currentPage),
                    page_size: String(PARENTS_DASHBOARD_PAGE_SIZE),
                    sort_by: sortState.dir ? sortState.key : '',
                    sort_dir: sortState.dir,
                });
                const requestKey = params.toString();

                if (dashboardCacheRef.current.has(requestKey)) {
                    setDashboardData(dashboardCacheRef.current.get(requestKey));
                    setDashboardLoaded(true);
                    setDashboardLoading(false);
                    return () => controller.abort();
                }

                setDashboardLoading(true);

                fetch(`${API_BASE}/parents_dashboard_state?${params.toString()}`, {
                    signal: controller.signal,
                    cache: 'no-store'
                })
                    .then(async (response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP ${response.status}`);
                        }
                        return response.json();
                    })
                    .then((data) => {
                        if (dashboardRequestSeq.current !== requestSeq) return;
                        const normalizedData = data && typeof data === 'object' ? data : {};
                        rememberBoundedCacheValue(dashboardCacheRef.current, requestKey, normalizedData, 72);
                        setDashboardData(normalizedData);
                        setDashboardLoaded(true);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (dashboardRequestSeq.current !== requestSeq) return;
                        showToast('Не удалось загрузить дашборд по записям', 'error');
                        setDashboardData({
                            totals: { rows: 0, primary: 0, secondary: 0, localities: 0 },
                            filteredCount: 0,
                            currentPage: 1,
                            totalPages: 1,
                            availableCaseYearStart: null,
                            availableCaseYearEnd: null,
                            selectedYearFrom: null,
                            selectedYearTo: null,
                            rows: [],
                            primaryOptions: [],
                            primaryOptionsTotal: 0,
                            primaryHiddenCount: 0,
                            secondaryOptions: [],
                            secondaryOptionsTotal: 0,
                            secondaryHiddenCount: 0,
                            localityOptions: [],
                            localityOptionsTotal: 0,
                            localityHiddenCount: 0,
                            selectedPrimaryLabel: '',
                            selectedSecondaryLabel: '',
                            selectedLocalityLabel: '',
                            selectedPrimaryRows: []
                        });
                        setDashboardLoaded(true);
                    })
                    .finally(() => {
                        if (dashboardRequestSeq.current === requestSeq) {
                            setDashboardLoading(false);
                        }
                    });

                return () => controller.abort();
            }, [projectId, parishId, dataVersion, dashboardRefreshRevision, liveRefreshNonce, eventType, resultSearch, caseYearFrom, caseYearTo, pairSearch, godparentSearch, localitySearch, filters.parentPairKey, filters.godparentKey, filters.localityKey, currentPage, sortState.key, sortState.dir]);

            useEffect(() => {
                if (!projectId || !dashboardLoaded) return;
                const controllers = [];
                let cancelled = false;
                const prefetch = () => {
                    if (cancelled) return;
                    PARENTS_DASHBOARD_EVENT_TABS.forEach((tabType) => {
                        if (tabType === eventType) return;
                        const requestKey = getDefaultDashboardCacheKey(tabType);
                        if (dashboardCacheRef.current.has(requestKey)) return;
                        const controller = new AbortController();
                        controllers.push(controller);
                        fetch(`${API_BASE}/parents_dashboard_state?${requestKey}`, {
                            signal: controller.signal,
                            cache: 'no-store'
                        })
                            .then(async (response) => {
                                if (!response.ok) return null;
                                return response.json();
                            })
                            .then((data) => {
                                if (cancelled || !data || typeof data !== 'object') return;
                                rememberBoundedCacheValue(dashboardCacheRef.current, requestKey, data, 72);
                            })
                            .catch(() => {});
                    });
                };
                const idleHandle = typeof window.requestIdleCallback === 'function'
                    ? window.requestIdleCallback(prefetch, { timeout: 2200 })
                    : window.setTimeout(prefetch, 900);
                return () => {
                    cancelled = true;
                    if (typeof window.cancelIdleCallback === 'function') {
                        window.cancelIdleCallback(idleHandle);
                    } else {
                        window.clearTimeout(idleHandle);
                    }
                    controllers.forEach((controller) => controller.abort());
                };
            }, [projectId, parishId, dataVersion, dashboardRefreshRevision, liveRefreshNonce, dashboardLoaded, eventType, getDefaultDashboardCacheKey]);

            const totals = dashboardData?.totals || { rows: 0, primary: 0, secondary: 0, localities: 0 };
            const filteredRows = Array.isArray(dashboardData?.rows) ? dashboardData.rows : [];
            const totalPages = Math.max(1, Number(dashboardData?.totalPages || 1));
            const filteredCount = Number(dashboardData?.filteredCount || 0);
            const selectedPairLabel = dashboardData?.selectedPrimaryLabel || '';
            const selectedGodparentLabel = dashboardData?.selectedSecondaryLabel || '';
            const selectedLocalityLabel = dashboardData?.selectedLocalityLabel || '';
            const selectedPairRows = Array.isArray(dashboardData?.selectedPrimaryRows) ? dashboardData.selectedPrimaryRows : [];
            const pairOptions = Array.isArray(dashboardData?.primaryOptions) ? dashboardData.primaryOptions : [];
            const godparentOptions = Array.isArray(dashboardData?.secondaryOptions) ? dashboardData.secondaryOptions : [];
            const localityOptions = Array.isArray(dashboardData?.localityOptions) ? dashboardData.localityOptions : [];
            const pairHiddenCount = Number(dashboardData?.primaryHiddenCount || 0);
            const godparentHiddenCount = Number(dashboardData?.secondaryHiddenCount || 0);
            const localityHiddenCount = Number(dashboardData?.localityHiddenCount || 0);
            const pairOptionsTotal = Number(dashboardData?.primaryOptionsTotal || pairOptions.length);
            const godparentOptionsTotal = Number(dashboardData?.secondaryOptionsTotal || godparentOptions.length);
            const localityOptionsTotal = Number(dashboardData?.localityOptionsTotal || localityOptions.length);
            const activePage = Math.max(1, Number(dashboardData?.currentPage || currentPage || 1));
            const availableCaseYearStart = dashboardData?.availableCaseYearStart ?? null;
            const availableCaseYearEnd = dashboardData?.availableCaseYearEnd ?? null;
            const hasYearFilter = Boolean(caseYearFrom || caseYearTo);
            const yearFilterLabel = caseYearFrom && caseYearTo
                ? (caseYearFrom === caseYearTo ? caseYearFrom : `${caseYearFrom} — ${caseYearTo}`)
                : (caseYearFrom || caseYearTo || '');

            const renderCellText = (value) => {
                const text = String(value || '').trim();
                if (!text) return '—';
                return resultSearch ? highlightText(text, resultSearch) : text;
            };

            return (
                <div className="flex-1 min-h-0 overflow-hidden bg-[#e8e4dc] bg-texture">
                    <div className="h-full overflow-auto">
                        <div className="max-w-[1880px] mx-auto px-6 py-6 space-y-6">
                            {!dashboardLoaded && dashboardLoading ? (
                                <DashboardSkeletonTable
                                    columns={(dashboardConfig?.columns?.length) || 6}
                                    rows={10}
                                    title="Готовим подборку записей"
                                />
                            ) : null}
                            <div className="parents-page-hero overflow-hidden">
                                <div className="relative px-6 py-7 sm:px-8 sm:py-8">
                                    <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
                                        <div className="min-w-0 max-w-2xl">
                                            <span className="parents-eyebrow">Дашборд событий</span>
                                            <h1 className="parents-page-title" style={{ fontSize: 'clamp(28px, 3.4vw, 40px)' }}>{dashboardConfig.title}</h1>
                                            <span className="parents-page-rule" />
                                            <p className="parents-page-lede" style={{ fontSize: '14px' }}>
                                                {dashboardConfig.description}
                                            </p>
                                            <div className="mt-5 flex flex-wrap gap-2">
                                                {PARENTS_DASHBOARD_EVENT_TABS.map((tabType) => {
                                                    const tabConfig = PARENTS_DASHBOARD_EVENT_CONFIG[tabType];
                                                    const active = !patronymicCheckActive && eventType === tabType;
                                                    return (
                                                        <button
                                                            key={tabType}
                                                            onClick={() => {
                                                                if (!patronymicCheckActive && tabType === eventType) return;
                                                                setPatronymicCheckActive(false);
                                                                if (tabType !== eventType) {
                                                                    const cacheKey = getDefaultDashboardCacheKey(tabType);
                                                                    const cachedData = dashboardCacheRef.current.get(cacheKey);
                                                                    if (cachedData) {
                                                                        setDashboardData(cachedData);
                                                                        setDashboardLoaded(true);
                                                                        setDashboardLoading(false);
                                                                    } else {
                                                                        setDashboardLoading(true);
                                                                    }
                                                                    setEventType(tabType);
                                                                    setResultSearch('');
                                                                    setPairSearch('');
                                                                    setGodparentSearch('');
                                                                    setLocalitySearch('');
                                                                    setFilters({ parentPairKey: '', godparentKey: '', localityKey: '' });
                                                                    setCurrentPage(1);
                                                                }
                                                            }}
                                                            className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${active ? 'bg-[#8b0000] text-white shadow-sm' : 'border border-stone-200 bg-white text-stone-500 hover:text-[#8b0000] hover:border-[#8b0000]'}`}
                                                        >
                                                            {tabConfig?.tabLabel || tabType}
                                                        </button>
                                                    );
                                                })}
                                                <button
                                                    onClick={() => setPatronymicCheckActive(true)}
                                                    className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${patronymicCheckActive ? 'bg-[#7a4b2f] text-white shadow-sm' : 'border border-[#7a4b2f]/40 bg-white text-[#7a4b2f] hover:bg-[#fff5e8]'}`}
                                                    title="Записи, где отчество ребёнка не согласуется с именем отца"
                                                >
                                                    ⚐ Проверка отчеств
                                                </button>
                                            </div>
                                            {project?.title && (
                                                <div className="mt-3 text-[11px] uppercase tracking-[0.16em] text-stone-400">
                                                    {project.title}
                                                </div>
                                            )}
                                            {parish?.title && (
                                                <div className="mt-4">
                                                    <span className="parents-parish-chip">
                                                        <span className="parents-parish-chip__dot" />
                                                        Приход · {parish.title}
                                                    </span>
                                                    {parish.subtitle && (
                                                        <div className="mt-2 text-[11px] text-[var(--parents-ink-soft)]">
                                                            {parish.subtitle}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 shrink-0">
                                            {[
                                                { label: dashboardConfig.totals.rows, value: totals.rows },
                                                { label: dashboardConfig.totals.primary, value: totals.primary },
                                                { label: dashboardConfig.totals.secondary, value: totals.secondary },
                                                { label: dashboardConfig.totals.localities, value: totals.localities },
                                            ].filter(card => String(card?.label || '').trim()).map((card) => (
                                                <div key={card.label} className="rounded-2xl border border-stone-200 bg-[#faf6ee] px-4 py-3 min-w-[128px]">
                                                    <div className="text-[10px] uppercase tracking-[0.16em] text-stone-400 font-bold">{card.label}</div>
                                                    <div className="mt-1 text-2xl font-black text-stone-800">{card.value}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {patronymicCheckActive ? null : (
                                <>
                                {(filters.parentPairKey || filters.godparentKey || filters.localityKey || (dashboardLoaded && dashboardLoading)) && (
                                    <div className="border-b border-stone-200 bg-[#fdf8f0] px-6 py-4">
                                        <div className="flex flex-col gap-3">
                                            {dashboardLoaded && dashboardLoading && (
                                                <div className="flex items-center gap-3 text-[11px] text-stone-500">
                                                    <div className="h-5 w-5 rounded-full border-2 border-stone-300 border-t-[#8b0000] animate-spin" />
                                                    <span>Обновляем выборку...</span>
                                                </div>
                                            )}
                                            {(filters.parentPairKey || filters.godparentKey || filters.localityKey) && (
                                        <div className="mt-3 flex flex-wrap gap-2">
                                            {filters.parentPairKey && (
                                                <button onClick={() => setFilters(prev => ({ ...prev, parentPairKey: '' }))} className="rounded-full border border-[#8b0000] bg-[#fff5f1] px-3 py-1 text-[11px] font-bold text-[#8b0000]">
                                                    {dashboardConfig.facetPrimary.chipLabel}: {selectedPairLabel || 'выбрано'} ×
                                                </button>
                                            )}
                                            {filters.godparentKey && (
                                                <button onClick={() => setFilters(prev => ({ ...prev, godparentKey: '' }))} className="rounded-full border border-[#8b0000] bg-[#fff5f1] px-3 py-1 text-[11px] font-bold text-[#8b0000]">
                                                    {dashboardConfig.facetSecondary.chipLabel}: {selectedGodparentLabel || 'выбрано'} ×
                                                </button>
                                            )}
                                            {filters.localityKey && (
                                                <button onClick={() => setFilters(prev => ({ ...prev, localityKey: '' }))} className="rounded-full border border-[#8b0000] bg-[#fff5f1] px-3 py-1 text-[11px] font-bold text-[#8b0000]">
                                                    Населённый пункт: {selectedLocalityLabel || 'выбрано'} ×
                                                </button>
                                            )}
                                            <button
                                                onClick={() => {
                                                    setFilters({ parentPairKey: '', godparentKey: '', localityKey: '' });
                                                }}
                                                className="rounded-full border border-stone-200 bg-white px-3 py-1 text-[11px] font-bold text-stone-500 hover:border-stone-300"
                                            >
                                                Сбросить всё
                                            </button>
                                        </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                
                                <div className="p-6 grid gap-6 xl:grid-cols-3">
                                    <ParentsDashboardFacetCard
                                        title={dashboardConfig.facetPrimary.title}
                                        subtitle={dashboardConfig.facetPrimary.subtitle}
                                        options={pairOptions}
                                        hiddenCount={pairHiddenCount}
                                        totalCount={pairOptionsTotal}
                                        activeKey={filters.parentPairKey}
                                        onToggle={(value) => handleFacetSelect('parentPairKey', value)}
                                        searchValue={pairSearch}
                                        onSearchChange={setPairSearch}
                                    />
                                    <ParentsDashboardFacetCard
                                        title={dashboardConfig.facetSecondary.title}
                                        subtitle={dashboardConfig.facetSecondary.subtitle}
                                        options={godparentOptions}
                                        hiddenCount={godparentHiddenCount}
                                        totalCount={godparentOptionsTotal}
                                        activeKey={filters.godparentKey}
                                        onToggle={(value) => handleFacetSelect('godparentKey', value)}
                                        searchValue={godparentSearch}
                                        onSearchChange={setGodparentSearch}
                                    />
                                    <ParentsDashboardFacetCard
                                        title={dashboardConfig.facetLocality.title}
                                        subtitle={dashboardConfig.facetLocality.subtitle}
                                        options={localityOptions}
                                        hiddenCount={localityHiddenCount}
                                        totalCount={localityOptionsTotal}
                                        activeKey={filters.localityKey}
                                        onToggle={(value) => handleFacetSelect('localityKey', value)}
                                        searchValue={localitySearch}
                                        onSearchChange={setLocalitySearch}
                                    />
                                </div>
                                </>)}
                            </div>

                            {patronymicCheckActive ? (
                                <ParentsPatronymicMismatchesView
                                    projectId={projectId}
                                    parishId={parishId}
                                    canEdit={canEdit}
                                    onOpenRow={onOpenRow}
                                />
                            ) : (
                            <div ref={tableRef} style={{ scrollMarginTop: '88px' }} className="parents-table-shell">
                                <div className="parents-table-header">
                                    <div>
                                        <div className="text-[10px] uppercase tracking-[0.24em] text-[#8b0000] font-bold">Результаты</div>
                                        <div className="mt-1 font-display text-2xl text-stone-800 leading-tight">Подборка записей</div>
                                        <div className="mt-1 text-sm text-stone-500 max-w-3xl">
                                            {filteredCount} записей соответствуют текущим фильтрам и поиску.
                                        </div>
                                        <div
                                            className="mt-4 parents-filter-bar"
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                gap: '12px 18px',
                                            }}
                                        >
                                                {/* Поиск по строкам */}
                                                <label
                                                    className="parents-table-search"
                                                    style={{
                                                        flex: '1 1 320px',
                                                        maxWidth: 'none',
                                                        padding: '11px 16px',
                                                        background: '#fffefb',
                                                    }}
                                                >
                                                    <span className="parents-table-search__icon" style={{ fontSize: '16px' }}>⌕</span>
                                                    <DebouncedSearchField
                                                        value={resultSearch}
                                                        onChange={setResultSearch}
                                                        delay={SEARCH_INPUT_DEBOUNCE_MS}
                                                        placeholder={dashboardConfig.searchHelp}
                                                        className="parents-table-search__input"
                                                    />
                                                </label>

                                                {/* Год дела */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                                                    <span style={{
                                                        fontFamily: "'Lora', serif",
                                                        fontSize: '10px',
                                                        fontWeight: 800,
                                                        letterSpacing: '0.20em',
                                                        textTransform: 'uppercase',
                                                        color: 'var(--parents-scarlet)',
                                                        whiteSpace: 'nowrap',
                                                    }}>Годы</span>
                                                    <label className="parents-table-search" style={{ width: '88px', padding: '8px 10px', background: '#fffefb' }}>
                                                        <DebouncedSearchField
                                                            value={caseYearFrom}
                                                            onChange={(value) => setCaseYearFrom(String(value || '').replace(/\D+/g, '').slice(0, 4))}
                                                            delay={SEARCH_INPUT_DEBOUNCE_MS}
                                                            placeholder="от"
                                                            className="parents-table-search__input"
                                                        />
                                                    </label>
                                                    <span style={{
                                                        fontFamily: "'Playfair Display', serif",
                                                        fontSize: '18px',
                                                        color: 'var(--parents-copper)',
                                                    }}>—</span>
                                                    <label className="parents-table-search" style={{ width: '88px', padding: '8px 10px', background: '#fffefb' }}>
                                                        <DebouncedSearchField
                                                            value={caseYearTo}
                                                            onChange={(value) => setCaseYearTo(String(value || '').replace(/\D+/g, '').slice(0, 4))}
                                                            delay={SEARCH_INPUT_DEBOUNCE_MS}
                                                            placeholder="до"
                                                            className="parents-table-search__input"
                                                        />
                                                    </label>
                                                    {hasYearFilter && (
                                                        <button
                                                            onClick={() => { setCaseYearFrom(''); setCaseYearTo(''); }}
                                                            className="parents-table-action-btn parents-table-action-btn--primary"
                                                            title="Сбросить годы"
                                                        >
                                                            ×
                                                        </button>
                                                    )}
                                                </div>

                                                {/* Pagination — на одном уровне с поиском и годами */}
                                                <div
                                                    className="pagination-embed"
                                                    style={{
                                                        flexShrink: 0,
                                                        marginLeft: 'auto',
                                                        paddingLeft: '14px',
                                                        borderLeft: '1px solid rgba(184,115,51,0.22)',
                                                    }}
                                                >
                                                    <PaginationControls
                                                        page={activePage}
                                                        totalPages={totalPages}
                                                        totalItems={filteredCount}
                                                        pageSize={PARENTS_DASHBOARD_PAGE_SIZE}
                                                        label="Записи"
                                                        onChange={setCurrentPage}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mt-2 text-[11px]" style={{ color: 'var(--parents-ink-soft)', fontFamily: "'Lora', serif" }}>
                                                {hasYearFilter ? <><span style={{ color: 'var(--parents-scarlet)', fontWeight: 700 }}>Фильтр: {yearFilterLabel}.</span> </> : null}
                                                Данные покрывают <span style={{ color: 'var(--parents-ink)', fontWeight: 600 }}>{availableCaseYearStart || '—'}{availableCaseYearEnd && availableCaseYearEnd !== availableCaseYearStart ? ` — ${availableCaseYearEnd}` : ''}</span>.
                                            </div>
                                    </div>
                                </div>

                                {filteredRows.length > 0 ? (
                                    <>
                                        <div className="parents-table-scroll">
                                            <table className="parents-table min-w-[1360px]">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>№</th>
                                                        {dashboardConfig.columns.map(column => {
                                                            const sortable = column.key === 'eventYear';
                                                            if (!sortable) return <th key={column.key}>{column.label}</th>;
                                                            const isActive = sortState.key === 'event_year' && sortState.dir;
                                                            const arrow = !isActive ? '↕' : (sortState.dir === 'asc' ? '↑' : '↓');
                                                            const cycle = () => {
                                                                setSortState((prev) => {
                                                                    if (prev.key !== 'event_year' || !prev.dir) return { key: 'event_year', dir: 'asc' };
                                                                    if (prev.dir === 'asc') return { key: 'event_year', dir: 'desc' };
                                                                    return { key: '', dir: '' };
                                                                });
                                                            };
                                                            return (
                                                                <th
                                                                    key={column.key}
                                                                    onClick={cycle}
                                                                    title="Сортировать по дате события"
                                                                    style={{ cursor: 'pointer', userSelect: 'none' }}
                                                                >
                                                                    <span className="inline-flex items-center gap-1">
                                                                        {column.label}
                                                                        <span
                                                                            className={isActive ? 'text-[#8b0000]' : 'text-stone-400'}
                                                                            style={{ fontSize: '11px', lineHeight: 1 }}
                                                                        >
                                                                            {arrow}
                                                                        </span>
                                                                    </span>
                                                                </th>
                                                            );
                                                        })}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredRows.map((row, index) => (
                                                        <tr key={row.id}>
                                                            <td className="parents-cell--actions">
                                                                <button
                                                                    onClick={() => onOpenRow?.(row)}
                                                                    className="parents-table-action-btn parents-table-action-btn--primary"
                                                                    title="Открыть страницу в каталоге"
                                                                >
                                                                    ↗
                                                                </button>
                                                                {canEdit && (
                                                                    <button
                                                                        onClick={() => onEditRow?.(row, filters.localityKey ? { field: 'locality', groupKey: filters.localityKey, label: selectedLocalityLabel } : {})}
                                                                        className="parents-table-action-btn"
                                                                        title="Править данные записи"
                                                                    >
                                                                        ✎
                                                                    </button>
                                                                )}
                                                                <ParentsDataQualityWarning
                                                                    row={row}
                                                                    onEdit={canEdit ? () => onEditRow?.(row, { field: 'death_cause', preferredStatus: 'DECEASED', label: 'Причина смерти' }) : null}
                                                                />
                                                            </td>
                                                            <td className="parents-cell--num">{(activePage - 1) * PARENTS_DASHBOARD_PAGE_SIZE + index + 1}</td>
                                                            {dashboardConfig.columns.map((column) => (
                                                                <td key={`${row.id}-${column.key}`} className={column.className || ''} style={column.className ? undefined : { minWidth: '150px' }}>
                                                                    {column.render(row, renderCellText, { onOpenRecord: onOpenRow })}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="parents-table-toolbar parents-table-toolbar--pagination">
                                            <PaginationControls
                                                page={activePage}
                                                totalPages={totalPages}
                                                totalItems={filteredCount}
                                                pageSize={PARENTS_DASHBOARD_PAGE_SIZE}
                                                label="Записи"
                                                onChange={setCurrentPage}
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <div className="px-8 py-20 text-center">
                                        <div className="text-xl text-[var(--parents-ink)]" style={{ fontFamily: "'Playfair Display', serif" }}>Под текущие фильтры ничего не нашлось</div>
                                        <div className="mt-2 text-sm text-[var(--parents-ink-soft)]" style={{ fontFamily: "'Lora', serif" }}>
                                            Попробуйте снять один из фильтров или изменить поисковый запрос.
                                        </div>
                                    </div>
                                )}
                            </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsLinkCandidateCard = ({ candidate, onOpenRow }) => (
            <div className="px-6 py-6 bg-[#fffdf8]">
                <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
                    <div className="min-w-0">
                        <div className="flex flex-wrap items-center gap-2">
                            <span className="rounded-full bg-[#8b0000] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-white">
                                {candidate.typeLabel}
                            </span>
                            <span className="rounded-full border border-stone-200 bg-white px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">
                                {candidate.scorePercent}% уверенности
                            </span>
                            {candidate.status ? (
                                <span className="rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-amber-700">
                                    {candidate.status}
                                </span>
                            ) : null}
                            {candidate.identityProfileStatus ? (
                                <span
                                    className={`rounded-full border px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] ${
                                        candidate.identityProfileStatus === 'conflict'
                                            ? 'border-rose-200 bg-rose-50 text-rose-700'
                                            : candidate.identityProfileStatus === 'auto'
                                            ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
                                            : 'border-sky-200 bg-sky-50 text-sky-700'
                                    }`}
                                    title={(candidate.identityProfileReasons || []).concat(candidate.identityProfileConflicts || []).join(' · ')}
                                >
                                    Биография: {candidate.identityProfileStatus}
                                </span>
                            ) : null}
                            {candidate.adjustedStatus && candidate.originalStatus && candidate.adjustedStatus !== candidate.originalStatus ? (
                                <span
                                    className="rounded-full border border-purple-200 bg-purple-50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-purple-700"
                                    title={candidate.adjustmentReason || ''}
                                >
                                    {candidate.originalStatus} → {candidate.adjustedStatus}
                                </span>
                            ) : null}
                        </div>
                        <div className="mt-3 font-display text-2xl text-stone-800 leading-tight">
                            {candidate.title}
                        </div>
                        {candidate.subjectLabel ? (
                            <div className="mt-2 text-sm text-stone-500">
                                Центральная персона/запись: <span className="font-semibold text-stone-700">{candidate.subjectLabel}</span>
                            </div>
                        ) : null}
                        {Array.isArray(candidate.reasons) && candidate.reasons.length > 0 ? (
                            <div className="mt-3 flex flex-wrap gap-2">
                                {candidate.reasons.map((reason, index) => (
                                    <span key={`${candidate.id}-reason-${index}`} className="rounded-full border border-[#8b0000]/20 bg-[#fff5f1] px-3 py-1 text-[11px] text-[#8b0000]">
                                        {reason}
                                    </span>
                                ))}
                            </div>
                        ) : null}
                        {Array.isArray(candidate.warnings) && candidate.warnings.length > 0 ? (
                            <div className="mt-3 flex flex-wrap gap-2">
                                {candidate.warnings.map((warning, index) => (
                                    <span key={`${candidate.id}-warning-${index}`} className="rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-[11px] text-amber-700">
                                        {warning}
                                    </span>
                                ))}
                            </div>
                        ) : null}
                    </div>
                </div>

                <div className="mt-5 grid gap-4 xl:grid-cols-2">
                    {[candidate.left, candidate.right].map((side, index) => (
                        <div key={`${candidate.id}-side-${index}`} className="rounded-[24px] border border-stone-200 bg-white/90 p-5 shadow-[0_10px_28px_rgba(45,34,20,0.06)]">
                            <div className="flex flex-wrap items-center gap-2">
                                <span className="rounded-full border border-stone-200 bg-[#faf6ee] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">
                                    {index === 0 ? 'Левая запись' : 'Правая запись'}
                                </span>
                                <span className="rounded-full border border-[#8b0000]/20 bg-[#fff5f1] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">
                                    {formatStructuredEntryType(side?.eventType)}
                                </span>
                            </div>
                            <div className="mt-3 font-display text-2xl text-stone-800 leading-tight">
                                {side?.previewLabel || 'Без подписи'}
                            </div>
                            <div className="mt-3 grid gap-2 text-sm text-stone-500">
                                <div><span className="font-semibold text-stone-700">Дата:</span> {side?.dateLabel || '—'}</div>
                                <div><span className="font-semibold text-stone-700">Шифр:</span> {side?.cipherLabel || '—'}</div>
                                <div><span className="font-semibold text-stone-700">Страница:</span> {side?.pageLabel || '—'}</div>
                                <div><span className="font-semibold text-stone-700">Локальность:</span> {side?.localityLabel || '—'}</div>
                            </div>
                            <div className="mt-4 flex flex-wrap gap-2">
                                <button
                                    onClick={() => onOpenRow?.({ itemId: side?.itemId })}
                                    className="rounded-full border border-[#8b0000] bg-[#fff5f1] px-3 py-1 text-[11px] font-bold text-[#8b0000] hover:bg-white"
                                >
                                    {side?.cipherLabel || 'Шифр дела'}
                                </button>
                                <button
                                    onClick={() => onOpenRow?.({ itemId: side?.itemId })}
                                    className="rounded-full border border-stone-200 bg-white px-3 py-1 text-[11px] font-bold text-stone-600 hover:border-[#8b0000] hover:text-[#8b0000]"
                                >
                                    стр. {side?.pageLabel || '—'}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );

        const normalizeParentsTreePersonKey = (value) => normalizeText(String(value || '').replace(/\s+/g, ' ').trim());
        const hasStrictParentsTreePersonLabel = (value) => {
            const parts = String(value || '').trim().split(/\s+/).filter(Boolean);
            return parts.length >= 3;
        };
        const buildStrictParentsTreeCoupleKey = (leftLabel, rightLabel) => {
            const left = String(leftLabel || '').trim();
            const right = String(rightLabel || '').trim();
            if (!hasStrictParentsTreePersonLabel(left) || !hasStrictParentsTreePersonLabel(right)) {
                return '';
            }
            return [normalizeParentsTreePersonKey(left), normalizeParentsTreePersonKey(right)].filter(Boolean).join('|');
        };

        const pushUniqueRow = (list, row) => {
            if (!Array.isArray(list) || !row?.id) return;
            if (!list.some(entry => entry?.id === row.id)) {
                list.push(row);
            }
        };

        const buildParentsFamilyTreeModel = (rows = [], links = []) => {
            const normalizedRows = Array.isArray(rows) ? rows : [];
            const normalizedLinks = Array.isArray(links) ? links : [];
            const rowMap = new Map(normalizedRows.map(row => [row.id, row]));
            const people = new Map();
            const couples = new Map();
            const childToNextCouples = new Map();
            const referencedCoupleKeys = new Set();

            const ensurePerson = (label) => {
                const cleanLabel = String(label || '').trim();
                const key = normalizeParentsTreePersonKey(cleanLabel);
                if (!key) return null;
                if (!people.has(key)) {
                    people.set(key, {
                        key,
                        label: cleanLabel,
                        birthRows: [],
                        weddingRows: [],
                        deathRows: [],
                        linkedWeddingRows: [],
                        linkedDeathRows: [],
                    });
                } else if (cleanLabel && !people.get(key).label) {
                    people.get(key).label = cleanLabel;
                }
                return people.get(key);
            };

            const ensureCouple = (key, fatherLabel, motherLabel) => {
                const cleanKey = String(key || '').trim();
                if (!cleanKey) return null;
                if (!couples.has(cleanKey)) {
                    couples.set(cleanKey, {
                        key: cleanKey,
                        fatherLabel: String(fatherLabel || '').trim(),
                        motherLabel: String(motherLabel || '').trim(),
                        fatherKey: normalizeParentsTreePersonKey(fatherLabel),
                        motherKey: normalizeParentsTreePersonKey(motherLabel),
                        weddingRows: [],
                        parentBirthRows: [],
                        childrenMap: new Map(),
                    });
                } else {
                    const existing = couples.get(cleanKey);
                    if (!existing.fatherLabel && fatherLabel) existing.fatherLabel = String(fatherLabel).trim();
                    if (!existing.motherLabel && motherLabel) existing.motherLabel = String(motherLabel).trim();
                    if (!existing.fatherKey && fatherLabel) existing.fatherKey = normalizeParentsTreePersonKey(fatherLabel);
                    if (!existing.motherKey && motherLabel) existing.motherKey = normalizeParentsTreePersonKey(motherLabel);
                }
                return couples.get(cleanKey);
            };

            normalizedRows.forEach((row) => {
                const eventType = String(row?.eventType || '').toUpperCase();
                if (eventType === 'BIRTH') {
                    const childPerson = ensurePerson(row?.childName);
                    const fatherPerson = ensurePerson(row?.fatherName);
                    const motherPerson = ensurePerson(row?.motherName);
                    if (childPerson) pushUniqueRow(childPerson.birthRows, row);
                    if (fatherPerson) pushUniqueRow(fatherPerson.birthRows, row);
                    if (motherPerson) pushUniqueRow(motherPerson.birthRows, row);

                    const pairKey = String(row?.parentPairKey || '').trim() || buildStrictParentsTreeCoupleKey(row?.fatherName, row?.motherName);
                    const couple = ensureCouple(pairKey, row?.fatherName, row?.motherName);
                    if (couple) {
                        pushUniqueRow(couple.parentBirthRows, row);
                        const childKey = childPerson?.key || `row:${row.id}`;
                        if (!couple.childrenMap.has(childKey)) {
                            couple.childrenMap.set(childKey, {
                                key: childKey,
                                label: row?.childName || row?.previewLabel || 'Без имени',
                                birthRows: [],
                                nextCoupleKeys: new Set(),
                            });
                        }
                        const childEntry = couple.childrenMap.get(childKey);
                        if (!childEntry.label && row?.childName) childEntry.label = row.childName;
                        pushUniqueRow(childEntry.birthRows, row);
                    }
                    return;
                }

                if (eventType === 'WEDDING') {
                    const groomPerson = ensurePerson(row?.groomName);
                    const bridePerson = ensurePerson(row?.brideName);
                    if (groomPerson) pushUniqueRow(groomPerson.weddingRows, row);
                    if (bridePerson) pushUniqueRow(bridePerson.weddingRows, row);
                    const pairKey = String(row?.spousePairKey || '').trim() || buildStrictParentsTreeCoupleKey(row?.groomName, row?.brideName);
                    const couple = ensureCouple(pairKey, row?.groomName, row?.brideName);
                    if (couple) pushUniqueRow(couple.weddingRows, row);
                    return;
                }

                if (eventType === 'DEATH') {
                    const deceasedPerson = ensurePerson(row?.deceasedName);
                    if (deceasedPerson) pushUniqueRow(deceasedPerson.deathRows, row);
                }
            });

            normalizedLinks.forEach((candidate) => {
                const type = String(candidate?.type || '').toUpperCase();
                const leftRow = rowMap.get(candidate?.left?.rowId);
                const rightRow = rowMap.get(candidate?.right?.rowId);

                if (type === 'BIRTH_TO_WEDDING_PERSON' && leftRow && rightRow) {
                    const childKey = normalizeParentsTreePersonKey(leftRow?.childName || candidate?.subjectLabel);
                    const coupleKey = String(rightRow?.spousePairKey || '').trim() || buildStrictParentsTreeCoupleKey(rightRow?.groomName, rightRow?.brideName);
                    if (childKey && coupleKey) {
                        if (!childToNextCouples.has(childKey)) childToNextCouples.set(childKey, new Set());
                        childToNextCouples.get(childKey).add(coupleKey);
                        referencedCoupleKeys.add(coupleKey);
                        const person = people.get(childKey);
                        if (person) pushUniqueRow(person.linkedWeddingRows, rightRow);
                    }
                    return;
                }

                if (type === 'BIRTH_TO_DEATH' && leftRow && rightRow) {
                    const childKey = normalizeParentsTreePersonKey(leftRow?.childName || candidate?.subjectLabel);
                    if (childKey) {
                        const person = people.get(childKey);
                        if (person) pushUniqueRow(person.linkedDeathRows, rightRow);
                    }
                }

            });

            couples.forEach((couple) => {
                couple.children = Array.from(couple.childrenMap.values())
                    .map((child) => ({
                        ...child,
                        nextCoupleKeys: Array.from(childToNextCouples.get(child.key) || child.nextCoupleKeys || []).filter(Boolean),
                    }))
                    .sort((a, b) => {
                        const aBirth = a.birthRows?.[0];
                        const bBirth = b.birthRows?.[0];
                        const aSort = Number(aBirth?.dateSort || 0);
                        const bSort = Number(bBirth?.dateSort || 0);
                        if (aSort !== bSort) return aSort - bSort;
                        const aPage = parseInt(String(aBirth?.pageLabel || '').replace(/\D+/g, ''), 10) || 10 ** 9;
                        const bPage = parseInt(String(bBirth?.pageLabel || '').replace(/\D+/g, ''), 10) || 10 ** 9;
                        if (aPage !== bPage) return aPage - bPage;
                        return String(a.label || '').localeCompare(String(b.label || ''), 'ru');
                    });
                delete couple.childrenMap;
            });

            let rootCoupleKeys = Array.from(couples.keys()).filter(key => !referencedCoupleKeys.has(key));
            if (!rootCoupleKeys.length) {
                rootCoupleKeys = Array.from(couples.keys());
            }
            rootCoupleKeys.sort((leftKey, rightKey) => {
                const leftCouple = couples.get(leftKey);
                const rightCouple = couples.get(rightKey);
                const leftRow = leftCouple?.weddingRows?.[0] || leftCouple?.parentBirthRows?.[0];
                const rightRow = rightCouple?.weddingRows?.[0] || rightCouple?.parentBirthRows?.[0];
                const leftSort = Number(leftRow?.dateSort || 0);
                const rightSort = Number(rightRow?.dateSort || 0);
                if (leftSort !== rightSort) return leftSort - rightSort;
                return String(leftCouple?.fatherLabel || leftCouple?.motherLabel || '').localeCompare(String(rightCouple?.fatherLabel || rightCouple?.motherLabel || ''), 'ru');
            });

            const usedRowIds = new Set();
            const markRowsUsed = (rowList) => {
                (rowList || []).forEach((row) => {
                    if (row?.id) usedRowIds.add(row.id);
                });
            };
            const visitedTraversal = new Set();
            const traverseCouple = (coupleKey) => {
                if (!coupleKey || visitedTraversal.has(coupleKey)) return;
                visitedTraversal.add(coupleKey);
                const couple = couples.get(coupleKey);
                if (!couple) return;
                markRowsUsed(couple.weddingRows);
                markRowsUsed(couple.parentBirthRows);
                const fatherPerson = people.get(couple.fatherKey);
                const motherPerson = people.get(couple.motherKey);
                markRowsUsed(fatherPerson?.deathRows);
                markRowsUsed(fatherPerson?.linkedDeathRows);
                markRowsUsed(motherPerson?.deathRows);
                markRowsUsed(motherPerson?.linkedDeathRows);
                couple.children.forEach((child) => {
                    markRowsUsed(child.birthRows);
                    const childPerson = people.get(child.key);
                    markRowsUsed(childPerson?.weddingRows);
                    markRowsUsed(childPerson?.linkedWeddingRows);
                    markRowsUsed(childPerson?.deathRows);
                    markRowsUsed(childPerson?.linkedDeathRows);
                    (child.nextCoupleKeys || []).forEach(traverseCouple);
                });
            };
            rootCoupleKeys.forEach(traverseCouple);

            const looseRows = normalizedRows.filter((row) => !usedRowIds.has(row.id));

            return {
                people,
                couples,
                rootCoupleKeys,
                looseRows,
            };
        };

        const ParentsFamilyPersonSummary = ({ person }) => {
            const weddingCount = Math.max(person?.weddingRows?.length || 0, person?.linkedWeddingRows?.length || 0);
            const deathCount = Math.max(person?.deathRows?.length || 0, person?.linkedDeathRows?.length || 0);
            return (
                <div className="flex flex-wrap gap-2">
                    {(person?.birthRows?.length || 0) > 0 ? (
                        <span className="rounded-full border border-stone-200 bg-[#faf6ee] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-stone-500">
                            рожд. {person.birthRows.length}
                        </span>
                    ) : null}
                    {weddingCount > 0 ? (
                        <span className="rounded-full border border-stone-200 bg-[#faf6ee] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-stone-500">
                            брак {weddingCount}
                        </span>
                    ) : null}
                    {deathCount > 0 ? (
                        <span className="rounded-full border border-stone-200 bg-[#faf6ee] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-stone-500">
                            смерть {deathCount}
                        </span>
                    ) : null}
                </div>
            );
        };

        const ParentsFamilyTreeBranch = ({ coupleKey, tree, onOpenRow, depth = 0, visited = new Set() }) => {
            const couple = tree?.couples?.get(coupleKey);
            if (!couple) return null;
            if (visited.has(coupleKey)) {
                return (
                    <div className="rounded-[22px] border border-dashed border-stone-300 bg-white/80 px-5 py-4 text-sm text-stone-500">
                        Эта ветка уже показана выше, чтобы не зациклить дерево.
                    </div>
                );
            }
            const nextVisited = new Set(visited);
            nextVisited.add(coupleKey);
            const fatherPerson = tree?.people?.get(couple.fatherKey);
            const motherPerson = tree?.people?.get(couple.motherKey);

            return (
                <div className={`rounded-[28px] border border-stone-300 bg-white/95 p-5 shadow-[0_18px_55px_rgba(45,34,20,0.08)] ${depth > 0 ? 'mt-4' : ''}`}>
                    <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
                        <div className="min-w-0">
                            <div className="text-[10px] uppercase tracking-[0.18em] text-[#8b0000] font-bold">Семейная ветка</div>
                            <div className="mt-2 grid gap-4 xl:grid-cols-2">
                                {[
                                    ['Отец', couple.fatherLabel || 'Не указан', fatherPerson],
                                    ['Мать', couple.motherLabel || 'Не указана', motherPerson],
                                ].map(([role, label, person]) => (
                                    <div key={`${couple.key}-${role}`} className="rounded-[22px] border border-stone-200 bg-[#fcfaf5] px-4 py-4">
                                        <div className="text-[10px] uppercase tracking-[0.16em] text-stone-400 font-bold">{role}</div>
                                        <div className="mt-2 font-display text-2xl text-stone-800 leading-tight">{label}</div>
                                        <div className="mt-3">
                                            <ParentsFamilyPersonSummary person={person} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {(couple.weddingRows?.length || 0) > 0 ? (
                            <div className="shrink-0 flex flex-wrap gap-2">
                                {couple.weddingRows.map((row) => (
                                    <button
                                        key={`${couple.key}-wedding-${row.id}`}
                                        onClick={() => onOpenRow?.({ itemId: row?.itemId })}
                                        className="rounded-full border border-[#8b0000] bg-[#fff5f1] px-3 py-1 text-[11px] font-bold text-[#8b0000] hover:bg-white"
                                    >
                                        брак · {row?.cipherLabel || 'дело'} · стр. {row?.pageLabel || '—'}
                                    </button>
                                ))}
                            </div>
                        ) : null}
                    </div>

                    {(couple.children || []).length > 0 ? (
                        <div className="mt-5 border-t border-stone-200 pt-5">
                            <div className="text-[10px] uppercase tracking-[0.16em] text-[#8b0000] font-bold">Дети и дальнейшие ветки</div>
                            <div className="mt-4 space-y-4">
                                {couple.children.map((child) => {
                                    const childPerson = tree?.people?.get(child.key);
                                    const directBirthRow = child.birthRows?.[0] || null;
                                    return (
                                        <div key={`${couple.key}-child-${child.key}`} className="rounded-[24px] border border-stone-200 bg-[#faf6ee]/85 p-4">
                                            <div className="flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
                                                <div className="min-w-0">
                                                    <div className="font-display text-2xl text-stone-800 leading-tight">
                                                        {child.label || 'Без имени'}
                                                    </div>
                                                    <div className="mt-3">
                                                        <ParentsFamilyPersonSummary person={childPerson} />
                                                    </div>
                                                </div>
                                                <div className="shrink-0 flex flex-wrap gap-2">
                                                    {child.birthRows.map((row) => (
                                                        <button
                                                            key={`${child.key}-birth-${row.id}`}
                                                            onClick={() => onOpenRow?.({ itemId: row?.itemId })}
                                                            className="rounded-full border border-stone-200 bg-white px-3 py-1 text-[11px] font-bold text-stone-600 hover:border-[#8b0000] hover:text-[#8b0000]"
                                                        >
                                                            рожд. · {row?.cipherLabel || 'дело'} · стр. {row?.pageLabel || '—'}
                                                        </button>
                                                    ))}
                                                    {(childPerson?.linkedWeddingRows || []).filter((row, index, arr) => arr.findIndex(item => item?.id === row?.id) === index).map((row) => (
                                                        <button
                                                            key={`${child.key}-linked-wedding-${row.id}`}
                                                            onClick={() => onOpenRow?.({ itemId: row?.itemId })}
                                                            className="rounded-full border border-[#8b0000] bg-[#fff5f1] px-3 py-1 text-[11px] font-bold text-[#8b0000] hover:bg-white"
                                                        >
                                                            брак · {row?.cipherLabel || 'дело'} · стр. {row?.pageLabel || '—'}
                                                        </button>
                                                    ))}
                                                    {(childPerson?.linkedDeathRows || []).filter((row, index, arr) => arr.findIndex(item => item?.id === row?.id) === index).map((row) => (
                                                        <button
                                                            key={`${child.key}-linked-death-${row.id}`}
                                                            onClick={() => onOpenRow?.({ itemId: row?.itemId })}
                                                            className="rounded-full border border-stone-200 bg-white px-3 py-1 text-[11px] font-bold text-stone-600 hover:border-[#8b0000] hover:text-[#8b0000]"
                                                        >
                                                            смерть · {row?.cipherLabel || 'дело'} · стр. {row?.pageLabel || '—'}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                            {(child.nextCoupleKeys || []).length > 0 ? (
                                                <div className="mt-4 border-l-2 border-[#8b0000]/20 pl-4 space-y-4">
                                                    {child.nextCoupleKeys.map((nextCoupleKey) => (
                                                        <ParentsFamilyTreeBranch
                                                            key={`${child.key}-branch-${nextCoupleKey}`}
                                                            coupleKey={nextCoupleKey}
                                                            tree={tree}
                                                            onOpenRow={onOpenRow}
                                                            depth={depth + 1}
                                                            visited={nextVisited}
                                                        />
                                                    ))}
                                                </div>
                                            ) : directBirthRow ? (
                                                <div className="mt-4 rounded-[18px] border border-dashed border-stone-300 bg-white/70 px-4 py-3 text-[12px] text-stone-500">
                                                    Пока эта ветка заканчивается на рождении: дальше еще нет уверенно найденных браков или следующих поколений.
                                                </div>
                                            ) : null}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : null}
                </div>
            );
        };

        const ParentsFamilyEventCard = ({ row, onOpenRow }) => {
            const eventType = String(row?.eventType || '').toUpperCase();
            const locality = row?.primaryLocalityLabel || joinLabels(row?.localityLabels);
            const eventMeta = PARENTS_DASHBOARD_EVENT_CONFIG[eventType] || PARENTS_DASHBOARD_EVENT_CONFIG.BIRTH;
            const detailLines = [];

            if (eventType === 'BIRTH') {
                if (row?.fatherName) detailLines.push({ label: 'Отец', value: row.fatherName });
                if (row?.motherName) detailLines.push({ label: 'Мать', value: row.motherName });
                if (joinLabels(row?.deathLabels || row?.secondaryLabels)) detailLines.push({ label: 'Сведения о смерти', value: joinLabels(row?.deathLabels || row?.secondaryLabels) });
            } else if (eventType === 'WEDDING') {
                if (row?.groomName) detailLines.push({ label: 'Жених', value: row.groomName });
                if (row?.brideName) detailLines.push({ label: 'Невеста', value: row.brideName });
                if (joinLabels(row?.witnessLabels)) detailLines.push({ label: 'Свидетели', value: joinLabels(row.witnessLabels) });
            } else if (eventType === 'DEATH') {
                if (row?.deceasedAge) detailLines.push({ label: 'Возраст', value: row.deceasedAge });
                if (joinLabels(row?.relatedLabels)) detailLines.push({ label: 'Связанные лица', value: joinLabels(row.relatedLabels) });
            }

            if (locality) detailLines.push({ label: 'Населённый пункт', value: locality });

            return (
                <div className="rounded-[24px] border border-stone-200 bg-white/95 p-5 shadow-[0_10px_28px_rgba(45,34,20,0.06)]">
                    <div className="flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
                        <div className="min-w-0">
                            <div className="flex flex-wrap items-center gap-2">
                                <span className="rounded-full border border-[#8b0000]/20 bg-[#fff5f1] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">
                                    {formatStructuredEntryType(eventType)}
                                </span>
                                <span className="rounded-full border border-stone-200 bg-[#faf6ee] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">
                                    {row?.dateLabel || 'Без даты'}
                                </span>
                            </div>
                            <div className="mt-3 font-display text-2xl text-stone-800 leading-tight">
                                {eventMeta.previewLabel?.(row) || row?.previewLabel || 'Без подписи'}
                            </div>
                        </div>
                        <div className="shrink-0 flex flex-wrap gap-2">
                            <button
                                onClick={() => onOpenRow?.({ itemId: row?.itemId })}
                                className="rounded-full border border-[#8b0000] bg-[#fff5f1] px-3 py-1 text-[11px] font-bold text-[#8b0000] hover:bg-white"
                            >
                                {row?.cipherLabel || 'Шифр дела'}
                            </button>
                            <button
                                onClick={() => onOpenRow?.({ itemId: row?.itemId })}
                                className="rounded-full border border-stone-200 bg-white px-3 py-1 text-[11px] font-bold text-stone-600 hover:border-[#8b0000] hover:text-[#8b0000]"
                            >
                                стр. {row?.pageLabel || '—'}
                            </button>
                        </div>
                    </div>
                    {detailLines.length > 0 ? (
                        <div className="mt-4 grid gap-2 text-sm text-stone-500">
                            {detailLines.map((line, index) => (
                                <div key={`${row?.id || 'row'}-detail-${index}`}>
                                    <span className="font-semibold text-stone-700">{line.label}:</span> {line.value}
                                </div>
                            ))}
                        </div>
                    ) : null}
                </div>
            );
        };

        const ParentsFamiliesView = ({ project, projectId, onOpenRow }) => {
            const [familyKey, setFamilyKey] = useState('');
            const [familySearch, setFamilySearch] = useState('');
            const [familiesData, setFamiliesData] = useState(null);
            const [familiesLoading, setFamiliesLoading] = useState(true);
            const [familiesLoaded, setFamiliesLoaded] = useState(false);
            const requestSeqRef = useRef(0);
            const cacheRef = useRef(parentsStatsStateCache);

            useEffect(() => {
                if (!projectId) return;
                const requestSeq = ++requestSeqRef.current;
                const controller = new AbortController();
                const params = new URLSearchParams({
                    pid: projectId,
                    family_search: familySearch,
                    family_key: familyKey,
                });
                const requestKey = params.toString();

                if (cacheRef.current.has(requestKey)) {
                    setFamiliesData(cacheRef.current.get(requestKey));
                    setFamiliesLoaded(true);
                    setFamiliesLoading(false);
                    return () => controller.abort();
                }

                setFamiliesLoading(true);
                fetch(`${API_BASE}/parents_families_state?${requestKey}`, { signal: controller.signal })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (requestSeqRef.current !== requestSeq) return;
                        const normalizedData = data && typeof data === 'object' ? data : {};
                        cacheRef.current.set(requestKey, normalizedData);
                        setFamiliesData(normalizedData);
                        setFamiliesLoaded(true);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (requestSeqRef.current !== requestSeq) return;
                        showToast('Не удалось загрузить семьи проекта', 'error');
                        setFamiliesData({
                            familyOptions: [],
                            familyOptionsTotal: 0,
                            familyHiddenCount: 0,
                            totalFamilies: 0,
                            selectedFamilyRows: [],
                            selectedFamilyLinks: [],
                            selectedFamilyCounts: { rows: 0, links: 0, births: 0, weddings: 0, deaths: 0 },
                        });
                        setFamiliesLoaded(true);
                    })
                    .finally(() => {
                        if (requestSeqRef.current === requestSeq) {
                            setFamiliesLoading(false);
                        }
                    });

                return () => controller.abort();
            }, [projectId, familySearch, familyKey]);

            const familyOptions = Array.isArray(familiesData?.familyOptions) ? familiesData.familyOptions : [];
            const selectedFamilyRows = Array.isArray(familiesData?.selectedFamilyRows) ? familiesData.selectedFamilyRows : [];
            const selectedFamilyLinks = Array.isArray(familiesData?.selectedFamilyLinks) ? familiesData.selectedFamilyLinks : [];
            const selectedFamilyCounts = familiesData?.selectedFamilyCounts || { rows: 0, links: 0, births: 0, weddings: 0, deaths: 0 };
            const selectedFamilyLabel = familiesData?.selectedFamilyLabel || '';
            const selectedFamilyVariants = Array.isArray(familiesData?.selectedFamilyVariants) ? familiesData.selectedFamilyVariants : [];
            const treeModel = useMemo(() => buildParentsFamilyTreeModel(selectedFamilyRows, selectedFamilyLinks), [selectedFamilyRows, selectedFamilyLinks]);

            return (
                <div className="flex-1 min-h-0 overflow-hidden bg-[#e8e4dc] bg-texture">
                    <div className="h-full overflow-auto">
                        <div className="max-w-[1860px] mx-auto px-6 py-6 space-y-6">
                            {!familiesLoaded && familiesLoading ? (
                                <div className="rounded-[30px] border border-stone-300 bg-white/95 px-8 py-10 text-center shadow-[0_18px_55px_rgba(45,34,20,0.1)]">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Собираем семьи проекта</div>
                                    <div className="mt-3 text-sm text-stone-500">Сводим все рождения, браки, смерти и уже найденные связи по фамильным линиям.</div>
                                </div>
                            ) : null}

                            <div className="parents-page-hero overflow-hidden">
                                <div className="relative px-6 py-7 sm:px-8 sm:py-8">
                                    <div className="flex flex-col gap-7 xl:flex-row xl:items-end xl:justify-between">
                                        <div className="min-w-0 max-w-2xl">
                                            <span className="parents-eyebrow">Семейный архив</span>
                                            <h1 className="parents-page-title" style={{ fontSize: 'clamp(28px, 3.4vw, 40px)' }}>Семьи <em>внутри проекта</em></h1>
                                            <span className="parents-page-rule" />
                                            <p className="parents-page-lede" style={{ fontSize: '14px' }}>
                                                Выберите фамильную линию и смотрите все записи этой семьи сразу: рождения, браки, смерти и уже найденные возможные связи между ними.
                                            </p>
                                            {project?.title && (
                                                <div className="mt-4 text-[11px] uppercase tracking-[0.18em] text-[var(--parents-ink-soft)]">
                                                    {project.title}
                                                </div>
                                            )}
                                        </div>
                                        <div className="grid grid-cols-2 xl:grid-cols-4 gap-2.5 shrink-0">
                                            <div className="parents-stat-tile">
                                                <div className="parents-stat-tile__label">Семей</div>
                                                <div className="parents-stat-tile__value">{Number(familiesData?.totalFamilies || 0)}</div>
                                            </div>
                                            <div className="parents-stat-tile">
                                                <div className="parents-stat-tile__label">Записей семьи</div>
                                                <div className="parents-stat-tile__value">{Number(selectedFamilyCounts?.rows || 0)}</div>
                                            </div>
                                            <div className="parents-stat-tile">
                                                <div className="parents-stat-tile__label">Связей семьи</div>
                                                <div className="parents-stat-tile__value">{Number(selectedFamilyCounts?.links || 0)}</div>
                                            </div>
                                            <div className="parents-stat-tile">
                                                <div className="parents-stat-tile__label">Вариантов фамилии</div>
                                                <div className="parents-stat-tile__value">{selectedFamilyVariants.length}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid gap-6 p-6 xl:grid-cols-[360px_minmax(0,1fr)]">
                                    <ParentsDashboardFacetCard
                                        title="Семьи"
                                        subtitle="Можно быстро перейти к одной фамилии и увидеть все записи, где она встречается."
                                        options={familyOptions}
                                        hiddenCount={Number(familiesData?.familyHiddenCount || 0)}
                                        totalCount={Number(familiesData?.familyOptionsTotal || 0)}
                                        activeKey={familyKey}
                                        onToggle={setFamilyKey}
                                        searchValue={familySearch}
                                        onSearchChange={setFamilySearch}
                                        emptyText="Под такой запрос семьи пока не нашлись."
                                    />

                                    <div className="space-y-6 min-w-0">
                                        {familyKey && selectedFamilyLabel ? (
                                            <>
                                                <div className="rounded-[28px] border border-stone-300 bg-white/95 px-6 py-5 shadow-[0_18px_55px_rgba(45,34,20,0.1)]">
                                                    <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
                                                        <div className="min-w-0">
                                                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Выбранная семья</div>
                                                            <div className="mt-2 font-display text-3xl text-stone-800 leading-tight">
                                                                {selectedFamilyLabel}
                                                            </div>
                                                            {selectedFamilyVariants.length > 0 ? (
                                                                <div className="mt-3 flex flex-wrap gap-2">
                                                                    {selectedFamilyVariants.map((variant) => (
                                                                        <span key={`${familyKey}-${variant}`} className="rounded-full border border-stone-200 bg-[#faf6ee] px-3 py-1 text-[11px] text-stone-600">
                                                                            {variant}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                        <div className="grid grid-cols-2 xl:grid-cols-5 gap-3 shrink-0">
                                                            {[
                                                                ['Рождений', selectedFamilyCounts?.births || 0],
                                                                ['Браков', selectedFamilyCounts?.weddings || 0],
                                                                ['Смертей', selectedFamilyCounts?.deaths || 0],
                                                                ['Всего записей', selectedFamilyCounts?.rows || 0],
                                                                ['Гипотез связей', selectedFamilyCounts?.links || 0],
                                                            ].map(([label, value]) => (
                                                                <div key={label} className="rounded-2xl border border-stone-200 bg-[#faf6ee] px-4 py-3 min-w-[128px]">
                                                                    <div className="text-[10px] uppercase tracking-[0.16em] text-stone-400 font-bold">{label}</div>
                                                                    <div className="mt-1 text-2xl font-black text-stone-800">{Number(value || 0)}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="rounded-[30px] border border-stone-300 bg-[#fffdf8]/95 shadow-[0_22px_70px_rgba(45,34,20,0.12)] overflow-hidden">
                                                    <div className="border-b border-stone-200 bg-[#fdf8f0] px-6 py-4">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-[#8b0000] font-bold">Черновик родословного дерева</div>
                                                        <div className="mt-1 text-sm text-stone-500">
                                                            Здесь мы пытаемся собрать поколения по уже найденным связям между рождением, браком и смертью членов этой семьи.
                                                        </div>
                                                    </div>
                                                    {treeModel.rootCoupleKeys.length > 0 ? (
                                                        <div className="space-y-5 p-6">
                                                            {treeModel.rootCoupleKeys.map((coupleKey) => (
                                                                <ParentsFamilyTreeBranch
                                                                    key={`family-root-${coupleKey}`}
                                                                    coupleKey={coupleKey}
                                                                    tree={treeModel}
                                                                    onOpenRow={onOpenRow}
                                                                />
                                                            ))}
                                                            {treeModel.looseRows.length > 0 ? (
                                                                <div className="rounded-[26px] border border-dashed border-stone-300 bg-white/80 p-5">
                                                                    <div className="text-[10px] uppercase tracking-[0.16em] text-[#8b0000] font-bold">Пока не встроились в дерево</div>
                                                                    <div className="mt-2 text-sm text-stone-500">
                                                                        Эти записи уже относятся к семье, но пока не получили уверенного места внутри поколений. Они остаются ниже и не теряются.
                                                                    </div>
                                                                    <div className="mt-4 space-y-4">
                                                                        {treeModel.looseRows.map((row) => (
                                                                            <ParentsFamilyEventCard
                                                                                key={`loose-${row.id}`}
                                                                                row={row}
                                                                                onOpenRow={onOpenRow}
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    ) : (
                                                        <div className="px-8 py-16 text-center">
                                                            <div className="text-lg font-display text-stone-700">Из этой семьи пока не получилось собрать дерево</div>
                                                            <div className="mt-2 text-sm text-stone-400">Записи семьи уже есть ниже, а дерево появится по мере накопления и уточнения связей.</div>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="rounded-[30px] border border-stone-300 bg-[#fffdf8]/95 shadow-[0_22px_70px_rgba(45,34,20,0.12)] overflow-hidden">
                                                    <div className="border-b border-stone-200 bg-[#fdf8f0] px-6 py-4">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-[#8b0000] font-bold">Все записи семьи</div>
                                                        <div className="mt-1 text-sm text-stone-500">
                                                            Здесь собраны все рождения, браки и смерти, где эта фамильная линия встречается в распознанных участниках.
                                                        </div>
                                                    </div>
                                                    {selectedFamilyRows.length > 0 ? (
                                                        <div className="space-y-4 p-6">
                                                            {selectedFamilyRows.map((row) => (
                                                                <ParentsFamilyEventCard
                                                                    key={row.id}
                                                                    row={row}
                                                                    onOpenRow={onOpenRow}
                                                                />
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="px-8 py-16 text-center">
                                                            <div className="text-lg font-display text-stone-700">По этой семье пока не нашлось записей</div>
                                                            <div className="mt-2 text-sm text-stone-400">Попробуй выбрать другую фамилию или добавить в проект больше страниц.</div>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="rounded-[30px] border border-stone-300 bg-[#fffdf8]/95 shadow-[0_22px_70px_rgba(45,34,20,0.12)] overflow-hidden">
                                                    <div className="border-b border-stone-200 bg-[#fdf8f0] px-6 py-4">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-[#8b0000] font-bold">Возможные связи внутри семьи</div>
                                                        <div className="mt-1 text-sm text-stone-500">
                                                            Это уже найденные гипотезы: возможные связки между рождением, браком и смертью членов выбранной семьи.
                                                        </div>
                                                    </div>
                                                    {selectedFamilyLinks.length > 0 ? (
                                                        <div className="divide-y divide-stone-200">
                                                            {selectedFamilyLinks.map((candidate) => (
                                                                <ParentsLinkCandidateCard
                                                                    key={candidate.id}
                                                                    candidate={candidate}
                                                                    onOpenRow={onOpenRow}
                                                                />
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="px-8 py-16 text-center">
                                                            <div className="text-lg font-display text-stone-700">Для этой семьи гипотезы пока не появились</div>
                                                            <div className="mt-2 text-sm text-stone-400">По мере добавления записей и расширения связей здесь будет видно все возможные совпадения.</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            <div className="rounded-[28px] border border-dashed border-stone-300 bg-white/80 px-8 py-16 text-center shadow-[0_10px_30px_rgba(45,34,20,0.06)]">
                                                <div className="text-lg font-display text-stone-700">Выбери семью слева</div>
                                                <div className="mt-2 text-sm text-stone-400 max-w-2xl mx-auto">
                                                    После выбора ты увидишь все записи этой семьи в проекте и все уже найденные возможные связи между рождениями, браками и смертями её членов.
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsLinksView = ({ project, projectId, parishId = '', onOpenRow }) => {
            const [candidateType, setCandidateType] = useState('');
            const [currentPage, setCurrentPage] = useState(1);
            const [linksData, setLinksData] = useState(null);
            const [linksLoading, setLinksLoading] = useState(true);
            const [linksLoaded, setLinksLoaded] = useState(false);
            const requestSeqRef = useRef(0);
            const cacheRef = useRef(new Map());

            useEffect(() => {
                setCurrentPage(1);
            }, [candidateType]);

            useEffect(() => {
                if (!projectId) return;
                const requestSeq = ++requestSeqRef.current;
                const controller = new AbortController();
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    candidate_type: candidateType,
                    page: String(currentPage),
                    page_size: String(PARENTS_LINK_PAGE_SIZE),
                    v: PARENTS_CHAINS_RESPONSE_VERSION,
                });
                const requestKey = params.toString();

                if (cacheRef.current.has(requestKey)) {
                    setLinksData(cacheRef.current.get(requestKey));
                    setLinksLoaded(true);
                    setLinksLoading(false);
                    return () => controller.abort();
                }

                setLinksLoading(true);
                fetch(`${API_BASE}/parents_links_state?${requestKey}`, { signal: controller.signal })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (requestSeqRef.current !== requestSeq) return;
                        const normalizedData = data && typeof data === 'object' ? data : {};
                        cacheRef.current.set(requestKey, normalizedData);
                        setLinksData(normalizedData);
                        setLinksLoaded(true);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (requestSeqRef.current !== requestSeq) return;
                        showToast('Не удалось загрузить гипотезы связей', 'error');
                        setLinksData({ counts: {}, total: 0, currentPage: 1, totalPages: 1, candidates: [] });
                        setLinksLoaded(true);
                    })
                    .finally(() => {
                        if (requestSeqRef.current === requestSeq) {
                            setLinksLoading(false);
                        }
                    });

                return () => controller.abort();
            }, [projectId, candidateType, currentPage]);

            const counts = linksData?.counts || {};
            const total = Number(linksData?.total || 0);
            const totalPages = Math.max(1, Number(linksData?.totalPages || 1));
            const activePage = Math.max(1, Number(linksData?.currentPage || currentPage || 1));
            const candidates = Array.isArray(linksData?.candidates) ? linksData.candidates : [];
            const activeFilter = PARENTS_LINK_TYPE_FILTERS.find(filter => filter.key === candidateType) || PARENTS_LINK_TYPE_FILTERS[0];

            return (
                <div className="flex-1 min-h-0 overflow-hidden bg-[#e8e4dc] bg-texture">
                    <div className="h-full overflow-auto">
                        <div className="max-w-[1760px] mx-auto px-6 py-6 space-y-6">
                            {!linksLoaded && linksLoading ? (
                                <div className="rounded-[30px] border border-stone-300 bg-white/95 px-8 py-10 text-center shadow-[0_18px_55px_rgba(45,34,20,0.1)]">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Строим гипотезы связей</div>
                                    <div className="mt-3 text-sm text-stone-500">Сопоставляем рождения, браки и смерти между собой.</div>
                                </div>
                            ) : null}

                            <div className="rounded-[30px] border border-stone-300 bg-[#fffdf8]/95 shadow-[0_22px_70px_rgba(45,34,20,0.12)] overflow-hidden">
                                <div className="border-b border-stone-200 bg-white/90 px-6 py-5">
                                    <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
                                        <div className="min-w-0">
                                            <div className="text-[10px] uppercase tracking-[0.24em] text-[#8b0000] font-bold">Служебная страница проекта</div>
                                            <div className="mt-2 font-display text-3xl text-stone-800 leading-tight">Связи между записями</div>
                                            <div className="mt-2 text-sm text-stone-500 max-w-4xl">
                                                Здесь собраны первые генеалогические гипотезы: брак родителей и рождения детей, возможные соответствия между рождением и смертью одного человека, а также рождение и будущий брак того же человека.
                                            </div>
                                            {project?.title && (
                                                <div className="mt-3 text-[11px] uppercase tracking-[0.16em] text-stone-400">
                                                    {project.title}
                                                </div>
                                            )}
                                        </div>
                                        <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 shrink-0">
                                            {PARENTS_LINK_TYPE_FILTERS.map((filter) => (
                                                <div key={filter.key || 'all'} className="rounded-2xl border border-stone-200 bg-[#faf6ee] px-4 py-3 min-w-[150px]">
                                                    <div className="text-[10px] uppercase tracking-[0.16em] text-stone-400 font-bold">{filter.label}</div>
                                                    <div className="mt-1 text-2xl font-black text-stone-800">
                                                        {filter.key ? Number(counts?.[filter.key] || 0) : Object.values(counts || {}).reduce((sum, value) => sum + Number(value || 0), 0)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="border-b border-stone-200 bg-[#fdf8f0] px-6 py-4">
                                    <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
                                        <div className="flex flex-wrap gap-2">
                                            {PARENTS_LINK_TYPE_FILTERS.map((filter) => {
                                                const active = candidateType === filter.key;
                                                return (
                                                    <button
                                                        key={filter.key || 'all'}
                                                        onClick={() => setCandidateType(filter.key)}
                                                        className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${active ? 'bg-[#8b0000] text-white shadow-sm' : 'border border-stone-200 bg-white text-stone-500 hover:text-[#8b0000] hover:border-[#8b0000]'}`}
                                                    >
                                                        {filter.label}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                        <div className="text-[11px] text-stone-500">
                                            {linksLoaded && linksLoading ? 'Обновляем гипотезы...' : `${total} гипотез в выборке «${activeFilter.label}»`}
                                        </div>
                                    </div>
                                </div>

                                <div className="border-b border-stone-200 bg-white/90 px-6 py-4">
                                    <PaginationControls
                                        page={activePage}
                                        totalPages={totalPages}
                                        totalItems={total}
                                        pageSize={PARENTS_LINK_PAGE_SIZE}
                                        label="Гипотезы"
                                        onChange={setCurrentPage}
                                    />
                                </div>

                                {candidates.length > 0 ? (
                                    <div className="divide-y divide-stone-200">
                                        {candidates.map((candidate) => (
                                            <ParentsLinkCandidateCard
                                                key={candidate.id}
                                                candidate={candidate}
                                                onOpenRow={onOpenRow}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <div className="px-8 py-20 text-center">
                                        <div className="text-lg font-display text-stone-700">Пока нет гипотез для этой выборки</div>
                                        <div className="mt-2 text-sm text-stone-400">
                                            Попробуй переключить тип связи или добавить в проект больше страниц с распознанными событиями.
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        const PARENTS_ANCESTRY_STATUS_META = {
            auto: {
                label: 'Уверенная связь',
                description: 'Есть несколько сильных совпадений.',
                badgeClassName: 'border-emerald-200 bg-emerald-50 text-emerald-700',
                meterClassName: 'bg-emerald-600',
            },
            probable: {
                label: 'Вероятная связь',
                description: 'Связь выглядит правдоподобной, но требует проверки.',
                badgeClassName: 'border-amber-200 bg-amber-50 text-amber-700',
                meterClassName: 'bg-amber-500',
            },
            candidate: {
                label: 'Гипотеза',
                description: 'Возможное совпадение, проверьте источник.',
                badgeClassName: 'border-[#d8c9b0] bg-[#fff7e8] text-stone-700',
                meterClassName: 'bg-[#8b0000]',
            },
            disputed: {
                label: 'Спорная связь',
                description: 'Есть признаки связи, но ветвь не входит в основную роспись.',
                badgeClassName: 'border-rose-200 bg-rose-50 text-rose-700',
                meterClassName: 'bg-rose-500',
            },
            incomplete: {
                label: 'Неполная семья',
                description: 'Есть семья, но данных пока недостаточно: нужна ручная проверка.',
                badgeClassName: 'border-sky-200 bg-sky-50 text-sky-700',
                meterClassName: 'bg-sky-500',
            },
            manual_check: {
                label: 'Требует проверки',
                description: 'Связь допустима, но её лучше проверить по источнику вручную.',
                badgeClassName: 'border-sky-200 bg-sky-50 text-sky-700',
                meterClassName: 'bg-sky-500',
            },
            review: {
                label: 'Требует проверки',
                description: 'Связь не скрыта, потому что проблема связана с нехваткой данных, а не с противоречием.',
                badgeClassName: 'border-sky-200 bg-sky-50 text-sky-700',
                meterClassName: 'bg-sky-500',
            },
            repeat_marriage: {
                label: 'Повторный брак',
                description: 'У родителя есть несколько браков, показанных хронологически.',
                badgeClassName: 'border-violet-200 bg-violet-50 text-violet-700',
                meterClassName: 'bg-violet-500',
            },
            sequential_marriage: {
                label: 'Последовательный брак',
                description: 'Браки идут последовательно и не конфликтуют по годам детей.',
                badgeClassName: 'border-violet-200 bg-violet-50 text-violet-700',
                meterClassName: 'bg-violet-500',
            },
            conflict: {
                label: 'Конфликт',
                description: 'Связь противоречит хронологии или жизненному профилю.',
                badgeClassName: 'border-rose-300 bg-rose-100 text-rose-800',
                meterClassName: 'bg-rose-700',
            },
            hidden: {
                label: 'Скрыто',
                description: 'Алгоритм отбросил эту ветвь из основной росписи.',
                badgeClassName: 'border-stone-200 bg-stone-100 text-stone-600',
                meterClassName: 'bg-stone-500',
            },
            unknown: {
                label: 'Недостаточно данных',
                description: 'Признаков недостаточно для уверенного совпадения.',
                badgeClassName: 'border-stone-200 bg-stone-100 text-stone-600',
                meterClassName: 'bg-stone-400',
            },
            sparse: {
                label: 'Редкие данные',
                description: 'Связь построена на слишком бедных данных.',
                badgeClassName: 'border-stone-200 bg-stone-100 text-stone-600',
                meterClassName: 'bg-stone-400',
            },
            manual: {
                label: 'Ручная пометка',
                description: 'Связь отмечена или требует ручной проверки.',
                badgeClassName: 'border-sky-200 bg-sky-50 text-sky-700',
                meterClassName: 'bg-sky-500',
            },
            rejected: {
                label: 'Отклонено',
                description: 'Кандидат отвергнут алгоритмом.',
                badgeClassName: 'border-stone-200 bg-stone-100 text-stone-600',
                meterClassName: 'bg-stone-400',
            },
            weak: {
                label: 'Слабая гипотеза',
                description: 'Недостаточно признаков для уверенного вывода.',
                badgeClassName: 'border-stone-200 bg-stone-100 text-stone-600',
                meterClassName: 'bg-stone-400',
            },
            none: {
                label: 'Не найдено',
                description: 'Подходящая связь пока не найдена.',
                badgeClassName: 'border-stone-200 bg-white text-stone-500',
                meterClassName: 'bg-stone-300',
            },
        };

        const PARENTS_ANCESTRY_EVIDENCE_LABELS = {
            fatherFirstName: 'Имя отца',
            father_first_name: 'Имя отца',
            fatherPatronymic: 'Отчество отца',
            father_patronymic: 'Отчество отца',
            fatherSurname: 'Фамилия отца',
            father_surname: 'Фамилия отца',
            motherFirstName: 'Имя матери',
            mother_first_name: 'Имя матери',
            motherPatronymic: 'Отчество матери',
            mother_patronymic: 'Отчество матери',
            motherSurname: 'Фамилия матери',
            mother_surname: 'Фамилия матери',
            groomFirstName: 'Имя жениха',
            groom_first_name: 'Имя жениха',
            groomPatronymic: 'Отчество жениха',
            groom_patronymic: 'Отчество жениха',
            groomSurname: 'Фамилия жениха',
            groom_surname: 'Фамилия жениха',
            brideFirstName: 'Имя невесты',
            bride_first_name: 'Имя невесты',
            bridePatronymic: 'Отчество невесты',
            bride_patronymic: 'Отчество невесты',
            brideSurname: 'Фамилия невесты',
            bride_surname: 'Фамилия невесты',
            personFirstName: 'Имя персоны',
            person_first_name: 'Имя персоны',
            father_name: 'Имя отца',
            mother_name: 'Имя матери',
            locality: 'Место',
            localityMatch: 'Совпадение места',
            locality_match: 'Совпадение места',
            parishMatch: 'Совпадение прихода',
            parish_match: 'Совпадение прихода',
            surname: 'Фамилия',
            yearGap: 'Интервал между браком и детьми',
            year_gap: 'Интервал между браком и детьми',
            years: 'Годы',
            ageMatch: 'Совпадение возраста',
            age_match: 'Совпадение возраста',
            siblings: 'Серия детей',
            rarity: 'Редкость сочетания',
            age: 'Возраст',
            father_from_patronymic: 'Имя отца из отчества',
            common_name_penalty: 'Частотность имени',
            nameFrequencyPenalty: 'Частотность имени',
            name_frequency_penalty: 'Частотность имени',
            family_match: 'Семейная группа',
            childrenLinkScore: 'Связь через детей',
            children_link_score: 'Связь через детей',
            familyCoherence: 'Цельность семьи по рождениям',
            family_coherence: 'Цельность семьи по рождениям',
            parent_names: 'Имена родителей',
            event_interval: 'Интервал событий',
            male_surname_conflict: 'Несовпадение мужской фамилии',
            female_surname_variation: 'Вариативность женской фамилии',
            weak_identity: 'Слабая идентификация',
            missing_surname: 'Нет фамилии',
            missing_patronymic: 'Нет отчества',
            missing_father_surname: 'Нет фамилии отца',
            missing_mother_surname: 'Нет фамилии матери',
            missing_locality: 'Нет географии',
            missing_children_years: 'Нет годов рождения детей',
            one_child_family: 'Слишком мало детей для уверенной семьи',
            one_child_no_parent_marriage: 'Один ребёнок и не найден брак родителей',
            incomplete_one_child: 'Неполная семья с одним ребёнком',
            manual_check_recommended: 'Рекомендуется ручная проверка',
            mixed_birth_family: 'Смешанная семья по рождениям',
            weak_due_to_missing_data: 'Слабая связь из-за нехватки данных',
            weak_due_to_real_conflict: 'Слабая связь из-за реального конфликта',
            weak_due_to_ocr_or_segmentation: 'Слабая связь из-за OCR или сегментации',
            acceptable_early_multi_child_family: 'Допустимая ранняя многодетная семья',
            needs_manual_check: 'Требуется ручная проверка',
            competitor_too_close: 'Слишком близкий конкурент',
            hidden_weaker_candidate: 'Слабый проигравший кандидат',
            candidate_not_in_main_tree: 'Candidate не входит в основную роспись',
            spouse_compatibility_self_check_fixed: 'Совместимость супруга проверена до объединения полей',
            loose_signature_conflict: 'Конфликт по мягкой сигнатуре личности',
            parent_locality_match: 'Совпадает география родителей',
            godparent_continuity: 'Есть преемственность по восприемникам',
            repeated_godparent_pairs: 'Повторяются пары восприемников',
            surname_spelling_variation: 'Вариант написания фамилии',
            fuzzy_surname_match: 'Нечёткое совпадение фамилии',
            real_surname_conflict: 'Настоящий конфликт фамилии',
            possible_bride_surname_leaked_to_groom: 'В брачной записи фамилия жениха, вероятно, распознана ошибочно: она совпадает с фамилией невесты и не совпадает с устойчивой фамилией семьи по рождениям детей.',
            groom_surname_ignored_as_likely_parse_error: 'Фамилия жениха не использована как жёсткий конфликт из-за вероятной ошибки разбора брака',
            patronymic_only_weak_match: 'Совпадение слишком опирается на патронимику',
            father_only_own_birth_ceiling_candidate: 'Связь с собственным рождением ограничена до candidate: нет независимых подтверждений кроме отца/возраста/места',
            father_only_lineage_ceiling_candidate: 'Поколенная связь ограничена до candidate: нет независимых подтверждений кроме отца/возраста/места',
            common_patronymic_father_only_risk: 'Частое имя-отчество: father-only связь рискованна',
            r_uncle_via_strong_b2bp: 'Семья найдена через сильную связь отец-как-рождение',
            r_uncle_no_marriage: 'Семья найдена без записи о браке через детей',
            r_uncle_one_child_no_marriage_needs_review: 'Однодетная семья без брака через R-Uncle требует проверки',
            father_name_patronymic_match: 'Совпадает имя и отчество / имя отца',
            age_or_year_match: 'Возраст или год согласуется',
            multi_child_family_without_surnames: 'Многодетная ранняя семья без фамилий',
            surname_absence_normal_for_period: 'Отсутствие фамилии нормально для раннего периода',
            surname_absence_late_warning: 'Для позднего периода отсутствие фамилии подозрительно',
            godparent_geo_ignored: 'География восприемников не учитывается для семьи',
            repeat_marriage: 'Повторный брак',
            sequential_marriage: 'Последовательный брак',
            overlapping_marriage_children_years: 'Перекрытие детей разных браков по годам',
            spouse_sequence_conflict: 'Конфликт последовательности браков',
            promoted_to_main: 'Поднято в основную роспись',
            kept_disputed: 'Оставлено вне основной росписи',
            incomplete_manual_check: 'Оставлено как неполная семья / ручная проверка',
            missing_marriage_explained_by_coverage: 'Запись о браке может отсутствовать из-за пробела в источниках',
            child_gap_explained_by_coverage: 'Разрыв между детьми может объясняться пробелом в книгах рождений',
            single_child_family_may_be_due_to_source_gap: 'Однодетная семья может быть следствием пробела в источниках',
            missing_death_explained_by_coverage: 'Запись о смерти может отсутствовать из-за пробела в источниках',
            incomplete_due_to_source_gap: 'Неполнота семьи может объясняться покрытием источников',
            review_due_to_missing_data: 'Показано для проверки из-за нехватки данных',
            review_family_requires_check: 'Связь требует проверки',
            one_child_incomplete_review: 'Однодетная неполная семья показана для проверки',
            incomplete_family_visible_for_manual_check: 'Неполная семья оставлена видимой для ручной проверки',
            one_child_not_hidden_without_conflict: 'Однодетная семья не скрыта: нет жёсткого конфликта',
            possible_merge_error_wide_child_gap: 'Большой разрыв между детьми может быть ошибочным объединением семей',
            possible_second_marriage_wide_child_gap: 'Большой разрыв между детьми может указывать на второго супруга',
            wide_child_gap_needs_review: 'Большой разрыв между детьми требует ручной проверки',
            acceptable_long_child_gap: 'Длинный разрыв между детьми выглядит допустимым',
            surname_cluster_switch_without_bridge: 'Фамильная линия резко сменилась без прямого источника',
            missing_surname_bridge_to_root_family: 'Нет брака или другого источника, который подтверждает переход к другой фамилии',
            questionable_incomplete_merge_needs_review: 'Сомнительное объединение неполной семьи требует проверки',
            unsafe_incomplete_merge_blocked: 'Небезопасное объединение неполной семьи заблокировано',
            merge_missing_locality_match: 'При объединении не совпала локальность',
            merge_missing_surname_match: 'При объединении не совпала фамилия',
            merge_missing_child_overlap: 'При объединении нет пересечения по детям',
            merge_missing_source_overlap: 'При объединении нет общего источника',
            merge_year_gap_conflict: 'Годы детей не подходят для объединения',
            father_not_matched: 'Отец не совпал при проверке объединения',
            mother_not_matched: 'Мать не совпала при проверке объединения',
        };

        const PARENTS_ANCESTRY_REASON_LABELS = {
            fatherFirstName: 'Совпадает имя отца',
            fatherPatronymic: 'Совпадает отчество отца',
            fatherSurname: 'Совпадает фамилия отца',
            motherFirstName: 'Совпадает имя матери',
            motherPatronymic: 'Совпадает отчество матери',
            motherSurname: 'Совпадает фамилия матери',
            groomFirstName: 'Совпадает имя жениха',
            groomPatronymic: 'Совпадает отчество жениха',
            groomSurname: 'Совпадает фамилия жениха',
            brideFirstName: 'Совпадает имя невесты',
            bridePatronymic: 'Совпадает отчество невесты',
            brideSurname: 'Совпадает фамилия невесты',
            localityMatch: 'Совпадает место',
            parishMatch: 'Совпадает приход',
            yearGap: 'Интервал событий выглядит правдоподобно',
            ageMatch: 'Возраст согласуется',
            childrenLinkScore: 'Связь подтверждена через детей',
            familyCoherence: 'Семья по рождениям выглядит цельной',
            male_surname_conflict: 'Несовпадение фамилии мужа и отца детей',
            female_surname_variation: 'Женская фамилия может варьироваться',
            weak_identity: 'Недостаточно данных для уверенной идентичности',
            missing_surname: 'Не хватает фамилии',
            missing_patronymic: 'Не хватает отчества',
            missing_father_surname: 'Не хватает фамилии отца',
            missing_mother_surname: 'Не хватает фамилии матери',
            missing_locality: 'Не хватает географии',
            missing_children_years: 'Не хватает годов рождения детей',
            one_child_family: 'В семье пока только один ребёнок',
            one_child_no_parent_marriage: 'В семье один ребёнок и не найден брак родителей',
            incomplete_one_child: 'Это неполная семья с одним ребёнком',
            manual_check_recommended: 'Семью лучше проверить вручную',
            hard_chronology_conflict: 'Жёсткий хронологический конфликт',
            overlapping_children_years: 'Годы рождения детей пересекаются с другой семьёй',
            mixed_birth_family: 'Семья по рождениям выглядит смешанной',
            weak_due_to_missing_data: 'Семья выглядит слабой из-за нехватки данных',
            weak_due_to_real_conflict: 'Семья конфликтует с другими сильными признаками',
            weak_due_to_ocr_or_segmentation: 'Семья может быть смешана OCR-слоем или сегментацией',
            acceptable_early_multi_child_family: 'Ранняя многодетная семья допустима даже без фамилий',
            needs_manual_check: 'Семья требует ручной проверки',
            spouse_conflict: 'Супруги в источниках конфликтуют',
            competitor_too_close: 'Есть слишком близкий конкурент',
            hidden_weaker_candidate: 'Есть более сильный кандидат на ту же семью',
            candidate_not_in_main_tree: 'Гипотеза не включается в основную роспись',
            same_union_family_dedupe: 'Дубликаты одной брачной связи объединены в одну семейную запись',
            spouse_compatibility_self_check_fixed: 'Совместимость супруга проверена до объединения полей',
            loose_signature_conflict: 'Есть более сильная семья того же вероятного человека',
            parent_locality_match: 'Совпадает география родителей',
            repeated_godparents: 'Повторяются восприемники',
            repeated_godparent_pairs: 'Повторяются одни и те же пары восприемников',
            surname_spelling_variation: 'Фамилия варьируется как орфографический вариант',
            fuzzy_surname_match: 'Фамилия совпадает нечётко',
            real_surname_conflict: 'Фамилия действительно конфликтует',
            possible_bride_surname_leaked_to_groom: 'В брачной записи фамилия жениха, вероятно, распознана ошибочно: она совпадает с фамилией невесты и не совпадает с устойчивой фамилией семьи по рождениям детей.',
            groom_surname_ignored_as_likely_parse_error: 'Фамилия жениха не использована как жёсткий конфликт из-за вероятной ошибки разбора брака',
            patronymic_only_weak_match: 'Совпадение держится почти только на патронимике',
            father_only_own_birth_ceiling_candidate: 'Связь с собственным рождением не поднимается выше candidate без независимых семейных подтверждений',
            father_only_lineage_ceiling_candidate: 'Поколенная связь не поднимается выше candidate без независимых семейных подтверждений',
            common_patronymic_father_only_risk: 'Имя-отчество распространены, поэтому father-only совпадение рискованно',
            r_uncle_via_strong_b2bp: 'Взрослая семья найдена через сильную b2bp-связь детей с отцом',
            r_uncle_no_marriage: 'Запись о браке не найдена; семья показана через детей и требует осторожности',
            r_uncle_one_child_no_marriage_needs_review: 'Однодетная семья без брака не включается уверенно и показана для ручной проверки',
            father_name_patronymic_match: 'Совпадает имя и отчество / имя отца',
            age_or_year_match: 'Возраст или год согласуется',
            multi_child_family_without_surnames: 'Многодетная семья без фамилий типична для раннего периода',
            surname_absence_normal_for_period: 'Для этого периода отсутствие фамилии нормально',
            surname_absence_late_warning: 'Для позднего периода отсутствие фамилии выглядит подозрительно',
            godparent_geo_ignored: 'География восприемников не влияет на географию семьи',
            repeat_marriage: 'Это повторный брак того же родителя',
            sequential_marriage: 'Повторные браки идут последовательно по времени',
            overlapping_marriage_children_years: 'Дети разных браков перекрываются по годам',
            spouse_sequence_conflict: 'Последовательность браков конфликтует по супругам или годам',
            promoted_to_main: 'Кейс поднят в основную роспись по правилу утечки фамилии невесты на жениха',
            kept_disputed: 'Кейс оставлен вне основной росписи',
            incomplete_manual_check: 'Кейс оставлен как неполная семья и требует ручной проверки',
            missing_marriage_explained_by_coverage: 'Окно вероятного брака покрыто неполно, поэтому отсутствие брака не считается сильным минусом',
            child_gap_explained_by_coverage: 'Разрыв между детьми попадает на годы неполного покрытия рождений',
            single_child_family_may_be_due_to_source_gap: 'Вокруг года рождения есть пробелы в книгах рождений или браков',
            missing_death_explained_by_coverage: 'Книги смертей за нужный период покрыты неполно',
            incomplete_due_to_source_gap: 'Неполнота семьи объясняется не только данными, но и покрытием источников',
            review_due_to_missing_data: 'Связь не скрыта, потому что проблема связана с нехваткой данных, а не с жёстким противоречием',
            review_family_requires_check: 'Связь требует проверки перед включением в основную роспись',
            one_child_incomplete_review: 'Однодетная неполная семья показана в review, а не спрятана в debug',
            incomplete_family_visible_for_manual_check: 'Неполная семья оставлена видимой для ручной проверки',
            one_child_not_hidden_without_conflict: 'Однодетная семья не скрыта, потому что жёсткого конфликта не найдено',
            possible_merge_error_wide_child_gap: 'Большой разрыв между детьми может быть следствием ошибочного объединения семей',
            possible_second_marriage_wide_child_gap: 'Большой разрыв между детьми может означать второго супруга или второй брак',
            wide_child_gap_needs_review: 'Разрыв между детьми требует ручной проверки',
            acceptable_long_child_gap: 'Длинный разрыв между детьми принят как допустимый диагностический признак',
            surname_cluster_switch_without_bridge: 'Дети взрослой семьи имеют другой устойчивый фамильный кластер, а прямого источника смены фамилии нет',
            missing_surname_bridge_to_root_family: 'Нет фамильного мостика к родительской семье корня: нужен брак, смерть или другой прямой источник',
            selected_child_adult_family_own_birth_risk: 'Взрослая семья выбранной персоны требует проверки: связь с её рождением рискованна',
            own_birth_candidate_not_enough_for_main: 'Own-birth candidate недостаточен для автоматического включения в основную роспись',
            father_only_adult_family_needs_review: 'Взрослая семья держится на father-only совпадении и требует проверки',
            name_alias_adult_family_needs_review: 'Взрослая семья держится на варианте имени / alias и требует проверки',
            questionable_incomplete_merge_needs_review: 'Неполная one-child семья похожа на дубль, но не хватает локальности, фамилии, общего ребёнка или источника',
            unsafe_incomplete_merge_blocked: 'Объединение неполной one-child семьи заблокировано как небезопасное',
            merge_missing_locality_match: 'Для объединения не найдено совпадение локальности',
            merge_missing_surname_match: 'Для объединения не найдено совпадение фамилии',
            merge_missing_child_overlap: 'Для объединения не найден общий ребёнок',
            merge_missing_source_overlap: 'Для объединения не найден общий источник',
            merge_year_gap_conflict: 'Годы детей конфликтуют с объединением',
            father_not_matched: 'Отец не совпал при проверке объединения',
            mother_not_matched: 'Мать не совпала при проверке объединения',
            missing_age: 'Нет возраста',
            wide_child_gap: 'Большой разрыв между детьми',
            multiple_children: 'Есть несколько детей',
            stable_father_surname: 'Фамилия отца стабильна',
            stable_mother_surname: 'Фамилия матери стабильна',
            stable_locality: 'Локальность стабильна',
            stable_child_surname_cluster: 'У детей единый фамильный кластер',
            godparent_continuity: 'Восприемники подтверждают преемственность',
            mixed_localities: 'У детей слишком разные места',
            locality_variation: 'Локальности семьи расходятся',
            very_wide_child_gap: 'Слишком большой разрыв между детьми',
            wide_children_year_span: 'Слишком широкий диапазон годов детей',
            suspicious_mixed_birth_family: 'Смешанная семья по рождениям',
            name_patronymic_exact: 'Имя и отчество совпадают точно',
            first_name_exact: 'Имя совпадает точно',
            first_name_fuzzy: 'Имя совпадает приблизительно',
            patronymic_exact: 'Отчество совпадает точно',
            patronymic_fuzzy: 'Отчество совпадает приблизительно',
            surnameMatch: 'Фамилия совпадает',
            missing_identity: 'Не хватает данных о персоне',
        };

        const normalizeParentsAncestryKey = (key) => {
            const raw = String(key || '').trim();
            if (!raw) return '';
            if (raw.includes('_')) return raw;
            return raw.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();
        };

        const formatParentsAncestryText = (value) => {
            const raw = String(value || '').trim();
            if (!raw) return '';
            return (
                PARENTS_ANCESTRY_REASON_LABELS[raw]
                || PARENTS_ANCESTRY_REASON_LABELS[normalizeParentsAncestryKey(raw)]
                || raw
            );
        };

        const getParentsAncestryStatusMeta = (status) => {
            const key = String(status || '').trim().toLowerCase();
            return PARENTS_ANCESTRY_STATUS_META[key] || PARENTS_ANCESTRY_STATUS_META.none;
        };

        const formatParentsConfidencePercent = (score) => {
            const numericScore = Number(score);
            if (!Number.isFinite(numericScore) || numericScore <= 0) return '—';
            return `${Math.round(numericScore * 100)}%`;
        };

        const getParentsChildRoleLabel = (child) => {
            if (child?.isSelected) return 'Выбранный ребёнок';
            if (String(child?.sex || '').toUpperCase() === 'MALE') return 'Возможный брат';
            if (String(child?.sex || '').toUpperCase() === 'FEMALE') return 'Возможная сестра';
            return 'Ребёнок этой пары';
        };

        const buildParentsEvidenceRows = (evidence) => {
            if (!evidence || typeof evidence !== 'object') return [];
            return Object.entries(evidence)
                .filter(([, value]) => value !== null && value !== undefined && value !== '' && Number(value) !== 0)
                .map(([key, value]) => ({
                    key,
                    label: PARENTS_ANCESTRY_EVIDENCE_LABELS[key] || PARENTS_ANCESTRY_EVIDENCE_LABELS[normalizeParentsAncestryKey(key)] || key,
                    value: typeof value === 'number' ? `${Math.round(value * 100)}%` : String(value),
                }))
                .sort((left, right) => left.label.localeCompare(right.label, 'ru'));
        };

        const ParentsAncestorSourceButton = ({ source, label, onOpenRow, primary = false }) => {
            if (!source?.itemId || typeof onOpenRow !== 'function') return null;
            return (
                <button
                    onClick={() => onOpenRow({ itemId: source.itemId })}
                    className={`rounded-full border px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] transition-colors ${primary ? 'border-[#8b0000]/20 bg-[#fff5f1] text-[#8b0000] hover:bg-[#ffece3]' : 'border-stone-200 bg-white text-stone-500 hover:border-[#8b0000] hover:text-[#8b0000]'}`}
                >
                    {label}
                </button>
            );
        };

        const ParentsRelationStatusBadge = ({ status, compact = false }) => {
            const meta = getParentsAncestryStatusMeta(status);
            return (
                <span className={`inline-flex items-center gap-1 rounded-full border ${compact ? 'px-2.5' : 'px-3'} py-1 text-[10px] font-bold uppercase tracking-[0.15em] ${meta.badgeClassName}`}>
                    <span className="inline-block h-1.5 w-1.5 rounded-full bg-current opacity-75" />
                    <span>{meta.label}</span>
                </span>
            );
        };

        const ParentsConfidenceMeter = ({ status, score, descriptionOverride = '' }) => {
            const meta = getParentsAncestryStatusMeta(status);
            const numericScore = Number(score);
            const safePercent = Number.isFinite(numericScore) ? Math.max(0, Math.min(100, Math.round(numericScore * 100))) : 0;
            return (
                <div className="rounded-2xl border border-stone-200 bg-[#fcfaf5] p-4">
                    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">Уверенность связи</div>
                            <div className="mt-1 text-lg font-semibold text-stone-800">{formatParentsConfidencePercent(score)}</div>
                            <div className="mt-1 text-sm text-stone-500">{descriptionOverride || meta.description}</div>
                        </div>
                        <ParentsRelationStatusBadge status={status} />
                    </div>
                    <div className="mt-4 h-2 overflow-hidden rounded-full bg-stone-200">
                        <div
                            className={`h-full rounded-full transition-all ${meta.meterClassName}`}
                            style={{ width: `${safePercent}%` }}
                        />
                    </div>
                </div>
            );
        };

        const ParentsEvidenceList = ({ title, items, emptyText, accent = 'stone', initiallyOpen = true }) => {
            const hasItems = Array.isArray(items) && items.length > 0;
            return (
                <details open={initiallyOpen} className="rounded-2xl border border-stone-200 bg-white/90 p-4">
                    <summary className={`cursor-pointer list-none text-[10px] font-bold uppercase tracking-[0.16em] ${accent === 'danger' ? 'text-[#8b0000]' : 'text-stone-500'}`}>
                        {title}
                    </summary>
                    <div className="mt-3">
                        {hasItems ? (
                            <ul className="space-y-2 text-sm text-stone-600">
                                {items.map((item, index) => (
                                    <li key={`${title}-${index}`} className="rounded-xl border border-stone-100 bg-[#fcfaf5] px-3 py-2">
                                        {typeof item === 'string' ? formatParentsAncestryText(item) : (
                                            <div className="flex flex-wrap items-center justify-between gap-2">
                                                <span className="font-medium text-stone-700">{item.label}</span>
                                                <span className="text-stone-500">{item.value}</span>
                                            </div>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div className="rounded-xl border border-dashed border-stone-200 bg-[#fcfaf5] px-3 py-4 text-sm text-stone-400">
                                {emptyText}
                            </div>
                        )}
                    </div>
                </details>
            );
        };

        const ParentsPersonMiniCard = ({
            title,
            personLabel,
            year = null,
            localityLabels = [],
            source = null,
            onOpenRow,
            actionLabel = 'Открыть источник',
            status = '',
            note = '',
            missing = false,
        }) => {
            return (
                <div className="rounded-[24px] border border-stone-200 bg-white/95 p-5 shadow-[0_10px_28px_rgba(45,34,20,0.06)]">
                    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">{title}</div>
                            <div className="mt-2 font-display text-[24px] leading-tight text-stone-800">
                                {personLabel || 'Имя не распознано'}
                            </div>
                            <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-[12px] text-stone-500">
                                {year ? <span>р. {year}</span> : null}
                                {joinLabels(localityLabels) ? <span>{joinLabels(localityLabels)}</span> : null}
                            </div>
                        </div>
                        <div className="flex flex-wrap items-center gap-2 shrink-0">
                            {status ? <ParentsRelationStatusBadge status={status} compact /> : null}
                            <ParentsAncestorSourceButton source={source} label={actionLabel} onOpenRow={onOpenRow} />
                        </div>
                    </div>
                    <div className={`mt-4 rounded-2xl border px-4 py-3 text-sm ${missing ? 'border-dashed border-stone-200 bg-[#fcfaf5] text-stone-500' : 'border-stone-200 bg-[#faf6ee] text-stone-600'}`}>
                        {missing ? 'Рождение пока не найдено. Это не означает, что его нет в приходе — просто алгоритм пока не связал запись.' : note || 'Есть отдельная запись о рождении, которую можно открыть и проверить.'}
                    </div>
                </div>
            );
        };

        const ParentsSiblingCard = ({ child, onOpenRow }) => {
            const selected = Boolean(child?.isSelected);
            return (
                <div className={`rounded-[22px] border p-4 shadow-[0_8px_22px_rgba(45,34,20,0.05)] transition-colors ${selected ? 'border-[#8b0000]/30 bg-[#fff5f1]' : 'border-stone-200 bg-white/95'}`}>
                    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                        <div className="min-w-0">
                            <div className="flex flex-wrap items-center gap-2">
                                <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">{getParentsChildRoleLabel(child)}</div>
                                {selected ? (
                                    <span className="rounded-full border border-[#8b0000]/20 bg-white px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.14em] text-[#8b0000]">
                                        Выбран
                                    </span>
                                ) : null}
                            </div>
                            <div className="mt-2 font-semibold text-stone-800">{child?.label || 'Без имени'}</div>
                            <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-[12px] text-stone-500">
                                {child?.year ? <span>{child.year}</span> : <span>Год не распознан</span>}
                                {joinLabels(child?.localityLabels) ? <span>{joinLabels(child.localityLabels)}</span> : null}
                            </div>
                            {child?.sourceLabel ? (
                                <div className="mt-2 text-[12px] text-stone-400">{child.sourceLabel}</div>
                            ) : null}
                        </div>
                        <div className="shrink-0">
                            <ParentsAncestorSourceButton
                                source={child?.source}
                                label="Открыть запись"
                                onOpenRow={onOpenRow}
                                primary={selected}
                            />
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsFamilySummaryCard = ({ selected, familyContext, onOpenRow }) => {
            const childrenCount = Number(familyContext?.childrenCount || 0);
            return (
                <section className="rounded-[30px] border border-stone-200 bg-white/95 p-6 shadow-[0_18px_50px_rgba(45,34,20,0.08)]">
                    <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Выбранная персона</div>
                            <div className="mt-2 font-display text-[34px] leading-tight text-stone-800">
                                {selected?.label || 'Выберите запись о рождении'}
                            </div>
                            <div className="mt-3 flex flex-wrap gap-x-4 gap-y-2 text-sm text-stone-500">
                                {selected?.year ? <span>Год рождения: {selected.year}</span> : <span>Год рождения не распознан</span>}
                                {joinLabels(selected?.localityLabels) ? <span>{joinLabels(selected.localityLabels)}</span> : null}
                                {selected?.sourceLabel ? <span>{selected.sourceLabel}</span> : null}
                            </div>
                        </div>
                        <div className="flex flex-wrap items-center gap-2 shrink-0">
                            <ParentsAncestorSourceButton source={selected?.source} label="Открыть рождение" onOpenRow={onOpenRow} primary />
                            {childrenCount > 0 ? (
                                <span className="rounded-full border border-[#ead8b0] bg-[#fff7e8] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-stone-700">
                                    Дети пары: {childrenCount}
                                </span>
                            ) : null}
                        </div>
                    </div>

                    <div className="mt-5 grid gap-4 lg:grid-cols-2">
                        <div className="rounded-[22px] border border-stone-200 bg-[#faf6ee] p-4">
                            <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">Отец из записи о рождении</div>
                            <div className="mt-2 text-base font-semibold text-stone-800">{selected?.fatherLabel || familyContext?.fatherLabel || 'Не указан'}</div>
                        </div>
                        <div className="rounded-[22px] border border-stone-200 bg-[#faf6ee] p-4">
                            <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">Мать из записи о рождении</div>
                            <div className="mt-2 text-base font-semibold text-stone-800">{selected?.motherLabel || familyContext?.motherLabel || 'Не указана'}</div>
                        </div>
                    </div>
                </section>
            );
        };

        const ParentsParentsMarriageCard = ({ marriage, onOpenRow }) => {
            const evidenceRows = buildParentsEvidenceRows(marriage?.evidence);
            if (!marriage) {
                return (
                    <section className="rounded-[30px] border border-stone-200 bg-white/95 p-6 shadow-[0_18px_50px_rgba(45,34,20,0.08)]">
                        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Брак родителей</div>
                        <div className="mt-3 rounded-[24px] border border-dashed border-stone-300 bg-[#fcfaf5] px-5 py-8">
                            <div className="font-display text-[24px] text-stone-700">Брак пока не найден</div>
                            <div className="mt-2 text-sm text-stone-500">
                                Это не означает, что брака не было. Просто в текущем наборе записей связь между рождением ребёнка и браком родителей ещё не подтвердилась.
                            </div>
                        </div>
                    </section>
                );
            }
            return (
                <section className="rounded-[30px] border border-stone-200 bg-white/95 p-6 shadow-[0_18px_50px_rgba(45,34,20,0.08)]">
                    <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Брак родителей</div>
                            <div className="mt-2 font-display text-[30px] leading-tight text-stone-800">
                                {marriage?.displayLabel || 'Предполагаемый брак'}
                            </div>
                            <div className="mt-3 flex flex-wrap gap-x-4 gap-y-2 text-sm text-stone-500">
                                {marriage?.year ? <span>{marriage.year}</span> : <span>Год не распознан</span>}
                                {joinLabels(marriage?.localityLabels) ? <span>{joinLabels(marriage.localityLabels)}</span> : null}
                                {marriage?.sourceLabel ? <span>{marriage.sourceLabel}</span> : null}
                            </div>
                        </div>
                        <div className="flex flex-wrap items-center gap-2 shrink-0">
                            <ParentsRelationStatusBadge status={marriage?.status} />
                            <ParentsAncestorSourceButton source={marriage?.source} label="Открыть брак" onOpenRow={onOpenRow} primary />
                        </div>
                    </div>

                    <div className="mt-5 grid gap-4 xl:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]">
                        <ParentsConfidenceMeter status={marriage?.status} score={marriage?.score} />
                        <div className="rounded-2xl border border-stone-200 bg-[#fcfaf5] p-4">
                            <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">Дополнительные признаки</div>
                            <div className="mt-3 grid gap-3 sm:grid-cols-2">
                                <div className="rounded-xl border border-stone-200 bg-white px-3 py-3">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.14em] text-stone-400">Сильных совпадений</div>
                                    <div className="mt-1 text-lg font-semibold text-stone-800">{Number(marriage?.strongEvidenceCount || 0)}</div>
                                </div>
                                <div className="rounded-xl border border-stone-200 bg-white px-3 py-3">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.14em] text-stone-400">Отрыв от следующего кандидата</div>
                                    <div className="mt-1 text-lg font-semibold text-stone-800">{formatParentsConfidencePercent(marriage?.secondBestGap)}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-5 grid gap-4 xl:grid-cols-3">
                        <ParentsEvidenceList
                            title="Почему связь найдена"
                            items={Array.isArray(marriage?.reasons) ? marriage.reasons : []}
                            emptyText="Алгоритм не вернул явные пояснения для этой связи."
                        />
                        <ParentsEvidenceList
                            title="Подтверждающие признаки"
                            items={evidenceRows}
                            emptyText="Подтверждающие признаки пока не собраны."
                        />
                        <ParentsEvidenceList
                            title="Что требует проверки"
                            items={Array.isArray(marriage?.warnings) ? marriage.warnings : []}
                            emptyText="Явных предупреждений для этой связи нет."
                            accent="danger"
                        />
                    </div>
                </section>
            );
        };

        const ParentsAncestryCompactTree = ({ node, onOpenRow, depth = 0 }) => {
            if (!node) {
                return (
                    <div className="rounded-[24px] border border-dashed border-stone-300 bg-[#fcfaf5] px-5 py-8 text-sm text-stone-500">
                        Вертикальная цепочка предков пока не строится для этой записи.
                    </div>
                );
            }
            const hasParents = Boolean(node?.father || node?.mother);
            return (
                <div className="min-w-0">
                    <div className={`rounded-[24px] border bg-white/95 p-4 shadow-[0_10px_28px_rgba(45,34,20,0.06)] ${depth === 0 ? 'border-[#8b0000]/25' : 'border-stone-200'}`}>
                        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                            <div className="min-w-0">
                                <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">{node?.roleLabel || 'Предок'}</div>
                                <div className="mt-1 font-semibold text-stone-800">{node?.personLabel || 'Без имени'}</div>
                                <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-[12px] text-stone-500">
                                    {node?.birthYear ? <span>р. {node.birthYear}</span> : node?.missingBirth ? <span>рождение пока не найдено</span> : null}
                                    {joinLabels(node?.birthLocalityLabels) ? <span>{joinLabels(node.birthLocalityLabels)}</span> : null}
                                </div>
                            </div>
                            <div className="flex flex-wrap items-center gap-2 shrink-0">
                                {node?.linkCandidate?.status ? <ParentsRelationStatusBadge status={node.linkCandidate.status} compact /> : null}
                                <ParentsAncestorSourceButton
                                    source={node?.source}
                                    label={depth === 0 ? 'Открыть запись' : 'Открыть источник'}
                                    onOpenRow={onOpenRow}
                                    primary={depth === 0}
                                />
                            </div>
                        </div>
                    </div>

                    {hasParents ? (
                        <div className="relative mt-4 pl-4 sm:pl-6">
                            <div className="absolute left-0 top-0 bottom-0 w-px bg-stone-300" />
                            <div className="grid gap-4 xl:grid-cols-2">
                                {node?.father ? (
                                    <div className="relative">
                                        <div className="absolute -left-4 sm:-left-6 top-7 h-px w-4 sm:w-6 bg-stone-300" />
                                        <ParentsAncestryCompactTree node={node.father} onOpenRow={onOpenRow} depth={depth + 1} />
                                    </div>
                                ) : null}
                                {node?.mother ? (
                                    <div className="relative">
                                        <div className="absolute -left-4 sm:-left-6 top-7 h-px w-4 sm:w-6 bg-stone-300" />
                                        <ParentsAncestryCompactTree node={node.mother} onOpenRow={onOpenRow} depth={depth + 1} />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                </div>
            );
        };

        const DEFAULT_CLASSIC_TREE_LAYOUT = {
            nodeWidth: 218,
            nodeHeight: 162,
            spouseGap: 112,
            siblingGap: 38,
            familyGap: 78,
            generationGap: 118,
            margin: 68,
        };

        const DEFAULT_CLASSIC_TREE_VIEW_OPTIONS = {
            treeType: 'all',
            relationClass: 'family',
            orientation: 'top',
            density: 'normal',
            cardDetail: 'full',
            multiMarriageDisplay: 'focus',
            showSources: true,
            showConfidence: true,
            showLifeProfile: true,
            showHypotheses: true,
            showConflicts: true,
            showSpiritualLinks: false,
            optimizeSpouses: true,
            optimizeBranches: true,
        };

        const TREE_TYPES = {
            direct: 'Прямая линия',
            directPlus: 'Прямая линия + семьи',
            family: 'Семья',
            all: 'Все связи',
            proof: 'Проверка гипотез',
        };

        const RELATION_CLASSES = {
            direct: 'Прямые предки',
            blood: 'Кровные',
            family: 'Семейные',
            all: 'Все',
            proof: 'Проверочные',
        };

        const TREE_ORIENTATIONS = {
            top: 'Предки сверху',
            bottom: 'Потомки сверху',
            left: 'Предки слева',
            right: 'Предки справа',
        };

        const TREE_DENSITIES = {
            compact: 'Компактно',
            normal: 'Обычно',
            wide: 'Просторно',
            print: 'Печать',
        };

        const CARD_DETAIL_LEVELS = {
            short: 'Кратко',
            medium: 'Средне',
            full: 'Подробно',
        };

        const MULTI_MARRIAGE_DISPLAY_OPTIONS = {
            focus: 'Фокус',
            compact: 'Компактно',
            expanded: 'Все',
        };

        const PAIR_STATUS = {
            marriage: 'Брак найден',
            children: 'Есть дети, брак не найден',
            beforeMarriage: 'Дети до брака',
            noMarriage: 'Брак не найден',
            maleOnly: 'Известен только отец',
            femaleOnly: 'Известна только мать',
            unknown: 'Статус не определён',
        };

        const RELATION_KIND = {
            blood: 'blood',
            marriage: 'marriage',
            probable: 'probable',
            hypothesis: 'hypothesis',
            conflict: 'conflict',
            spiritual: 'spiritual',
            witness: 'witness',
        };

        const CLASSIC_TREE_DENSITY_LAYOUTS = {
            compact: { nodeWidth: 190, nodeHeight: 88, spouseGap: 18, siblingGap: 22, familyGap: 70, generationGap: 95, margin: 32, descendantMarriageGap: 32, descendantChildGap: 48, marriageRailGap: 40, marriageSlotGap: 28, familyGroupPadding: 14, maxMarriageSlotWidth: 620, maxVisibleChildrenInCompactMarriage: 2, maxVisibleChildrenInFocusSideMarriage: 2 },
            normal: { nodeWidth: 230, nodeHeight: 108, spouseGap: 28, siblingGap: 40, familyGap: 100, generationGap: 130, margin: 48, descendantMarriageGap: 44, descendantChildGap: 66, marriageRailGap: 56, marriageSlotGap: 42, familyGroupPadding: 18, maxMarriageSlotWidth: 780, maxVisibleChildrenInCompactMarriage: 3, maxVisibleChildrenInFocusSideMarriage: 3 },
            wide: { nodeWidth: 260, nodeHeight: 126, spouseGap: 36, siblingGap: 58, familyGap: 130, generationGap: 160, margin: 64, descendantMarriageGap: 52, descendantChildGap: 78, marriageRailGap: 68, marriageSlotGap: 52, familyGroupPadding: 22, maxMarriageSlotWidth: 920, maxVisibleChildrenInCompactMarriage: 4, maxVisibleChildrenInFocusSideMarriage: 4 },
            print: { nodeWidth: 250, nodeHeight: 120, spouseGap: 34, siblingGap: 52, familyGap: 120, generationGap: 155, margin: 80, descendantMarriageGap: 56, descendantChildGap: 82, marriageRailGap: 72, marriageSlotGap: 56, familyGroupPadding: 22, maxMarriageSlotWidth: 960, maxVisibleChildrenInCompactMarriage: 4, maxVisibleChildrenInFocusSideMarriage: 4 },
        };

        const CLASSIC_TREE_PRINT_NOTE = 'Статусы связей являются алгоритмическими гипотезами и требуют проверки по источникам.';

        const makeClassicTreePolyline = (points) => (
            Array.isArray(points)
                ? points
                    .filter((point) => Array.isArray(point) && point.length >= 2)
                    .map(([x, y]) => `${Number(x || 0).toFixed(2)},${Number(y || 0).toFixed(2)}`)
                    .join(' ')
                : ''
        );

        const makeClassicTreePath = (points) => {
            const polyline = makeClassicTreePolyline(points);
            if (!polyline) return '';
            const segments = polyline.split(' ');
            if (!segments.length) return '';
            return `M ${segments.join(' L ')}`;
        };

        const formatClassicTreeYear = (year, isMissing = false) => {
            const numericYear = Number(year);
            if (Number.isFinite(numericYear) && numericYear > 0) return `р. ${numericYear}`;
            return isMissing ? 'Рождение не найдено' : '';
        };

        const formatClassicTreeDeath = (deathYear, deathAge = '', deathYearLabel = '') => {
            const yearText = String(deathYearLabel || '').trim();
            const ageText = String(deathAge || '').trim();
            const resolvedYear = yearText || (Number.isFinite(Number(deathYear)) && Number(deathYear) > 0 ? String(Number(deathYear)) : '');
            if (!resolvedYear && !ageText) return '';
            if (resolvedYear && ageText) return `ум. ${resolvedYear} · ${ageText}`;
            if (resolvedYear) return `ум. ${resolvedYear}`;
            return `ум. ${ageText}`;
        };

        const formatClassicTreeMarriageLabel = (marriage) => {
            const year = Number(marriage?.year || marriage?.marriageYear || 0);
            if (Number.isFinite(year) && year > 0) return `Брак · ${year}`;
            return 'Брак';
        };

        const formatClassicTreeRomanOrdinal = (value) => {
            const num = Number(value);
            if (!Number.isFinite(num) || num <= 0) return '';
            const numerals = [
                ['M', 1000], ['CM', 900], ['D', 500], ['CD', 400],
                ['C', 100], ['XC', 90], ['L', 50], ['XL', 40],
                ['X', 10], ['IX', 9], ['V', 5], ['IV', 4], ['I', 1],
            ];
            let rest = Math.floor(num);
            let result = '';
            numerals.forEach(([symbol, threshold]) => {
                while (rest >= threshold) {
                    result += symbol;
                    rest -= threshold;
                }
            });
            return result;
        };

        const formatClassicTreeMarriageOrdinalLabel = (family) => {
            const ordinal = Number(family?.marriageOrdinal || 0);
            if (!Number.isFinite(ordinal) || ordinal <= 0) return '';
            const roman = formatClassicTreeRomanOrdinal(ordinal);
            return roman ? `${roman} брак` : `${ordinal}-й брак`;
        };

        const getClassicTreeSourceSnippet = (source, sourceLabel = '') => {
            const explicit = String(sourceLabel || source?.label || '').trim();
            if (explicit) return explicit;
            const cipher = String(source?.cipher || source?.sourceLabel || source?.recordLabel || '').trim();
            const page = String(source?.pageLabel || source?.page || '').trim();
            if (cipher && page) return `${cipher} · стр. ${page}`;
            return cipher || page || '';
        };

        const safeClassicTreeId = (prefix, value) => {
            const raw = `${prefix}:${String(value || '').trim() || 'unknown'}`;
            return raw.replace(/[^\wа-яА-ЯёЁ:-]+/g, '_');
        };

        const normalizeClassicTreeViewOptions = (value) => ({
            ...DEFAULT_CLASSIC_TREE_VIEW_OPTIONS,
            ...(value && typeof value === 'object' ? value : {}),
        });

        const getClassicTreeDensityLayout = (density = 'normal') => {
            const key = String(density || 'normal').trim();
            return CLASSIC_TREE_DENSITY_LAYOUTS[key] || CLASSIC_TREE_DENSITY_LAYOUTS.normal;
        };

        const getClassicTreeLayoutOptions = (viewOptions = {}) => ({
            ...(() => {
                const base = {
                    ...DEFAULT_CLASSIC_TREE_LAYOUT,
                    ...getClassicTreeDensityLayout(viewOptions?.density),
                };
                const detailLevel = String(viewOptions?.cardDetail || 'medium').trim();
                if (detailLevel === 'full') {
                    return {
                        ...base,
                        nodeWidth: base.nodeWidth + 6,
                        nodeHeight: base.nodeHeight + 64,
                    };
                }
                if (detailLevel === 'short') {
                    return {
                        ...base,
                        nodeHeight: Math.max(76, base.nodeHeight - 18),
                    };
                }
                return base;
            })(),
        });

        const getClassicTreePairStatusKey = (family, persons = {}, familyCountByParentId = {}) => {
            if (!family) return 'unknown';
            const father = family?.fatherId ? persons[family.fatherId] : null;
            const mother = family?.motherId ? persons[family.motherId] : null;
            const hasFather = Boolean(father);
            const hasMother = Boolean(mother);
            const marriageYear = Number(family?.marriage?.year || family?.marriage?.marriageYear || 0);
            const childYears = (Array.isArray(family?.childIds) ? family.childIds : [])
                .map((childId) => Number(persons?.[childId]?.birthYear || 0))
                .filter((year) => Number.isFinite(year) && year > 0);
            const firstChildYear = childYears.length ? Math.min(...childYears) : 0;

            if (!hasFather && hasMother) return 'femaleOnly';
            if (hasFather && !hasMother) return 'maleOnly';
            if (marriageYear > 0 && firstChildYear > 0 && firstChildYear < (marriageYear - 1)) return 'beforeMarriage';
            if (marriageYear > 0) return 'marriage';
            if (childYears.length > 0) return 'children';
            if (hasFather || hasMother) return 'noMarriage';
            return 'unknown';
        };

        const getClassicTreeRelationKind = ({
            status = '',
            pairStatus = '',
            isMarriage = false,
            hasConflicts = false,
            hasWarnings = false,
            isSpiritual = false,
        } = {}) => {
            if (hasConflicts) return RELATION_KIND.conflict;
            if (isSpiritual) return RELATION_KIND.spiritual;
            if (isMarriage) return RELATION_KIND.marriage;
            const normalizedStatus = String(status || '').trim().toLowerCase();
            if (normalizedStatus === 'conflict') return RELATION_KIND.conflict;
            if (normalizedStatus === 'candidate' || normalizedStatus === 'weak') return RELATION_KIND.hypothesis;
            if (normalizedStatus === 'probable' || hasWarnings) return RELATION_KIND.probable;
            if (pairStatus === 'children' || pairStatus === 'noMarriage' || pairStatus === 'beforeMarriage') return RELATION_KIND.hypothesis;
            return RELATION_KIND.blood;
        };

        const getClassicTreePairStatusMeta = (pairStatus = '') => {
            const key = String(pairStatus || '').trim();
            switch (key) {
                case 'marriage':
                    return { label: PAIR_STATUS.marriage, tone: 'solid', badgeClassName: 'border-emerald-200 bg-emerald-50 text-emerald-700' };
                case 'children':
                    return { label: PAIR_STATUS.children, tone: 'dashed', badgeClassName: 'border-amber-200 bg-amber-50 text-amber-700' };
                case 'beforeMarriage':
                    return { label: PAIR_STATUS.beforeMarriage, tone: 'warning', badgeClassName: 'border-rose-200 bg-rose-50 text-rose-700' };
                case 'maleOnly':
                    return { label: PAIR_STATUS.maleOnly, tone: 'ghost', badgeClassName: 'border-sky-200 bg-sky-50 text-sky-700' };
                case 'femaleOnly':
                    return { label: PAIR_STATUS.femaleOnly, tone: 'ghost', badgeClassName: 'border-fuchsia-200 bg-fuchsia-50 text-fuchsia-700' };
                case 'noMarriage':
                    return { label: PAIR_STATUS.noMarriage, tone: 'dashed', badgeClassName: 'border-stone-200 bg-stone-50 text-stone-600' };
                default:
                    return { label: PAIR_STATUS.unknown, tone: 'default', badgeClassName: 'border-stone-200 bg-stone-50 text-stone-500' };
            }
        };

        const getClassicTreeStatusTone = (status, { isFocus = false, isMissing = false } = {}) => {
            if (isFocus) {
                return {
                    borderColor: '#b87333',
                    background: '#fffaf2',
                    shadow: '0 0 0 3px rgba(184,115,51,0.13), 0 10px 24px rgba(56,41,24,0.11)',
                    badgeBackground: '#b87333',
                    badgeColor: '#fffaf4',
                    dotColor: '#b87333',
                    opacity: 1,
                    borderStyle: 'solid',
                };
            }
            if (isMissing) {
                return {
                    borderColor: 'rgba(150, 135, 118, 0.48)',
                    background: '#faf7f1',
                    shadow: '0 8px 18px rgba(45,34,20,0.035)',
                    badgeBackground: '#f0ebe2',
                    badgeColor: '#74695f',
                    dotColor: '#9f9488',
                    opacity: 0.8,
                    borderStyle: 'dashed',
                };
            }
            const normalizedStatus = String(status || '').trim().toLowerCase();
            if (normalizedStatus === 'auto') {
                return {
                    borderColor: 'rgba(113, 130, 102, 0.38)',
                    background: '#fffdf8',
                    shadow: '0 9px 20px rgba(45,34,20,0.045)',
                    badgeBackground: '#e8f4eb',
                    badgeColor: '#56705b',
                    dotColor: '#56705b',
                    opacity: 1,
                    borderStyle: 'solid',
                };
            }
            if (normalizedStatus === 'probable') {
                return {
                    borderColor: 'rgba(184, 115, 51, 0.34)',
                    background: '#fffbf3',
                    shadow: '0 9px 20px rgba(45,34,20,0.045)',
                    badgeBackground: '#fff0d7',
                    badgeColor: '#915c24',
                    dotColor: '#b87333',
                    opacity: 1,
                    borderStyle: 'solid',
                };
            }
            if (normalizedStatus === 'candidate' || normalizedStatus === 'weak') {
                return {
                    borderColor: 'rgba(154, 139, 122, 0.26)',
                    background: '#fffdf9',
                    shadow: '0 9px 20px rgba(45,34,20,0.045)',
                    badgeBackground: '#f3eee7',
                    badgeColor: '#6f655b',
                    dotColor: '#8a7d70',
                    opacity: 1,
                    borderStyle: 'dashed',
                };
            }
            return {
                borderColor: 'rgba(141, 126, 108, 0.24)',
                background: '#fffdf8',
                shadow: '0 9px 20px rgba(45,34,20,0.045)',
                badgeBackground: '#f5f1eb',
                badgeColor: '#73675b',
                dotColor: '#887b6f',
                opacity: 1,
                borderStyle: 'solid',
            };
        };

        const getClassicTreeSexTone = (sex = '') => {
            const normalizedSex = String(sex || '').trim().toUpperCase();
            if (normalizedSex === 'MALE') {
                return {
                    borderOverlay: 'rgba(106, 127, 145, 0.2)',
                    badgeBackground: '#eef4f7',
                    badgeColor: '#5d7282',
                    glyphColor: '#5d7282',
                };
            }
            if (normalizedSex === 'FEMALE') {
                return {
                    borderOverlay: 'rgba(157, 116, 116, 0.2)',
                    badgeBackground: '#faf0f0',
                    badgeColor: '#8d6666',
                    glyphColor: '#8d6666',
                };
            }
            return {
                borderOverlay: 'rgba(138, 125, 112, 0.16)',
                badgeBackground: '#f5f1eb',
                badgeColor: '#73675b',
                glyphColor: '#73675b',
            };
        };

        const getClassicTreeLineColor = (line, options = {}) => {
            const relationKind = String(line?.relationKind || '').trim();
            const pairStatus = String(line?.pairStatus || '').trim();
            if (line?.kind === 'marriageRail') return '#a89272';
            if (relationKind === RELATION_KIND.conflict) return '#b54d4d';
            if (relationKind === RELATION_KIND.hypothesis) return '#b49772';
            if (relationKind === RELATION_KIND.probable) return '#99816c';
            if (relationKind === RELATION_KIND.spiritual || relationKind === RELATION_KIND.witness) return '#a7a196';
            if (relationKind === RELATION_KIND.marriage) {
                if (pairStatus === 'beforeMarriage') return '#b15f5f';
                if (pairStatus === 'children' || pairStatus === 'noMarriage') return '#b79a6e';
                return '#8a6a40';
            }
            const fromSex = String(line?.fromSex || '').trim().toUpperCase();
            if (fromSex === 'MALE') return '#6f8191';
            if (fromSex === 'FEMALE') return '#8c6e76';
            return options?.density === 'print' ? '#8a7f73' : '#9b8e7d';
        };

        const getClassicTreeLineWidth = (line, options = {}) => {
            const relationKind = String(line?.relationKind || '').trim();
            const density = String(options?.density || 'normal').trim();
            if (line?.kind === 'marriageRail') return density === 'compact' ? 0.9 : 1.0;
            if (relationKind === RELATION_KIND.marriage) return density === 'print' ? 1.35 : 1.1;
            if (relationKind === RELATION_KIND.conflict) return 1.25;
            if (line?.kind === 'child_bar') return density === 'compact' ? 1.4 : 1.8;
            return density === 'compact' ? 0.95 : 1.05;
        };

        const getClassicTreeLineOpacity = (line, options = {}) => {
            const relationKind = String(line?.relationKind || '').trim();
            if (line?.kind === 'marriageRail') return 0.64;
            if (relationKind === RELATION_KIND.conflict) return 0.9;
            if (relationKind === RELATION_KIND.hypothesis) return 0.72;
            if (relationKind === RELATION_KIND.probable) return 0.78;
            if (relationKind === RELATION_KIND.spiritual || relationKind === RELATION_KIND.witness) {
                return options?.showSpiritualLinks ? 0.52 : 0.18;
            }
            if (relationKind === RELATION_KIND.marriage) return 0.96;
            if (line?.kind === 'child_bar') return 0.85;
            return 0.72;
        };

        const getClassicTreeLineDashArray = (line, options = {}) => {
            const relationKind = String(line?.relationKind || '').trim();
            const pairStatus = String(line?.pairStatus || '').trim();
            if (relationKind === RELATION_KIND.conflict) return '5 4';
            if (relationKind === RELATION_KIND.hypothesis) return '6 5';
            if (relationKind === RELATION_KIND.spiritual || relationKind === RELATION_KIND.witness) return options?.showSpiritualLinks ? '3 5' : '4 7';
            if (pairStatus === 'children' || pairStatus === 'noMarriage') return '5 5';
            if (pairStatus === 'beforeMarriage') return '4 4';
            return '';
        };

        const makeClassicTreePersonFromAncestorNode = (node, fallbackId, roleLabel = '') => {
            if (!node) return null;
            return {
                id: node?.birthRecordId || node?.id || fallbackId,
                label: node?.personLabel || 'Неизвестно',
                sex: String(node?.personSex || '').trim().toUpperCase(),
                roleLabel: roleLabel || node?.roleLabel || '',
                birthYear: node?.birthYear ?? null,
                birthPlace: joinLabels(node?.birthLocalityLabels),
                death: node?.death || null,
                deathLabel: node?.deathLabel || '',
                deathYear: node?.deathYear ?? null,
                deathYearLabel: node?.deathYearLabel || '',
                deathAge: node?.deathAge || '',
                source: node?.source || null,
                sourceLabel: getClassicTreeSourceSnippet(node?.source, node?.sourceLabel),
                isMissing: Boolean(node?.missingBirth),
                kind: node?.missingBirth ? 'ghost' : 'person',
                confidenceStatus: String(node?.adjustedStatus || node?.linkCandidate?.status || node?.parentsMarriage?.status || '').trim(),
                identityProfile: node?.identityProfile || null,
                identityProfileStatus: String(node?.identityProfileStatus || node?.identityProfile?.status || '').trim(),
                identityProfileWarnings: Array.isArray(node?.identityProfileWarnings) ? node.identityProfileWarnings : [],
                identityProfileConflicts: Array.isArray(node?.identityProfileConflicts) ? node.identityProfileConflicts : [],
                adjustedStatus: String(node?.adjustedStatus || '').trim(),
            };
        };

        const buildParentsClassicTreeModel = ({ selected, familyContext, tree, options = {} }) => {
            const viewOptions = normalizeClassicTreeViewOptions(options);
            const densityLayout = getClassicTreeDensityLayout(viewOptions?.density || 'normal');
            const sourceChildren = Array.isArray(familyContext?.children) ? familyContext.children : [];
            if (!selected && !tree && sourceChildren.length === 0) return null;

            const persons = {};
            const families = [];
            const parentFamilyByChildId = {};
            const descendantFamilyIdsByParentId = {};
            const familySeen = new Set();
            const visitedAncestorPeople = new Set();

            const upsertPerson = (payload) => {
                if (!payload?.id) return null;
                const existing = persons[payload.id] || {};
                const next = {
                    ...existing,
                    ...payload,
                    label: payload.label || existing.label || 'Неизвестно',
                    sex: String(payload.sex || existing.sex || '').trim().toUpperCase(),
                    roleLabel: payload.roleLabel || existing.roleLabel || '',
                    familyRoleLabel: payload.familyRoleLabel || existing.familyRoleLabel || payload.roleLabel || '',
                    birthYear: payload.birthYear !== undefined && payload.birthYear !== null ? payload.birthYear : (existing.birthYear ?? null),
                    birthPlace: payload.birthPlace || existing.birthPlace || '',
                    death: payload.death || existing.death || null,
                    deathLabel: payload.deathLabel || existing.deathLabel || '',
                    deathYear: payload.deathYear !== undefined && payload.deathYear !== null ? payload.deathYear : (existing.deathYear ?? null),
                    deathYearLabel: payload.deathYearLabel || existing.deathYearLabel || '',
                    deathAge: payload.deathAge || existing.deathAge || '',
                    source: payload.source || existing.source || null,
                    sourceLabel: payload.sourceLabel || existing.sourceLabel || getClassicTreeSourceSnippet(payload.source || existing.source, payload.sourceLabel || existing.sourceLabel),
                    kind: payload.kind || existing.kind || 'person',
                    isFocus: Boolean(payload.isFocus || existing.isFocus),
                    isMissing: Boolean(payload.isMissing || existing.isMissing),
                    confidenceStatus: payload.confidenceStatus || existing.confidenceStatus || '',
                    identityProfile: payload.identityProfile || existing.identityProfile || null,
                    identityProfileStatus: payload.identityProfileStatus || existing.identityProfileStatus || '',
                    identityProfileWarnings: Array.isArray(payload.identityProfileWarnings) ? payload.identityProfileWarnings : (Array.isArray(existing.identityProfileWarnings) ? existing.identityProfileWarnings : []),
                    identityProfileConflicts: Array.isArray(payload.identityProfileConflicts) ? payload.identityProfileConflicts : (Array.isArray(existing.identityProfileConflicts) ? existing.identityProfileConflicts : []),
                    adjustedStatus: payload.adjustedStatus || existing.adjustedStatus || '',
                };
                persons[payload.id] = next;
                return next;
            };

            const makeMissingPerson = (label, roleLabel, idSeed, sex = '', localityLabels = []) => upsertPerson({
                id: safeClassicTreeId(idSeed, label || roleLabel || 'missing'),
                label: label || 'Неизвестно',
                sex,
                roleLabel,
                familyRoleLabel: roleLabel,
                birthYear: null,
                birthPlace: joinLabels(localityLabels),
                death: null,
                deathLabel: '',
                deathYear: null,
                deathYearLabel: '',
                deathAge: '',
                source: null,
                sourceLabel: '',
                kind: 'ghost',
                isMissing: true,
                confidenceStatus: '',
            });

            const upsertFromNode = (node, fallbackId, roleLabel = '') => {
                const person = makeClassicTreePersonFromAncestorNode(node, fallbackId, roleLabel);
                if (!person) return null;
                return upsertPerson({
                    ...person,
                    familyRoleLabel: roleLabel || person.roleLabel || '',
                });
            };

            const focusId = selected?.birthRecordId || tree?.birthRecordId || safeClassicTreeId('focus', selected?.label || 'selected');
            const focusPerson = upsertPerson({
                id: focusId,
                label: selected?.label || tree?.personLabel || 'Выбранная персона',
                sex: String(selected?.sex || tree?.personSex || '').trim().toUpperCase(),
                roleLabel: 'Выбранная персона',
                familyRoleLabel: 'Выбранная персона',
                birthYear: selected?.year ?? tree?.birthYear ?? null,
                birthPlace: joinLabels(selected?.localityLabels || tree?.birthLocalityLabels || []),
                death: selected?.death || tree?.death || null,
                deathLabel: selected?.deathLabel || tree?.deathLabel || '',
                deathYear: selected?.deathYear ?? tree?.deathYear ?? null,
                deathYearLabel: selected?.deathYearLabel || tree?.deathYearLabel || '',
                deathAge: selected?.deathAge || tree?.deathAge || '',
                source: selected?.source || tree?.source || null,
                sourceLabel: getClassicTreeSourceSnippet(selected?.source || tree?.source, selected?.sourceLabel || tree?.sourceLabel),
                isFocus: true,
                isMissing: false,
                confidenceStatus: String(selected?.adjustedStatus || tree?.adjustedStatus || '').trim(),
                identityProfile: selected?.identityProfile || tree?.identityProfile || null,
                identityProfileStatus: String(selected?.identityProfileStatus || tree?.identityProfileStatus || '').trim(),
                identityProfileWarnings: Array.isArray(selected?.identityProfileWarnings) ? selected.identityProfileWarnings : (Array.isArray(tree?.identityProfileWarnings) ? tree.identityProfileWarnings : []),
                identityProfileConflicts: Array.isArray(selected?.identityProfileConflicts) ? selected.identityProfileConflicts : (Array.isArray(tree?.identityProfileConflicts) ? tree.identityProfileConflicts : []),
            });

            const childrenEntries = sourceChildren.length > 0
                ? sourceChildren
                : [{
                    birthRecordId: focusId,
                    eventId: focusId,
                    label: focusPerson?.label || selected?.label || 'Выбранная персона',
                    year: focusPerson?.birthYear ?? selected?.year ?? null,
                    sex: focusPerson?.sex || selected?.sex || '',
                    localityLabels: selected?.localityLabels || [],
                    source: selected?.source || null,
                    sourceLabel: selected?.sourceLabel || '',
                    isSelected: true,
                }];

            const rootChildIds = [];
            childrenEntries.forEach((child, index) => {
                const isSelected = Boolean(child?.isSelected) || String(child?.birthRecordId || child?.eventId || '').trim() === focusId;
                const childId = isSelected
                    ? focusId
                    : String(child?.birthRecordId || child?.eventId || '').trim() || safeClassicTreeId(`child:${index}`, child?.label || index);
                upsertPerson({
                    id: childId,
                    label: child?.label || 'Без имени',
                    sex: String(child?.sex || '').trim().toUpperCase(),
                    roleLabel: isSelected ? 'Выбранная персона' : getParentsChildRoleLabel(child),
                    familyRoleLabel: isSelected ? 'Выбранная персона' : getParentsChildRoleLabel(child),
                    birthYear: child?.year ?? null,
                    birthPlace: joinLabels(child?.localityLabels),
                    death: child?.death || null,
                    deathLabel: child?.deathLabel || '',
                    deathYear: child?.deathYear ?? null,
                    deathYearLabel: child?.deathYearLabel || '',
                    deathAge: child?.deathAge || '',
                    source: child?.source || null,
                    sourceLabel: getClassicTreeSourceSnippet(child?.source, child?.sourceLabel),
                    isFocus: isSelected,
                    isMissing: false,
                    confidenceStatus: String(child?.adjustedStatus || '').trim(),
                    identityProfileStatus: String(child?.identityProfileStatus || '').trim(),
                    identityProfileWarnings: Array.isArray(child?.identityProfileWarnings) ? child.identityProfileWarnings : [],
                    identityProfileConflicts: Array.isArray(child?.identityProfileConflicts) ? child.identityProfileConflicts : [],
                });
                rootChildIds.push(childId);
            });

            if (!rootChildIds.includes(focusId)) {
                rootChildIds.push(focusId);
            }

            const rootFather = tree?.father
                ? upsertFromNode(tree.father, safeClassicTreeId(`father:${focusId}`, tree?.father?.personLabel || selected?.fatherLabel || 'father'), tree?.father?.roleLabel || 'Отец')
                : ((selected?.fatherLabel || familyContext?.fatherLabel || tree?.mother || selected?.motherLabel || familyContext?.motherLabel)
                    ? makeMissingPerson(selected?.fatherLabel || familyContext?.fatherLabel || 'Отец не найден', 'Отец', `father:${focusId}`)
                    : null);
            const rootMother = tree?.mother
                ? upsertFromNode(tree.mother, safeClassicTreeId(`mother:${focusId}`, tree?.mother?.personLabel || selected?.motherLabel || 'mother'), tree?.mother?.roleLabel || 'Мать')
                : ((selected?.motherLabel || familyContext?.motherLabel || tree?.father || selected?.fatherLabel || familyContext?.fatherLabel)
                    ? makeMissingPerson(selected?.motherLabel || familyContext?.motherLabel || 'Мать не найдена', 'Мать', `mother:${focusId}`)
                    : null);

            const pushFamily = (family) => {
                if (!family?.id || familySeen.has(family.id)) return;
                familySeen.add(family.id);
                families.push(family);
                if (Array.isArray(family.childIds) && family.childIds.length === 1) {
                    parentFamilyByChildId[family.childIds[0]] = family.id;
                }
            };

            const rootFamilyId = String(familyContext?.birthFamilyId || '').trim() || safeClassicTreeId('family', focusId);
                pushFamily({
                    id: rootFamilyId,
                    fatherId: rootFather?.id || '',
                    motherId: rootMother?.id || '',
                    spouseIds: [rootFather?.id, rootMother?.id].filter(Boolean),
                    childIds: rootChildIds,
                    marriage: familyContext?.parentsMarriage || tree?.parentsMarriage || null,
                    generation: 1,
                    isRoot: true,
                    role: 'root',
                    familyGroupId: rootFamilyId,
                    marriageGroupId: String(familyContext?.parentsMarriage?.source?.itemId || tree?.parentsMarriage?.source?.itemId || rootFamilyId),
                });

            const appendAncestorFamilies = (node, fallbackRoleLabel = '') => {
                if (!node) return;
                const personId = String(node?.birthRecordId || node?.id || '').trim() || safeClassicTreeId('ancestor', node?.personLabel || fallbackRoleLabel || 'person');
                upsertFromNode(node, personId, node?.roleLabel || fallbackRoleLabel || 'Предок');
                if (visitedAncestorPeople.has(personId)) return;
                visitedAncestorPeople.add(personId);

                const fatherPerson = node?.father
                    ? upsertFromNode(node.father, safeClassicTreeId(`ancestor-father:${personId}`, node?.father?.personLabel || node?.fatherLabel || 'father'), node?.father?.roleLabel || 'Отец')
                    : ((node?.fatherLabel || node?.mother || node?.motherLabel || node?.parentsMarriage)
                        ? makeMissingPerson(node?.fatherLabel || 'Отец не найден', 'Отец', `ancestor-father:${personId}`)
                        : null);
                const motherPerson = node?.mother
                    ? upsertFromNode(node.mother, safeClassicTreeId(`ancestor-mother:${personId}`, node?.mother?.personLabel || node?.motherLabel || 'mother'), node?.mother?.roleLabel || 'Мать')
                    : ((node?.motherLabel || node?.father || node?.fatherLabel || node?.parentsMarriage)
                        ? makeMissingPerson(node?.motherLabel || 'Мать не найдена', 'Мать', `ancestor-mother:${personId}`)
                        : null);

                if (!fatherPerson && !motherPerson && !node?.parentsMarriage) return;

                pushFamily({
                    id: safeClassicTreeId('ancestors', personId),
                    fatherId: fatherPerson?.id || '',
                    motherId: motherPerson?.id || '',
                    spouseIds: [fatherPerson?.id, motherPerson?.id].filter(Boolean),
                    childIds: [personId],
                    marriage: node?.parentsMarriage || null,
                    generation: null,
                    isRoot: false,
                    role: 'ancestor',
                    familyGroupId: safeClassicTreeId('ancestors', personId),
                    marriageGroupId: String(node?.parentsMarriage?.source?.itemId || personId),
                });

                if (node?.father) appendAncestorFamilies(node.father, node?.father?.roleLabel || 'Отец');
                if (node?.mother) appendAncestorFamilies(node.mother, node?.mother?.roleLabel || 'Мать');
            };

            if (tree?.father) appendAncestorFamilies(tree.father, tree?.father?.roleLabel || 'Отец');
            if (tree?.mother) appendAncestorFamilies(tree.mother, tree?.mother?.roleLabel || 'Мать');

            // Боковые линии: братья/сёстры предков (дяди/тёти выбранной персоны).
            // Бэкенд присылает их в familyContext.ancestorExtraPersons — добавляем
            // в persons заранее, чтобы descendantFamilies-цикл ниже мог к ним привязаться.
            const ancestorExtraPersons = Array.isArray(familyContext?.ancestorExtraPersons) ? familyContext.ancestorExtraPersons : [];
            ancestorExtraPersons.forEach((person) => {
                const personId = String(person?.birthRecordId || '').trim();
                if (!personId || persons[personId]) return;
                upsertPerson({
                    id: personId,
                    label: person?.label || 'Боковая линия',
                    sex: String(person?.sex || '').trim().toUpperCase(),
                    roleLabel: 'Боковая линия',
                    familyRoleLabel: '',
                    birthYear: person?.year ?? null,
                    birthPlace: joinLabels(person?.localityLabels),
                    death: null,
                    deathLabel: '',
                    deathYear: null,
                    deathYearLabel: '',
                    deathAge: '',
                    source: person?.source || null,
                    sourceLabel: getClassicTreeSourceSnippet(person?.source, person?.sourceLabel),
                    isMissing: false,
                    confidenceStatus: String(person?.adjustedStatus || '').trim(),
                    identityProfileStatus: String(person?.identityProfileStatus || '').trim(),
                    identityProfileWarnings: Array.isArray(person?.identityProfileWarnings) ? person.identityProfileWarnings : [],
                    identityProfileConflicts: Array.isArray(person?.identityProfileConflicts) ? person.identityProfileConflicts : [],
                });
            });

            const buildClassicTreeOverflowChild = (family, familyIndex, hiddenCount, parentId) => {
                const count = Number(hiddenCount || 0);
                if (count <= 0) return null;
                const isFocusParent = String(parentId || '').trim() === String(focusId || '').trim();
                return {
                    birthRecordId: safeClassicTreeId(`desc-overflow:${familyIndex}`, `${parentId}:${family?.unionId || family?.birthFamilyId || familyIndex}:${count}`),
                    eventId: '',
                    label: count === 1 ? 'Ещё 1 ребёнок' : `Ещё ${count} детей`,
                    year: null,
                    localityLabels: [],
                    sex: '',
                    source: null,
                    sourceLabel: '',
                    isClassicTreeOverflow: true,
                    roleLabel: isFocusParent ? 'Остальные дети' : 'Боковая ветвь',
                };
            };

            const descendantFamilies = Array.isArray(familyContext?.descendantFamilies) ? familyContext.descendantFamilies : [];
            descendantFamilies.forEach((family, index) => {
                const parentId = String(family?.parentBirthRecordId || '').trim();
                if (!parentId || !persons[parentId]) return;
                const spouse = family?.spouse || {};
                const spouseSex = String(spouse?.sex || '').trim().toUpperCase();
                const spouseRoleLabel = spouseSex === 'MALE' ? 'Супруг' : spouseSex === 'FEMALE' ? 'Супруга' : 'Супруг';
                const spouseId = safeClassicTreeId(`desc-spouse:${family?.unionId || index}`, spouse?.label || spouseRoleLabel);
                const spousePerson = upsertPerson({
                    id: spouseId,
                    label: spouse?.label || (spouseSex === 'FEMALE' ? 'Супруга не найдена' : spouseSex === 'MALE' ? 'Супруг не найден' : 'Супруг не найден'),
                    sex: spouseSex,
                    roleLabel: spouseRoleLabel,
                    familyRoleLabel: spouseRoleLabel,
                    birthYear: null,
                    birthPlace: joinLabels(spouse?.localityLabels),
                    death: null,
                    deathLabel: '',
                    deathYear: null,
                    deathYearLabel: '',
                    deathAge: '',
                    source: spouse?.source || family?.marriage?.source || null,
                    sourceLabel: getClassicTreeSourceSnippet(spouse?.source || family?.marriage?.source, spouse?.sourceLabel || family?.marriage?.sourceLabel),
                    kind: spouse?.label ? 'person' : 'ghost',
                    isMissing: !spouse?.label,
                    confidenceStatus: String(family?.marriage?.status || '').trim(),
                    identityProfileStatus: String(spouse?.identityProfileStatus || '').trim(),
                    identityProfileWarnings: Array.isArray(spouse?.identityProfileWarnings) ? spouse.identityProfileWarnings : [],
                    identityProfileConflicts: Array.isArray(spouse?.identityProfileConflicts) ? spouse.identityProfileConflicts : [],
                });

                const childIds = [];
                (Array.isArray(family?.children) ? family.children : []).forEach((child, childIndex) => {
                    const childId = String(child?.birthRecordId || child?.eventId || '').trim() || safeClassicTreeId(`desc-child:${index}:${childIndex}`, child?.label || childIndex);
                    upsertPerson({
                        id: childId,
                        label: child?.label || 'Ребёнок',
                        sex: String(child?.sex || '').trim().toUpperCase(),
                        roleLabel: getParentsChildRoleLabel(child),
                        familyRoleLabel: getParentsChildRoleLabel(child),
                        birthYear: child?.year ?? null,
                        birthPlace: joinLabels(child?.localityLabels),
                        death: child?.death || null,
                        deathLabel: child?.deathLabel || '',
                        deathYear: child?.deathYear ?? null,
                        deathYearLabel: child?.deathYearLabel || '',
                        deathAge: child?.deathAge || '',
                        source: child?.source || null,
                        sourceLabel: getClassicTreeSourceSnippet(child?.source, child?.sourceLabel),
                        kind: 'person',
                        isMissing: false,
                        confidenceStatus: String(family?.childrenLinkStatus || '').trim(),
                        identityProfileStatus: String(child?.identityProfileStatus || '').trim(),
                        identityProfileWarnings: Array.isArray(child?.identityProfileWarnings) ? child.identityProfileWarnings : [],
                        identityProfileConflicts: Array.isArray(child?.identityProfileConflicts) ? child.identityProfileConflicts : [],
                    });
                    childIds.push(childId);
                });

                const parentSex = String(persons[parentId]?.sex || '').trim().toUpperCase();
                const fatherId = parentSex === 'MALE' ? parentId : (spouseSex === 'MALE' ? spousePerson?.id || '' : '');
                const motherId = parentSex === 'FEMALE' ? parentId : (spouseSex === 'FEMALE' ? spousePerson?.id || '' : '');
                const descendantFamilyId = safeClassicTreeId('desc-family', `${parentId}:${family?.unionId || index}`);
                pushFamily({
                    id: descendantFamilyId,
                    fatherId,
                    motherId,
                    spouseIds: [parentId, spousePerson?.id].filter(Boolean),
                    childIds,
                    marriage: family?.marriage || null,
                    generation: -1,
                    isDescendant: true,
                    parentId,
                    role: 'descendant',
                    childrenLinkStatus: String(family?.childrenLinkStatus || '').trim(),
                    isOtherMarriageOfParent: Boolean(family?.isOtherMarriageOfParent),
                    parentRoleLabel: family?.parentRoleLabel || '',
                    unionId: family?.unionId || '',
                    spouseGroupIndex: index,
                    marriageGroupId: String(family?.unionId || family?.marriage?.source?.itemId || descendantFamilyId),
                    familyGroupId: descendantFamilyId,
                    childrenOfMarriage: childIds.slice(),
                    visibleChildIds: childIds.slice(),
                    hiddenChildrenCount: 0,
                });
                if (!descendantFamilyIdsByParentId[parentId]) descendantFamilyIdsByParentId[parentId] = [];
                descendantFamilyIdsByParentId[parentId].push(descendantFamilyId);
            });

            const familyCountByParentId = {};
            families.forEach((family) => {
                [family?.fatherId, family?.motherId, family?.parentId].filter(Boolean).forEach((parentId) => {
                    familyCountByParentId[parentId] = Number(familyCountByParentId[parentId] || 0) + 1;
                });
            });

            const descendantFamiliesByParentId = {};
            families.forEach((family) => {
                if (!family?.isDescendant || !family?.parentId) return;
                if (!descendantFamiliesByParentId[family.parentId]) descendantFamiliesByParentId[family.parentId] = [];
                descendantFamiliesByParentId[family.parentId].push(family);
            });

            const getFamilyChronologyYear = (family) => {
                const marriageYear = Number(family?.marriage?.year || family?.marriage?.marriageYear || 0);
                if (Number.isFinite(marriageYear) && marriageYear > 0) return marriageYear;
                const childYears = (Array.isArray(family?.childrenOfMarriage) ? family.childrenOfMarriage : [])
                    .map((childId) => Number(persons?.[childId]?.birthYear || 0))
                    .filter((year) => Number.isFinite(year) && year > 0);
                if (childYears.length) return Math.min(...childYears);
                return Number.POSITIVE_INFINITY;
            };

            const getFamilyLastYear = (family) => {
                const childYears = (Array.isArray(family?.childrenOfMarriage) ? family.childrenOfMarriage : [])
                    .map((childId) => Number(persons?.[childId]?.birthYear || 0))
                    .filter((year) => Number.isFinite(year) && year > 0);
                return childYears.length ? Math.max(...childYears) : Number.POSITIVE_INFINITY;
            };

            Object.entries(descendantFamiliesByParentId).forEach(([parentId, group]) => {
                group.sort((leftFamily, rightFamily) => {
                    const leftYear = getFamilyChronologyYear(leftFamily);
                    const rightYear = getFamilyChronologyYear(rightFamily);
                    if (leftYear !== rightYear) return leftYear - rightYear;
                    const leftLastYear = getFamilyLastYear(leftFamily);
                    const rightLastYear = getFamilyLastYear(rightFamily);
                    if (leftLastYear !== rightLastYear) return leftLastYear - rightLastYear;
                    const leftChildren = Number(leftFamily?.childrenOfMarriage?.length || leftFamily?.childIds?.length || 0);
                    const rightChildren = Number(rightFamily?.childrenOfMarriage?.length || rightFamily?.childIds?.length || 0);
                    if (leftChildren !== rightChildren) return rightChildren - leftChildren;
                    return String(leftFamily?.id || '').localeCompare(String(rightFamily?.id || ''), 'ru');
                });

                const primaryFamily = group.find((family) => (Array.isArray(family?.childIds) ? family.childIds : []).includes(focusId))
                    || group.find((family) => family?.isSelectedParent && !family?.isOtherMarriageOfParent)
                    || group.find((family) => !family?.isOtherMarriageOfParent)
                    || group[0];

                group.forEach((family, index) => {
                    family.marriageOrderIndex = index;
                    family.marriageOrdinal = index + 1;
                    family.marriageTotalForParent = group.length;
                    family.isRepeatedMarriage = group.length > 1;
                    family.isPrimaryMarriage = primaryFamily?.id === family.id;
                    family.firstChildYear = getFamilyChronologyYear(family);
                    family.lastChildYear = getFamilyLastYear(family);

                    const baseChildIds = (Array.isArray(family?.childrenOfMarriage) ? family.childrenOfMarriage : family?.childIds || []).filter((childId) => persons?.[childId]);
                    let visibleChildIds = baseChildIds.slice();
                    let hiddenChildrenCount = 0;
                    if (group.length > 1) {
                        const mode = String(viewOptions?.multiMarriageDisplay || 'focus').trim();
                        let maxVisible = Infinity;
                        if (mode === 'compact') {
                            maxVisible = Number(densityLayout?.maxVisibleChildrenInCompactMarriage || 3);
                        } else if (mode === 'focus') {
                            maxVisible = family?.isPrimaryMarriage
                                ? Infinity
                                : Number(densityLayout?.maxVisibleChildrenInFocusSideMarriage || 3);
                        }
                        if (Number.isFinite(maxVisible) && maxVisible >= 0 && visibleChildIds.length > maxVisible) {
                            hiddenChildrenCount = visibleChildIds.length - maxVisible;
                            visibleChildIds = visibleChildIds.slice(0, maxVisible);
                            const overflowChild = buildClassicTreeOverflowChild(family, index, hiddenChildrenCount, parentId);
                            if (overflowChild) {
                                upsertPerson({
                                    id: overflowChild.birthRecordId,
                                    label: overflowChild.label,
                                    sex: '',
                                    roleLabel: overflowChild.roleLabel || 'Остальные дети',
                                    familyRoleLabel: overflowChild.roleLabel || 'Остальные дети',
                                    birthYear: null,
                                    birthPlace: '',
                                    death: null,
                                    deathLabel: '',
                                    deathYear: null,
                                    deathYearLabel: '',
                                    deathAge: '',
                                    source: null,
                                    sourceLabel: '',
                                    kind: 'childrenSummary',
                                    isMissing: true,
                                    confidenceStatus: '',
                                });
                                visibleChildIds.push(overflowChild.birthRecordId);
                            }
                        }
                    }
                    family.visibleChildIds = visibleChildIds;
                    family.hiddenChildrenCount = hiddenChildrenCount;
                });

                descendantFamilyIdsByParentId[parentId] = group.map((family) => family.id);
            });

            families.forEach((family) => {
                const pairStatus = getClassicTreePairStatusKey(family, persons, familyCountByParentId);
                const marriageStatus = String(family?.marriage?.adjustedStatus || family?.marriage?.status || family?.childrenLinkStatus || '').trim();
                const profileWarnings = Array.isArray(family?.marriage?.identityProfileWarnings) ? family.marriage.identityProfileWarnings : [];
                const profileConflicts = Array.isArray(family?.marriage?.identityProfileConflicts) ? family.marriage.identityProfileConflicts : [];
                family.pairStatus = pairStatus;
                family.relationKind = getClassicTreeRelationKind({
                    status: marriageStatus,
                    pairStatus,
                    isMarriage: true,
                    hasWarnings: profileWarnings.length > 0 || pairStatus === 'beforeMarriage',
                    hasConflicts: profileConflicts.length > 0,
                });
                family.confidenceStatus = marriageStatus;
                family.hasWarnings = profileWarnings.length > 0 || pairStatus === 'beforeMarriage';
                family.hasConflicts = profileConflicts.length > 0;
            });

            return {
                rootId: focusId,
                rootFamilyId,
                focusPersonId: focusId,
                rootChildIds,
                persons,
                families,
                parentFamilyByChildId,
                descendantFamilyIdsByParentId,
                familyCountByParentId,
                viewOptions,
            };
        };

        const layoutParentsClassicTree = (model, options = {}) => {
            const viewOptions = normalizeClassicTreeViewOptions({
                ...(model?.viewOptions || {}),
                ...(options && typeof options === 'object' ? options : {}),
            });
            const opts = getClassicTreeLayoutOptions(viewOptions);
            if (!model?.focusPersonId) {
                return {
                    width: 0,
                    height: 0,
                    nodes: [],
                    lines: [],
                    rootId: '',
                };
            }

            const persons = model?.persons && typeof model.persons === 'object' ? model.persons : {};
            const families = Array.isArray(model?.families) ? model.families : [];
            const familyById = Object.fromEntries(families.map((family) => [family.id, family]));
            const parentFamilyByChildId = model?.parentFamilyByChildId && typeof model.parentFamilyByChildId === 'object'
                ? model.parentFamilyByChildId
                : {};
            const descendantFamilyIdsByParentId = model?.descendantFamilyIdsByParentId && typeof model.descendantFamilyIdsByParentId === 'object'
                ? model.descendantFamilyIdsByParentId
                : {};
            const rootFamily = familyById[model.rootFamilyId] || families.find((family) => family?.isRoot) || null;
            const treeType = String(viewOptions?.treeType || 'directPlus').trim();
            const positionedNodes = {};
            const lines = [];
            const widthCache = new Map();
            const depthCache = new Map();
            const visibleFamilyIds = new Set();
            const frames = [];

            const addVisibleFamily = (familyId) => {
                if (!familyId || !familyById[familyId]) return;
                visibleFamilyIds.add(familyId);
            };

            const addAncestorChainForPerson = (personId) => {
                if (!personId) return;
                const familyId = parentFamilyByChildId[personId];
                if (!familyId || visibleFamilyIds.has(familyId)) return;
                addVisibleFamily(familyId);
                const family = familyById[familyId];
                if (!family) return;
                if (family?.fatherId) addAncestorChainForPerson(family.fatherId);
                if (family?.motherId) addAncestorChainForPerson(family.motherId);
            };

            const addDescendantFamiliesForPerson = (personId, { includeOtherMarriages = false } = {}) => {
                const familyIds = Array.isArray(descendantFamilyIdsByParentId?.[personId]) ? descendantFamilyIdsByParentId[personId] : [];
                familyIds.forEach((familyId) => {
                    const family = familyById[familyId];
                    if (!family) return;
                    if (!includeOtherMarriages && family?.isOtherMarriageOfParent) return;
                    addVisibleFamily(familyId);
                });
            };

            if (rootFamily) addVisibleFamily(rootFamily.id);

            if (treeType === 'direct') {
                addAncestorChainForPerson(model.focusPersonId);
            } else if (treeType === 'family') {
                addDescendantFamiliesForPerson(model.focusPersonId);
                (Array.isArray(model?.rootChildIds) ? model.rootChildIds : []).forEach((personId) => {
                    if (personId !== model.focusPersonId) addDescendantFamiliesForPerson(personId);
                });
            } else if (treeType === 'all' || treeType === 'proof') {
                families.forEach((family) => addVisibleFamily(family?.id));
            } else {
                addAncestorChainForPerson(model.focusPersonId);
                addDescendantFamiliesForPerson(model.focusPersonId, { includeOtherMarriages: true });
                if (rootFamily?.fatherId) addDescendantFamiliesForPerson(rootFamily.fatherId, { includeOtherMarriages: true });
                if (rootFamily?.motherId) addDescendantFamiliesForPerson(rootFamily.motherId, { includeOtherMarriages: true });
            }

            const getVisibleDescendantFamilyIds = (personId, { excludeFamilyId = '', includeOtherOnly = false } = {}) => {
                const familyIds = Array.isArray(descendantFamilyIdsByParentId?.[personId]) ? descendantFamilyIdsByParentId[personId] : [];
                return familyIds
                    .filter((familyId) => visibleFamilyIds.has(familyId))
                    .filter((familyId) => !excludeFamilyId || familyId !== excludeFamilyId)
                    .filter((familyId) => !includeOtherOnly || Boolean(familyById[familyId]?.isOtherMarriageOfParent))
                    .sort((leftId, rightId) => {
                        const leftFamily = familyById[leftId] || {};
                        const rightFamily = familyById[rightId] || {};
                        const leftOrder = Number(leftFamily?.marriageOrderIndex ?? Number.POSITIVE_INFINITY);
                        const rightOrder = Number(rightFamily?.marriageOrderIndex ?? Number.POSITIVE_INFINITY);
                        if (leftOrder !== rightOrder) return leftOrder - rightOrder;
                        const leftPrimary = leftFamily?.isPrimaryMarriage ? 0 : 1;
                        const rightPrimary = rightFamily?.isPrimaryMarriage ? 0 : 1;
                        if (leftPrimary !== rightPrimary) return leftPrimary - rightPrimary;
                        return String(leftId).localeCompare(String(rightId), 'ru');
                    });
            };

            const shouldSpouseBeLeft = (parentId, family) => {
                const spouseIds = Array.isArray(family?.spouseIds) ? family.spouseIds.filter(Boolean) : [];
                const spouseId = spouseIds.find((id) => id !== parentId);
                const parentSex = String(persons[parentId]?.sex || '').trim().toUpperCase();
                const spouseSex = String(persons[spouseId]?.sex || '').trim().toUpperCase();
                if (parentSex === 'FEMALE' && spouseSex === 'MALE') return true;
                return false;
            };

            const getDescendantFamilyMetrics = (familyId, parentId) => {
                const family = familyById[familyId];
                if (!family) {
                    return {
                        familyId,
                        spouseId: '',
                        childIds: [],
                        childSpan: 0,
                        clusterWidth: opts.nodeWidth,
                        hasSpouse: false,
                    };
                }
                const spouseIds = Array.isArray(family?.spouseIds) ? family.spouseIds.filter(Boolean) : [];
                const spouseId = spouseIds.find((id) => id !== parentId) || '';
                const childIds = (Array.isArray(family?.visibleChildIds) ? family.visibleChildIds : (Array.isArray(family?.childrenOfMarriage) ? family.childrenOfMarriage : family?.childIds || []))
                    .filter((personId) => persons[personId]);
                const childSpan = childIds.length > 0
                    ? (childIds.length * opts.nodeWidth) + (Math.max(0, childIds.length - 1) * opts.siblingGap)
                    : 0;
                const coupleSpan = spouseId ? ((opts.nodeWidth * 2) + opts.spouseGap) : opts.nodeWidth;
                return {
                    familyId,
                    spouseId,
                    childIds,
                    childSpan,
                    coupleSpan,
                    clusterWidth: Math.max(opts.nodeWidth, childSpan, coupleSpan),
                    hasSpouse: Boolean(spouseId),
                };
            };

            const buildDescendantFamilyRenderPlan = (personId, config = {}) => {
                const familyIds = getVisibleDescendantFamilyIds(personId, config);
                const baseExtents = { left: opts.nodeWidth / 2, right: opts.nodeWidth / 2 };
                if (familyIds.length === 0) {
                    return {
                        familyIds,
                        assignments: [],
                        leftExtent: baseExtents.left,
                        rightExtent: baseExtents.right,
                        totalWidth: opts.nodeWidth,
                    };
                }
                if (familyIds.length > 1) {
                    const orderedFamilies = familyIds
                        .map((familyId) => ({
                            familyId,
                            family: familyById[familyId] || {},
                            metrics: getDescendantFamilyMetrics(familyId, personId),
                        }))
                        .filter((entry) => entry.familyId && entry.family);
                    const primaryFamilyId = orderedFamilies.find((entry) => entry.family?.isPrimaryMarriage)?.familyId || orderedFamilies[0]?.familyId;
                    const primaryIndex = orderedFamilies.findIndex((entry) => entry.familyId === primaryFamilyId);
                    const slots = orderedFamilies.map((entry) => ({
                        ...entry,
                        slotWidth: Math.min(
                            Number(opts?.maxMarriageSlotWidth || 780),
                            Math.max(
                                opts.nodeWidth + (Number(opts?.familyGroupPadding || 18) * 2),
                                Number(entry?.metrics?.childSpan || 0) + (Number(opts?.familyGroupPadding || 18) * 2),
                            ),
                        ),
                    }));
                    if (primaryIndex < 0) {
                        return {
                            familyIds,
                            assignments: [],
                            leftExtent: baseExtents.left,
                            rightExtent: baseExtents.right,
                            totalWidth: opts.nodeWidth,
                        };
                    }
                    const primarySlot = slots[primaryIndex];
                    const assignments = [];
                    let leftExtent = Number(primarySlot?.slotWidth || opts.nodeWidth) / 2;
                    let rightExtent = Number(primarySlot?.slotWidth || opts.nodeWidth) / 2;
                    assignments[primaryIndex] = {
                        familyId: primarySlot.familyId,
                        family: primarySlot.family,
                        metrics: primarySlot.metrics,
                        side: 'center',
                        isPrimary: true,
                        slotWidth: primarySlot.slotWidth,
                        centerOffset: 0,
                    };
                    let leftCursor = -Number(primarySlot?.slotWidth || opts.nodeWidth) / 2;
                    for (let index = primaryIndex - 1; index >= 0; index -= 1) {
                        const slot = slots[index];
                        const centerOffset = leftCursor - Number(opts?.marriageSlotGap || opts?.familyGap || 42) - (slot.slotWidth / 2);
                        assignments[index] = {
                            familyId: slot.familyId,
                            family: slot.family,
                            metrics: slot.metrics,
                            side: 'left',
                            isPrimary: false,
                            slotWidth: slot.slotWidth,
                            centerOffset,
                        };
                        leftCursor = centerOffset - (slot.slotWidth / 2);
                        leftExtent = Math.max(leftExtent, Math.abs(centerOffset) + (slot.slotWidth / 2));
                    }
                    let rightCursor = Number(primarySlot?.slotWidth || opts.nodeWidth) / 2;
                    for (let index = primaryIndex + 1; index < slots.length; index += 1) {
                        const slot = slots[index];
                        const centerOffset = rightCursor + Number(opts?.marriageSlotGap || opts?.familyGap || 42) + (slot.slotWidth / 2);
                        assignments[index] = {
                            familyId: slot.familyId,
                            family: slot.family,
                            metrics: slot.metrics,
                            side: 'right',
                            isPrimary: false,
                            slotWidth: slot.slotWidth,
                            centerOffset,
                        };
                        rightCursor = centerOffset + (slot.slotWidth / 2);
                        rightExtent = Math.max(rightExtent, centerOffset + (slot.slotWidth / 2));
                    }
                    return {
                        familyIds,
                        assignments: assignments.filter(Boolean),
                        leftExtent,
                        rightExtent,
                        totalWidth: leftExtent + rightExtent,
                        isMarriageRail: true,
                        primaryFamilyId,
                    };
                }
                const primaryFamilyId = familyIds.find((familyId) => !familyById[familyId]?.isOtherMarriageOfParent) || familyIds[0];
                const primaryIndex = familyIds.indexOf(primaryFamilyId);
                const orderedIds = [
                    primaryFamilyId,
                    ...familyIds.filter((familyId) => familyId !== primaryFamilyId),
                ];
                const primarySide = shouldSpouseBeLeft(personId, familyById[primaryFamilyId]) ? 'left' : 'right';
                const sideSequence = [primarySide, primarySide === 'left' ? 'right' : 'left'];
                const sideCursor = {
                    left: opts.nodeWidth / 2,
                    right: opts.nodeWidth / 2,
                };
                const assignments = [];
                orderedIds.forEach((familyId, index) => {
                    const metrics = getDescendantFamilyMetrics(familyId, personId);
                    const family = familyById[familyId] || {};
                    const clusterHalf = metrics.clusterWidth / 2;
                    const minAnchorOffset = metrics.hasSpouse
                        ? ((opts.nodeWidth + opts.spouseGap) / 2)
                        : ((opts.nodeWidth / 2) + 14);
                    const side = index === 0
                        ? primarySide
                        : sideSequence[(index - 1) % sideSequence.length];
                    const anchorOffset = familyIds.length === 1
                        ? minAnchorOffset
                        : Math.max(minAnchorOffset, sideCursor[side] + (opts.familyGap / 2) + clusterHalf);
                    sideCursor[side] = Math.max(sideCursor[side], anchorOffset + clusterHalf);
                    assignments.push({
                        familyId,
                        family,
                        metrics,
                        side,
                        isPrimary: familyId === primaryFamilyId,
                        primaryIndex,
                        anchorOffset,
                    });
                });
                return {
                    familyIds,
                    assignments,
                    leftExtent: sideCursor.left,
                    rightExtent: sideCursor.right,
                    totalWidth: sideCursor.left + sideCursor.right,
                };
            };

            const getDescendantFamilyWidth = (familyId) => {
                const family = familyById[familyId];
                if (!family) return opts.nodeWidth;
                const spouseIds = Array.isArray(family?.spouseIds) ? family.spouseIds.filter(Boolean) : [];
                const childIds = Array.isArray(family?.childIds) ? family.childIds.filter((personId) => persons[personId]) : [];
                const coupleWidth = spouseIds.length >= 2
                    ? (opts.nodeWidth * 2) + opts.spouseGap
                    : opts.nodeWidth;
                const childWidth = childIds.length > 0
                    ? (childIds.length * opts.nodeWidth) + (Math.max(0, childIds.length - 1) * opts.siblingGap)
                    : 0;
                return Math.max(opts.nodeWidth, coupleWidth, childWidth);
            };

            const getDescendantBlockWidth = (personId) => {
                const plan = buildDescendantFamilyRenderPlan(personId);
                return Math.max(opts.nodeWidth, Number(plan?.totalWidth || opts.nodeWidth));
            };

            const getRootChildPlanMetrics = (personId) => {
                const plan = buildDescendantFamilyRenderPlan(personId);
                const isFocusPerson = personId === model.focusPersonId;
                const descendantFamilyCount = getVisibleDescendantFamilyIds(personId).length;
                if (isFocusPerson) {
                    return {
                        plan,
                        leftExtent: Number(plan?.leftExtent || (opts.nodeWidth / 2)),
                        rightExtent: Number(plan?.rightExtent || (opts.nodeWidth / 2)),
                    };
                }
                const capMultiplier = descendantFamilyCount > 1 ? 2.35 : 1.75;
                const cap = opts.nodeWidth * capMultiplier;
                return {
                    plan,
                    leftExtent: Math.min(Number(plan?.leftExtent || (opts.nodeWidth / 2)), cap / 2),
                    rightExtent: Math.min(Number(plan?.rightExtent || (opts.nodeWidth / 2)), cap / 2),
                };
            };

            const getBranchWidth = (personId) => {
                const familyId = parentFamilyByChildId[personId];
                if (!familyId || !visibleFamilyIds.has(familyId)) return opts.nodeWidth;
                return getFamilyWidth(familyId);
            };

            const getFamilyWidth = (familyId) => {
                if (widthCache.has(familyId)) return widthCache.get(familyId);
                const family = familyById[familyId];
                if (!family || !visibleFamilyIds.has(familyId)) return opts.nodeWidth;
                const fatherWidth = family?.fatherId ? getBranchWidth(family.fatherId) : 0;
                const motherWidth = family?.motherId ? getBranchWidth(family.motherId) : 0;
                let span = opts.nodeWidth;
                if (family?.fatherId && family?.motherId) {
                    span = fatherWidth + opts.spouseGap + motherWidth;
                } else if (family?.fatherId) {
                    span = fatherWidth;
                } else if (family?.motherId) {
                    span = motherWidth;
                }
                if (family?.isRoot) {
                    const childCount = Math.max(1, Array.isArray(family?.childIds) ? family.childIds.length : 0);
                    const childSpan = (childCount * opts.nodeWidth) + (Math.max(0, childCount - 1) * opts.siblingGap);
                    span = Math.max(span, childSpan);
                }
                span = Math.max(span, opts.nodeWidth);
                widthCache.set(familyId, span);
                return span;
            };

            const getBranchDepth = (personId) => {
                const familyId = parentFamilyByChildId[personId];
                if (!familyId || !visibleFamilyIds.has(familyId)) return 0;
                return getFamilyDepth(familyId);
            };

            const getFamilyDepth = (familyId) => {
                if (depthCache.has(familyId)) return depthCache.get(familyId);
                const family = familyById[familyId];
                if (!family || !visibleFamilyIds.has(familyId)) return 0;
                const fatherDepth = family?.fatherId ? getBranchDepth(family.fatherId) : 0;
                const motherDepth = family?.motherId ? getBranchDepth(family.motherId) : 0;
                const depth = 1 + Math.max(fatherDepth, motherDepth);
                depthCache.set(familyId, depth);
                return depth;
            };

            const maxAncestorDepth = rootFamily ? getFamilyDepth(rootFamily.id) : 0;
            const getYForGeneration = (generation) => (
                opts.margin + ((maxAncestorDepth - generation) * (opts.nodeHeight + opts.generationGap)) + (opts.nodeHeight / 2)
            );

            const setNodePosition = (personId, x, generation, overrides = {}) => {
                if (!personId || !persons[personId]) return;
                const person = persons[personId];
                const isChildrenSummary = person?.kind === 'childrenSummary';
                const resolvedY = Number.isFinite(Number(overrides?.customY)) ? Number(overrides.customY) : getYForGeneration(generation);
                const resolvedWidth = Number.isFinite(Number(overrides?.customWidth))
                    ? Number(overrides.customWidth)
                    : (isChildrenSummary ? Math.min(opts.nodeWidth * 0.72, 172) : opts.nodeWidth);
                const resolvedHeight = Number.isFinite(Number(overrides?.customHeight))
                    ? Number(overrides.customHeight)
                    : (isChildrenSummary ? 58 : opts.nodeHeight);
                positionedNodes[personId] = {
                    ...positionedNodes[personId],
                    ...person,
                    ...overrides,
                    id: personId,
                    x,
                    y: resolvedY,
                    width: resolvedWidth,
                    height: resolvedHeight,
                    generation,
                    cardDetail: viewOptions?.cardDetail || 'medium',
                };
            };

            const pushLine = (kind, points, extra = {}) => {
                const normalizedPoints = Array.isArray(points)
                    ? points.filter((point) => Array.isArray(point) && point.length >= 2)
                    : [];
                if (normalizedPoints.length < 2) return;
                lines.push({
                    kind,
                    points: normalizedPoints,
                    ...extra,
                });
            };

            const layoutAncestorBranch = (personId, centerX, generation) => {
                if (!personId || !persons[personId]) return;
                setNodePosition(personId, centerX, generation);
                const familyId = parentFamilyByChildId[personId];
                if (!familyId) return;
                const family = familyById[familyId];
                if (!family) return;

                const fatherWidth = family?.fatherId ? getBranchWidth(family.fatherId) : 0;
                const motherWidth = family?.motherId ? getBranchWidth(family.motherId) : 0;
                let fatherCenter = centerX;
                let motherCenter = centerX;

                if (family?.fatherId && family?.motherId) {
                    const span = fatherWidth + opts.spouseGap + motherWidth;
                    const left = centerX - (span / 2);
                    fatherCenter = left + (fatherWidth / 2);
                    motherCenter = left + fatherWidth + opts.spouseGap + (motherWidth / 2);
                }

                if (family?.fatherId) setNodePosition(family.fatherId, fatherCenter, generation + 1);
                if (family?.motherId) setNodePosition(family.motherId, motherCenter, generation + 1);

                const parentY = getYForGeneration(generation + 1);
                const childY = getYForGeneration(generation);
                const parentBottom = parentY + (opts.nodeHeight / 2);
                const childTop = childY - (opts.nodeHeight / 2);
                const gapTotal = Math.max(0, childTop - parentBottom);
                const connectorY = parentBottom + (gapTotal * 0.35);
                const marriageMidX = family?.fatherId && family?.motherId
                    ? (fatherCenter + motherCenter) / 2
                    : (family?.fatherId ? fatherCenter : motherCenter);

                if (family?.fatherId && family?.motherId) {
                    pushLine('marriage', [
                        [fatherCenter + (opts.nodeWidth / 2), parentY],
                        [motherCenter - (opts.nodeWidth / 2), parentY],
                    ], {
                        familyId: family.id,
                        fromId: family.fatherId,
                        toId: family.motherId,
                        marriage: family?.marriage || null,
                        labelX: marriageMidX,
                        labelY: parentY,
                    });
                }

                const stemPoints = [
                    [marriageMidX, parentY],
                    [marriageMidX, connectorY],
                ];
                if (Math.abs(centerX - marriageMidX) > 1) {
                    stemPoints.push([centerX, connectorY]);
                }
                pushLine('parent_child', stemPoints, {
                    familyId: family.id,
                    fromId: family.fatherId || family.motherId,
                    toId: personId,
                    fromSex: family.fatherId ? persons[family.fatherId]?.sex : persons[family.motherId]?.sex,
                    relationKind: getClassicTreeRelationKind({
                        status: family?.confidenceStatus,
                        pairStatus: family?.pairStatus,
                        hasWarnings: family?.hasWarnings,
                        hasConflicts: family?.hasConflicts,
                    }),
                    confidenceStatus: family?.confidenceStatus || '',
                    pairStatus: family?.pairStatus || '',
                });
                pushLine('child_bar', [
                    [centerX, connectorY],
                    [centerX, childTop],
                ], {
                    familyId: family.id,
                    toId: personId,
                    relationKind: getClassicTreeRelationKind({
                        status: family?.confidenceStatus,
                        pairStatus: family?.pairStatus,
                        hasWarnings: family?.hasWarnings,
                        hasConflicts: family?.hasConflicts,
                    }),
                    confidenceStatus: family?.confidenceStatus || '',
                    pairStatus: family?.pairStatus || '',
                });

                if (family?.fatherId) layoutAncestorBranch(family.fatherId, fatherCenter, generation + 1);
                if (family?.motherId) layoutAncestorBranch(family.motherId, motherCenter, generation + 1);
            };

            if (rootFamily) {
                const childIds = (Array.isArray(rootFamily?.childIds) ? rootFamily.childIds : [])
                    .filter((personId) => persons[personId])
                    .filter((personId) => treeType !== 'direct' || personId === model.focusPersonId);
                const focusChildId = childIds.includes(model.focusPersonId) ? model.focusPersonId : (childIds[0] || model.focusPersonId);
                const focusIndex = childIds.indexOf(focusChildId);
                const leftChildIds = focusIndex > 0 ? childIds.slice(0, focusIndex) : [];
                const rightChildIds = focusIndex >= 0 ? childIds.slice(focusIndex + 1) : childIds.slice(1);
                const planMetricsByChildId = {};
                childIds.forEach((childId) => {
                    planMetricsByChildId[childId] = getRootChildPlanMetrics(childId);
                });

                if (focusChildId && persons[focusChildId]) {
                    setNodePosition(focusChildId, 0, 0, {
                        isFocus: focusChildId === model.focusPersonId,
                    });
                }

                let leftCursor = -(Number(planMetricsByChildId[focusChildId]?.leftExtent || (opts.nodeWidth / 2)));
                [...leftChildIds].reverse().forEach((childId) => {
                    const metrics = planMetricsByChildId[childId] || { leftExtent: opts.nodeWidth / 2, rightExtent: opts.nodeWidth / 2 };
                    const childX = leftCursor - opts.siblingGap - Number(metrics.rightExtent || (opts.nodeWidth / 2));
                    setNodePosition(childId, childX, 0, {
                        isFocus: childId === model.focusPersonId,
                    });
                    leftCursor = childX - Number(metrics.leftExtent || (opts.nodeWidth / 2));
                });

                let rightCursor = Number(planMetricsByChildId[focusChildId]?.rightExtent || (opts.nodeWidth / 2));
                rightChildIds.forEach((childId) => {
                    const metrics = planMetricsByChildId[childId] || { leftExtent: opts.nodeWidth / 2, rightExtent: opts.nodeWidth / 2 };
                    const childX = rightCursor + opts.siblingGap + Number(metrics.leftExtent || (opts.nodeWidth / 2));
                    setNodePosition(childId, childX, 0, {
                        isFocus: childId === model.focusPersonId,
                    });
                    rightCursor = childX + Number(metrics.rightExtent || (opts.nodeWidth / 2));
                });

                const fatherWidth = rootFamily?.fatherId ? getBranchWidth(rootFamily.fatherId) : 0;
                const motherWidth = rootFamily?.motherId ? getBranchWidth(rootFamily.motherId) : 0;
                let fatherCenter = 0;
                let motherCenter = 0;
                if (rootFamily?.fatherId && rootFamily?.motherId) {
                    const span = fatherWidth + opts.spouseGap + motherWidth;
                    const left = -(span / 2);
                    fatherCenter = left + (fatherWidth / 2);
                    motherCenter = left + fatherWidth + opts.spouseGap + (motherWidth / 2);
                }

                if (rootFamily?.fatherId) layoutAncestorBranch(rootFamily.fatherId, fatherCenter, 1);
                if (rootFamily?.motherId) layoutAncestorBranch(rootFamily.motherId, motherCenter, 1);

                const parentY = getYForGeneration(1);
                const childY = getYForGeneration(0);
                const parentBottom = parentY + (opts.nodeHeight / 2);
                const childTop = childY - (opts.nodeHeight / 2);
                const gapTotal = Math.max(0, childTop - parentBottom);
                const connectorY = parentBottom + (gapTotal * 0.35);
                const childXs = childIds.map((childId) => positionedNodes[childId]?.x).filter((value) => Number.isFinite(value));
                const childrenCenter = childXs.length > 0
                    ? childXs.reduce((sum, value) => sum + value, 0) / childXs.length
                    : 0;
                const marriageMidX = rootFamily?.fatherId && rootFamily?.motherId
                    ? (fatherCenter + motherCenter) / 2
                    : (rootFamily?.fatherId ? fatherCenter : motherCenter);

                if (rootFamily?.fatherId && rootFamily?.motherId) {
                    pushLine('marriage', [
                        [fatherCenter + (opts.nodeWidth / 2), parentY],
                        [motherCenter - (opts.nodeWidth / 2), parentY],
                    ], {
                        familyId: rootFamily.id,
                        fromId: rootFamily.fatherId,
                        toId: rootFamily.motherId,
                        marriage: rootFamily?.marriage || null,
                        labelX: marriageMidX,
                        labelY: parentY,
                        relationKind: rootFamily?.relationKind || RELATION_KIND.marriage,
                        confidenceStatus: rootFamily?.confidenceStatus || '',
                        pairStatus: rootFamily?.pairStatus || '',
                    });
                }

                if (childXs.length > 0 && (rootFamily?.fatherId || rootFamily?.motherId)) {
                    const stemPoints = [
                        [marriageMidX, parentY],
                        [marriageMidX, connectorY],
                    ];
                    if (Math.abs(childrenCenter - marriageMidX) > 1) {
                        stemPoints.push([childrenCenter, connectorY]);
                    }
                    pushLine('parent_child', stemPoints, {
                        familyId: rootFamily.id,
                        fromId: rootFamily.fatherId || rootFamily.motherId,
                        toId: model.focusPersonId,
                        fromSex: rootFamily.fatherId ? persons[rootFamily.fatherId]?.sex : persons[rootFamily.motherId]?.sex,
                        relationKind: getClassicTreeRelationKind({
                            status: rootFamily?.confidenceStatus,
                            pairStatus: rootFamily?.pairStatus,
                            hasWarnings: rootFamily?.hasWarnings,
                            hasConflicts: rootFamily?.hasConflicts,
                        }),
                        confidenceStatus: rootFamily?.confidenceStatus || '',
                        pairStatus: rootFamily?.pairStatus || '',
                    });
                    pushLine('child_bar', [
                        [Math.min(...childXs), connectorY],
                        [Math.max(...childXs), connectorY],
                    ], {
                        familyId: rootFamily.id,
                        relationKind: getClassicTreeRelationKind({
                            status: rootFamily?.confidenceStatus,
                            pairStatus: rootFamily?.pairStatus,
                            hasWarnings: rootFamily?.hasWarnings,
                            hasConflicts: rootFamily?.hasConflicts,
                        }),
                        confidenceStatus: rootFamily?.confidenceStatus || '',
                        pairStatus: rootFamily?.pairStatus || '',
                    });
                    childIds.forEach((childId) => {
                        const childX = positionedNodes[childId]?.x;
                        if (!Number.isFinite(childX)) return;
                        pushLine('child_bar', [
                            [childX, connectorY],
                            [childX, childTop],
                        ], {
                            familyId: rootFamily.id,
                            toId: childId,
                            relationKind: getClassicTreeRelationKind({
                                status: rootFamily?.confidenceStatus,
                                pairStatus: rootFamily?.pairStatus,
                                hasWarnings: rootFamily?.hasWarnings,
                                hasConflicts: rootFamily?.hasConflicts,
                            }),
                            confidenceStatus: rootFamily?.confidenceStatus || '',
                            pairStatus: rootFamily?.pairStatus || '',
                        });
                    });
                }

                const layoutSingleDescendantFamily = (parentId, parentGeneration, childGeneration, plan) => {
                    const parentNode = positionedNodes[parentId];
                    if (!parentNode) return;
                    if (!Array.isArray(plan?.assignments) || plan.assignments.length === 0) return;
                    const parentY = getYForGeneration(parentGeneration);
                    const descendantChildY = getYForGeneration(childGeneration);
                    const parentBottom = parentY + (opts.nodeHeight / 2);
                    const childTop = descendantChildY - (opts.nodeHeight / 2);
                    const gapTotal = Math.max(0, childTop - parentBottom);
                    const descendantConnectorY = parentBottom + (gapTotal * 0.35);

                    plan.assignments.forEach((assignment) => {
                        const descendantFamily = assignment?.family;
                        if (!descendantFamily) return;
                        const sideMultiplier = assignment?.side === 'left' ? -1 : 1;
                        const marriageMidX = parentNode.x + (Number(assignment?.anchorOffset || 0) * sideMultiplier);
                        const spouseId = assignment?.metrics?.spouseId || '';
                        let spouseX = null;
                        if (spouseId && persons[spouseId]) {
                            spouseX = parentNode.x + ((Number(assignment?.anchorOffset || 0) * 2) * sideMultiplier);
                            setNodePosition(spouseId, spouseX, parentGeneration, {
                                roleLabel: persons[spouseId]?.roleLabel || (persons[spouseId]?.sex === 'MALE' ? 'Супруг' : 'Супруга'),
                            });
                            pushLine('marriage', [
                                [Math.min(parentNode.x, spouseX) + (opts.nodeWidth / 2), parentY],
                                [Math.max(parentNode.x, spouseX) - (opts.nodeWidth / 2), parentY],
                            ], {
                                familyId: descendantFamily.id,
                                fromId: parentId,
                                toId: spouseId,
                                marriage: descendantFamily?.marriage || null,
                                labelX: marriageMidX,
                                labelY: parentY,
                                relationKind: descendantFamily?.relationKind || RELATION_KIND.marriage,
                                confidenceStatus: descendantFamily?.confidenceStatus || '',
                                pairStatus: descendantFamily?.pairStatus || '',
                                marriageOrdinal: descendantFamily?.marriageOrdinal,
                                isRepeatedMarriage: descendantFamily?.isRepeatedMarriage,
                                isPrimaryMarriage: descendantFamily?.isPrimaryMarriage,
                            });
                        }

                        const descendantChildIds = assignment?.metrics?.childIds || [];
                        if (descendantChildIds.length === 0) return;
                        const childSpan = assignment?.metrics?.childSpan || ((descendantChildIds.length * opts.nodeWidth) + (Math.max(0, descendantChildIds.length - 1) * opts.siblingGap));
                        let childCursor = marriageMidX - (childSpan / 2) + (opts.nodeWidth / 2);
                        descendantChildIds.forEach((descChildId) => {
                            setNodePosition(descChildId, childCursor, childGeneration, {
                                roleLabel: persons[descChildId]?.roleLabel || 'Ребёнок',
                            });
                            childCursor += opts.nodeWidth + opts.siblingGap;
                        });
                        const descendantXs = descendantChildIds.map((descChildId) => positionedNodes[descChildId]?.x).filter((value) => Number.isFinite(value));
                        if (descendantXs.length === 0) return;
                        const childrenCenter = descendantXs.reduce((sum, value) => sum + value, 0) / descendantXs.length;
                        const stemPoints = [
                            [marriageMidX, parentY],
                            [marriageMidX, descendantConnectorY],
                        ];
                        if (Math.abs(childrenCenter - marriageMidX) > 1) {
                            stemPoints.push([childrenCenter, descendantConnectorY]);
                        }
                        pushLine('parent_child', stemPoints, {
                            familyId: descendantFamily.id,
                            fromId: parentId,
                            toId: descendantFamily.id,
                            fromSex: persons[parentId]?.sex,
                            relationKind: getClassicTreeRelationKind({
                                status: descendantFamily?.confidenceStatus,
                                pairStatus: descendantFamily?.pairStatus,
                                hasWarnings: descendantFamily?.hasWarnings,
                                hasConflicts: descendantFamily?.hasConflicts,
                            }),
                            confidenceStatus: descendantFamily?.confidenceStatus || '',
                            pairStatus: descendantFamily?.pairStatus || '',
                        });
                        pushLine('child_bar', [
                            [Math.min(...descendantXs), descendantConnectorY],
                            [Math.max(...descendantXs), descendantConnectorY],
                        ], {
                            familyId: descendantFamily.id,
                            relationKind: getClassicTreeRelationKind({
                                status: descendantFamily?.confidenceStatus,
                                pairStatus: descendantFamily?.pairStatus,
                                hasWarnings: descendantFamily?.hasWarnings,
                                hasConflicts: descendantFamily?.hasConflicts,
                            }),
                            confidenceStatus: descendantFamily?.confidenceStatus || '',
                            pairStatus: descendantFamily?.pairStatus || '',
                        });
                        descendantChildIds.forEach((descChildId) => {
                            const descChildX = positionedNodes[descChildId]?.x;
                            if (!Number.isFinite(descChildX)) return;
                            pushLine('child_bar', [
                                [descChildX, descendantConnectorY],
                                [descChildX, childTop],
                            ], {
                                familyId: descendantFamily.id,
                                toId: descChildId,
                                relationKind: getClassicTreeRelationKind({
                                    status: descendantFamily?.confidenceStatus,
                                    pairStatus: descendantFamily?.pairStatus,
                                    hasWarnings: descendantFamily?.hasWarnings,
                                    hasConflicts: descendantFamily?.hasConflicts,
                                }),
                                confidenceStatus: descendantFamily?.confidenceStatus || '',
                                pairStatus: descendantFamily?.pairStatus || '',
                            });
                        });
                    });
                };

                const buildMultiMarriageSlotsForParent = (parentId, familyIds, parentGeneration, childGeneration) => {
                    const parentNode = positionedNodes[parentId];
                    if (!parentNode) return null;
                    const parentY = getYForGeneration(parentGeneration);
                    const descendantChildY = getYForGeneration(childGeneration);
                    const parentBottom = parentY + (opts.nodeHeight / 2);
                    const childTop = descendantChildY - (opts.nodeHeight / 2);
                    const railY = parentBottom + Number(opts?.descendantMarriageGap || 44);
                    const spouseY = railY + (opts.nodeHeight / 2) + 16;
                    const spouseTop = spouseY - (opts.nodeHeight / 2);
                    const spouseBottom = spouseY + (opts.nodeHeight / 2);
                    const connectorRoom = Math.max(18, childTop - spouseBottom - 18);
                    const childConnectorY = Math.min(childTop - 14, spouseBottom + Math.max(18, connectorRoom * 0.42));
                    const orderedFamilies = familyIds
                        .map((familyId) => familyById[familyId])
                        .filter(Boolean);
                    const primaryFamily = orderedFamilies.find((family) => family?.isPrimaryMarriage) || orderedFamilies[0];
                    const primaryIndex = orderedFamilies.findIndex((family) => family?.id === primaryFamily?.id);
                    const slotGap = Number(opts?.marriageSlotGap || 42);
                    const padding = Number(opts?.familyGroupPadding || 18);
                    const slots = orderedFamilies.map((family) => {
                        const spouseIds = Array.isArray(family?.spouseIds) ? family.spouseIds.filter(Boolean) : [];
                        const spouseId = spouseIds.find((id) => id !== parentId) || '';
                        const childIds = (Array.isArray(family?.visibleChildIds) ? family.visibleChildIds : (Array.isArray(family?.childrenOfMarriage) ? family.childrenOfMarriage : family?.childIds || []))
                            .filter((childId) => persons?.[childId]);
                        const childSpan = childIds.length > 0
                            ? (childIds.length * opts.nodeWidth) + (Math.max(0, childIds.length - 1) * opts.siblingGap)
                            : 0;
                        const slotWidth = Math.min(
                            Number(opts?.maxMarriageSlotWidth || 780),
                            Math.max(opts.nodeWidth + (padding * 2), childSpan + (padding * 2)),
                        );
                        return {
                            familyId: family.id,
                            family,
                            spouseId,
                            childIds,
                            visibleChildIds: childIds,
                            hiddenChildrenCount: Number(family?.hiddenChildrenCount || 0),
                            pairStatus: family?.pairStatus || '',
                            isPrimaryMarriage: Boolean(family?.isPrimaryMarriage),
                            isRepeatedMarriage: Boolean(family?.isRepeatedMarriage),
                            marriageOrdinal: family?.marriageOrdinal,
                            marriageYear: family?.marriage?.year || family?.marriage?.marriageYear || null,
                            slotWidth,
                            childSpan,
                        };
                    });
                    if (primaryIndex < 0 || !slots.length) return null;

                    slots[primaryIndex].marriageHubX = parentNode.x;
                    slots[primaryIndex].slotX = parentNode.x - (slots[primaryIndex].slotWidth / 2);

                    let leftEdge = slots[primaryIndex].slotX;
                    for (let index = primaryIndex - 1; index >= 0; index -= 1) {
                        const slot = slots[index];
                        slot.slotX = leftEdge - slotGap - slot.slotWidth;
                        slot.marriageHubX = slot.slotX + (slot.slotWidth / 2);
                        leftEdge = slot.slotX;
                    }

                    let rightEdge = slots[primaryIndex].slotX + slots[primaryIndex].slotWidth;
                    for (let index = primaryIndex + 1; index < slots.length; index += 1) {
                        const slot = slots[index];
                        slot.slotX = rightEdge + slotGap;
                        slot.marriageHubX = slot.slotX + (slot.slotWidth / 2);
                        rightEdge = slot.slotX + slot.slotWidth;
                    }

                    slots.forEach((slot) => {
                        slot.spouseX = slot.marriageHubX;
                        slot.childrenXs = [];
                        if (slot.childIds.length > 0) {
                            let childCursor = slot.marriageHubX - (slot.childSpan / 2) + (opts.nodeWidth / 2);
                            slot.childIds.forEach((childId) => {
                                slot.childrenXs.push({ childId, x: childCursor });
                                childCursor += opts.nodeWidth + opts.siblingGap;
                            });
                        }
                    });

                    return {
                        slots,
                        railY,
                        spouseY,
                        spouseTop,
                        spouseBottom,
                        childConnectorY,
                        childTop,
                    };
                };

                const layoutMultiMarriageFamiliesForParent = (parentId, parentGeneration, childGeneration, config = {}) => {
                    const parentNode = positionedNodes[parentId];
                    if (!parentNode) return;
                    const familyIds = getVisibleDescendantFamilyIds(parentId, config);
                    if (familyIds.length <= 1) return;
                    const multi = buildMultiMarriageSlotsForParent(parentId, familyIds, parentGeneration, childGeneration);
                    if (!multi || !Array.isArray(multi?.slots) || multi.slots.length === 0) return;
                    const parentY = getYForGeneration(parentGeneration);
                    const railMinX = Math.min(...multi.slots.map((slot) => slot.marriageHubX));
                    const railMaxX = Math.max(...multi.slots.map((slot) => slot.marriageHubX));
                    pushLine('marriageRail', [
                        [parentNode.x, parentNode.y + (opts.nodeHeight / 2)],
                        [parentNode.x, multi.railY],
                    ], {
                        familyId: `${parentId}:rail`,
                        fromId: parentId,
                        relationKind: RELATION_KIND.marriage,
                        isRail: true,
                    });
                    if (railMaxX > railMinX) {
                        pushLine('marriageRail', [
                            [railMinX, multi.railY],
                            [railMaxX, multi.railY],
                        ], {
                            familyId: `${parentId}:rail-bar`,
                            fromId: parentId,
                            relationKind: RELATION_KIND.marriage,
                            isRail: true,
                        });
                    }

                    multi.slots.forEach((slot) => {
                        const descendantFamily = slot.family;
                        if (!descendantFamily) return;
                        frames.push({
                            kind: 'familyGroupFrame',
                            familyId: descendantFamily.id,
                            x: slot.slotX,
                            y: multi.railY - 18,
                            width: slot.slotWidth,
                            height: Math.max(88, (slot.childIds.length > 0 ? (multi.childTop - (multi.railY - 18)) : ((multi.spouseBottom + 18) - (multi.railY - 18)))),
                            pairStatus: descendantFamily?.pairStatus || '',
                            isPrimaryMarriage: Boolean(descendantFamily?.isPrimaryMarriage),
                            isRepeatedMarriage: Boolean(descendantFamily?.isRepeatedMarriage),
                            label: formatClassicTreeMarriageOrdinalLabel(descendantFamily),
                        });

                        const spouseId = slot.spouseId;
                        if (spouseId && persons[spouseId]) {
                            setNodePosition(spouseId, slot.spouseX, childGeneration + 0.5, {
                                customY: multi.spouseY,
                                roleLabel: persons[spouseId]?.roleLabel || (persons[spouseId]?.sex === 'MALE' ? 'Супруг' : 'Супруга'),
                            });
                        }

                        pushLine('marriage', [
                            [slot.marriageHubX - 16, multi.railY],
                            [slot.marriageHubX + 16, multi.railY],
                        ], {
                            familyId: descendantFamily.id,
                            fromId: parentId,
                            toId: spouseId,
                            marriage: descendantFamily?.marriage || null,
                            labelX: slot.marriageHubX,
                            labelY: multi.railY,
                            relationKind: descendantFamily?.relationKind || RELATION_KIND.marriage,
                            confidenceStatus: descendantFamily?.confidenceStatus || '',
                            pairStatus: descendantFamily?.pairStatus || '',
                            marriageOrdinal: descendantFamily?.marriageOrdinal,
                            isRepeatedMarriage: descendantFamily?.isRepeatedMarriage,
                            isPrimaryMarriage: descendantFamily?.isPrimaryMarriage,
                            isRail: true,
                        });

                        if (spouseId && persons[spouseId]) {
                            pushLine('marriageSlot', [
                                [slot.marriageHubX, multi.railY],
                                [slot.marriageHubX, multi.spouseTop],
                            ], {
                                familyId: descendantFamily.id,
                                relationKind: descendantFamily?.relationKind || RELATION_KIND.marriage,
                                confidenceStatus: descendantFamily?.confidenceStatus || '',
                                pairStatus: descendantFamily?.pairStatus || '',
                                isRail: true,
                            });
                        }

                        if (!slot.childrenXs.length) return;
                        slot.childrenXs.forEach((entry) => {
                            setNodePosition(entry.childId, entry.x, childGeneration, {
                                roleLabel: persons[entry.childId]?.roleLabel || 'Ребёнок',
                            });
                        });
                        const descendantXs = slot.childrenXs.map((entry) => entry.x).filter((value) => Number.isFinite(value));
                        if (!descendantXs.length) return;
                        const fromY = spouseId && persons[spouseId] ? multi.spouseBottom : multi.railY;
                        pushLine('descendant', [
                            [slot.marriageHubX, fromY],
                            [slot.marriageHubX, multi.childConnectorY],
                        ], {
                            familyId: descendantFamily.id,
                            fromId: parentId,
                            relationKind: getClassicTreeRelationKind({
                                status: descendantFamily?.confidenceStatus,
                                pairStatus: descendantFamily?.pairStatus,
                                hasWarnings: descendantFamily?.hasWarnings,
                                hasConflicts: descendantFamily?.hasConflicts,
                            }),
                            confidenceStatus: descendantFamily?.confidenceStatus || '',
                            pairStatus: descendantFamily?.pairStatus || '',
                        });
                        pushLine('child_bar', [
                            [Math.min(...descendantXs), multi.childConnectorY],
                            [Math.max(...descendantXs), multi.childConnectorY],
                        ], {
                            familyId: descendantFamily.id,
                            relationKind: getClassicTreeRelationKind({
                                status: descendantFamily?.confidenceStatus,
                                pairStatus: descendantFamily?.pairStatus,
                                hasWarnings: descendantFamily?.hasWarnings,
                                hasConflicts: descendantFamily?.hasConflicts,
                            }),
                            confidenceStatus: descendantFamily?.confidenceStatus || '',
                            pairStatus: descendantFamily?.pairStatus || '',
                        });
                        slot.childrenXs.forEach((entry) => {
                            pushLine('child_bar', [
                                [entry.x, multi.childConnectorY],
                                [entry.x, multi.childTop],
                            ], {
                                familyId: descendantFamily.id,
                                toId: entry.childId,
                                relationKind: getClassicTreeRelationKind({
                                    status: descendantFamily?.confidenceStatus,
                                    pairStatus: descendantFamily?.pairStatus,
                                    hasWarnings: descendantFamily?.hasWarnings,
                                    hasConflicts: descendantFamily?.hasConflicts,
                                }),
                                confidenceStatus: descendantFamily?.confidenceStatus || '',
                                pairStatus: descendantFamily?.pairStatus || '',
                            });
                        });
                    });
                };

                const layoutDescendantFamiliesForParent = (parentId, parentGeneration, childGeneration, config = {}) => {
                    const parentNode = positionedNodes[parentId];
                    if (!parentNode) return;
                    const familyIds = getVisibleDescendantFamilyIds(parentId, config);
                    if (familyIds.length === 0) return;
                    if (familyIds.length > 1) {
                        layoutMultiMarriageFamiliesForParent(parentId, parentGeneration, childGeneration, config);
                        return;
                    }
                    const plan = buildDescendantFamilyRenderPlan(parentId, config);
                    layoutSingleDescendantFamily(parentId, parentGeneration, childGeneration, plan);
                };

                childIds.forEach((childId) => {
                    const isFocusChild = childId === model.focusPersonId;
                    layoutDescendantFamiliesForParent(childId, 0, isFocusChild ? -1 : -2);
                });

                if (treeType !== 'family' && treeType !== 'direct') {
                    if (rootFamily?.fatherId) layoutDescendantFamiliesForParent(rootFamily.fatherId, 1, 0, { excludeFamilyId: rootFamily.id, includeOtherOnly: true });
                    if (rootFamily?.motherId) layoutDescendantFamiliesForParent(rootFamily.motherId, 1, 0, { excludeFamilyId: rootFamily.id, includeOtherOnly: true });
                }
            } else {
                setNodePosition(model.focusPersonId, 0, 0, { isFocus: true });
            }

            const nodeList = Object.values(positionedNodes);
            if (nodeList.length === 0) {
                return {
                    width: 0,
                    height: 0,
                    nodes: [],
                    lines: [],
                    rootId: model.focusPersonId,
                };
            }

            const pointXs = [];
            const pointYs = [];
            lines.forEach((line) => {
                (line?.points || []).forEach((point) => {
                    pointXs.push(Number(point?.[0] || 0));
                    pointYs.push(Number(point?.[1] || 0));
                });
            });

            const frameXs = [];
            const frameYs = [];
            frames.forEach((frame) => {
                frameXs.push(Number(frame?.x || 0), Number(frame?.x || 0) + Number(frame?.width || 0));
                frameYs.push(Number(frame?.y || 0), Number(frame?.y || 0) + Number(frame?.height || 0));
            });

            const minNodeX = Math.min(...nodeList.map((node) => node.x - (node.width / 2)));
            const maxNodeX = Math.max(...nodeList.map((node) => node.x + (node.width / 2)));
            const minNodeY = Math.min(...nodeList.map((node) => node.y - (node.height / 2)));
            const maxNodeY = Math.max(...nodeList.map((node) => node.y + (node.height / 2)));
            const minX = Math.min(minNodeX, ...(pointXs.length ? pointXs : [minNodeX]));
            const maxX = Math.max(maxNodeX, ...(pointXs.length ? pointXs : [maxNodeX]));
            const minY = Math.min(minNodeY, ...(pointYs.length ? pointYs : [minNodeY]));
            const maxY = Math.max(maxNodeY, ...(pointYs.length ? pointYs : [maxNodeY]));
            const boundsMinX = Math.min(minX, ...(frameXs.length ? frameXs : [minX]));
            const boundsMaxX = Math.max(maxX, ...(frameXs.length ? frameXs : [maxX]));
            const boundsMinY = Math.min(minY, ...(frameYs.length ? frameYs : [minY]));
            const boundsMaxY = Math.max(maxY, ...(frameYs.length ? frameYs : [maxY]));
            const shiftX = opts.margin - boundsMinX;
            const shiftY = opts.margin - boundsMinY;

            const shiftedNodes = nodeList.map((node) => ({
                ...node,
                x: node.x + shiftX,
                y: node.y + shiftY,
            }));
            const shiftedLines = lines.map((line) => ({
                ...line,
                points: (line?.points || []).map(([x, y]) => [x + shiftX, y + shiftY]),
            }));
            const shiftedFrames = frames.map((frame) => ({
                ...frame,
                x: Number(frame?.x || 0) + shiftX,
                y: Number(frame?.y || 0) + shiftY,
            }));

            return {
                width: Math.max(320, Math.ceil((boundsMaxX - boundsMinX) + (opts.margin * 2))),
                height: Math.max(240, Math.ceil((boundsMaxY - boundsMinY) + (opts.margin * 2))),
                nodes: shiftedNodes,
                lines: shiftedLines,
                frames: shiftedFrames,
                rootId: model.focusPersonId,
                maxAncestorDepth,
                viewOptions,
            };
        };

        const ParentsClassicTreeFamilyFrame = ({ frame, viewOptions = DEFAULT_CLASSIC_TREE_VIEW_OPTIONS }) => {
            if (!frame) return null;
            const pairStatusMeta = getClassicTreePairStatusMeta(frame?.pairStatus);
            const isProofMode = String(viewOptions?.treeType || '').trim() === 'proof';
            const isPrimary = Boolean(frame?.isPrimaryMarriage);
            const borderColor = frame?.pairStatus === 'beforeMarriage'
                ? 'rgba(181, 77, 77, 0.34)'
                : frame?.pairStatus === 'children' || frame?.pairStatus === 'noMarriage'
                    ? 'rgba(184, 145, 84, 0.3)'
                    : 'rgba(141, 121, 95, 0.2)';
            const background = isPrimary
                ? 'rgba(255, 250, 239, 0.92)'
                : 'rgba(255, 253, 248, 0.72)';
            const opacity = isPrimary || isProofMode ? 0.9 : 0.62;
            return (
                <g opacity={opacity}>
                    <rect
                        x={frame.x}
                        y={frame.y}
                        width={frame.width}
                        height={frame.height}
                        rx="18"
                        ry="18"
                        fill={background}
                        stroke={borderColor}
                        strokeWidth="1"
                        strokeDasharray={(frame?.pairStatus === 'children' || frame?.pairStatus === 'noMarriage' || frame?.pairStatus === 'beforeMarriage') ? '5 5' : undefined}
                    />
                    {frame?.label ? (
                        <foreignObject
                            x={frame.x + 10}
                            y={frame.y + 8}
                            width={Math.max(90, frame.width - 20)}
                            height={34}
                            style={{ overflow: 'visible' }}
                        >
                            <div
                                xmlns="http://www.w3.org/1999/xhtml"
                                data-no-tree-pan="true"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    maxWidth: '100%',
                                    borderRadius: '999px',
                                    border: '1px solid rgba(184,115,51,0.14)',
                                    background: 'rgba(255,252,246,0.88)',
                                    padding: '3px 10px',
                                    boxShadow: '0 2px 8px rgba(45,34,20,0.04)',
                                }}
                            >
                                <span style={{ fontSize: '8px', fontWeight: 800, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#7a4f1f', whiteSpace: 'nowrap' }}>
                                    {frame.label}
                                </span>
                                {!isPrimary ? (
                                    <span style={{ fontSize: '8px', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#9b8a76', whiteSpace: 'nowrap' }}>
                                        боковой
                                    </span>
                                ) : null}
                                {pairStatusMeta?.label && frame?.pairStatus && frame?.pairStatus !== 'marriage' ? (
                                    <span style={{ fontSize: '8px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8d7258', whiteSpace: 'nowrap' }}>
                                        {pairStatusMeta.label}
                                    </span>
                                ) : null}
                            </div>
                        </foreignObject>
                    ) : null}
                </g>
            );
        };

        const buildClassicTreeLineSegments = (line) => {
            const points = Array.isArray(line?.points)
                ? line.points.filter((point) => Array.isArray(point) && point.length >= 2)
                : [];
            const segments = [];
            for (let index = 0; index < points.length - 1; index += 1) {
                const start = points[index];
                const end = points[index + 1];
                if (!start || !end) continue;
                segments.push([start, end]);
            }
            return segments;
        };

        const ParentsClassicTreeMarriageBadge = ({ line, onOpenRow, viewOptions = DEFAULT_CLASSIC_TREE_VIEW_OPTIONS }) => {
            const marriage = line?.marriage || null;
            const pairStatusMeta = getClassicTreePairStatusMeta(line?.pairStatus);
            if (!marriage && !line?.pairStatus) return null;
            const statusMeta = getParentsAncestryStatusMeta(marriage?.adjustedStatus || marriage?.status);
            const hasSource = Boolean(marriage?.source?.itemId);
            const year = Number(marriage?.year || marriage?.marriageYear || 0);
            const yearText = (Number.isFinite(year) && year > 0) ? String(year) : '';
            const ordinalText = line?.isRepeatedMarriage ? formatClassicTreeRomanOrdinal(line?.marriageOrdinal) : '';
            const ordinalLongText = line?.isRepeatedMarriage && Number(line?.marriageOrdinal || 0) > 0
                ? `${Number(line?.marriageOrdinal || 0)}-й брак`
                : '';
            const compactMainText = yearText
                || (line?.pairStatus === 'children' || line?.pairStatus === 'noMarriage' ? 'дети' : line?.pairStatus === 'beforeMarriage' ? 'до брака' : '');
            const statusDotColor = (marriage?.adjustedStatus || marriage?.status) === 'auto' || marriage?.status === 'confirmed'
                ? '#7a9b6c'
                : (marriage?.adjustedStatus || marriage?.status) === 'probable'
                    ? '#c8a14a'
                    : '#b87a4a';
            const showConfidence = Boolean(viewOptions?.showConfidence);
            const showSources = Boolean(viewOptions?.showSources);
            const showStatusLabel = Boolean(line?.pairStatus && line?.pairStatus !== 'marriage');
            const showOrdinalLabel = Boolean(ordinalText);
            const badgeHeight = showStatusLabel || showOrdinalLabel ? 42 : 30;
            const badgeWidth = Math.max(84, Math.min(212, 84 + ((pairStatusMeta?.label?.length || 0) * 4) + (yearText ? 24 : 0) + (ordinalText ? 16 : 0)));
            const x = Number(line?.labelX || 0) - (badgeWidth / 2);
            const y = Number(line?.labelY || 0) - (badgeHeight / 2);
            const titleText = marriage?.sourceLabel
                || (yearText ? `Брак · ${yearText}${ordinalLongText ? ` · ${ordinalLongText}` : ''}${hasSource ? ' · открыть запись' : ''}` : `${pairStatusMeta?.label || 'Брак'}${ordinalLongText ? ` · ${ordinalLongText}` : ''}${hasSource ? ' · открыть запись' : ''}`);
            const handleActivate = (event) => {
                if (!hasSource) return;
                event.stopPropagation();
                if (typeof onOpenRow === 'function') {
                    onOpenRow({ itemId: marriage.source.itemId });
                }
            };
            return (
                <foreignObject x={x} y={y} width={badgeWidth} height={badgeHeight} style={{ overflow: 'visible' }}>
                    <div
                        xmlns="http://www.w3.org/1999/xhtml"
                        data-no-tree-pan="true"
                        title={titleText}
                        style={{
                            pointerEvents: 'auto',
                            height: '100%',
                            display: 'inline-flex',
                            flexDirection: showStatusLabel ? 'column' : 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: showStatusLabel ? '1px' : '5px',
                            padding: showStatusLabel ? '4px 10px 3px' : '0 10px',
                            borderRadius: '16px',
                            border: `1px ${pairStatusMeta?.tone === 'dashed' || pairStatusMeta?.tone === 'warning' ? 'dashed' : 'solid'} rgba(184,115,51,0.34)`,
                            background: pairStatusMeta?.tone === 'warning'
                                ? 'linear-gradient(180deg, #fffaf7 0%, #fde7de 100%)'
                                : 'linear-gradient(180deg, #fffbf2 0%, #faecd1 100%)',
                            boxShadow: '0 3px 10px rgba(86,55,20,0.12), inset 0 1px 0 rgba(255,255,255,0.85)',
                            cursor: hasSource ? 'pointer' : 'default',
                            position: 'relative',
                        }}
                        role={hasSource ? 'button' : undefined}
                        tabIndex={hasSource ? 0 : undefined}
                        onClick={handleActivate}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                handleActivate(event);
                            }
                        }}
                    >
                        <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                            <span
                                aria-hidden="true"
                                style={{
                                    fontSize: '13px',
                                    lineHeight: 1,
                                    color: '#a06a2f',
                                    flexShrink: 0,
                                    fontWeight: 700,
                                    marginTop: '-1px',
                                }}
                            >
                                ⚭
                            </span>
                            {compactMainText ? (
                                <span
                                    style={{
                                        fontFamily: '"Cormorant Garamond", "Playfair Display", "Times New Roman", serif',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#5e3a18',
                                        lineHeight: 1,
                                        letterSpacing: '0.02em',
                                        flexShrink: 0,
                                    }}
                                >
                                    {compactMainText}
                                </span>
                            ) : (
                                <span
                                    style={{
                                        fontSize: '9px',
                                        fontWeight: 700,
                                        color: '#7a4f1f',
                                        letterSpacing: '0.14em',
                                        textTransform: 'uppercase',
                                        lineHeight: 1,
                                        flexShrink: 0,
                                    }}
                                >
                                    Брак
                                </span>
                            )}
                            {showConfidence && marriage?.status ? (
                                <span
                                    style={{
                                        fontSize: '8px',
                                        fontWeight: 700,
                                        color: statusMeta.color || '#7a4f1f',
                                        letterSpacing: '0.08em',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    {statusMeta.label}
                                </span>
                            ) : null}
                            {showOrdinalLabel ? (
                                <span
                                    style={{
                                        fontSize: '8px',
                                        fontWeight: 800,
                                        color: '#7a4f1f',
                                        letterSpacing: '0.08em',
                                        textTransform: 'uppercase',
                                        lineHeight: 1,
                                        flexShrink: 0,
                                    }}
                                >
                                    {ordinalText}
                                </span>
                            ) : null}
                        </div>
                        {(showStatusLabel || showOrdinalLabel) ? (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '6px',
                                    maxWidth: '100%',
                                    flexWrap: 'wrap',
                                }}
                            >
                                {showStatusLabel ? (
                                    <span
                                        style={{
                                            fontSize: '8px',
                                            lineHeight: 1.1,
                                            color: '#7a4f1f',
                                            letterSpacing: '0.08em',
                                            textTransform: 'uppercase',
                                            fontWeight: 700,
                                            textAlign: 'center',
                                            maxWidth: '100%',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {pairStatusMeta.label}
                                    </span>
                                ) : null}
                                {showOrdinalLabel ? (
                                    <span
                                        style={{
                                            fontSize: '8px',
                                            lineHeight: 1.1,
                                            color: '#8a6a40',
                                            letterSpacing: '0.12em',
                                            textTransform: 'uppercase',
                                            fontWeight: 700,
                                            textAlign: 'center',
                                        }}
                                    >
                                        {ordinalLongText}
                                    </span>
                                ) : null}
                            </div>
                        ) : null}
                        {showSources && hasSource ? (
                            <span
                                style={{
                                    position: 'absolute',
                                    bottom: '-6px',
                                    right: '6px',
                                    fontSize: '8px',
                                    fontWeight: 800,
                                    letterSpacing: '0.12em',
                                    textTransform: 'uppercase',
                                    color: '#8b0000',
                                    background: '#fff9ef',
                                    border: '1px solid rgba(139,0,0,0.14)',
                                    borderRadius: '999px',
                                    padding: '1px 6px',
                                }}
                            >
                                Брак ↗
                            </span>
                        ) : null}
                        {marriage?.status ? (
                            <span
                                title={statusMeta.label}
                                aria-hidden="true"
                                style={{
                                    position: 'absolute',
                                    top: '-3px',
                                    right: '-3px',
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '999px',
                                        background: statusDotColor,
                                        boxShadow: '0 0 0 2px #faecd1',
                                    }}
                                />
                            ) : null}
                    </div>
                </foreignObject>
            );
        };

        const ParentsClassicTreeNode = ({ node, onOpenRow, viewOptions = DEFAULT_CLASSIC_TREE_VIEW_OPTIONS }) => {
            const isChildrenSummary = node?.kind === 'childrenSummary';
            const tone = getClassicTreeStatusTone(node?.confidenceStatus, {
                isFocus: Boolean(node?.isFocus) && !isChildrenSummary,
                isMissing: Boolean(node?.isMissing || isChildrenSummary),
            });
            const statusMeta = getParentsAncestryStatusMeta(node?.adjustedStatus || node?.confidenceStatus);
            const identityMeta = getParentsAncestryStatusMeta(node?.identityProfileStatus);
            const sourceItemId = node?.source?.itemId;
            const sex = String(node?.sex || '').trim().toUpperCase();
            const sexTone = getClassicTreeSexTone(sex);
            const cardDetail = String(node?.cardDetail || viewOptions?.cardDetail || 'medium').trim();
            const showSources = Boolean(viewOptions?.showSources);
            const showConfidence = Boolean(viewOptions?.showConfidence);
            const showLifeProfile = Boolean(viewOptions?.showLifeProfile);
            const showConflicts = Boolean(viewOptions?.showConflicts);
            const isProofMode = String(viewOptions?.treeType || '').trim() === 'proof';
            const hasLifeWarnings = Array.isArray(node?.identityProfileWarnings) && node.identityProfileWarnings.length > 0;
            const hasLifeConflicts = Array.isArray(node?.identityProfileConflicts) && node.identityProfileConflicts.length > 0;
            const sourceSnippet = String(node?.sourceLabel || getClassicTreeSourceSnippet(node?.source)).trim();
            const openSource = useCallback(() => {
                if (sourceItemId && typeof onOpenRow === 'function') {
                    onOpenRow({ itemId: sourceItemId });
                }
            }, [onOpenRow, sourceItemId]);
            const statusGlyph = statusMeta.label === 'Уверенная связь' ? '✓' : statusMeta.label === 'Вероятная связь' ? '≈' : statusMeta.label === 'Гипотеза' ? '?' : '!';
            if (isChildrenSummary) {
                return (
                    <foreignObject
                        x={node.x - (node.width / 2)}
                        y={node.y - (node.height / 2)}
                        width={node.width}
                        height={node.height}
                        data-no-tree-pan="true"
                    >
                        <div
                            xmlns="http://www.w3.org/1999/xhtml"
                            data-no-tree-pan="true"
                            style={{
                                height: '100%',
                                borderRadius: '14px',
                                border: '1px dashed rgba(158, 145, 128, 0.42)',
                                background: 'linear-gradient(180deg, rgba(255,253,248,0.96) 0%, rgba(247,241,232,0.94) 100%)',
                                boxShadow: '0 4px 10px rgba(45,34,20,0.04)',
                                padding: '8px 10px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                gap: '3px',
                                textAlign: 'center',
                                color: '#75695d',
                            }}
                        >
                            <div style={{ fontSize: '8px', fontWeight: 800, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#8f7f6d' }}>
                                {node?.roleLabel || 'Дети этого брака'}
                            </div>
                            <div style={{ fontFamily: '"Cormorant Garamond", "Playfair Display", "Times New Roman", serif', fontSize: '14px', lineHeight: 1.15, color: '#4c4035', fontWeight: 600 }}>
                                {node?.label || 'Ещё дети'}
                            </div>
                        </div>
                    </foreignObject>
                );
            }
            return (
                <foreignObject
                    x={node.x - (node.width / 2)}
                    y={node.y - (node.height / 2)}
                    width={node.width}
                    height={node.height}
                    data-no-tree-pan="true"
                >
                    <div
                        xmlns="http://www.w3.org/1999/xhtml"
                        data-no-tree-pan="true"
                        role={sourceItemId ? 'button' : undefined}
                        tabIndex={sourceItemId ? 0 : undefined}
                        onClick={openSource}
                        onDoubleClick={openSource}
                        onKeyDown={(event) => {
                            if (!sourceItemId) return;
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                openSource();
                            }
                        }}
                        style={{
                            height: '100%',
                            borderRadius: '12px',
                            border: `1px ${tone.borderStyle} ${tone.borderColor}`,
                            background: node?.isFocus
                                ? `linear-gradient(180deg, rgba(255,250,236,1) 0%, rgba(254,240,214,1) 100%)`
                                : `linear-gradient(180deg, #ffffff 0%, #fbf6ec 100%)`,
                            boxShadow: node?.isFocus ? tone.shadow : '0 6px 16px rgba(45,34,20,0.06), inset 0 1px 0 rgba(255,255,255,0.85)',
                            opacity: tone.opacity,
                            padding: cardDetail === 'short' ? '10px 12px' : '11px 13px',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: cardDetail === 'short' ? '5px' : '7px',
                            color: '#2b2118',
                            cursor: sourceItemId ? 'pointer' : 'default',
                            position: 'relative',
                        }}
                    >
                        <div
                            aria-hidden="true"
                            style={{
                                position: 'absolute',
                                inset: '0',
                                pointerEvents: 'none',
                                background: `linear-gradient(180deg, ${sexTone.borderOverlay} 0%, transparent 34%)`,
                            }}
                        />
                        {showConflicts && hasLifeConflicts ? (
                            <div style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '4px', background: '#c46b6b' }} />
                        ) : null}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '8px',
                                flexShrink: 0,
                            }}
                        >
                            <div className="min-w-0" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                <div style={{ fontSize: '8px', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: node?.isFocus ? '#a56028' : '#8b7c6a' }}>
                                    {node?.roleLabel || 'Персона'}
                                </div>
                            </div>
                            <div className="flex shrink-0 items-center gap-1.5">
                                {showConfidence && node?.confidenceStatus ? (
                                    <span
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            minWidth: '18px',
                                            height: '18px',
                                            padding: '0 6px',
                                            borderRadius: '999px',
                                            background: tone.badgeBackground,
                                            color: tone.badgeColor,
                                            fontSize: '7px',
                                            fontWeight: 800,
                                            letterSpacing: '0.08em',
                                            textTransform: 'uppercase',
                                        }}
                                        title={statusMeta.description}
                                    >
                                        {statusGlyph}
                                    </span>
                                ) : null}
                                {showLifeProfile && node?.identityProfileStatus ? (
                                    <span
                                        title={node?.identityProfileStatus === 'conflict' ? 'Конфликт биографии' : node?.identityProfileStatus === 'auto' ? 'Биография подтверждает' : 'Биография вероятна'}
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            minWidth: '18px',
                                            height: '18px',
                                            padding: '0 6px',
                                            borderRadius: '999px',
                                            background: node?.identityProfileStatus === 'conflict' ? '#fde8e8' : '#eef3e7',
                                            color: node?.identityProfileStatus === 'conflict' ? '#a94f4f' : '#61734d',
                                            fontSize: '7px',
                                            fontWeight: 800,
                                            letterSpacing: '0.08em',
                                            textTransform: 'uppercase',
                                        }}
                                    >
                                        биогр.
                                    </span>
                                ) : null}
                                {sex === 'MALE' ? <span style={{ fontSize: '10px', color: sexTone.glyphColor }}>♂</span> : null}
                                {sex === 'FEMALE' ? <span style={{ fontSize: '10px', color: sexTone.glyphColor }}>♀</span> : null}
                            </div>
                        </div>

                        <div
                            className="searchable-value"
                            title={node?.label || ''}
                            style={{
                                fontFamily: '"Cormorant Garamond", "Playfair Display", "Times New Roman", serif',
                                fontSize: cardDetail === 'short' ? '15px' : cardDetail === 'full' ? '17px' : '16px',
                                fontWeight: 600,
                                lineHeight: 1.14,
                                color: '#1a1715',
                                overflow: 'hidden',
                                wordBreak: 'break-word',
                                flexShrink: 0,
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '4px',
                            }}
                        >
                            <span style={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                wordBreak: 'break-word',
                                minWidth: 0,
                                flex: 1,
                            }}>
                                {node?.label || 'Без имени'}
                            </span>
                            {node?.label && cardDetail !== 'short' ? (
                                <button
                                    type="button"
                                    data-no-tree-pan="true"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        requestGlobalSearch(node.label, 'name');
                                    }}
                                    title={`Найти «${node.label}» в каталоге`}
                                    aria-label={`Найти «${node.label}» в каталоге`}
                                    className="searchable-value__lens"
                                    style={{
                                        flexShrink: 0,
                                        marginTop: '3px',
                                        width: '17px',
                                        height: '17px',
                                        padding: 0,
                                        border: '1px solid rgba(139,0,0,0.18)',
                                        borderRadius: '999px',
                                        background: 'rgba(255,250,242,0.92)',
                                        color: '#8b0000',
                                        fontSize: '10px',
                                        lineHeight: 1,
                                        cursor: 'pointer',
                                        opacity: 0,
                                        transition: 'opacity 0.15s ease, transform 0.15s ease',
                                    }}
                                >
                                    ⌕
                                </button>
                            ) : null}
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: cardDetail === 'full' ? '4px' : '2px', flex: 1, minHeight: 0, overflow: 'hidden' }}>
                            {cardDetail === 'full' ? (
                                <>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', flexShrink: 0 }}>
                                        {formatClassicTreeYear(node?.birthYear, node?.isMissing) ? (
                                            <div style={{ fontFamily: '"Lora", serif', fontSize: '11px', color: '#8a7e68', lineHeight: 1.28 }}>
                                                {formatClassicTreeYear(node?.birthYear, node?.isMissing)}
                                            </div>
                                        ) : null}
                                        {formatClassicTreeDeath(node?.deathYear, node?.deathAge, node?.deathYearLabel) ? (
                                            <div style={{ fontFamily: '"Lora", serif', fontSize: '10.5px', color: '#826454', lineHeight: 1.28 }}>
                                                {'† '}
                                                {formatClassicTreeDeath(node?.deathYear, node?.deathAge, node?.deathYearLabel).replace(/^ум\.\s*/i, '')}
                                            </div>
                                        ) : null}
                                    </div>
                                    {node?.birthPlace ? (
                                        <div
                                            title={node.birthPlace}
                                            style={{
                                                fontFamily: '"Lora", serif',
                                                fontSize: '10.5px',
                                                color: '#8a7d70',
                                                lineHeight: 1.32,
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            {node.birthPlace}
                                        </div>
                                    ) : null}
                                    {showSources && sourceSnippet ? (
                                        <div
                                            title={sourceSnippet}
                                            style={{
                                                paddingTop: '4px',
                                                borderTop: '1px solid rgba(139,125,112,0.12)',
                                                fontSize: '9px',
                                                color: '#7d6f61',
                                                lineHeight: 1.32,
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            <span style={{ fontWeight: 700, color: '#6f6155' }}>Источник:</span> {sourceSnippet}
                                        </div>
                                    ) : null}
                                </>
                            ) : (
                                <>
                                    {formatClassicTreeYear(node?.birthYear, node?.isMissing) ? (
                                        <div style={{ fontFamily: '"Lora", serif', fontSize: cardDetail === 'short' ? '10px' : '11px', color: '#8a7e68', lineHeight: 1.25, flexShrink: 0 }}>
                                            {formatClassicTreeYear(node?.birthYear, node?.isMissing)}
                                        </div>
                                    ) : null}
                                    {formatClassicTreeDeath(node?.deathYear, node?.deathAge, node?.deathYearLabel) ? (
                                        <div style={{ fontFamily: '"Lora", serif', fontSize: cardDetail === 'short' ? '9.5px' : '10.5px', color: '#826454', lineHeight: 1.25, flexShrink: 0 }}>
                                            {'† '}
                                            {formatClassicTreeDeath(node?.deathYear, node?.deathAge, node?.deathYearLabel).replace(/^ум\.\s*/i, '')}
                                        </div>
                                    ) : null}
                                    {cardDetail !== 'short' && node?.birthPlace ? (
                                        <div
                                            title={node.birthPlace}
                                            style={{
                                                fontFamily: '"Lora", serif',
                                                fontSize: '10.5px',
                                                color: '#8a7d70',
                                                lineHeight: 1.3,
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                wordBreak: 'break-word',
                                                marginTop: '2px',
                                            }}
                                        >
                                            {node.birthPlace}
                                        </div>
                                    ) : null}
                                </>
                            )}
                            {cardDetail !== 'short' && (isProofMode || (showConflicts && (hasLifeWarnings || hasLifeConflicts))) ? (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
                                    {showLifeProfile && node?.identityProfileStatus ? (
                                        <span
                                            style={{
                                                fontSize: '8px',
                                                fontWeight: 700,
                                                letterSpacing: '0.08em',
                                                textTransform: 'uppercase',
                                                padding: '2px 6px',
                                                borderRadius: '999px',
                                                border: `1px solid ${node?.identityProfileStatus === 'conflict' ? '#efc2c2' : '#d6ddc8'}`,
                                                background: node?.identityProfileStatus === 'conflict' ? '#fff2f2' : '#f4f7ee',
                                                color: node?.identityProfileStatus === 'conflict' ? '#a15454' : '#6a7853',
                                            }}
                                            title={identityMeta.description}
                                        >
                                            {node?.identityProfileStatus === 'conflict' ? 'конфликт биографии' : node?.identityProfileStatus === 'auto' ? 'биография подтверждает' : 'биография вероятна'}
                                        </span>
                                    ) : null}
                                    {showConflicts && hasLifeWarnings ? (
                                        <span
                                            style={{
                                                fontSize: '8px',
                                                fontWeight: 700,
                                                letterSpacing: '0.08em',
                                                textTransform: 'uppercase',
                                                padding: '2px 6px',
                                                borderRadius: '999px',
                                                border: '1px solid #f1d8ae',
                                                background: '#fff7e7',
                                                color: '#8e6a28',
                                            }}
                                            title={node.identityProfileWarnings.join('\n')}
                                        >
                                            предупреждение
                                        </span>
                                    ) : null}
                                    {showConflicts && hasLifeConflicts ? (
                                        <span
                                            style={{
                                                fontSize: '8px',
                                                fontWeight: 700,
                                                letterSpacing: '0.08em',
                                                textTransform: 'uppercase',
                                                padding: '2px 6px',
                                                borderRadius: '999px',
                                                border: '1px solid #e9bcbc',
                                                background: '#fff2f2',
                                                color: '#a15454',
                                            }}
                                            title={node.identityProfileConflicts.join('\n')}
                                        >
                                            конфликт
                                        </span>
                                    ) : null}
                                </div>
                            ) : null}
                        </div>

                        {showSources && sourceItemId ? (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
                                <button
                                    type="button"
                                    data-no-tree-pan="true"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        openSource();
                                    }}
                                    style={{
                                        padding: '3px 8px',
                                        borderRadius: '999px',
                                        border: '1px solid rgba(184,115,51,0.25)',
                                        background: 'rgba(255,250,242,0.95)',
                                        color: '#8b5a2b',
                                        fontSize: '8px',
                                        fontWeight: 800,
                                        letterSpacing: '0.14em',
                                        textTransform: 'uppercase',
                                    }}
                                    title="Открыть запись"
                                >
                                    {cardDetail === 'full' ? 'Открыть источник ↗' : 'Источник ↗'}
                                </button>
                            </div>
                        ) : null}
                    </div>
                </foreignObject>
            );
        };

        const ParentsClassicTreeSvg = ({ layout, onOpenRow, svgRef = null, viewOptions = DEFAULT_CLASSIC_TREE_VIEW_OPTIONS }) => {
            const nodes = Array.isArray(layout?.nodes) ? layout.nodes : [];
            const lines = Array.isArray(layout?.lines) ? layout.lines : [];
            const frames = Array.isArray(layout?.frames) ? layout.frames : [];
            if (!nodes.length) return null;
            return (
                <svg
                    ref={svgRef}
                    width={layout?.width || 0}
                    height={layout?.height || 0}
                    viewBox={`0 0 ${layout?.width || 0} ${layout?.height || 0}`}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs />
                    <g>
                        {frames.map((frame, index) => (
                            <ParentsClassicTreeFamilyFrame
                                key={`${frame?.familyId || 'frame'}-${index}`}
                                frame={frame}
                                viewOptions={viewOptions}
                            />
                        ))}
                    </g>
                    <g>
                        {lines.map((line, index) => {
                            const points = Array.isArray(line?.points)
                                ? line.points.filter((point) => Array.isArray(point) && point.length >= 2)
                                : [];
                            const segments = buildClassicTreeLineSegments(line);
                            if (!segments.length) return null;
                            if (!viewOptions?.showHypotheses && line?.relationKind === RELATION_KIND.hypothesis) return null;
                            if (!viewOptions?.showConflicts && line?.relationKind === RELATION_KIND.conflict) return null;
                            const stroke = getClassicTreeLineColor(line, viewOptions);
                            const strokeWidth = getClassicTreeLineWidth(line, viewOptions);
                            const opacity = getClassicTreeLineOpacity(line, viewOptions);
                            const dashArray = getClassicTreeLineDashArray(line, viewOptions);
                            if (line?.kind === 'marriage' && segments.length === 1) {
                                const [[x1, y1], [x2, y2]] = segments[0];
                                const offset = 1.6;
                                const isHorizontal = Math.abs(x2 - x1) >= Math.abs(y2 - y1);
                                return (
                                    <g key={`${line?.kind || 'line'}-${index}`} opacity={opacity}>
                                        <line
                                            x1={isHorizontal ? x1 : x1 - offset}
                                            y1={isHorizontal ? y1 - offset : y1}
                                            x2={isHorizontal ? x2 : x2 - offset}
                                            y2={isHorizontal ? y2 - offset : y2}
                                            stroke={stroke}
                                            strokeWidth={strokeWidth}
                                            strokeLinecap="round"
                                            strokeDasharray={dashArray || undefined}
                                        />
                                        <line
                                            x1={isHorizontal ? x1 : x1 + offset}
                                            y1={isHorizontal ? y1 + offset : y1}
                                            x2={isHorizontal ? x2 : x2 + offset}
                                            y2={isHorizontal ? y2 + offset : y2}
                                            stroke={stroke}
                                            strokeWidth={strokeWidth}
                                            strokeLinecap="round"
                                            strokeDasharray={dashArray || undefined}
                                        />
                                    </g>
                                );
                            }
                            if (points.length > 2) {
                                const d = makeClassicTreePath(points);
                                if (!d) return null;
                                return (
                                    <path
                                        key={`${line?.kind || 'line'}-${index}`}
                                        d={d}
                                        fill="none"
                                        stroke={stroke}
                                        strokeWidth={strokeWidth}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        opacity={opacity}
                                        strokeDasharray={dashArray || undefined}
                                    />
                                );
                            }
                            return (
                                <g key={`${line?.kind || 'line'}-${index}`} opacity={opacity}>
                                    {segments.map((segment, segmentIndex) => (
                                        <line
                                            key={`${index}-${segmentIndex}`}
                                            x1={segment[0][0]}
                                            y1={segment[0][1]}
                                            x2={segment[1][0]}
                                            y2={segment[1][1]}
                                            stroke={stroke}
                                            strokeWidth={strokeWidth}
                                            strokeLinecap="round"
                                            strokeDasharray={dashArray || undefined}
                                        />
                                    ))}
                                </g>
                            );
                        })}
                        {lines.map((line, index) => (
                            line?.kind === 'marriage'
                                ? <ParentsClassicTreeMarriageBadge key={`marriage-badge-${index}`} line={line} onOpenRow={onOpenRow} viewOptions={viewOptions} />
                                : null
                        ))}
                    </g>
                    <g>
                        {nodes.map((node) => (
                            <ParentsClassicTreeNode key={node.id} node={node} onOpenRow={onOpenRow} viewOptions={viewOptions} />
                        ))}
                    </g>
                </svg>
            );
        };

        const ParentsClassicTreeOptionSelect = ({ label, value, options, onChange }) => (
            <label className="block">
                <div className="mb-1 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-500">{label}</div>
                <select
                    value={value}
                    onChange={(event) => onChange(event.target.value)}
                    className="w-full rounded-xl border border-stone-200 bg-white px-3 py-2 text-[12px] text-stone-700 outline-none transition-colors focus:border-[#8b0000]/45"
                >
                    {Object.entries(options || {}).map(([optionValue, optionLabel]) => (
                        <option key={optionValue} value={optionValue}>{optionLabel}</option>
                    ))}
                </select>
            </label>
        );

        const ParentsClassicTreeToggle = ({ label, checked, onChange }) => (
            <label className="flex items-center gap-2 rounded-xl border border-stone-200 bg-white px-3 py-2 text-[12px] text-stone-700">
                <input type="checkbox" checked={checked} onChange={(event) => onChange(event.target.checked)} className="h-4 w-4 accent-[#8b0000]" />
                <span>{label}</span>
            </label>
        );

        const ParentsClassicTreeToolbar = ({
            scale = 1,
            viewOptions = DEFAULT_CLASSIC_TREE_VIEW_OPTIONS,
            onChangeViewOptions,
            onZoomOut,
            onReset,
            onZoomIn,
            onCenter,
            onFit,
            onExportSvg,
            onExportPng,
            onPrint,
        }) => {
            const [settingsOpen, setSettingsOpen] = useState(false);
            const patchOptions = useCallback((patch) => {
                if (typeof onChangeViewOptions === 'function') {
                    onChangeViewOptions((prev) => ({ ...prev, ...patch }));
                }
            }, [onChangeViewOptions]);
            return (
                <div className="relative flex flex-wrap items-center gap-2 rounded-[18px] border border-stone-200 bg-[rgba(255,252,246,0.95)] px-3 py-3 shadow-[0_10px_24px_rgba(45,34,20,0.05)]">
                    <button type="button" onClick={onZoomOut} className="rounded-full border border-stone-300 bg-white px-3 py-2 text-[12px] font-bold text-stone-700 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]">−</button>
                    <button type="button" onClick={onReset} className="rounded-full border border-stone-300 bg-white px-3 py-2 text-[11px] font-bold uppercase tracking-[0.12em] text-stone-700 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]">
                        {Math.round((Number(scale) || 1) * 100)}%
                    </button>
                    <button type="button" onClick={onZoomIn} className="rounded-full border border-stone-300 bg-white px-3 py-2 text-[12px] font-bold text-stone-700 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]">+</button>
                    <button type="button" onClick={onCenter} className="rounded-full border border-stone-300 bg-white px-3 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-600 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]">
                        По центру
                    </button>
                    <button type="button" onClick={onFit} className="rounded-full border border-[#8b0000]/18 bg-[#fff5f1] px-3 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-[#8b0000] transition-colors hover:bg-[#ffece3]">
                        Подогнать
                    </button>
                    <div className="mx-1 h-6 w-px bg-stone-200" />
                    <button type="button" onClick={onExportSvg} className="rounded-full border border-stone-300 bg-white px-3 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-700 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]">
                        Скачать SVG
                    </button>
                    <button type="button" onClick={onExportPng} className="rounded-full border border-stone-300 bg-white px-3 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-700 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]">
                        Скачать PNG
                    </button>
                    <button type="button" onClick={onPrint} className="rounded-full border border-stone-300 bg-white px-3 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-700 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]">
                        Печать
                    </button>
                    <button type="button" onClick={() => setSettingsOpen((value) => !value)} className="rounded-full border border-[#8b0000]/18 bg-[#fff5f1] px-3 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-[#8b0000] transition-colors hover:bg-[#ffece3]">
                        Настройки схемы
                    </button>

                    {settingsOpen ? (
                        <div className="absolute left-0 top-[calc(100%+10px)] z-20 w-[min(680px,92vw)] rounded-[22px] border border-stone-200 bg-[rgba(255,252,246,0.98)] p-4 shadow-[0_18px_42px_rgba(45,34,20,0.12)]" data-no-tree-pan="true">
                            <div className="grid gap-4 lg:grid-cols-3">
                                <ParentsClassicTreeOptionSelect
                                    label="Тип дерева"
                                    value={viewOptions?.treeType || 'directPlus'}
                                    options={TREE_TYPES}
                                    onChange={(value) => patchOptions({ treeType: value })}
                                />
                                <ParentsClassicTreeOptionSelect
                                    label="Плотность"
                                    value={viewOptions?.density || 'normal'}
                                    options={TREE_DENSITIES}
                                    onChange={(value) => patchOptions({ density: value })}
                                />
                                <ParentsClassicTreeOptionSelect
                                    label="Карточки"
                                    value={viewOptions?.cardDetail || 'medium'}
                                    options={CARD_DETAIL_LEVELS}
                                    onChange={(value) => patchOptions({ cardDetail: value })}
                                />
                            </div>
                            <div className="mt-4 grid gap-4 lg:grid-cols-3">
                                <ParentsClassicTreeOptionSelect
                                    label="Несколько браков"
                                    value={viewOptions?.multiMarriageDisplay || 'focus'}
                                    options={MULTI_MARRIAGE_DISPLAY_OPTIONS}
                                    onChange={(value) => patchOptions({ multiMarriageDisplay: value })}
                                />
                            </div>
                            <div className="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
                                <ParentsClassicTreeToggle label="Источники" checked={Boolean(viewOptions?.showSources)} onChange={(checked) => patchOptions({ showSources: checked })} />
                                <ParentsClassicTreeToggle label="Уверенность" checked={Boolean(viewOptions?.showConfidence)} onChange={(checked) => patchOptions({ showConfidence: checked })} />
                                <ParentsClassicTreeToggle label="Биография" checked={Boolean(viewOptions?.showLifeProfile)} onChange={(checked) => patchOptions({ showLifeProfile: checked })} />
                                <ParentsClassicTreeToggle label="Гипотезы" checked={Boolean(viewOptions?.showHypotheses)} onChange={(checked) => patchOptions({ showHypotheses: checked })} />
                                <ParentsClassicTreeToggle label="Конфликты" checked={Boolean(viewOptions?.showConflicts)} onChange={(checked) => patchOptions({ showConflicts: checked })} />
                            </div>
                            <div className="mt-4 rounded-2xl border border-stone-200 bg-white/85 px-4 py-3 text-[12px] leading-6 text-stone-600">
                                Сейчас полностью поддерживаются режимы <span className="font-semibold text-stone-800">top</span>, <span className="font-semibold text-stone-800">direct</span>, <span className="font-semibold text-stone-800">directPlus</span>, <span className="font-semibold text-stone-800">family</span>, <span className="font-semibold text-stone-800">all</span> и <span className="font-semibold text-stone-800">proof</span>. Поворот дерева влево/вправо подготовлен архитектурно и будет добавляться отдельно.
                            </div>
                        </div>
                    ) : null}
                </div>
            );
        };

        const ParentsClassicTreeLegend = ({ viewOptions = DEFAULT_CLASSIC_TREE_VIEW_OPTIONS }) => {
            const items = [
                { label: 'Выбранная персона', type: 'node', style: getClassicTreeStatusTone('', { isFocus: true }) },
                { label: 'Найденная запись', type: 'node', style: getClassicTreeStatusTone('auto') },
                { label: 'Вероятная связь', type: 'node', style: getClassicTreeStatusTone('probable') },
                { label: 'Рождение не найдено', type: 'node', style: getClassicTreeStatusTone('', { isMissing: true }) },
                { label: 'Ещё N детей этого брака', type: 'node', style: { borderStyle: 'dashed', borderColor: 'rgba(158, 145, 128, 0.42)', background: 'rgba(247,241,232,0.94)' } },
                { label: 'Подтверждённая кровная связь', type: 'line', line: { relationKind: RELATION_KIND.blood } },
                { label: 'Гипотеза', type: 'line', line: { relationKind: RELATION_KIND.hypothesis } },
                { label: 'Конфликт', type: 'line', line: { relationKind: RELATION_KIND.conflict } },
                { label: 'Брак / брачная пара', type: 'line', line: { relationKind: RELATION_KIND.marriage, pairStatus: 'marriage' } },
                { label: 'Дети есть, брак не найден', type: 'line', line: { relationKind: RELATION_KIND.marriage, pairStatus: 'children' } },
                { label: 'Брачная лента нескольких браков', type: 'line', line: { kind: 'marriageRail', relationKind: RELATION_KIND.marriage } },
            ];
            return (
                <details className="rounded-[18px] border border-stone-200 bg-[rgba(255,252,246,0.95)] p-4 shadow-[0_10px_24px_rgba(45,34,20,0.05)]" open={false}>
                    <summary className="cursor-pointer list-none text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">
                        Легенда схемы
                    </summary>
                    <div className="mt-3 grid gap-3 lg:grid-cols-2">
                        {items.map((item) => (
                            <div key={item.label} className="flex items-center gap-3 text-[12px] text-stone-600">
                                {item.type === 'node' ? (
                                    <span
                                        style={{
                                            width: '18px',
                                            height: '18px',
                                            borderRadius: '8px',
                                            border: `1px ${item.style.borderStyle} ${item.style.borderColor}`,
                                            background: item.style.background,
                                            display: 'inline-block',
                                        }}
                                    />
                                ) : (
                                    <span style={{ position: 'relative', display: 'inline-flex', width: '24px', height: '18px', alignItems: 'center' }}>
                                        <span
                                            style={{
                                                width: '24px',
                                                borderTop: `${getClassicTreeLineWidth(item.line, viewOptions)}px solid ${getClassicTreeLineColor(item.line, viewOptions)}`,
                                                opacity: getClassicTreeLineOpacity(item.line, viewOptions),
                                                borderStyle: getClassicTreeLineDashArray(item.line, viewOptions) ? 'dashed' : 'solid',
                                            }}
                                        />
                                    </span>
                                )}
                                <span>{item.label}</span>
                            </div>
                        ))}
                    </div>
                    <div className="mt-3 text-[12px] leading-6 text-stone-500">
                        Сплошная линия показывает подтверждённую кровную связь, светлая — вероятную, пунктир — гипотезу, красный пунктир — конфликт. I / II / III показывают порядок браков по году. Светлый семейный блок выделяет отдельный брак, а карточка <span className="font-semibold text-stone-700">Ещё N детей</span> означает свёрнутую часть этой ветви.
                    </div>
                </details>
            );
        };

        const ParentsClassicTreeViewer = ({
            layout,
            onOpenRow,
            autoFitKey = '',
            viewOptions = DEFAULT_CLASSIC_TREE_VIEW_OPTIONS,
            onChangeViewOptions = null,
            title = 'Родословная схема',
            subtitle = '',
            footerNote = CLASSIC_TREE_PRINT_NOTE,
        }) => {
            const containerRef = useRef(null);
            const svgRef = useRef(null);
            const dragRef = useRef(null);
            const [scale, setScale] = useState(1);

            const resolveTreeEventElement = useCallback((target) => {
                if (!target) return null;
                if (target instanceof Element) return target;
                if (target.parentElement instanceof Element) return target.parentElement;
                if (target.parentNode instanceof Element) return target.parentNode;
                return null;
            }, []);

            const centerContent = useCallback((targetScale = null) => {
                const container = containerRef.current;
                if (!container || !layout?.width || !layout?.height) return;
                const activeScale = Number(targetScale || scale || 1);
                requestAnimationFrame(() => {
                    const fullWidth = layout.width * activeScale;
                    const fullHeight = layout.height * activeScale;
                    container.scrollLeft = Math.max(0, (fullWidth - container.clientWidth) / 2);
                    container.scrollTop = Math.max(0, (fullHeight - container.clientHeight) / 2);
                });
            }, [layout?.height, layout?.width, scale]);

            const fitToViewport = useCallback(() => {
                const container = containerRef.current;
                if (!container || !layout?.width || !layout?.height) return;
                const availableWidth = Math.max(0, container.clientWidth - 32);
                const availableHeight = Math.max(0, container.clientHeight - 32);
                if (availableWidth <= 0 || availableHeight <= 0) return;
                const rawScale = Math.min(
                    availableWidth / layout.width,
                    availableHeight / layout.height,
                );
                const nextScale = Math.max(0.18, Math.min(1.6, rawScale));
                setScale(nextScale);
                centerContent(nextScale);
            }, [centerContent, layout?.height, layout?.width]);

            // Стабильная ссылка на актуальный fitToViewport — иначе пересоздание
            // колбэка на каждое изменение scale ронит зум обратно в auto-fit.
            const fitToViewportRef = useRef(fitToViewport);
            useEffect(() => { fitToViewportRef.current = fitToViewport; }, [fitToViewport]);

            useEffect(() => {
                if (!layout?.width || !layout?.height) return;
                // Auto-fit срабатывает ТОЛЬКО при смене выбранной персоны или размеров
                // layout — не при каждом ручном изменении scale пользователем.
                fitToViewportRef.current();
            }, [autoFitKey, layout?.height, layout?.width]);

            useEffect(() => {
                const container = containerRef.current;
                if (!container || typeof ResizeObserver === 'undefined') return;
                let frame = 0;
                const observer = new ResizeObserver(() => {
                    cancelAnimationFrame(frame);
                    frame = requestAnimationFrame(() => fitToViewportRef.current());
                });
                observer.observe(container);
                return () => {
                    cancelAnimationFrame(frame);
                    observer.disconnect();
                };
            }, []);

            const applyZoom = useCallback((nextScale, mouse = null) => {
                const container = containerRef.current;
                if (!container) return;
                const safeNextScale = Math.max(0.45, Math.min(2.4, nextScale));
                if (mouse && layout?.width && layout?.height) {
                    const rect = container.getBoundingClientRect();
                    const offsetX = mouse.clientX - rect.left;
                    const offsetY = mouse.clientY - rect.top;
                    const worldX = (container.scrollLeft + offsetX) / scale;
                    const worldY = (container.scrollTop + offsetY) / scale;
                    setScale(safeNextScale);
                    requestAnimationFrame(() => {
                        container.scrollLeft = Math.max(0, (worldX * safeNextScale) - offsetX);
                        container.scrollTop = Math.max(0, (worldY * safeNextScale) - offsetY);
                    });
                    return;
                }
                setScale(safeNextScale);
                centerContent(safeNextScale);
            }, [centerContent, layout?.height, layout?.width, scale]);

            useEffect(() => {
                const handleMouseMove = (event) => {
                    const drag = dragRef.current;
                    const container = containerRef.current;
                    if (!drag || !container) return;
                    container.scrollLeft = drag.startScrollLeft - (event.clientX - drag.startX);
                    container.scrollTop = drag.startScrollTop - (event.clientY - drag.startY);
                };
                const handleMouseUp = () => {
                    dragRef.current = null;
                    document.body.style.cursor = '';
                    document.body.style.userSelect = '';
                };
                window.addEventListener('mousemove', handleMouseMove);
                window.addEventListener('mouseup', handleMouseUp);
                return () => {
                    window.removeEventListener('mousemove', handleMouseMove);
                    window.removeEventListener('mouseup', handleMouseUp);
                };
            }, []);

            const serializeSvgMarkup = useCallback(() => {
                const svgElement = svgRef.current;
                if (!svgElement) return '';
                const clone = svgElement.cloneNode(true);
                clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                clone.setAttribute('xmlns:xhtml', 'http://www.w3.org/1999/xhtml');
                clone.setAttribute('width', String(layout?.width || 0));
                clone.setAttribute('height', String(layout?.height || 0));
                return new XMLSerializer().serializeToString(clone);
            }, [layout?.height, layout?.width]);

            const downloadBlob = useCallback((blob, fileName) => {
                const url = URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                window.setTimeout(() => URL.revokeObjectURL(url), 0);
            }, []);

            const safeDownloadBase = useMemo(() => {
                const raw = String(title || 'classic-tree').trim() || 'classic-tree';
                return raw.toLowerCase().replace(/[^\wа-яА-ЯёЁ-]+/g, '_');
            }, [title]);

            const handleExportSvg = useCallback(() => {
                const markup = serializeSvgMarkup();
                if (!markup) return;
                downloadBlob(new Blob([markup], { type: 'image/svg+xml;charset=utf-8' }), `${safeDownloadBase}.svg`);
            }, [downloadBlob, safeDownloadBase, serializeSvgMarkup]);

            const handleExportPng = useCallback(async () => {
                const markup = serializeSvgMarkup();
                if (!markup) return;
                try {
                    const svgBlob = new Blob([markup], { type: 'image/svg+xml;charset=utf-8' });
                    const url = URL.createObjectURL(svgBlob);
                    const img = new Image();
                    await new Promise((resolve, reject) => {
                        img.onload = resolve;
                        img.onerror = reject;
                        img.src = url;
                    });
                    const canvas = document.createElement('canvas');
                    canvas.width = Math.max(1, Math.ceil(layout?.width || 1));
                    canvas.height = Math.max(1, Math.ceil(layout?.height || 1));
                    const ctx = canvas.getContext('2d');
                    if (!ctx) throw new Error('canvas');
                    ctx.fillStyle = '#fdfbf7';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0);
                    URL.revokeObjectURL(url);
                    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
                    if (!blob) throw new Error('png');
                    downloadBlob(blob, `${safeDownloadBase}.png`);
                } catch (error) {
                    console.error('classic tree png export failed', error);
                    handleExportSvg();
                }
            }, [downloadBlob, handleExportSvg, layout?.height, layout?.width, safeDownloadBase, serializeSvgMarkup]);

            const handlePrint = useCallback(() => {
                const markup = serializeSvgMarkup();
                if (!markup) return;
                const printWindow = window.open('', '_blank', 'noopener,noreferrer,width=1400,height=900');
                if (!printWindow) return;
                const html = `<!DOCTYPE html><html lang="ru"><head><meta charset="UTF-8"><title>${title}</title><style>
                    body { margin:0; font-family: 'Lora', serif; background:#fdfbf7; color:#2b2118; }
                    .shell { padding: 24px; }
                    .title { font-family: 'Playfair Display', serif; font-size: 30px; font-weight: 700; color:#2b2118; }
                    .subtitle { margin-top: 8px; font-size: 14px; color:#6d6358; }
                    .note { margin-top: 16px; font-size: 12px; color:#7b7065; }
                    .svg-wrap { margin-top: 20px; border:1px solid #e3dccf; border-radius: 18px; background:#fffdf7; padding: 18px; }
                    svg { width: 100%; height: auto; }
                    @media print { .shell { padding: 10mm; } }
                </style></head><body><div class="shell"><div class="title">${title}</div>${subtitle ? `<div class="subtitle">${subtitle}</div>` : ''}<div class="svg-wrap">${markup}</div><div class="note">${footerNote}</div></div><script>window.onload = () => window.print();</script></body></html>`;
                printWindow.document.open();
                printWindow.document.write(html);
                printWindow.document.close();
            }, [footerNote, serializeSvgMarkup, subtitle, title]);

            if (!layout?.width || !layout?.height) {
                return (
                    <div className="rounded-[28px] border border-dashed border-stone-300 bg-[#fcfaf5] px-5 py-10 text-center text-sm text-stone-500">
                        Для выбранной записи пока не удалось построить классическое древо.
                    </div>
                );
            }

            return (
                <div className="space-y-4">
                    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                        <ParentsClassicTreeToolbar
                            scale={scale}
                            viewOptions={viewOptions}
                            onChangeViewOptions={onChangeViewOptions}
                            onZoomOut={() => applyZoom(scale * 0.9)}
                            onReset={() => {
                                setScale(1);
                                centerContent(1);
                            }}
                            onZoomIn={() => applyZoom(scale * 1.1)}
                            onCenter={() => centerContent()}
                            onFit={fitToViewport}
                            onExportSvg={handleExportSvg}
                            onExportPng={handleExportPng}
                            onPrint={handlePrint}
                        />
                        <ParentsClassicTreeLegend viewOptions={viewOptions} />
                    </div>

                    <div
                        ref={containerRef}
                        onWheel={(event) => {
                            event.preventDefault();
                            const direction = event.deltaY < 0 ? 1.08 : 0.92;
                            applyZoom(scale * direction, event);
                        }}
                        onMouseDown={(event) => {
                            if (event.button !== 0) return;
                            const targetElement = resolveTreeEventElement(event.target);
                            if (targetElement?.closest?.('[data-no-tree-pan="true"]')) return;
                            const container = containerRef.current;
                            if (!container) return;
                            dragRef.current = {
                                startX: event.clientX,
                                startY: event.clientY,
                                startScrollLeft: container.scrollLeft,
                                startScrollTop: container.scrollTop,
                            };
                            document.body.style.cursor = 'grabbing';
                            document.body.style.userSelect = 'none';
                        }}
                        className="overflow-auto rounded-[26px] border border-[#e4dccb] bg-[radial-gradient(circle_at_top,rgba(184,115,51,0.045),transparent_30%),linear-gradient(180deg,#fbf7ee_0%,#f4ecdd_100%)] shadow-[inset_0_1px_0_rgba(255,255,255,0.72)]"
                        style={{ minHeight: '620px', maxHeight: '74vh' }}
                    >
                        <div
                            style={{
                                minWidth: '100%',
                                minHeight: '100%',
                                width: `${(layout.width || 0) * scale}px`,
                                height: `${(layout.height || 0) * scale}px`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <div style={{ width: `${(layout.width || 0) * scale}px`, height: `${(layout.height || 0) * scale}px`, flexShrink: 0 }}>
                                <div style={{ transform: `scale(${scale})`, transformOrigin: 'top left', width: `${layout.width}px`, height: `${layout.height}px` }}>
                                    <ParentsClassicTreeSvg layout={layout} onOpenRow={onOpenRow} svgRef={svgRef} viewOptions={viewOptions} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsAncestryCandidateEvidenceCard = ({ title, personLabel, candidate, source, onOpenRow }) => {
            if (!candidate) {
                return (
                    <div className="rounded-[24px] border border-dashed border-stone-300 bg-[#fcfaf5] px-5 py-6">
                        <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">{title}</div>
                        <div className="mt-2 text-base font-semibold text-stone-800">{personLabel || 'Персона'}</div>
                        <div className="mt-3 text-sm text-stone-500">
                            Алгоритм пока не подтвердил собственное рождение для этой персоны.
                        </div>
                    </div>
                );
            }
            return (
                <div className="rounded-[24px] border border-stone-200 bg-white/95 p-5 shadow-[0_10px_28px_rgba(45,34,20,0.06)]">
                    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                        <div className="min-w-0">
                            <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">{title}</div>
                            <div className="mt-2 text-base font-semibold text-stone-800">{personLabel || 'Персона'}</div>
                        </div>
                        <div className="flex flex-wrap items-center gap-2 shrink-0">
                            <ParentsRelationStatusBadge status={candidate?.status} compact />
                            <ParentsAncestorSourceButton source={source} label="Открыть рождение" onOpenRow={onOpenRow} />
                        </div>
                    </div>
                    <div className="mt-4">
                        <ParentsConfidenceMeter
                            status={candidate?.status}
                            score={candidate?.score}
                            descriptionOverride={getParentsAncestryStatusMeta(candidate?.status).description}
                        />
                    </div>
                    <div className="mt-4 grid gap-4 xl:grid-cols-3">
                        <ParentsEvidenceList
                            title="Почему связь найдена"
                            items={Array.isArray(candidate?.reasons) ? candidate.reasons : []}
                            emptyText="Алгоритм не вернул явных пояснений."
                        />
                        <ParentsEvidenceList
                            title="Подтверждающие признаки"
                            items={buildParentsEvidenceRows(candidate?.evidence)}
                            emptyText="Подтверждающие признаки пока не собраны."
                        />
                        <ParentsEvidenceList
                            title="Что требует проверки"
                            items={Array.isArray(candidate?.warnings) ? candidate.warnings : []}
                            emptyText="Явных предупреждений для этой связи нет."
                            accent="danger"
                        />
                    </div>
                </div>
            );
        };

        const ParentsAncestryEvidencePanel = ({ tree, familyContext, selected, onOpenRow }) => {
            const parentsMarriage = familyContext?.parentsMarriage || tree?.parentsMarriage || null;
            const fatherCandidate = tree?.father?.linkCandidate || null;
            const motherCandidate = tree?.mother?.linkCandidate || null;

            return (
                <div className="space-y-6">
                    <ParentsParentsMarriageCard marriage={parentsMarriage} onOpenRow={onOpenRow} />
                    <div className="grid gap-5 xl:grid-cols-2">
                        <ParentsAncestryCandidateEvidenceCard
                            title="Почему найден отец"
                            personLabel={tree?.father?.personLabel || selected?.fatherLabel}
                            candidate={fatherCandidate}
                            source={tree?.father?.source}
                            onOpenRow={onOpenRow}
                        />
                        <ParentsAncestryCandidateEvidenceCard
                            title="Почему найдена мать"
                            personLabel={tree?.mother?.personLabel || selected?.motherLabel}
                            candidate={motherCandidate}
                            source={tree?.mother?.source}
                            onOpenRow={onOpenRow}
                        />
                    </div>
                </div>
            );
        };

        // ===== Роспись д'Абовиля (текстовое представление родословной) =====
        // Основной источник истины — ancestry payload сервера. Но для росписи
        // дополнительно применяем safety-net: не показываем конфликтные и
        // заведомо слабые параллельные семьи, если они противоречат уже
        // сильной семейной траектории той же персоны.

        const formatRospisYears = (entry) => {
            if (!entry) return '';
            const parts = [];
            const by = Number(entry?.birthYear || entry?.year || 0);
            if (by > 0) parts.push(`р. ${by}`);
            const dyLabel = String(entry?.deathYearLabel || '').trim();
            const dy = Number(entry?.deathYear || entry?.death?.year || 0);
            const da = String(entry?.deathAge || entry?.death?.deceasedAge || '').trim();
            const yText = dyLabel || (dy > 0 ? String(dy) : '');
            if (yText && da) parts.push(`ум. ${yText} (${da})`);
            else if (yText) parts.push(`ум. ${yText}`);
            else if (da) parts.push(`ум. ${da}`);
            const locality = Array.isArray(entry?.birthLocalityLabels || entry?.localityLabels)
                ? (entry?.birthLocalityLabels || entry?.localityLabels).filter(Boolean).join(', ')
                : '';
            if (locality) parts.push(locality);
            return parts.join(' · ');
        };

        const formatRospisSourceLabel = (source) => {
            if (!source) return '';
            const cipher = String(source?.cipherLabel || '').trim();
            const page = String(source?.pageLabel || '').trim();
            if (!cipher && !page) return '';
            return `${cipher}${page ? ` · стр. ${page}` : ''}`;
        };

        const RospisSourceButton = ({ source, birthRecordId = '', onOpenRow }) => {
            const label = formatRospisSourceLabel(source);
            if (!label) return null;
            const itemId = source?.itemId || '';
            if (!itemId || !onOpenRow) {
                return <span className="ml-2 text-[11px] text-stone-400">{label}</span>;
            }
            return (
                <button
                    onClick={() => onOpenRow({
                        itemId,
                        itemUrl: source?.url || source?.itemUrl || '',
                        url: source?.url || source?.itemUrl || '',
                        cipherLabel: source?.cipherLabel || '',
                        pageLabel: source?.pageLabel || '',
                        birthRecordId: birthRecordId || '',
                    })}
                    className="ml-2 rounded-full border border-stone-200 bg-[#fff7e8] px-2 py-[2px] text-[10px] font-bold uppercase tracking-[0.14em] text-stone-600 hover:border-[#8b0000]/40 hover:text-[#8b0000]"
                >
                    {label}
                </button>
            );
        };

        const getParentsRospisFamilySortKey = (family) => {
            const marriageYear = Number(family?.marriage?.marriageYear || 0);
            const firstChildYear = Number(family?.firstChildYear || 0);
            const lastChildYear = Number(family?.lastChildYear || 0);
            return [
                Number.isFinite(marriageYear) && marriageYear > 0 ? marriageYear : 9999,
                Number.isFinite(firstChildYear) && firstChildYear > 0 ? firstChildYear : 9999,
                Number.isFinite(lastChildYear) && lastChildYear > 0 ? lastChildYear : 9999,
                String(family?.birthFamilyId || family?.unionId || ''),
            ];
        };

        const compareParentsRospisFamilySortKey = (left, right) => {
            const leftKey = getParentsRospisFamilySortKey(left);
            const rightKey = getParentsRospisFamilySortKey(right);
            for (let index = 0; index < leftKey.length; index += 1) {
                if (leftKey[index] < rightKey[index]) return -1;
                if (leftKey[index] > rightKey[index]) return 1;
            }
            return 0;
        };

        const getParentsRospisFamilyDisplayStatus = (family) => {
            if (family?.displayStatus) return String(family.displayStatus).trim().toLowerCase();
            if (family?.isRepeatMarriage && family?.isSequentialMarriage) return 'sequential_marriage';
            if (family?.isRepeatMarriage) return 'repeat_marriage';
            return String(
                family?.effectiveStatus
                || family?.marriage?.adjustedStatus
                || family?.marriage?.status
                || family?.childrenLinkAdjustedStatus
                || family?.childrenLinkStatus
                || ''
            ).trim().toLowerCase();
        };

        const getParentsRospisMarriageLabel = (family) => {
            const marriageYear = family?.marriage?.marriageYear;
            const ordinal = Number(family?.marriageOrdinal || 0);
            const prefix = ordinal > 0 ? `${ordinal}-й брак` : '';
            const base = marriageYear ? `брак ${marriageYear}` : 'запись о браке не найдена';
            if (family?.displayStatus === 'incomplete') return base;
            return prefix ? `${base} · ${prefix}` : base;
        };

        // R-UI: компактный совмещённый индикатор для подсемей (subCouples).
        const SubCoupleIndicator = ({ confidence, confidenceBand, marriageStatus }) => {
            const conf = Number(confidence);
            const hasConf = Number.isFinite(conf);
            const band = confidenceBand || (hasConf ? (conf >= 0.85 ? 'high' : conf >= 0.6 ? 'medium' : 'low') : 'medium');
            const dotColor = band === 'high' ? 'bg-emerald-500' : band === 'low' ? 'bg-orange-500' : 'bg-amber-400';
            const statusMeta = marriageStatus ? getParentsAncestryStatusMeta(marriageStatus) : null;
            const statusLabel = statusMeta?.label || marriageStatus || '';
            const tooltip = [hasConf ? `Уверенность: ${Math.round(conf * 100)}%` : '', statusLabel ? `Статус: ${statusLabel}` : ''].filter(Boolean).join(' · ');
            return (
                <span className="inline-flex items-baseline gap-1.5 select-none" title={tooltip}>
                    <span className={`inline-block w-2 h-2 rounded-full ${dotColor} translate-y-[-1px]`}></span>
                    {hasConf ? <span className="text-[11px] text-stone-500 tabular-nums">{Math.round(conf * 100)}%</span> : null}
                </span>
            );
        };

        const RospisPersonLine = ({ number, person, isFocus = false, onOpenRow }) => {
            const meta = formatRospisYears(person);
            const focused = isFocus || person?.isFocus || person?.isSelected;
            const subCouples = Array.isArray(person?.subCouples) ? person.subCouples : [];
            return (
                <li className={`rospis-row ${focused ? 'rospis-row--focused' : ''}`}>
                    <div className="rospis-row__main">
                        <span className="rospis-row__num">{number}</span>
                        <span className="rospis-row__body min-w-0">
                            <span className="rospis-row__name">{person?.label || person?.personLabel || 'Без имени'}</span>
                            {focused ? <span className="rospis-row__star">★</span> : null}
                            {meta ? <span className="rospis-row__meta">· {meta}</span> : null}
                            {person?.missingBirth ? <span className="rospis-row__hint">· запись о рождении не найдена</span> : null}
                        </span>
                        <span className="rospis-row__src">
                            <RospisSourceButton source={person?.source} birthRecordId={person?.birthRecordId || ''} onOpenRow={onOpenRow} />
                        </span>
                    </div>
                    {subCouples.length > 0 ? (
                        <div className="rospis-subcouples">
                            {subCouples.map((sub) => (
                                <div key={sub.id} className="rospis-subcouple">
                                    <div className="rospis-subcouple__head">
                                        <span className="rospis-subcouple__cross">×</span>
                                        <span className="rospis-subcouple__spouse">{sub.spouseLabel}</span>
                                        {sub.marriageLabel ? <span className="rospis-subcouple__marriage">· {sub.marriageLabel}</span> : null}
                                        <span className="rospis-subcouple__indicator">
                                            <SubCoupleIndicator
                                                confidence={sub.confidence}
                                                confidenceBand={sub.confidenceBand}
                                                marriageStatus={sub.marriageStatus}
                                            />
                                        </span>
                                        <span className="rospis-subcouple__src">
                                            <RospisSourceButton source={sub.marriageSource} onOpenRow={onOpenRow} />
                                        </span>
                                    </div>
                                    {Array.isArray(sub.entries) && sub.entries.length > 0 ? (
                                        <ol className="rospis-list">
                                            {sub.entries.map((entry) => (
                                                <RospisPersonLine key={`${sub.id}-${entry.number}`} number={entry.number} person={entry} onOpenRow={onOpenRow} />
                                            ))}
                                        </ol>
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    ) : null}
                </li>
            );
        };

        const buildAscendingChain = (rootNode, branch /* 'father' | 'mother' */) => {
            const chain = [];
            let cursor = rootNode;
            while (cursor) {
                chain.push(cursor);
                cursor = cursor?.[branch] || null;
            }
            return chain;
        };

        const buildParentsRospisModel = ({ selected, familyContext, tree }) => {
            const focusId = String(selected?.birthRecordId || tree?.birthRecordId || '').trim();
            const mainFamilies = Array.isArray(familyContext?.descendantFamilies) ? familyContext.descendantFamilies : [];
            const disputedFamilies = (Array.isArray(familyContext?.disputedDescendantFamilies) ? familyContext.disputedDescendantFamilies.slice() : []).sort(compareParentsRospisFamilySortKey);
            const hiddenFamilies = (Array.isArray(familyContext?.hiddenDescendantFamilies) ? familyContext.hiddenDescendantFamilies.slice() : []).sort(compareParentsRospisFamilySortKey);
            const reviewFamilies = (Array.isArray(familyContext?.reviewDescendantFamilies) ? familyContext.reviewDescendantFamilies.slice() : []).sort(compareParentsRospisFamilySortKey);
            const sideFamilies = (Array.isArray(familyContext?.sideDescendantFamilies) ? familyContext.sideDescendantFamilies.slice() : []).sort(compareParentsRospisFamilySortKey);
            const mixedBirthFamilyAuditItems = Array.isArray(familyContext?.mixedBirthFamilyAuditItems) ? familyContext.mixedBirthFamilyAuditItems : [];
            const possibleBrideSurnameLeakAuditItems = Array.isArray(familyContext?.possibleBrideSurnameLeakAuditItems) ? familyContext.possibleBrideSurnameLeakAuditItems : [];
            const mainChildren = Array.isArray(familyContext?.children) ? familyContext.children : [];
            // Берём имя родителя из familyContext (он отражает root после
            // подъёма deepestPaternalRoot). selected.fatherLabel — это всегда
            // отец селекта (а не корня), поэтому если корень поднимался —
            // selected.fatherLabel будет указывать не на ту пару. Используем
            // его только как fallback, если familyContext пуст.
            const pickRospisRootLabel = (familyCtxLabel, selectedLabel) => {
                const sa = String(familyCtxLabel || '').trim();
                const sb = String(selectedLabel || '').trim();
                if (sa) return sa;
                return sb;
            };
            const fatherLabel = pickRospisRootLabel(familyContext?.fatherLabel, selected?.fatherLabel);
            const motherLabel = pickRospisRootLabel(familyContext?.motherLabel, selected?.motherLabel);
            const fatherApprox = Number(familyContext?.fatherBirthYearApprox) || null;
            const motherApprox = Number(familyContext?.motherBirthYearApprox) || null;
            const deepestRoot = familyContext?.deepestPaternalRoot || {};
            const rootHops = Number(deepestRoot?.hops || 0);
            const rootClimbed = rootHops > 0;

            // Помощник: добавляет «(около YYYY)» если приблизительный год известен.
            const appendApproxBirth = (label, approxYear) => {
                const cleanLabel = String(label || '').trim();
                const year = Number(approxYear);
                if (!cleanLabel) return cleanLabel;
                if (!Number.isInteger(year) || year < 1500 || year > 2100) return cleanLabel;
                return `${cleanLabel} (около ${year})`;
            };

            const sections = [];

            // Секции «Восходящая линия по отцу/матери» убраны по запросу:
            // вся восходящая информация и без них видна в «Родительская семья»
            // и в подъёме корня д'Абовиль-росписи.

            // Группируем все «не-сводные» семьи по parentBirthRecordId,
            // чтобы под каждым ребёнком в росписи показать его собственные браки и детей
            // как вложенные подпункты, а не как отдельный блок в конце.
            const ownFamiliesByParentId = {};
            mainFamilies.forEach((fam) => {
                if (fam?.isOtherMarriageOfParent) return;
                const pid = String(fam?.parentBirthRecordId || '').trim();
                if (!pid) return;
                if (!ownFamiliesByParentId[pid]) ownFamiliesByParentId[pid] = [];
                ownFamiliesByParentId[pid].push(fam);
            });
            Object.keys(ownFamiliesByParentId).forEach((pid) => {
                ownFamiliesByParentId[pid].sort(compareParentsRospisFamilySortKey);
            });

            // Один проход dfs: для каждого «ребёнка-пары» собираем его описание
            // и рекурсивно его собственные браки+потомков (внуки родительской пары).
            const visitedParentIds = new Set();
            const buildCoupleEntries = (children, basePrefix, startIndex = 0) =>
                (Array.isArray(children) ? children : []).map((child, index) => {
                    const number = `${basePrefix}.${startIndex + index + 1}`;
                    const childBid = String(child?.birthRecordId || child?.eventId || '').trim();
                    const ownMarriages = (childBid && !visitedParentIds.has(childBid))
                        ? (ownFamiliesByParentId[childBid] || [])
                        : [];
                    if (childBid) visitedParentIds.add(childBid);
                    let nestedChildOffset = 0;
                    const subCouples = ownMarriages.map((fam, fidx) => {
                        const subEntries = buildCoupleEntries(fam?.children || [], number, nestedChildOffset);
                        nestedChildOffset += subEntries.length;
                        const spouseRaw = fam?.spouse?.label || 'не указан(а)';
                        const spouseApprox = fam?.spouse?.birthYearApprox;
                        return {
                            id: `${number}-${fidx}-${fam?.birthFamilyId || fam?.unionId || fidx}`,
                            spouseLabel: appendApproxBirth(spouseRaw, spouseApprox),
                            marriageLabel: getParentsRospisMarriageLabel(fam),
                            marriageStatus: getParentsRospisFamilyDisplayStatus(fam),
                            marriageSource: fam?.marriage?.source || null,
                            confidence: fam?.confidence,
                            confidenceBand: fam?.confidenceBand,
                            entries: subEntries,
                        };
                    });
                    return {
                        number,
                        birthRecordId: childBid,
                        label: child?.label || 'Без имени',
                        sex: String(child?.sex || '').toUpperCase(),
                        birthYear: child?.year ?? null,
                        deathYear: child?.deathYear ?? null,
                        deathYearLabel: child?.deathYearLabel || '',
                        deathAge: child?.deathAge || '',
                        birthLocalityLabels: child?.localityLabels || [],
                        source: child?.source || null,
                        isFocus: childBid === focusId,
                        isSelected: Boolean(child?.isSelected),
                        subCouples,
                    };
                });

            const parentsCouples = [];
            // Основная семья — родители выбранной + их дети (включая выбранную).
            // У выбранной и у её сиблингов их собственные браки и дети будут
            // нанизаны прямо под их пунктом, без отдельной секции.
            const rootMarriage = familyContext?.parentsMarriage || null;
            const rootFatherTitle = appendApproxBirth(fatherLabel || 'Отец не указан', fatherApprox);
            const rootMotherTitle = appendApproxBirth(motherLabel || 'Мать не указана', motherApprox);
            parentsCouples.push({
                id: 'root-couple',
                number: '1',
                title: `1. ${rootFatherTitle} × ${rootMotherTitle}`,
                marriageLabel: rootMarriage?.marriageYear ? `брак ${rootMarriage.marriageYear}` : 'запись о браке не найдена',
                marriageStatus: rootMarriage?.adjustedStatus || rootMarriage?.status || '',
                marriageSource: rootMarriage?.source || null,
                isOther: false,
                entries: buildCoupleEntries(mainChildren, '1'),
            });
            // Сводные браки родителей: отдельные пары с собственной нумерацией,
            // но сводные братья/сёстры так же могут иметь вложенные потомства.
            const halves = mainFamilies.filter((f) => f?.isOtherMarriageOfParent).slice().sort(compareParentsRospisFamilySortKey);
            halves.forEach((fam, idx) => {
                const role = String(fam?.parentRoleKey || '').toLowerCase();
                const shared = String(fam?.parentLabel || '').trim() || (role === 'wife' ? motherLabel : fatherLabel);
                const sharedApprox = fam?.parentBirthYearApprox || (role === 'wife' ? motherApprox : fatherApprox);
                const other = fam?.spouse?.label || 'не указан(а)';
                const otherApprox = fam?.spouse?.birthYearApprox;
                const num = `${idx + 2}`;
                parentsCouples.push({
                    id: `half-${fam?.birthFamilyId || idx}`,
                    number: num,
                    title: `${num}. ${appendApproxBirth(shared || 'Родитель', sharedApprox)} × ${appendApproxBirth(other, otherApprox)}`,
                    marriageLabel: getParentsRospisMarriageLabel(fam),
                    marriageStatus: getParentsRospisFamilyDisplayStatus(fam),
                    marriageSource: fam?.marriage?.source || null,
                    confidence: fam?.confidence,
                    confidenceBand: fam?.confidenceBand,
                    isOther: true,
                    parentRoleLabel: fam?.parentRoleLabel || (role === 'wife' ? 'матери' : 'отца'),
                    entries: buildCoupleEntries(fam?.children || [], num),
                });
            });
            if (parentsCouples.some((c) => c.entries.length > 0) || parentsCouples.length > 0) {
                sections.push({
                    id: 'parents-family',
                    title: 'Родительская семья',
                    note: 'Под каждым ребёнком, если известны его браки и потомки, они показаны вложенно. Сводные братья и сёстры — отдельным блоком для другого брака отца или матери.',
                    couples: parentsCouples,
                });
            }

            if (disputedFamilies.length > 0) {
                sections.push({
                    id: 'disputed-families',
                    title: `Спорные семьи (${disputedFamilies.length})`,
                    note: 'Сюда вынесены слабые или конкурирующие семейные ветви. Они не попадают в основную роспись, пока не будут проверены по источнику, OCR или восприемникам.',
                    collapsedByDefault: true,
                    couples: disputedFamilies.map((fam, idx) => ({
                        id: `disputed-${fam?.birthFamilyId || fam?.unionId || idx}`,
                        title: `${idx + 1}. ${appendApproxBirth(fam?.parentLabel || 'Родитель', fam?.parentBirthYearApprox)} × ${appendApproxBirth(fam?.spouse?.label || 'не указан(а)', fam?.spouse?.birthYearApprox)}`,
                        marriageLabel: getParentsRospisMarriageLabel(fam),
                        marriageStatus: getParentsRospisFamilyDisplayStatus(fam),
                        marriageSource: fam?.marriage?.source || null,
                        confidence: fam?.confidence,
                        confidenceBand: fam?.confidenceBand,
                        isDisputed: true,
                        displayReasons: Array.isArray(fam?.displayReasonKeys) && fam.displayReasonKeys.length > 0 ? fam.displayReasonKeys : (Array.isArray(fam?.displayReasons) ? fam.displayReasons : []),
                        displayWarnings: Array.isArray(fam?.displayWarningKeys) && fam.displayWarningKeys.length > 0 ? fam.displayWarningKeys : (Array.isArray(fam?.displayWarnings) ? fam.displayWarnings : []),
                        debugMeta: {
                            debugDispositionReason: fam?.debugDispositionReason || '',
                            suppressedBy: fam?.suppressedBy || null,
                            displayScore: fam?.displayScore,
                            effectiveStatus: fam?.effectiveStatus || '',
                            possibleBrideSurnameLeakDecision: fam?.possibleBrideSurnameLeakDecision || '',
                            possibleBrideSurnameLeakedToGroom: Boolean(fam?.possibleBrideSurnameLeakedToGroom),
                            familyCoherenceScore: fam?.familyCoherenceScore ?? fam?.familyCoherence?.score ?? null,
                            spouseCompatibilityResult: fam?.spouseCompatibility?.result || fam?.spouseCompatibilityResult || '',
                            parentRoleCompatibilityResult: fam?.parentRoleCompatibility?.result || fam?.parentRoleCompatibilityResult || '',
                            spouseCompatibilityMissing: Array.isArray(fam?.spouseCompatibilityMissing) ? fam.spouseCompatibilityMissing : (Array.isArray(fam?.spouseCompatibility?.missing) ? fam.spouseCompatibility.missing : []),
                            parentRoleCompatibilityMissing: Array.isArray(fam?.parentRoleCompatibilityMissing) ? fam.parentRoleCompatibilityMissing : (Array.isArray(fam?.parentRoleCompatibility?.missing) ? fam.parentRoleCompatibility.missing : []),
                            spouseCompatibilityDebugFlags: Array.isArray(fam?.spouseCompatibilityDebugFlags) ? fam.spouseCompatibilityDebugFlags : (Array.isArray(fam?.spouseCompatibility?.debugFlags) ? fam.spouseCompatibility.debugFlags : []),
                            statusCeiling: fam?.statusCeiling || fam?.marriage?.statusCeiling || '',
                            spouseRawIdentity: fam?.spouseRawIdentity || null,
                            spouseMergedIdentity: fam?.spouseMergedIdentity || null,
                        },
                        entries: (Array.isArray(fam?.children) ? fam.children : []).map((child, childIndex) => ({
                            number: `${idx + 1}.${childIndex + 1}`,
                            birthRecordId: child?.birthRecordId || child?.eventId || '',
                            label: child?.label || 'Без имени',
                            sex: String(child?.sex || '').toUpperCase(),
                            birthYear: child?.year ?? null,
                            deathYear: child?.deathYear ?? null,
                            deathYearLabel: child?.deathYearLabel || '',
                            deathAge: child?.deathAge || '',
                            birthLocalityLabels: child?.localityLabels || [],
                            source: child?.source || null,
                            isFocus: String(child?.birthRecordId || child?.eventId || '').trim() === focusId,
                            isSelected: Boolean(child?.isSelected),
                            subCouples: [],
                        })),
                    })),
                });
            }

            if (reviewFamilies.length > 0) {
                sections.push({
                    id: 'review-families',
                    title: `Требуют проверки (${reviewFamilies.length})`,
                    note: 'Эти ветви не включены в основную роспись, но и не скрыты полностью: проблема связана с нехваткой данных, покрытием источников или OCR, а не с жёстким противоречием.',
                    collapsedByDefault: true,
                    couples: reviewFamilies.map((fam, idx) => ({
                        id: `review-${fam?.birthFamilyId || fam?.unionId || idx}`,
                        title: `${idx + 1}. ${appendApproxBirth(fam?.parentLabel || 'Родитель', fam?.parentBirthYearApprox)} × ${appendApproxBirth(fam?.spouse?.label || 'не указан(а)', fam?.spouse?.birthYearApprox)}`,
                        marriageLabel: getParentsRospisMarriageLabel(fam),
                        marriageStatus: getParentsRospisFamilyDisplayStatus(fam) || 'review',
                        marriageSource: fam?.marriage?.source || null,
                        isReview: true,
                        displayReasons: Array.isArray(fam?.reviewReasonCodes) && fam.reviewReasonCodes.length > 0 ? fam.reviewReasonCodes : (Array.isArray(fam?.displayReasonKeys) ? fam.displayReasonKeys : []),
                        displayWarnings: Array.isArray(fam?.displayWarningKeys) && fam.displayWarningKeys.length > 0 ? fam.displayWarningKeys : (Array.isArray(fam?.displayWarnings) ? fam.displayWarnings : []),
                        debugMeta: {
                            debugDispositionReason: fam?.debugDispositionReason || '',
                            originalBucket: fam?.originalBucket || '',
                            originalDisposition: fam?.originalDisposition || '',
                            suppressedBy: fam?.suppressedBy || null,
                            displayScore: fam?.displayScore,
                            effectiveStatus: fam?.effectiveStatus || '',
                            familyCoherenceScore: fam?.familyCoherenceScore ?? fam?.familyCoherence?.score ?? null,
                            spouseCompatibilityResult: fam?.spouseCompatibility?.result || fam?.spouseCompatibilityResult || '',
                            parentRoleCompatibilityResult: fam?.parentRoleCompatibility?.result || fam?.parentRoleCompatibilityResult || '',
                            statusCeiling: fam?.statusCeiling || fam?.marriage?.statusCeiling || '',
                            coverageReasons: Array.isArray(fam?.coverageReasons) ? fam.coverageReasons : [],
                            coverageAdjusted: Boolean(fam?.coverageAdjusted),
                            missingEvidenceExplainedByCoverage: Boolean(fam?.missingEvidenceExplainedByCoverage),
                            reviewEligible: Boolean(fam?.reviewEligible),
                            canShowInExtendedTree: Boolean(fam?.canShowInExtendedTree),
                        },
                        entries: (Array.isArray(fam?.children) ? fam.children : []).map((child, childIndex) => ({
                            number: `${idx + 1}.${childIndex + 1}`,
                            birthRecordId: child?.birthRecordId || child?.eventId || '',
                            label: child?.label || 'Без имени',
                            sex: String(child?.sex || '').toUpperCase(),
                            birthYear: child?.year ?? null,
                            deathYear: child?.deathYear ?? null,
                            deathYearLabel: child?.deathYearLabel || '',
                            deathAge: child?.deathAge || '',
                            birthLocalityLabels: child?.localityLabels || [],
                            source: child?.source || null,
                            isFocus: String(child?.birthRecordId || child?.eventId || '').trim() === focusId,
                            isSelected: Boolean(child?.isSelected),
                            subCouples: [],
                        })),
                    })),
                });
            }

            if (sideFamilies.length > 0) {
                // R4: группируем боковые семьи по structured sideExclusionCategory.
                // Каждая категория = отдельная свёрнутая секция со своим
                // объяснением. Пользователь видит «почему» сразу, а не из
                // ребуса reason-keys.
                const sideCategoryOrder = [
                    'MOTHER_OTHER_MARRIAGE',
                    'FATHER_OTHER_MARRIAGE_NO_ROOT_CLIMB',
                    'UNRELATED_DISTANT_BRANCH',
                    'UNKNOWN_NEEDS_REVIEW',
                    'OTHER',
                ];
                const sideGroups = new Map();
                sideFamilies.forEach((fam) => {
                    const cat = String(fam?.sideExclusionCategory || 'OTHER');
                    if (!sideGroups.has(cat)) {
                        sideGroups.set(cat, {
                            category: cat,
                            label: String(fam?.sideExclusionLabel || 'Прочее'),
                            explanation: String(fam?.sideExclusionExplanation || ''),
                            families: [],
                        });
                    }
                    sideGroups.get(cat).families.push(fam);
                });

                const orderedGroups = [...sideGroups.values()].sort((a, b) => {
                    const ai = sideCategoryOrder.indexOf(a.category);
                    const bi = sideCategoryOrder.indexOf(b.category);
                    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
                });

                orderedGroups.forEach((group) => {
                    sections.push({
                        id: `side-${group.category.toLowerCase()}`,
                        title: `${group.label} (${group.families.length})`,
                        note: group.explanation,
                        collapsedByDefault: true,
                        sideCategory: group.category,
                        couples: group.families.map((fam, idx) => ({
                            id: `side-${group.category}-${fam?.birthFamilyId || fam?.unionId || idx}`,
                            title: `${idx + 1}. ${appendApproxBirth(fam?.parentLabel || 'Родитель', fam?.parentBirthYearApprox)} × ${appendApproxBirth(fam?.spouse?.label || 'не указан(а)', fam?.spouse?.birthYearApprox)}`,
                            marriageLabel: getParentsRospisMarriageLabel(fam),
                            marriageStatus: getParentsRospisFamilyDisplayStatus(fam) || 'side',
                            marriageSource: fam?.marriage?.source || null,
                            isSide: true,
                            sideReason: fam?.rootLineEligibility || '',
                            sideExclusionCategory: fam?.sideExclusionCategory || '',
                            displayReasons: Array.isArray(fam?.displayReasonKeys) && fam.displayReasonKeys.length > 0 ? fam.displayReasonKeys : (Array.isArray(fam?.displayReasons) ? fam.displayReasons : []),
                            displayWarnings: Array.isArray(fam?.displayWarningKeys) && fam.displayWarningKeys.length > 0 ? fam.displayWarningKeys : (Array.isArray(fam?.displayWarnings) ? fam.displayWarnings : []),
                            debugMeta: {
                                rootLineEligibility: fam?.rootLineEligibility || '',
                                originalDisposition: fam?.originalDisposition || '',
                                isOtherMarriageOfParent: Boolean(fam?.isOtherMarriageOfParent),
                                parentRoleLabel: fam?.parentRoleLabel || '',
                                parentBirthRecordId: fam?.parentBirthRecordId || '',
                                displayScore: fam?.displayScore,
                                effectiveStatus: fam?.effectiveStatus || '',
                            },
                            entries: (Array.isArray(fam?.children) ? fam.children : []).map((child, childIndex) => ({
                                number: `${idx + 1}.${childIndex + 1}`,
                                birthRecordId: child?.birthRecordId || child?.eventId || '',
                                label: child?.label || 'Без имени',
                                sex: String(child?.sex || '').toUpperCase(),
                                birthYear: child?.year ?? null,
                                deathYear: child?.deathYear ?? null,
                                deathYearLabel: child?.deathYearLabel || '',
                                deathAge: child?.deathAge || '',
                                birthLocalityLabels: child?.localityLabels || [],
                                source: child?.source || null,
                                isFocus: String(child?.birthRecordId || child?.eventId || '').trim() === focusId,
                                isSelected: Boolean(child?.isSelected),
                                subCouples: [],
                            })),
                        })),
                    });
                });
            }

            if (hiddenFamilies.length > 0) {
                sections.push({
                    id: 'hidden-families',
                    title: `Отклонённые семьи (${hiddenFamilies.length})`,
                    note: 'Эти ветви серверный ancestry-слой отбросил как невозможные или слишком конфликтные. По умолчанию блок скрыт и нужен для отладки.',
                    collapsedByDefault: true,
                    couples: hiddenFamilies.map((fam, idx) => ({
                        id: `hidden-${fam?.birthFamilyId || fam?.unionId || idx}`,
                        title: `${idx + 1}. ${appendApproxBirth(fam?.parentLabel || 'Родитель', fam?.parentBirthYearApprox)} × ${appendApproxBirth(fam?.spouse?.label || 'не указан(а)', fam?.spouse?.birthYearApprox)}`,
                        marriageLabel: getParentsRospisMarriageLabel(fam),
                        marriageStatus: getParentsRospisFamilyDisplayStatus(fam) || 'hidden',
                        marriageSource: fam?.marriage?.source || null,
                        isHidden: true,
                        displayReasons: Array.isArray(fam?.displayReasonKeys) && fam.displayReasonKeys.length > 0 ? fam.displayReasonKeys : (Array.isArray(fam?.displayReasons) ? fam.displayReasons : []),
                        displayWarnings: Array.isArray(fam?.displayWarningKeys) && fam.displayWarningKeys.length > 0 ? fam.displayWarningKeys : (Array.isArray(fam?.displayWarnings) ? fam.displayWarnings : []),
                        debugMeta: {
                            debugDispositionReason: fam?.debugDispositionReason || '',
                            suppressedBy: fam?.suppressedBy || null,
                            displayScore: fam?.displayScore,
                            effectiveStatus: fam?.effectiveStatus || '',
                            possibleBrideSurnameLeakDecision: fam?.possibleBrideSurnameLeakDecision || '',
                            possibleBrideSurnameLeakedToGroom: Boolean(fam?.possibleBrideSurnameLeakedToGroom),
                            familyCoherenceScore: fam?.familyCoherenceScore ?? fam?.familyCoherence?.score ?? null,
                            spouseCompatibilityResult: fam?.spouseCompatibility?.result || fam?.spouseCompatibilityResult || '',
                            parentRoleCompatibilityResult: fam?.parentRoleCompatibility?.result || fam?.parentRoleCompatibilityResult || '',
                            spouseCompatibilityMissing: Array.isArray(fam?.spouseCompatibilityMissing) ? fam.spouseCompatibilityMissing : (Array.isArray(fam?.spouseCompatibility?.missing) ? fam.spouseCompatibility.missing : []),
                            parentRoleCompatibilityMissing: Array.isArray(fam?.parentRoleCompatibilityMissing) ? fam.parentRoleCompatibilityMissing : (Array.isArray(fam?.parentRoleCompatibility?.missing) ? fam.parentRoleCompatibility.missing : []),
                            spouseCompatibilityDebugFlags: Array.isArray(fam?.spouseCompatibilityDebugFlags) ? fam.spouseCompatibilityDebugFlags : (Array.isArray(fam?.spouseCompatibility?.debugFlags) ? fam.spouseCompatibility.debugFlags : []),
                            statusCeiling: fam?.statusCeiling || fam?.marriage?.statusCeiling || '',
                            spouseRawIdentity: fam?.spouseRawIdentity || null,
                            spouseMergedIdentity: fam?.spouseMergedIdentity || null,
                        },
                        entries: (Array.isArray(fam?.children) ? fam.children : []).map((child, childIndex) => ({
                            number: `${idx + 1}.${childIndex + 1}`,
                            birthRecordId: child?.birthRecordId || child?.eventId || '',
                            label: child?.label || 'Без имени',
                            sex: String(child?.sex || '').toUpperCase(),
                            birthYear: child?.year ?? null,
                            deathYear: child?.deathYear ?? null,
                            deathYearLabel: child?.deathYearLabel || '',
                            deathAge: child?.deathAge || '',
                            birthLocalityLabels: child?.localityLabels || [],
                            source: child?.source || null,
                            isFocus: String(child?.birthRecordId || child?.eventId || '').trim() === focusId,
                            isSelected: Boolean(child?.isSelected),
                            subCouples: [],
                        })),
                    })),
                });
            }

            if (mixedBirthFamilyAuditItems.length > 0) {
                sections.push({
                    id: 'mixed-birth-family-audit',
                    title: 'Аудит смешанных семей по рождениям',
                    note: 'Этот блок нужен для отладки смешанных birth-family, которые могли получиться из OCR или неправильной сегментации записей.',
                    auditItems: mixedBirthFamilyAuditItems,
                });
            }

            if (possibleBrideSurnameLeakAuditItems.length > 0) {
                sections.push({
                    id: 'possible-bride-surname-leak-audit',
                    title: 'Аудит утечки фамилии невесты на жениха',
                    note: 'Этот блок показывает браки, где фамилия жениха в брачной записи, вероятно, ошибочно совпала с фамилией невесты и была ослаблена как parse/OCR ошибка.',
                    leakAuditItems: possibleBrideSurnameLeakAuditItems,
                });
            }

            return { sections };
        };

        // R-UI: единый комбинированный индикатор для пары — точка по band + чек
        // если найдена marriage запись + опционально число процента.
        const RospisIndicator = ({ confidence, confidenceBand, marriageStatus, isOther, isDisputed, isSide, parentRoleLabel }) => {
            const conf = Number(confidence);
            const hasConf = Number.isFinite(conf);
            const band = confidenceBand || (hasConf ? (conf >= 0.85 ? 'high' : conf >= 0.6 ? 'medium' : 'low') : 'medium');
            const dotColor = band === 'high' ? 'bg-emerald-500' : band === 'low' ? 'bg-orange-500' : 'bg-amber-400';
            const tone = isDisputed ? 'спорная' : isSide ? 'вне основной линии' : isOther ? `другой брак ${parentRoleLabel || 'родителя'}` : '';
            const statusMeta = marriageStatus ? getParentsAncestryStatusMeta(marriageStatus) : null;
            const statusLabel = statusMeta?.label || marriageStatus || '';
            const tooltip = [
                hasConf ? `Уверенность: ${Math.round(conf * 100)}%` : '',
                statusLabel ? `Статус брака: ${statusLabel}` : '',
                tone ? `Состояние: ${tone}` : '',
            ].filter(Boolean).join(' · ');
            return (
                <span className="inline-flex items-baseline gap-1.5 select-none" title={tooltip}>
                    <span className={`inline-block w-2 h-2 rounded-full ${dotColor} translate-y-[-1px]`}></span>
                    {hasConf ? <span className="text-[12px] text-stone-500 tabular-nums">{Math.round(conf * 100)}%</span> : null}
                    {tone ? <span className="text-[11px] text-stone-500 italic">· {tone}</span> : null}
                </span>
            );
        };

        // R-UI: скрытый блок reasons/warnings за иконкой «ⓘ».
        const RospisReasonsToggle = ({ reasons, warnings }) => {
            const [open, setOpen] = useState(false);
            const reasonList = (Array.isArray(reasons) ? reasons : []).filter(Boolean);
            const warningList = (Array.isArray(warnings) ? warnings : []).filter(Boolean);
            if (!reasonList.length && !warningList.length) return null;
            return (
                <span className="inline-block">
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
                        className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-stone-300 text-[10px] text-stone-500 hover:text-stone-800 hover:border-stone-500 leading-none"
                        title="Показать причины и предупреждения"
                    >ⓘ</button>
                    {open ? (
                        <div className="mt-1 ml-1 rounded-md border border-stone-200 bg-white/90 px-3 py-2 text-[12px] leading-5 text-stone-600 max-w-xl">
                            {reasonList.length > 0 ? (
                                <div className="text-rose-700">{reasonList.map((r) => formatParentsAncestryText(r)).join(' · ')}</div>
                            ) : null}
                            {warningList.length > 0 ? (
                                <div className="text-stone-500">{warningList.map((w) => formatParentsAncestryText(w)).join(' · ')}</div>
                            ) : null}
                        </div>
                    ) : null}
                </span>
            );
        };

        const RospisSection = ({ section, showHiddenDebug, onOpenRow }) => {
            const [expanded, setExpanded] = useState(!section.collapsedByDefault);
            const isCollapsible = Boolean(section.collapsedByDefault);
            // Главная роспись и восходящие линии — без обводки/тени, чистая иерархия.
            // Все остальные секции (спорные/боковые/проверка/отклонённые) сохраняют
            // оформление карточкой, чтобы визуально выделяться как «не основная роспись».
            const isClean = section.id === 'parents-family' || section.id === 'paternal' || section.id === 'maternal';
            const sectionShell = isClean
                ? 'border-b border-stone-200 pt-3 pb-6 last:border-b-0'
                : 'rounded-[24px] border border-stone-200 bg-white/95 p-5 shadow-[0_8px_30px_rgba(45,34,20,0.06)]';
            return (
                <section className={sectionShell}>
                    {isCollapsible ? (
                        <button
                            type="button"
                            onClick={() => setExpanded((v) => !v)}
                            className="flex w-full items-baseline justify-between gap-2 text-left font-display text-xl text-stone-800 hover:text-[#8b0000]"
                        >
                            <span>{section.title}</span>
                            <span className="text-[11px] text-stone-500">{expanded ? '▾' : '▸'}</span>
                        </button>
                    ) : (
                        <div className="font-display text-xl text-stone-800">{section.title}</div>
                    )}
                    {section.note ? <div className="mt-1 text-[12px] leading-5 text-stone-500 italic">{section.note}</div> : null}
                    {expanded ? (
                        <React.Fragment>
                            {Array.isArray(section.chain) ? (
                                <ol className="mt-3 list-none pl-0">
                                    {section.chain.map((node, idx) => (
                                        <li key={`${section.id}-${idx}`} className="mt-1 leading-7 text-stone-700">
                                            <span className="inline-block min-w-[3em] pr-2 font-mono text-[12px] uppercase tracking-[0.08em] text-stone-500">{node.depth}.</span>
                                            <span className="text-[11px] uppercase tracking-[0.14em] text-stone-500">{node.roleLabel}:</span>
                                            <span className="ml-2">{node.missingBirth ? <em className="text-stone-500">{node.label} (запись о рождении не найдена)</em> : node.label}</span>
                                            {(() => { const m = formatRospisYears(node); return m ? <span className="text-stone-500"> — {m}</span> : null; })()}
                                            <RospisSourceButton source={node.source} birthRecordId={node.birthRecordId} onOpenRow={onOpenRow} />
                                        </li>
                                    ))}
                                </ol>
                            ) : null}
                            {Array.isArray(section.couples) ? (
                                <div className={isClean ? 'mt-3 space-y-2' : 'mt-4 space-y-4'}>
                                    {section.couples.map((couple) => {
                                        // Для основной росписи (parents-family) — простая строка без карточки.
                                        // Для неосновных (спорные/боковые/проверка) — rounded-карточка с фоном.
                                        const coupleShell = isClean
                                            ? (couple.isOther ? 'pt-2 border-l-2 border-amber-200 pl-3' : '')
                                            : (
                                                'rounded-[18px] border px-4 py-3 ' +
                                                (couple.isOther ? 'border-amber-200 bg-amber-50/40' :
                                                 couple.isSide ? 'border-sky-200 bg-sky-50/40' :
                                                 'border-stone-200 bg-[#fcfaf5]')
                                            );
                                        return (
                                        <div key={couple.id} className={coupleShell}>
                                            <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1 leading-7">
                                                <span className="text-stone-800">{couple.title}</span>
                                                <span className="text-[12px] text-stone-500 tabular-nums">{couple.marriageLabel}</span>
                                                <RospisIndicator
                                                    confidence={couple.confidence}
                                                    confidenceBand={couple.confidenceBand}
                                                    marriageStatus={couple.marriageStatus}
                                                    isOther={couple.isOther}
                                                    isDisputed={couple.isDisputed}
                                                    isSide={couple.isSide}
                                                    parentRoleLabel={couple.parentRoleLabel}
                                                />
                                                <RospisReasonsToggle reasons={couple.displayReasons} warnings={couple.displayWarnings} />
                                                <RospisSourceButton source={couple.marriageSource} onOpenRow={onOpenRow} />
                                            </div>
                                            {(showHiddenDebug && couple.debugMeta) ? (
                                                <div className="mt-2 rounded-[16px] border border-stone-200/80 bg-white/80 px-3 py-2 text-[11px] leading-5 text-stone-500">
                                                    <div className="flex flex-wrap gap-x-4 gap-y-1">
                                                        {couple.debugMeta.rootLineEligibility ? <span>Eligibility: <span className="text-stone-700">{formatParentsAncestryText(couple.debugMeta.rootLineEligibility)}</span></span> : null}
                                                        {couple.debugMeta.originalDisposition ? <span>Исходный бакет: <span className="text-stone-700">{couple.debugMeta.originalDisposition}</span></span> : null}
                                                        {couple.debugMeta.debugDispositionReason ? <span>Причина: <span className="text-stone-700">{formatParentsAncestryText(couple.debugMeta.debugDispositionReason)}</span></span> : null}
                                                        {Number.isFinite(Number(couple.debugMeta.displayScore)) ? <span>Display score: <span className="text-stone-700">{couple.debugMeta.displayScore}</span></span> : null}
                                                        {couple.debugMeta.effectiveStatus ? <span>Итоговый статус: <span className="text-stone-700">{couple.debugMeta.effectiveStatus}</span></span> : null}
                                                        {couple.debugMeta.possibleBrideSurnameLeakDecision ? <span>Leak-решение: <span className="text-stone-700">{formatParentsAncestryText(couple.debugMeta.possibleBrideSurnameLeakDecision)}</span></span> : null}
                                                        {couple.debugMeta.statusCeiling ? <span>Потолок статуса: <span className="text-stone-700">{couple.debugMeta.statusCeiling}</span></span> : null}
                                                        {Number.isFinite(Number(couple.debugMeta.familyCoherenceScore)) ? <span>Цельность семьи: <span className="text-stone-700">{formatParentsConfidencePercent(couple.debugMeta.familyCoherenceScore)}</span></span> : null}
                                                        {couple.debugMeta.spouseCompatibilityResult ? <span>Совм. супруга: <span className="text-stone-700">{couple.debugMeta.spouseCompatibilityResult}</span></span> : null}
                                                        {couple.debugMeta.parentRoleCompatibilityResult ? <span>Совм. роли родителя: <span className="text-stone-700">{couple.debugMeta.parentRoleCompatibilityResult}</span></span> : null}
                                                    </div>
                                                    {Array.isArray(couple.debugMeta.spouseCompatibilityMissing) && couple.debugMeta.spouseCompatibilityMissing.length > 0 ? (
                                                        <div className="mt-1">Не хватает для супруга: <span className="text-stone-700">{couple.debugMeta.spouseCompatibilityMissing.map((item) => formatParentsAncestryText(item)).join(' · ')}</span></div>
                                                    ) : null}
                                                    {Array.isArray(couple.debugMeta.parentRoleCompatibilityMissing) && couple.debugMeta.parentRoleCompatibilityMissing.length > 0 ? (
                                                        <div className="mt-1">Не хватает для роли родителя: <span className="text-stone-700">{couple.debugMeta.parentRoleCompatibilityMissing.map((item) => formatParentsAncestryText(item)).join(' · ')}</span></div>
                                                    ) : null}
                                                    {Array.isArray(couple.debugMeta.spouseCompatibilityDebugFlags) && couple.debugMeta.spouseCompatibilityDebugFlags.length > 0 ? (
                                                        <div className="mt-1">Флаги проверки: <span className="text-stone-700">{couple.debugMeta.spouseCompatibilityDebugFlags.map((item) => formatParentsAncestryText(item)).join(' · ')}</span></div>
                                                    ) : null}
                                                    {couple.debugMeta.suppressedBy?.parentLabel || couple.debugMeta.suppressedBy?.spouseLabel ? (
                                                        <div className="mt-1">Подавлено семьёй: <span className="text-stone-700">{[couple.debugMeta.suppressedBy?.parentLabel, couple.debugMeta.suppressedBy?.spouseLabel].filter(Boolean).join(' × ')}</span></div>
                                                    ) : null}
                                                    {(couple.debugMeta.spouseRawIdentity?.label || couple.debugMeta.spouseMergedIdentity?.label) ? (
                                                        <div className="mt-1">
                                                            Супруг raw/merged: <span className="text-stone-700">{couple.debugMeta.spouseRawIdentity?.label || '—'}</span> → <span className="text-stone-700">{couple.debugMeta.spouseMergedIdentity?.label || '—'}</span>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            ) : null}
                                            {couple.entries.length > 0 ? (
                                                <ol className={isClean ? "mt-1 list-none pl-0 rospis-branch rospis-list" : "mt-2 list-none pl-0 rospis-list"}>
                                                    {couple.entries.map((entry) => (
                                                        <RospisPersonLine key={`${couple.id}-${entry.number}`} number={entry.number} person={entry} onOpenRow={onOpenRow} />
                                                    ))}
                                                </ol>
                                            ) : (
                                                <div className="mt-1 ml-3 text-[12px] text-stone-500 italic">Детей в записях не обнаружено</div>
                                            )}
                                        </div>
                                        );
                                    })}
                                </div>
                            ) : null}
                            {Array.isArray(section.auditItems) ? (
                                <div className="mt-4 space-y-3">
                                    {section.auditItems.map((item, index) => (
                                        <div key={`${section.id}-${item.birthFamilyId || index}`} className="rounded-[18px] border border-stone-200 bg-[#fcfaf5] px-4 py-3">
                                            <div className="font-semibold text-stone-800">{index + 1}. {item.fatherLabel || 'Отец?'} × {item.motherLabel || 'Мать?'}</div>
                                            <div className="mt-1 text-[12px] leading-6 text-stone-500">
                                                {Array.isArray(item.localityLabels) && item.localityLabels.length > 0 ? item.localityLabels.join(' · ') : 'география семьи не определена'}
                                            </div>
                                            {Array.isArray(item.children) && item.children.length > 0 ? (
                                                <div className="mt-2 text-[12px] leading-6 text-stone-700">
                                                    {item.children.map((child) => `${child.label || 'Без имени'}${child.year ? ` (${child.year})` : ''}`).join(' · ')}
                                                </div>
                                            ) : null}
                                            {Array.isArray(item.surnameClusters) && item.surnameClusters.length > 0 ? (
                                                <div className="mt-1 text-[12px] leading-6 text-stone-500">
                                                    Кластеры фамилий: {item.surnameClusters.map((cluster) => (cluster?.surnameKeys || []).join('/')).filter(Boolean).join(' · ')}
                                                </div>
                                            ) : null}
                                            {Array.isArray(item.sourceRefs) && item.sourceRefs.length > 0 ? (
                                                <div className="mt-1 text-[12px] leading-6 text-stone-500">
                                                    Источники: {item.sourceRefs.map((ref) => [ref?.cipherLabel, ref?.pageLabel].filter(Boolean).join(' · ')).filter(Boolean).join(' | ')}
                                                </div>
                                            ) : null}
                                            {Array.isArray(item.reasonKeys) && item.reasonKeys.length > 0 ? (
                                                <div className="mt-1 text-[12px] leading-6 text-rose-700">
                                                    {item.reasonKeys.map((reason) => formatParentsAncestryText(reason)).join(' · ')}
                                                </div>
                                            ) : null}
                                            {Array.isArray(item.warningKeys) && item.warningKeys.length > 0 ? (
                                                <div className="mt-1 text-[12px] leading-6 text-stone-500">
                                                    {item.warningKeys.map((warning) => formatParentsAncestryText(warning)).join(' · ')}
                                                </div>
                                            ) : null}
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                            {Array.isArray(section.leakAuditItems) ? (
                                <div className="mt-4 space-y-3">
                                    {section.leakAuditItems.map((item, index) => (
                                        <div key={`${section.id}-${item.birthFamilyId || item.marriageLabel || index}`} className="rounded-[18px] border border-stone-200 bg-[#fcfaf5] px-4 py-3">
                                            <div className="font-semibold text-stone-800">{index + 1}. {item.marriageLabel || 'Брак без подписи'}</div>
                                            <div className="mt-1 text-[12px] leading-6 text-stone-700">
                                                Семья по рождениям: {item.birthFamilyLabel || '—'}
                                            </div>
                                            <div className="mt-1 text-[12px] leading-6 text-stone-500">
                                                Брак: {item.marriageYear || '—'} · Первый ребёнок: {item.firstChildYear || '—'} · Детей: {item.childrenCount ?? '—'} · Цельность семьи: {Number.isFinite(Number(item.familyCoherenceScore)) ? formatParentsConfidencePercent(item.familyCoherenceScore) : '—'}
                                            </div>
                                            {item.decision ? (
                                                <div className="mt-1 text-[12px] leading-6 text-stone-500">
                                                    Решение: <span className="text-stone-700">{formatParentsAncestryText(item.decision)}</span>
                                                </div>
                                            ) : null}
                                            {Array.isArray(item.reasonKeys) && item.reasonKeys.length > 0 ? (
                                                <div className="mt-1 text-[12px] leading-6 text-rose-700">
                                                    {item.reasonKeys.map((reason) => formatParentsAncestryText(reason)).join(' · ')}
                                                </div>
                                            ) : null}
                                            {Array.isArray(item.warningKeys) && item.warningKeys.length > 0 ? (
                                                <div className="mt-1 text-[12px] leading-6 text-stone-500">
                                                    {item.warningKeys.map((warning) => formatParentsAncestryText(warning)).join(' · ')}
                                                </div>
                                            ) : null}
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </React.Fragment>
                    ) : null}
                </section>
            );
        };

        // R-UI: per-parish alias modal — модератор отмечает «эти OCR-варианты считать
        // одним словом» прямо из росписи. Применяется только в рамках одного прихода.
        const ParishAliasModal = ({ parishId, onClose }) => {
            const [data, setData] = useState(null);
            const [loading, setLoading] = useState(true);
            const [kind, setKind] = useState('names');
            const [canonical, setCanonical] = useState('');
            const [alias, setAlias] = useState('');
            const [saving, setSaving] = useState(false);
            const [message, setMessage] = useState('');
            const fetchAliases = useCallback(() => {
                setLoading(true);
                fetch(`${API_BASE}/parents_parish_aliases?parish_id=${encodeURIComponent(parishId)}`, { credentials: 'include' })
                    .then((r) => r.ok ? r.json() : Promise.reject(r.status))
                    .then((j) => { setData(j); setLoading(false); })
                    .catch(() => { setLoading(false); });
            }, [parishId]);
            useEffect(() => { fetchAliases(); }, [fetchAliases]);
            const submit = async () => {
                const canN = String(canonical || '').trim().toLowerCase();
                const aliN = String(alias || '').trim().toLowerCase();
                if (!canN || !aliN) { setMessage('Заполните оба поля'); return; }
                if (canN === aliN) { setMessage('Канонический и алиас совпадают'); return; }
                setSaving(true);
                setMessage('');
                try {
                    const r = await fetch(`${API_BASE}/parents_parish_alias_add`, {
                        method: 'POST',
                        credentials: 'include',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ parish_id: parishId, kind, canonical: canN, alias: aliN }),
                    });
                    const j = await r.json();
                    if (!r.ok || !j.ok) {
                        setMessage(j.error || 'Не удалось сохранить');
                    } else {
                        setMessage(j.added ? `Добавлено: ${canN} ⇐ ${aliN}` : 'Уже существовало');
                        setCanonical(''); setAlias('');
                        fetchAliases();
                        // Через 1.5 сек — закрыть и перезагрузить страницу, чтобы росписи пересчитались
                        setTimeout(() => { onClose(); window.location.reload(); }, 1200);
                    }
                } catch (e) {
                    setMessage('Сетевая ошибка');
                }
                setSaving(false);
            };
            const aliases = (data?.aliases) || {};
            const namesList = Object.entries(aliases.names || {});
            const patrList = Object.entries(aliases.patronymics || {});
            return (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
                    <div className="bg-white rounded-[22px] shadow-2xl w-[640px] max-w-[92vw] max-h-[88vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                        <div className="px-6 py-4 border-b border-stone-200 flex items-baseline justify-between">
                            <div>
                                <div className="font-display text-xl text-stone-800">Алиасы прихода</div>
                                <div className="text-[12px] text-stone-500">Объединяет OCR-варианты имён и отчеств для прихода <span className="font-semibold">{parishId}</span></div>
                            </div>
                            <button onClick={onClose} className="text-stone-500 hover:text-stone-800 text-[20px] leading-none">×</button>
                        </div>
                        <div className="px-6 py-4 space-y-4">
                            <div className="rounded-[14px] border border-stone-200 bg-stone-50 px-4 py-3 space-y-3">
                                <div className="font-semibold text-stone-700 text-[13px]">Добавить новую пару алиасов</div>
                                <div className="flex gap-2 flex-wrap items-end">
                                    <label className="flex flex-col text-[12px] text-stone-500">
                                        Тип
                                        <select value={kind} onChange={(e) => setKind(e.target.value)} className="mt-1 rounded border border-stone-300 bg-white px-2 py-1 text-[13px] text-stone-800">
                                            <option value="names">Имя</option>
                                            <option value="patronymics">Отчество</option>
                                        </select>
                                    </label>
                                    <label className="flex flex-col text-[12px] text-stone-500 flex-1 min-w-[160px]">
                                        Канонический (правильный)
                                        <input value={canonical} onChange={(e) => setCanonical(e.target.value)} placeholder="например, маструков" className="mt-1 rounded border border-stone-300 bg-white px-2 py-1 text-[13px] text-stone-800" />
                                    </label>
                                    <label className="flex flex-col text-[12px] text-stone-500 flex-1 min-w-[160px]">
                                        Алиас (OCR-вариант)
                                        <input value={alias} onChange={(e) => setAlias(e.target.value)} placeholder="например, мастроков" className="mt-1 rounded border border-stone-300 bg-white px-2 py-1 text-[13px] text-stone-800" />
                                    </label>
                                    <button onClick={submit} disabled={saving} className="rounded bg-[#8b0000] text-white px-3 py-[6px] text-[13px] disabled:opacity-50">
                                        {saving ? 'Сохраняю…' : 'Добавить'}
                                    </button>
                                </div>
                                {message ? <div className="text-[12px] text-stone-700">{message}</div> : null}
                                <div className="text-[11px] italic text-stone-500">Пишите варианты в нижнем регистре, без отчества/окончаний. После добавления страница перезагрузится — все росписи пересчитаются с новым алиасом.</div>
                            </div>

                            <div>
                                <div className="font-semibold text-stone-700 text-[13px] mb-1">Текущие алиасы прихода</div>
                                {loading ? <div className="text-[12px] text-stone-500">Загружаю…</div> : null}
                                {!loading && namesList.length === 0 && patrList.length === 0 ? (
                                    <div className="text-[12px] text-stone-500 italic">Пока нет добавленных алиасов.</div>
                                ) : null}
                                {namesList.length > 0 ? (
                                    <div className="mt-1">
                                        <div className="text-[11px] uppercase tracking-wider text-stone-500">Имена</div>
                                        <ul className="mt-1 space-y-1">
                                            {namesList.map(([can, list]) => (
                                                <li key={`n-${can}`} className="text-[13px] text-stone-700">
                                                    <span className="font-semibold">{can}</span> ⇐ {Array.isArray(list) ? list.join(', ') : ''}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ) : null}
                                {patrList.length > 0 ? (
                                    <div className="mt-2">
                                        <div className="text-[11px] uppercase tracking-wider text-stone-500">Отчества</div>
                                        <ul className="mt-1 space-y-1">
                                            {patrList.map(([can, list]) => (
                                                <li key={`p-${can}`} className="text-[13px] text-stone-700">
                                                    <span className="font-semibold">{can}</span> ⇐ {Array.isArray(list) ? list.join(', ') : ''}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsAncestryRospisView = ({ selected, familyContext, tree, onOpenRow }) => {
            const rospis = useMemo(() => buildParentsRospisModel({ selected, familyContext, tree }), [selected, familyContext, tree]);
            const [aliasModalOpen, setAliasModalOpen] = useState(false);
            const parishIdFromUrl = useMemo(() => {
                try {
                    const parts = window.location.pathname.replace(BASE_PATH, '').split('/').filter(Boolean);
                    if (parts[0] === 'parents' && parts[1]) return parts[1];
                } catch (e) {}
                return '';
            }, []);
            const showHiddenDebug = useMemo(() => {
                try {
                    return new URLSearchParams(window.location.search || '').get('debug') === '1';
                } catch (error) {
                    return false;
                }
            }, []);
            if (!selected) {
                return (
                    <div className="rounded-[24px] border border-dashed border-stone-300 bg-white/70 px-6 py-10 text-center">
                        <div className="font-display text-2xl text-stone-700">Роспись пока не построена</div>
                        <div className="mt-2 text-sm text-stone-500">Выберите запись о рождении слева — появится текстовая роспись с восходящими линиями, родительской семьёй и потомками.</div>
                    </div>
                );
            }
            if (!rospis.sections.length) {
                return (
                    <div className="rounded-[24px] border border-dashed border-stone-300 bg-white/70 px-6 py-10 text-center text-sm text-stone-500">
                        Для выбранной персоны пока не собрано достаточно данных.
                    </div>
                );
            }
            return (
                <div className="space-y-5">
                    {parishIdFromUrl ? (
                        <div className="flex justify-end">
                            <button
                                type="button"
                                onClick={() => setAliasModalOpen(true)}
                                className="text-[12px] text-stone-500 hover:text-[#8b0000] underline-offset-2 hover:underline"
                                title="Объединить OCR-варианты имён в рамках этого прихода"
                            >🔗 Алиасы прихода</button>
                        </div>
                    ) : null}
                    {aliasModalOpen ? <ParishAliasModal parishId={parishIdFromUrl} onClose={() => setAliasModalOpen(false)} /> : null}
                    {rospis.sections.map((section) => (
                        (section.id === 'hidden-families' || section.id === 'mixed-birth-family-audit' || section.id === 'possible-bride-surname-leak-audit') && !showHiddenDebug ? null : (
                        <RospisSection key={section.id} section={section} showHiddenDebug={showHiddenDebug} onOpenRow={onOpenRow} />
                        )
                    ))}
                </div>
            );
        };

        const ParentsClassicKinshipTree = ({ selected, familyContext, tree, onOpenRow, projectTitle = '', parishTitle = '' }) => {
            const [viewOptions, setViewOptions] = useState(DEFAULT_CLASSIC_TREE_VIEW_OPTIONS);
            const classicTreeModel = useMemo(
                () => buildParentsClassicTreeModel({ selected, familyContext, tree, options: viewOptions }),
                [selected, familyContext, tree, viewOptions]
            );
            const classicTreeLayout = useMemo(
                () => layoutParentsClassicTree(classicTreeModel, viewOptions),
                [classicTreeModel, viewOptions]
            );
            const selectedYear = Number(selected?.year || tree?.birthYear || 0);
            const familyChildrenCount = Number(familyContext?.childrenCount || (Array.isArray(familyContext?.children) ? familyContext.children.length : 0));
            const selectedParentsLabel = String(familyContext?.parentsLabel || '').trim();
            const schemeTitle = `Родословная схема: ${selected?.label || 'выбранная персона'}`;
            const schemeSubtitleParts = [
                parishTitle ? `Приход: ${parishTitle}` : '',
                projectTitle ? `Проект: ${projectTitle}` : '',
                selectedYear > 0 ? `Рождение: ${selectedYear}` : '',
                selectedParentsLabel ? `Родители: ${selectedParentsLabel}` : '',
            ].filter(Boolean);
            const schemeSubtitle = schemeSubtitleParts.join(' · ');

            if (!selected) {
                return (
                    <div className="rounded-[30px] border border-dashed border-stone-300 bg-white/70 px-8 py-14 text-center">
                        <div className="font-display text-3xl text-stone-700">Древо пока не выбрано</div>
                        <div className="mt-3 text-sm leading-6 text-stone-500">
                            Выберите запись о рождении слева, и здесь появится классическое дерево семьи: родители, братья и сёстры, деды и бабки.
                        </div>
                    </div>
                );
            }

            return (
                <section className="rounded-[14px] border border-stone-200 bg-white/95 p-5">
                    <div className="min-w-0">
                        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Классическое древо</div>
                        <div className="mt-1 font-display text-[28px] leading-tight text-stone-800">
                            {schemeTitle}
                        </div>
                        {schemeSubtitle ? (
                            <div className="mt-1 text-[13px] text-stone-500 max-w-3xl">
                                {schemeSubtitle}
                            </div>
                        ) : null}
                    </div>
                    <div className="mt-4">
                        <ParentsAncestryRospisView
                            selected={selected}
                            familyContext={familyContext}
                            tree={tree}
                            onOpenRow={onOpenRow}
                        />
                    </div>
                    <div className="mt-4 rounded-[10px] border border-stone-200 bg-[#fcfaf5] px-4 py-3 text-[12px] leading-6 text-stone-500">
                        <span className="font-semibold text-stone-700">Сформировано в yarchiver.</span> {CLASSIC_TREE_PRINT_NOTE}
                    </div>
                </section>
            );
        };

        const ParentsAncestryResultCard = ({ option, active = false, onSelect }) => {
            return (
                <button
                    onClick={() => onSelect(option?.birthRecordId || '')}
                    className={`w-full rounded-[24px] border p-4 text-left transition-colors ${active ? 'border-[#8b0000] bg-[#fff5f1] shadow-[0_10px_28px_rgba(139,0,0,0.08)]' : 'border-stone-200 bg-white/95 hover:border-[#8b0000]/45 hover:bg-white'}`}
                >
                    <div className="flex flex-col gap-3">
                        <div>
                            <div className="font-semibold text-stone-800">{option?.label || 'Без имени'}</div>
                            <div className="mt-1 text-[12px] text-stone-500">
                                {option?.year ? `${option.year} · ` : ''}{option?.sourceLabel || ''}
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {option?.hasFamily ? (
                                <span className="rounded-full border border-stone-200 bg-[#faf6ee] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-stone-600">
                                    Семья
                                </span>
                            ) : null}
                            {option?.hasParentsMarriage ? (
                                <span className="rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-emerald-700">
                                    Брак найден
                                </span>
                            ) : null}
                            {Number(option?.childrenCount || 0) > 0 ? (
                                <span className="rounded-full border border-[#ead8b0] bg-[#fff7e8] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-stone-700">
                                    Дети: {Number(option?.childrenCount || 0)}
                                </span>
                            ) : null}
                        </div>
                        <div className="space-y-1 text-[12px] leading-5 text-stone-500">
                            {option?.fatherLabel ? <div>Отец: <span className="text-stone-700">{option.fatherLabel}</span></div> : null}
                            {option?.motherLabel ? <div>Мать: <span className="text-stone-700">{option.motherLabel}</span></div> : null}
                            {joinLabels(option?.localityLabels) ? <div>{joinLabels(option.localityLabels)}</div> : null}
                        </div>
                    </div>
                </button>
            );
        };

        const ParentsAncestryView = ({ project, projectId, parish = null, parishId = '', onOpenRow, selectedRecordId = '', onSelectedRecordChange = null }) => {
            const [searchValue, setSearchValue] = useState('');
            // selectedBirthRecordId синхронизируется с пропом selectedRecordId (URL-routed).
            const [selectedBirthRecordId, setSelectedBirthRecordIdState] = useState(selectedRecordId || '');
            const setSelectedBirthRecordId = useCallback((value) => {
                const normalized = String(value || '');
                setSelectedBirthRecordIdState(normalized);
                if (typeof onSelectedRecordChange === 'function') {
                    onSelectedRecordChange(normalized);
                }
            }, [onSelectedRecordChange]);
            useEffect(() => {
                const next = String(selectedRecordId || '');
                if (next !== selectedBirthRecordId) {
                    setSelectedBirthRecordIdState(next);
                }
            }, [selectedRecordId]);
            const [currentPage, setCurrentPage] = useState(1);
            const [activeAncestryPane, setActiveAncestryPane] = useState('tree');
            const [listData, setListData] = useState(null);
            const [detailData, setDetailData] = useState(null);
            const [listLoading, setListLoading] = useState(true);
            const [detailLoading, setDetailLoading] = useState(false);
            const [listLoaded, setListLoaded] = useState(false);
            const listRequestSeqRef = useRef(0);
            const detailRequestSeqRef = useRef(0);
            const listCacheRef = useRef(parentsAncestryListStateCache);
            const detailCacheRef = useRef(parentsAncestryDetailStateCache);
            const debouncedSearchValue = useDebouncedValue(searchValue, 350);

            useEffect(() => {
                setCurrentPage(1);
            }, [searchValue]);

            useEffect(() => {
                setSearchValue('');
                setSelectedBirthRecordIdState(String(selectedRecordId || ''));
                setActiveAncestryPane('tree');
                setCurrentPage(1);
                setListData(null);
                setDetailData(null);
                setListLoaded(false);
                setListLoading(true);
            }, [parishId]);

            useEffect(() => {
                setActiveAncestryPane('tree');
            }, [selectedBirthRecordId]);

            useEffect(() => {
                if (!projectId) return;
                const requestSeq = ++listRequestSeqRef.current;
                const controller = new AbortController();
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    search: debouncedSearchValue,
                    page: String(currentPage),
                    page_size: String(PARENTS_ANCESTRY_PAGE_SIZE),
                    v: PARENTS_ANCESTRY_RESPONSE_VERSION,
                });
                const requestKey = params.toString();

                if (listCacheRef.current.has(requestKey)) {
                    setListData(listCacheRef.current.get(requestKey));
                    setListLoaded(true);
                    setListLoading(false);
                    return () => controller.abort();
                }

                setListLoading(true);
                fetch(`${API_BASE}/parents_ancestry_list?${requestKey}`, { signal: controller.signal })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (listRequestSeqRef.current !== requestSeq) return;
                        const normalizedData = data && typeof data === 'object' ? data : {};
                        listCacheRef.current.set(requestKey, normalizedData);
                        setListData(normalizedData);
                        setListLoaded(true);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (listRequestSeqRef.current !== requestSeq) return;
                        showToast('Не удалось загрузить список рождений для вкладки «Связи»', 'error');
                        setListData({ options: [], total: 0, allBirthsTotal: 0, currentPage: 1, totalPages: 1 });
                        setListLoaded(true);
                    })
                    .finally(() => {
                        if (listRequestSeqRef.current === requestSeq) {
                            setListLoading(false);
                        }
                    });

                return () => controller.abort();
            }, [projectId, parishId, debouncedSearchValue, currentPage]);

            useEffect(() => {
                if (!projectId || !selectedBirthRecordId) {
                    setDetailLoading(false);
                    if (!selectedBirthRecordId) {
                        setDetailData(null);
                    }
                    return;
                }
                const requestSeq = ++detailRequestSeqRef.current;
                const controller = new AbortController();
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    birth_record_id: selectedBirthRecordId,
                    max_depth: '4',
                    v: PARENTS_ANCESTRY_RESPONSE_VERSION,
                });
                const requestKey = params.toString();

                // Perf-#3 (SWR): если в локальном кеше есть payload — показываем
                // его МГНОВЕННО, спиннер не появляется. Параллельно fetch-имся
                // за свежими данными в фоне. При получении — обновляем UI и
                // кеш. Это убирает «загружаюсь» при возврате к уже-открытой
                // персоне или быстрой навигации туда-сюда.
                const cachedDetail = detailCacheRef.current.get(requestKey);
                const hadCached = cachedDetail !== undefined;
                if (hadCached) {
                    setDetailData(cachedDetail);
                    setDetailLoading(false);
                } else {
                    setDetailLoading(true);
                }

                fetch(`${API_BASE}/parents_ancestry_detail?${requestKey}`, { signal: controller.signal })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (detailRequestSeqRef.current !== requestSeq) return;
                        const normalizedData = data && typeof data === 'object' ? data : {};
                        detailCacheRef.current.set(requestKey, normalizedData);
                        setDetailData(normalizedData);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (detailRequestSeqRef.current !== requestSeq) return;
                        // Если у нас уже был cached payload — оставляем его и
                        // не пишем ошибку (она затронет UX, payload-то есть).
                        if (!hadCached) {
                            showToast('Не удалось загрузить семейную карточку и древо предков', 'error');
                            setDetailData({ birthRecordId: selectedBirthRecordId, selected: null, familyContext: null, tree: null });
                        }
                    })
                    .finally(() => {
                        if (detailRequestSeqRef.current === requestSeq) {
                            setDetailLoading(false);
                        }
                    });

                return () => controller.abort();
            }, [projectId, parishId, selectedBirthRecordId]);

            const options = Array.isArray(listData?.options) ? listData.options : [];
            const selectedOption = useMemo(
                () => options.find((option) => option?.birthRecordId === selectedBirthRecordId) || null,
                [options, selectedBirthRecordId]
            );
            const selected = detailData?.selected || selectedOption || null;
            const tree = detailData?.tree || null;
            const familyContext = detailData?.familyContext && typeof detailData.familyContext === 'object' ? detailData.familyContext : null;
            const children = Array.isArray(familyContext?.children) ? familyContext.children : [];
            const total = Number(listData?.total || 0);
            const allBirthsTotal = Number(listData?.allBirthsTotal || total || 0);
            const totalPages = Math.max(1, Number(listData?.totalPages || 1));
            const activePage = Math.max(1, Number(listData?.currentPage || currentPage || 1));
            const parentsMarriage = familyContext?.parentsMarriage || tree?.parentsMarriage || null;
            const activeStatusMeta = getParentsAncestryStatusMeta(parentsMarriage?.status);
            const selectedPersonLabel = selected?.label || selectedOption?.label || 'Не выбрано';
            const childrenDisplayCount = Number(familyContext?.childrenTotal || familyContext?.childrenCount || children.length || 0);
            const hasSelectedRecord = Boolean(selectedBirthRecordId);
            const detailIsReady = Boolean(detailData) && detailData?.birthRecordId === selectedBirthRecordId;

            return (
                <div className="flex-1 min-h-0 overflow-hidden bg-[#e8e4dc] bg-texture">
                    <div className="h-full overflow-auto">
                        <div className="max-w-[1760px] mx-auto px-4 py-4 sm:px-6 sm:py-6 space-y-6">
                            {!listLoaded && listLoading ? (
                                <ServicePageLoaderCard
                                    title="Готовим связи"
                                    description="Сначала загружаем быстрый список рождений, чтобы вкладка открывалась сразу. Семейная карточка и древо догружаются отдельно."
                                />
                            ) : null}

                            <section className="parents-page-hero">
                                <div className="relative px-6 py-7 sm:px-8 sm:py-8">
                                    <div className="flex flex-col gap-8 xl:flex-row xl:items-end xl:justify-between">
                                        <div className="min-w-0 max-w-2xl">
                                            <span className="parents-eyebrow">Генеалогический экран</span>
                                            <h1 className="parents-page-title">Связи <em>между поколениями</em></h1>
                                            <span className="parents-page-rule" />
                                            <p className="parents-page-lede">
                                                Выберите запись о рождении слева — справа развернётся классическое родословное древо с родителями, детьми одной пары, предполагаемыми предками и ссылками на источники.
                                            </p>
                                            {parish?.title ? (
                                                <div className="mt-5">
                                                    <span className="parents-parish-chip">
                                                        <span className="parents-parish-chip__dot" />
                                                        Приход · {parish.title}
                                                    </span>
                                                </div>
                                            ) : null}
                                        </div>

                                        <div className="grid gap-2.5 sm:grid-cols-2 xl:grid-cols-4 xl:min-w-[640px]">
                                            <div className="parents-stat-tile">
                                                <div className="parents-stat-tile__label">Рождений в приходе</div>
                                                <div className="parents-stat-tile__value">{allBirthsTotal}</div>
                                            </div>
                                            <div className="parents-stat-tile">
                                                <div className="parents-stat-tile__label">Выбранная персона</div>
                                                <div className="mt-2 text-sm font-semibold leading-5 text-[var(--parents-ink)]">{selectedPersonLabel}</div>
                                            </div>
                                            <div className="parents-stat-tile">
                                                <div className="parents-stat-tile__label">Детей в семье</div>
                                                <div className="parents-stat-tile__value">{childrenDisplayCount}</div>
                                            </div>
                                            <div className="parents-stat-tile">
                                                <div className="parents-stat-tile__label">Статус связи с браком</div>
                                                <div className="mt-2 text-sm font-semibold text-[var(--parents-ink)] leading-5">{activeStatusMeta.label}</div>
                                                <div className="mt-1 text-[12px] text-[var(--parents-ink-soft)]">{activeStatusMeta.description}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid gap-0 xl:grid-cols-[420px_minmax(0,1fr)]">
                                    <aside className="border-b border-stone-200 bg-[#fdf8f0] p-4 sm:p-5 xl:border-b-0 xl:border-r">
                                        <div className="xl:sticky xl:top-6 space-y-4">
                                            <div className="rounded-[26px] border border-stone-200 bg-white/95 p-4 shadow-[0_10px_28px_rgba(45,34,20,0.06)]">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">Поиск по родившимся</div>
                                                <input
                                                    type="text"
                                                    value={searchValue}
                                                    onChange={(event) => setSearchValue(event.target.value)}
                                                    placeholder="Найти ребёнка по имени..."
                                                    autoComplete="off"
                                                    spellCheck={false}
                                                    className="mt-3 w-full rounded-2xl border border-stone-200 bg-white px-4 py-3 text-sm text-stone-700 placeholder:text-stone-400 outline-none transition focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                                />
                                                <div className="mt-3 flex items-center justify-between gap-3 text-[12px] text-stone-500">
                                                    <span>{debouncedSearchValue ? `Найдено по запросу: ${total}` : `Всего в списке: ${total}`}</span>
                                                    {listLoaded && listLoading ? <span>Обновляем…</span> : null}
                                                </div>
                                                <div className="mt-4">
                                                    <PaginationControls
                                                        page={activePage}
                                                        totalPages={totalPages}
                                                        totalItems={total}
                                                        pageSize={PARENTS_ANCESTRY_PAGE_SIZE}
                                                        label="Рождения"
                                                        onChange={setCurrentPage}
                                                    />
                                                </div>
                                            </div>

                                            <div className="max-h-[calc(100vh-290px)] min-h-[320px] overflow-auto pr-1">
                                                <div className="space-y-3">
                                                    {options.length > 0 ? options.map((option) => (
                                                        <ParentsAncestryResultCard
                                                            key={option.birthRecordId}
                                                            option={option}
                                                            active={selectedBirthRecordId === option.birthRecordId}
                                                            onSelect={setSelectedBirthRecordId}
                                                        />
                                                    )) : (
                                                        <div className="rounded-[24px] border border-dashed border-stone-300 bg-white/90 px-5 py-8 text-center">
                                                            <div className="font-display text-2xl text-stone-700">Ничего не найдено</div>
                                                            <div className="mt-2 text-sm text-stone-500">
                                                                Попробуйте изменить запрос или очистить поиск, чтобы вернуться к полному списку рождений.
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </aside>

                                    <main className="min-w-0 bg-[#fffdf8] p-4 sm:p-6">
                                        {detailLoading && hasSelectedRecord ? (
                                            <div className="mb-4 rounded-2xl border border-stone-200 bg-white px-4 py-3 text-[12px] text-stone-500">
                                                Обновляем семейную карточку и цепочку предков...
                                            </div>
                                        ) : null}

                                        {!hasSelectedRecord ? (
                                            <div className="flex min-h-[560px] items-center justify-center rounded-[30px] border border-dashed border-stone-300 bg-white/70 px-8 py-16 text-center">
                                                <div className="max-w-2xl">
                                                    <div className="font-display text-3xl text-stone-700">Выберите запись о рождении слева</div>
                                                    <div className="mt-3 text-sm leading-6 text-stone-500">
                                                        После выбора здесь появится классическое древо семьи: выбранный ребёнок, братья и сёстры в одном ряду, родители, предполагаемые браки и предки выше по поколениям.
                                                    </div>
                                                </div>
                                            </div>
                                        ) : !detailIsReady && detailLoading ? (
                                            <div className="rounded-[30px] border border-stone-200 bg-white/90 p-8 shadow-[0_18px_50px_rgba(45,34,20,0.08)]">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Семейная карточка</div>
                                                <div className="mt-3 font-display text-[30px] leading-tight text-stone-800">Собираем источники и связи</div>
                                                <div className="mt-3 text-sm text-stone-500">
                                                    Загружаем родителей, детей той же пары и данные для классического древа отдельно от списка, чтобы вкладка открывалась быстрее.
                                                </div>
                                            </div>
                                        ) : selected ? (
                                            <ParentsClassicKinshipTree
                                                selected={selected}
                                                familyContext={familyContext}
                                                tree={tree}
                                                onOpenRow={onOpenRow}
                                                projectTitle={project?.title || projectId || ''}
                                                parishTitle={parish?.title || ''}
                                            />
                                        ) : (
                                            <div className="flex min-h-[560px] items-center justify-center rounded-[30px] border border-dashed border-stone-300 bg-white/70 px-8 py-16 text-center">
                                                <div className="max-w-2xl">
                                                    <div className="font-display text-3xl text-stone-700">Не удалось собрать семейную карточку</div>
                                                    <div className="mt-3 text-sm leading-6 text-stone-500">
                                                        Для выбранной записи пока не удалось построить подробный блок связей. Список рождений уже загружен, поэтому можно выбрать другую запись или попробовать открыть эту снова.
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </main>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            );
        };

        const PARENTS_CHAIN_CONFIDENCE_META = {
            high: {
                label: 'Высокая уверенность',
                className: 'border-emerald-200 bg-emerald-50 text-emerald-700'
            },
            medium: {
                label: 'Средняя уверенность',
                className: 'border-amber-200 bg-amber-50 text-amber-700'
            },
            candidate: {
                label: 'Кандидат',
                className: 'border-stone-200 bg-stone-100 text-stone-600'
            }
        };

        const ParentsChainCard = ({ chain, onOpenRow }) => {
            const confidenceMeta = PARENTS_CHAIN_CONFIDENCE_META[chain?.confidence] || PARENTS_CHAIN_CONFIDENCE_META.candidate;
            const marriageCandidate = chain?.birthFamilyCandidate || null;
            const husbandBirthCandidate = chain?.husbandBirthCandidate || null;
            const wifeBirthCandidate = chain?.wifeBirthCandidate || null;

            const openSource = useCallback((source) => {
                if (!source?.itemId || typeof onOpenRow !== 'function') return;
                onOpenRow({ itemId: source.itemId });
            }, [onOpenRow]);

            const buildReasonChips = (reasons) => {
                if (!Array.isArray(reasons) || reasons.length === 0) return null;
                return (
                    <div className="mt-3 flex flex-wrap gap-2">
                        {reasons.slice(0, 4).map((reason, index) => (
                            <span key={`${chain?.chainId || 'chain'}-reason-${index}`} className="rounded-full border border-stone-200 bg-white/90 px-3 py-1 text-[11px] text-stone-500">
                                {formatParentsAncestryText(reason)}
                            </span>
                        ))}
                    </div>
                );
            };

            return (
                <div className="rounded-[30px] border border-stone-300 bg-[#fffdf8]/95 shadow-[0_18px_55px_rgba(45,34,20,0.1)] overflow-hidden">
                    <div className="border-b border-stone-200 bg-white/90 px-6 py-5">
                        <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
                            <div className="min-w-0">
                                <div className="flex flex-wrap items-center gap-2">
                                    <span className={`rounded-full border px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] ${confidenceMeta.className}`}>
                                        {confidenceMeta.label}
                                    </span>
                                    <span className="rounded-full border border-[#8b0000]/15 bg-[#fff5f1] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">
                                        {Math.round(Number(chain?.score || 0) * 100)}% score
                                    </span>
                                </div>
                                <div className="mt-3 font-display text-[28px] leading-tight text-stone-800">
                                    {chain?.displayLabel || 'Семейная цепочка'}
                                </div>
                                <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-stone-500">
                                    {chain?.marriageYear ? <span>Брак: {chain.marriageYear}</span> : null}
                                    {joinLabels(chain?.localityLabels) ? <span>Места: {joinLabels(chain.localityLabels)}</span> : null}
                                    <span>Детей в цепочке: {Number(chain?.childrenCount || 0)}</span>
                                </div>
                            </div>
                            <div className="flex flex-wrap gap-2 shrink-0">
                                {chain?.source?.itemId ? (
                                    <button
                                        onClick={() => openSource(chain.source)}
                                        className="rounded-full border border-[#8b0000]/20 bg-[#fff5f1] px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b0000] hover:bg-[#ffece3]"
                                    >
                                        Открыть брак
                                    </button>
                                ) : null}
                                {husbandBirthCandidate?.birthRecord?.source?.itemId ? (
                                    <button
                                        onClick={() => openSource(husbandBirthCandidate.birthRecord.source)}
                                        className="rounded-full border border-stone-200 bg-white px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] text-stone-600 hover:border-[#8b0000] hover:text-[#8b0000]"
                                    >
                                        Рождение мужа
                                    </button>
                                ) : null}
                                {wifeBirthCandidate?.birthRecord?.source?.itemId ? (
                                    <button
                                        onClick={() => openSource(wifeBirthCandidate.birthRecord.source)}
                                        className="rounded-full border border-stone-200 bg-white px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] text-stone-600 hover:border-[#8b0000] hover:text-[#8b0000]"
                                    >
                                        Рождение жены
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    <div className="grid gap-5 p-6 xl:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,1fr)]">
                        <div className="rounded-[24px] border border-stone-200 bg-white/90 p-5 shadow-[0_10px_28px_rgba(45,34,20,0.06)]">
                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Дети пары</div>
                            <div className="mt-2 text-sm text-stone-500">
                                Первая найденная семейная серия рождений для этого брака.
                            </div>
                            <div className="mt-4 flex flex-wrap gap-2">
                                {(chain?.childrenPreview || []).length > 0 ? (
                                    (chain.childrenPreview || []).map((childName, index) => (
                                        <span key={`${chain?.chainId || 'chain'}-child-${index}`} className="rounded-full border border-stone-200 bg-[#faf6ee] px-3 py-1 text-[12px] text-stone-700">
                                            {childName}
                                        </span>
                                    ))
                                ) : (
                                    <span className="text-sm text-stone-400">Дети пока не выделились в preview.</span>
                                )}
                            </div>
                            {marriageCandidate?.birthFamily?.firstChildYear || marriageCandidate?.birthFamily?.lastChildYear ? (
                                <div className="mt-4 text-sm text-stone-500">
                                    Диапазон рождений: {marriageCandidate?.birthFamily?.firstChildYear || '—'}
                                    {marriageCandidate?.birthFamily?.lastChildYear && marriageCandidate?.birthFamily?.lastChildYear !== marriageCandidate?.birthFamily?.firstChildYear ? ` — ${marriageCandidate.birthFamily.lastChildYear}` : ''}
                                </div>
                            ) : null}
                            {buildReasonChips(marriageCandidate?.reasons)}
                        </div>

                        <div className="rounded-[24px] border border-stone-200 bg-white/90 p-5 shadow-[0_10px_28px_rgba(45,34,20,0.06)]">
                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Вероятное рождение мужа</div>
                            {husbandBirthCandidate ? (
                                <>
                                    <div className="mt-3 font-semibold text-stone-800">
                                        {husbandBirthCandidate?.birthRecord?.childLabel || 'Без имени'}
                                    </div>
                                    <div className="mt-2 space-y-1 text-sm text-stone-500">
                                        <div>Отец: {husbandBirthCandidate?.birthRecord?.fatherLabel || '—'}</div>
                                        <div>Мать: {husbandBirthCandidate?.birthRecord?.motherLabel || '—'}</div>
                                        <div>Год: {husbandBirthCandidate?.birthRecord?.year || '—'}</div>
                                        {joinLabels(husbandBirthCandidate?.birthRecord?.localityLabels) ? (
                                            <div>Место: {joinLabels(husbandBirthCandidate.birthRecord.localityLabels)}</div>
                                        ) : null}
                                    </div>
                                    {buildReasonChips(husbandBirthCandidate?.reasons)}
                                </>
                            ) : (
                                <div className="mt-3 text-sm text-stone-400">Пока не найдено уверенное рождение мужа.</div>
                            )}
                        </div>

                        <div className="rounded-[24px] border border-stone-200 bg-white/90 p-5 shadow-[0_10px_28px_rgba(45,34,20,0.06)]">
                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Вероятное рождение жены</div>
                            {wifeBirthCandidate ? (
                                <>
                                    <div className="mt-3 font-semibold text-stone-800">
                                        {wifeBirthCandidate?.birthRecord?.childLabel || 'Без имени'}
                                    </div>
                                    <div className="mt-2 space-y-1 text-sm text-stone-500">
                                        <div>Отец: {wifeBirthCandidate?.birthRecord?.fatherLabel || '—'}</div>
                                        <div>Мать: {wifeBirthCandidate?.birthRecord?.motherLabel || '—'}</div>
                                        <div>Год: {wifeBirthCandidate?.birthRecord?.year || '—'}</div>
                                        {joinLabels(wifeBirthCandidate?.birthRecord?.localityLabels) ? (
                                            <div>Место: {joinLabels(wifeBirthCandidate.birthRecord.localityLabels)}</div>
                                        ) : null}
                                    </div>
                                    {buildReasonChips(wifeBirthCandidate?.reasons)}
                                </>
                            ) : (
                                <div className="mt-3 text-sm text-stone-400">Пока не найдено уверенное рождение жены.</div>
                            )}
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsChainsView = ({ project, projectId, onOpenRow }) => {
            const [searchValue, setSearchValue] = useState('');
            const [currentPage, setCurrentPage] = useState(1);
            const [chainsData, setChainsData] = useState(null);
            const [chainsLoading, setChainsLoading] = useState(true);
            const [chainsLoaded, setChainsLoaded] = useState(false);
            const requestSeqRef = useRef(0);
            const cacheRef = useRef(new Map());

            useEffect(() => {
                setCurrentPage(1);
            }, [searchValue]);

            useEffect(() => {
                if (!projectId) return;
                const requestSeq = ++requestSeqRef.current;
                const controller = new AbortController();
                const params = new URLSearchParams({
                    pid: projectId,
                    search: searchValue,
                    page: String(currentPage),
                    page_size: String(PARENTS_CHAINS_PAGE_SIZE),
                    v: PARENTS_CHAINS_RESPONSE_VERSION,
                });
                const requestKey = params.toString();

                if (cacheRef.current.has(requestKey)) {
                    setChainsData(cacheRef.current.get(requestKey));
                    setChainsLoaded(true);
                    setChainsLoading(false);
                    return () => controller.abort();
                }

                setChainsLoading(true);
                fetch(`${API_BASE}/parents_chains_state?${requestKey}`, { signal: controller.signal })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (requestSeqRef.current !== requestSeq) return;
                        const normalizedData = data && typeof data === 'object' ? data : {};
                        cacheRef.current.set(requestKey, normalizedData);
                        setChainsData(normalizedData);
                        setChainsLoaded(true);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (requestSeqRef.current !== requestSeq) return;
                        showToast('Не удалось загрузить семейные цепочки', 'error');
                        setChainsData({
                            counts: { all: 0, high: 0, medium: 0, candidate: 0 },
                            total: 0,
                            currentPage: 1,
                            totalPages: 1,
                            pageSize: PARENTS_CHAINS_PAGE_SIZE,
                            rows: [],
                        });
                        setChainsLoaded(true);
                    })
                    .finally(() => {
                        if (requestSeqRef.current === requestSeq) {
                            setChainsLoading(false);
                        }
                    });

                return () => controller.abort();
            }, [projectId, searchValue, currentPage]);

            const counts = chainsData?.counts || { all: 0, high: 0, medium: 0, candidate: 0 };
            const total = Number(chainsData?.total || 0);
            const totalPages = Math.max(1, Number(chainsData?.totalPages || 1));
            const activePage = Math.max(1, Number(chainsData?.currentPage || currentPage || 1));
            const chains = Array.isArray(chainsData?.rows) ? chainsData.rows : [];

            return (
                <div className="flex-1 min-h-0 overflow-hidden bg-[#e8e4dc] bg-texture">
                    <div className="h-full overflow-auto">
                        <div className="max-w-[1760px] mx-auto px-6 py-6 space-y-6">
                            {!chainsLoaded && chainsLoading ? (
                                <ServicePageLoaderCard
                                    title="Собираем семейные цепочки"
                                    description="Связываем браки, серии рождений детей и вероятные рождения супругов внутри одного прихода."
                                />
                            ) : null}

                            <div className="parents-page-hero overflow-hidden">
                                <div className="relative px-6 py-7 sm:px-8 sm:py-8">
                                    <div className="flex flex-col gap-7 xl:flex-row xl:items-end xl:justify-between">
                                        <div className="min-w-0 max-w-2xl">
                                            <span className="parents-eyebrow">Реконструкция родословной</span>
                                            <h1 className="parents-page-title" style={{ fontSize: 'clamp(28px, 3.4vw, 40px)' }}>Семейные <em>цепочки</em></h1>
                                            <span className="parents-page-rule" />
                                            <p className="parents-page-lede" style={{ fontSize: '14px' }}>
                                                Здесь аккуратно связываются браки пар, рождения их детей и вероятные рождения самих супругов. Алгоритм намеренно консервативный: лучше меньше цепочек, чем лишние ошибки.
                                            </p>
                                            {project?.title && (
                                                <div className="mt-4 text-[11px] uppercase tracking-[0.18em] text-[var(--parents-ink-soft)]">
                                                    {project.title}
                                                </div>
                                            )}
                                        </div>
                                        <div className="grid grid-cols-2 xl:grid-cols-4 gap-2.5 shrink-0">
                                            {[
                                                ['Всего цепочек', counts.all || 0],
                                                ['Высокая уверенность', counts.high || 0],
                                                ['Средняя уверенность', counts.medium || 0],
                                                ['Кандидаты', counts.candidate || 0],
                                            ].map(([label, value]) => (
                                                <div key={label} className="parents-stat-tile">
                                                    <div className="parents-stat-tile__label">{label}</div>
                                                    <div className="parents-stat-tile__value">{Number(value || 0)}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="border-b border-stone-200 bg-[#fdf8f0] px-6 py-4">
                                    <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
                                        <div className="w-full max-w-xl">
                                            <DebouncedSearchField
                                                value={searchValue}
                                                onChange={setSearchValue}
                                                placeholder="Найти по именам супругов, детям или месту..."
                                                className="w-full rounded-2xl border border-stone-200 bg-white px-4 py-3 text-sm text-stone-700 placeholder:text-stone-400 outline-none transition focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                            />
                                        </div>
                                        <div className="text-[11px] text-stone-500">
                                            {chainsLoaded && chainsLoading ? 'Обновляем цепочки...' : `${total} цепочек в текущей выборке`}
                                        </div>
                                    </div>
                                </div>

                                <div className="border-b border-stone-200 bg-white/90 px-6 py-4">
                                    <PaginationControls
                                        page={activePage}
                                        totalPages={totalPages}
                                        totalItems={total}
                                        pageSize={PARENTS_CHAINS_PAGE_SIZE}
                                        label="Цепочки"
                                        onChange={setCurrentPage}
                                    />
                                </div>

                                {chains.length > 0 ? (
                                    <div className="space-y-5 p-6">
                                        {chains.map((chain) => (
                                            <ParentsChainCard
                                                key={chain.chainId}
                                                chain={chain}
                                                onOpenRow={onOpenRow}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <div className="px-8 py-20 text-center">
                                        <div className="text-lg font-display text-stone-700">Пока нет цепочек для этой выборки</div>
                                        <div className="mt-2 text-sm text-stone-400">
                                            Попробуй убрать часть поискового запроса или добавить в проект больше страниц с браками и рождениями.
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsDeathCauseAdmin = ({ projectId, parishId = '', onClose, onOpenRow, canEdit = false }) => {
            const [page, setPage] = useState(1);
            const [pageSize] = useState(20);
            const [data, setData] = useState(null);
            const [loading, setLoading] = useState(true);
            const [error, setError] = useState('');
            const [drafts, setDrafts] = useState({}); // { 'itemId|entryIndex': 'value' }
            const [savedKeys, setSavedKeys] = useState(new Set());
            const [savingKey, setSavingKey] = useState('');

            // Esc → закрыть
            useEffect(() => {
                const handleKey = (event) => {
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        onClose?.();
                    }
                };
                window.addEventListener('keydown', handleKey);
                return () => window.removeEventListener('keydown', handleKey);
            }, [onClose]);

            const fetchData = useCallback(async () => {
                if (!projectId) return;
                setLoading(true);
                setError('');
                try {
                    const params = new URLSearchParams({
                        pid: projectId,
                        parish_id: parishId || '',
                        page: String(page),
                        page_size: String(pageSize),
                    });
                    const res = await fetch(`${API_BASE}/parents_unknown_death_causes_list?${params.toString()}`, {
                        credentials: 'same-origin'
                    });
                    const json = await res.json().catch(() => ({}));
                    if (!res.ok || json.error) {
                        throw new Error(json.error || `HTTP ${res.status}`);
                    }
                    setData(json);
                } catch (e) {
                    console.error(e);
                    setError(e?.message || 'Не удалось загрузить выборку');
                } finally {
                    setLoading(false);
                }
            }, [projectId, parishId, page, pageSize]);

            useEffect(() => { fetchData(); }, [fetchData]);

            const items = Array.isArray(data?.items) ? data.items : [];
            const topKnown = Array.isArray(data?.top_known_causes) ? data.top_known_causes : [];
            const total = Number(data?.total || 0);
            const recognized = Number(data?.recognized_count || 0);
            const totalPages = Number(data?.total_pages || 1);

            const rowKey = (it) => `${it.item_id}|${it.entry_index}`;

            const setDraft = (key, value) => setDrafts(prev => ({ ...prev, [key]: value }));

            const saveOne = useCallback(async (item) => {
                if (!canEdit) {
                    showToast('Нужны права на редактирование проекта', 'warning');
                    return;
                }
                const key = rowKey(item);
                const value = String(drafts[key] || '').trim();
                if (!value) {
                    showToast('Заполните причину', 'warning');
                    return;
                }
                setSavingKey(key);
                try {
                    const res = await fetch(`${API_BASE}/structured/entry/update`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        credentials: 'same-origin',
                        body: JSON.stringify({
                            pid: projectId,
                            parish_id: parishId || '',
                            item_id: item.item_id,
                            entry_index: item.entry_index,
                            fields: { death_cause: value },
                        }),
                    });
                    const json = await res.json().catch(() => ({}));
                    if (!res.ok || json.error) {
                        throw new Error(json.error || `HTTP ${res.status}`);
                    }
                    setSavedKeys(prev => {
                        const next = new Set(prev);
                        next.add(key);
                        return next;
                    });
                    showToast(`Причина сохранена: ${value}`, 'success', 2000);
                } catch (e) {
                    console.error(e);
                    showToast(e?.message || 'Не удалось сохранить', 'error');
                } finally {
                    setSavingKey('');
                }
            }, [canEdit, drafts, projectId, parishId]);

            return (
                <div
                    className="fixed inset-0 z-[10000] flex items-stretch justify-center"
                    style={{ background: 'rgba(20,12,6,0.55)', backdropFilter: 'blur(4px)' }}
                    onClick={(event) => {
                        if (event.target === event.currentTarget) onClose?.();
                    }}
                >
                    <div className="w-full max-w-[1080px] my-6 mx-4 flex flex-col parents-table-shell" style={{ maxHeight: 'calc(100vh - 48px)' }}>
                        {/* Sticky close-bar */}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '10px 18px',
                                borderBottom: '1px solid rgba(228,216,191,0.55)',
                                background: 'linear-gradient(180deg, rgba(255,251,242,0.92) 0%, rgba(245,236,216,0.65) 100%)',
                                position: 'relative',
                                zIndex: 4,
                            }}
                        >
                            <span style={{
                                fontFamily: "'Lora', serif",
                                fontSize: '10px',
                                fontWeight: 700,
                                letterSpacing: '0.18em',
                                textTransform: 'uppercase',
                                color: 'var(--parents-ink-soft)',
                            }}>
                                Esc, клик по фону или кнопка справа — закроют панель
                            </span>
                            <button
                                onClick={onClose}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '8px 16px',
                                    borderRadius: '10px',
                                    border: '1px solid rgba(122,14,14,0.40)',
                                    background: 'linear-gradient(180deg, #fffaf2 0%, #fbe6dc 100%)',
                                    color: 'var(--parents-scarlet)',
                                    fontFamily: "'Lora', serif",
                                    fontSize: '11px',
                                    fontWeight: 700,
                                    letterSpacing: '0.14em',
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    boxShadow: '0 3px 10px rgba(122,14,14,0.10), inset 0 1px 0 rgba(255,255,255,0.7)',
                                }}
                                title="Закрыть (Esc)"
                            >
                                <span style={{ fontSize: '14px', lineHeight: 1 }}>×</span>
                                Закрыть
                            </button>
                        </div>

                        <div className="parents-table-header">
                            <div className="flex items-end justify-between gap-4 flex-wrap">
                                <div className="min-w-0 max-w-2xl">
                                    <span className="parents-eyebrow">Доразметка причин</span>
                                    <h2 className="parents-page-title" style={{ fontSize: 'clamp(22px, 2.4vw, 30px)', marginTop: '10px' }}>
                                        Смерти <em>без распознанной причины</em>
                                    </h2>
                                    <span className="parents-page-rule" style={{ marginTop: '12px', width: '72px' }} />
                                    <p className="parents-page-lede" style={{ fontSize: '13px', marginTop: '12px' }}>
                                        Откройте источник, прочитайте колонку «От чего умер» и впишите вручную. Под полем — частые формулировки из этого же прихода для быстрого выбора.
                                    </p>
                                </div>
                                <div className="grid grid-cols-2 gap-2.5 shrink-0">
                                    <div className="parents-stat-tile">
                                        <div className="parents-stat-tile__label">Без причины</div>
                                        <div className="parents-stat-tile__value">{total}</div>
                                    </div>
                                    <div className="parents-stat-tile">
                                        <div className="parents-stat-tile__label">Уже распознано</div>
                                        <div className="parents-stat-tile__value">{recognized}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="parents-table-toolbar parents-table-toolbar--pagination">
                            <PaginationControls
                                page={page}
                                totalPages={totalPages}
                                totalItems={total}
                                pageSize={pageSize}
                                label="Записи"
                                onChange={setPage}
                            />
                        </div>

                        <div className="overflow-auto flex-1" style={{ background: 'linear-gradient(180deg, rgba(255,253,247,0.6) 0%, rgba(245,236,216,0.4) 100%)' }}>
                            {loading ? (
                                <div className="py-16 text-center">
                                    <div className="text-xl" style={{ fontFamily: "'Playfair Display', serif", color: 'var(--parents-ink)' }}>Загружаем выборку…</div>
                                </div>
                            ) : error ? (
                                <div className="py-16 text-center">
                                    <div className="text-xl" style={{ fontFamily: "'Playfair Display', serif", color: 'var(--parents-scarlet)' }}>{error}</div>
                                </div>
                            ) : items.length === 0 ? (
                                <div className="py-16 text-center">
                                    <div className="text-xl" style={{ fontFamily: "'Playfair Display', serif", color: 'var(--parents-ink)' }}>Все записи получили причину. ✓</div>
                                </div>
                            ) : (
                                <div className="px-6 py-4 space-y-3">
                                    {items.map((item) => {
                                        const key = rowKey(item);
                                        const isSaved = savedKeys.has(key);
                                        const isSaving = savingKey === key;
                                        const draftValue = drafts[key] ?? '';
                                        return (
                                            <div
                                                key={key}
                                                style={{
                                                    borderRadius: '14px',
                                                    border: `1px solid ${isSaved ? 'rgba(122,155,108,0.55)' : 'rgba(228,216,191,0.85)'}`,
                                                    background: isSaved ? 'rgba(238,248,232,0.85)' : 'rgba(255,253,247,0.92)',
                                                    padding: '14px 16px',
                                                    transition: 'border-color 0.2s ease, background 0.2s ease',
                                                    opacity: isSaved ? 0.7 : 1,
                                                }}
                                            >
                                                <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                                                    <span style={{ fontFamily: "'Playfair Display', serif", fontSize: '15px', fontWeight: 600, color: 'var(--parents-ink)' }}>
                                                        {item.deceased_label || 'Без имени'}
                                                    </span>
                                                    {item.deceased_age ? (
                                                        <span style={{ fontSize: '12px', color: 'var(--parents-ink-soft)' }}>
                                                            возр. {item.deceased_age}
                                                        </span>
                                                    ) : null}
                                                    {item.year ? (
                                                        <span style={{ fontFamily: "'Playfair Display', serif", fontSize: '13px', color: 'var(--parents-scarlet)', fontVariantNumeric: 'tabular-nums' }}>
                                                            {item.year}
                                                        </span>
                                                    ) : null}
                                                    {item.locality_label ? (
                                                        <span style={{ fontSize: '12px', color: 'var(--parents-ink-soft)' }}>
                                                            · {item.locality_label}
                                                        </span>
                                                    ) : null}
                                                </div>
                                                <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px]" style={{ color: 'var(--parents-ink-soft)' }}>
                                                    <span>{item.cipher_label}</span>
                                                    <span>стр. {item.page_label}</span>
                                                    <button
                                                        onClick={() => onOpenRow?.({ itemId: item.item_id })}
                                                        className="parents-table-action-btn parents-table-action-btn--primary"
                                                        style={{ width: 'auto', padding: '2px 10px', fontSize: '10px', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', borderColor: 'rgba(122,14,14,0.30)' }}
                                                        title="Открыть страницу источника"
                                                    >
                                                        Открыть источник ↗
                                                    </button>
                                                </div>

                                                {!isSaved && canEdit ? (
                                                    <>
                                                        <div className="mt-3 flex items-stretch gap-2">
                                                            <input
                                                                type="text"
                                                                value={draftValue}
                                                                onChange={(e) => setDraft(key, e.target.value)}
                                                                placeholder="например: от чахотки"
                                                                disabled={isSaving}
                                                                className="parents-table-search__input"
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '8px 12px',
                                                                    borderRadius: '10px',
                                                                    border: '1px solid rgba(228,216,191,0.85)',
                                                                    background: 'rgba(255,253,247,0.92)',
                                                                }}
                                                            />
                                                            <button
                                                                type="button"
                                                                disabled={isSaving || !draftValue.trim()}
                                                                onClick={() => saveOne(item)}
                                                                style={{
                                                                    padding: '0 18px',
                                                                    borderRadius: '10px',
                                                                    border: '1px solid rgba(122,14,14,0.45)',
                                                                    background: 'linear-gradient(180deg, #7a0e0e 0%, #5c0a0a 100%)',
                                                                    color: '#fffaf2',
                                                                    fontFamily: "'Lora', serif",
                                                                    fontSize: '11px',
                                                                    fontWeight: 700,
                                                                    letterSpacing: '0.12em',
                                                                    textTransform: 'uppercase',
                                                                    cursor: isSaving || !draftValue.trim() ? 'not-allowed' : 'pointer',
                                                                    opacity: isSaving || !draftValue.trim() ? 0.55 : 1,
                                                                    transition: 'opacity 0.15s ease',
                                                                }}
                                                            >
                                                                {isSaving ? 'Сохраняем…' : 'Сохранить'}
                                                            </button>
                                                        </div>
                                                        {topKnown.length > 0 ? (
                                                            <div className="mt-2 flex flex-wrap gap-1.5">
                                                                {topKnown.map((c) => (
                                                                    <button
                                                                        key={c.label}
                                                                        type="button"
                                                                        onClick={() => setDraft(key, c.label)}
                                                                        style={{
                                                                            padding: '3px 10px',
                                                                            borderRadius: '999px',
                                                                            border: '1px solid rgba(139,90,43,0.30)',
                                                                            background: 'rgba(255,251,242,0.85)',
                                                                            fontFamily: "'Lora', serif",
                                                                            fontSize: '11px',
                                                                            color: 'var(--parents-copper)',
                                                                            cursor: 'pointer',
                                                                            transition: 'background 0.15s ease',
                                                                        }}
                                                                        title={`${c.count} записей`}
                                                                    >
                                                                        {c.label}
                                                                        <span style={{ marginLeft: '6px', color: 'rgba(45,34,20,0.42)', fontVariantNumeric: 'tabular-nums' }}>
                                                                            {c.count}
                                                                        </span>
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        ) : null}
                                                    </>
                                                ) : isSaved ? (
                                                    <div className="mt-2 text-[12px]" style={{ color: '#5b7a3f', fontFamily: "'Lora', serif" }}>
                                                        ✓ Сохранено · обновится в общей статистике после следующей загрузки.
                                                    </div>
                                                ) : !canEdit ? (
                                                    <div className="mt-2 text-[12px]" style={{ color: 'var(--parents-ink-soft)' }}>
                                                        Доступно только редакторам проекта.
                                                    </div>
                                                ) : null}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        <div className="parents-table-toolbar parents-table-toolbar--pagination">
                            <PaginationControls
                                page={page}
                                totalPages={totalPages}
                                totalItems={total}
                                pageSize={pageSize}
                                label="Записи"
                                onChange={setPage}
                            />
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsDataAuditView = ({ projectId, parish = null, parishId = '', canEdit = false, dataVersion = 0 }) => {
            const [payload, setPayload] = useState(null);
            const [loading, setLoading] = useState(true);
            const [preparing, setPreparing] = useState(false);
            const [statusFilter, setStatusFilter] = useState('all');

            const loadAudit = useCallback(async () => {
                setLoading(true);
                try {
                    const params = new URLSearchParams({
                        pid: projectId || 'parents',
                        parish_id: parishId || '',
                        status: statusFilter,
                        limit: '200',
                    });
                    const response = await fetch(`${API_BASE}/parents_data_audit_state?${params.toString()}`, {
                        credentials: 'include',
                    });
                    const data = await response.json();
                    if (!response.ok || data?.error) throw new Error(data?.error || 'Не удалось построить аудит');
                    setPayload(data);
                } catch (error) {
                    console.error(error);
                    showToast(error?.message || 'Не удалось построить аудит данных', 'error');
                    setPayload(null);
                } finally {
                    setLoading(false);
                }
            }, [parishId, projectId, statusFilter]);

            useEffect(() => {
                loadAudit();
            }, [loadAudit, dataVersion]);

            const prepareSnapshot = async () => {
                if (!canEdit || preparing) return;
                setPreparing(true);
                try {
                    const response = await fetch(`${API_BASE}/parents_data_audit_prepare`, {
                        method: 'POST',
                        credentials: 'include',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ pid: projectId || 'parents', parish_id: parishId || '' }),
                    });
                    const data = await response.json();
                    if (!response.ok || data?.error) throw new Error(data?.error || 'Не удалось создать снимок');
                    showToast('Исходный снимок зафиксирован');
                    await loadAudit();
                } catch (error) {
                    console.error(error);
                    showToast(error?.message || 'Не удалось создать исходный снимок', 'error');
                } finally {
                    setPreparing(false);
                }
            };

            const downloadUrl = (kind) => {
                const params = new URLSearchParams({
                    pid: projectId || 'parents',
                    parish_id: parishId || '',
                    kind,
                    status: statusFilter,
                });
                return `${API_BASE}/parents_data_audit_download?${params.toString()}`;
            };

            const summary = payload?.summary || {};
            const snapshot = payload?.sourceSnapshot || {};
            const tasks = Array.isArray(payload?.tasks) ? payload.tasks : [];
            const statusCounts = summary.statusCounts || {};
            const riskEntries = Object.entries(summary.riskCounts || {}).slice(0, 12);
            const reviewedCount = Number(statusCounts.fixed || 0) + Number(statusCounts.kept || 0) + Number(statusCounts.skipped || 0);
            const total = Number(summary.total || 0);
            const progress = total ? Math.round((reviewedCount / total) * 100) : 0;

            return (
                <div className="flex-1 min-h-0 overflow-auto bg-[#e9e2d6]" style={{ backgroundImage: 'radial-gradient(circle at 10% 8%, rgba(139,0,0,0.07), transparent 30%), linear-gradient(135deg, rgba(255,255,255,0.74), rgba(239,231,218,0.74))' }}>
                    <div className="mx-auto max-w-[1480px] px-4 py-6 lg:px-8 lg:py-8">
                        <header className="overflow-hidden rounded-[30px] border border-stone-300 bg-[#fffdf9] shadow-[0_24px_70px_rgba(61,43,26,0.13)]">
                            <div className="grid gap-6 border-b border-stone-200 bg-[#f8f1e7] px-6 py-7 lg:grid-cols-[minmax(0,1fr)_auto] lg:px-9">
                                <div>
                                    <div className="text-[10px] font-black uppercase tracking-[0.24em] text-[#8b0000]">Контроль исходных данных · {parish?.title || 'приход'}</div>
                                    <h2 className="mt-2 text-4xl font-bold leading-none text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Аудит перед визуальной проверкой</h2>
                                    <p className="mt-3 max-w-3xl text-sm leading-6 text-stone-600">Система отмечает конкретные расхождения OCR, структуры и здравого смысла. Ничего не исправляется автоматически: пакет только объясняет модели, какую строку и какое поле нужно сверить.</p>
                                </div>
                                <button onClick={loadAudit} disabled={loading} className="self-start rounded-full border border-stone-300 bg-white px-5 py-3 text-[11px] font-bold uppercase tracking-[0.15em] text-stone-700 hover:border-[#8b0000] hover:text-[#8b0000] disabled:opacity-50">
                                    {loading ? 'Анализируем…' : 'Обновить анализ'}
                                </button>
                            </div>

                            <div className="grid gap-4 p-6 lg:grid-cols-3 lg:p-9">
                                <div className="rounded-[24px] border border-stone-200 bg-white p-5">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">1 · Исходный снимок</div>
                                    <div className="mt-3 text-2xl font-bold text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{snapshot.available ? `${snapshot.documentCount || 0} листов` : 'Не создан'}</div>
                                    <p className="mt-2 min-h-[48px] text-xs leading-5 text-stone-500">Неизменяемая копия импортированного OCR и структурированного слоя. Старые листы при первой фиксации помечаются как baseline текущего состояния.</p>
                                    <div className="mt-4 flex flex-wrap gap-2">
                                        {!snapshot.available ? <button onClick={prepareSnapshot} disabled={!canEdit || preparing} className="rounded-full bg-[#8b0000] px-4 py-2.5 text-[10px] font-bold uppercase tracking-[0.12em] text-white disabled:opacity-50">{preparing ? 'Фиксируем…' : 'Зафиксировать'}</button> : null}
                                        {snapshot.available ? <a href={downloadUrl('source')} className="rounded-full border border-stone-300 px-4 py-2.5 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-700 hover:border-[#8b0000] hover:text-[#8b0000]">Скачать JSON</a> : null}
                                    </div>
                                </div>

                                <div className="rounded-[24px] border border-stone-200 bg-white p-5">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">2 · Обогащённый JSON</div>
                                    <div className="mt-3 text-2xl font-bold text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{total} заданий</div>
                                    <p className="mt-2 min-h-[48px] text-xs leading-5 text-stone-500">Для каждого риска указаны поле, объяснение, OCR-доказательство, координаты строки и предлагаемое значение.</p>
                                    <a href={downloadUrl('enriched')} className="mt-4 inline-flex rounded-full border border-[#8b0000] px-4 py-2.5 text-[10px] font-bold uppercase tracking-[0.12em] text-[#8b0000]">Скачать enriched JSON</a>
                                </div>

                                <div className="rounded-[24px] border border-[#8b0000]/20 bg-[#fff8f4] p-5">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8b0000]">3 · Пакет для модели</div>
                                    <div className="mt-3 text-2xl font-bold text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Без cookies и SSH</div>
                                    <p className="mt-2 min-h-[48px] text-xs leading-5 text-stone-600">ZIP содержит задания и временные read-only ссылки на нужные фрагменты сканов. Ссылки не дают доступа к аккаунту Яндекса.</p>
                                    <a href={downloadUrl('package')} className="mt-4 inline-flex rounded-full bg-[#8b0000] px-4 py-2.5 text-[10px] font-bold uppercase tracking-[0.12em] text-white">Скачать пакет ZIP</a>
                                </div>
                            </div>
                        </header>

                        <section className="mt-6 grid gap-6 lg:grid-cols-[360px_minmax(0,1fr)]">
                            <aside className="space-y-4">
                                <div className="rounded-[24px] border border-stone-300 bg-[#fffdf9] p-5 shadow-sm">
                                    <div className="flex items-end justify-between"><span className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">Проверено</span><b className="text-2xl text-stone-800">{progress}%</b></div>
                                    <div className="mt-3 h-2 overflow-hidden rounded-full bg-stone-200"><div className="h-full rounded-full bg-[#8b0000]" style={{ width: `${progress}%` }} /></div>
                                    <div className="mt-3 grid grid-cols-2 gap-2 text-xs text-stone-600"><span>Ожидают: <b>{statusCounts.pending || 0}</b></span><span>Исправлено: <b>{statusCounts.fixed || 0}</b></span><span>Оставлено: <b>{statusCounts.kept || 0}</b></span><span>Пропущено: <b>{statusCounts.skipped || 0}</b></span></div>
                                </div>
                                <div className="rounded-[24px] border border-stone-300 bg-[#fffdf9] p-5 shadow-sm">
                                    <label className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">Статус заданий</label>
                                    <select value={statusFilter} onChange={event => setStatusFilter(event.target.value)} className="mt-2 w-full rounded-xl border border-stone-300 bg-white px-3 py-2.5 text-sm text-stone-700 outline-none focus:border-[#8b0000]">
                                        <option value="all">Все случаи</option><option value="pending">Не проверено</option><option value="fixed">Исправлено</option><option value="kept">Оставлено</option><option value="skipped">Пропущено</option>
                                    </select>
                                    <div className="mt-5 text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">Основные типы риска</div>
                                    <div className="mt-2 space-y-2">{riskEntries.map(([key, count]) => <div key={key} className="flex items-start justify-between gap-3 rounded-xl bg-stone-50 px-3 py-2 text-xs"><span className="break-words text-stone-600">{key}</span><b className="text-stone-800">{count}</b></div>)}</div>
                                </div>
                            </aside>

                            <div className="rounded-[26px] border border-stone-300 bg-[#fffdf9] shadow-sm">
                                <div className="flex items-center justify-between border-b border-stone-200 px-5 py-4"><div><div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">Очередь модели</div><div className="mt-1 text-sm text-stone-600">Показано {tasks.length} из {summary.total || 0}</div></div></div>
                                {loading ? <div className="flex min-h-[360px] items-center justify-center"><div className="loader-paper" /></div> : tasks.length ? <div className="divide-y divide-stone-200">{tasks.map(task => (
                                    <article key={task.taskId} className="grid gap-3 px-5 py-4 md:grid-cols-[minmax(0,1fr)_auto]">
                                        <div className="min-w-0"><div className="flex flex-wrap items-center gap-2"><span className="rounded-full bg-[#f3e4dc] px-2.5 py-1 text-[9px] font-bold uppercase tracking-[0.12em] text-[#8b0000]">{task.reviewKind === 'logic' ? 'Логика' : 'OCR'}</span><span className="text-xs text-stone-400">{task.eventType || 'Событие'} · {task.year || 'год не указан'}</span></div><div className="mt-2 text-lg font-bold text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{task.personLabel || 'Персона не распознана'}</div><div className="mt-1 text-sm leading-5 text-stone-600">{task.humanExplanation || task.riskType}</div><div className="mt-2 line-clamp-2 text-xs italic text-stone-500">{task.ocrEvidence?.fragment || 'OCR-фрагмент не указан'}</div></div>
                                        <div className="flex items-center gap-2 md:flex-col md:items-end"><span className="text-[10px] font-semibold text-stone-500">{task.cipher || task.pageLabel || ''}</span>{task.image?.externalCropUrl ? <a href={task.image.externalCropUrl} target="_blank" rel="noreferrer" className="rounded-full border border-stone-300 px-3 py-2 text-[9px] font-bold uppercase tracking-[0.12em] text-stone-600 hover:border-[#8b0000] hover:text-[#8b0000]">Фрагмент</a> : null}</div>
                                    </article>
                                ))}</div> : <div className="flex min-h-[360px] items-center justify-center px-8 text-center text-sm text-stone-500">Для выбранного фильтра заданий нет.</div>}
                            </div>
                        </section>
                    </div>
                </div>
            );
        };

        const ParentsOcrReviewView = ({ project, projectId, parish = null, parishId = '', onOpenRow, onEditRow = null, onItemUpdate = null, canEdit = false, dataVersion = 0, reviewKind = 'ocr' }) => {
            const [statusFilter, setStatusFilter] = useState('pending');
            const [payload, setPayload] = useState(null);
            const [loading, setLoading] = useState(true);
            const [activeIndex, setActiveIndex] = useState(0);
            const [manualValue, setManualValue] = useState('');
            const [logicDraft, setLogicDraft] = useState({});
            const [comment, setComment] = useState('');
            const [savingAction, setSavingAction] = useState('');
            const requestSeqRef = useRef(0);
            const isLogicReview = reviewKind === 'logic';
            const reviewStateEndpoint = isLogicReview ? 'parents_logic_review_state' : 'parents_ocr_review_state';
            const reviewDecisionEndpoint = isLogicReview ? 'parents_logic_review_decide' : 'parents_ocr_review_decide';
            const items = Array.isArray(payload?.items) ? payload.items : [];
            const currentCase = items[Math.min(activeIndex, Math.max(0, items.length - 1))] || null;
            const counts = payload?.counts && typeof payload.counts === 'object' ? payload.counts : {};
            const total = Number(payload?.total || 0);
            const fixedCount = Number(counts.fixed || 0);
            const keptCount = Number(counts.kept || 0);
            const skippedCount = Number(counts.skipped || 0);
            const reviewedCount = fixedCount + keptCount;
            const progressPercent = total > 0 ? Math.round((reviewedCount / total) * 100) : 0;
            const reasonLabels = {
                ocr_age_unit_conflict: 'В OCR и структуре совпало число, но различаются единицы возраста',
                structured_age_conflicts_with_ocr_age_column: 'Возраст в структуре противоречит однозначному значению в возрастной колонке OCR',
                possible_previous_or_next_entry_leak: 'Набор данных персоны лучше подтверждается OCR соседней строки',
                secondary_event_before_primary_event: 'Вторая дата события оказалась раньше основной',
                event_date_year_outside_document_range: 'Дата события не согласуется с годом метрической книги',
                event_date_day_column_holds_act_number: 'В графу дня, вероятно, попал порядковый номер акта',
                event_date_day_found_in_month_cell: 'Настоящий день, вероятно, находится в ячейке месяца',
                death_cause_adjacent_row_value_ignored: 'Причина из соседней строки была отброшена и не использована автоматически',
                death_cause_merged_ocr_rows_split: 'OCR склеил две соседние причины; выбрана часть из строки этой записи',
                death_cause_multiple_categories_detected: 'В OCR найдено несколько разных причин смерти',
                death_cause_multiple_explicit_values: 'В OCR есть несколько оборотов «от …»',
                death_cause_long_noisy_fragment: 'Причина извлечена из подозрительно длинного OCR-фрагмента',
                death_cause_old_age_child_conflict: '«Старость» не согласуется с детским возрастом',
                death_cause_fallback_without_direct_ocr_candidate: 'Причина найдена резервным OCR-поиском',
                death_cause_non_cause_text_rejected: 'Служебный текст или фамилия не использованы как причина смерти',
                death_cause_ocr_spelling_uncertain: 'Причина смерти распознана по неуверенному OCR-варианту',
                manual_death_cause_conflicts_with_row_ocr: 'Ручная причина смерти не совпадает с OCR собственной строки',
                person_role_sex_conflict: 'Пол человека противоречит его роли в записи',
                person_age_over_115: 'Указан возраст более 115 лет',
                marriage_age_below_minimum: 'Возраст жениха или невесты ниже допустимого минимума',
                parent_age_at_birth_impossible: 'Возраст родителя при рождении ребёнка невозможен или крайне маловероятен',
                death_old_age_under_30: 'Причина «старость» указана для человека младше 30 лет',
                infant_cause_over_10: 'Причина «младенческая» указана для человека старше 10 лет',
                childbirth_cause_demographic_conflict: 'Причина, связанная с родами, не согласуется с полом или возрастом',
                child_has_adult_marital_status: 'Детский возраст не согласуется со взрослым брачным статусом',
            };
            const evidenceLabels = {
                copiedFields: 'Совпавшие поля',
                discriminativeFields: 'Значимые совпадения',
                currentRowSupport: 'Подтверждение своей строкой',
                neighbourRowSupport: 'Подтверждение соседней строкой',
                neighbourPersonLabel: 'Персона в соседней записи',
                documentYear: 'Год книги',
                primaryDate: 'Основная дата',
                secondaryDate: 'Дополнительная дата',
                structuredAge: 'Возраст в структуре',
                ocrAge: 'Возраст в OCR',
                ageColumnOcr: 'OCR возрастной колонки',
                nameSupport: 'Подтверждение имени',
                patronymicSupport: 'Подтверждение отчества',
                surnameSupport: 'Подтверждение фамилии',
                deathCauseOcrRaw: 'Как прочитал OCR',
                deathCauseOcrNormalized: 'Нормализованная причина',
                deathCauseAdjacentRaw: 'OCR соседней причины',
                deathCauseAdjacentNormalized: 'Причина в соседней строке',
                deathCauseResolved: 'Значение в таблице',
                rowBoundsApplied: 'Проверены границы строки',
                personRole: 'Роль в записи',
                recordedSex: 'Указанный пол',
                expectedSex: 'Ожидаемый пол',
                recordedAge: 'Указанный возраст',
                ageYears: 'Возраст в годах',
                minimumExpectedAge: 'Минимальный ожидаемый возраст',
                marriageRole: 'Роль в браке',
                parentRole: 'Роль родителя',
                deathCause: 'Причина смерти',
                statusText: 'Статус в записи',
            };

            const formatEvidenceValue = (value) => {
                if (Array.isArray(value)) return value.join(', ') || '—';
                if (value && typeof value === 'object') return value.label || value.date || JSON.stringify(value);
                if (typeof value === 'number' && value >= 0 && value <= 1) return `${Math.round(value * 100)}%`;
                return String(value ?? '') || '—';
            };

            const statusTabs = [
                { key: 'pending', label: 'Не проверено', count: Number(counts.pending || 0) },
                { key: 'fixed', label: 'Исправлено', count: fixedCount },
                { key: 'kept', label: 'Оставлено', count: keptCount },
                { key: 'skipped', label: 'Пропущено', count: skippedCount },
                { key: 'all', label: 'Все', count: Number(counts.all || total || 0) },
            ];

            const loadReviewQueue = useCallback(() => {
                if (!projectId) return () => {};
                const requestSeq = ++requestSeqRef.current;
                const controller = new AbortController();
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    status: statusFilter,
                    v: String(dataVersion || 0),
                });
                setLoading(true);
                fetch(`${API_BASE}/${reviewStateEndpoint}?${params.toString()}`, {
                    signal: controller.signal,
                    cache: 'no-store',
                })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (requestSeqRef.current !== requestSeq) return;
                        setPayload(data && typeof data === 'object' ? data : { items: [], counts: {}, total: 0 });
                        setActiveIndex(0);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (requestSeqRef.current !== requestSeq) return;
                        showToast(isLogicReview ? 'Не удалось загрузить очередь проверки логики' : 'Не удалось загрузить очередь проверки OCR', 'error');
                        setPayload({ items: [], counts: {}, total: 0 });
                    })
                    .finally(() => {
                        if (requestSeqRef.current === requestSeq) {
                            setLoading(false);
                        }
                    });
                return () => controller.abort();
            }, [projectId, parishId, statusFilter, dataVersion, isLogicReview, reviewStateEndpoint]);

            useEffect(() => loadReviewQueue(), [loadReviewQueue]);

            useEffect(() => {
                setManualValue(String(currentCase?.proposedValue || currentCase?.structuredValue || ''));
                const personFields = currentCase?.personFields && typeof currentCase.personFields === 'object'
                    ? currentCase.personFields
                    : currentCase?.person && typeof currentCase.person === 'object'
                        ? currentCase.person
                        : {};
                setLogicDraft({
                    name: String(personFields.name || ''),
                    second_name: String(personFields.second_name || ''),
                    surname: String(personFields.surname || ''),
                    sex: String(personFields.sex || ''),
                    status: String(personFields.status || ''),
                    age: String(personFields.age || ''),
                    info: String(personFields.info || ''),
                    geo: String(personFields.geo || ''),
                    other_status: String(personFields.other_status || ''),
                    death_cause: String(currentCase?.entryDeathCause || ''),
                });
                setComment('');
            }, [currentCase?.caseId, currentCase?.proposedValue, currentCase?.structuredValue, currentCase?.entryDeathCause]);

            const buildReviewRow = useCallback((item) => ({
                id: item?.itemId || '',
                itemId: item?.itemId || '',
                itemUrl: item?.itemUrl || '',
                parishId: item?.parishId || parishId || '',
                entryId: item?.entryId || '',
                entryIndex: Number.isInteger(Number(item?.entryIndex)) ? Number(item.entryIndex) : null,
                eventType: item?.eventType || '',
                year: item?.year || '',
                label: item?.personLabel || '',
                personLabel: item?.personLabel || '',
            }), [parishId]);

            const buildStructuredEditOptions = useCallback((item) => {
                const eventType = String(item?.eventType || '').trim().toUpperCase();
                const field = String(item?.field || '').trim();
                let preferredStatus = '';
                if (eventType === 'DEATH') preferredStatus = 'DECEASED';
                else if (eventType === 'BIRTH') preferredStatus = 'BORN';
                else if (eventType === 'WEDDING' || eventType === 'MARRIAGE') preferredStatus = 'GROOM';
                let editorField = field;
                if (field === 'age' && eventType === 'DEATH') editorField = 'death_age';
                if (field === 'person_bundle') editorField = '';
                return { preferredStatus, field: editorField, label: item?.personLabel || '' };
            }, []);

            const handleDecision = useCallback(async (action) => {
                if (!currentCase || !canEdit || savingAction) return;
                const body = {
                    pid: projectId,
                    parish_id: parishId || currentCase.parishId || '',
                    case_id: currentCase.caseId,
                    item_id: currentCase.itemId,
                    action,
                    comment,
                };
                if (action === 'manual') {
                    body.manual_value = manualValue;
                }
                setSavingAction(action);
                try {
                    const response = await fetch(`${API_BASE}/${reviewDecisionEndpoint}`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(body),
                    });
                    const data = await response.json().catch(() => ({}));
                    if (!response.ok || !data?.ok) {
                        throw new Error(data?.error || `HTTP ${response.status}`);
                    }
                    if (typeof onItemUpdate === 'function') {
                        onItemUpdate(data.item_id || currentCase.itemId, {
                            structured_entries: data.structured_entries || [],
                            structured_summary: data.structured_summary || '',
                            structured_search_text: data.structured_search_text || '',
                            structured_has_manual_edits: !!data.structured_has_manual_edits,
                        }, {
                            entryId: currentCase.entryId || '',
                            entryIndex: currentCase.entryIndex,
                        });
                    }
                    showToast(action === 'keep' ? 'Решение сохранено: оставлено как есть' : action === 'skip' ? 'Случай пропущен' : 'Исправление сохранено');
                    loadReviewQueue();
                } catch (error) {
                    console.error(error);
                    showToast('Не удалось сохранить решение проверки', 'error');
                } finally {
                    setSavingAction('');
                }
            }, [canEdit, comment, currentCase, loadReviewQueue, manualValue, onItemUpdate, parishId, projectId, reviewDecisionEndpoint, savingAction]);

            const handleLogicSave = useCallback(async () => {
                if (!currentCase || !canEdit || savingAction) return;
                setSavingAction('manual_fields');
                try {
                    const personFields = {};
                    ['name', 'second_name', 'surname', 'sex', 'status', 'age', 'info', 'geo', 'other_status'].forEach(field => {
                        personFields[field] = String(logicDraft[field] || '').trim();
                    });
                    const response = await fetch(`${API_BASE}/${reviewDecisionEndpoint}`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            pid: projectId,
                            parish_id: parishId || currentCase.parishId || '',
                            case_id: currentCase.caseId,
                            item_id: currentCase.itemId,
                            action: 'manual_fields',
                            person_fields: personFields,
                            entry_fields: { death_cause: String(logicDraft.death_cause || '').trim() },
                            comment,
                        }),
                    });
                    const data = await response.json().catch(() => ({}));
                    if (!response.ok || !data?.ok) {
                        if (data?.error === 'no_review_field_changes') {
                            throw new Error('Измените хотя бы одно поле перед сохранением');
                        }
                        throw new Error(data?.error || `HTTP ${response.status}`);
                    }
                    if (typeof onItemUpdate === 'function') {
                        onItemUpdate(data.item_id || currentCase.itemId, {
                            structured_entries: data.structured_entries || [],
                            structured_summary: data.structured_summary || '',
                            structured_search_text: data.structured_search_text || '',
                            structured_has_manual_edits: !!data.structured_has_manual_edits,
                        }, {
                            entryId: currentCase.entryId || '',
                            entryIndex: currentCase.entryIndex,
                        });
                    }
                    showToast('Исправление сохранено');
                    loadReviewQueue();
                } catch (error) {
                    console.error(error);
                    showToast(error?.message || 'Не удалось сохранить исправление', 'error');
                } finally {
                    setSavingAction('');
                }
            }, [canEdit, comment, currentCase, loadReviewQueue, logicDraft, onItemUpdate, parishId, projectId, reviewDecisionEndpoint, savingAction]);

            const eventLabel = (eventType) => {
                const normalized = String(eventType || '').trim().toUpperCase();
                if (normalized === 'BIRTH') return 'Рождение';
                if (normalized === 'WEDDING' || normalized === 'MARRIAGE') return 'Брак';
                if (normalized === 'DEATH') return 'Смерть';
                return normalized || 'Событие';
            };

            const imageSrc = currentCase?.imageUrl ? toAbsoluteViewerImageUrl(currentCase.imageUrl) : '';
            const bbox = currentCase?.bbox && typeof currentCase.bbox === 'object' ? currentCase.bbox : {};
            const crop = useMemo(() => {
                if (!currentCase) return null;
                const imageWidth = Number(currentCase.imageWidth || 0);
                const imageHeight = Number(currentCase.imageHeight || 0);
                const x = Number(bbox.x || 0);
                const y = Number(bbox.y || 0);
                const width = Number(bbox.width || 0);
                const height = Number(bbox.height || 0);
                if (!imageWidth || !imageHeight || !width || !height) return null;
                const padX = Math.max(120, width * 0.35);
                const padY = Math.max(80, height * 0.6);
                const cropX = Math.max(0, x - padX);
                const cropY = Math.max(0, y - padY);
                const cropRight = Math.min(imageWidth, x + width + padX);
                const cropBottom = Math.min(imageHeight, y + height + padY);
                const cropWidth = Math.max(1, cropRight - cropX);
                const cropHeight = Math.max(1, cropBottom - cropY);
                const scale = Math.min(1.35, 760 / cropWidth, 230 / cropHeight);
                return {
                    x: cropX,
                    y: cropY,
                    width: cropWidth,
                    height: cropHeight,
                    scale,
                    imageWidth,
                    imageHeight,
                };
            }, [bbox.height, bbox.width, bbox.x, bbox.y, currentCase]);

            if (isLogicReview) {
                const logicScale = crop ? Math.min(1.8, 860 / crop.width, 410 / crop.height) : 1;
                const logicFields = [
                    { key: 'name', label: 'Имя' },
                    { key: 'second_name', label: 'Отчество' },
                    { key: 'surname', label: 'Фамилия' },
                    { key: 'age', label: 'Возраст' },
                    { key: 'sex', label: 'Пол' },
                    { key: 'status', label: 'Роль в записи' },
                    { key: 'geo', label: 'Место' },
                    { key: 'info', label: 'Сословие / пояснение' },
                    { key: 'other_status', label: 'Дополнительный статус' },
                ];
                const highlightedField = String(currentCase?.field || '');
                return (
                    <div className="flex-1 min-h-0 overflow-auto bg-[#e9e2d6]" style={{ backgroundImage: 'radial-gradient(circle at 12% 10%, rgba(139,0,0,0.06), transparent 32%), linear-gradient(135deg, rgba(255,255,255,0.7), rgba(241,234,222,0.72))' }}>
                        <div className="mx-auto max-w-[1500px] px-4 py-5 lg:px-7 lg:py-7">
                            <div className="overflow-hidden rounded-[30px] border border-stone-300 bg-[#fffdf9] shadow-[0_24px_70px_rgba(61,43,26,0.14)]">
                                <div className="border-b border-stone-200 bg-[#f8f1e7] px-5 py-5 lg:px-7">
                                    <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
                                        <div className="min-w-0">
                                            <div className="text-[10px] font-black uppercase tracking-[0.22em] text-[#8b0000]">Проверка логики · {parish?.title || 'приход'}</div>
                                            <div className="mt-1 flex flex-wrap items-baseline gap-x-3 gap-y-1">
                                                <h2 className="text-3xl font-bold text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Исправление без переходов</h2>
                                                <span className="text-sm text-stone-500">{total ? `${reviewedCount} из ${total} проверено` : 'Очередь пуста'}</span>
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap items-center gap-2">
                                            {statusTabs.map(tab => (
                                                <button
                                                    key={tab.key}
                                                    onClick={() => setStatusFilter(tab.key)}
                                                    className={`rounded-full border px-3 py-2 text-[10px] font-bold uppercase tracking-[0.12em] transition ${statusFilter === tab.key ? 'border-[#8b0000] bg-[#8b0000] text-white' : 'border-stone-300 bg-white text-stone-600 hover:border-[#8b0000]'}`}
                                                >
                                                    {tab.label} · {tab.count}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="mt-4 h-1.5 overflow-hidden rounded-full bg-stone-200">
                                        <div className="h-full rounded-full bg-[#8b0000] transition-all" style={{ width: `${progressPercent}%` }} />
                                    </div>
                                </div>

                                {loading ? (
                                    <div className="flex min-h-[560px] items-center justify-center p-10 text-center">
                                        <div><div className="loader-paper mx-auto" /><div className="mt-4 text-sm text-stone-500">Собираем записи для проверки…</div></div>
                                    </div>
                                ) : !currentCase ? (
                                    <div className="flex min-h-[500px] items-center justify-center p-10 text-center">
                                        <div><div className="text-2xl font-bold text-stone-800" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Для этого фильтра всё проверено</div><div className="mt-2 text-sm text-stone-500">Можно выбрать другой статус или другой приход.</div></div>
                                    </div>
                                ) : (
                                    <div className="grid min-h-[690px] grid-cols-1 xl:grid-cols-[minmax(0,1.25fr)_minmax(430px,0.75fr)]">
                                        <section className="border-b border-stone-200 bg-[#302b27] p-4 xl:border-b-0 xl:border-r xl:p-6">
                                            <div className="flex flex-wrap items-center justify-between gap-3 text-white">
                                                <div>
                                                    <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">Оригинальная запись</div>
                                                    <div className="mt-1 text-sm font-semibold">{currentCase.cipher || 'Шифр не указан'}{currentCase.pageLabel ? ` · ${currentCase.pageLabel}` : ''}</div>
                                                </div>
                                                {currentCase.itemUrl ? <a href={currentCase.itemUrl} target="_blank" rel="noreferrer" className="rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs font-semibold hover:bg-white/15">Открыть весь лист ↗</a> : null}
                                            </div>
                                            <div className="mt-4 flex min-h-[430px] items-center justify-center overflow-hidden rounded-[22px] border border-white/10 bg-[#191714] shadow-inner">
                                                {imageSrc && crop ? (
                                                    <div className="relative h-[430px] w-full overflow-hidden">
                                                        <img
                                                            src={imageSrc}
                                                            alt="Фрагмент архивной записи"
                                                            className="absolute max-w-none select-none"
                                                            style={{
                                                                width: `${crop.imageWidth * logicScale}px`,
                                                                height: `${crop.imageHeight * logicScale}px`,
                                                                left: `${Math.max((860 - crop.width * logicScale) / 2, 0) - crop.x * logicScale}px`,
                                                                top: `${Math.max((430 - crop.height * logicScale) / 2, 0) - crop.y * logicScale}px`,
                                                            }}
                                                        />
                                                        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/35 to-transparent" />
                                                    </div>
                                                ) : imageSrc ? (
                                                    <img src={imageSrc} alt="Архивный лист" className="max-h-[560px] w-full object-contain" />
                                                ) : (
                                                    <div className="px-8 text-center text-sm text-stone-400">Изображение недоступно. OCR-текст записи показан ниже.</div>
                                                )}
                                            </div>
                                            <div className="mt-4 rounded-[20px] border border-white/10 bg-white/[0.06] p-5 text-stone-100">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">OCR этой строки</div>
                                                <div className="mt-2 text-lg leading-7" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{currentCase.ocrFragment || 'OCR-фрагмент отсутствует.'}</div>
                                            </div>
                                        </section>

                                        <section className="flex min-h-0 flex-col bg-[#fffdf9]">
                                            <div className="border-b border-stone-200 px-5 py-5 lg:px-6">
                                                <div className="flex items-start justify-between gap-4">
                                                    <div className="min-w-0">
                                                        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">{eventLabel(currentCase.eventType)} · {currentCase.year || 'год не указан'}</div>
                                                        <h3 className="mt-1 text-3xl font-bold leading-none text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{currentCase.personLabel || 'Персона не распознана'}</h3>
                                                    </div>
                                                    <span className="shrink-0 rounded-full border border-rose-200 bg-rose-50 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-rose-800">{currentCase.fieldLabel || 'Проверка'}</span>
                                                </div>
                                                <div className="mt-4 rounded-2xl border border-amber-300 bg-amber-50 p-4">
                                                    <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-amber-800">Что не сходится</div>
                                                    <div className="mt-1 text-base font-semibold leading-6 text-stone-800">{currentCase.note || currentCase.reasonCodes?.map(reason => reasonLabels[reason] || reason).join('. ')}</div>
                                                    {currentCase.evidence && Object.keys(currentCase.evidence).length ? (
                                                        <div className="mt-3 flex flex-wrap gap-2">
                                                            {Object.entries(currentCase.evidence).map(([key, value]) => (
                                                                <span key={key} className="rounded-lg border border-amber-200 bg-white/80 px-2.5 py-1.5 text-xs text-stone-600"><b>{evidenceLabels[key] || key}:</b> {formatEvidenceValue(value)}</span>
                                                            ))}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>

                                            <div className="flex-1 overflow-auto px-5 py-5 lg:px-6">
                                                <div className="mb-3 text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">Исправьте нужное поле прямо здесь</div>
                                                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                                    {logicFields.map(({ key, label }) => (
                                                        <label key={key} className={`${key === 'geo' || key === 'info' || key === 'other_status' ? 'sm:col-span-2' : ''} rounded-xl border p-3 transition ${highlightedField === key || (highlightedField === 'person_bundle' && ['sex', 'status', 'info', 'other_status'].includes(key)) ? 'border-[#8b0000]/45 bg-[#fff5f1]' : 'border-stone-200 bg-white'}`}>
                                                            <span className="block text-[10px] font-bold uppercase tracking-[0.13em] text-stone-400">{label}</span>
                                                            {key === 'sex' ? (
                                                                <select value={logicDraft[key] || ''} onChange={event => setLogicDraft(prev => ({ ...prev, [key]: event.target.value }))} disabled={!canEdit || !!savingAction} className="mt-1 w-full bg-transparent py-1 text-sm font-semibold text-stone-800 outline-none">
                                                                    <option value="">Не указан</option><option value="MALE">Мужской</option><option value="FEMALE">Женский</option>
                                                                </select>
                                                            ) : (
                                                                <input value={logicDraft[key] || ''} onChange={event => setLogicDraft(prev => ({ ...prev, [key]: event.target.value }))} disabled={!canEdit || !!savingAction} className="mt-1 w-full bg-transparent py-1 text-sm font-semibold text-stone-800 outline-none" />
                                                            )}
                                                        </label>
                                                    ))}
                                                    {String(currentCase.eventType || '').toUpperCase() === 'DEATH' ? (
                                                        <label className={`sm:col-span-2 rounded-xl border p-3 ${highlightedField === 'death_cause' ? 'border-[#8b0000]/45 bg-[#fff5f1]' : 'border-stone-200 bg-white'}`}>
                                                            <span className="block text-[10px] font-bold uppercase tracking-[0.13em] text-stone-400">Причина смерти</span>
                                                            <input value={logicDraft.death_cause || ''} onChange={event => setLogicDraft(prev => ({ ...prev, death_cause: event.target.value }))} disabled={!canEdit || !!savingAction} className="mt-1 w-full bg-transparent py-1 text-sm font-semibold text-stone-800 outline-none" />
                                                        </label>
                                                    ) : null}
                                                </div>
                                                <textarea value={comment} onChange={event => setComment(event.target.value)} disabled={!canEdit || !!savingAction} placeholder="Комментарий к исправлению, если нужен" className="mt-3 min-h-[64px] w-full rounded-xl border border-stone-200 bg-white px-3 py-2 text-sm outline-none focus:border-[#8b0000]" />
                                            </div>

                                            <div className="border-t border-stone-200 bg-[#f8f3ea] px-5 py-4 lg:px-6">
                                                <div className="flex flex-wrap items-center gap-2">
                                                    <button onClick={handleLogicSave} disabled={!canEdit || !!savingAction} className="rounded-full bg-[#8b0000] px-5 py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-white shadow-sm disabled:opacity-50">{savingAction === 'manual_fields' ? 'Сохраняем…' : 'Сохранить исправление'}</button>
                                                    <button onClick={() => handleDecision('keep')} disabled={!canEdit || !!savingAction} className="rounded-full border border-stone-300 bg-white px-4 py-3 text-[11px] font-bold uppercase tracking-[0.12em] text-stone-600 disabled:opacity-50">Оставить как есть</button>
                                                    <button onClick={() => handleDecision('skip')} disabled={!canEdit || !!savingAction} className="rounded-full border border-stone-300 bg-transparent px-4 py-3 text-[11px] font-bold uppercase tracking-[0.12em] text-stone-500 disabled:opacity-50">Пропустить</button>
                                                </div>
                                                <div className="mt-4 flex items-center justify-between gap-3 border-t border-stone-200 pt-4">
                                                    <button onClick={() => setActiveIndex(prev => Math.max(0, prev - 1))} disabled={activeIndex <= 0} className="text-xs font-bold text-stone-500 disabled:opacity-30">← Предыдущая</button>
                                                    <div className="text-xs font-semibold text-stone-500">{activeIndex + 1} из {items.length}</div>
                                                    <button onClick={() => setActiveIndex(prev => Math.min(items.length - 1, prev + 1))} disabled={activeIndex >= items.length - 1} className="text-xs font-bold text-stone-500 disabled:opacity-30">Следующая →</button>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            }

            return (
                <div className="flex-1 min-h-0 overflow-auto bg-[#e8e4dc] bg-texture">
                    <div className="mx-auto max-w-7xl px-6 py-8">
                        <div className="rounded-[32px] border border-stone-300 bg-[#fdfbf7]/95 p-6 shadow-[0_22px_70px_rgba(45,34,20,0.12)]">
                            <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
                                <div>
                                    <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#8b0000]">{isLogicReview ? 'Проверка здравого смысла' : 'Ручная сверка OCR'}</div>
                                    <h2 className="mt-2 text-3xl font-bold text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                                        {isLogicReview ? 'Логические противоречия в записях' : 'Расхождения между OCR и структурой'}
                                    </h2>
                                    <p className="mt-2 max-w-2xl text-sm text-stone-600">
                                        {isLogicReview
                                            ? 'Здесь собраны значения, которые противоречат возрасту, полу или роли человека. Это только сигнал для ручной проверки: исходный OCR и данные не меняются автоматически.'
                                            : 'Здесь проверяются случаи, где исходный текст и структурированный слой расходятся. OCR остаётся неизменным, а правка сохраняется как ручное решение внутри записи.'}
                                    </p>
                                </div>
                                <div className="min-w-[240px] rounded-2xl border border-stone-200 bg-white/80 p-4">
                                    <div className="flex items-center justify-between text-[11px] font-bold uppercase tracking-[0.16em] text-stone-500">
                                        <span>Прогресс</span>
                                        <span>{progressPercent}%</span>
                                    </div>
                                    <div className="mt-3 h-2 overflow-hidden rounded-full bg-stone-200">
                                        <div className="h-full rounded-full bg-[#8b0000]" style={{ width: `${progressPercent}%` }}></div>
                                    </div>
                                    <div className="mt-2 text-xs text-stone-500">{reviewedCount} из {total} проверено</div>
                                </div>
                            </div>

                            <div className="mt-6 flex flex-wrap gap-2">
                                {statusTabs.map(tab => (
                                    <button
                                        key={tab.key}
                                        onClick={() => setStatusFilter(tab.key)}
                                        className={`rounded-full border px-4 py-2 text-[11px] font-bold uppercase tracking-[0.14em] transition-colors ${statusFilter === tab.key ? 'border-[#8b0000] bg-[#8b0000] text-white' : 'border-stone-300 bg-white text-stone-600 hover:border-[#8b0000] hover:text-[#8b0000]'}`}
                                    >
                                        {tab.label} · {tab.count}
                                    </button>
                                ))}
                            </div>

                            {loading ? (
                                <div className="mt-8 rounded-[28px] border border-stone-200 bg-white/90 px-8 py-12 text-center">
                                    <div className="loader-paper mx-auto"></div>
                                    <div className="mt-4 text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Загружаем очередь</div>
                                    <div className="mt-2 text-sm text-stone-500">{isLogicReview ? 'Ищем внутренние противоречия в записях выбранного прихода.' : 'Сверяем известные расхождения для выбранного прихода.'}</div>
                                </div>
                            ) : !currentCase ? (
                                <div className="mt-8 rounded-[28px] border border-stone-200 bg-white/90 px-8 py-12 text-center">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Очередь пуста</div>
                                    <div className="mt-2 text-sm text-stone-500">Для выбранного фильтра нет случаев проверки.</div>
                                </div>
                            ) : (
                                <div className="mt-8 grid grid-cols-1 gap-6 xl:grid-cols-[minmax(0,1fr)_360px]">
                                    <div className="rounded-[30px] border border-stone-300 bg-white p-6 shadow-sm">
                                        <div className="flex flex-wrap items-start justify-between gap-4">
                                            <div>
                                                <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">
                                                    {eventLabel(currentCase.eventType)} · {currentCase.year || currentCase.eventYearLabel || 'год не указан'}
                                                </div>
                                                <h3 className="mt-2 text-3xl font-bold text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                                                    {currentCase.personLabel || 'Персона не распознана'}
                                                </h3>
                                                <div className="mt-2 text-sm text-stone-500">
                                                    {currentCase.cipher || 'шифр не указан'}{currentCase.pageLabel ? ` · ${currentCase.pageLabel}` : ''}
                                                </div>
                                            </div>
                                            <div className="flex flex-wrap justify-end gap-2">
                                                <span className="rounded-full border border-stone-300 bg-stone-50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">
                                                    {currentCase.statusLabel || currentCase.status}
                                                </span>
                                                <span className={`rounded-full border px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] ${currentCase.riskLevel === 'high' ? 'border-rose-300 bg-rose-50 text-rose-800' : 'border-amber-300 bg-amber-50 text-amber-800'}`}>
                                                    {currentCase.riskLevel === 'high' ? 'Высокий риск' : 'Требует внимания'}
                                                </span>
                                                <span className="rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-sky-800">
                                                    {currentCase.fieldLabel || currentCase.field || 'Поле'}
                                                </span>
                                            </div>
                                        </div>

                                        {Array.isArray(currentCase.reasonCodes) && currentCase.reasonCodes.length ? (
                                            <div className="mt-5 rounded-2xl border border-amber-200 bg-amber-50/70 p-4">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-amber-800">Почему случай попал в очередь</div>
                                                <div className="mt-2 space-y-1 text-sm text-stone-700">
                                                    {currentCase.reasonCodes.map(reason => <div key={reason}>{reasonLabels[reason] || reason}</div>)}
                                                </div>
                                            </div>
                                        ) : null}

                                        <div className={`mt-6 grid grid-cols-1 gap-3 ${isLogicReview ? 'md:grid-cols-2' : 'md:grid-cols-3'}`}>
                                            {!isLogicReview ? (
                                                <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4">
                                                    <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-amber-800">OCR</div>
                                                    <div className="mt-2 text-xl font-bold text-stone-900">{currentCase.ocrValue || '—'}</div>
                                                </div>
                                            ) : null}
                                            <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-rose-800">{isLogicReview ? 'Подозрительное значение' : 'Структура'}</div>
                                                <div className="mt-2 text-xl font-bold text-stone-900">{currentCase.structuredValue || '—'}</div>
                                            </div>
                                            <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-emerald-800">{isLogicReview ? 'Что проверить' : 'Предложение'}</div>
                                                <div className="mt-2 text-base font-semibold leading-6 text-stone-900">{isLogicReview ? (currentCase.note || 'Сверьте значение со сканом.') : (currentCase.proposedValue || '—')}</div>
                                            </div>
                                        </div>

                                        <div className="mt-6 rounded-2xl border border-stone-200 bg-[#fbf7ef] p-5">
                                            <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">{isLogicReview ? 'Текст строки OCR для сверки' : 'Исходный OCR-фрагмент'}</div>
                                            <blockquote className="mt-3 border-l-4 border-[#8b0000] pl-4 text-lg leading-relaxed text-stone-800" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                                                {currentCase.ocrFragment || 'Фрагмент OCR не указан.'}
                                            </blockquote>
                                        </div>

                                        {currentCase.evidence && Object.keys(currentCase.evidence).some(key => key !== 'neighbourOcrFragment' && key !== 'neighbourEntryId' && key !== 'neighbourEntryIndex') ? (
                                            <div className="mt-6 rounded-2xl border border-sky-200 bg-sky-50/60 p-5">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-sky-800">Диагностика</div>
                                                <dl className="mt-3 grid gap-2 text-sm sm:grid-cols-2">
                                                    {Object.entries(currentCase.evidence)
                                                        .filter(([key]) => key !== 'neighbourOcrFragment' && key !== 'neighbourEntryId' && key !== 'neighbourEntryIndex')
                                                        .map(([key, value]) => (
                                                            <div key={key} className="rounded-xl border border-sky-100 bg-white/80 p-3">
                                                                <dt className="text-[10px] font-bold uppercase tracking-[0.12em] text-stone-400">{evidenceLabels[key] || key}</dt>
                                                                <dd className="mt-1 text-stone-700">{formatEvidenceValue(value)}</dd>
                                                            </div>
                                                        ))}
                                                </dl>
                                                {currentCase.evidence.neighbourOcrFragment ? (
                                                    <div className="mt-3 rounded-xl border border-sky-100 bg-white/80 p-3">
                                                        <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-stone-400">OCR соседней строки</div>
                                                        <div className="mt-2 text-sm leading-relaxed text-stone-700">{currentCase.evidence.neighbourOcrFragment}</div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        ) : null}

                                        <div className="mt-6">
                                            <div className="mb-2 flex items-center justify-between gap-3">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">Фрагмент скана</div>
                                                {currentCase.itemUrl ? (
                                                    <a className="text-xs font-semibold text-[#8b0000] hover:underline" href={currentCase.itemUrl} target="_blank" rel="noreferrer">Открыть оригинал</a>
                                                ) : null}
                                            </div>
                                            {imageSrc && crop ? (
                                                <div className="relative h-[240px] overflow-hidden rounded-2xl border border-stone-300 bg-stone-100">
                                                    <img
                                                        src={imageSrc}
                                                        alt="Фрагмент архивного листа"
                                                        className="absolute max-w-none select-none"
                                                        style={{
                                                            width: `${crop.imageWidth * crop.scale}px`,
                                                            height: `${crop.imageHeight * crop.scale}px`,
                                                            left: `${-crop.x * crop.scale}px`,
                                                            top: `${-crop.y * crop.scale}px`,
                                                        }}
                                                    />
                                                </div>
                                            ) : imageSrc ? (
                                                <div className="overflow-hidden rounded-2xl border border-stone-300 bg-stone-100">
                                                    <img src={imageSrc} alt="Архивный лист" className="max-h-[360px] w-full object-contain" />
                                                </div>
                                            ) : (
                                                <div className="rounded-2xl border border-dashed border-stone-300 bg-stone-50 p-6 text-sm text-stone-500">
                                                    Изображение или координаты фрагмента недоступны, но ссылка на оригинальную страницу сохранена.
                                                </div>
                                            )}
                                        </div>

                                        {currentCase.diagnosticOnly ? (
                                            <div className="mt-6 rounded-2xl border border-amber-300 bg-amber-50 p-5 text-sm text-stone-700">
                                                {isLogicReview
                                                    ? 'Автоматическое исправление отключено: система заметила противоречие, но не знает правильного значения. Сверьте скан и откройте структурированный редактор.'
                                                    : 'Автоматическое исправление отключено: подозревается ошибка целой строки. Сверьте скан и откройте структурированный редактор.'}
                                            </div>
                                        ) : (
                                        <div className="mt-6 rounded-2xl border border-stone-200 bg-white p-5">
                                            <label className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">Ручное значение перед сохранением</label>
                                            <input
                                                value={manualValue}
                                                onChange={(event) => setManualValue(event.target.value)}
                                                className="mt-2 w-full rounded-xl border border-stone-300 bg-white px-4 py-3 text-base text-stone-900 outline-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/15"
                                                placeholder="Например: 10 лет"
                                                disabled={!canEdit || !currentCase.canManualEdit || !!savingAction}
                                            />
                                            <textarea
                                                value={comment}
                                                onChange={(event) => setComment(event.target.value)}
                                                className="mt-3 min-h-[72px] w-full rounded-xl border border-stone-300 bg-white px-4 py-3 text-sm text-stone-900 outline-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/15"
                                                placeholder="Комментарий к решению, если нужен"
                                                disabled={!canEdit || !!savingAction}
                                            />
                                        </div>
                                        )}

                                        <div className="mt-6 flex flex-wrap gap-3">
                                            {!isLogicReview ? <button
                                                disabled={!canEdit || !currentCase.canApplyOcr || !!savingAction}
                                                onClick={() => handleDecision('fix_ocr')}
                                                className="rounded-full bg-[#8b0000] px-5 py-3 text-[11px] font-bold uppercase tracking-[0.16em] text-white shadow-sm disabled:cursor-not-allowed disabled:opacity-50"
                                            >
                                                {savingAction === 'fix_ocr' ? 'Сохраняем…' : 'Исправить по OCR'}
                                            </button> : null}
                                            <button
                                                disabled={!canEdit || !currentCase.canManualEdit || !!savingAction}
                                                onClick={() => handleDecision('manual')}
                                                className="rounded-full border border-[#8b0000] bg-white px-5 py-3 text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b0000] disabled:cursor-not-allowed disabled:opacity-50"
                                            >
                                                {savingAction === 'manual' ? 'Сохраняем…' : 'Ввести вручную'}
                                            </button>
                                            <button
                                                disabled={!canEdit || !!savingAction}
                                                onClick={() => handleDecision('keep')}
                                                className="rounded-full border border-stone-300 bg-white px-5 py-3 text-[11px] font-bold uppercase tracking-[0.16em] text-stone-600 disabled:cursor-not-allowed disabled:opacity-50"
                                            >
                                                Оставить как есть
                                            </button>
                                            <button
                                                disabled={!canEdit || !!savingAction}
                                                onClick={() => handleDecision('skip')}
                                                className="rounded-full border border-stone-300 bg-stone-50 px-5 py-3 text-[11px] font-bold uppercase tracking-[0.16em] text-stone-500 disabled:cursor-not-allowed disabled:opacity-50"
                                            >
                                                Пропустить
                                            </button>
                                        </div>
                                        {!canEdit ? (
                                            <div className="mt-3 text-sm text-stone-500">Сохранять решения могут только редакторы проекта.</div>
                                        ) : null}
                                    </div>

                                    <aside className="space-y-4">
                                        <div className="rounded-[28px] border border-stone-300 bg-white p-5 shadow-sm">
                                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">Навигация</div>
                                            <div className="mt-4 flex items-center justify-between gap-3">
                                                <button
                                                    onClick={() => setActiveIndex(prev => Math.max(0, prev - 1))}
                                                    disabled={activeIndex <= 0}
                                                    className="rounded-full border border-stone-300 px-4 py-2 text-xs font-bold text-stone-600 disabled:opacity-40"
                                                >
                                                    ← Предыдущий
                                                </button>
                                                <div className="text-sm font-semibold text-stone-600">{items.length ? activeIndex + 1 : 0} / {items.length}</div>
                                                <button
                                                    onClick={() => setActiveIndex(prev => Math.min(items.length - 1, prev + 1))}
                                                    disabled={activeIndex >= items.length - 1}
                                                    className="rounded-full border border-stone-300 px-4 py-2 text-xs font-bold text-stone-600 disabled:opacity-40"
                                                >
                                                    Следующий →
                                                </button>
                                            </div>
                                        </div>

                                        <div className="rounded-[28px] border border-stone-300 bg-white p-5 shadow-sm">
                                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">Связанные действия</div>
                                            <div className="mt-4 space-y-2">
                                                <button
                                                    onClick={() => onOpenRow?.(buildReviewRow(currentCase))}
                                                    className="w-full rounded-2xl border border-stone-300 bg-[#fbf7ef] px-4 py-3 text-left text-sm font-semibold text-stone-700 hover:border-[#8b0000] hover:text-[#8b0000]"
                                                >
                                                    Открыть лист и OCR
                                                </button>
                                                <button
                                                    onClick={() => onEditRow?.(buildReviewRow(currentCase), buildStructuredEditOptions(currentCase))}
                                                    disabled={!canEdit}
                                                    className="w-full rounded-2xl border border-stone-300 bg-[#fbf7ef] px-4 py-3 text-left text-sm font-semibold text-stone-700 hover:border-[#8b0000] hover:text-[#8b0000] disabled:opacity-50"
                                                >
                                                    Открыть структурированный редактор
                                                </button>
                                            </div>
                                        </div>

                                        <div className="rounded-[28px] border border-stone-300 bg-white p-5 text-sm text-stone-600 shadow-sm">
                                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">Что сохраняется</div>
                                            <ul className="mt-3 space-y-2">
                                                <li>• новое structured-значение поля, если вы его исправили;</li>
                                                <li>• пересобранные summary и search text;</li>
                                                <li>• признак ручной правки;</li>
                                                <li>• журнал решения с текстом строки и старым значением.</li>
                                            </ul>
                                            <div className="mt-3 rounded-2xl bg-stone-50 p-3 text-xs text-stone-500">
                                                Исходный OCR не перезаписывается.
                                            </div>
                                        </div>
                                    </aside>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        };

        const ParentsStatsRecordPreview = ({ row, label = '', onOpen = null }) => {
            const containerRef = useRef(null);
            const dragStateRef = useRef(null);
            const [shouldLoad, setShouldLoad] = useState(false);
            const [zoom, setZoom] = useState(1);
            const [pan, setPan] = useState({ x: 0, y: 0 });
            const [isDragging, setIsDragging] = useState(false);
            const imageUrl = toAbsoluteViewerImageUrl(row?.previewImageUrl || row?.imageUrl || '');
            const imageWidth = Number(row?.previewImageWidth || row?.imageWidth || 0);
            const imageHeight = Number(row?.previewImageHeight || row?.imageHeight || 0);
            const bbox = row?.previewBbox || row?.bbox || {};
            const bboxX = Number(bbox?.x || 0);
            const bboxY = Number(bbox?.y || 0);
            const bboxWidth = Number(bbox?.width || 0);
            const bboxHeight = Number(bbox?.height || 0);
            const hasCrop = Boolean(imageUrl && imageWidth > 0 && imageHeight > 0 && bboxWidth > 0 && bboxHeight > 0);

            useEffect(() => {
                if (!imageUrl || shouldLoad) return;
                const node = containerRef.current;
                if (!node || typeof IntersectionObserver === 'undefined') {
                    setShouldLoad(true);
                    return;
                }
                const observer = new IntersectionObserver((entries) => {
                    if (entries.some(entry => entry.isIntersecting)) {
                        setShouldLoad(true);
                        observer.disconnect();
                    }
                }, { rootMargin: '320px 0px' });
                observer.observe(node);
                return () => observer.disconnect();
            }, [imageUrl, shouldLoad]);

            const crop = useMemo(() => {
                if (!hasCrop) return null;
                const padX = Math.max(90, bboxWidth * 0.2);
                const padY = Math.max(55, bboxHeight * 0.65);
                const x = Math.max(0, bboxX - padX);
                const y = Math.max(0, bboxY - padY);
                const right = Math.min(imageWidth, bboxX + bboxWidth + padX);
                const bottom = Math.min(imageHeight, bboxY + bboxHeight + padY);
                return {
                    x,
                    y,
                    width: Math.max(1, right - x),
                    height: Math.max(1, bottom - y),
                };
            }, [bboxHeight, bboxWidth, bboxX, bboxY, hasCrop, imageHeight, imageWidth]);

            const movementBounds = useMemo(() => {
                if (!crop) return null;
                const extraX = Math.max(220, crop.width * 0.45);
                const extraY = Math.max(100, crop.height * 0.25);
                const x = Math.max(0, crop.x - extraX);
                const y = Math.max(0, crop.y - extraY);
                const right = Math.min(imageWidth, crop.x + crop.width + extraX);
                const bottom = Math.min(imageHeight, crop.y + crop.height + extraY);
                return {
                    x,
                    y,
                    width: Math.max(crop.width, right - x),
                    height: Math.max(crop.height, bottom - y),
                };
            }, [crop, imageHeight, imageWidth]);

            useEffect(() => {
                setZoom(1);
                setPan({ x: 0, y: 0 });
                dragStateRef.current = null;
                setIsDragging(false);
            }, [row?.id, imageUrl]);

            const viewport = useMemo(() => {
                if (!crop || !movementBounds) return null;
                const safeZoom = Math.max(1, Math.min(4, Number(zoom || 1)));
                const width = crop.width / safeZoom;
                const height = crop.height / safeZoom;
                const minCenterX = movementBounds.x + width / 2;
                const maxCenterX = movementBounds.x + movementBounds.width - width / 2;
                const minCenterY = movementBounds.y + height / 2;
                const maxCenterY = movementBounds.y + movementBounds.height - height / 2;
                const requestedCenterX = crop.x + crop.width / 2 + Number(pan.x || 0);
                const requestedCenterY = crop.y + crop.height / 2 + Number(pan.y || 0);
                const centerX = Math.max(minCenterX, Math.min(maxCenterX, requestedCenterX));
                const centerY = Math.max(minCenterY, Math.min(maxCenterY, requestedCenterY));
                return {
                    x: centerX - width / 2,
                    y: centerY - height / 2,
                    width,
                    height,
                };
            }, [crop, movementBounds, pan.x, pan.y, zoom]);

            const resetViewport = () => {
                setZoom(1);
                setPan({ x: 0, y: 0 });
            };

            const changeZoom = (nextZoom) => {
                const value = Math.max(1, Math.min(4, Number(nextZoom || 1)));
                setZoom(value);
            };

            const handlePreviewWheel = (event) => {
                if (!crop) return;
                event.preventDefault();
                changeZoom(zoom + (event.deltaY < 0 ? 0.3 : -0.3));
            };

            const handlePreviewPointerDown = (event) => {
                if (!crop || !viewport) return;
                event.preventDefault();
                event.currentTarget.setPointerCapture?.(event.pointerId);
                dragStateRef.current = {
                    pointerId: event.pointerId,
                    clientX: event.clientX,
                    clientY: event.clientY,
                    panX: Number(pan.x || 0),
                    panY: Number(pan.y || 0),
                    width: Math.max(1, event.currentTarget.clientWidth),
                    height: Math.max(1, event.currentTarget.clientHeight),
                };
                setIsDragging(true);
            };

            const handlePreviewPointerMove = (event) => {
                const drag = dragStateRef.current;
                if (!drag || drag.pointerId !== event.pointerId || !crop) return;
                const scaleX = crop.width / (drag.width * Math.max(1, zoom));
                const scaleY = crop.height / (drag.height * Math.max(1, zoom));
                setPan({
                    x: drag.panX - (event.clientX - drag.clientX) * scaleX,
                    y: drag.panY - (event.clientY - drag.clientY) * scaleY,
                });
            };

            const stopPreviewDrag = (event) => {
                if (dragStateRef.current?.pointerId === event.pointerId) {
                    event.currentTarget.releasePointerCapture?.(event.pointerId);
                    dragStateRef.current = null;
                    setIsDragging(false);
                }
            };

            const content = shouldLoad && imageUrl ? (
                viewport ? (
                    <svg
                        viewBox={`${viewport.x} ${viewport.y} ${viewport.width} ${viewport.height}`}
                        preserveAspectRatio="xMidYMid meet"
                        className="block h-[104px] w-full bg-[#eee5d7]"
                        aria-label={label ? `Фрагмент: ${label}` : 'Фрагмент архивной записи'}
                    >
                        <image href={imageUrl} x="0" y="0" width={imageWidth} height={imageHeight} preserveAspectRatio="none" />
                        <rect
                            x={bboxX}
                            y={bboxY}
                            width={bboxWidth}
                            height={bboxHeight}
                            fill="rgba(255, 238, 151, 0.10)"
                            stroke="rgba(139, 0, 0, 0.72)"
                            strokeWidth="1.4"
                            vectorEffect="non-scaling-stroke"
                        />
                    </svg>
                ) : (
                    <img
                        src={imageUrl}
                        alt={label ? `Страница записи: ${label}` : 'Страница архивной записи'}
                        loading="lazy"
                        className="block h-[104px] w-full object-cover object-center grayscale-[0.12]"
                    />
                )
            ) : (
                <div className="flex h-[104px] items-center justify-center bg-[#eee8de] text-[10px] font-semibold uppercase tracking-[0.12em] text-stone-400">
                    {imageUrl ? 'Загрузка фрагмента' : 'Нет изображения'}
                </div>
            );

            return (
                <div ref={containerRef} className="min-w-0">
                    <div className="mb-1 flex min-h-[20px] items-center justify-between gap-2">
                        <div className="min-w-0 truncate text-[9px] font-bold uppercase tracking-[0.13em] text-stone-400">
                            {label || 'Архивная запись'}
                        </div>
                        {onOpen ? (
                            <button
                                type="button"
                                onClick={onOpen}
                                className="shrink-0 rounded-full border border-stone-300 bg-white px-2 py-0.5 text-[9px] font-bold text-stone-500 hover:border-[#8b0000] hover:text-[#8b0000]"
                                title="Открыть запись и полный лист"
                            >
                                Лист ↗
                            </button>
                        ) : null}
                    </div>
                    <div
                        className={`relative overflow-hidden rounded-xl border border-stone-300 bg-[#f4eee4] shadow-sm select-none touch-none ${crop ? (isDragging ? 'cursor-grabbing' : 'cursor-grab') : ''}`}
                        onWheel={handlePreviewWheel}
                        onPointerDown={handlePreviewPointerDown}
                        onPointerMove={handlePreviewPointerMove}
                        onPointerUp={stopPreviewDrag}
                        onPointerCancel={stopPreviewDrag}
                        onDoubleClick={resetViewport}
                        title={crop ? 'Колесо — масштаб, перетаскивание — движение, двойной щелчок — сброс' : ''}
                    >
                        {content}
                        {crop && shouldLoad ? (
                            <div className="absolute right-1.5 top-1.5 flex items-center gap-1 rounded-full border border-white/70 bg-stone-900/72 p-1 text-white shadow-md backdrop-blur-sm">
                                <button
                                    type="button"
                                    onPointerDown={event => event.stopPropagation()}
                                    onClick={event => { event.stopPropagation(); changeZoom(zoom - 0.4); }}
                                    disabled={zoom <= 1}
                                    className="flex h-5 w-5 items-center justify-center rounded-full text-[13px] font-bold hover:bg-white/20 disabled:opacity-35"
                                    aria-label="Уменьшить фрагмент"
                                >−</button>
                                <span className="min-w-[30px] text-center text-[9px] font-bold tabular-nums">{Math.round(zoom * 100)}%</span>
                                <button
                                    type="button"
                                    onPointerDown={event => event.stopPropagation()}
                                    onClick={event => { event.stopPropagation(); changeZoom(zoom + 0.4); }}
                                    disabled={zoom >= 4}
                                    className="flex h-5 w-5 items-center justify-center rounded-full text-[13px] font-bold hover:bg-white/20 disabled:opacity-35"
                                    aria-label="Увеличить фрагмент"
                                >+</button>
                                <button
                                    type="button"
                                    onPointerDown={event => event.stopPropagation()}
                                    onClick={event => { event.stopPropagation(); resetViewport(); }}
                                    disabled={zoom === 1 && !pan.x && !pan.y}
                                    className="flex h-5 items-center justify-center rounded-full px-1.5 text-[8px] font-bold uppercase tracking-wide hover:bg-white/20 disabled:opacity-35"
                                    aria-label="Вернуть фрагмент в центр"
                                >Центр</button>
                            </div>
                        ) : null}
                    </div>
                </div>
            );
        };

        const ParentsStatsView = ({ project, projectId, parish = null, parishId = '', onOpenRow, onEditRow = null, canEdit = false, dataVersion = 0, refreshState = null }) => {
            const drilldownRef = useRef(null);
            const [deathCauseAdminOpen, setDeathCauseAdminOpen] = useState(false);
            const [statsData, setStatsData] = useState(null);
            const [statsLoading, setStatsLoading] = useState(true);
            const [statsLoaded, setStatsLoaded] = useState(false);
            const [activeDrilldown, setActiveDrilldown] = useState(null);
            const [drilldownData, setDrilldownData] = useState(null);
            const [drilldownLoading, setDrilldownLoading] = useState(false);
            const [drilldownPage, setDrilldownPage] = useState(1);
            const [activeStatsTab, setActiveStatsTab] = useState('timeline');
            const [activeDeathAgeRange, setActiveDeathAgeRange] = useState('all');
            const [statsYearFilter, setStatsYearFilter] = useState(null);
            const [fullEventTimeline, setFullEventTimeline] = useState([]);
            const [eventTimelineLegendSelected, setEventTimelineLegendSelected] = useState({
                'Рождения': true,
                'Смерти': true,
                'Браки': true,
            });
            const requestSeqRef = useRef(0);
            const cacheRef = useRef(parentsStatsStateCache);
            const drilldownRequestSeqRef = useRef(0);
            const drilldownCacheRef = useRef(parentsStatsDrilldownStateCache);
            const lookupCacheRef = useRef(parentsStatsLookupStateCache);
            const lookupRequestSeqRef = useRef({ name: 0, surname: 0, occupation: 0 });
            const statsRefreshRevision = Number(refreshState?.token || 0);
            const statsRefreshItemId = String(refreshState?.itemId || '').trim();
            const [liveRefreshNonce, setLiveRefreshNonce] = useState(0);
            const [nameLookupQuery, setNameLookupQuery] = useState('');
            const [surnameLookupQuery, setSurnameLookupQuery] = useState('');
            const [nameLookupResults, setNameLookupResults] = useState([]);
            const [surnameLookupResults, setSurnameLookupResults] = useState([]);
            const [occupationLookupQuery, setOccupationLookupQuery] = useState('');
            const [occupationLookupResults, setOccupationLookupResults] = useState([]);
            const [nameLookupLoading, setNameLookupLoading] = useState(false);
            const [surnameLookupLoading, setSurnameLookupLoading] = useState(false);
            const [occupationLookupLoading, setOccupationLookupLoading] = useState(false);
            const [selectedNameLookup, setSelectedNameLookup] = useState(null);
            const [selectedSurnameLookup, setSelectedSurnameLookup] = useState(null);
            const [selectedOccupationLookup, setSelectedOccupationLookup] = useState(null);
            const debouncedNameLookupQuery = useDebouncedValue(nameLookupQuery, 320);
            const debouncedSurnameLookupQuery = useDebouncedValue(surnameLookupQuery, 320);
            const debouncedOccupationLookupQuery = useDebouncedValue(occupationLookupQuery, 320);

            useEffect(() => {
                setNameLookupQuery('');
                setSurnameLookupQuery('');
                setOccupationLookupQuery('');
                setNameLookupResults([]);
                setSurnameLookupResults([]);
                setOccupationLookupResults([]);
                setNameLookupLoading(false);
                setSurnameLookupLoading(false);
                setOccupationLookupLoading(false);
                setSelectedNameLookup(null);
                setSelectedSurnameLookup(null);
                setSelectedOccupationLookup(null);
            }, [projectId, parishId]);

            useEffect(() => {
                if (!projectId || !statsRefreshRevision) return;
                invalidateParentsScopedCache(cacheRef.current, projectId, parishId);
                invalidateParentsScopedCache(drilldownCacheRef.current, projectId, parishId);
                invalidateParentsScopedCache(lookupCacheRef.current, projectId, parishId);
                if (statsRefreshItemId) {
                    setDrilldownData(prev => {
                        if (!prev || !Array.isArray(prev.rows)) return prev;
                        const nextRows = prev.rows.filter(row => row?.itemId !== statsRefreshItemId);
                        const removedCount = prev.rows.length - nextRows.length;
                        if (!removedCount) return prev;
                        return {
                            ...prev,
                            rows: nextRows,
                            total: Math.max(0, Number(prev.total || 0) - removedCount),
                        };
                    });
                }
            }, [projectId, parishId, statsRefreshRevision, statsRefreshItemId]);

            useEffect(() => {
                const handleParentsDataUpdated = (event) => {
                    const detail = event?.detail || {};
                    if (String(detail.projectId || '').trim() !== String(projectId || '').trim()) return;
                    invalidateParentsScopedCache(cacheRef.current, projectId, parishId);
                    invalidateParentsScopedCache(drilldownCacheRef.current, projectId, parishId);
                    invalidateParentsScopedCache(lookupCacheRef.current, projectId, parishId);
                    const detailItemId = String(detail.itemId || '').trim();
                    const detailEntryId = String(detail.entryId || '').trim();
                    const detailEntryIndex = Number(detail.entryIndex);
                    const hasDetailEntryIndex = Number.isInteger(detailEntryIndex) && detailEntryIndex >= 0;
                    if (detailItemId) {
                        setDrilldownData(prev => {
                            if (!prev || !Array.isArray(prev.rows)) return prev;
                            const nextRows = prev.rows.filter(row => {
                                if (String(row?.itemId || '').trim() !== detailItemId) return true;
                                if (detailEntryId) {
                                    return String(row?.entryId || '').trim() !== detailEntryId;
                                }
                                if (hasDetailEntryIndex) {
                                    return Number(row?.entryIndex) !== detailEntryIndex;
                                }
                                return false;
                            });
                            if (nextRows.length === prev.rows.length) return prev;
                            return {
                                ...prev,
                                rows: nextRows,
                                total: Math.max(0, Number(prev.total || 0) - (prev.rows.length - nextRows.length)),
                            };
                        });
                    }
                    setLiveRefreshNonce(prev => prev + 1);
                };
                window.addEventListener(PARENTS_DATA_UPDATED_EVENT, handleParentsDataUpdated);
                return () => window.removeEventListener(PARENTS_DATA_UPDATED_EVENT, handleParentsDataUpdated);
            }, [projectId, parishId]);

            useEffect(() => {
                if (!projectId) return;
                const requestSeq = ++requestSeqRef.current;
                const controller = new AbortController();
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    v: `${PARENTS_STATS_RESPONSE_VERSION}:${dataVersion || 0}:${statsRefreshRevision}:${liveRefreshNonce}`
                });
                const hasYearFilter = Number.isFinite(Number(statsYearFilter?.from)) && Number.isFinite(Number(statsYearFilter?.to));
                if (hasYearFilter) {
                    params.set('year_from', String(statsYearFilter.from));
                    params.set('year_to', String(statsYearFilter.to));
                }
                const requestKey = params.toString();
                const rememberFullTimeline = (data) => {
                    if (hasYearFilter || data?.yearFilter) return;
                    const timeline = Array.isArray(data?.eventTimelineByYear) ? data.eventTimelineByYear : [];
                    setFullEventTimeline(timeline);
                };

                if (cacheRef.current.has(requestKey)) {
                    const cachedData = cacheRef.current.get(requestKey);
                    setStatsData(cachedData);
                    rememberFullTimeline(cachedData);
                    setStatsLoaded(true);
                    setStatsLoading(false);
                    return () => controller.abort();
                }

                setStatsLoading(true);
                fetch(`${API_BASE}/parents_stats_state?${requestKey}`, {
                    signal: controller.signal,
                    cache: 'no-store'
                })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (requestSeqRef.current !== requestSeq) return;
                        const normalizedData = data && typeof data === 'object' ? data : {};
                        rememberBoundedCacheValue(cacheRef.current, requestKey, normalizedData, 48);
                        setStatsData(normalizedData);
                        rememberFullTimeline(normalizedData);
                        setStatsLoaded(true);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (requestSeqRef.current !== requestSeq) return;
                        showToast('Не удалось загрузить статистику проекта', 'error');
                        setStatsData({
                            totals: {
                                people: 0,
                                entries: 0,
                                names: 0,
                                surnames: 0,
                                birthFamilies: 0,
                                twinBirthCases: 0,
                                siblingBirthIntervals: 0,
                                firstBirthAfterMarriageIntervals: 0,
                                occupations: 0,
                                localities: 0,
                                uyezds: 0,
                                governorates: 0,
                                groomAges: 0,
                                brideAges: 0,
                                spouseAgeGaps: 0,
                                deathAges: 0,
                                deathCauses: 0,
                            },
                            averages: {
                                groomAgeAtMarriage: null,
                                brideAgeAtMarriage: null,
                                firstBirthAfterMarriageMonths: null,
                                siblingBirthGapYears: null,
                            },
                            factTotals: {
                                names: 0,
                                surnames: 0,
                                birthFamilies: 0,
                                siblingBirthIntervals: 0,
                                firstBirthAfterMarriageIntervals: 0,
                                occupations: 0,
                                deathAges: 0,
                                deathCauses: 0,
                            },
                            eventTimelineByYear: [],
                            childrenPerFamilyDistribution: [],
                            siblingBirthGapDistribution: [],
                            firstBirthAfterMarriageDistribution: [],
                            topNames: [],
                            topSurnames: [],
                            topTwinBirthYears: [],
                            topOccupations: [],
                            topLocalities: [],
                            topUyezds: [],
                            topGovernorates: [],
                            topGroomGovernorates: [],
                            topBrideGovernorates: [],
                            topGroomAges: [],
                            topBrideAges: [],
                            topSpouseAgeGaps: [],
                            topDeathAges: [],
                            topDeathCauses: [],
                            deathCauseAgeMatrix: {
                                causes: [],
                                ageBands: [],
                                cells: [],
                                recognizedCauseCount: 0,
                                knownAgeCauseCount: 0,
                                missingAgeCount: 0,
                                maxValue: 0,
                            },
                        });
                        setStatsLoaded(true);
                    })
                    .finally(() => {
                        if (requestSeqRef.current === requestSeq) {
                            setStatsLoading(false);
                        }
                    });

                return () => controller.abort();
            }, [projectId, parishId, dataVersion, statsRefreshRevision, liveRefreshNonce, statsYearFilter]);

            useEffect(() => {
                if (!projectId) {
                    setNameLookupResults([]);
                    setNameLookupLoading(false);
                    return;
                }
                const query = String(debouncedNameLookupQuery || '').trim();
                if (!query) {
                    setNameLookupResults([]);
                    setNameLookupLoading(false);
                    return;
                }
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    field: 'name',
                    query,
                    limit: '12',
                });
                const requestKey = params.toString();
                if (lookupCacheRef.current.has(requestKey)) {
                    setNameLookupResults(lookupCacheRef.current.get(requestKey));
                    setNameLookupLoading(false);
                    return;
                }
                const requestSeq = (lookupRequestSeqRef.current.name || 0) + 1;
                lookupRequestSeqRef.current.name = requestSeq;
                const controller = new AbortController();
                setNameLookupLoading(true);
                fetch(`${API_BASE}/parents_stats_lookup_state?${requestKey}`, {
                    signal: controller.signal,
                    cache: 'no-store'
                })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (lookupRequestSeqRef.current.name !== requestSeq) return;
                        const results = Array.isArray(data?.results) ? data.results : [];
                        rememberBoundedCacheValue(lookupCacheRef.current, requestKey, results, 120);
                        setNameLookupResults(results);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (lookupRequestSeqRef.current.name !== requestSeq) return;
                        setNameLookupResults([]);
                    })
                    .finally(() => {
                        if (lookupRequestSeqRef.current.name === requestSeq) {
                            setNameLookupLoading(false);
                        }
                    });
                return () => controller.abort();
            }, [projectId, parishId, debouncedNameLookupQuery]);

            useEffect(() => {
                if (!projectId) {
                    setSurnameLookupResults([]);
                    setSurnameLookupLoading(false);
                    return;
                }
                const query = String(debouncedSurnameLookupQuery || '').trim();
                if (!query) {
                    setSurnameLookupResults([]);
                    setSurnameLookupLoading(false);
                    return;
                }
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    field: 'surname',
                    query,
                    limit: '12',
                });
                const requestKey = params.toString();
                if (lookupCacheRef.current.has(requestKey)) {
                    setSurnameLookupResults(lookupCacheRef.current.get(requestKey));
                    setSurnameLookupLoading(false);
                    return;
                }
                const requestSeq = (lookupRequestSeqRef.current.surname || 0) + 1;
                lookupRequestSeqRef.current.surname = requestSeq;
                const controller = new AbortController();
                setSurnameLookupLoading(true);
                fetch(`${API_BASE}/parents_stats_lookup_state?${requestKey}`, {
                    signal: controller.signal,
                    cache: 'no-store'
                })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (lookupRequestSeqRef.current.surname !== requestSeq) return;
                        const results = Array.isArray(data?.results) ? data.results : [];
                        rememberBoundedCacheValue(lookupCacheRef.current, requestKey, results, 120);
                        setSurnameLookupResults(results);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (lookupRequestSeqRef.current.surname !== requestSeq) return;
                        setSurnameLookupResults([]);
                    })
                    .finally(() => {
                        if (lookupRequestSeqRef.current.surname === requestSeq) {
                            setSurnameLookupLoading(false);
                        }
                    });
                return () => controller.abort();
            }, [projectId, parishId, debouncedSurnameLookupQuery]);

            useEffect(() => {
                if (!projectId) {
                    setOccupationLookupResults([]);
                    setOccupationLookupLoading(false);
                    return;
                }
                const query = String(debouncedOccupationLookupQuery || '').trim();
                if (!query) {
                    setOccupationLookupResults([]);
                    setOccupationLookupLoading(false);
                    return;
                }
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    field: 'occupation',
                    query,
                    limit: '12',
                });
                const requestKey = params.toString();
                if (lookupCacheRef.current.has(requestKey)) {
                    setOccupationLookupResults(lookupCacheRef.current.get(requestKey));
                    setOccupationLookupLoading(false);
                    return;
                }
                const requestSeq = (lookupRequestSeqRef.current.occupation || 0) + 1;
                lookupRequestSeqRef.current.occupation = requestSeq;
                const controller = new AbortController();
                setOccupationLookupLoading(true);
                fetch(`${API_BASE}/parents_stats_lookup_state?${requestKey}`, {
                    signal: controller.signal,
                    cache: 'no-store'
                })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (lookupRequestSeqRef.current.occupation !== requestSeq) return;
                        const results = Array.isArray(data?.results) ? data.results : [];
                        rememberBoundedCacheValue(lookupCacheRef.current, requestKey, results, 120);
                        setOccupationLookupResults(results);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (lookupRequestSeqRef.current.occupation !== requestSeq) return;
                        setOccupationLookupResults([]);
                    })
                    .finally(() => {
                        if (lookupRequestSeqRef.current.occupation === requestSeq) {
                            setOccupationLookupLoading(false);
                        }
                    });
                return () => controller.abort();
            }, [projectId, parishId, debouncedOccupationLookupQuery]);

            const totals = statsData?.totals || {
                people: 0,
                entries: 0,
                names: 0,
                surnames: 0,
                birthFamilies: 0,
                twinBirthCases: 0,
                siblingBirthIntervals: 0,
                firstBirthAfterMarriageIntervals: 0,
                occupations: 0,
                localities: 0,
                uyezds: 0,
                governorates: 0,
                groomAges: 0,
                brideAges: 0,
                spouseAgeGaps: 0,
                deathAges: 0,
                deathCauses: 0,
            };
            const averages = statsData?.averages && typeof statsData.averages === 'object' ? statsData.averages : {
                groomAgeAtMarriage: null,
                brideAgeAtMarriage: null,
                firstBirthAfterMarriageMonths: null,
                siblingBirthGapMonths: null,
                siblingBirthGapYears: null,
            };
            const factTotals = statsData?.factTotals && typeof statsData.factTotals === 'object' ? statsData.factTotals : {
                names: 0,
                surnames: 0,
                birthFamilies: 0,
                siblingBirthIntervals: 0,
                firstBirthAfterMarriageIntervals: 0,
                occupations: 0,
                deathAges: 0,
                deathCauses: 0,
            };
            const childrenPerFamilyDistribution = Array.isArray(statsData?.childrenPerFamilyDistribution) ? statsData.childrenPerFamilyDistribution : [];
            const siblingBirthGapDistribution = Array.isArray(statsData?.siblingBirthGapDistribution) ? statsData.siblingBirthGapDistribution : [];
            const firstBirthAfterMarriageDistribution = Array.isArray(statsData?.firstBirthAfterMarriageDistribution) ? statsData.firstBirthAfterMarriageDistribution : [];
            const topNames = Array.isArray(statsData?.topNames) ? statsData.topNames : [];
            const topSurnames = Array.isArray(statsData?.topSurnames) ? statsData.topSurnames : [];
            const topTwinBirthYears = Array.isArray(statsData?.topTwinBirthYears) ? statsData.topTwinBirthYears : [];
            const topOccupations = Array.isArray(statsData?.topOccupations) ? statsData.topOccupations : [];
            const topLocalities = Array.isArray(statsData?.topLocalities) ? statsData.topLocalities : [];
            const topUyezds = Array.isArray(statsData?.topUyezds) ? statsData.topUyezds : [];
            const topGovernorates = Array.isArray(statsData?.topGovernorates) ? statsData.topGovernorates : [];
            const topGroomGovernorates = Array.isArray(statsData?.topGroomGovernorates) ? statsData.topGroomGovernorates : [];
            const topBrideGovernorates = Array.isArray(statsData?.topBrideGovernorates) ? statsData.topBrideGovernorates : [];
            const topGroomAges = Array.isArray(statsData?.topGroomAges) ? statsData.topGroomAges : [];
            const topBrideAges = Array.isArray(statsData?.topBrideAges) ? statsData.topBrideAges : [];
            const topSpouseAgeGaps = Array.isArray(statsData?.topSpouseAgeGaps) ? statsData.topSpouseAgeGaps : [];
            const topDeathAges = Array.isArray(statsData?.topDeathAges) ? statsData.topDeathAges : [];
            const topDeathCauses = Array.isArray(statsData?.topDeathCauses) ? statsData.topDeathCauses : [];
            const deathCauseAgeMatrix = statsData?.deathCauseAgeMatrix && typeof statsData.deathCauseAgeMatrix === 'object'
                ? statsData.deathCauseAgeMatrix
                : {
                    causes: [],
                    ageBands: [],
                    cells: [],
                    recognizedCauseCount: 0,
                    knownAgeCauseCount: 0,
                    missingAgeCount: 0,
                    maxValue: 0,
                };
            const statisticsQualitySummary = statsData?.statisticsQualitySummary && typeof statsData.statisticsQualitySummary === 'object'
                ? statsData.statisticsQualitySummary
                : {};
            const excludedDeathCauseCount = Number(statisticsQualitySummary?.excludedDeathCauses || 0);
            const excludedDeathAgeCount = Number(statisticsQualitySummary?.excludedDeathAges || 0);
            const excludedMarriageAgeCount = Number(statisticsQualitySummary?.excludedMarriageAges || 0);
            const deathCauseAgeMatrixHasData = Array.isArray(deathCauseAgeMatrix?.cells)
                && deathCauseAgeMatrix.cells.some(cell => Number(cell?.value || 0) > 0);
            const eventTimelineByYear = Array.isArray(statsData?.eventTimelineByYear) ? statsData.eventTimelineByYear : [];
            const deathAgeRangeTabs = useMemo(() => ([
                { key: 'all', label: 'Все возраста', min: null, max: null },
                { key: '0_3', label: '0–3 года', min: 0, max: 3 },
                { key: '4_10', label: '4–10 лет', min: 4, max: 10 },
                { key: '11_20', label: '11–20 лет', min: 11, max: 20 },
                { key: '21_50', label: '21–50 лет', min: 21, max: 50 },
                { key: '50_plus', label: 'Старше 50', min: 51, max: null },
            ]), []);
            const formatMarriageAverageBadge = useCallback((value) => {
                const numeric = Number(value);
                if (!Number.isFinite(numeric)) return '';
                return `${numeric.toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} года`;
            }, []);
            const parseDeathAgeBucketNumber = useCallback((entry) => {
                const rawKey = String(entry?.groupKey ?? entry?.name ?? '').trim().toLowerCase();
                if (!rawKey) return null;
                if (rawKey === '0_under_1' || rawKey.includes('under_1') || rawKey.includes('<1')) return 0;
                const match = rawKey.match(/\d+/);
                if (!match) return null;
                const value = Number.parseInt(match[0], 10);
                return Number.isFinite(value) ? value : null;
            }, []);
            const matchesDeathAgeRange = useCallback((entry, rangeKey) => {
                const range = deathAgeRangeTabs.find(item => item.key === rangeKey) || deathAgeRangeTabs[0];
                if (!range || range.key === 'all') return true;
                const numericAge = parseDeathAgeBucketNumber(entry);
                if (!Number.isFinite(numericAge)) return false;
                if (Number.isFinite(range.min) && numericAge < range.min) return false;
                if (Number.isFinite(range.max) && numericAge > range.max) return false;
                return true;
            }, [deathAgeRangeTabs, parseDeathAgeBucketNumber]);
            useEffect(() => {
                setActiveDrilldown(null);
                setDrilldownData(null);
                setDrilldownLoading(false);
                setDrilldownPage(1);
                setActiveDeathAgeRange('all');
                setStatsYearFilter(null);
                setFullEventTimeline([]);
            }, [projectId, parishId]);

            const mergeStatsSeriesWithLookup = useCallback((baseData, selectedLookup) => {
                const normalizedBase = Array.isArray(baseData) ? baseData.map((item) => ({
                    ...item,
                    isLookupHighlighted: false,
                })) : [];
                const selectedGroupKey = String(selectedLookup?.groupKey || '').trim();
                const selectedName = String(selectedLookup?.name || '').trim();
                if (!selectedGroupKey || !selectedName) return normalizedBase;
                const existingIndex = normalizedBase.findIndex((item) => String(item?.groupKey || '').trim() === selectedGroupKey);
                if (existingIndex >= 0) {
                    normalizedBase[existingIndex] = {
                        ...normalizedBase[existingIndex],
                        isLookupHighlighted: true,
                    };
                    return normalizedBase;
                }
                return [...normalizedBase, {
                    name: selectedName,
                    groupKey: selectedGroupKey,
                    value: Number(selectedLookup?.value || 0),
                    isLookupHighlighted: true,
                }].sort((left, right) => {
                    const valueDiff = Number(right?.value || 0) - Number(left?.value || 0);
                    if (valueDiff !== 0) return valueDiff;
                    return String(left?.name || '').localeCompare(String(right?.name || ''), 'ru');
                });
            }, []);

            const buildBarOption = useCallback((data, color, config = {}) => ({
                animationDuration: 500,
                textStyle: { fontFamily: 'Cormorant Garamond, serif' },
                grid: {
                    left: Number.isFinite(config?.gridLeft) ? config.gridLeft : 16,
                    right: Number.isFinite(config?.gridRight) ? config.gridRight : 22,
                    top: Number.isFinite(config?.gridTop) ? config.gridTop : 18,
                    bottom: Number.isFinite(config?.gridBottom) ? config.gridBottom : 12,
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    backgroundColor: 'rgba(41, 33, 24, 0.92)',
                    borderWidth: 0,
                    textStyle: { color: '#fdfbf7', fontFamily: 'Cormorant Garamond, serif', fontSize: 14 }
                },
                xAxis: {
                    type: 'value',
                    axisLabel: { color: '#7c6f64', fontSize: 12, fontFamily: 'Cormorant Garamond, serif' },
                    splitLine: { lineStyle: { color: 'rgba(124,111,100,0.16)' } }
                },
                yAxis: {
                    type: 'category',
                    inverse: true,
                    data: data.map(item => item.name),
                    axisLabel: {
                        color: '#4d4036',
                        fontSize: 13,
                        fontFamily: 'Cormorant Garamond, serif',
                        width: Number.isFinite(config?.axisLabelWidth) ? config.axisLabelWidth : 170,
                        overflow: 'truncate'
                    },
                    axisTick: { show: false },
                    axisLine: { show: false }
                },
                series: [{
                    type: 'bar',
                    data: data.map(item => ({
                        value: item.value,
                        groupKey: item.groupKey,
                        name: item.name,
                        itemStyle: item?.isLookupHighlighted ? {
                            color,
                            borderRadius: [0, 10, 10, 0],
                            borderColor: 'rgba(53,39,30,0.72)',
                            borderWidth: 1.5,
                            shadowBlur: 16,
                            shadowColor: `${color}55`,
                        } : undefined,
                    })),
                    barMaxWidth: 22,
                    itemStyle: {
                        color,
                        borderRadius: [0, 8, 8, 0]
                    },
                    label: {
                        show: true,
                        position: 'right',
                        color: '#4d4036',
                        fontWeight: 'bold',
                        fontSize: 13,
                        fontFamily: 'Cormorant Garamond, serif'
                    }
                }]
            }), []);

            const buildAgeBarOption = useCallback((data, color, valueLabel = 'Возраст') => {
                const sortedData = [...data].sort((a, b) => {
                    const aNum = Number.parseInt(String(a?.groupKey ?? a?.name ?? ''), 10);
                    const bNum = Number.parseInt(String(b?.groupKey ?? b?.name ?? ''), 10);
                    if (Number.isFinite(aNum) && Number.isFinite(bNum) && aNum !== bNum) return aNum - bNum;
                    return String(a?.name || '').localeCompare(String(b?.name || ''), 'ru');
                });
                return {
                    animationDuration: 500,
                    textStyle: { fontFamily: 'Cormorant Garamond, serif' },
                    grid: { left: 28, right: 18, top: 24, bottom: 42, containLabel: true },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'shadow' },
                        backgroundColor: 'rgba(41, 33, 24, 0.92)',
                        borderWidth: 0,
                        textStyle: { color: '#fdfbf7', fontFamily: 'Cormorant Garamond, serif', fontSize: 14 },
                        formatter: (params) => {
                            const point = Array.isArray(params) ? params[0] : params;
                            const age = point?.name || '';
                            const value = point?.value ?? 0;
                            return `${valueLabel}: ${age}<br/>Записей: ${value}`;
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: sortedData.map(item => item.name),
                        axisLabel: {
                            color: '#6e6258',
                            fontSize: 12,
                            fontFamily: 'Cormorant Garamond, serif',
                            interval: 0
                        },
                        axisTick: { show: false },
                        axisLine: { lineStyle: { color: 'rgba(124,111,100,0.28)' } }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#7c6f64',
                            fontSize: 12,
                            fontFamily: 'Cormorant Garamond, serif'
                        },
                        splitLine: { lineStyle: { color: 'rgba(124,111,100,0.16)' } }
                    },
                    series: [{
                        type: 'bar',
                        data: sortedData.map(item => ({
                            value: item.value,
                            groupKey: item.groupKey,
                            name: item.name,
                        })),
                        barMaxWidth: 26,
                        itemStyle: {
                            color,
                            borderRadius: [8, 8, 0, 0]
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#4d4036',
                            fontWeight: 'bold',
                            fontSize: 13,
                            fontFamily: 'Cormorant Garamond, serif'
                        }
                    }]
                };
            }, []);

            const buildCountByYearOption = useCallback((data, color, valueLabel = 'Случаев') => {
                const sortedData = [...data].sort((a, b) => {
                    const aNum = Number.parseInt(String(a?.groupKey ?? a?.name ?? ''), 10);
                    const bNum = Number.parseInt(String(b?.groupKey ?? b?.name ?? ''), 10);
                    if (Number.isFinite(aNum) && Number.isFinite(bNum) && aNum !== bNum) return aNum - bNum;
                    return String(a?.name || '').localeCompare(String(b?.name || ''), 'ru');
                });
                return {
                    animationDuration: 520,
                    textStyle: { fontFamily: 'Cormorant Garamond, serif' },
                    grid: { left: 28, right: 18, top: 24, bottom: 46, containLabel: true },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'shadow' },
                        backgroundColor: 'rgba(41, 33, 24, 0.92)',
                        borderWidth: 0,
                        textStyle: { color: '#fdfbf7', fontFamily: 'Cormorant Garamond, serif', fontSize: 14 },
                        formatter: (params) => {
                            const point = Array.isArray(params) ? params[0] : params;
                            const year = point?.name || '';
                            const value = point?.value ?? 0;
                            return `Год: ${year}<br/>${valueLabel}: ${value}`;
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: sortedData.map(item => item.name),
                        axisLabel: {
                            color: '#6e6258',
                            fontSize: 12,
                            fontFamily: 'Cormorant Garamond, serif',
                            interval: 0,
                            rotate: sortedData.length > 16 ? 45 : 0
                        },
                        axisTick: { show: false },
                        axisLine: { lineStyle: { color: 'rgba(124,111,100,0.28)' } }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#7c6f64',
                            fontSize: 12,
                            fontFamily: 'Cormorant Garamond, serif'
                        },
                        splitLine: { lineStyle: { color: 'rgba(124,111,100,0.16)' } }
                    },
                    series: [{
                        type: 'bar',
                        data: sortedData.map(item => ({
                            value: item.value,
                            groupKey: item.groupKey,
                            name: item.name,
                        })),
                        barMaxWidth: 28,
                        itemStyle: {
                            color,
                            borderRadius: [8, 8, 0, 0]
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#4d4036',
                            fontWeight: 'bold',
                            fontSize: 13,
                            fontFamily: 'Cormorant Garamond, serif'
                        }
                    }]
                };
            }, []);

            const buildEventTimelineOption = useCallback((data, legendSelected = {}) => {
                const years = data.map(item => String(item?.year ?? ''));
                return {
                    animationDuration: 650,
                    textStyle: { fontFamily: 'Cormorant Garamond, serif' },
                    color: ['#8b0000', '#4f5d75', '#4a3875'],
                    legend: {
                        top: 0,
                        selected: legendSelected,
                        textStyle: {
                            color: '#5f5247',
                            fontSize: 13,
                            fontFamily: 'Cormorant Garamond, serif'
                        }
                    },
                    grid: { left: 26, right: 20, top: 52, bottom: 42, containLabel: true },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'shadow' },
                        backgroundColor: 'rgba(41, 33, 24, 0.92)',
                        borderWidth: 0,
                        textStyle: { color: '#fdfbf7', fontFamily: 'Cormorant Garamond, serif', fontSize: 14 }
                    },
                    xAxis: {
                        type: 'category',
                        data: years,
                        axisLabel: {
                            color: '#6e6258',
                            fontSize: 11,
                            fontFamily: 'Cormorant Garamond, serif',
                            interval: 0,
                            rotate: years.length > 24 ? 45 : 0
                        },
                        axisTick: { show: false },
                        axisLine: { lineStyle: { color: 'rgba(124,111,100,0.28)' } }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#7c6f64',
                            fontSize: 12,
                            fontFamily: 'Cormorant Garamond, serif'
                        },
                        splitLine: { lineStyle: { color: 'rgba(124,111,100,0.16)' } }
                    },
                    series: [
                        {
                            name: 'Рождения',
                            type: 'line',
                            smooth: true,
                            symbol: 'circle',
                            symbolSize: 7,
                            lineStyle: { width: 3 },
                            itemStyle: { color: '#8b0000' },
                            areaStyle: { color: 'rgba(139,0,0,0.08)' },
                            data: data.map(item => ({
                                value: Number(item?.births || 0),
                                year: item?.year,
                                eventType: 'BIRTH'
                            }))
                        },
                        {
                            name: 'Смерти',
                            type: 'line',
                            smooth: true,
                            symbol: 'circle',
                            symbolSize: 7,
                            lineStyle: { width: 3 },
                            itemStyle: { color: '#4f5d75' },
                            areaStyle: { color: 'rgba(79,93,117,0.08)' },
                            data: data.map(item => ({
                                value: Number(item?.deaths || 0),
                                year: item?.year,
                                eventType: 'DEATH'
                            }))
                        },
                        {
                            name: 'Браки',
                            type: 'line',
                            smooth: true,
                            symbol: 'circle',
                            symbolSize: 7,
                            lineStyle: { width: 3 },
                            itemStyle: { color: '#4a3875' },
                            areaStyle: { color: 'rgba(74,56,117,0.08)' },
                            data: data.map(item => ({
                                value: Number(item?.weddings || 0),
                                year: item?.year,
                                eventType: 'WEDDING'
                            }))
                        }
                    ]
                };
            }, []);

            const getChartHeight = useCallback((count) => Math.max(360, 110 + (Math.max(count, 1) * 28)), []);

            const visibleTopNames = useMemo(
                () => mergeStatsSeriesWithLookup(topNames, selectedNameLookup),
                [mergeStatsSeriesWithLookup, topNames, selectedNameLookup]
            );
            const visibleTopSurnames = useMemo(
                () => mergeStatsSeriesWithLookup(topSurnames, selectedSurnameLookup),
                [mergeStatsSeriesWithLookup, topSurnames, selectedSurnameLookup]
            );
            const normalizedChildrenPerFamilyDistribution = useMemo(() => (
                [...childrenPerFamilyDistribution].sort((left, right) => {
                    const leftValue = Number.parseInt(String(left?.groupKey ?? left?.name ?? '0'), 10);
                    const rightValue = Number.parseInt(String(right?.groupKey ?? right?.name ?? '0'), 10);
                    const safeLeft = Number.isFinite(leftValue) ? leftValue : 0;
                    const safeRight = Number.isFinite(rightValue) ? rightValue : 0;
                    return safeRight - safeLeft;
                })
            ), [childrenPerFamilyDistribution]);
            const namesOption = useMemo(() => buildBarOption(visibleTopNames, '#8b0000'), [buildBarOption, visibleTopNames]);
            const surnamesOption = useMemo(() => buildBarOption(visibleTopSurnames, '#9f2d22'), [buildBarOption, visibleTopSurnames]);
            const childrenPerFamilyOption = useMemo(
                () => buildBarOption(normalizedChildrenPerFamilyDistribution, '#7a4b2f', { axisLabelWidth: 170, gridLeft: 28 }),
                [buildBarOption, normalizedChildrenPerFamilyDistribution]
            );
            const siblingBirthGapOption = useMemo(() => {
                const option = buildAgeBarOption(siblingBirthGapDistribution, '#a85d32', 'Интервал');
                const needsZoom = siblingBirthGapDistribution.length > 30;
                return {
                    ...option,
                    grid: {
                        ...(option.grid || {}),
                        bottom: needsZoom ? 72 : 48,
                    },
                    xAxis: {
                        ...(option.xAxis || {}),
                        name: 'Полных месяцев',
                        nameLocation: 'middle',
                        nameGap: needsZoom ? 54 : 36,
                        axisLabel: {
                            ...(option.xAxis?.axisLabel || {}),
                            formatter: (value) => String(value || '').replace(/\s+месяц(?:а|ев)?$/u, ''),
                        },
                    },
                    dataZoom: needsZoom ? [
                        { type: 'inside', start: 0, end: Math.min(100, 30 / siblingBirthGapDistribution.length * 100) },
                        {
                            type: 'slider',
                            start: 0,
                            end: Math.min(100, 30 / siblingBirthGapDistribution.length * 100),
                            height: 16,
                            bottom: 12,
                            borderColor: 'rgba(168,93,50,0.18)',
                            fillerColor: 'rgba(168,93,50,0.16)',
                            handleStyle: { color: '#a85d32' },
                            textStyle: { color: '#7c6f64', fontSize: 10 },
                        },
                    ] : [],
                };
            }, [buildAgeBarOption, siblingBirthGapDistribution]);
            const firstBirthAfterMarriageOption = useMemo(() => {
                const option = buildAgeBarOption(firstBirthAfterMarriageDistribution, '#8b4f3d', 'Интервал');
                const needsZoom = firstBirthAfterMarriageDistribution.length > 30;
                return {
                    ...option,
                    grid: {
                        ...(option.grid || {}),
                        bottom: needsZoom ? 72 : 48,
                    },
                    xAxis: {
                        ...(option.xAxis || {}),
                        name: 'Полных месяцев',
                        nameLocation: 'middle',
                        nameGap: needsZoom ? 54 : 36,
                        axisLabel: {
                            ...(option.xAxis?.axisLabel || {}),
                            formatter: (value) => String(value || '').replace(/\s+месяц(?:а|ев)?$/u, ''),
                        },
                    },
                    dataZoom: needsZoom ? [
                        { type: 'inside', start: 0, end: Math.min(100, 30 / firstBirthAfterMarriageDistribution.length * 100) },
                        {
                            type: 'slider',
                            start: 0,
                            end: Math.min(100, 30 / firstBirthAfterMarriageDistribution.length * 100),
                            height: 16,
                            bottom: 12,
                            borderColor: 'rgba(139,79,61,0.18)',
                            fillerColor: 'rgba(139,79,61,0.16)',
                            handleStyle: { color: '#8b4f3d' },
                            textStyle: { color: '#7c6f64', fontSize: 10 },
                        },
                    ] : [],
                };
            }, [buildAgeBarOption, firstBirthAfterMarriageDistribution]);
            const twinBirthYearsOption = useMemo(() => buildCountByYearOption(topTwinBirthYears, '#8b0000', 'Случаев'), [buildCountByYearOption, topTwinBirthYears]);
            const visibleOccupationBase = useMemo(() => topOccupations.slice(0, 15), [topOccupations]);
            const visibleOccupations = useMemo(
                () => mergeStatsSeriesWithLookup(visibleOccupationBase, selectedOccupationLookup),
                [mergeStatsSeriesWithLookup, selectedOccupationLookup, visibleOccupationBase]
            );
            const occupationsOption = useMemo(() => buildBarOption(visibleOccupations, '#7a4b2f'), [buildBarOption, visibleOccupations]);
            const localitiesOption = useMemo(() => buildBarOption(topLocalities, '#a86f37'), [buildBarOption, topLocalities]);
            const uyezdsOption = useMemo(() => buildBarOption(topUyezds, '#88633d'), [buildBarOption, topUyezds]);
            const governoratesOption = useMemo(() => buildBarOption(topGovernorates, '#6f2216'), [buildBarOption, topGovernorates]);
            const groomGovernoratesOption = useMemo(() => buildBarOption(topGroomGovernorates, '#5d2b1f'), [buildBarOption, topGroomGovernorates]);
            const brideGovernoratesOption = useMemo(() => buildBarOption(topBrideGovernorates, '#8f3b2e'), [buildBarOption, topBrideGovernorates]);
            const deathCausesOption = useMemo(
                () => buildBarOption(topDeathCauses, '#5a3f2c', { axisLabelWidth: 230, gridLeft: 28 }),
                [buildBarOption, topDeathCauses]
            );
            const deathCauseAgeMatrixOption = useMemo(() => {
                const causes = Array.isArray(deathCauseAgeMatrix?.causes) ? deathCauseAgeMatrix.causes : [];
                const ageBands = Array.isArray(deathCauseAgeMatrix?.ageBands) ? deathCauseAgeMatrix.ageBands : [];
                const cells = Array.isArray(deathCauseAgeMatrix?.cells) ? deathCauseAgeMatrix.cells : [];
                const colorSteps = [
                    { min: 0, max: 0, label: '0', color: '#f3ecdf' },
                    { min: 1, max: 1, label: '1', color: '#d8e8d2' },
                    { min: 2, max: 3, label: '2–3', color: '#79bca6' },
                    { min: 4, max: 7, label: '4–7', color: '#efca62' },
                    { min: 8, max: 14, label: '8–14', color: '#e98d52' },
                    { min: 15, max: 29, label: '15–29', color: '#bd4652' },
                    { min: 30, max: Number.POSITIVE_INFINITY, label: '30+', color: '#5b193e' },
                ];
                const colorForValue = (rawValue) => {
                    const value = Number(rawValue || 0);
                    return colorSteps.find(step => value >= step.min && value <= step.max)?.color || colorSteps[0].color;
                };
                return {
                    animationDuration: 620,
                    textStyle: { fontFamily: 'Cormorant Garamond, serif' },
                    grid: {
                        left: 228,
                        right: 34,
                        top: 72,
                        bottom: 58,
                    },
                    tooltip: {
                        position: 'top',
                        backgroundColor: 'rgba(41, 29, 23, 0.95)',
                        borderColor: 'rgba(233, 198, 160, 0.28)',
                        borderWidth: 1,
                        padding: [11, 14],
                        textStyle: {
                            color: '#fffaf1',
                            fontFamily: 'Cormorant Garamond, serif',
                            fontSize: 15,
                        },
                        formatter: (params) => {
                            const cell = params?.data || {};
                            const value = Number(Array.isArray(cell?.value) ? cell.value[2] : cell?.value || 0);
                            return [
                                `<strong>${cell?.causeLabel || 'Причина не указана'}</strong>`,
                                `Возраст: ${cell?.ageBandLabel || '—'} лет`,
                                `Умерших: ${value.toLocaleString('ru-RU')}`,
                                value > 0 ? '<span style="opacity:.72">Нажмите, чтобы открыть записи</span>' : '',
                            ].filter(Boolean).join('<br/>');
                        },
                    },
                    xAxis: {
                        type: 'category',
                        data: ageBands.map(item => item?.label || ''),
                        name: 'Возраст умерших, лет',
                        nameLocation: 'middle',
                        nameGap: 42,
                        splitArea: { show: false },
                        axisTick: { show: false },
                        axisLine: { lineStyle: { color: 'rgba(95,71,53,0.25)' } },
                        axisLabel: {
                            interval: 0,
                            color: '#695b50',
                            fontFamily: 'Cormorant Garamond, serif',
                            fontSize: 12,
                            rotate: ageBands.length > 16 ? 38 : 0,
                        },
                    },
                    yAxis: {
                        type: 'category',
                        inverse: true,
                        data: causes.map(item => item?.label || ''),
                        axisTick: { show: false },
                        axisLine: { show: false },
                        axisLabel: {
                            color: '#493b31',
                            fontFamily: 'Cormorant Garamond, serif',
                            fontSize: 14,
                            fontWeight: 600,
                            width: 195,
                            overflow: 'truncate',
                        },
                    },
                    // Static legend instead of visualMap: it cannot grow handles or overlap
                    // the matrix when an old ECharts option is restored from browser state.
                    graphic: [{
                        type: 'group',
                        left: 'center',
                        top: 14,
                        silent: true,
                        children: colorSteps.flatMap((step, index) => {
                            const x = index * 72;
                            return [
                                {
                                    type: 'rect',
                                    shape: { x, y: 0, width: 18, height: 12, r: 3 },
                                    style: { fill: step.color, stroke: 'rgba(73,59,49,0.14)', lineWidth: 1 },
                                },
                                {
                                    type: 'text',
                                    style: {
                                        x: x + 25,
                                        y: 6,
                                        text: step.label,
                                        fill: '#6b5c50',
                                        font: '600 12px Cormorant Garamond, serif',
                                        textVerticalAlign: 'middle',
                                    },
                                },
                            ];
                        }),
                    }],
                    series: [{
                        type: 'heatmap',
                        data: cells.map(cell => {
                            const value = Number(cell?.value || 0);
                            return {
                                value: [
                                    Number(cell?.xIndex || 0),
                                    Number(cell?.yIndex || 0),
                                    value,
                                ],
                                name: `${cell?.causeLabel || ''} · ${cell?.ageBandLabel || ''}`,
                                groupKey: cell?.groupKey || '',
                                causeLabel: cell?.causeLabel || '',
                                ageBandLabel: cell?.ageBandLabel || '',
                                itemStyle: { color: colorForValue(value) },
                            };
                        }),
                        label: {
                            show: true,
                            fontFamily: 'Cormorant Garamond, serif',
                            fontWeight: 700,
                            fontSize: 12,
                            formatter: (params) => {
                                const value = Number(Array.isArray(params?.data?.value) ? params.data.value[2] : 0);
                                if (value <= 0) return '';
                                const style = value >= 15 ? 'light' : 'dark';
                                return `{${style}|${value}}`;
                            },
                            rich: {
                                light: { color: '#fffaf2', fontWeight: 700 },
                                dark: { color: '#3e2e27', fontWeight: 700 },
                            },
                        },
                        itemStyle: {
                            borderColor: '#fffaf2',
                            borderWidth: 3,
                            borderRadius: 5,
                        },
                        emphasis: {
                            itemStyle: {
                                borderColor: '#3d261d',
                                borderWidth: 2,
                                shadowBlur: 14,
                                shadowColor: 'rgba(61,38,29,0.32)',
                            },
                        },
                    }],
                };
            }, [deathCauseAgeMatrix]);
            const groomAgesOption = useMemo(() => buildAgeBarOption(topGroomAges, '#7f1d1d', 'Возраст'), [buildAgeBarOption, topGroomAges]);
            const brideAgesOption = useMemo(() => buildAgeBarOption(topBrideAges, '#9d174d', 'Возраст'), [buildAgeBarOption, topBrideAges]);
            const spouseAgeGapsOption = useMemo(() => buildAgeBarOption(topSpouseAgeGaps, '#4c7a53', 'Разница'), [buildAgeBarOption, topSpouseAgeGaps]);
            const filteredDeathAges = useMemo(() => (
                topDeathAges.filter((entry) => matchesDeathAgeRange(entry, activeDeathAgeRange))
            ), [activeDeathAgeRange, matchesDeathAgeRange, topDeathAges]);
            const deathAgesOption = useMemo(
                () => buildAgeBarOption(filteredDeathAges, '#4f5d75', 'Возраст'),
                [buildAgeBarOption, filteredDeathAges]
            );
            const eventTimelineOption = useMemo(
                () => buildEventTimelineOption(eventTimelineByYear, eventTimelineLegendSelected),
                [buildEventTimelineOption, eventTimelineByYear, eventTimelineLegendSelected]
            );
            const eventTimelineBadges = useMemo(() => {
                if (!eventTimelineByYear.length) return [];
                const firstYear = eventTimelineByYear[0]?.year;
                const lastYear = eventTimelineByYear[eventTimelineByYear.length - 1]?.year;
                const periodLabel = firstYear && lastYear ? (firstYear === lastYear ? String(firstYear) : `${firstYear}–${lastYear}`) : '';
                return [
                    periodLabel ? { label: 'Период', value: periodLabel } : null,
                    { label: 'Лет', value: String(eventTimelineByYear.length) }
                ].filter(Boolean);
            }, [eventTimelineByYear]);
            const twinBirthBadges = useMemo(() => {
                const totalCases = Number(totals.twinBirthCases || 0);
                const yearsCount = topTwinBirthYears.length;
                return [
                    totalCases ? { label: 'Случаев', value: totalCases.toLocaleString('ru-RU') } : null,
                    yearsCount ? { label: 'Лет с близнецами', value: yearsCount.toLocaleString('ru-RU') } : null,
                ].filter(Boolean);
            }, [topTwinBirthYears.length, totals.twinBirthCases]);
            const namesFactBadges = useMemo(() => {
                const totalFacts = Number(factTotals?.names || 0);
                return totalFacts ? [{ label: 'Всего имён', value: totalFacts.toLocaleString('ru-RU') }] : [];
            }, [factTotals?.names]);
            const surnamesFactBadges = useMemo(() => {
                const totalFacts = Number(factTotals?.surnames || 0);
                return totalFacts ? [{ label: 'Всего фамилий', value: totalFacts.toLocaleString('ru-RU') }] : [];
            }, [factTotals?.surnames]);
            const childrenPerFamilyBadges = useMemo(() => {
                if (!normalizedChildrenPerFamilyDistribution.length) return [];
                const pairsTotal = normalizedChildrenPerFamilyDistribution.reduce((sum, item) => (
                    sum + Number(item?.value || 0)
                ), 0);
                const maxChildren = normalizedChildrenPerFamilyDistribution.reduce((max, item) => {
                    const current = Number.parseInt(String(item?.groupKey ?? item?.name ?? '0'), 10);
                    return Number.isFinite(current) ? Math.max(max, current) : max;
                }, 0);
                return [
                    pairsTotal ? { label: 'Семейных пар', value: pairsTotal.toLocaleString('ru-RU') } : null,
                    maxChildren ? { label: 'Максимум детей', value: String(maxChildren) } : null,
                ].filter(Boolean);
            }, [normalizedChildrenPerFamilyDistribution]);
            const siblingBirthGapBadges = useMemo(() => {
                const intervalsTotal = Number(totals.siblingBirthIntervals || factTotals.siblingBirthIntervals || 0);
                const averageGap = Number(averages.siblingBirthGapMonths);
                return [
                    intervalsTotal ? { label: 'Интервалов', value: intervalsTotal.toLocaleString('ru-RU') } : null,
                    intervalsTotal && Number.isFinite(averageGap)
                        ? { label: 'Средний интервал', value: `${averageGap.toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} мес.` }
                        : null,
                ].filter(Boolean);
            }, [averages.siblingBirthGapMonths, factTotals.siblingBirthIntervals, totals.siblingBirthIntervals]);
            const firstBirthAfterMarriageBadges = useMemo(() => {
                const intervalsTotal = Number(
                    totals.firstBirthAfterMarriageIntervals
                    || factTotals.firstBirthAfterMarriageIntervals
                    || 0
                );
                const averageGap = Number(averages.firstBirthAfterMarriageMonths);
                return [
                    intervalsTotal ? { label: 'Сопоставленных семей', value: intervalsTotal.toLocaleString('ru-RU') } : null,
                    intervalsTotal && Number.isFinite(averageGap)
                        ? { label: 'Средний интервал', value: `${averageGap.toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} мес.` }
                        : null,
                ].filter(Boolean);
            }, [
                averages.firstBirthAfterMarriageMonths,
                factTotals.firstBirthAfterMarriageIntervals,
                totals.firstBirthAfterMarriageIntervals,
            ]);
            const occupationsFactBadges = useMemo(() => {
                const totalFacts = Number(factTotals?.occupations || 0);
                return totalFacts ? [{ label: 'Всего статусов', value: totalFacts.toLocaleString('ru-RU') }] : [];
            }, [factTotals?.occupations]);
            const deathAgesFactBadges = useMemo(() => {
                const totalFacts = Number(factTotals?.deathAges || 0);
                const selectedRange = deathAgeRangeTabs.find(tab => tab.key === activeDeathAgeRange) || deathAgeRangeTabs[0];
                const rangeFacts = filteredDeathAges.reduce((sum, item) => sum + Number(item?.value || 0), 0);
                return [
                    totalFacts ? { label: 'Всего возрастов', value: totalFacts.toLocaleString('ru-RU') } : null,
                    selectedRange?.key !== 'all' ? { label: 'В диапазоне', value: rangeFacts.toLocaleString('ru-RU') } : null,
                ].filter(Boolean);
            }, [activeDeathAgeRange, deathAgeRangeTabs, factTotals?.deathAges, filteredDeathAges]);
            const totalDeathsInPeriod = useMemo(
                () => eventTimelineByYear.reduce((sum, year) => sum + Number(year?.deaths || 0), 0),
                [eventTimelineByYear]
            );
            const deathCausesFactBadges = useMemo(() => {
                const recognized = Number(factTotals?.deathCauses || 0);
                const total = Number(totalDeathsInPeriod || 0);
                const uniqueLabels = Number(totals?.deathCauses || 0);
                const badges = [];
                if (total > 0) {
                    const pct = recognized > 0 ? Math.round((recognized / total) * 100) : 0;
                    badges.push({
                        label: 'В надёжной статистике',
                        value: `${recognized.toLocaleString('ru-RU')} из ${total.toLocaleString('ru-RU')} (${pct}%)`
                    });
                } else if (recognized) {
                    badges.push({ label: 'Распознано причин', value: recognized.toLocaleString('ru-RU') });
                }
                if (uniqueLabels) {
                    badges.push({ label: 'Уникальных причин', value: uniqueLabels.toLocaleString('ru-RU') });
                }
                if (excludedDeathCauseCount) {
                    badges.push({ label: 'Требуют проверки', value: excludedDeathCauseCount.toLocaleString('ru-RU') });
                }
                return badges;
            }, [excludedDeathCauseCount, factTotals?.deathCauses, totalDeathsInPeriod, totals?.deathCauses]);
            const deathCauseAgeMatrixBadges = useMemo(() => {
                const causesCount = Array.isArray(deathCauseAgeMatrix?.causes)
                    ? deathCauseAgeMatrix.causes.length
                    : 0;
                const knownAgeCount = Number(deathCauseAgeMatrix?.knownAgeCauseCount || 0);
                const missingAgeCount = Number(deathCauseAgeMatrix?.missingAgeCount || 0);
                const recognizedCount = Number(deathCauseAgeMatrix?.recognizedCauseCount || 0);
                const coverage = recognizedCount > 0
                    ? Math.round((knownAgeCount / recognizedCount) * 100)
                    : 0;
                return [
                    causesCount ? { label: 'Причин', value: causesCount.toLocaleString('ru-RU') } : null,
                    knownAgeCount ? { label: 'С известным возрастом', value: knownAgeCount.toLocaleString('ru-RU') } : null,
                    recognizedCount ? { label: 'Покрытие возрастом', value: `${coverage}%` } : null,
                    missingAgeCount ? { label: 'Без возраста', value: missingAgeCount.toLocaleString('ru-RU') } : null,
                ].filter(Boolean);
            }, [deathCauseAgeMatrix]);
            const deathAgeRangeControls = useMemo(() => (
                <div className="flex flex-wrap gap-2">
                    {deathAgeRangeTabs.map((tab) => {
                        const isActive = tab.key === activeDeathAgeRange;
                        const count = tab.key === 'all'
                            ? topDeathAges.reduce((sum, item) => sum + Number(item?.value || 0), 0)
                            : topDeathAges.filter((entry) => matchesDeathAgeRange(entry, tab.key)).reduce((sum, item) => sum + Number(item?.value || 0), 0);
                        return (
                            <button
                                key={tab.key}
                                onClick={() => setActiveDeathAgeRange(tab.key)}
                                className={`rounded-full border px-3 py-1.5 text-[11px] font-bold transition-colors ${isActive ? 'bg-[#4f5d75] text-white border-[#4f5d75] shadow-sm' : 'bg-white text-stone-600 border-stone-200 hover:border-[#4f5d75] hover:text-[#4f5d75]'}`}
                            >
                                {tab.label}
                                <span className={`ml-2 text-[10px] ${isActive ? 'text-white/80' : 'text-stone-400'}`}>{count.toLocaleString('ru-RU')}</span>
                            </button>
                        );
                    })}
                </div>
            ), [activeDeathAgeRange, deathAgeRangeTabs, matchesDeathAgeRange, topDeathAges]);

            const openDrilldown = useCallback((field, title, params) => {
                let groupKey = String(params?.data?.groupKey || '').trim();
                let label = String(params?.name || '').trim();
                if (field === 'event_year_type') {
                    const eventType = String(params?.data?.eventType || '').trim().toUpperCase();
                    const year = String(params?.data?.year || params?.name || '').trim();
                    if (!eventType || !year) return;
                    groupKey = `${eventType}:${year}`;
                    const seriesLabel = String(params?.seriesName || '').trim() || 'События';
                    label = `${seriesLabel} · ${year}`;
                }
                if (!groupKey) return;
                setDrilldownPage(1);
                setActiveDrilldown({ field, title, groupKey, label });
            }, []);

            useEffect(() => {
                if (!activeDrilldown) return;
                const node = drilldownRef.current;
                if (!node) return;
                const frame = requestAnimationFrame(() => {
                    try {
                        node.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } catch (e) {
                        node.scrollIntoView();
                    }
                });
                return () => cancelAnimationFrame(frame);
            }, [activeDrilldown?.field, activeDrilldown?.groupKey]);
            const handleSelectNameLookup = useCallback((result) => {
                const normalizedResult = result && typeof result === 'object' ? result : null;
                if (!normalizedResult?.groupKey) return;
                setSelectedNameLookup(normalizedResult);
                setNameLookupQuery(String(normalizedResult.name || ''));
                openDrilldown('name', 'Имя', {
                    name: normalizedResult.name,
                    data: { groupKey: normalizedResult.groupKey },
                });
            }, [openDrilldown]);
            const handleSelectSurnameLookup = useCallback((result) => {
                const normalizedResult = result && typeof result === 'object' ? result : null;
                if (!normalizedResult?.groupKey) return;
                setSelectedSurnameLookup(normalizedResult);
                setSurnameLookupQuery(String(normalizedResult.name || ''));
                openDrilldown('surname', 'Фамилия', {
                    name: normalizedResult.name,
                    data: { groupKey: normalizedResult.groupKey },
                });
            }, [openDrilldown]);
            const handleSelectOccupationLookup = useCallback((result) => {
                const normalizedResult = result && typeof result === 'object' ? result : null;
                if (!normalizedResult?.groupKey) return;
                setSelectedOccupationLookup(normalizedResult);
                setOccupationLookupQuery(String(normalizedResult.name || ''));
                openDrilldown('occupation', 'Занятие / статус', {
                    name: normalizedResult.name,
                    data: { groupKey: normalizedResult.groupKey },
                });
            }, [openDrilldown]);
            const occupationSearchPanel = useMemo(() => (
                <StatisticsLookupPanel
                    accentColor="#7a4b2f"
                    placeholder="Найти любое сословие или занятие…"
                    query={occupationLookupQuery}
                    onQueryChange={setOccupationLookupQuery}
                    loading={occupationLookupLoading}
                    results={occupationLookupResults}
                    selectedResult={selectedOccupationLookup}
                    onSelectResult={handleSelectOccupationLookup}
                    onClearSelection={() => {
                        setSelectedOccupationLookup(null);
                    }}
                />
            ), [handleSelectOccupationLookup, occupationLookupLoading, occupationLookupQuery, occupationLookupResults, selectedOccupationLookup]);
            const handleEventTimelineLegendSelectChange = useCallback((params) => {
                const nextSelected = params?.selected && typeof params.selected === 'object' ? params.selected : null;
                if (!nextSelected) return;
                setEventTimelineLegendSelected(prev => ({
                    ...prev,
                    ...nextSelected,
                }));
            }, []);

            useEffect(() => {
                if (!projectId || !activeDrilldown?.field || !activeDrilldown?.groupKey) {
                    setDrilldownData(null);
                    setDrilldownLoading(false);
                    return;
                }
                const requestSeq = ++drilldownRequestSeqRef.current;
                const controller = new AbortController();
                const params = new URLSearchParams({
                    pid: projectId,
                    parish_id: parishId || '',
                    v: `${dataVersion || 0}:${statsRefreshRevision}:${liveRefreshNonce}`,
                    field: activeDrilldown.field,
                    group_key: activeDrilldown.groupKey,
                    page: String(drilldownPage),
                    page_size: '100',
                });
                if (Number.isFinite(Number(statsYearFilter?.from)) && Number.isFinite(Number(statsYearFilter?.to))) {
                    params.set('year_from', String(statsYearFilter.from));
                    params.set('year_to', String(statsYearFilter.to));
                }
                const requestKey = params.toString();

                if (drilldownCacheRef.current.has(requestKey)) {
                    setDrilldownData(drilldownCacheRef.current.get(requestKey));
                    setDrilldownLoading(false);
                    return () => controller.abort();
                }

                setDrilldownLoading(true);
                fetch(`${API_BASE}/parents_stats_rows_state?${requestKey}`, {
                    signal: controller.signal,
                    cache: 'no-store'
                })
                    .then(async (response) => {
                        if (!response.ok) throw new Error(`HTTP ${response.status}`);
                        return response.json();
                    })
                    .then((data) => {
                        if (drilldownRequestSeqRef.current !== requestSeq) return;
                        const normalizedData = data && typeof data === 'object' ? data : {};
                        rememberBoundedCacheValue(drilldownCacheRef.current, requestKey, normalizedData, 96);
                        setDrilldownData(normalizedData);
                    })
                    .catch((error) => {
                        if (controller.signal.aborted) return;
                        console.error(error);
                        if (drilldownRequestSeqRef.current !== requestSeq) return;
                        showToast('Не удалось загрузить выборку по статистике', 'error');
                        setDrilldownData({
                            field: activeDrilldown.field,
                            groupKey: activeDrilldown.groupKey,
                            selectedLabel: activeDrilldown.label,
                            total: 0,
                            currentPage: 1,
                            totalPages: 1,
                            pageSize: 100,
                            rows: [],
                        });
                    })
                    .finally(() => {
                        if (drilldownRequestSeqRef.current === requestSeq) {
                            setDrilldownLoading(false);
                        }
                    });

                return () => controller.abort();
            }, [projectId, parishId, dataVersion, statsRefreshRevision, liveRefreshNonce, activeDrilldown, drilldownPage, statsYearFilter]);

            const drilldownRows = Array.isArray(drilldownData?.rows) ? drilldownData.rows : [];
            const drilldownTotal = Number(drilldownData?.total || 0);
            const drilldownPageSize = Number(drilldownData?.pageSize || 100);
            const drilldownCurrentPage = Math.max(1, Number(drilldownData?.currentPage || drilldownPage || 1));
            const drilldownTotalPages = Math.max(1, Number(drilldownData?.totalPages || 1));
            const isSiblingBirthGapDrilldown = activeDrilldown?.field === 'sibling_birth_gap';
            const isFirstBirthAfterMarriageDrilldown = activeDrilldown?.field === 'first_birth_after_marriage';

            const buildPreviousSiblingDrilldownRow = useCallback((row) => ({
                ...row,
                id: row?.previousSiblingBirthRowId || `previous:${row?.id || ''}`,
                itemId: row?.previousSiblingItemId || '',
                itemUrl: row?.previousSiblingItemUrl || '',
                entryId: row?.previousSiblingBirthRecordId || '',
                entryIndex: row?.previousSiblingEntryIndex ?? null,
                parishId: row?.previousSiblingParishId || row?.parishId || '',
                eventType: 'BIRTH',
                cipherLabel: row?.previousSiblingCipherLabel || '',
                pageLabel: row?.previousSiblingPageLabel || '',
                eventDate: row?.previousSiblingBirthDate || '',
                eventDateLabel: row?.previousSiblingBirthDateLabel || '',
                year: row?.previousSiblingBirthYear ?? null,
                eventYearLabel: row?.previousSiblingBirthDateLabel || row?.previousSiblingBirthYear || '',
                previewLabel: row?.previousSiblingLabel || '',
                childName: row?.previousSiblingLabel || '',
                primaryLocalityLabel: row?.previousSiblingLocalityLabel || '',
                previewImageId: row?.previousSiblingPreviewImageId || '',
                previewImageUrl: row?.previousSiblingPreviewImageUrl || '',
                previewImageWidth: row?.previousSiblingPreviewImageWidth ?? null,
                previewImageHeight: row?.previousSiblingPreviewImageHeight ?? null,
                previewBbox: row?.previousSiblingPreviewBbox || {},
            }), []);
            const buildMarriageDrilldownRow = useCallback((row) => ({
                ...row,
                id: row?.marriageRowId || `marriage:${row?.id || ''}`,
                itemId: row?.marriageItemId || '',
                itemUrl: row?.marriageItemUrl || '',
                entryId: row?.marriageEntryId || '',
                entryIndex: row?.marriageEntryIndex ?? null,
                parishId: row?.marriageParishId || row?.parishId || '',
                eventType: 'WEDDING',
                cipherLabel: row?.marriageCipherLabel || '',
                pageLabel: row?.marriagePageLabel || '',
                eventDate: row?.marriageDate || '',
                eventDateLabel: row?.marriageDateLabel || '',
                year: row?.marriageYear ?? null,
                eventYearLabel: row?.marriageDateLabel || row?.marriageYear || '',
                previewLabel: [row?.marriageGroomLabel, row?.marriageBrideLabel].filter(Boolean).join(' × '),
                groomName: row?.marriageGroomLabel || '',
                brideName: row?.marriageBrideLabel || '',
                previewImageId: row?.marriagePreviewImageId || '',
                previewImageUrl: row?.marriagePreviewImageUrl || '',
                previewImageWidth: row?.marriagePreviewImageWidth ?? null,
                previewImageHeight: row?.marriagePreviewImageHeight ?? null,
                previewBbox: row?.marriagePreviewBbox || {},
            }), []);

            const renderDrilldownDetails = useCallback((row) => {
                const eventType = String(row?.eventType || '').toUpperCase();
                if (eventType === 'BIRTH') {
                    return [
                        row?.fatherName ? `Отец: ${row.fatherName}` : '',
                        row?.motherName ? `Мать: ${row.motherName}` : '',
                        joinLabels(row?.deathLabels || row?.secondaryLabels) ? `Смерть: ${joinLabels(row?.deathLabels || row?.secondaryLabels)}` : '',
                    ].filter(Boolean).join(' · ');
                }
                if (eventType === 'WEDDING') {
                    return [
                        row?.groomName ? `Жених: ${row.groomName}${row?.groomAge ? ` (${row.groomAge})` : ''}` : '',
                        row?.brideName ? `Невеста: ${row.brideName}${row?.brideAge ? ` (${row.brideAge})` : ''}` : '',
                        row?.spouseAgeGapValue !== null && row?.spouseAgeGapValue !== undefined ? `Разница в возрасте: ${row.spouseAgeGapValue}` : '',
                        joinLabels(row?.witnessLabels) ? `Свидетели: ${joinLabels(row.witnessLabels)}` : '',
                    ].filter(Boolean).join(' · ');
                }
                if (eventType === 'DEATH') {
                    return [
                        row?.deceasedAge ? `Возраст: ${row.deceasedAge}` : '',
                        row?.deathCause ? `Причина: ${row.deathCause}` : '',
                        joinLabels(row?.relatedLabels) ? `Связанные лица: ${joinLabels(row.relatedLabels)}` : '',
                    ].filter(Boolean).join(' · ');
                }
                return '';
            }, []);

            const STATS_KPIS = [
                { label: 'Участников', value: totals.people, icon: '👥' },
                { label: 'Событий', value: totals.entries, icon: '📜' },
                { label: 'Имён детей', value: totals.names, icon: '✍️' },
                { label: 'Фамилий детей', value: totals.surnames, icon: '🏷️' },
                { label: 'Семейных пар', value: totals.birthFamilies, icon: '👨‍👩‍👧‍👦' },
                { label: 'Занятий', value: totals.occupations, icon: '🧾' },
                { label: 'Пунктов', value: totals.localities, icon: '📍' },
                { label: 'Уездов', value: totals.uyezds, icon: '🗺️' },
                { label: 'Губерний', value: totals.governorates, icon: '🏛️' },
                { label: 'Уникальных причин смерти', value: totals.deathCauses, icon: '🩺' },
            ];

            const hasStatsContent = Boolean(
                eventTimelineByYear.length ||
                topNames.length ||
                topSurnames.length ||
                normalizedChildrenPerFamilyDistribution.length ||
                siblingBirthGapDistribution.length ||
                firstBirthAfterMarriageDistribution.length ||
                topTwinBirthYears.length ||
                topOccupations.length ||
                topLocalities.length ||
                topUyezds.length ||
                topGovernorates.length ||
                topGroomGovernorates.length ||
                topBrideGovernorates.length ||
                topGroomAges.length ||
                topBrideAges.length ||
                topSpouseAgeGaps.length ||
                topDeathAges.length ||
                topDeathCauses.length
            );
            const timelinePeriodLabel = eventTimelineBadges.find(item => item?.label === 'Период')?.value || 'не определён';
            const primaryHeroStats = [
                { label: 'Участников событий', value: totals.people, note: 'всего распознанных персон', accent: '#f6b26b' },
                { label: 'Событий', value: totals.entries, note: 'рождения, браки, смерти', accent: '#f08b6d' },
                { label: 'Период', value: timelinePeriodLabel, note: eventTimelineByYear.length ? `${eventTimelineByYear.length} лет в ряду` : 'годовой ряд уточняется', accent: '#d6c39a' },
            ];
            const compactKpis = STATS_KPIS.filter(item => !['Участников', 'Событий'].includes(item.label));
            const eventSeriesKpis = useMemo(() => {
                const sumBy = (key) => eventTimelineByYear.reduce((acc, item) => acc + Number(item?.[key] || 0), 0);
                const seriesBy = (key) => (fullEventTimeline.length ? fullEventTimeline : eventTimelineByYear)
                    .map(item => ({ year: Number(item?.year), value: Number(item?.[key] || 0) }));
                return [
                    { label: 'Рождения', value: sumBy('births'), color: '#f6b26b', series: seriesBy('births') },
                    { label: 'Браки', value: sumBy('weddings'), color: '#c9a7e8', series: seriesBy('weddings') },
                    { label: 'Смерти', value: sumBy('deaths'), color: '#9fb3d1', series: seriesBy('deaths') },
                ];
            }, [eventTimelineByYear, fullEventTimeline]);
            const visibleStatsTabs = useMemo(() => (
                [
                    { key: 'timeline', label: 'Хронология', count: 1, visible: eventTimelineByYear.length > 0 },
                    { key: 'births', label: 'Дети', count: (topNames.length > 0 ? 1 : 0) + (topSurnames.length > 0 ? 1 : 0) + (normalizedChildrenPerFamilyDistribution.length > 0 ? 1 : 0) + (siblingBirthGapDistribution.length > 0 ? 1 : 0) + (firstBirthAfterMarriageDistribution.length > 0 ? 1 : 0) + (topTwinBirthYears.length > 0 ? 1 : 0), visible: topNames.length > 0 || topSurnames.length > 0 || normalizedChildrenPerFamilyDistribution.length > 0 || siblingBirthGapDistribution.length > 0 || firstBirthAfterMarriageDistribution.length > 0 || topTwinBirthYears.length > 0 },
                    { key: 'social', label: 'Сословия', count: topOccupations.length > 0 ? 1 : 0, visible: topOccupations.length > 0 },
                    { key: 'geography', label: 'География', count: (topLocalities.length > 0 ? 1 : 0) + (topUyezds.length > 0 ? 1 : 0) + (topGovernorates.length > 0 ? 1 : 0), visible: topLocalities.length > 0 || topUyezds.length > 0 || topGovernorates.length > 0 },
                    { key: 'marriages', label: 'Женихи и невесты', count: (topGroomGovernorates.length > 0 ? 1 : 0) + (topBrideGovernorates.length > 0 ? 1 : 0) + (topGroomAges.length > 0 ? 1 : 0) + (topBrideAges.length > 0 ? 1 : 0) + (topSpouseAgeGaps.length > 0 ? 1 : 0), visible: topGroomGovernorates.length > 0 || topBrideGovernorates.length > 0 || topGroomAges.length > 0 || topBrideAges.length > 0 || topSpouseAgeGaps.length > 0 },
                    { key: 'deaths', label: 'Смерти', count: (topDeathAges.length > 0 ? 1 : 0) + (topDeathCauses.length > 0 ? 1 : 0) + (deathCauseAgeMatrixHasData ? 1 : 0), visible: topDeathAges.length > 0 || topDeathCauses.length > 0 || deathCauseAgeMatrixHasData },
                ].filter(tab => tab.visible)
            ), [
                eventTimelineByYear.length,
                topNames.length,
                topSurnames.length,
                normalizedChildrenPerFamilyDistribution.length,
                siblingBirthGapDistribution.length,
                firstBirthAfterMarriageDistribution.length,
                topTwinBirthYears.length,
                topOccupations.length,
                topLocalities.length,
                topUyezds.length,
                topGovernorates.length,
                topGroomGovernorates.length,
                topBrideGovernorates.length,
                topGroomAges.length,
                topBrideAges.length,
                topSpouseAgeGaps.length,
                topDeathAges.length,
                topDeathCauses.length,
                deathCauseAgeMatrixHasData,
            ]);

            const handleStatsTabChange = useCallback((nextTabKey) => {
                setActiveStatsTab(nextTabKey);
                setActiveDrilldown(null);
                setDrilldownData(null);
                setDrilldownLoading(false);
                setDrilldownPage(1);
                setDeathCauseAdminOpen(false);
            }, []);

            const handleStatsYearFilterChange = useCallback((nextRange) => {
                setDrilldownPage(1);
                setStatsYearFilter(
                    nextRange && Number.isFinite(Number(nextRange.from)) && Number.isFinite(Number(nextRange.to))
                        ? { from: Number(nextRange.from), to: Number(nextRange.to) }
                        : null
                );
            }, []);
            const brushTimeline = fullEventTimeline.length ? fullEventTimeline : eventTimelineByYear;

            useEffect(() => {
                if (!visibleStatsTabs.length) return;
                if (!visibleStatsTabs.some(tab => tab.key === activeStatsTab)) {
                    setActiveStatsTab(visibleStatsTabs[0].key);
                }
            }, [visibleStatsTabs, activeStatsTab]);

            return (
                <div
                    className="flex-1 min-h-0 overflow-hidden"
                    style={{
                        background: 'linear-gradient(180deg, #efe8db 0%, #e7dece 42%, #ede6d9 100%)',
                        position: 'relative'
                    }}
                >
                    <div className="h-full overflow-auto">
                        <div style={{ maxWidth: '1760px', margin: '0 auto', padding: '30px 24px 44px', opacity: statsLoading && statsLoaded ? 0.55 : 1, transition: 'opacity 220ms ease' }}>
                            {statsLoading && statsLoaded && (
                                <div style={{
                                    position: 'sticky',
                                    top: '12px',
                                    zIndex: 50,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    pointerEvents: 'none',
                                    marginBottom: '-34px'
                                }}>
                                    <div style={{
                                        padding: '8px 14px',
                                        borderRadius: '999px',
                                        background: 'rgba(43, 27, 21, 0.92)',
                                        color: '#fff8ec',
                                        fontSize: '12px',
                                        fontWeight: 700,
                                        letterSpacing: '0.02em',
                                        boxShadow: '0 8px 22px rgba(43, 27, 21, 0.2)'
                                    }}>
                                        Обновляем графики после правки…
                                    </div>
                                </div>
                            )}
                            {!statsLoaded && statsLoading && (
                                <div style={{ marginBottom: '24px' }}>
                                    <ServicePageLoaderCard
                                        title="Собираем статистику проекта"
                                        description="Считаем участников событий, фамилии и географию по всем записям."
                                    />
                                </div>
                            )}

                            <div style={{
                                borderRadius: '36px',
                                overflow: 'hidden',
                                marginBottom: '22px',
                                background: 'linear-gradient(135deg, #1b0d0c 0%, #2a1712 34%, #5b2418 100%)',
                                boxShadow: '0 10px 28px rgba(28,15,11,0.14), 0 24px 52px rgba(77,22,10,0.12)',
                                position: 'relative',
                                border: '1px solid rgba(255,255,255,0.06)',
                                contain: 'layout paint'
                            }}>
                                <div style={{
                                    position: 'absolute', inset: 0, opacity: 0.05,
                                    backgroundImage: 'repeating-linear-gradient(45deg, #fff 0px, #fff 1px, transparent 1px, transparent 10px)',
                                    pointerEvents: 'none'
                                }} />
                                <div style={{
                                    position: 'absolute', inset: 'auto -8% -20% auto', width: '52%', height: '86%', opacity: 0.26,
                                    background: 'radial-gradient(circle at center, rgba(247,163,94,0.42) 0%, rgba(247,163,94,0.15) 26%, transparent 66%)',
                                    pointerEvents: 'none'
                                }} />
                                <div style={{
                                    position: 'absolute', inset: '0 auto auto 0', width: '44%', height: '100%', opacity: 0.16,
                                    background: 'linear-gradient(120deg, rgba(255,255,255,0.14) 0%, transparent 60%)',
                                    pointerEvents: 'none'
                                }} />

                                <div style={{ position: 'relative', padding: '30px 32px 28px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '18px', alignItems: 'stretch' }}>
                                        <div>
                                            <div style={{ fontSize: '10px', fontWeight: 800, letterSpacing: '0.24em', textTransform: 'uppercase', color: 'rgba(255,184,126,0.72)', marginBottom: '10px' }}>
                                                Аналитика · {project?.title || 'Проект'}
                                            </div>
                                            {parish?.title && (
                                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '16px', padding: '8px 12px', borderRadius: '999px', border: '1px solid rgba(255,214,170,0.26)', background: 'rgba(255,244,232,0.08)', color: '#ffe7c9', fontSize: '11px', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' }}>
                                                    <span style={{ color: '#ffb87e' }}>Приход</span>
                                                    <span>{parish.title}</span>
                                                </div>
                                            )}
                                            <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 'clamp(32px, 4vw, 54px)', fontWeight: 900, color: '#fff8f0', lineHeight: 0.98, letterSpacing: '-0.03em', maxWidth: '12ch' }}>
                                                Статистический атлас прихода
                                            </div>
                                            <div style={{ marginTop: '14px', fontSize: '15px', color: 'rgba(255,246,236,0.68)', lineHeight: 1.7, maxWidth: '48rem' }}>
                                                Большой обзор имён, географии, сословий, возрастов и смертности по всем структурированным записям проекта.
                                            </div>
                                            {parish?.subtitle && (
                                                <div style={{ marginTop: '12px', fontSize: '12px', lineHeight: 1.6, color: 'rgba(255,236,218,0.48)', maxWidth: '42rem' }}>
                                                    {parish.subtitle}
                                                </div>
                                            )}
                                        </div>

                                        <div style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                            gap: '12px',
                                            alignContent: 'start'
                                        }}>
                                            {primaryHeroStats.map(({ label, value, note, accent }) => (
                                                <div key={label} style={{
                                                    padding: '16px 16px 15px',
                                                    borderRadius: '20px',
                                                    background: 'linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.06) 100%)',
                                                    border: '1px solid rgba(255,255,255,0.11)',
                                                    minHeight: '120px'
                                                }}>
                                                    <div style={{ fontSize: '9px', fontWeight: 800, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,246,236,0.44)' }}>
                                                        {label}
                                                    </div>
                                                    <div style={{ marginTop: '12px', fontFamily: 'Playfair Display, serif', fontSize: typeof value === 'number' ? '30px' : '25px', fontWeight: 900, color: accent, lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>
                                                        {typeof value === 'number' ? Number(value || 0).toLocaleString('ru') : value}
                                                    </div>
                                                    <div style={{ marginTop: '10px', fontSize: '12px', lineHeight: 1.45, color: 'rgba(255,246,236,0.66)' }}>
                                                        {note}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            marginTop: '24px',
                                            display: 'flex',
                                            flexWrap: 'nowrap',
                                            gap: '8px',
                                            overflowX: 'auto',
                                            paddingBottom: '2px'
                                        }}
                                    >
                                        {eventSeriesKpis.map(({ label, value, color, series }) => (
                                            <div key={label} style={{
                                                padding: '9px 12px',
                                                borderRadius: '15px',
                                                background: 'rgba(255,255,255,0.075)',
                                                border: `1px solid ${color}44`,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                flex: '0 0 auto',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <div style={{ minWidth: 0 }}>
                                                    <div style={{ fontSize: '15px', fontWeight: 800, color: '#fff', lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>
                                                        {Number(value || 0).toLocaleString('ru')}
                                                    </div>
                                                    <div style={{ marginTop: '2px', fontSize: '8px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color, lineHeight: 1.15 }}>
                                                        {label}
                                                    </div>
                                                </div>
                                                <StatsSparkline
                                                    series={series}
                                                    color={color}
                                                    width={104}
                                                    height={26}
                                                    highlightFrom={statsYearFilter ? Number(statsYearFilter.from) : null}
                                                    highlightTo={statsYearFilter ? Number(statsYearFilter.to) : null}
                                                />
                                            </div>
                                        ))}
                                        {compactKpis.map(({ label, value, icon }) => (
                                            <div key={label} style={{
                                                padding: '9px 12px',
                                                borderRadius: '15px',
                                                background: 'rgba(255,255,255,0.055)',
                                                border: '1px solid rgba(255,255,255,0.08)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                flex: '0 0 auto',
                                                minWidth: '132px',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                <span style={{ fontSize: '15px', flexShrink: 0 }}>{icon}</span>
                                                <div style={{ minWidth: 0 }}>
                                                    <div style={{ fontSize: '15px', fontWeight: 800, color: '#fff', lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>
                                                        {Number(value || 0).toLocaleString('ru')}
                                                    </div>
                                                    <div style={{ marginTop: '2px', fontSize: '8px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.38)', lineHeight: 1.15 }}>
                                                        {label}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {brushTimeline.length > 1 && (
                                <StatsYearRangeBrush
                                    timeline={brushTimeline}
                                    value={statsYearFilter}
                                    onChange={handleStatsYearFilterChange}
                                />
                            )}

                            {visibleStatsTabs.length > 1 && (
                                <div
                                    className="mb-5 rounded-[28px] border border-stone-300 bg-[#fffaf2]/95 p-3 shadow-[0_12px_32px_rgba(45,34,20,0.06)]"
                                    style={{ position: 'sticky', top: '10px', zIndex: 12 }}
                                >
                                    <div className="mb-2 px-1 text-[10px] font-bold uppercase tracking-[0.18em] text-stone-500">
                                        Тематические разделы статистики
                                    </div>
                                    <div className="flex flex-wrap gap-2">
                                        {visibleStatsTabs.map((tab) => {
                                            const isActive = activeStatsTab === tab.key;
                                            return (
                                                <button
                                                    key={tab.key}
                                                    onClick={() => handleStatsTabChange(tab.key)}
                                                    className="rounded-full px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.12em] transition-all"
                                                    style={{
                                                        background: isActive ? 'linear-gradient(135deg, #7a1f1f 0%, #a03b2d 100%)' : 'rgba(255,255,255,0.88)',
                                                        color: isActive ? '#fffaf4' : '#5e5348',
                                                        border: isActive ? '1px solid rgba(122,31,31,0.5)' : '1px solid rgba(84,61,43,0.14)',
                                                        boxShadow: isActive ? '0 10px 24px rgba(122,31,31,0.18)' : 'none'
                                                    }}
                                                >
                                                    {tab.label}
                                                    <span
                                                        style={{
                                                            marginLeft: '8px',
                                                            display: 'inline-flex',
                                                            minWidth: '22px',
                                                            height: '22px',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            borderRadius: '999px',
                                                            background: isActive ? 'rgba(255,255,255,0.16)' : 'rgba(122,31,31,0.08)',
                                                            color: isActive ? '#fffaf4' : '#7a1f1f',
                                                            fontSize: '10px',
                                                            padding: '0 6px'
                                                        }}
                                                    >
                                                        {tab.count}
                                                    </span>
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                            {hasStatsContent ? (
                                <>
                                    {activeStatsTab === 'timeline' && eventTimelineByYear.length > 0 && (
                                        <div style={{ marginBottom: '18px' }}>
                                            <StatisticsSectionShell
                                                eyebrow="Хронология прихода"
                                                title="Движение метрических событий по годам"
                                                description="Линейный ряд для рождения, брака и смерти по точным годам событий. Это главный обзор ритма прихода во времени."
                                                accentColor="#7a1f1f"
                                                side={
                                                    <div className="flex flex-wrap justify-end gap-2">
                                                        {eventTimelineBadges.map((badge, index) => (
                                                            <div
                                                                key={`timeline-badge-${index}`}
                                                                style={{
                                                                    padding: '9px 12px',
                                                                    borderRadius: '16px',
                                                                    background: 'rgba(122,31,31,0.08)',
                                                                    border: '1px solid rgba(122,31,31,0.16)',
                                                                    color: '#69493d',
                                                                    fontSize: '11px',
                                                                    fontWeight: 700
                                                                }}
                                                            >
                                                                <span style={{ color: '#7a1f1f' }}>{badge.label}:</span> {badge.value}
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                            >
                                            <StatisticsChartCard
                                                title="Рождения, смерти и браки по годам"
                                                subtitle="Точное распределение событий по годам внутри текущего прихода"
                                                icon="📆"
                                                accentColor="#7a1f1f"
                                                badges={eventTimelineBadges}
                                                option={eventTimelineOption}
                                                height={390}
                                                onLegendSelectChange={handleEventTimelineLegendSelectChange}
                                                onChartClick={(params) => openDrilldown('event_year_type', 'События по годам', params)}
                                            />
                                            </StatisticsSectionShell>
                                        </div>
                                    )}

                                    {activeStatsTab === 'births' && (
                                    <div style={{ marginBottom: '18px' }}>
                                        <StatisticsSectionShell
                                            eyebrow="Антропонимия"
                                            title="Имена и фамилии родившихся детей"
                                            description="Срез самых частых имен и фамилий именно по записям о рождении. Рядом вынесен отдельный блок по случаям близнецов, чтобы их можно было смотреть и править отдельно."
                                            accentColor="#8b0000"
                                        >
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '14px', marginBottom: '14px' }}>
                                            <StatisticsChartCard
                                                title="Топ имён"
                                                subtitle="15 самых частых имен родившихся детей"
                                                icon="✍️"
                                                accentColor="#8b0000"
                                                badges={namesFactBadges}
                                                searchPanel={
                                                    <StatisticsLookupPanel
                                                        placeholder="Найти любое имя среди всех распознанных имён детей"
                                                        query={nameLookupQuery}
                                                        onQueryChange={(value) => {
                                                            setNameLookupQuery(value);
                                                            if (selectedNameLookup && String(value || '').trim() !== String(selectedNameLookup?.name || '').trim()) {
                                                                setSelectedNameLookup(null);
                                                            }
                                                        }}
                                                        loading={nameLookupLoading}
                                                        results={nameLookupResults}
                                                        selectedResult={selectedNameLookup}
                                                        onSelectResult={handleSelectNameLookup}
                                                        onClearSelection={() => {
                                                            setSelectedNameLookup(null);
                                                            setNameLookupQuery('');
                                                            setNameLookupResults([]);
                                                        }}
                                                        accentColor="#8b0000"
                                                    />
                                                }
                                                option={namesOption}
                                                height={getChartHeight(visibleTopNames.length)}
                                                onChartClick={(params) => openDrilldown('name', 'Имя', params)}
                                            />
                                            <StatisticsChartCard
                                                title="Топ фамилий"
                                                subtitle="15 самых частых фамилий родившихся детей"
                                                icon="🏷️"
                                                accentColor="#9f2d22"
                                                badges={surnamesFactBadges}
                                                searchPanel={
                                                    <StatisticsLookupPanel
                                                        placeholder="Найти любую фамилию среди всех распознанных фамилий детей"
                                                        query={surnameLookupQuery}
                                                        onQueryChange={(value) => {
                                                            setSurnameLookupQuery(value);
                                                            if (selectedSurnameLookup && String(value || '').trim() !== String(selectedSurnameLookup?.name || '').trim()) {
                                                                setSelectedSurnameLookup(null);
                                                            }
                                                        }}
                                                        loading={surnameLookupLoading}
                                                        results={surnameLookupResults}
                                                        selectedResult={selectedSurnameLookup}
                                                        onSelectResult={handleSelectSurnameLookup}
                                                        onClearSelection={() => {
                                                            setSelectedSurnameLookup(null);
                                                            setSurnameLookupQuery('');
                                                            setSurnameLookupResults([]);
                                                        }}
                                                        accentColor="#9f2d22"
                                                    />
                                                }
                                                option={surnamesOption}
                                                height={getChartHeight(visibleTopSurnames.length)}
                                                onChartClick={(params) => openDrilldown('surname', 'Фамилия', params)}
                                            />
                                        </div>
                                        {normalizedChildrenPerFamilyDistribution.length > 0 && (
                                            <div style={{ marginBottom: '14px' }}>
                                                <StatisticsChartCard
                                                    title="Сколько детей у одной пары"
                                                    subtitle="Распределение семей по числу найденных рождений: сколько пар дали 2, 3, 5, 10 и более детей."
                                                    icon="👨‍👩‍👧‍👦"
                                                    accentColor="#7a4b2f"
                                                    badges={childrenPerFamilyBadges}
                                                    option={childrenPerFamilyOption}
                                                    height={getChartHeight(normalizedChildrenPerFamilyDistribution.length)}
                                                />
                                            </div>
                                        )}
                                        {siblingBirthGapDistribution.length > 0 ? (
                                            <div style={{ marginBottom: '14px' }}>
                                                <StatisticsChartCard
                                                    title="Интервалы между рождениями детей в месяцах"
                                                    subtitle="Точное число полных месяцев между соседними рождениями у одной пары родителей. Учитываются только записи, где распознаны обе полные даты; по клику откроются обе записи о рождении."
                                                    icon="↔"
                                                    accentColor="#a85d32"
                                                    badges={siblingBirthGapBadges}
                                                    option={siblingBirthGapOption}
                                                    height={390}
                                                    onChartClick={(params) => openDrilldown('sibling_birth_gap', 'Интервал между рождениями', params)}
                                                />
                                            </div>
                                        ) : (
                                            <div style={{
                                                marginBottom: '14px',
                                                borderRadius: '22px',
                                                border: '1px solid rgba(168,93,50,0.18)',
                                                background: 'linear-gradient(145deg, rgba(255,253,248,0.98), rgba(249,241,229,0.82))',
                                                padding: '28px 30px',
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <span style={{ fontSize: '24px', color: '#a85d32' }}>↔</span>
                                                    <div>
                                                        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: '20px', color: '#3f332a' }}>
                                                            Интервалы между рождениями детей в месяцах
                                                        </div>
                                                        <div style={{ marginTop: '7px', fontSize: '13px', lineHeight: 1.6, color: '#7c6f64', maxWidth: '760px' }}>
                                                            Пока недостаточно двух рождений с точными датами у одной распознанной пары родителей. График появится автоматически, когда такие записи будут найдены.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {firstBirthAfterMarriageDistribution.length > 0 ? (
                                            <div style={{ marginBottom: '14px' }}>
                                                <StatisticsChartCard
                                                    title="Первый ребёнок после брака"
                                                    subtitle="Интервал в полных месяцах от точной даты брака до первого найденного рождения у сопоставленной пары. Учитываются только подтверждённые пары и интервалы не более пяти лет; по клику откроются обе исходные записи."
                                                    icon="💍"
                                                    accentColor="#8b4f3d"
                                                    badges={firstBirthAfterMarriageBadges}
                                                    option={firstBirthAfterMarriageOption}
                                                    height={390}
                                                    onChartClick={(params) => openDrilldown('first_birth_after_marriage', 'Первый ребёнок после брака', params)}
                                                />
                                            </div>
                                        ) : (
                                            <div style={{
                                                marginBottom: '14px',
                                                borderRadius: '22px',
                                                border: '1px solid rgba(139,79,61,0.18)',
                                                background: 'linear-gradient(145deg, rgba(255,253,248,0.98), rgba(248,239,232,0.82))',
                                                padding: '28px 30px',
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <span style={{ fontSize: '24px', color: '#8b4f3d' }}>💍</span>
                                                    <div>
                                                        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: '20px', color: '#3f332a' }}>
                                                            Первый ребёнок после брака
                                                        </div>
                                                        <div style={{ marginTop: '7px', fontSize: '13px', lineHeight: 1.6, color: '#7c6f64', maxWidth: '760px' }}>
                                                            Пока не найдены уверенно сопоставленные записи брака и первого рождения с точными датами. График появится автоматически после появления таких пар.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {topTwinBirthYears.length > 0 && (
                                            <StatisticsChartCard
                                                title="Случаи близнецов по годам"
                                                subtitle="Подтвержденные страницы и записи, где близнецы явно обозначены в тексте метрической записи. По клику откроется выборка таких рождений."
                                                icon="👶👶"
                                                accentColor="#7f1d1d"
                                                badges={twinBirthBadges}
                                                option={twinBirthYearsOption}
                                                height={340}
                                                onChartClick={(params) => openDrilldown('twin_birth_year', 'Близнецы по годам', params)}
                                            />
                                        )}
                                        </StatisticsSectionShell>
                                    </div>
                                    )}

                                    {activeStatsTab === 'social' && topOccupations.length > 0 && (
                                        <div style={{ marginBottom: '18px' }}>
                                            <StatisticsSectionShell
                                                eyebrow="Сословия и занятия"
                                                title="Социальный состав и повседневные роли"
                                                description="Показаны первые 15 самых частых значений. Любое другое сословие или занятие можно найти через поисковую строку под графиком."
                                                accentColor="#7a4b2f"
                                            >
                                                <StatisticsChartCard
                                                    title="Топ занятий"
                                                    subtitle="15 самых частых значений из поля статуса и занятия участников"
                                                    icon="🧾"
                                                    accentColor="#7a4b2f"
                                                    badges={occupationsFactBadges}
                                                    searchPanel={occupationSearchPanel}
                                                    option={occupationsOption}
                                                    height={getChartHeight(visibleOccupations.length || 1)}
                                                    onChartClick={(params) => openDrilldown('occupation', 'Занятие / статус', params)}
                                                />
                                            </StatisticsSectionShell>
                                        </div>
                                    )}

                                    {activeStatsTab === 'geography' && (topLocalities.length > 0 || topUyezds.length > 0 || topGovernorates.length > 0) && (
                                    <div style={{ marginBottom: '18px' }}>
                                        <StatisticsSectionShell
                                            eyebrow="География"
                                            title="Карта происхождения и локальной привязки"
                                            description="Населённые пункты, уезды и губернии по всему массиву записей. Брачная география вынесена в отдельный тематический таб."
                                            accentColor="#1a6b6b"
                                        >
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '14px', marginBottom: '14px' }}>
                                            <StatisticsChartCard
                                                title="Топ населённых пунктов"
                                                subtitle="Деревни, сёла, города и посады"
                                                icon="📍"
                                                accentColor="#a86f37"
                                                option={localitiesOption}
                                                height={getChartHeight(topLocalities.length)}
                                                onChartClick={(params) => openDrilldown('locality', 'Населённый пункт', params)}
                                            />
                                            <StatisticsChartCard
                                                title="Топ уездов"
                                                subtitle="15 самых частых уездов"
                                                icon="🗺️"
                                                accentColor="#1a6b6b"
                                                option={uyezdsOption}
                                                height={getChartHeight(topUyezds.length)}
                                                onChartClick={(params) => openDrilldown('uyezd', 'Уезд', params)}
                                            />
                                        </div>
                                        {topGovernorates.length > 0 && (
                                            <StatisticsChartCard
                                                title="Топ губерний"
                                                subtitle="15 самых частых губерний"
                                                icon="🏛️"
                                                accentColor="#6f2216"
                                                option={governoratesOption}
                                                height={getChartHeight(topGovernorates.length)}
                                                onChartClick={(params) => openDrilldown('governorate', 'Губерния', params)}
                                            />
                                        )}
                                        </StatisticsSectionShell>
                                    </div>
                                    )}

                                    {activeStatsTab === 'marriages' && (topGroomGovernorates.length > 0 || topBrideGovernorates.length > 0) && (
                                        <div style={{ marginBottom: '18px' }}>
                                            <StatisticsSectionShell
                                                eyebrow="Брачная география"
                                                title="Происхождение женихов и невест"
                                                description="Отдельный взгляд на губернии происхождения супругов в брачных записях."
                                                accentColor="#8f3b2e"
                                            >
                                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '14px' }}>
                                                    {topGroomGovernorates.length > 0 && (
                                                        <StatisticsChartCard
                                                            title="Губернии женихов"
                                                            subtitle="Топ-10 губерний происхождения женихов"
                                                            icon="🤵"
                                                            accentColor="#5d2b1f"
                                                            option={groomGovernoratesOption}
                                                            height={getChartHeight(topGroomGovernorates.length)}
                                                            onChartClick={(params) => openDrilldown('groom_governorate', 'Губерния жениха', params)}
                                                        />
                                                    )}
                                                    {topBrideGovernorates.length > 0 && (
                                                        <StatisticsChartCard
                                                            title="Губернии невест"
                                                            subtitle="Топ-10 губерний происхождения невест"
                                                            icon="👰"
                                                            accentColor="#8f3b2e"
                                                            option={brideGovernoratesOption}
                                                            height={getChartHeight(topBrideGovernorates.length)}
                                                            onChartClick={(params) => openDrilldown('bride_governorate', 'Губерния невесты', params)}
                                                        />
                                                    )}
                                                </div>
                                            </StatisticsSectionShell>
                                        </div>
                                    )}

                                    {activeStatsTab === 'marriages' && (topGroomAges.length > 0 || topBrideAges.length > 0 || topSpouseAgeGaps.length > 0) && (
                                        <div style={{ marginBottom: '18px' }}>
                                            <StatisticsSectionShell
                                                eyebrow="Возрастные распределения"
                                                title="Возраст женихов, невест и разница супругов"
                                                description="Демографический срез брачных записей: возраст вступления в брак и возрастной баланс внутри пары."
                                                accentColor="#4a3875"
                                            >
                                            {excludedMarriageAgeCount ? (
                                                <div className="mb-4 rounded-2xl border border-amber-300/70 bg-amber-50/80 px-4 py-3 text-[12px] leading-relaxed text-amber-950">
                                                    <span className="font-bold">{excludedMarriageAgeCount.toLocaleString('ru-RU')}</span>
                                                    {' '}аномальных значений возраста временно не участвуют в возрастных графиках, но остаются в таблицах для ручной проверки.
                                                </div>
                                            ) : null}
                                            {(topGroomAges.length > 0 || topBrideAges.length > 0 || topSpouseAgeGaps.length > 0) && (
                                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '14px' }}>
                                                    {topGroomAges.length > 0 && (
                                                        <StatisticsChartCard
                                                            title="Возраст женихов"
                                                            subtitle="Распределение возраста мужчин при вступлении в брак"
                                                            icon="🤵"
                                                            accentColor="#4a3875"
                                                            badges={formatMarriageAverageBadge(averages?.groomAgeAtMarriage) ? [{ label: 'Средний возраст', value: formatMarriageAverageBadge(averages?.groomAgeAtMarriage) }] : []}
                                                            option={groomAgesOption}
                                                            height={360}
                                                            onChartClick={(params) => openDrilldown('groom_age', 'Возраст жениха', params)}
                                                        />
                                                    )}
                                                    {topBrideAges.length > 0 && (
                                                        <StatisticsChartCard
                                                            title="Возраст невест"
                                                            subtitle="Распределение возраста женщин при вступлении в брак"
                                                            icon="👰"
                                                            accentColor="#7a2055"
                                                            badges={formatMarriageAverageBadge(averages?.brideAgeAtMarriage) ? [{ label: 'Средний возраст', value: formatMarriageAverageBadge(averages?.brideAgeAtMarriage) }] : []}
                                                            option={brideAgesOption}
                                                            height={360}
                                                            onChartClick={(params) => openDrilldown('bride_age', 'Возраст невесты', params)}
                                                        />
                                                    )}
                                                    {topSpouseAgeGaps.length > 0 && (
                                                        <StatisticsChartCard
                                                            title="Разница в возрасте супругов"
                                                            subtitle="Абсолютная разница в возрасте жениха и невесты в годах"
                                                            icon="↔️"
                                                            accentColor="#4c7a53"
                                                            option={spouseAgeGapsOption}
                                                            height={360}
                                                            onChartClick={(params) => openDrilldown('spouse_age_gap', 'Разница в возрасте супругов', params)}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                            </StatisticsSectionShell>
                                        </div>
                                    )}

                                    {activeStatsTab === 'deaths' && (topDeathAges.length > 0 || topDeathCauses.length > 0) && (
                                        <div style={{ marginBottom: '18px' }}>
                                            <StatisticsSectionShell
                                                eyebrow="Смертность"
                                                title="Возраст и причины смерти"
                                                description="Отдельный блок для записей о смерти: возраст умерших и самые частые формулировки причин."
                                                accentColor="#5a3f2c"
                                            >
                                                {(excludedDeathCauseCount || excludedDeathAgeCount) ? (
                                                    <div className="mb-4 rounded-2xl border border-amber-300/70 bg-amber-50/80 px-4 py-3 text-[12px] leading-relaxed text-amber-950">
                                                        <div className="font-bold">Сомнительные значения не смешиваются с подтверждённой статистикой</div>
                                                        <div className="mt-1 opacity-80">
                                                            {excludedDeathCauseCount ? `${excludedDeathCauseCount.toLocaleString('ru-RU')} причин смерти` : ''}
                                                            {excludedDeathCauseCount && excludedDeathAgeCount ? ' и ' : ''}
                                                            {excludedDeathAgeCount ? `${excludedDeathAgeCount.toLocaleString('ru-RU')} значений возраста` : ''}
                                                            {' '}оставлены в исходных таблицах для проверки, но временно не участвуют в графиках.
                                                        </div>
                                                    </div>
                                                ) : null}
                                                {topDeathAges.length > 0 && (
                                                    <StatisticsChartCard
                                                        title="Возраст в момент смерти"
                                                        subtitle="Распределение возраста умерших по записям о смерти"
                                                        icon="⚰️"
                                                        accentColor="#4f5d75"
                                                        badges={deathAgesFactBadges}
                                                        controls={deathAgeRangeControls}
                                                        option={deathAgesOption}
                                                        height={360}
                                                        onChartClick={(params) => openDrilldown('death_age', 'Возраст в момент смерти', params)}
                                                    />
                                                )}
                                                {topDeathAges.length > 0 && topDeathCauses.length > 0 && (
                                                    <div style={{ height: '14px' }} />
                                                )}
                                                {topDeathCauses.length > 0 && (
                                                    <>
                                                        <StatisticsChartCard
                                                            title="Причины смерти"
                                                            subtitle="Самые частые надёжно привязанные формулировки из колонки «От чего умер». Неуверенные OCR-значения и возможные переносы из соседних строк остаются на проверке и временно не входят в график."
                                                            icon="🩺"
                                                            accentColor="#5a3f2c"
                                                            badges={deathCausesFactBadges}
                                                            option={deathCausesOption}
                                                            height={getChartHeight(topDeathCauses.length)}
                                                            onChartClick={(params) => openDrilldown('death_cause', 'Причина смерти', params)}
                                                        />
                                                        {totalDeathsInPeriod > Number(factTotals?.deathCauses || 0) ? (
                                                            <div className="mt-3 flex flex-wrap items-center gap-3 justify-end">
                                                                <span className="text-[12px]" style={{ color: 'var(--parents-ink-soft)', fontFamily: "'Lora', serif" }}>
                                                                    {totalDeathsInPeriod - Number(factTotals?.deathCauses || 0)} записей без надёжно подтверждённой причины, включая значения на ручной проверке.
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setDeathCauseAdminOpen(true)}
                                                                    style={{
                                                                        padding: '8px 16px',
                                                                        borderRadius: '12px',
                                                                        border: '1px solid rgba(122,14,14,0.32)',
                                                                        background: 'linear-gradient(180deg, #fffaf2 0%, #fbf0dd 100%)',
                                                                        color: 'var(--parents-scarlet)',
                                                                        fontFamily: "'Lora', serif",
                                                                        fontSize: '11px',
                                                                        fontWeight: 700,
                                                                        letterSpacing: '0.14em',
                                                                        textTransform: 'uppercase',
                                                                        cursor: 'pointer',
                                                                        boxShadow: '0 4px 12px rgba(86,55,20,0.10), inset 0 1px 0 rgba(255,255,255,0.7)',
                                                                    }}
                                                                >
                                                                    Доразметить вручную →
                                                                </button>
                                                            </div>
                                                        ) : null}
                                                    </>
                                                )}
                                                {deathCauseAgeMatrixHasData && (
                                                    <>
                                                        <div style={{ height: '14px' }} />
                                                        <StatisticsChartCard
                                                            title="Причины смерти по возрастам"
                                                            subtitle="Тепловая матрица: строки — 15 наиболее частых причин смерти, столбцы — пятилетние возрастные интервалы. Чем насыщеннее ячейка, тем больше смертей. По клику открываются конкретные записи."
                                                            icon="▦"
                                                            accentColor="#8d3b31"
                                                            badges={deathCauseAgeMatrixBadges}
                                                            option={deathCauseAgeMatrixOption}
                                                            replaceOption={true}
                                                            height={Math.max(590, ((deathCauseAgeMatrix?.causes || []).length * 34) + 180)}
                                                            onChartClick={(params) => {
                                                                const value = Number(Array.isArray(params?.data?.value) ? params.data.value[2] : 0);
                                                                if (value > 0) {
                                                                    openDrilldown('death_cause_age', 'Причина смерти и возраст', params);
                                                                }
                                                            }}
                                                        />
                                                    </>
                                                )}
                                            </StatisticsSectionShell>
                                        </div>
                                    )}
                                </>
                            ) : !statsLoading ? (
                                <div style={{
                                    borderRadius: '28px',
                                    padding: '60px 40px',
                                    textAlign: 'center',
                                    background: 'linear-gradient(145deg, #fff 0%, #fdfaf4 100%)',
                                    border: '1px dashed rgba(139,0,0,0.2)',
                                    boxShadow: '0 4px 24px rgba(45,34,20,0.06)'
                                }}>
                                    <div style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.4 }}>📊</div>
                                    <div style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#4d4036', marginBottom: '8px' }}>Пока нет данных для статистики</div>
                                    <div style={{ fontSize: '13px', color: '#9b8f7f', lineHeight: 1.6, maxWidth: '400px', margin: '0 auto' }}>
                                        Добавьте страницы с распознанными участниками событий, и графики появятся автоматически.
                                    </div>
                                </div>
                            ) : null}

                            {activeDrilldown && (
                                <div
                                    ref={drilldownRef}
                                    style={{ scrollMarginTop: '88px' }}
                                    className="parents-table-shell"
                                >
                                    <div className="parents-table-header">
                                        <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
                                            <div className="min-w-0 max-w-3xl">
                                                <span className="parents-eyebrow">Выборка по графику</span>
                                                <h2 className="parents-page-title" style={{ fontSize: 'clamp(22px, 2.4vw, 30px)', marginTop: '10px' }}>
                                                    {activeDrilldown.title}: <em>{drilldownData?.selectedLabel || activeDrilldown.label}</em>
                                                </h2>
                                                <span className="parents-page-rule" style={{ marginTop: '12px', width: '64px' }} />
                                                <p className="parents-page-lede" style={{ fontSize: '13px', marginTop: '12px' }}>
                                                    {isFirstBirthAfterMarriageDrilldown
                                                        ? 'Каждая строка — сопоставленные записи брака и первого найденного рождения у этой пары. Обе точные даты и интервал показаны отдельно.'
                                                        : isSiblingBirthGapDrilldown
                                                            ? 'Каждая строка — два последовательных рождения у одной пары родителей. Имена, обе даты и точная разница в днях показаны отдельно.'
                                                            : 'События, где выбранное значение встречается в соответствующем поле.'}
                                                </p>
                                            </div>
                                            <button
                                                onClick={() => { setActiveDrilldown(null); setDrilldownData(null); }}
                                                className="parents-table-action-btn parents-table-action-btn--primary shrink-0"
                                                style={{ width: '34px', height: '34px', fontSize: '16px' }}
                                                title="Закрыть выборку"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    </div>

                                    {drilldownLoading && !drilldownData ? (
                                        <div className="px-8 py-16 text-center">
                                            <div className="text-xl text-[var(--parents-ink)]" style={{ fontFamily: "'Playfair Display', serif" }}>Собираем выборку по статистике</div>
                                            <div className="mt-2 text-sm text-[var(--parents-ink-soft)]" style={{ fontFamily: "'Lora', serif" }}>Подгружаем только подходящие записи проекта.</div>
                                        </div>
                                    ) : drilldownTotal > 0 ? (
                                        <>
                                            <div className="parents-table-toolbar parents-table-toolbar--pagination">
                                                <PaginationControls
                                                    page={drilldownCurrentPage}
                                                    totalPages={drilldownTotalPages}
                                                    totalItems={drilldownTotal}
                                                    pageSize={drilldownPageSize}
                                                    label={isFirstBirthAfterMarriageDrilldown ? 'Семьи' : (isSiblingBirthGapDrilldown ? 'Интервалы' : 'События')}
                                                    onChange={setDrilldownPage}
                                                />
                                            </div>
                                            <div className="parents-table-scroll">
                                                {isFirstBirthAfterMarriageDrilldown ? (
                                                    <table className="parents-table min-w-[1510px]">
                                                        <thead>
                                                            <tr>
                                                                {['Фрагменты записей', 'Супруги / родители', 'Дата брака', 'Первый ребёнок', 'Дата рождения', 'Разница', 'Источники'].map(label => (
                                                                    <th key={label}>{label}</th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {drilldownRows.map((row) => {
                                                                const marriageRow = buildMarriageDrilldownRow(row);
                                                                const coupleLabel = [
                                                                    row?.marriageGroomLabel || row?.fatherName,
                                                                    row?.marriageBrideLabel || row?.motherName,
                                                                ].filter(Boolean).join(' × ');
                                                                const parentLabel = [row?.fatherName, row?.motherName].filter(Boolean).join(' × ');
                                                                const childLabel = row?.childName || row?.previewLabel || 'Ребёнок не указан';
                                                                const marriageDateLabel = row?.marriageDateLabel
                                                                    || row?.marriageDate
                                                                    || row?.marriageYear
                                                                    || '—';
                                                                const birthDateLabel = row?.eventDateLabel
                                                                    || row?.eventDate
                                                                    || row?.eventYearLabel
                                                                    || row?.year
                                                                    || '—';
                                                                const marriageEditContext = {
                                                                    field: activeDrilldown?.field || '',
                                                                    groupKey: activeDrilldown?.groupKey || '',
                                                                    label: activeDrilldown?.label || '',
                                                                    preferredStatus: 'GROOM',
                                                                };
                                                                const birthEditContext = {
                                                                    field: activeDrilldown?.field || '',
                                                                    groupKey: activeDrilldown?.groupKey || '',
                                                                    label: activeDrilldown?.label || '',
                                                                    preferredStatus: 'BORN',
                                                                };
                                                                return (
                                                                    <tr key={row.id}>
                                                                        <td style={{ minWidth: '250px', width: '250px' }}>
                                                                            <div className="space-y-3">
                                                                                <ParentsStatsRecordPreview row={marriageRow} label="Брак" onOpen={() => onOpenRow?.(marriageRow)} />
                                                                                <ParentsStatsRecordPreview row={row} label="Первое рождение" onOpen={() => onOpenRow?.(row)} />
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ minWidth: '290px' }}>
                                                                            <div className="font-semibold">{coupleLabel || parentLabel || '—'}</div>
                                                                            {parentLabel && parentLabel !== coupleLabel && (
                                                                                <div className="parents-cell--meta" style={{ marginTop: '5px' }}>
                                                                                    В рождениях: {parentLabel}
                                                                                </div>
                                                                            )}
                                                                            <div className="parents-cell--meta" style={{ marginTop: '5px' }}>
                                                                                {row?.primaryLocalityLabel || joinLabels(row?.localityLabels) || '—'}
                                                                            </div>
                                                                        </td>
                                                                        <td className="parents-cell--num" style={{ minWidth: '175px' }}>
                                                                            <div className="flex items-center gap-2">
                                                                                <strong>{marriageDateLabel}</strong>
                                                                {canEdit && (
                                                                    <button
                                                                                        onClick={() => onEditRow?.(marriageRow, marriageEditContext)}
                                                                                        className="parents-table-action-btn parents-table-action-btn--primary"
                                                                                        title="Править брак и его точную дату"
                                                                                    >
                                                                                        ✎
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ minWidth: '210px' }}>
                                                                            <div className="flex items-center gap-2">
                                                                                <button
                                                                                    onClick={() => onOpenRow?.(row)}
                                                                                    className="text-left font-semibold hover:text-[var(--parents-scarlet)] transition-colors"
                                                                                    title="Открыть рождение ребёнка"
                                                                                >
                                                                                    {childLabel}
                                                                                </button>
                                                                                {canEdit && (
                                                                                    <button
                                                                                        onClick={() => onEditRow?.(row, birthEditContext)}
                                                                                        className="parents-table-action-btn parents-table-action-btn--primary"
                                                                                        title="Править рождение и его точную дату"
                                                                                    >
                                                                                        ✎
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        <td className="parents-cell--num" style={{ minWidth: '175px' }}>
                                                                            <strong>{birthDateLabel}</strong>
                                                                        </td>
                                                                        <td className="parents-cell--num" style={{ minWidth: '150px' }}>
                                                                            <strong style={{ color: 'var(--parents-scarlet)' }}>
                                                                                {Number.isFinite(Number(row?.firstBirthAfterMarriageDays))
                                                                                    ? `${Number(row.firstBirthAfterMarriageDays).toLocaleString('ru-RU')} дней`
                                                                                    : '—'}
                                                                            </strong>
                                                                            <div className="parents-cell--meta" style={{ marginTop: '5px' }}>
                                                                                {row?.firstBirthAfterMarriageLabel || '—'}
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ minWidth: '220px' }}>
                                                                            <button
                                                                                onClick={() => onOpenRow?.(marriageRow)}
                                                                                className="block text-left hover:text-[var(--parents-scarlet)] transition-colors"
                                                                            >
                                                                                Брак: {[marriageRow?.cipherLabel, marriageRow?.pageLabel].filter(Boolean).join(' · ') || 'Открыть'}
                                                                            </button>
                                                                            <button
                                                                                onClick={() => onOpenRow?.(row)}
                                                                                className="mt-2 block text-left hover:text-[var(--parents-scarlet)] transition-colors"
                                                                            >
                                                                                Рождение: {[row?.cipherLabel, row?.pageLabel].filter(Boolean).join(' · ') || 'Открыть'}
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                ) : isSiblingBirthGapDrilldown ? (
                                                    <table className="parents-table min-w-[1630px]">
                                                        <thead>
                                                            <tr>
                                                                {['Фрагменты записей', 'Родители', 'Первый ребёнок', 'Дата рождения', 'Второй ребёнок', 'Дата рождения', 'Разница', 'Источники'].map(label => (
                                                                    <th key={label}>{label}</th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {drilldownRows.map((row) => {
                                                                const previousRow = buildPreviousSiblingDrilldownRow(row);
                                                                const parentLabel = [row?.fatherName, row?.motherName].filter(Boolean).join(' × ');
                                                                const localityLabel = row?.primaryLocalityLabel
                                                                    || row?.previousSiblingLocalityLabel
                                                                    || joinLabels(row?.localityLabels)
                                                                    || '—';
                                                                const firstChildLabel = row?.previousSiblingLabel || 'Ребёнок не указан';
                                                                const secondChildLabel = row?.childName || row?.previewLabel || 'Ребёнок не указан';
                                                                const firstDateLabel = row?.previousSiblingBirthDateLabel
                                                                    || row?.previousSiblingBirthDate
                                                                    || row?.previousSiblingBirthYear
                                                                    || '—';
                                                                const secondDateLabel = row?.eventDateLabel
                                                                    || row?.eventDate
                                                                    || row?.eventYearLabel
                                                                    || row?.year
                                                                    || '—';
                                                                const editContext = {
                                                                    field: activeDrilldown?.field || '',
                                                                    groupKey: activeDrilldown?.groupKey || '',
                                                                    label: activeDrilldown?.label || '',
                                                                    preferredStatus: 'BORN',
                                                                };
                                                                return (
                                                                    <tr key={row.id}>
                                                                        <td style={{ minWidth: '250px', width: '250px' }}>
                                                                            <div className="space-y-3">
                                                                                <ParentsStatsRecordPreview row={previousRow} label="Первое рождение" onOpen={() => onOpenRow?.(previousRow)} />
                                                                                <ParentsStatsRecordPreview row={row} label="Второе рождение" onOpen={() => onOpenRow?.(row)} />
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ minWidth: '250px' }}>
                                                                            <div className="font-semibold">{parentLabel || '—'}</div>
                                                                            <div className="parents-cell--meta" style={{ marginTop: '5px' }}>{localityLabel}</div>
                                                                        </td>
                                                                        <td style={{ minWidth: '190px' }}>
                                                                            <div className="flex items-center gap-2">
                                                                                <button
                                                                                    onClick={() => onOpenRow?.(previousRow)}
                                                                                    className="text-left font-semibold hover:text-[var(--parents-scarlet)] transition-colors"
                                                                                    title="Открыть первое рождение"
                                                                                >
                                                                                    {firstChildLabel}
                                                                                </button>
                                                                                {canEdit && (
                                                                                    <button
                                                                                        onClick={() => onEditRow?.(previousRow, editContext)}
                                                                                        className="parents-table-action-btn parents-table-action-btn--primary"
                                                                                        title="Править первое рождение и его точную дату"
                                                                                    >
                                                                                        ✎
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        <td className="parents-cell--num" style={{ minWidth: '150px' }}>
                                                                            <strong>{firstDateLabel}</strong>
                                                                        </td>
                                                                        <td style={{ minWidth: '190px' }}>
                                                                            <div className="flex items-center gap-2">
                                                                                <button
                                                                                    onClick={() => onOpenRow?.(row)}
                                                                                    className="text-left font-semibold hover:text-[var(--parents-scarlet)] transition-colors"
                                                                                    title="Открыть второе рождение"
                                                                                >
                                                                                    {secondChildLabel}
                                                                                </button>
                                                                                {canEdit && (
                                                                                    <button
                                                                                        onClick={() => onEditRow?.(row, editContext)}
                                                                                        className="parents-table-action-btn parents-table-action-btn--primary"
                                                                                        title="Править второе рождение и его точную дату"
                                                                                    >
                                                                                        ✎
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        <td className="parents-cell--num" style={{ minWidth: '150px' }}>
                                                                            <strong>{secondDateLabel}</strong>
                                                                        </td>
                                                                        <td className="parents-cell--num" style={{ minWidth: '140px' }}>
                                                                            <strong style={{ color: 'var(--parents-scarlet)' }}>
                                                                                {Number.isFinite(Number(row?.siblingBirthGapDays))
                                                                                    ? `${Number(row.siblingBirthGapDays).toLocaleString('ru-RU')} дней`
                                                                                    : '—'}
                                                                            </strong>
                                                                            <div className="parents-cell--meta" style={{ marginTop: '5px' }}>
                                                                                {row?.siblingBirthGapLabel || '—'}
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ minWidth: '210px' }}>
                                                                            <button
                                                                                onClick={() => onOpenRow?.(previousRow)}
                                                                                className="block text-left hover:text-[var(--parents-scarlet)] transition-colors"
                                                                            >
                                                                                1. {[previousRow?.cipherLabel, previousRow?.pageLabel].filter(Boolean).join(' · ') || 'Открыть'}
                                                                            </button>
                                                                            <button
                                                                                onClick={() => onOpenRow?.(row)}
                                                                                className="mt-2 block text-left hover:text-[var(--parents-scarlet)] transition-colors"
                                                                            >
                                                                                2. {[row?.cipherLabel, row?.pageLabel].filter(Boolean).join(' · ') || 'Открыть'}
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                ) : (
                                                    <table className="parents-table min-w-[1430px]">
                                                        <thead>
                                                            <tr>
                                                                {['', 'Фрагмент записи', 'Тип', 'Шифр дела', 'Страница', 'Дата события', 'Главная запись', 'Детали', 'Населёный пункт'].map(label => (
                                                                    <th key={label}>{label}</th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {drilldownRows.map((row) => (
                                                                <tr key={row.id}>
                                                                    <td className="parents-cell--actions">
                                                                        {canEdit && (
                                                                            <button
                                                                                onClick={() => onEditRow?.(row, { field: activeDrilldown?.field || '', groupKey: activeDrilldown?.groupKey || '', label: activeDrilldown?.label || '' })}
                                                                                className="parents-table-action-btn parents-table-action-btn--primary"
                                                                                title="Править данные записи"
                                                                            >
                                                                        ✎
                                                                    </button>
                                                                )}
                                                                <ParentsDataQualityWarning
                                                                    row={row}
                                                                    onEdit={canEdit ? () => onEditRow?.(row, { field: 'death_cause', preferredStatus: 'DECEASED', label: 'Причина смерти' }) : null}
                                                                />
                                                            </td>
                                                                    <td style={{ minWidth: '230px', width: '230px' }}>
                                                                        <ParentsStatsRecordPreview row={row} onOpen={() => onOpenRow?.(row)} />
                                                                    </td>
                                                                    <td className="parents-cell--meta">{formatStructuredEntryType(row?.eventType)}</td>
                                                                    <td>
                                                                        <button
                                                                            onClick={() => onOpenRow?.(row)}
                                                                            className="text-left hover:text-[var(--parents-scarlet)] transition-colors"
                                                                        >
                                                                            {row?.cipherLabel || '—'}
                                                                        </button>
                                                                    </td>
                                                                    <td className="parents-cell--meta">{row?.pageLabel || '—'}</td>
                                                                    <td className="parents-cell--num">{row?.eventYearLabel || row?.year || '—'}</td>
                                                                    <td style={{ minWidth: '180px' }}>
                                                                        {row?.previewLabel ? (
                                                                            <SearchableValue value={row.previewLabel} type="name">
                                                                                {row.previewLabel}
                                                                            </SearchableValue>
                                                                        ) : '—'}
                                                                    </td>
                                                                    <td style={{ minWidth: '320px', color: 'var(--parents-ink-soft)' }}>{renderDrilldownDetails(row) || '—'}</td>
                                                                    <td style={{ minWidth: '190px' }}>{row?.primaryLocalityLabel || joinLabels(row?.localityLabels) || '—'}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>
                                            <div className="parents-table-toolbar parents-table-toolbar--pagination">
                                                <PaginationControls
                                                    page={drilldownCurrentPage}
                                                    totalPages={drilldownTotalPages}
                                                    totalItems={drilldownTotal}
                                                    pageSize={drilldownPageSize}
                                                    label={isSiblingBirthGapDrilldown ? 'Интервалы' : 'События'}
                                                    onChange={setDrilldownPage}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <div className="px-8 py-16 text-center">
                                            <div className="text-xl text-[var(--parents-ink)]" style={{ fontFamily: "'Playfair Display', serif" }}>По этой полоске событий не нашлось</div>
                                            <div className="mt-2 text-sm text-[var(--parents-ink-soft)]" style={{ fontFamily: "'Lora', serif" }}>Попробуйте выбрать другое значение на графике.</div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    {deathCauseAdminOpen ? (
                        <ParentsDeathCauseAdmin
                            projectId={projectId}
                            parishId={parishId}
                            canEdit={canEdit}
                            onOpenRow={onOpenRow}
                            onClose={() => setDeathCauseAdminOpen(false)}
                        />
                    ) : null}
                </div>
            );
        };

        // === WORKSPACE ===
        const Workspace = ({ user, initialPid, onBack }) => {
            const [projects, setProjects] = useState([]);
            const [catalog, setCatalog] = useState([]);
            const [summaryRowsData, setSummaryRowsData] = useState(null);
            const [summaryRowsLoading, setSummaryRowsLoading] = useState(false);
            const [parentsDashboardRowsData, setParentsDashboardRowsData] = useState(null);
            const [parentsDashboardLoading, setParentsDashboardLoading] = useState(false);
            const [search, setSearch] = useState('');
            const [yearFilter, setYearFilter] = useState('0');
            const [showFavs, setShowFavs] = useState(false);
            const [groupMode, setGroupMode] = useState('periodical'); // 'periodical' или 'year'
            const [tagPopoverId, setTagPopoverId] = useState(null); // ID карточки с открытым popover
            const [newTagInput, setNewTagInput] = useState('');
            const [editDocModal, setEditDocModal] = useState(null); // {id, form: {...}, textExpanded: bool, saving: bool} или null
            const [tagFilter, setTagFilter] = useState(null); // Фильтр по тегу
            const [isProjectMenuOpen, setIsProjectMenuOpen] = useState(false);
            const [isParishMenuOpen, setIsParishMenuOpen] = useState(false);
            
            // Закрываем popover и выпадающие меню при клике вне.
            useEffect(() => {
                const handleClickOutside = (e) => {
                    if (tagPopoverId && !e.target.closest('.tag-popover') && !e.target.closest('[title="Теги"]')) {
                        setTagPopoverId(null);
                    }
                    if (isProjectMenuOpen && !e.target.closest('.project-menu') && !e.target.closest('.project-menu-btn')) {
                        setIsProjectMenuOpen(false);
                    }
                    if (isParishMenuOpen && !e.target.closest('.parents-parish-menu')) {
                        setIsParishMenuOpen(false);
                    }
                };
                const handleEscape = (e) => {
                    if (e.key === 'Escape') setIsParishMenuOpen(false);
                };
                document.addEventListener('click', handleClickOutside);
                document.addEventListener('keydown', handleEscape);
                return () => {
                    document.removeEventListener('click', handleClickOutside);
                    document.removeEventListener('keydown', handleEscape);
                };
            }, [tagPopoverId, isProjectMenuOpen, isParishMenuOpen]);
            
            // Получаем все уникальные теги из каталога
            const allTags = useMemo(() => {
                const tags = new Set();
                catalog.forEach(item => {
                    (item.tags || []).forEach(t => tags.add(t));
                });
                return Array.from(tags).sort();
            }, [catalog]);
            
            // Добавить тег к карточке
            const addTag = (itemId, tag) => {
                if (!tag.trim()) return;
                fetch(`${API_BASE}/tag`, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({ item_id: itemId, pid: curPid, tag: tag.trim(), action: 'add' })
                }).then(() => refreshData());
                setNewTagInput('');
            };
            
            // Удалить тег с карточки
            const removeTag = (itemId, tag) => {
                fetch(`${API_BASE}/tag`, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({ item_id: itemId, pid: curPid, tag, action: 'remove' })
                }).then(() => refreshData());
            };
            const [isModalOpen, setIsModalOpen] = useState(false);
            const [modalType, setModalType] = useState('projects');
            const [isYearOpen, setIsYearOpen] = useState(false);
            const [newProj, setNewProj] = useState({ id: '', title: '', subtitle: '', cover_data: null, cover_name: '', allow_google_domain_famiry: false });
            const [newParish, setNewParish] = useState({ title: '', subtitle: '' });
            const [editingProj, setEditingProj] = useState(null);
            const [dragOver, setDragOver] = useState(false);
            const [workspaceStatus, setWorkspaceStatus] = useState(null);
            const [importUrl, setImportUrl] = useState('');
            const [batchImportPreview, setBatchImportPreview] = useState(null);
            const [batchImportRange, setBatchImportRange] = useState({ from: '', to: '' });
            const [batchImportYearRanges, setBatchImportYearRanges] = useState([]);
            const [batchImportManualYear, setBatchImportManualYear] = useState('');
            const [batchPreviewLoading, setBatchPreviewLoading] = useState(false);
            const [batchImportLoading, setBatchImportLoading] = useState(false);
            const [batchImportResult, setBatchImportResult] = useState(null);
            const [batchImportProgress, setBatchImportProgress] = useState(null);
            const [summaryEditorTarget, setSummaryEditorTarget] = useState(null);
            const [parentsEditorTarget, setParentsEditorTarget] = useState(null);
            const [parentsDataVersion, setParentsDataVersion] = useState(0);
            const [parentsRefreshState, setParentsRefreshState] = useState({ token: 0, itemId: '' });
            const [catalogPage, setCatalogPage] = useState(1);
            const activeYearOptionRef = useRef(null);
            const [summaryTablePage, setSummaryTablePage] = useState(1);
            const [summaryTableSearch, setSummaryTableSearch] = useState('');
            
            const [curPid, setCurPid] = useState(initialPid);
            const [activeParishId, setActiveParishId] = useState(() => {
                if (typeof window === 'undefined' || initialPid !== 'parents') return '';
                try {
                    const fromLocation = getParentsParishIdFromLocation(initialPid);
                    if (fromLocation) return fromLocation;
                    return normalizeParentsParishId(window.localStorage.getItem(getParentsParishStorageKey(initialPid))) || '';
                } catch (error) {
                    return '';
                }
            });
            const [workspacePage, setWorkspacePage] = useState(() => {
                if (typeof window === 'undefined' || initialPid !== 'parents') return 'catalog';
                try {
                    const parts = window.location.pathname.replace(BASE_PATH, '').split('/').filter(Boolean);
                    if (parts.length >= 3 && PARENTS_SECTIONS.includes(parts[2])) {
                        return PARENTS_SECTION_TO_WORKSPACE[parts[2]] || 'catalog';
                    }
                } catch (e) {}
                return 'catalog';
            });
            const [globalSearchPulse, setGlobalSearchPulse] = useState(0);
            const [selId, setSelId] = useState(null);

            useEffect(() => {
                return searchActionEvents.subscribe(({ value }) => {
                    const text = String(value || '').trim();
                    if (!text) return;
                    setSearch(text);
                    setYearFilter('0');
                    setShowFavs(false);
                    setTagFilter(null);
                    setWorkspacePage('catalog');
                    setGlobalSearchPulse(seq => seq + 1);
                    showToast(`Поиск «${text}» в каталоге`, 'info', 2200);
                });
            }, []);
            const [catalogOverlayState, setCatalogOverlayState] = useState({
                mounted: false,
                open: false,
                src: '',
                itemId: '',
                item: null,
                title: '',
                sourcePage: '',
                parishId: '',
            });
            const [catalogOverlayLoading, setCatalogOverlayLoading] = useState(false);
            const [collapsedGroups, setCollapsedGroups] = useState({});
            const [newlyAddedId, setNewlyAddedId] = useState(null);
            const [mobileSheetOpen, setMobileSheetOpen] = useState(false);
            const sheetRef = useRef(null);
            const startYRef = useRef(0);
            const refreshSeq = useRef(0);
            const hasLoadedProjectsRef = useRef(false);
            const projectsUserKeyRef = useRef(String(user?.user_id || ''));
            const catalogLoadedScopeRef = useRef('');
            const batchImportPollTimeoutRef = useRef(null);
            const catalogOverlayCloseTimeoutRef = useRef(null);
            const pendingCatalogFocusRef = useRef(null);
            const activeParishScopeRef = useRef('');
            const project = projects.find(p => p.id === curPid) || {};
            const isParentsProject = curPid === 'parents';
            const projectParishes = useMemo(() => (
                isParentsProject ? getParentsProjectParishes(project) : []
            ), [isParentsProject, project]);
            const effectiveParishId = useMemo(() => {
                if (!isParentsProject) return '';
                const normalized = normalizeParentsParishId(activeParishId);
                if (normalized) {
                    if (!project?.id) return normalized;
                    if (projectParishes.some(parish => parish.id === normalized)) {
                        return normalized;
                    }
                }
                return projectParishes[0]?.id || DEFAULT_PARENTS_PARISH.id;
            }, [isParentsProject, activeParishId, project?.id, projectParishes]);
            const activeParish = useMemo(() => {
                if (!isParentsProject) return null;
                return projectParishes.find(parish => parish.id === effectiveParishId) || projectParishes[0] || DEFAULT_PARENTS_PARISH;
            }, [isParentsProject, projectParishes, effectiveParishId]);
            
            // Закрытие панели свайпом вниз
            const handleSheetTouchStart = (e) => {
                startYRef.current = e.touches[0].clientY;
            };
            const handleSheetTouchMove = (e) => {
                const deltaY = e.touches[0].clientY - startYRef.current;
                if (deltaY > 100) {
                    setMobileSheetOpen(false);
                }
            };
            
            // Открытие панели при выборе карточки на мобильном
            useEffect(() => {
                if (selId && window.innerWidth <= 768) {
                    setMobileSheetOpen(true);
                }
            }, [selId]);

            useEffect(() => {
                if (!isParentsProject) {
                    setActiveParishId('');
                    activeParishScopeRef.current = '';
                    return;
                }
                try {
                    const fromLocation = getParentsParishIdFromLocation(curPid);
                    const stored = fromLocation || normalizeParentsParishId(window.localStorage.getItem(getParentsParishStorageKey(curPid)));
                    setActiveParishId(stored || '');
                } catch (error) {
                    setActiveParishId('');
                }
            }, [curPid, isParentsProject]);

            useEffect(() => {
                if (!isParentsProject || !project?.id || !projectParishes.length) return;
                const normalized = normalizeParentsParishId(activeParishId);
                if (normalized && projectParishes.some(parish => parish.id === normalized)) return;
                setActiveParishId(projectParishes[0].id);
            }, [isParentsProject, project?.id, projectParishes, activeParishId]);

            useEffect(() => {
                if (!isParentsProject || !effectiveParishId) return;
                try {
                    window.localStorage.setItem(getParentsParishStorageKey(curPid), effectiveParishId);
                } catch (error) {}
            }, [curPid, effectiveParishId, isParentsProject]);

            const closeCatalogOverlay = useCallback((options = {}) => {
                if (catalogOverlayCloseTimeoutRef.current) {
                    clearTimeout(catalogOverlayCloseTimeoutRef.current);
                    catalogOverlayCloseTimeoutRef.current = null;
                }
                if (options?.immediate) {
                    setCatalogOverlayState({
                        mounted: false,
                        open: false,
                        src: '',
                        itemId: '',
                        item: null,
                        title: '',
                        sourcePage: '',
                        parishId: '',
                    });
                    setCatalogOverlayLoading(false);
                    return;
                }
                setCatalogOverlayState(prev => (
                    prev.mounted ? { ...prev, open: false } : prev
                ));
            }, []);

            useEffect(() => {
                if (!catalogOverlayState.mounted) return;
                if (catalogOverlayState.open) {
                    if (catalogOverlayCloseTimeoutRef.current) {
                        clearTimeout(catalogOverlayCloseTimeoutRef.current);
                        catalogOverlayCloseTimeoutRef.current = null;
                    }
                    return;
                }
                catalogOverlayCloseTimeoutRef.current = setTimeout(() => {
                    setCatalogOverlayState(prev => (
                        prev.open ? prev : {
                            mounted: false,
                            open: false,
                            src: '',
                            itemId: '',
                            item: null,
                            title: '',
                            sourcePage: '',
                            parishId: '',
                        }
                    ));
                    setCatalogOverlayLoading(false);
                    catalogOverlayCloseTimeoutRef.current = null;
                }, 280);
                return () => {
                    if (catalogOverlayCloseTimeoutRef.current) {
                        clearTimeout(catalogOverlayCloseTimeoutRef.current);
                        catalogOverlayCloseTimeoutRef.current = null;
                    }
                };
            }, [catalogOverlayState.mounted, catalogOverlayState.open]);

            useEffect(() => {
                return () => {
                    if (catalogOverlayCloseTimeoutRef.current) {
                        clearTimeout(catalogOverlayCloseTimeoutRef.current);
                        catalogOverlayCloseTimeoutRef.current = null;
                    }
                };
            }, []);

            useEffect(() => {
                if (!catalogOverlayState.mounted) return;
                const handleEscape = (event) => {
                    if (event.key === 'Escape') {
                        closeCatalogOverlay();
                    }
                };
                window.addEventListener('keydown', handleEscape);
                return () => window.removeEventListener('keydown', handleEscape);
            }, [catalogOverlayState.mounted, closeCatalogOverlay]);

            useEffect(() => {
                if (workspacePage === 'catalog' && catalogOverlayState.mounted) {
                    closeCatalogOverlay({ immediate: true });
                }
            }, [workspacePage, catalogOverlayState.mounted, closeCatalogOverlay]);

            const toggleGroup = (groupName) => {
                setCollapsedGroups(prev => ({...prev, [groupName]: !prev[groupName]}));
            };

            // Workspace доступен только авторизованным

            // === URL routing ===
            // Для parents: /parents/<parish>/<section>[/<id>] (catalog/dashboard/families/stats).
            // Для остальных проектов: /<pid>[/<card_id>] (как раньше).
            // Старый формат /parents/<card_id> поддерживается через legacyCardId.
            const [selectedFamilyRecordId, setSelectedFamilyRecordId] = useState(() => {
                if (typeof window === 'undefined' || initialPid !== 'parents') return '';
                const parts = window.location.pathname.replace(BASE_PATH, '').split('/').filter(Boolean);
                return (parts.length >= 4 && parts[2] === 'families') ? decodeParentsRouteSegment(parts[3]) : '';
            });
            const [pendingDeepLink, setPendingDeepLink] = useState(() => {
                if (typeof window === 'undefined' || initialPid !== 'parents') return null;
                const parts = window.location.pathname.replace(BASE_PATH, '').split('/').filter(Boolean);
                // collect any record id from URL — applied once project/parishes loaded
                if (parts.length >= 4 && parts[2] === 'catalog') return { type: 'card', value: parts[3] };
                if (parts.length === 2) return { type: 'legacyCard', value: parts[1] }; // /parents/<maybeCard>
                return null;
            });
            const initialUrlSectionRef = useRef(null);
            if (typeof window !== 'undefined' && initialUrlSectionRef.current === null && initialPid === 'parents') {
                const parts = window.location.pathname.replace(BASE_PATH, '').split('/').filter(Boolean);
                if (parts.length >= 3 && PARENTS_SECTIONS.includes(parts[2])) {
                    initialUrlSectionRef.current = parts[2];
                }
            }

            // Применяем стартовую секцию из URL один раз после монтирования
            useEffect(() => {
                if (initialUrlSectionRef.current) {
                    const ws = PARENTS_SECTION_TO_WORKSPACE[initialUrlSectionRef.current];
                    if (ws) setWorkspacePage(ws);
                    initialUrlSectionRef.current = null;
                }
            }, []);

            // popstate (кнопка назад / вперёд)
            useEffect(() => {
                const handlePopState = () => {
                    const pathname = window.location.pathname;
                    const parts = pathname.replace(BASE_PATH, '').split('/').filter(Boolean);
                    const pathPid = parts[0];
                    if (!pathPid) {
                        setSelId(null);
                        setMobileSheetOpen(false);
                        return;
                    }
                    if (pathPid !== curPid) setCurPid(pathPid);
                    if (pathPid === 'parents') {
                        const known = projectParishes.map(p => p.id);
                        const parsed = parseParentsPath(pathname, known);
                        if (!parsed) return;
                        if (parsed.parishId && parsed.parishId !== activeParishId) {
                            setActiveParishId(parsed.parishId);
                        }
                        const ws = PARENTS_SECTION_TO_WORKSPACE[parsed.section] || 'catalog';
                        if (ws !== workspacePage) setWorkspacePage(ws);
                        if (parsed.section === 'families') {
                            setSelectedFamilyRecordId(parsed.recordId || '');
                            setSelId(null);
                        } else if (parsed.section === 'catalog') {
                            setSelectedFamilyRecordId('');
                            setSelId(parsed.recordId || parsed.legacyCardId || null);
                            if (parsed.recordId && window.innerWidth <= 768) setMobileSheetOpen(true);
                            else if (!parsed.recordId) setMobileSheetOpen(false);
                        } else {
                            setSelectedFamilyRecordId('');
                            setSelId(null);
                        }
                    } else {
                        // не-parents проекты: 2-й сегмент = card_id
                        const cardId = parts[1] || null;
                        setSelId(cardId);
                        if (cardId && window.innerWidth <= 768) setMobileSheetOpen(true);
                        else if (!cardId) setMobileSheetOpen(false);
                    }
                };
                window.addEventListener('popstate', handlePopState);
                return () => window.removeEventListener('popstate', handlePopState);
            }, [curPid, activeParishId, workspacePage, projectParishes]);

            // Применяем «отложенный» card_id из URL когда каталог загрузился
            useEffect(() => {
                if (!pendingDeepLink || !catalog.length) return;
                const { value } = pendingDeepLink;
                const card = catalog.find(c => c.id === value);
                if (card) {
                    setSelId(value);
                    if (window.innerWidth <= 768) setMobileSheetOpen(true);
                    setTimeout(() => {
                        const el = document.getElementById('card-' + value);
                        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }, 300);
                }
                setPendingDeepLink(null);
            }, [catalog, pendingDeepLink]);

            // Синхронизируем URL ← состояние (для parents)
            useEffect(() => {
                if (typeof window === 'undefined') return;
                if (curPid !== 'parents') {
                    // не-parents: /<pid>[/<selId>]
                    const desired = `${BASE_PATH}/${curPid}${selId ? '/' + selId : ''}`;
                    if (window.location.pathname !== desired) {
                        window.history.replaceState(window.history.state || { pid: curPid }, '', desired);
                    }
                    return;
                }
                // parents: ждём, пока приходы загрузились, иначе не различим parish от legacy card
                if (!projectParishes.length) return;
                const section = PARENTS_WORKSPACE_TO_SECTION[workspacePage] || 'catalog';
                let recordId = '';
                if (section === 'families') recordId = selectedFamilyRecordId || '';
                else if (section === 'catalog') recordId = selId || '';
                const desired = buildParentsPath({
                    parishId: effectiveParishId || '',
                    section,
                    recordId,
                });
                if (window.location.pathname !== desired) {
                    window.history.replaceState(
                        window.history.state || { pid: 'parents' },
                        '',
                        desired,
                    );
                }
            }, [curPid, workspacePage, effectiveParishId, selId, selectedFamilyRecordId, projectParishes]);

            // Смена прихода (без перезагрузки) — чистим выбранную запись/карточку,
            // чтобы URL не уносил мёртвый id с предыдущего прихода.
            const prevParishRef = useRef(effectiveParishId);
            useEffect(() => {
                if (prevParishRef.current && prevParishRef.current !== effectiveParishId) {
                    setSelectedFamilyRecordId('');
                    setSelId(null);
                }
                prevParishRef.current = effectiveParishId;
            }, [effectiveParishId]);

            const navigateToProject = (pid) => {
                setCurPid(pid);
                setSelId(null);
                setSelectedFamilyRecordId('');
                setSearch('');
                setYearFilter('0');
                setShowFavs(false);
                setTagFilter(null);
                window.history.pushState({ pid }, '', `${BASE_PATH}/${pid}`);
            };

            const selectParentsParish = useCallback((parishId) => {
                const normalized = normalizeParentsParishId(parishId);
                setIsParishMenuOpen(false);
                if (!normalized || normalized === effectiveParishId) return;
                setSelectedFamilyRecordId('');
                setSelId(null);
                setMobileSheetOpen(false);
                setActiveParishId(normalized);
            }, [effectiveParishId]);

            const shouldUseLightCatalog = (pid) => LIGHT_CATALOG_PROJECT_IDS.has(pid);

            const loadSummaryRows = useCallback(async (pid, { force = false } = {}) => {
                if (!pid || pid !== 'mospriyut') return [];
                if (!force && Array.isArray(summaryRowsData)) return summaryRowsData;
                setSummaryRowsLoading(true);
                try {
                    const response = await fetch(`${API_BASE}/summary_rows?pid=${pid}`);
                    const data = await response.json();
                    const normalized = Array.isArray(data) ? data : [];
                    setSummaryRowsData(normalized);
                    return normalized;
                } catch (error) {
                    showToast('Не удалось загрузить строки общей таблицы', 'error');
                    setSummaryRowsData([]);
                    return [];
                } finally {
                    setSummaryRowsLoading(false);
                }
            }, [summaryRowsData]);

            const loadParentsDashboardRows = useCallback(async (pid, { force = false } = {}) => {
                if (!pid || pid !== 'parents') return [];
                if (!force && Array.isArray(parentsDashboardRowsData)) return parentsDashboardRowsData;
                setParentsDashboardLoading(true);
                try {
                    const params = new URLSearchParams({ pid });
                    if (pid === 'parents' && effectiveParishId) params.set('parish_id', effectiveParishId);
                    const response = await fetch(`${API_BASE}/parents_dashboard_rows?${params.toString()}`);
                    const data = await response.json();
                    const normalized = Array.isArray(data) ? data : [];
                    setParentsDashboardRowsData(normalized);
                    return normalized;
                } catch (error) {
                    showToast('Не удалось загрузить дашборд по семьям', 'error');
                    setParentsDashboardRowsData([]);
                    return [];
                } finally {
                    setParentsDashboardLoading(false);
                }
            }, [parentsDashboardRowsData, effectiveParishId]);

            const refreshData = useCallback((options = {}) => {
                const includeProjects = options.includeProjects !== false;
                const includeProjectInfo = options.includeProjectInfo !== false;
                const forceCatalog = options.forceCatalog !== false;
                const catalogScopeKey = curPid === 'parents'
                    ? `${curPid}:${effectiveParishId || ''}`
                    : String(curPid || '');
                const shouldLoadCatalog = !!curPid && (curPid !== 'parents' || workspacePage === 'catalog');
                const catalogAlreadyLoaded = !forceCatalog
                    && catalogLoadedScopeRef.current === catalogScopeKey;
                const shouldRequestCatalog = shouldLoadCatalog && !catalogAlreadyLoaded;
                const refreshToken = ++refreshSeq.current;
                const isCurrentRefresh = () => refreshSeq.current === refreshToken;
                const updateWorkspaceStatus = (status) => {
                    if (isCurrentRefresh()) {
                        setWorkspaceStatus(status);
                    }
                };
                const endpoint = user ? `${API_BASE}/projects` : `${API_BASE}/shared`;
                if (includeProjects || includeProjectInfo || shouldRequestCatalog) {
                    updateWorkspaceStatus({
                        title: curPid ? 'Открываем проект' : 'Обновляем рабочее пространство',
                        detail: shouldRequestCatalog
                            ? 'Загружаем каталог, обложку и описание коллекции'
                            : 'Получаем список доступных проектов'
                    });
                }
                const projectsPromise = includeProjects
                    ? fetch(endpoint).then(res => res.json()).then(data => {
                        if (!isCurrentRefresh()) return;
                        const formattedData = user ? data : data.map(p => ({...p, id: p.project_id}));
                        hasLoadedProjectsRef.current = true;
                        setProjects(formattedData);
                        if (!curPid && formattedData.length > 0) {
                            updateWorkspaceStatus({
                                title: 'Подготавливаем первый проект',
                                detail: 'Открываем первую доступную коллекцию'
                            });
                            navigateToProject(formattedData[0].id);
                        }
                    })
                    : Promise.resolve();
                const catalogView = shouldUseLightCatalog(curPid) ? 'light' : 'full';
                const catalogParams = new URLSearchParams({ pid: curPid, view: catalogView });
                if (curPid === 'parents') {
                    if (effectiveParishId) catalogParams.set('parish_id', effectiveParishId);
                }
                const projectPromise = curPid ? Promise.all([
                    shouldRequestCatalog
                        ? fetch(`${API_BASE}/catalog?${catalogParams.toString()}`).then(res => res.json()).then(data => {
                            if (!isCurrentRefresh()) return;
                            setCatalog(Array.isArray(data) ? data : []);
                            catalogLoadedScopeRef.current = catalogScopeKey;
                            setSummaryRowsData(null);
                            setParentsDashboardRowsData(null);
                        })
                        : Promise.resolve(),
                    includeProjectInfo ? fetch(`${API_BASE}/project_info?pid=${curPid}`).then(res => res.json()).then(info => {
                        if (!isCurrentRefresh()) return;
                        if (info && info.owner_id) {
                            setProjects(prev => prev.map(p => p.id === curPid ? {...p, ...info} : p));
                        }
                    }) : Promise.resolve()
                ]) : Promise.resolve().then(() => {
                    if (!isCurrentRefresh()) return;
                    setCatalog([]);
                    setSummaryRowsData(null);
                    setParentsDashboardRowsData(null);
                });
                Promise.allSettled([projectsPromise, projectPromise]).finally(() => {
                    if (refreshSeq.current === refreshToken) {
                        setWorkspaceStatus(null);
                    }
                });
            }, [curPid, user, effectiveParishId, workspacePage]);

            useEffect(() => {
                const userKey = String(user?.user_id || '');
                const shouldReloadProjects = !hasLoadedProjectsRef.current || projectsUserKeyRef.current !== userKey;
                if (shouldReloadProjects) {
                    hasLoadedProjectsRef.current = false;
                    projectsUserKeyRef.current = userKey;
                }
                refreshData({
                    includeProjects: shouldReloadProjects,
                    includeProjectInfo: false,
                    forceCatalog: false,
                });
            }, [refreshData, user?.user_id]);

            useEffect(() => {
                if (curPid !== 'mospriyut') return;
                if (workspacePage !== 'summary_table' && workspacePage !== 'stats') return;
                if (Array.isArray(summaryRowsData)) return;
                loadSummaryRows(curPid);
            }, [curPid, workspacePage, summaryRowsData, loadSummaryRows]);

            // На смену проекта чистим все вспомогательные state'ы. Но НЕ на первый mount —
            // там URL уже дал нам корректные workspacePage / activeParishId, и сброс
            // setWorkspacePage('catalog') перетёр бы их (например при открытии прямой ссылки
            // /parents/taininskoe/stats).
            const projectSwitchInitialMountRef = useRef(true);
            useEffect(() => {
                if (projectSwitchInitialMountRef.current) {
                    projectSwitchInitialMountRef.current = false;
                    return;
                }
                setImportUrl('');
                setBatchImportPreview(null);
                setBatchImportResult(null);
                setBatchImportProgress(null);
                setBatchImportRange({ from: '', to: '' });
                setBatchImportYearRanges([]);
                setBatchImportManualYear('');
                setSummaryRowsData(null);
                setSummaryRowsLoading(false);
                setParentsDashboardRowsData(null);
                setParentsDashboardLoading(false);
                setWorkspacePage('catalog');
                setSummaryEditorTarget(null);
                setParentsEditorTarget(null);
                setParentsDataVersion(0);
                setParentsRefreshState({ token: 0, itemId: '' });
                catalogLoadedScopeRef.current = '';
                setCatalogPage(1);
                setSummaryTablePage(1);
                setSummaryTableSearch('');
                if (batchImportPollTimeoutRef.current) {
                    clearTimeout(batchImportPollTimeoutRef.current);
                    batchImportPollTimeoutRef.current = null;
                }
            }, [curPid]);

            useEffect(() => {
                if (!isParentsProject || !effectiveParishId) return;
                const scopeKey = `${curPid}:${effectiveParishId}`;
                if (activeParishScopeRef.current === scopeKey) return;
                activeParishScopeRef.current = scopeKey;
                catalogLoadedScopeRef.current = '';
                setCatalog([]);
                pendingCatalogFocusRef.current = null;
                setSelId(null);
                setSearch('');
                setYearFilter('0');
                setShowFavs(false);
                setTagFilter(null);
                setImportUrl('');
                setBatchImportPreview(null);
                setBatchImportResult(null);
                setBatchImportProgress(null);
                setBatchImportRange({ from: '', to: '' });
                setBatchImportYearRanges([]);
                setBatchImportManualYear('');
                setParentsEditorTarget(null);
                setCatalogPage(1);
                if (batchImportPollTimeoutRef.current) {
                    clearTimeout(batchImportPollTimeoutRef.current);
                    batchImportPollTimeoutRef.current = null;
                }
            }, [curPid, effectiveParishId, isParentsProject]);

            useEffect(() => {
                setCatalogPage(1);
            }, [search, yearFilter, showFavs, groupMode, tagFilter, curPid]);

            useEffect(() => {
                setSummaryTablePage(1);
            }, [summaryTableSearch]);

            useEffect(() => (
                () => {
                    if (batchImportPollTimeoutRef.current) {
                        clearTimeout(batchImportPollTimeoutRef.current);
                        batchImportPollTimeoutRef.current = null;
                    }
                }
            ), []);

            const currentUserId = String(user?.user_id || '');
            const canCreateProjects = !!currentUserId && OWN_PROJECT_MANAGER_IDS.has(currentUserId);
            const currentUserEmail = String(user?.email || user?.user_id || '').trim().toLowerCase();
            const isFamiryDomainEditor = String(user?.auth_provider || '').toLowerCase() === 'google'
                && currentUserEmail.endsWith('@famiry.ru');
            const canManageProject = (proj) => {
                if (!proj?.id) return false;
                if (canCreateProjects && String(proj.owner_id || currentUserId) === currentUserId) return true;
                return isFamiryDomainEditor && !!proj.allow_google_domain_famiry;
            };
            const canEditCurrentProject = canManageProject(project);
            const canUseBatchImport = canEditCurrentProject && BATCH_IMPORT_PROJECT_IDS.has(curPid);
            const serviceMode = curPid === 'mospriyut' ? 'mospriyut' : curPid === 'parents' ? 'parents' : null;
            const showServiceTabs = !!serviceMode;
            const servicePageNeedsSummaryRows = serviceMode === 'mospriyut' && (workspacePage === 'summary_table' || workspacePage === 'stats');
            const servicePageNeedsParentsDashboard = serviceMode === 'parents' && workspacePage === 'dashboard';
            const summaryEditorRow = summaryEditorTarget ? ((summaryRowsData || []).find(row => row.itemId === summaryEditorTarget.itemId && row.fragmentIndex === summaryEditorTarget.fragmentIndex) || null) : null;
            const summaryEditorCatalogItem = summaryEditorTarget ? (catalog.find(entry => entry.id === summaryEditorTarget.itemId) || null) : null;
            const summaryEditorItem = summaryEditorRow ? {
                ...(summaryEditorCatalogItem || {}),
                id: summaryEditorRow.itemId,
                url: summaryEditorRow.itemUrl
            } : null;
            const parentsEditorCatalogItem = parentsEditorTarget ? (catalog.find(entry => entry.id === parentsEditorTarget.itemId) || null) : null;
            const parentsEditorItem = parentsEditorTarget ? {
                ...(parentsEditorCatalogItem || {}),
                id: parentsEditorTarget.itemId,
                url: parentsEditorTarget.itemUrl || parentsEditorCatalogItem?.url
            } : null;
            const getProjectCoverSrc = (proj) => proj?.cover_image ? `/covers/${proj.owner_id || user?.user_id}/${proj.cover_image}` : null;
            const currentProjectCover = getProjectCoverSrc(project);
            const notifyParentsDataUpdated = useCallback((itemId, meta = null) => {
                if (curPid !== 'parents') return;
                const parsedMetaEntryIndex = Number(meta?.entryIndex);
                setParentsDashboardRowsData(null);
                setParentsDataVersion(prev => prev + 1);
                setParentsRefreshState(prev => ({ token: prev.token + 1, itemId }));
                window.dispatchEvent(new CustomEvent(PARENTS_DATA_UPDATED_EVENT, {
                    detail: {
                        projectId: curPid,
                        parishId: effectiveParishId || '',
                        itemId,
                        entryId: meta?.entryId || '',
                        entryIndex: Number.isInteger(parsedMetaEntryIndex) && parsedMetaEntryIndex >= 0 ? parsedMetaEntryIndex : null,
                        at: Date.now()
                    }
                }));
            }, [curPid, effectiveParishId]);
            const updateCatalogItem = useCallback((itemId, patch, meta = null) => {
                setCatalog(prev => prev.map(entry => entry.id === itemId ? {...entry, ...patch} : entry));
                const hasStructuredEntriesPatch = patch
                    && Object.prototype.hasOwnProperty.call(patch, 'structured_entries');
                if (curPid === 'parents' && hasStructuredEntriesPatch && !meta?.refreshHandled) {
                    notifyParentsDataUpdated(itemId, meta);
                }
                setSummaryRowsData(prev => {
                    if (!Array.isArray(prev) || curPid !== 'mospriyut') return prev;
                    const baseItem = (catalog.find(entry => entry.id === itemId) || summaryEditorCatalogItem || { id: itemId });
                    const nextItem = {
                        ...baseItem,
                        ...patch,
                        id: itemId,
                        url: patch?.url || baseItem?.url
                    };
                    const nextRows = buildSummaryRowsForCatalogItem(nextItem, curPid);
                    const firstIndex = prev.findIndex(row => row.itemId === itemId);
                    if (firstIndex === -1) return prev;
                    let lastIndex = firstIndex;
                    while (lastIndex + 1 < prev.length && prev[lastIndex + 1].itemId === itemId) {
                        lastIndex += 1;
                    }
                    return [
                        ...prev.slice(0, firstIndex),
                        ...nextRows,
                        ...prev.slice(lastIndex + 1)
                    ];
                });
            }, [catalog, curPid, notifyParentsDataUpdated, summaryEditorCatalogItem]);
            const closeSummaryEditor = useCallback(() => {
                setSummaryEditorTarget(null);
            }, []);
            const closeParentsEditor = useCallback(() => {
                setParentsEditorTarget(null);
            }, []);
            
            const yearStats = useMemo(() => {
                const s = {};
                catalog.forEach(i => {
                    getCatalogTimelineYears(i, curPid).forEach(year => {
                        s[year] = (s[year] || 0) + 1;
                    });
                });
                return s;
            }, [catalog, curPid]);
            
            const monthStats = useMemo(() => {
                const s = {};
                catalog.forEach(i => {
                    const { year, month } = getCatalogTimelineDateParts(i, curPid);
                    if (year && month) {
                        const key = `${year}-${month}`;
                        s[key] = (s[key] || 0) + 1;
                    }
                });
                return s;
            }, [catalog, curPid]);

            const selectedYearOnly = useMemo(() => {
                if (!yearFilter || yearFilter === '0') return '';
                return yearFilter.includes('-') ? yearFilter.split('-')[0] : yearFilter;
            }, [yearFilter]);

            useEffect(() => {
                if (!isYearOpen || !selectedYearOnly) return;
                const node = activeYearOptionRef.current;
                if (!node) return;
                requestAnimationFrame(() => {
                    try {
                        node.scrollIntoView({ block: 'nearest' });
                    } catch (e) {}
                });
            }, [isYearOpen, selectedYearOnly]);

            const filteredCatalogItems = useMemo(() => {
                const filtered = catalog.filter(i => {
                    const normSearch = normalizeText(search);
                    const mSearch = !search || [
                        i.issue,
                        i.snippet,
                        i.catalog_search_text,
                        i.structured_search_text,
                        i.text,
                        i.cipher,
                        i.periodical,
                    ].some(t => normalizeText(t || '').includes(normSearch));
                    const mYear = yearFilter === '0' || (() => {
                        const years = getCatalogTimelineYears(i, curPid);
                        const { month } = getCatalogTimelineDateParts(i, curPid);
                        if (yearFilter.includes('-')) {
                            const [filterYear, filterMonth] = yearFilter.split('-');
                            return years.includes(filterYear) && month === filterMonth;
                        }
                        return years.includes(yearFilter);
                    })();
                    const mFav = !showFavs || i.is_favorite;
                    const mTag = !tagFilter || (i.tags || []).includes(tagFilter);
                    return mSearch && mYear && mFav && mTag;
                });
                
                filtered.sort((a, b) => compareCatalogItems(a, b, curPid));
                return filtered;
            }, [catalog, search, yearFilter, showFavs, tagFilter, curPid]);

            const catalogPageCount = Math.max(1, Math.ceil(filteredCatalogItems.length / CATALOG_PAGE_SIZE));

            useEffect(() => {
                setCatalogPage(prev => Math.min(prev, catalogPageCount));
            }, [catalogPageCount]);

            const paginatedCatalogItems = useMemo(() => {
                const start = (catalogPage - 1) * CATALOG_PAGE_SIZE;
                return filteredCatalogItems.slice(start, start + CATALOG_PAGE_SIZE);
            }, [filteredCatalogItems, catalogPage]);

            const scrollToCard = useCallback((cardId, attempts = 0) => {
                const el = document.getElementById('card-' + cardId);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return;
                }
                if (attempts < 10) {
                    setTimeout(() => scrollToCard(cardId, attempts + 1), 200);
                }
            }, []);

            useEffect(() => {
                const targetItemId = String(pendingCatalogFocusRef.current || selId || '').trim();
                if (!targetItemId) return;
                const selectedIndex = filteredCatalogItems.findIndex(item => item.id === targetItemId);
                if (selectedIndex === -1) return;
                const targetPage = Math.floor(selectedIndex / CATALOG_PAGE_SIZE) + 1;
                if (catalogPage !== targetPage) {
                    setCatalogPage(targetPage);
                    return;
                }
                scrollToCard(targetItemId);
                pendingCatalogFocusRef.current = null;
            }, [catalogPage, filteredCatalogItems, scrollToCard, selId]);

            const groupedCatalog = useMemo(() => {
                const groups = {};
                
                if (groupMode === 'periodical') {
                    // Группировка по изданиям
                    paginatedCatalogItems.forEach(item => {
                        if (!groups[item.periodical]) groups[item.periodical] = [];
                        groups[item.periodical].push(item);
                    });
                } else {
                    // Группировка по годам
                    paginatedCatalogItems.forEach(item => {
                        const years = getCatalogTimelineYears(item, curPid);
                        let groupLabel = 'Без даты';
                        if (yearFilter !== '0' && years.includes(yearFilter)) {
                            groupLabel = yearFilter;
                        } else if (years.length === 1) {
                            groupLabel = years[0];
                        } else if (years.length > 1) {
                            groupLabel = years.join(' / ');
                        }
                        if (!groups[groupLabel]) groups[groupLabel] = [];
                        groups[groupLabel].push(item);
                    });
                }
                
                return groups;
            }, [paginatedCatalogItems, groupMode, curPid]);

            const summaryTableRows = useMemo(() => {
                if (workspacePage !== 'summary_table' && workspacePage !== 'stats') return [];
                if (curPid !== 'mospriyut') return [];
                if (!Array.isArray(summaryRowsData)) return [];
                return summaryRowsData;
            }, [summaryRowsData, curPid, workspacePage]);

            const filteredSummaryTableRows = useMemo(() => {
                return filterSummaryTableRows(summaryTableRows, summaryTableSearch);
            }, [summaryTableRows, summaryTableSearch]);

            const summaryTablePageCount = Math.max(1, Math.ceil(filteredSummaryTableRows.length / SUMMARY_TABLE_PAGE_SIZE));

            useEffect(() => {
                setSummaryTablePage(prev => Math.min(prev, summaryTablePageCount));
            }, [summaryTablePageCount]);

            const paginatedSummaryTableRows = useMemo(() => {
                const start = (summaryTablePage - 1) * SUMMARY_TABLE_PAGE_SIZE;
                return filteredSummaryTableRows.slice(start, start + SUMMARY_TABLE_PAGE_SIZE);
            }, [filteredSummaryTableRows, summaryTablePage]);

            // Drag & Drop для обложки
            const handleDrop = (e) => {
                e.preventDefault();
                setDragOver(false);
                const file = e.dataTransfer?.files?.[0];
                if (file && file.type.startsWith('image/')) {
                    const reader = new FileReader();
                    reader.onload = (ev) => {
                        setNewProj(prev => ({...prev, cover_data: ev.target.result.split(',')[1], cover_name: file.name}));
                    };
                    reader.readAsDataURL(file);
                }
            };

            const handleFileSelect = (e) => {
                const file = e.target.files?.[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (ev) => {
                        setNewProj(prev => ({...prev, cover_data: ev.target.result.split(',')[1], cover_name: file.name}));
                    };
                    reader.readAsDataURL(file);
                }
            };

            const focusCatalogItem = useCallback((rowLike, { replaceHistory = false } = {}) => {
                const rawItemId = String(rowLike?.itemId || rowLike?.id || '').trim();
                const itemId = rawItemId.includes(':') ? rawItemId.split(':')[0] : rawItemId;
                if (!itemId) return;
                const targetParishId = isParentsProject ? normalizeParentsParishId(rowLike?.parishId || rowLike?.parish_id || '') : '';
                const catalogItem = catalog.find(entry => entry.id === itemId) || null;
                const rawRowYear = rowLike?.year;
                const normalizedRowYear = (
                    rawRowYear !== null
                    && rawRowYear !== undefined
                    && String(rawRowYear).trim() !== ''
                    && Number.isInteger(Number(rawRowYear))
                ) ? String(rawRowYear).trim() : '';
                const itemYears = catalogItem ? getCatalogTimelineYears(catalogItem, curPid) : [];
                const targetYearFilter = normalizedRowYear || itemYears[0] || '0';

                pendingCatalogFocusRef.current = itemId;
                if (targetParishId && targetParishId !== effectiveParishId) {
                    setActiveParishId(targetParishId);
                }
                setWorkspacePage('catalog');
                setSearch('');
                setShowFavs(false);
                setTagFilter(null);
                setYearFilter(targetYearFilter || '0');
                setCatalogPage(1);
                setSelId(itemId);

                const nextUrl = `${BASE_PATH}/${curPid}/${itemId}`;
                if (replaceHistory) {
                    window.history.replaceState({}, '', nextUrl);
                } else {
                    window.history.pushState({}, '', nextUrl);
                }
            }, [catalog, curPid, effectiveParishId, isParentsProject]);

            const openCatalogOverlay = useCallback((rowLike) => {
                const rawItemId = String(rowLike?.itemId || rowLike?.id || '').trim();
                const itemId = rawItemId.includes(':') ? rawItemId.split(':')[0] : rawItemId;
                if (!itemId) return;
                const targetParishId = isParentsProject ? normalizeParentsParishId(rowLike?.parishId || rowLike?.parish_id || '') : '';
                const catalogItem = catalog.find(entry => entry.id === itemId) || null;
                const itemUrl = String(rowLike?.itemUrl || rowLike?.url || catalogItem?.url || '').trim();
                const title = String(
                    rowLike?.label
                    || rowLike?.personLabel
                    || rowLike?.childName
                    || rowLike?.name
                    || getCatalogItemDocumentCipher(catalogItem)
                    || 'Запись каталога'
                ).trim();
                const params = new URLSearchParams();
                params.set('catalog_overlay', '1');
                if (targetParishId) {
                    params.set('parish_id', targetParishId);
                }
                // Auto-scroll внутри overlay: пробрасываем entryId/entryIndex,
                // ImageViewer прочитает на mount и прокрутит к нужной записи.
                const rawEntryId = String(rowLike?.entryId || '').trim();
                if (rawEntryId) {
                    params.set('scroll_to_entry', rawEntryId);
                }
                const rawEntryIndex = Number(rowLike?.entryIndex);
                if (Number.isInteger(rawEntryIndex) && rawEntryIndex >= 0) {
                    params.set('scroll_to_entry_index', String(rawEntryIndex));
                }
                const nextSrc = `${BASE_PATH}/${curPid}/${itemId}?${params.toString()}`;
                if (catalogOverlayCloseTimeoutRef.current) {
                    clearTimeout(catalogOverlayCloseTimeoutRef.current);
                    catalogOverlayCloseTimeoutRef.current = null;
                }
                const overlayItem = catalogItem ? { ...catalogItem } : (itemUrl ? {
                    id: itemId,
                    url: itemUrl,
                    owner_id: project?.owner_id || '',
                    parish_id: targetParishId || effectiveParishId || '',
                    snippet: '',
                    text: '',
                    highlights: [],
                    highlight_fragments: [],
                    deleted_highlight_fragments: [],
                    highlight_mode: '',
                } : null);
                setCatalogOverlayLoading(!overlayItem);
                setCatalogOverlayState({
                    mounted: true,
                    open: false,
                    src: nextSrc,
                    itemId,
                    item: overlayItem,
                    title,
                    sourcePage: workspacePage,
                    parishId: targetParishId || effectiveParishId,
                    // R-UI: автоскролл к выбранной entry в правой панели.
                    // Когда item найден локально, ImageViewer рендерится в текущей
                    // вкладке — параметры из URL не сработают, нужно прокинуть пропами.
                    scrollToEntry: rawEntryId || '',
                    scrollToEntryIndex: Number.isInteger(rawEntryIndex) && rawEntryIndex >= 0 ? rawEntryIndex : -1,
                });
                window.requestAnimationFrame(() => {
                    setCatalogOverlayState(prev => (
                        prev.mounted && prev.src === nextSrc ? { ...prev, open: true } : prev
                    ));
                });
            }, [BASE_PATH, catalog, curPid, effectiveParishId, isParentsProject, workspacePage]);

            const buildParentsEditorTargetFromRow = useCallback((row, options = {}) => {
                const rawRowId = String(row?.id || '').trim();
                const itemId = String(row?.itemId || '').trim() || (rawRowId.includes(':') ? rawRowId.split(':')[0] : '');
                const entryId = String(row?.entryId || '').trim();
                const parsedEntryIndex = Number(row?.entryIndex);
                const hasValidEntryIndex = Number.isInteger(parsedEntryIndex) && parsedEntryIndex >= 0;
                if (!itemId || (!entryId && !hasValidEntryIndex)) return null;
                const preferredStatuses = [];
                const appendStatus = (value) => {
                    const cleaned = String(value || '').trim().toUpperCase();
                    if (cleaned && !preferredStatuses.includes(cleaned)) {
                        preferredStatuses.push(cleaned);
                    }
                };
                const appendStatuses = (values) => {
                    (Array.isArray(values) ? values : [values]).forEach(appendStatus);
                };
                const statsField = String(options?.field || '').trim().toLowerCase();
                if (statsField === 'name' || statsField === 'surname') appendStatus('BORN');
                if (statsField === 'groom_governorate' || statsField === 'groom_age') appendStatus('GROOM');
                if (statsField === 'bride_governorate' || statsField === 'bride_age') appendStatus('BRIDE');
                if (statsField === 'death_age' || statsField === 'death_cause' || statsField === 'death_cause_age') appendStatus('DECEASED');
                if (statsField === 'spouse_age_gap') appendStatuses(['GROOM', 'BRIDE']);

                appendStatuses(options?.preferredStatuses || []);
                appendStatus(options?.preferredStatus || '');

                const eventType = String(row?.eventType || '').trim().toUpperCase();
                if (!preferredStatuses.length) {
                    if (eventType === 'BIRTH') appendStatus('BORN');
                    if (eventType === 'WEDDING') appendStatus('GROOM');
                    if (eventType === 'DEATH') appendStatus('DECEASED');
                }

                return {
                    itemId,
                    itemUrl: row.itemUrl,
                    parishId: normalizeParentsParishId(row?.parishId || row?.parish_id || effectiveParishId),
                    entryId,
                    entryIndex: hasValidEntryIndex ? parsedEntryIndex : null,
                    eventType,
                    preferredStatuses,
                    deathCause: row?.deathCause || '',
                    personLabel: cleanStructuredValue(row?.label || row?.personLabel || row?.childLabel || row?.name || options?.label || ''),
                    matchField: cleanStructuredValue(options?.field || ''),
                    matchGroupKey: cleanStructuredValue(options?.groupKey || ''),
                    matchLabel: cleanStructuredValue(options?.label || '')
                };
            }, [effectiveParishId]);

            const openParentsDashboardRow = useCallback((row) => {
                if (!row?.itemId) return;
                openCatalogOverlay(row);
            }, [openCatalogOverlay]);

            const handleCatalogOverlayFrameLoad = useCallback(() => {
                setCatalogOverlayLoading(false);
            }, []);

            const catalogOverlaySourceLabel = useMemo(() => {
                if (catalogOverlayState.sourcePage === 'dashboard') return 'Дашборда';
                if (catalogOverlayState.sourcePage === 'chains') return 'Связей';
                if (catalogOverlayState.sourcePage === 'stats') return 'Статистики';
                if (catalogOverlayState.sourcePage === 'summary_table') return 'Общей таблицы';
                return 'служебного раздела';
            }, [catalogOverlayState.sourcePage]);

            const openParentsEditorRow = useCallback((row, options = {}) => {
                const target = buildParentsEditorTargetFromRow(row, options);
                if (!target) {
                    showToast('Не удалось открыть редактор для этой строки', 'warning');
                    return;
                }
                if (target.parishId && target.parishId !== effectiveParishId) {
                    setActiveParishId(target.parishId);
                }
                setParentsEditorTarget(target);
            }, [buildParentsEditorTargetFromRow, effectiveParishId]);

            const finalizeImportedItem = useCallback((item) => {
                if (!item?.id) return;
                setNewlyAddedId(item.id);
                setTimeout(() => scrollToCard(item.id), 500);
                setTimeout(() => {
                    setNewlyAddedId(null);
                    setSelId(item.id);
                    if (window.innerWidth <= 768) {
                        window.history.pushState({}, '', `${BASE_PATH}/${curPid}/${item.id}`);
                    }
                }, 3000);
            }, [curPid, scrollToCard]);

            const handleSingleImport = useCallback(async (rawUrl) => {
                const url = String(rawUrl || '').trim();
                if (!url) return;
                try {
                    const response = await fetch(`${API_BASE}/add`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({ url, pid: curPid, parish_id: effectiveParishId })
                    });
                    const data = await response.json();
                    if (!response.ok || data.error) {
                        showToast(data?.error || 'Не удалось добавить документ', 'error');
                        return;
                    }
                    setImportUrl('');
                    showToast('Документ добавлен!', 'success');
                    setSummaryRowsData(null);
                    refreshData();
                    finalizeImportedItem(data);
                } catch (error) {
                    showToast('Не удалось добавить документ', 'error');
                }
            }, [curPid, effectiveParishId, finalizeImportedItem, refreshData]);

            const loadBatchImportPreview = useCallback(async (rawUrl, { openModal = false } = {}) => {
                const url = String(rawUrl || '').trim();
                if (!url) {
                    showToast('Вставьте ссылку на каталог', 'warning');
                    return null;
                }
                if (openModal) {
                    setModalType('batch_import');
                    setIsModalOpen(true);
                }
                setBatchPreviewLoading(true);
                setBatchImportResult(null);
                setBatchImportProgress(null);
                try {
                    const response = await fetch(`${API_BASE}/add_batch_preview`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({ url, pid: curPid, parish_id: effectiveParishId })
                    });
                    const data = await response.json();
                    if (!response.ok || data.error) {
                        showToast(data?.error || 'Не удалось подготовить пакетный импорт', 'error');
                        setBatchImportPreview(null);
                        return null;
                    }
                    setBatchImportPreview(data);
                    setBatchImportRange({
                        from: data.first_page ? String(data.first_page) : '',
                        to: data.last_page ? String(data.last_page) : ''
                    });
                    if (data.detected_year) {
                        setBatchImportManualYear(String(data.detected_year));
                    } else if (data.detected_year_start) {
                        setBatchImportManualYear(String(data.detected_year_start));
                    } else {
                        setBatchImportManualYear('');
                    }
                    setImportUrl(data.base_url || url);
                    return data;
                } catch (error) {
                    showToast('Не удалось подготовить пакетный импорт', 'error');
                    setBatchImportPreview(null);
                    return null;
                } finally {
                    setBatchPreviewLoading(false);
                }
            }, [curPid, effectiveParishId]);

            const parsedBatchRange = useMemo(() => {
                const parsePage = (value) => {
                    const num = parseInt(String(value || '').trim(), 10);
                    return Number.isFinite(num) && num > 0 ? num : null;
                };
                let from = parsePage(batchImportRange.from);
                let to = parsePage(batchImportRange.to);
                if (from && to && from > to) {
                    [from, to] = [to, from];
                }
                return { from, to };
            }, [batchImportRange]);

            const visibleBatchPages = useMemo(() => {
                const pages = batchImportPreview?.pages || [];
                const { from, to } = parsedBatchRange;
                return pages.filter(page => {
                    if (from && page.page < from) return false;
                    if (to && page.page > to) return false;
                    return true;
                });
            }, [batchImportPreview, parsedBatchRange]);

            const visibleBatchMissingPages = useMemo(() => (
                visibleBatchPages.filter(page => !page.imported)
            ), [visibleBatchPages]);

            const batchImportProgressMetrics = useMemo(() => {
                const total = Number(batchImportProgress?.total_count || 0);
                const processed = Number(batchImportProgress?.processed_count || 0);
                const remaining = Number(batchImportProgress?.remaining_count || Math.max(total - processed, 0));
                const percent = total > 0 ? Math.max(0, Math.min(100, Math.round((processed / total) * 100))) : 0;
                return { total, processed, remaining, percent };
            }, [batchImportProgress]);

            const finalizeBatchImportJob = useCallback(async (jobData, baseUrl) => {
                setBatchImportResult({
                    added_count: jobData.added_count || 0,
                    added_items: jobData.added_items || [],
                    skipped_existing_count: jobData.skipped_existing_count || 0,
                    skipped_existing: jobData.skipped_existing || [],
                    error_count: jobData.error_count || 0,
                    errors: jobData.errors || []
                });

                if ((jobData.added_count || 0) > 0) {
                    showToast(`Добавлено страниц: ${jobData.added_count}`, 'success');
                    setSummaryRowsData(null);
                    refreshData();
                    const lastItem = jobData.added_items?.[jobData.added_items.length - 1];
                    if (lastItem?.id) {
                        finalizeImportedItem(lastItem);
                    }
                } else if ((jobData.skipped_existing_count || 0) > 0 && (jobData.error_count || 0) === 0) {
                    showToast('Все страницы из диапазона уже импортированы', 'info');
                } else if ((jobData.error_count || 0) > 0 && (jobData.added_count || 0) === 0) {
                    showToast('Часть страниц не удалось импортировать', 'warning');
                }

                await loadBatchImportPreview(baseUrl || batchImportPreview?.base_url || '');
            }, [batchImportPreview, finalizeImportedItem, loadBatchImportPreview, refreshData]);

            const pollBatchImportJob = useCallback(async (jobId, baseUrl) => {
                try {
                    const response = await fetch(`${API_BASE}/add_batch_status?job_id=${encodeURIComponent(jobId)}`);
                    const data = await response.json();
                    if (!response.ok || data.error) {
                        showToast(data?.error || 'Не удалось получить статус пакетного импорта', 'error');
                        setBatchImportLoading(false);
                        return;
                    }
                    setBatchImportProgress(data);
                    if (data.status === 'completed') {
                        setBatchImportLoading(false);
                        await finalizeBatchImportJob(data, baseUrl);
                        return;
                    }
                    if (data.status === 'failed') {
                        setBatchImportLoading(false);
                        setBatchImportResult({
                            added_count: data.added_count || 0,
                            added_items: data.added_items || [],
                            skipped_existing_count: data.skipped_existing_count || 0,
                            skipped_existing: data.skipped_existing || [],
                            error_count: data.error_count || 0,
                            errors: data.errors || []
                        });
                        showToast('Пакетный импорт завершился с ошибкой', 'error');
                        await loadBatchImportPreview(baseUrl || batchImportPreview?.base_url || '');
                        return;
                    }
                    batchImportPollTimeoutRef.current = setTimeout(() => {
                        pollBatchImportJob(jobId, baseUrl);
                    }, 900);
                } catch (error) {
                    setBatchImportLoading(false);
                    showToast('Не удалось получить статус пакетного импорта', 'error');
                }
            }, [batchImportPreview, finalizeBatchImportJob, loadBatchImportPreview]);

            const runBatchImport = useCallback(async () => {
                if (!batchImportPreview?.base_url) {
                    showToast('Сначала подготовьте пакет страниц', 'warning');
                    return;
                }
                setBatchImportLoading(true);
                setBatchImportResult(null);
                setBatchImportProgress(null);
                try {
                    const yearRangesPayload = batchImportYearRanges
                        .map(r => ({
                            from: parseInt(String(r.from || '').trim(), 10),
                            to: parseInt(String(r.to || '').trim(), 10),
                            year: parseInt(String(r.year || '').trim(), 10),
                        }))
                        .filter(r => Number.isFinite(r.from) && Number.isFinite(r.to) && Number.isFinite(r.year) && r.from > 0 && r.to > 0 && r.year > 0);
                    const manualYearParsed = parseInt(String(batchImportManualYear || '').trim(), 10);
                    const manualYearPayload = Number.isFinite(manualYearParsed) && manualYearParsed > 0 ? manualYearParsed : null;
                    const response = await fetch(`${API_BASE}/add_batch_start`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({
                            pid: curPid,
                            parish_id: effectiveParishId,
                            url: batchImportPreview.base_url,
                            page_from: parsedBatchRange.from,
                            page_to: parsedBatchRange.to,
                            year_ranges: yearRangesPayload,
                            manual_year: manualYearPayload,
                        })
                    });
                    const data = await response.json();
                    if (!response.ok || data.error) {
                        showToast(data?.error || 'Не удалось выполнить пакетный импорт', 'error');
                        setBatchImportLoading(false);
                        return;
                    }
                    setBatchImportProgress(data);
                    if (data.status === 'completed') {
                        setBatchImportLoading(false);
                        await finalizeBatchImportJob(data, batchImportPreview.base_url);
                        return;
                    }
                    if (batchImportPollTimeoutRef.current) {
                        clearTimeout(batchImportPollTimeoutRef.current);
                    }
                    batchImportPollTimeoutRef.current = setTimeout(() => {
                        pollBatchImportJob(data.job_id, batchImportPreview.base_url);
                    }, 500);
                } catch (error) {
                    showToast('Не удалось выполнить пакетный импорт', 'error');
                    setBatchImportLoading(false);
                }
            }, [batchImportPreview, batchImportYearRanges, batchImportManualYear, curPid, effectiveParishId, finalizeBatchImportJob, parsedBatchRange, pollBatchImportJob]);

            return (
                <div className="flex h-screen w-screen flex-col overflow-hidden">
                    {workspaceStatus && catalog.length === 0 && (
                        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[#fdfbf7]">
                            <div className="text-center px-6">
                                <div className="loader-paper mx-auto"></div>
                                <div className="mt-5 text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">{workspaceStatus.title}</div>
                                <div className="mt-2 text-xs text-stone-500">{workspaceStatus.detail}</div>
                            </div>
                        </div>
                    )}
                    {showServiceTabs && (
                        <div className="relative z-[70] shrink-0 border-b border-stone-300 bg-[#fbf7ef]/95 backdrop-blur-sm">
                            <div className="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 px-4 py-3 sm:px-6 lg:grid-cols-[minmax(180px,1fr)_auto_minmax(120px,1fr)] lg:gap-4">
                                {serviceMode === 'parents' ? (
                                    <div className="parents-parish-menu relative min-w-0 justify-self-start">
                                        <button
                                            type="button"
                                            aria-haspopup="listbox"
                                            aria-expanded={isParishMenuOpen}
                                            onClick={() => setIsParishMenuOpen(open => !open)}
                                            className={`group flex max-w-full items-center gap-2.5 rounded-xl border bg-white px-3 py-2 text-left shadow-sm transition-all ${isParishMenuOpen ? 'border-[#8b0000] ring-2 ring-[#8b0000]/10' : 'border-stone-300 hover:border-[#b89788] hover:bg-[#fffdf9]'}`}
                                            title="Выбрать другой приход"
                                        >
                                            <span className="shrink-0 text-[#8b0000]"><IconMenu /></span>
                                            <span className="min-w-0">
                                                <span className="block text-[9px] font-bold uppercase tracking-[0.18em] text-stone-400">Приход</span>
                                                <span className="block truncate text-[12px] font-bold text-stone-800">{activeParish?.title || 'Выберите приход'}</span>
                                            </span>
                                            <span className={`ml-auto shrink-0 text-[9px] text-stone-400 transition-transform ${isParishMenuOpen ? 'rotate-180' : ''}`}>▼</span>
                                        </button>
                                        {isParishMenuOpen && (
                                            <div className="absolute left-0 top-full z-[80] mt-2 w-[min(360px,calc(100vw-2rem))] overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-[0_22px_60px_rgba(48,36,24,0.2)]" role="listbox" aria-label="Приходы">
                                                <div className="border-b border-stone-200 bg-[#faf6ee] px-4 py-3">
                                                    <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Перейти в другой приход</div>
                                                    <div className="mt-1 text-[11px] text-stone-500">Текущий раздел останется открытым.</div>
                                                </div>
                                                <div className="max-h-[min(420px,65vh)] overflow-y-auto p-1.5">
                                                    {projectParishes.map(parish => {
                                                        const isActive = parish.id === effectiveParishId;
                                                        return (
                                                            <button
                                                                key={parish.id}
                                                                type="button"
                                                                role="option"
                                                                aria-selected={isActive}
                                                                onClick={() => selectParentsParish(parish.id)}
                                                                className={`flex w-full items-start gap-3 rounded-xl px-3 py-3 text-left transition-colors ${isActive ? 'bg-[#f7ebe5] text-[#8b0000]' : 'text-stone-700 hover:bg-stone-50 hover:text-[#8b0000]'}`}
                                                            >
                                                                <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border text-[10px] font-black ${isActive ? 'border-[#8b0000] bg-[#8b0000] text-white' : 'border-stone-300 bg-white text-transparent'}`}>✓</span>
                                                                <span className="min-w-0 flex-1">
                                                                    <span className="block text-[13px] font-bold leading-5">{parish.title}</span>
                                                                    {parish.subtitle && <span className="mt-0.5 block line-clamp-2 text-[11px] leading-4 text-stone-500">{parish.subtitle}</span>}
                                                                </span>
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="min-w-0">
                                        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400 truncate">
                                            {project.title || curPid || 'Проект'}
                                        </div>
                                        <div className="mt-1 text-[11px] text-stone-500 truncate">
                                            {workspacePage === 'catalog' ? 'Основной каталог проекта' : 'Служебная страница проекта'}
                                        </div>
                                    </div>
                                )}
                                <div className="order-3 col-span-2 flex max-w-full justify-self-stretch overflow-x-auto rounded-full border border-stone-300 bg-white p-1 shadow-sm lg:order-2 lg:col-span-1 lg:inline-flex lg:justify-self-center">
                                    <button
                                        onClick={() => { setWorkspacePage('catalog'); setMobileSheetOpen(false); }}
                                        className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${workspacePage === 'catalog' ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:text-[#8b0000]'}`}
                                    >
                                        Каталог
                                    </button>
                                    {serviceMode === 'mospriyut' ? (
                                        <>
                                            <button
                                                onClick={() => { setWorkspacePage('summary_table'); setMobileSheetOpen(false); }}
                                                className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${workspacePage === 'summary_table' ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:text-[#8b0000]'}`}
                                            >
                                                Общая таблица
                                            </button>
                                            <button
                                                onClick={() => { setWorkspacePage('stats'); setMobileSheetOpen(false); }}
                                                className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${workspacePage === 'stats' ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:text-[#8b0000]'}`}
                                            >
                                                Статистика
                                            </button>
                                        </>
                                    ) : serviceMode === 'parents' ? (
                                        <>
                                            <button
                                                onClick={() => { setWorkspacePage('dashboard'); setMobileSheetOpen(false); }}
                                                className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${workspacePage === 'dashboard' ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:text-[#8b0000]'}`}
                                            >
                                                Дашборд
                                            </button>
                                            <button
                                                onClick={() => { setWorkspacePage('chains'); setMobileSheetOpen(false); }}
                                                className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${workspacePage === 'chains' ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:text-[#8b0000]'}`}
                                            >
                                                Связи
                                            </button>
                                            <button
                                                onClick={() => { setWorkspacePage('stats'); setMobileSheetOpen(false); }}
                                                className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${workspacePage === 'stats' ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:text-[#8b0000]'}`}
                                            >
                                                Статистика
                                            </button>
                                            <button
                                                onClick={() => { setWorkspacePage('ocr'); setMobileSheetOpen(false); }}
                                                className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${workspacePage === 'ocr' ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:text-[#8b0000]'}`}
                                            >
                                                Проверка OCR
                                            </button>
                                            <button
                                                onClick={() => { setWorkspacePage('logic'); setMobileSheetOpen(false); }}
                                                className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${workspacePage === 'logic' ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:text-[#8b0000]'}`}
                                            >
                                                Проверка логики
                                            </button>
                                            <button
                                                onClick={() => { setWorkspacePage('audit'); setMobileSheetOpen(false); }}
                                                className={`rounded-full px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] transition-colors ${workspacePage === 'audit' ? 'bg-[#8b0000] text-white shadow-sm' : 'text-stone-500 hover:text-[#8b0000]'}`}
                                            >
                                                Аудит данных
                                            </button>
                                        </>
                                    ) : null}
                                </div>
                                <div className="order-2 justify-self-end text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400 lg:order-3">
                                    {serviceMode === 'mospriyut'
                                        ? (workspacePage === 'summary_table' ? `${filteredSummaryTableRows.length} строк` : workspacePage === 'stats' ? 'статистика проекта' : '')
                                        : serviceMode === 'parents'
                                            ? (workspacePage === 'dashboard' ? 'дашборд событий' : workspacePage === 'chains' ? 'древо предков' : workspacePage === 'stats' ? 'статистика прихода' : workspacePage === 'ocr' ? 'ручная проверка OCR' : workspacePage === 'logic' ? 'логические противоречия' : workspacePage === 'audit' ? 'экспорт для визуальной проверки' : '')
                                            : ''}
                                </div>
                            </div>
                        </div>
                    )}

                    {workspacePage === 'summary_table' ? (
                        servicePageNeedsSummaryRows && (summaryRowsLoading || !Array.isArray(summaryRowsData)) ? (
                            <div className="flex-1 min-h-0 overflow-hidden bg-[#e8e4dc] bg-texture">
                                <div className="h-full flex items-center justify-center px-6">
                                    <div className="max-w-md rounded-[28px] border border-stone-300 bg-white/95 px-8 py-10 text-center shadow-[0_18px_55px_rgba(45,34,20,0.1)]">
                                        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Готовим полные данные проекта</div>
                                        <div className="mt-3 text-sm text-stone-500">Загружаем строки и поля для общей таблицы.</div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                        <SummaryTableView
                            project={project}
                            rows={paginatedSummaryTableRows}
                            allRows={filteredSummaryTableRows}
                            currentPage={summaryTablePage}
                            totalPages={summaryTablePageCount}
                            onPageChange={(nextPage) => setSummaryTablePage(Math.min(Math.max(nextPage, 1), summaryTablePageCount))}
                            canEdit={canEditCurrentProject}
                            onEditRow={(row) => {
                                if (!canEditCurrentProject) return;
                                setSummaryEditorTarget({ itemId: row.itemId, fragmentIndex: row.fragmentIndex });
                            }}
                            searchQuery={summaryTableSearch}
                            onSearchChange={setSummaryTableSearch}
                        />
                        )
                    ) : serviceMode === 'mospriyut' && workspacePage === 'stats' ? (
                        servicePageNeedsSummaryRows && (summaryRowsLoading || !Array.isArray(summaryRowsData)) ? (
                            <div className="flex-1 min-h-0 overflow-hidden bg-[#e8e4dc] bg-texture">
                                <div className="h-full flex items-center justify-center px-6">
                                    <div className="max-w-md rounded-[28px] border border-stone-300 bg-white/95 px-8 py-10 text-center shadow-[0_18px_55px_rgba(45,34,20,0.1)]">
                                        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Готовим полные данные проекта</div>
                                        <div className="mt-3 text-sm text-stone-500">Собираем строки для статистики и сводных графиков.</div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                        <StatisticsView
                            project={project}
                            rows={summaryTableRows}
                            canEdit={canEditCurrentProject}
                            onEditRow={(row) => {
                                if (!canEditCurrentProject) return;
                                setSummaryEditorTarget({ itemId: row.itemId, fragmentIndex: row.fragmentIndex });
                            }}
                        />
                        )
                    ) : workspacePage === 'dashboard' ? (
                        <ParentsDashboardView
                            project={project}
                            projectId={curPid}
                            parish={activeParish}
                            parishId={effectiveParishId}
                            onOpenRow={openParentsDashboardRow}
                            onEditRow={openParentsEditorRow}
                            canEdit={canEditCurrentProject}
                            dataVersion={parentsDataVersion}
                            refreshToken={parentsRefreshState.token}
                        />
                    ) : workspacePage === 'chains' ? (
                        <ParentsAncestryView
                            project={project}
                            projectId={curPid}
                            parish={activeParish}
                            parishId={effectiveParishId}
                            onOpenRow={openParentsDashboardRow}
                            selectedRecordId={selectedFamilyRecordId}
                            onSelectedRecordChange={setSelectedFamilyRecordId}
                        />
                    ) : workspacePage === 'stats' ? (
                        <ParentsStatsView
                            project={project}
                            projectId={curPid}
                            parish={activeParish}
                            parishId={effectiveParishId}
                            onOpenRow={openParentsDashboardRow}
                            onEditRow={openParentsEditorRow}
                            canEdit={canEditCurrentProject}
                            dataVersion={parentsDataVersion}
                            refreshState={parentsRefreshState}
                        />
                    ) : workspacePage === 'ocr' ? (
                        <ParentsOcrReviewView
                            project={project}
                            projectId={curPid}
                            parish={activeParish}
                            parishId={effectiveParishId}
                            onOpenRow={openParentsDashboardRow}
                            onEditRow={openParentsEditorRow}
                            onItemUpdate={updateCatalogItem}
                            canEdit={canEditCurrentProject}
                            dataVersion={parentsDataVersion}
                        />
                    ) : workspacePage === 'logic' ? (
                        <ParentsOcrReviewView
                            project={project}
                            projectId={curPid}
                            parish={activeParish}
                            parishId={effectiveParishId}
                            reviewKind="logic"
                            canEdit={canEditCurrentProject}
                            onOpenRow={openParentsDashboardRow}
                            onEditRow={openParentsEditorRow}
                            onItemUpdate={updateCatalogItem}
                            dataVersion={parentsDataVersion}
                        />
                    ) : workspacePage === 'audit' ? (
                        <ParentsDataAuditView
                            projectId={curPid}
                            parish={activeParish}
                            parishId={effectiveParishId}
                            canEdit={canEditCurrentProject}
                            dataVersion={parentsDataVersion}
                        />
                    ) : (
                    <div className="flex flex-1 min-h-0 overflow-hidden">
                    {/* Sidebar */}
                    <div className="w-[420px] sidebar-mobile bg-[#fdfbf7] border-r border-stone-300 flex flex-col shadow-2xl z-30">
                        {/* Компактный объединённый хедер */}
                        <div className="bg-white border-b-[3px] border-double border-stone-800 shrink-0">
                            {/* Верхняя строка: пользователь + меню */}
                            <div className="flex items-center justify-between px-4 py-2 bg-stone-50 border-b border-stone-200">
                                <div className="flex items-center gap-2">
                                    <button onClick={() => { onBack(); window.history.pushState({}, '', '/'); }} className="p-1.5 text-stone-400 hover:text-stone-800 transition-colors rounded hover:bg-stone-200" title="На главную"><IconHome /></button>
                                    {user ? (
                                        <div className="flex items-center gap-2">
                                            {user.photo_url ? (
                                                <img src={user.photo_url} className="w-6 h-6 rounded-full border border-stone-300" />
                                            ) : (
                                                <div className="w-6 h-6 rounded-full bg-stone-300 flex items-center justify-center text-[9px] font-bold">{user.first_name[0]}</div>
                                            )}
                                            <span className="text-[11px] font-medium text-stone-600">{user.first_name}</span>
                                        </div>
                                    ) : (
                                        <div id="workspace-tg-login" className="scale-75 origin-left">
                                            
                                            
                                        </div>
                                    )}
                                </div>
                                <div className="flex items-center gap-1">
                                    {user && <a href={`${API_BASE}/logout`} className="text-[9px] text-stone-400 hover:text-[#8b0000] px-2">Выйти</a>}
                                    {user && (
                                        <div className="relative">
                                            <button 
                                                onClick={() => setIsProjectMenuOpen(!isProjectMenuOpen)} 
                                                className="project-menu-btn flex items-center gap-2 rounded-md border border-stone-200 bg-white px-2.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000] hover:bg-[#fdf8f8] transition-colors"
                                            >
                                                <IconMenu />
                                                <span>Проекты</span>
                                            </button>
                                            {isProjectMenuOpen && (
                                                <div className="project-menu absolute right-0 top-full mt-2 w-80 bg-white border border-stone-200 rounded-lg shadow-xl z-50 overflow-hidden">
                                                    <div className="max-h-72 overflow-y-auto">
                                                        {projects.map(p => {
                                                            const coverSrc = getProjectCoverSrc(p);
                                                            return (
                                                                <div 
                                                                    key={p.id} 
                                                                    onClick={() => { navigateToProject(p.id); setIsProjectMenuOpen(false); }}
                                                                    className={`px-4 py-3 cursor-pointer flex items-center gap-3 hover:bg-stone-50 transition-colors border-b border-stone-100 last:border-b-0 ${p.id === curPid ? 'bg-[#fdf8f8] border-l-2 border-l-[#8b0000]' : ''}`}
                                                                >
                                                                    <div className="w-12 h-14 rounded-md overflow-hidden bg-stone-200 shrink-0 shadow-sm">
                                                                        {coverSrc ? (
                                                                            <img src={coverSrc} className="w-full h-full object-cover" />
                                                                        ) : (
                                                                            <div className="w-full h-full flex items-center justify-center bg-stone-300 text-stone-700 text-xs font-black uppercase">
                                                                                {(p.title || p.id || '?').slice(0, 1)}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="flex-1 min-w-0">
                                                                        <div className={`font-bold text-sm truncate ${p.id === curPid ? 'text-[#8b0000]' : 'text-stone-800'}`}>{p.title}</div>
                                                                        <div className="text-[10px] text-stone-400 truncate">{p.subtitle || p.id}</div>
                                                                    </div>
                                                                    {p.id === curPid && <span className="text-[#8b0000] text-xs ml-2">✓</span>}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="border-t border-stone-200 p-2 bg-stone-50">
                                                        <button 
                                                            onClick={() => { setIsProjectMenuOpen(false); setModalType('projects'); setIsModalOpen(true); }}
                                                            className="w-full py-2 px-3 text-[11px] font-bold uppercase tracking-wide text-stone-600 hover:text-[#8b0000] hover:bg-white rounded transition-colors flex items-center justify-center gap-2"
                                                        >
                                                            <span>⚙</span>
                                                            <span>Управление проектами</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* Название проекта */}
                            <div className="px-4 py-2">
                                {projects.length === 0 ? (
                                    <div>
                                        <h1 className="text-lg font-display font-black uppercase text-stone-900 leading-tight">Добро пожаловать!</h1>
                                        <div className="text-[10px] font-display italic text-stone-500 mt-1">Создайте первую коллекцию и наполните ее архивными выпусками.</div>
                                    </div>
                                ) : (
                                    <div>
                                        <h1 className="text-lg font-display font-black uppercase text-stone-900 leading-tight line-clamp-2" style={{wordBreak: 'break-word'}}>
                                            {project.title || 'Выберите проект'}
                                        </h1>
                                        {project.subtitle && <div className="text-[10px] font-display italic text-stone-500 mt-1 truncate">{project.subtitle}</div>}
                                    </div>
                                )}
                            </div>
                            {isParentsProject && activeParish && (
                                <div className="px-4 pb-3">
                                    <div className="rounded-2xl border border-stone-200 bg-[#faf6ee] px-3 py-3 shadow-sm">
                                        <div className="flex items-start gap-2">
                                            <div className="min-w-0 flex-1">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Каталог прихода</div>
                                                <div className="mt-2 flex items-center gap-2">
                                                    <select
                                                        value={effectiveParishId}
                                                        onChange={e => setActiveParishId(e.target.value)}
                                                        className="min-w-0 flex-1 rounded-xl border border-stone-300 bg-white px-3 py-2 text-[12px] font-semibold text-stone-700 outline-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                                    >
                                                        {projectParishes.map(parish => (
                                                            <option key={parish.id} value={parish.id}>{parish.title}</option>
                                                        ))}
                                                    </select>
                                                    {canEditCurrentProject && (
                                                        <button
                                                            onClick={() => {
                                                                setNewParish({ title: '', subtitle: '' });
                                                                setModalType('parish_create');
                                                                setIsModalOpen(true);
                                                            }}
                                                            className="shrink-0 rounded-xl border border-[#d9c0b4] bg-white px-3 py-2 text-[10px] font-bold uppercase tracking-[0.14em] text-[#8b0000] transition-colors hover:bg-[#fff5f1]"
                                                        >
                                                            + Приход
                                                        </button>
                                                    )}
                                                </div>
                                                {activeParish.subtitle && (
                                                    <div className="mt-2 text-[11px] leading-4 text-stone-500">
                                                        {activeParish.subtitle}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {workspaceStatus && (
                                <div className="px-4 pb-3">
                                    <div className="rounded-2xl border border-stone-200 bg-[#faf5ed] px-4 py-3 flex items-center gap-3 shadow-sm">
                                        <div className="shrink-0 scale-[0.72] origin-left">
                                            <div className="loader-paper"></div>
                                        </div>
                                        <div className="min-w-0">
                                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">{workspaceStatus.title}</div>
                                            <div className="mt-1 text-xs text-stone-500">{workspaceStatus.detail}</div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            
                            {/* Поиск и фильтры */}
                            <div className="px-4 pb-3 flex gap-2 items-center border-b border-stone-200 relative">
                                <input type="text" placeholder="Поиск..." className="bg-transparent flex-1 outline-none text-sm py-1 font-serif" value={search} onChange={e => setSearch(e.target.value)} />
                                <div className="relative">
                                    <button
                                        onClick={() => setIsYearOpen(!isYearOpen)}
                                        className={`text-[11px] font-bold font-display flex items-center gap-1 uppercase transition-colors ${yearFilter !== '0' ? 'rounded-full border border-[#e2b9ac] bg-[#fff4ee] px-2.5 py-1 text-[#8b0000] hover:bg-[#ffe9df]' : 'text-[#8b0000] hover:text-red-700'}`}
                                    >
                                        {formatDateFilterLabel(yearFilter, catalog.length)}
                                        <span className={`text-[8px] transition-transform ${isYearOpen ? 'rotate-180' : ''}`}>▼</span>
                                    </button>
                                    {isYearOpen && (
                                        <div className="absolute right-0 top-full mt-2 w-48 bg-white border border-stone-200 shadow-xl z-50 max-h-60 overflow-y-auto">
                                            <div
                                                onClick={() => {setYearFilter('0'); setIsYearOpen(false);}}
                                                className={`p-3 text-[11px] font-bold cursor-pointer uppercase border-b border-stone-100 flex justify-between transition-colors ${yearFilter === '0' ? 'bg-[#8b0000] text-white' : 'hover:bg-[#8b0000] hover:text-white'}`}
                                            >
                                                <span>Все годы</span><span className={yearFilter === '0' ? 'opacity-80' : ''}>({catalog.length})</span>
                                            </div>
                                            {Object.entries(yearStats).sort((a, b) => Number(a[0]) - Number(b[0])).map(([y, c]) => (
                                                <div
                                                    key={y}
                                                    ref={selectedYearOnly === y ? activeYearOptionRef : null}
                                                    onClick={() => {setYearFilter(y); setIsYearOpen(false);}}
                                                    className={`p-3 text-[11px] font-bold cursor-pointer flex justify-between transition-colors ${selectedYearOnly === y ? 'bg-[#8b0000] text-white' : 'hover:bg-[#8b0000] hover:text-white'}`}
                                                >
                                                    <span>{y}</span><span className={selectedYearOnly === y ? 'opacity-80' : 'opacity-50'}>({c})</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {yearFilter !== '0' && (
                                <div className="px-4 pt-2 pb-1 border-b border-stone-100">
                                    <div className="inline-flex items-center gap-2 rounded-full border border-[#e2b9ac] bg-[#fff4ee] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-[#8b0000]">
                                        <span>Выбран год</span>
                                        <span>{formatDateFilterLabel(yearFilter, catalog.length)}</span>
                                    </div>
                                </div>
                            )}
                            
                            {/* Переключатель группировки и фильтр избранного */}
                            <div className="mt-2 flex justify-between items-center px-4 pb-2">
                                <div className="flex bg-stone-100 rounded-lg p-0.5">
                                    <button 
                                        onClick={() => setGroupMode('periodical')} 
                                        className={`px-2 py-1 text-[10px] rounded-md transition-all ${groupMode === 'periodical' ? 'bg-white shadow text-[#8b0000] font-bold' : 'text-stone-500 hover:text-stone-700'}`}
                                    >
                                        По изданиям
                                    </button>
                                    <button 
                                        onClick={() => setGroupMode('year')} 
                                        className={`px-2 py-1 text-[10px] rounded-md transition-all ${groupMode === 'year' ? 'bg-white shadow text-[#8b0000] font-bold' : 'text-stone-500 hover:text-stone-700'}`}
                                    >
                                        По годам
                                    </button>
                                </div>
                                {tagFilter && (
                                    <button onClick={() => setTagFilter(null)} className="flex items-center gap-1 text-[9px] text-[#8b0000] font-bold bg-red-50 px-2 py-1 rounded uppercase tracking-wide">
                                        <span>🏷</span>
                                        <span>{tagFilter}</span>
                                        <span className="opacity-50 hover:opacity-100 ml-1">×</span>
                                    </button>
                                )}
                                <button onClick={() => setShowFavs(!showFavs)} className={`flex items-center gap-1.5 text-[10px] transition-all ${showFavs ? 'text-[#8b0000] font-bold' : 'text-stone-400 hover:text-stone-600'}`}>
                                    <span className={`text-sm ${showFavs ? '' : 'opacity-50'}`}>♥</span>
                                    Избранное
                                </button>
                            </div>
                        </div>
                        
                        <Timeline 
                            stats={yearStats} 
                            monthStats={monthStats}
                            currentFilter={yearFilter} 
                            onYearClick={(year) => setYearFilter(yearFilter === year ? '0' : year)}
                            onMonthClick={(monthKey) => setYearFilter(yearFilter === monthKey ? monthKey.split('-')[0] : monthKey)}
                            onReset={() => setYearFilter('0')}
                            disableMonths={curPid === 'parents'}
                            centerLabel={curPid === 'parents' ? 'Точные годы событий' : 'Шкала времени'}
                        />
                        
                        {/* Catalog */}
                        <div className="flex-1 overflow-y-auto p-4 bg-texture catalog-mobile-padding">
                            {filteredCatalogItems.length > 0 && catalogPageCount > 1 && (
                                <div className="mb-4">
                                    <PaginationControls
                                        page={catalogPage}
                                        totalPages={catalogPageCount}
                                        totalItems={filteredCatalogItems.length}
                                        pageSize={CATALOG_PAGE_SIZE}
                                        label="Карточки каталога"
                                        onChange={(nextPage) => setCatalogPage(Math.min(Math.max(nextPage, 1), catalogPageCount))}
                                    />
                                </div>
                            )}
                            {Object.keys(groupedCatalog).length === 0 ? (
                                projects.length === 0 ? (
                                    /* Экран приветствия для новых пользователей */
                                    <div className="welcome-screen">
                                        <div className="welcome-title">🎉 Добро пожаловать!</div>
                                        <div className="welcome-subtitle">Начните работу с YArchiver за 2 шага</div>
                                        
                                        <div className="welcome-steps">
                                            <div className="welcome-step">
                                                <div className="welcome-step-number">1</div>
                                                <div className="welcome-step-title">Создайте коллекцию</div>
                                                <div className="welcome-step-text">
                                                    Нажмите на <strong>☰ меню</strong> справа вверху и создайте свой первый проект
                                                </div>
                                                <div className="welcome-step-arrow">→</div>
                                            </div>
                                            
                                            <div className="welcome-step">
                                                <div className="welcome-step-number">2</div>
                                                <div className="welcome-step-title">Добавляйте документы</div>
                                                <div className="welcome-step-text">
                                                    Откройте <a href="https://ya.ru/archive" target="_blank" className="text-[#8b0000] underline font-medium">ya.ru/archive</a>, найдите документ, скопируйте ссылку и вставьте в поле внизу
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <button 
                                            className="welcome-btn"
                                            onClick={() => { setModalType('projects'); setIsModalOpen(true); }}
                                        >
                                            Создать первый проект
                                        </button>
                                        
                                        {/* Подсказка на меню */}
                                        <div className="menu-hint">Или нажмите сюда ↗</div>
                                    </div>
                                ) : catalog.length === 0 ? (
                                    /* Проект есть, но пустой */
                                    <div className="empty-state">
                                        <div className="empty-state-icon">📜</div>
                                        <div className="empty-state-title">Проект пока пуст</div>
                                        <div className="empty-state-text">
                                            Добавьте первый документ из Яндекс.Архива
                                        </div>
                                        <div className="empty-state-hint">
                                            <div className="mb-2"><strong>Как добавить:</strong></div>
                                            <div>1. Откройте <a href="https://ya.ru/archive" target="_blank" className="text-[#8b0000] underline">ya.ru/archive</a></div>
                                            <div>2. Найдите нужный документ</div>
                                            <div>3. Скопируйте ссылку из браузера</div>
                                            <div>4. Вставьте в поле ниже ↓</div>
                                        </div>
                                    </div>
                                ) : (
                                    /* Ничего не найдено по фильтрам */
                                    <div className="empty-state">
                                        <div className="empty-state-icon">🔍</div>
                                        <div className="empty-state-title">Ничего не найдено</div>
                                        <div className="empty-state-text">
                                            Попробуйте изменить параметры поиска
                                        </div>
                                        <button 
                                            onClick={() => { setSearch(''); setYearFilter('0'); setShowFavs(false); setTagFilter(null); }}
                                            className="mt-4 px-4 py-2 bg-[#8b0000] text-white rounded text-sm hover:bg-red-900 transition-colors"
                                        >
                                            Сбросить фильтры
                                        </button>
                                    </div>
                                )
                            ) : Object.entries(groupedCatalog).sort((a, b) => {
                                // Для годов сортируем по возрастанию, для изданий — алфавитно
                                if (groupMode === 'year') {
                                    if (a[0] === 'Без даты') return 1;
                                    if (b[0] === 'Без даты') return -1;
                                    return parseInt(a[0]) - parseInt(b[0]);
                                }
                                return a[0].localeCompare(b[0]);
                            }).map(([group, items]) => (
                                <div key={group} className="mb-4 border border-stone-200 rounded-lg overflow-hidden bg-white">
                                    <div 
                                        onClick={() => toggleGroup(group)}
                                        className="sticky top-0 bg-[#fffefb] z-10 font-display font-bold text-stone-700 text-[12px] uppercase tracking-[0.1em] py-3 px-4 border-b border-stone-200 cursor-pointer hover:bg-stone-50 flex items-center justify-between transition-colors"
                                    >
                                        <div className="flex items-center gap-2">
                                            <span className={`text-[10px] transition-transform ${collapsedGroups[group] ? '' : 'rotate-90'}`}>▶</span>
                                            <span>{group}</span>
                                        </div>
                                        <span className="text-[10px] font-bold text-white bg-[#8b0000] px-2 py-0.5 rounded-full min-w-[20px] text-center">{items.length}</span>
                                    </div>
                                    {!collapsedGroups[group] && <div className="p-3 space-y-3">
                                    {items.map(item => {
                                        const docType = getDocType(item);
                                        const isNew = item.id === newlyAddedId;
                                        const isMospriyutCard = MOSPRIYUT_STYLE_PROJECT_IDS.has(curPid);
                                        const cardSnippetText = getCatalogCardSnippetText(item, curPid);
                                        const parentsStructuredSummary = curPid === 'parents' ? String(item.structured_summary || '').trim() : '';
                                        const showDocTypeBadge = !(isMospriyutCard && docType.type === 'archive');
                                        const exactEventYearLabel = curPid === 'parents' ? (item.event_year_label || (item.event_year ? String(item.event_year) : '')) : '';
                                        return (
                                        <div key={item.id} id={'card-' + item.id} onClick={() => { setSelId(item.id); window.history.pushState({}, '', `${BASE_PATH}/${curPid}/${item.id}`); }} className={`group relative p-4 rounded-lg border transition-all cursor-pointer ${isNew ? 'card-new card-highlight' : ''} ${selId === item.id ? 'border-[#8b0000] ring-1 ring-[#8b0000] shadow-md bg-[#fffbfb]' : 'border-stone-100 bg-white hover:shadow-md hover:border-[#8b0000]/30'}`}>
                                            <div className="absolute top-3 right-3 flex items-center gap-1 rounded-full border border-stone-200 bg-white/95 px-1.5 py-1 shadow-sm">
                                                {canEditCurrentProject && <button onClick={(e) => { e.stopPropagation(); fetch(`${API_BASE}/toggle_favorite`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:item.id, pid:curPid})}).then(() => refreshData()); }} className="rounded-full p-1 transition-colors hover:bg-[#fdf0f0]" title={item.is_favorite ? 'Убрать из избранного' : 'Добавить в избранное'}><IconHeart active={item.is_favorite} /></button>}
                                                {canEditCurrentProject && <div className="relative">
                                                    <button onClick={(e) => { e.stopPropagation(); setTagPopoverId(tagPopoverId === item.id ? null : item.id); setNewTagInput(''); }} className="flex items-center justify-center rounded-full p-1 text-stone-400 transition-colors hover:bg-stone-100 hover:text-stone-700" title="Теги">
                                                        <svg viewBox="0 0 24 24" width="14" height="14"><circle cx="12" cy="5" r="2" fill="currentColor"/><circle cx="12" cy="12" r="2" fill="currentColor"/><circle cx="12" cy="19" r="2" fill="currentColor"/></svg>
                                                    </button>
                                                    {tagPopoverId === item.id && (
                                                        <div className="tag-popover" onClick={(e) => e.stopPropagation()}>
                                                            <input type="text" placeholder="Новый тег..." value={newTagInput} onChange={(e) => setNewTagInput(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter' && newTagInput.trim()) { addTag(item.id, newTagInput); setTagPopoverId(null); }}} autoFocus />
                                                            {allTags.length > 0 && (
                                                                <div className="tag-popover-list">
                                                                    {allTags.map((t) => (
                                                                        <div key={t} className={`tag-popover-item ${(item.tags || []).includes(t) ? 'selected' : ''}`} onClick={() => { if ((item.tags || []).includes(t)) { removeTag(item.id, t); } else { addTag(item.id, t); } setTagPopoverId(null); }}>
                                                                            <span>{(item.tags || []).includes(t) ? '✓' : '○'}</span>
                                                                            <span>🏷 {t}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>}
                                                {canEditCurrentProject && curPid === 'parents' && <button onClick={(e) => { e.stopPropagation(); setEditDocModal({
                                                    id: item.id,
                                                    form: {
                                                        event_year: item.event_year ? String(item.event_year) : '',
                                                        case_year_start: item.case_year_start ? String(item.case_year_start) : '',
                                                        case_year_end: item.case_year_end ? String(item.case_year_end) : '',
                                                        cipher: item.cipher || '',
                                                        issue: item.issue || '',
                                                        periodical: item.periodical || '',
                                                        date_label: item.date_label || '',
                                                        snippet: item.snippet || '',
                                                        text: item.text || '',
                                                    },
                                                    textExpanded: false,
                                                    saving: false,
                                                }); }} className="rounded-full p-1 text-stone-400 transition-colors hover:bg-amber-50 hover:text-amber-700" title="Редактировать карточку">
                                                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                                                </button>}
                                                {canEditCurrentProject && <button onClick={async (e) => { e.stopPropagation(); if(await showConfirm('Удалить этот документ?')) { fetch(`${API_BASE}/delete`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:item.id, pid:curPid})}).then(() => { showToast('Документ удалён', 'info'); refreshData(); }); } }} className="rounded-full p-1 text-[18px] leading-none text-stone-400 transition-colors hover:bg-red-50 hover:text-red-600" title="Удалить документ">×</button>}
                                            </div>
                                            <div className="flex items-start justify-between gap-2 mb-1">
                                                <div className={`${isMospriyutCard ? 'font-semibold text-stone-900 text-[13px] leading-5' : 'font-bold text-stone-900 text-[14px]'} pr-16`}>{item.issue}</div>
                                            </div>
                                            {groupMode === 'year' && !isMospriyutCard && (
                                                <div className="text-[11px] text-stone-500 mb-1 font-medium">{item.periodical}</div>
                                            )}
                                            <div className="mb-2 flex flex-wrap gap-1">
                                                {showDocTypeBadge && <span className={`doc-type-badge ${docType.className}`}>{docType.label}</span>}
                                                {(item.tags || []).map(t => (
                                                    <span key={t} className="tag-badge" onClick={(e) => { e.stopPropagation(); setTagFilter(tagFilter === t ? null : t); }} title="Фильтр по тегу">
                                                        <span className="tag-badge-icon">🏷</span>
                                                        {t}
                                                        {canEditCurrentProject && <span className="tag-badge-remove" onClick={(e) => { e.stopPropagation(); removeTag(item.id, t); }}>×</span>}
                                                    </span>
                                                ))}

                                            </div>
                                            {exactEventYearLabel && (
                                                <div className="mb-2 inline-flex items-center gap-1.5 rounded-full border border-[#ead8b0] bg-[#fff7e8] px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-600">
                                                    <span className="text-[#8b0000]">Год события</span>
                                                    <span>{exactEventYearLabel}</span>
                                                </div>
                                            )}
                                            {item.date_label && <div className="text-[10px] text-[#8b0000] font-display font-bold mb-2 uppercase">{item.date_label}</div>}
                                            {parentsStructuredSummary && (
                                                <div className="mb-2 text-[12px] font-medium text-stone-700 leading-relaxed line-clamp-2">
                                                    {highlightText(parentsStructuredSummary, search)}
                                                </div>
                                            )}
                                            <div className={`text-[13px] text-stone-600 leading-relaxed ${isMospriyutCard ? 'line-clamp-4' : parentsStructuredSummary ? 'line-clamp-2 italic text-[12px]' : 'line-clamp-3 italic'}`}>
                                                {highlightText(cardSnippetText, search, { preserveLineBreaks: isMospriyutCard })}
                                            </div>
                                            {item.cipher && <div className="text-[10px] text-stone-400 mt-2 pt-2 border-t border-stone-100 font-mono">{item.cipher}</div>}
                                        </div>
                                    );})}
                                    </div>}
                                </div>
                            ))}
                            {filteredCatalogItems.length > 0 && catalogPageCount > 1 && (
                                <div className="mt-4">
                                    <PaginationControls
                                        page={catalogPage}
                                        totalPages={catalogPageCount}
                                        totalItems={filteredCatalogItems.length}
                                        pageSize={CATALOG_PAGE_SIZE}
                                        label="Карточки каталога"
                                        onChange={(nextPage) => setCatalogPage(Math.min(Math.max(nextPage, 1), catalogPageCount))}
                                    />
                                </div>
                            )}
                        </div>
                        
                        {/* Footer - Desktop */}
                        {user && canEditCurrentProject && (
                            <div className="p-4 bg-white border-t border-stone-200 shrink-0 hidden md:block">
                                {isParentsProject && activeParish && (
                                    <div className="mb-2 text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">
                                        Импорт в приход: <span className="text-[#8b0000]">{activeParish.title}</span>
                                    </div>
                                )}
                                <div className="flex items-center gap-2">
                                    <input
                                        type="text"
                                        placeholder={canUseBatchImport ? "Страница или каталог ya.ru/archive..." : "Ссылка ya.ru/archive..."}
                                        value={importUrl}
                                        onChange={e => setImportUrl(e.target.value)}
                                        className="flex-1 text-sm p-2 border border-stone-300 rounded bg-stone-50 outline-none focus:border-[#8b0000] focus:ring-1 focus:ring-[#8b0000]/20"
                                        onKeyDown={e => { if (e.key === 'Enter') handleSingleImport(importUrl); }}
                                    />
                                    {canUseBatchImport && (
                                        <button
                                            onClick={() => loadBatchImportPreview(importUrl, { openModal: true })}
                                            className="shrink-0 rounded border border-stone-300 bg-stone-50 px-3 py-2 text-[10px] font-bold uppercase tracking-[0.14em] text-stone-600 hover:border-[#8b0000] hover:bg-[#fdf8f8] hover:text-[#8b0000] transition-colors"
                                        >
                                            Пакет
                                        </button>
                                    )}
                                    <button onClick={() => handleSingleImport(importUrl)} className="bg-[#8b0000] text-white w-10 h-10 rounded font-bold text-xl hover:bg-red-900 transition-colors flex items-center justify-center">+</button>
                                    {user?.user_id === MODERATOR_ID && <button onClick={() => { setModalType('cookies'); setIsModalOpen(true); }} className="w-10 h-10 border border-stone-300 rounded hover:bg-stone-50 text-stone-400 hover:text-stone-900 flex items-center justify-center transition-colors"><IconGear /></button>}
                                </div>
                            </div>
                        )}
                        
                        {/* Mobile Footer */}
                        {user && canEditCurrentProject && (
                            <div className="sidebar-footer-mobile">
                                {isParentsProject && activeParish && (
                                    <div className="mb-2 text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500">
                                        Импорт в приход: <span className="text-[#8b0000]">{activeParish.title}</span>
                                    </div>
                                )}
                                <div className="flex gap-2">
                                    <input 
                                        type="text" 
                                        placeholder={canUseBatchImport ? "Страница или каталог ya.ru/archive..." : "Ссылка ya.ru/archive..."}
                                        value={importUrl}
                                        onChange={e => setImportUrl(e.target.value)}
                                        onKeyDown={e => { if (e.key === 'Enter') handleSingleImport(importUrl); }} 
                                    />
                                    {canUseBatchImport && (
                                        <button
                                            className="rounded border border-stone-300 bg-stone-50 px-3 text-[10px] font-bold uppercase tracking-[0.14em] text-stone-600 hover:border-[#8b0000] hover:text-[#8b0000] transition-colors"
                                            onClick={() => loadBatchImportPreview(importUrl, { openModal: true })}
                                        >
                                            Пакет
                                        </button>
                                    )}
                                    <button 
                                        className="btn-add"
                                        onClick={() => handleSingleImport(importUrl)}
                                    >+</button>
                                    {user?.user_id === MODERATOR_ID && <button 
                                        className="btn-settings"
                                        onClick={() => { setModalType('cookies'); setIsModalOpen(true); }}
                                    >⚙</button>}
                                </div>
                            </div>
                        )}

                        {/* Modal */}
                        {isModalOpen && (
                            <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                                <div className={`bg-white rounded-xl shadow-2xl w-full border border-stone-300 overflow-hidden max-h-[90vh] overflow-y-auto ${modalType === 'batch_import' ? 'max-w-4xl' : 'max-w-lg'}`}>
                                    <div className="p-6 border-b flex justify-between items-center bg-white sticky top-0">
                                        <h2 className="font-display font-black uppercase tracking-wider text-stone-800">
                                            {modalType === 'projects' ? 'Проекты' : modalType === 'edit_project' ? 'Редактирование' : modalType === 'batch_import' ? 'Пакетный импорт' : modalType === 'parish_create' ? 'Новый приход' : 'Cookies'}
                                        </h2>
                                        <button onClick={() => setIsModalOpen(false)} className="text-2xl text-stone-300 hover:text-stone-600">×</button>
                                    </div>
                                    <div className="p-6 space-y-6 bg-stone-50 text-stone-800">
                                        {modalType === 'projects' ? (
                                            <div className="space-y-6">
                                                <div className="grid grid-cols-1 gap-2">
                                                    {projects.map(p => {
                                                        const coverSrc = getProjectCoverSrc(p);
                                                        return (
                                                            <div key={p.id} onClick={() => { navigateToProject(p.id); setIsModalOpen(false); }} className={`p-3 rounded-xl border cursor-pointer flex items-center gap-3 group transition-all ${p.id === curPid ? 'bg-[#fdfbf7] border-[#8b0000] ring-1 ring-[#8b0000]' : 'bg-white hover:border-stone-400'}`}>
                                                                <div className="w-14 h-16 rounded-lg overflow-hidden bg-stone-200 shrink-0 shadow-sm">
                                                                    {coverSrc ? (
                                                                        <img src={coverSrc} className="w-full h-full object-cover" />
                                                                    ) : (
                                                                        <div className="w-full h-full flex items-center justify-center bg-stone-300 text-stone-700 text-sm font-black uppercase">
                                                                            {(p.title || p.id || '?').slice(0, 1)}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="flex-1 min-w-0">
                                                                    <div className="font-bold text-sm truncate">{p.title}</div>
                                                                    <div className="text-[10px] text-stone-400 truncate">{p.subtitle || p.id}</div>
                                                                    {p.id === curPid && <div className="mt-1 text-[9px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Открыт сейчас</div>}
                                                                </div>
                                                                <div className="flex items-center gap-1 shrink-0">
                                                                    {canManageProject(p) && <button onClick={(e) => { e.stopPropagation(); setEditingProj(p); setModalType('edit_project'); }} className="opacity-0 group-hover:opacity-100 p-1 hover:text-[#8b0000] text-stone-400">✎</button>}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {canCreateProjects && <div className="pt-6 border-t border-stone-200 space-y-3">
                                                    <h3 className="text-[12px] font-bold uppercase text-stone-500 tracking-widest">Новый проект</h3>
                                                    <input type="text" placeholder="ID (латиница)" className="w-full p-2 border rounded text-sm outline-none focus:border-[#8b0000]" value={newProj.id} onChange={e => setNewProj({...newProj, id: e.target.value})} />
                                                    <input type="text" placeholder="Название" className="w-full p-2 border rounded text-sm outline-none focus:border-[#8b0000]" value={newProj.title} onChange={e => setNewProj({...newProj, title: e.target.value})} />
                                                    <input type="text" placeholder="Подзаголовок" className="w-full p-2 border rounded text-sm outline-none focus:border-[#8b0000]" value={newProj.subtitle} onChange={e => setNewProj({...newProj, subtitle: e.target.value})} />
                                                    <div className={`drop-zone rounded-lg p-6 text-center cursor-pointer ${dragOver ? 'dragover' : ''}`} onDragOver={(e) => { e.preventDefault(); setDragOver(true); }} onDragLeave={() => setDragOver(false)} onDrop={handleDrop} onClick={() => document.getElementById('coverInput').click()}>
                                                        <input type="file" id="coverInput" hidden accept="image/*" onChange={handleFileSelect} />
                                                        {newProj.cover_name ? (
                                                            <div className="text-green-600 font-bold">✓ {newProj.cover_name}</div>
                                                        ) : (
                                                            <div className="text-stone-400 text-sm">Перетащите обложку сюда<br/>или нажмите для выбора</div>
                                                        )}
                                                    </div>
                                                    <button onClick={() => { if (!newProj.id.trim()) { showToast('Укажите ID проекта', 'warning'); return; } fetch(`${API_BASE}/projects/create`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({...newProj, title: newProj.title || newProj.id})}).then(r=>r.json()).then(d => { if (d.error) showToast(d.error, 'error'); else { showToast('Проект создан!', 'success'); refreshData(); setNewProj({id:'',title:'',subtitle:'',cover_data:null,cover_name:'',allow_google_domain_famiry:false}); setIsModalOpen(false); navigateToProject(newProj.id); } }); }} className="w-full py-2 bg-stone-900 text-white rounded font-bold uppercase text-[10px] hover:bg-[#8b0000]">Создать</button>
                                                </div>}
                                            </div>
                                        ) : modalType === 'batch_import' ? (
                                            <div className="space-y-5">
                                                <div className="rounded-xl border border-stone-200 bg-white p-4">
                                                    <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Каталог для пакетного импорта</div>
                                                    <div className="mt-2 break-all font-mono text-xs text-stone-500">{batchImportPreview?.base_url || importUrl || 'Вставьте ссылку на каталог внизу слева и нажмите «Пакет»'}</div>
                                                    {isParentsProject && activeParish && (
                                                        <div className="mt-3 inline-flex items-center gap-2 rounded-full border border-[#ead8b0] bg-[#fff7e8] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-stone-700">
                                                            <span className="text-[#8b0000]">Импорт в приход</span>
                                                            <span>{activeParish.title}</span>
                                                        </div>
                                                    )}
                                                    {batchImportPreview && (
                                                        <div className="mt-4 grid gap-3 md:grid-cols-3">
                                                            <div className="rounded-lg border border-stone-200 bg-stone-50 p-3">
                                                                <div className="text-[10px] uppercase tracking-[0.14em] text-stone-400">Всего страниц</div>
                                                                <div className="mt-1 text-2xl font-black text-stone-800">{batchImportPreview.total_count}</div>
                                                            </div>
                                                            <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3">
                                                                <div className="text-[10px] uppercase tracking-[0.14em] text-emerald-700">Уже импортировано</div>
                                                                <div className="mt-1 text-2xl font-black text-emerald-800">{batchImportPreview.imported_count}</div>
                                                            </div>
                                                            <div className="rounded-lg border border-[#e7d5d5] bg-[#fdf8f8] p-3">
                                                                <div className="text-[10px] uppercase tracking-[0.14em] text-[#8b0000]">Еще не добавлено</div>
                                                                <div className="mt-1 text-2xl font-black text-[#8b0000]">{batchImportPreview.missing_count}</div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {batchPreviewLoading ? (
                                                    <div className="rounded-xl border border-stone-200 bg-white px-6 py-10 text-center">
                                                        <div className="text-sm font-bold text-stone-700">Собираем страницы каталога</div>
                                                        <div className="mt-2 text-xs text-stone-400">Проверяем, какие листы уже лежат в проекте, а какие можно добавить пакетом.</div>
                                                    </div>
                                                ) : batchImportPreview ? (
                                                    <>
                                                        <div className="grid gap-4 lg:grid-cols-[280px_minmax(0,1fr)]">
                                                            <div className="min-w-0 rounded-xl border border-stone-200 bg-white p-4 space-y-4">
                                                                <div>
                                                                    <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">Диапазон</div>
                                                                    <div className="mt-3 grid grid-cols-2 gap-2">
                                                                        <div>
                                                                            <div className="mb-1 text-[10px] uppercase tracking-[0.12em] text-stone-400">С</div>
                                                                            <input
                                                                                type="number"
                                                                                min={batchImportPreview.first_page || 1}
                                                                                max={batchImportPreview.last_page || undefined}
                                                                                value={batchImportRange.from}
                                                                                onChange={e => setBatchImportRange(prev => ({ ...prev, from: e.target.value }))}
                                                                                className="w-full rounded border border-stone-300 bg-stone-50 px-3 py-2 text-sm outline-none focus:border-[#8b0000]"
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <div className="mb-1 text-[10px] uppercase tracking-[0.12em] text-stone-400">По</div>
                                                                            <input
                                                                                type="number"
                                                                                min={batchImportPreview.first_page || 1}
                                                                                max={batchImportPreview.last_page || undefined}
                                                                                value={batchImportRange.to}
                                                                                onChange={e => setBatchImportRange(prev => ({ ...prev, to: e.target.value }))}
                                                                                className="w-full rounded border border-stone-300 bg-stone-50 px-3 py-2 text-sm outline-none focus:border-[#8b0000]"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="mt-2 text-[11px] text-stone-400">
                                                                        По умолчанию берем весь каталог. Уже добавленные страницы повторно не импортируются.
                                                                    </div>
                                                                </div>

                                                                {curPid === 'parents' && (
                                                                    <div className="rounded-lg border border-[#ead8b0] bg-[#fff7e8] p-3">
                                                                        <div className="text-[10px] uppercase tracking-[0.14em] text-[#8b0000] font-bold">Год дела</div>
                                                                        <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1">
                                                                            <input
                                                                                type="number"
                                                                                min={1500}
                                                                                max={2100}
                                                                                value={batchImportManualYear}
                                                                                onChange={e => setBatchImportManualYear(e.target.value)}
                                                                                className="w-24 shrink-0 rounded border border-stone-300 bg-white px-3 py-2 text-base font-bold outline-none focus:border-[#8b0000]"
                                                                                placeholder="1875"
                                                                            />
                                                                            {batchImportPreview?.detected_year_label ? (
                                                                                <span className="min-w-0 text-[11px] text-stone-500 break-words">
                                                                                    Определилось: <span className="font-bold text-stone-800">{batchImportPreview.detected_year_label}</span>
                                                                                </span>
                                                                            ) : (
                                                                                <span className="min-w-0 text-[11px] text-stone-400 break-words">Не определилось — введите вручную</span>
                                                                            )}
                                                                        </div>
                                                                        <div className="mt-2 text-[11px] leading-snug text-stone-600">
                                                                            Этот год будет проставлен каждой импортируемой странице как «год дела» и «год события». Оставьте пустым, чтобы оставить автоопределение по каждой странице.
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {curPid === 'parents' && (
                                                                    <div className="rounded-lg border border-stone-200 bg-white p-3">
                                                                        <div className="flex items-start justify-between gap-2">
                                                                            <div className="min-w-0">
                                                                                <div className="text-[10px] uppercase tracking-[0.14em] text-[#8b0000] font-bold">Разметка годов по страницам</div>
                                                                                <div className="mt-1 text-[11px] leading-snug text-stone-500">
                                                                                    Если в деле несколько лет на разных листах — пропиши соответствие. Эти годы перекроют автоопределение для каждой импортируемой страницы из заданного диапазона.
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {batchImportYearRanges.length > 0 && (
                                                                            <div className="mt-3 space-y-2">
                                                                                {batchImportYearRanges.map((row, idx) => (
                                                                                    <div key={`year-row-${idx}`} className="rounded-md border border-stone-200 bg-stone-50 p-2 space-y-2">
                                                                                        <div className="grid grid-cols-2 gap-2">
                                                                                            <input
                                                                                                type="number"
                                                                                                placeholder="стр. с"
                                                                                                min={1}
                                                                                                value={row.from}
                                                                                                onChange={e => setBatchImportYearRanges(prev => prev.map((r, i) => i === idx ? { ...r, from: e.target.value } : r))}
                                                                                                className="min-w-0 rounded border border-stone-300 bg-white px-2 py-1.5 text-[12px] outline-none focus:border-[#8b0000]"
                                                                                            />
                                                                                            <input
                                                                                                type="number"
                                                                                                placeholder="стр. по"
                                                                                                min={1}
                                                                                                value={row.to}
                                                                                                onChange={e => setBatchImportYearRanges(prev => prev.map((r, i) => i === idx ? { ...r, to: e.target.value } : r))}
                                                                                                className="min-w-0 rounded border border-stone-300 bg-white px-2 py-1.5 text-[12px] outline-none focus:border-[#8b0000]"
                                                                                            />
                                                                                        </div>
                                                                                        <div className="flex items-center gap-2">
                                                                                            <input
                                                                                                type="number"
                                                                                                placeholder="год"
                                                                                                min={1700}
                                                                                                max={2100}
                                                                                                value={row.year}
                                                                                                onChange={e => setBatchImportYearRanges(prev => prev.map((r, i) => i === idx ? { ...r, year: e.target.value } : r))}
                                                                                                className="min-w-0 flex-1 rounded border border-stone-300 bg-white px-2 py-1.5 text-[12px] outline-none focus:border-[#8b0000]"
                                                                                            />
                                                                                            <button
                                                                                                type="button"
                                                                                                onClick={() => setBatchImportYearRanges(prev => prev.filter((_, i) => i !== idx))}
                                                                                                className="shrink-0 rounded-full border border-stone-300 bg-white px-2 py-1 text-[10px] text-stone-400 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]"
                                                                                                title="Удалить строку"
                                                                                            >
                                                                                                ×
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => setBatchImportYearRanges(prev => [...prev, { from: '', to: '', year: '' }])}
                                                                            className="mt-3 w-full rounded-md border border-dashed border-stone-300 bg-stone-50 px-3 py-2 text-[11px] font-bold uppercase tracking-[0.12em] text-stone-500 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]"
                                                                        >
                                                                            + Добавить диапазон
                                                                        </button>
                                                                    </div>
                                                                )}

                                                                <div className="rounded-lg border border-stone-200 bg-stone-50 p-3">
                                                                    <div className="text-[10px] uppercase tracking-[0.12em] text-stone-400">В выбранном диапазоне</div>
                                                                    <div className="mt-2 text-sm text-stone-700">
                                                                        <div>Всего: <span className="font-bold">{visibleBatchPages.length}</span></div>
                                                                        <div>Новых: <span className="font-bold text-[#8b0000]">{visibleBatchMissingPages.length}</span></div>
                                                                        <div>Уже есть: <span className="font-bold text-emerald-700">{visibleBatchPages.length - visibleBatchMissingPages.length}</span></div>
                                                                    </div>
                                                                </div>

                                                                {batchImportLoading && batchImportProgress && (
                                                                    <div className="rounded-lg border border-[#e7d5d5] bg-[#fff7f4] p-4">
                                                                        <div className="flex items-start justify-between gap-3">
                                                                            <div className="min-w-0 flex-1">
                                                                                <div className="text-[10px] uppercase tracking-[0.12em] text-[#8b0000] font-bold">Идет пакетный импорт</div>
                                                                                <div className="mt-1 text-sm font-bold text-stone-800 break-words">
                                                                                    {batchImportProgress.current_page ? `Стр. ${batchImportProgress.current_page}` : 'Подготовка'}
                                                                                </div>
                                                                                <div className="mt-1 text-[11px] text-stone-500">
                                                                                    Обработано: <span className="font-bold text-stone-700">{batchImportProgressMetrics.processed}</span> из <span className="font-bold text-stone-700">{batchImportProgressMetrics.total}</span> новых страниц.
                                                                                </div>
                                                                                <div className="mt-1 text-[11px] text-stone-500">
                                                                                    Осталось: <span className="font-bold text-[#8b0000]">{batchImportProgressMetrics.remaining}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="shrink-0 text-right">
                                                                                <div className="text-2xl font-black text-[#8b0000]">{batchImportProgressMetrics.percent}%</div>
                                                                                <div className="text-[10px] uppercase tracking-[0.12em] text-stone-400">
                                                                                    уже было: {batchImportProgress.skipped_existing_count || 0}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mt-3 h-2 rounded-full bg-stone-200 overflow-hidden">
                                                                            <div
                                                                                className="h-full rounded-full bg-gradient-to-r from-[#8b0000] to-[#d35230] transition-all duration-300"
                                                                                style={{ width: `${batchImportProgressMetrics.percent}%` }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <button
                                                                    onClick={runBatchImport}
                                                                    disabled={batchImportLoading || visibleBatchMissingPages.length === 0}
                                                                    className="w-full rounded-lg bg-stone-900 px-4 py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-white transition-colors hover:bg-[#8b0000] disabled:cursor-not-allowed disabled:bg-stone-300"
                                                                >
                                                                    {batchImportLoading ? 'Импортируем...' : 'Импортировать новые'}
                                                                </button>

                                                                <button
                                                                    onClick={() => loadBatchImportPreview(batchImportPreview.base_url)}
                                                                    disabled={batchPreviewLoading || batchImportLoading}
                                                                    className="w-full rounded-lg border border-stone-300 bg-white px-4 py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-stone-600 transition-colors hover:border-stone-400 hover:text-stone-900 disabled:cursor-not-allowed disabled:text-stone-300"
                                                                >
                                                                    Обновить список
                                                                </button>
                                                            </div>

                                                            <div className="space-y-4">
                                                                {batchImportResult && (
                                                                    <div className="rounded-xl border border-stone-200 bg-white p-4">
                                                                        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">Последний запуск</div>
                                                                        <div className="mt-3 grid gap-3 md:grid-cols-3">
                                                                            <div className="rounded-lg bg-[#fdf8f8] p-3">
                                                                                <div className="text-[10px] uppercase tracking-[0.12em] text-[#8b0000]">Добавлено</div>
                                                                                <div className="mt-1 text-xl font-black text-[#8b0000]">{batchImportResult.added_count}</div>
                                                                            </div>
                                                                            <div className="rounded-lg bg-emerald-50 p-3">
                                                                                <div className="text-[10px] uppercase tracking-[0.12em] text-emerald-700">Пропущено</div>
                                                                                <div className="mt-1 text-xl font-black text-emerald-800">{batchImportResult.skipped_existing_count}</div>
                                                                            </div>
                                                                            <div className="rounded-lg bg-amber-50 p-3">
                                                                                <div className="text-[10px] uppercase tracking-[0.12em] text-amber-700">Ошибки</div>
                                                                                <div className="mt-1 text-xl font-black text-amber-800">{batchImportResult.error_count}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className="rounded-xl border border-stone-200 bg-white overflow-hidden">
                                                                    <div className="border-b border-stone-200 px-4 py-3">
                                                                        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-stone-400">Страницы каталога</div>
                                                                    </div>
                                                                    <div className="max-h-[48vh] overflow-y-auto">
                                                                        {visibleBatchPages.length > 0 ? visibleBatchPages.map(page => (
                                                                            <div key={page.page} className="flex items-center justify-between gap-3 border-b border-stone-100 px-4 py-3 last:border-b-0">
                                                                                <div className="min-w-0 flex-1">
                                                                                    <div className="text-sm font-bold text-stone-800">Страница {page.page}</div>
                                                                                    <div className="mt-1 text-[11px] font-mono text-stone-400 break-all">{page.url}</div>
                                                                                </div>
                                                                                <div className={`shrink-0 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] ${page.imported ? 'bg-emerald-50 text-emerald-700' : 'bg-[#fdf0f0] text-[#8b0000]'}`}>
                                                                                    {page.imported ? 'Уже есть' : 'Новая'}
                                                                                </div>
                                                                            </div>
                                                                        )) : (
                                                                            <div className="px-4 py-10 text-center text-sm text-stone-400">
                                                                                В этом диапазоне нет страниц.
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="rounded-xl border border-stone-200 bg-white px-6 py-10 text-center">
                                                        <div className="text-sm font-bold text-stone-700">Пакет еще не подготовлен</div>
                                                        <div className="mt-2 text-xs text-stone-400">Вставьте ссылку на каталог и нажмите кнопку `Пакет` рядом с полем импорта.</div>
                                                    </div>
                                                )}
                                            </div>
                                        ) : modalType === 'edit_project' ? (
                                            canManageProject(editingProj) ? (
                                            <div className="space-y-4">
                                                <input type="text" className="w-full p-2 border rounded text-sm" defaultValue={editingProj?.title} onChange={e => setEditingProj({...editingProj, title: e.target.value})} placeholder="Название" />
                                                <input type="text" className="w-full p-2 border rounded text-sm" defaultValue={editingProj?.subtitle} onChange={e => setEditingProj({...editingProj, subtitle: e.target.value})} placeholder="Подзаголовок" />
                                                <div className="text-[10px] font-display uppercase tracking-wider text-stone-500 mt-2">Доступ по Telegram ID</div>
                                                <textarea
                                                    className="w-full p-2 border rounded text-sm font-mono"
                                                    rows={4}
                                                    defaultValue={(editingProj?.allowed_users || []).join('\n')}
                                                    onChange={e => setEditingProj({...editingProj, allowed_users: e.target.value.split(/[\n,]/).map(s => s.trim()).filter(Boolean)})}
                                                    placeholder="Один Telegram ID на строку, например:\n123456789\n987654321"
                                                />
                                                <div className="text-[10px] text-stone-400">Эти пользователи увидят проект после входа через Telegram. Только этот проект, не другие.</div>
                                                <label className="flex items-start gap-3 rounded-xl border border-stone-200 bg-stone-50 px-4 py-3 cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        className="mt-0.5 h-4 w-4 rounded border-stone-300 text-[#8b0000] focus:ring-[#8b0000]"
                                                        checked={!!editingProj?.allow_google_domain_famiry}
                                                        onChange={e => setEditingProj({...editingProj, allow_google_domain_famiry: e.target.checked})}
                                                    />
                                                    <div className="min-w-0">
                                                        <div className="text-[11px] font-bold uppercase tracking-[0.12em] text-stone-600">
                                                            Доступно для просмотра и редактирования пользователям famiry.ru
                                                        </div>
                                                        <div className="mt-1 text-[10px] leading-5 text-stone-400">
                                                            Пользователь, вошедший через Google-аккаунт <span className="font-mono text-stone-500">@famiry.ru</span>, увидит проект и сможет редактировать его данные. Настройки самого проекта останутся доступны только администраторам.
                                                        </div>
                                                    </div>
                                                </label>
                                                
                                                {/* Обложка проекта */}
                                                <div className="pt-2 border-t border-stone-200">
                                                    <div className="text-[11px] font-bold uppercase text-stone-500 mb-2">Обложка проекта</div>
                                                    {editingProj?.cover_image && !editingProj?.new_cover_name && (
                                                        <div className="mb-2 p-2 bg-stone-50 rounded flex items-center gap-2">
                                                            <span className="text-green-600">✓</span>
                                                            <span className="text-xs text-stone-600">Текущая: {editingProj.cover_image}</span>
                                                        </div>
                                                    )}
                                                    {editingProj?.new_cover_name && (
                                                        <div className="mb-2 p-2 bg-green-50 rounded flex items-center gap-2">
                                                            <span className="text-green-600">✓</span>
                                                            <span className="text-xs text-green-700">Новая: {editingProj.new_cover_name}</span>
                                                        </div>
                                                    )}
                                                    <div 
                                                        className="drop-zone rounded-lg p-4 text-center cursor-pointer border-2 border-dashed border-stone-300 hover:border-[#8b0000] transition-colors"
                                                        onClick={() => document.getElementById('editCoverInput').click()}
                                                        onDragOver={(e) => { e.preventDefault(); e.currentTarget.classList.add('border-[#8b0000]', 'bg-red-50'); }}
                                                        onDragLeave={(e) => { e.currentTarget.classList.remove('border-[#8b0000]', 'bg-red-50'); }}
                                                        onDrop={(e) => {
                                                            e.preventDefault();
                                                            e.currentTarget.classList.remove('border-[#8b0000]', 'bg-red-50');
                                                            const file = e.dataTransfer?.files?.[0];
                                                            if (file && file.type.startsWith('image/')) {
                                                                const reader = new FileReader();
                                                                reader.onload = (ev) => {
                                                                    setEditingProj({...editingProj, cover_data: ev.target.result.split(',')[1], new_cover_name: file.name});
                                                                };
                                                                reader.readAsDataURL(file);
                                                            }
                                                        }}
                                                    >
                                                        <input 
                                                            type="file" 
                                                            id="editCoverInput" 
                                                            hidden 
                                                            accept="image/*" 
                                                            onChange={(e) => {
                                                                const file = e.target.files?.[0];
                                                                if (file) {
                                                                    const reader = new FileReader();
                                                                    reader.onload = (ev) => {
                                                                        setEditingProj({...editingProj, cover_data: ev.target.result.split(',')[1], new_cover_name: file.name});
                                                                    };
                                                                    reader.readAsDataURL(file);
                                                                }
                                                            }} 
                                                        />
                                                        <div className="text-stone-400 text-sm">
                                                            {editingProj?.cover_image ? 'Заменить обложку' : 'Добавить обложку'}
                                                        </div>
                                                        <div className="text-stone-300 text-xs mt-1">Нажмите или перетащите файл</div>
                                                    </div>
                                                </div>
                                                
                                                <button onClick={() => { fetch(`${API_BASE}/projects/update`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(editingProj)}).then(() => { refreshData(); setModalType('projects'); }); }} className="w-full py-2 bg-stone-900 text-white font-bold uppercase text-[10px] rounded hover:bg-[#8b0000]">Сохранить</button>
                                            </div>
                                            ) : (
                                            <div className="rounded-lg border border-stone-200 bg-white p-4 text-sm text-stone-500">
                                                Этот проект доступен только для просмотра.
                                            </div>
                                            )
                                        ) : modalType === 'parish_create' ? (
                                            canEditCurrentProject ? (
                                            <div className="space-y-4">
                                                <div className="rounded-xl border border-stone-200 bg-white px-4 py-4 text-sm leading-6 text-stone-500">
                                                    Новый приход внутри <span className="font-semibold text-stone-700">parents</span> получает собственный каталог, собственные графики, дашборд и древо связей. Документы разных приходов не будут смешиваться.
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Название прихода"
                                                    className="w-full p-2 border rounded text-sm outline-none focus:border-[#8b0000]"
                                                    value={newParish.title}
                                                    onChange={e => setNewParish(prev => ({ ...prev, title: e.target.value }))}
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Подзаголовок / описание"
                                                    className="w-full p-2 border rounded text-sm outline-none focus:border-[#8b0000]"
                                                    value={newParish.subtitle}
                                                    onChange={e => setNewParish(prev => ({ ...prev, subtitle: e.target.value }))}
                                                />
                                                <button
                                                    onClick={async () => {
                                                        const title = String(newParish.title || '').trim();
                                                        const subtitle = String(newParish.subtitle || '').trim();
                                                        if (!title) {
                                                            showToast('Укажите название прихода', 'warning');
                                                            return;
                                                        }
                                                        try {
                                                            const response = await fetch(`${API_BASE}/project_parish_create`, {
                                                                method: 'POST',
                                                                headers: {'Content-Type':'application/json'},
                                                                body: JSON.stringify({ pid: curPid, title, subtitle })
                                                            });
                                                            const data = await response.json();
                                                            if (!response.ok || data?.error) {
                                                                showToast(data?.error || 'Не удалось создать приход', 'error');
                                                                return;
                                                            }
                                                            setProjects(prev => prev.map(entry => entry.id === curPid ? { ...entry, parishes: Array.isArray(data?.parishes) ? data.parishes : entry.parishes } : entry));
                                                            setActiveParishId(String(data?.parish?.id || ''));
                                                            setWorkspacePage('catalog');
                                                            setSelId(null);
                                                            setNewParish({ title: '', subtitle: '' });
                                                            setIsModalOpen(false);
                                                            refreshData();
                                                            showToast('Приход создан!', 'success');
                                                        } catch (error) {
                                                            showToast('Не удалось создать приход', 'error');
                                                        }
                                                    }}
                                                    className="w-full py-2 bg-stone-900 text-white font-bold uppercase text-[10px] rounded hover:bg-[#8b0000]"
                                                >
                                                    Создать приход
                                                </button>
                                            </div>
                                            ) : (
                                            <div className="rounded-lg border border-stone-200 bg-white p-4 text-sm text-stone-500">
                                                Этот проект доступен только для просмотра.
                                            </div>
                                            )
                                        ) : (
                                            <div className="space-y-4">
                                                <textarea id="cookInp" className="w-full h-40 p-2 border rounded font-mono text-xs outline-none bg-white" placeholder="Вставьте cookies из браузера..."></textarea>
                                                <button onClick={() => { fetch(`${API_BASE}/cookies`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({cookies: document.getElementById('cookInp').value})}).then(() => setIsModalOpen(false)); }} className="w-full py-2 bg-stone-900 text-white font-bold rounded hover:bg-[#8b0000]">Сохранить</button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    
                    {/* Main Viewer - Desktop */}
                    <div className="flex-1 relative flex-col overflow-hidden bg-[#e8e4dc] bg-texture desktop-viewer">
                        {selId && catalog.find(i => i.id === selId) ? (
                            <ImageViewer item={catalog.find(i => i.id === selId)} pid={curPid} ownerId={project?.owner_id} canEditProject={canEditCurrentProject} onItemUpdate={updateCatalogItem} />
                        ) : (
                            <div className="absolute inset-0 flex items-center justify-center text-center bg-[#d4cfc4]">
                                {currentProjectCover && <img src={currentProjectCover} className="absolute inset-0 w-full h-full object-cover opacity-60" />}
                                <div className={`relative z-10 p-10 bg-white/80 backdrop-blur-[2px] rounded-xl shadow-2xl border border-stone-200 mx-6 ${isParentsProject ? 'max-w-3xl w-full' : 'max-w-md'}`}>
                                    {workspaceStatus ? (
                                        <div className="flex flex-col items-center text-center">
                                            <div className="scale-[0.85]">
                                                <div className="loader-paper"></div>
                                            </div>
                                            <div className="mt-5 text-[11px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">{workspaceStatus.title}</div>
                                            <div className="mt-2 text-sm text-stone-500">{workspaceStatus.detail}</div>
                                        </div>
                                    ) : (
                                        <>
                                            <h2 className="text-3xl font-display font-black text-stone-800 uppercase tracking-wider leading-tight">{project.title}</h2>
                                            {project.subtitle && <p className="text-stone-500 italic mt-3 text-sm">{project.subtitle}</p>}
                                            {isParentsProject ? (
                                                <div className="mt-6 border-t border-stone-200 pt-5 text-left">
                                                    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                                                        <div>
                                                            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Приходы проекта</div>
                                                            <div className="mt-2 text-sm text-stone-500">
                                                                Каждый приход живет в отдельном каталоге со своей статистикой, дашбордом и древом связей.
                                                            </div>
                                                        </div>
                                                        {canEditCurrentProject && (
                                                            <button
                                                                onClick={() => {
                                                                    setNewParish({ title: '', subtitle: '' });
                                                                    setModalType('parish_create');
                                                                    setIsModalOpen(true);
                                                                }}
                                                                className="shrink-0 rounded-full border border-[#d9c0b4] bg-white px-4 py-2 text-[10px] font-bold uppercase tracking-[0.14em] text-[#8b0000] transition-colors hover:bg-[#fff5f1]"
                                                            >
                                                                Добавить приход
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className="mt-4 grid gap-3 md:grid-cols-2">
                                                        {projectParishes.map(parish => {
                                                            const isActive = parish.id === effectiveParishId;
                                                            return (
                                                                <button
                                                                    key={parish.id}
                                                                    onClick={() => {
                                                                        setActiveParishId(parish.id);
                                                                        setWorkspacePage('catalog');
                                                                    }}
                                                                    className={`rounded-2xl border px-4 py-4 text-left transition-all ${isActive ? 'border-[#8b0000] bg-[#fff5f1] shadow-sm' : 'border-stone-200 bg-white/90 hover:border-[#8b0000]/35'}`}
                                                                >
                                                                    <div className="flex items-center justify-between gap-3">
                                                                        <div className="font-semibold text-stone-800">{parish.title}</div>
                                                                        {isActive && (
                                                                            <span className="rounded-full border border-[#e2b9ac] bg-white px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.14em] text-[#8b0000]">
                                                                                Активен
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div className="mt-2 text-[12px] leading-5 text-stone-500">
                                                                        {parish.subtitle || 'Новый каталог внутри проекта parents.'}
                                                                    </div>
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="mt-5 pt-4 border-t border-stone-200 text-[10px] uppercase tracking-widest text-stone-400 text-center">
                                                        Выберите документ слева
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="mt-6 pt-4 border-t border-stone-200 text-[10px] uppercase tracking-widest text-stone-400">
                                                    Выберите документ слева
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Doc edit modal (parents) */}
                        {editDocModal && (
                            <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={() => { if (!editDocModal.saving) setEditDocModal(null); }}>
                                <div className="bg-white rounded-xl shadow-2xl w-full max-w-xl border border-stone-300 overflow-hidden max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                                    <div className="p-5 border-b flex justify-between items-center bg-white sticky top-0 z-10">
                                        <h2 className="font-display font-black uppercase tracking-wider text-stone-800 text-sm">Редактирование карточки</h2>
                                        <button onClick={() => { if (!editDocModal.saving) setEditDocModal(null); }} className="text-2xl text-stone-300 hover:text-stone-600">×</button>
                                    </div>
                                    <div className="p-5 space-y-4 bg-stone-50 text-stone-800 text-[13px]">
                                        {(() => {
                                            const f = editDocModal.form;
                                            const upd = (k, v) => setEditDocModal({ ...editDocModal, form: { ...f, [k]: v } });
                                            const labelCls = "block text-[10px] uppercase tracking-[0.14em] text-stone-500 font-bold mb-1";
                                            const inputCls = "w-full p-2 border border-stone-300 rounded text-[13px] outline-none focus:border-[#8b0000] bg-white";
                                            return (
                                                <>
                                                    <div className="grid grid-cols-2 gap-3">
                                                        <div>
                                                            <label className={labelCls}>Год события</label>
                                                            <input type="number" className={inputCls} value={f.event_year} onChange={(e) => upd('event_year', e.target.value)} placeholder="напр. 1875" />
                                                            <div className="text-[10px] text-stone-400 mt-1">Пусто — авто-определение</div>
                                                        </div>
                                                        <div>
                                                            <label className={labelCls}>Диапазон дела</label>
                                                            <div className="flex items-center gap-2">
                                                                <input type="number" className={inputCls} value={f.case_year_start} onChange={(e) => upd('case_year_start', e.target.value)} placeholder="с" />
                                                                <span className="text-stone-400">—</span>
                                                                <input type="number" className={inputCls} value={f.case_year_end} onChange={(e) => upd('case_year_end', e.target.value)} placeholder="по" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label className={labelCls}>Название дела (issue)</label>
                                                        <input type="text" className={inputCls} value={f.issue} onChange={(e) => upd('issue', e.target.value)} />
                                                    </div>
                                                    <div className="grid grid-cols-2 gap-3">
                                                        <div>
                                                            <label className={labelCls}>Фонд / журнал (periodical)</label>
                                                            <input type="text" className={inputCls} value={f.periodical} onChange={(e) => upd('periodical', e.target.value)} />
                                                        </div>
                                                        <div>
                                                            <label className={labelCls}>Шифр</label>
                                                            <input type="text" className={`${inputCls} font-mono`} value={f.cipher} onChange={(e) => upd('cipher', e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label className={labelCls}>Дата-метка</label>
                                                        <input type="text" className={inputCls} value={f.date_label} onChange={(e) => upd('date_label', e.target.value)} />
                                                    </div>
                                                    <div>
                                                        <label className={labelCls}>Snippet (превью)</label>
                                                        <textarea className={`${inputCls} resize-y min-h-[60px]`} rows={3} value={f.snippet} onChange={(e) => upd('snippet', e.target.value)} />
                                                    </div>
                                                    <div className="border-t border-stone-200 pt-3">
                                                        <button type="button" onClick={() => setEditDocModal({ ...editDocModal, textExpanded: !editDocModal.textExpanded })} className="flex items-center gap-2 text-[11px] uppercase tracking-[0.14em] font-bold text-stone-600 hover:text-[#8b0000]">
                                                            <span className={`text-[10px] transition-transform ${editDocModal.textExpanded ? 'rotate-90' : ''}`}>▶</span>
                                                            <span>OCR-текст ({(f.text || '').length} симв.)</span>
                                                        </button>
                                                        {editDocModal.textExpanded && (
                                                            <textarea className={`${inputCls} mt-2 font-mono text-[12px] resize-y min-h-[180px]`} rows={12} value={f.text} onChange={(e) => upd('text', e.target.value)} />
                                                        )}
                                                    </div>
                                                </>
                                            );
                                        })()}
                                    </div>
                                    <div className="p-4 border-t border-stone-200 bg-white flex justify-end gap-2 sticky bottom-0">
                                        <button onClick={() => { if (!editDocModal.saving) setEditDocModal(null); }} disabled={editDocModal.saving} className="px-4 py-2 text-[11px] uppercase tracking-[0.14em] font-bold text-stone-500 hover:text-stone-800 disabled:opacity-40">Отмена</button>
                                        <button disabled={editDocModal.saving} onClick={async () => {
                                            setEditDocModal({ ...editDocModal, saving: true });
                                            try {
                                                const f = editDocModal.form;
                                                const r = await fetch(`${API_BASE}/parents_doc_update`, {
                                                    method: 'POST',
                                                    headers: { 'Content-Type': 'application/json' },
                                                    body: JSON.stringify({
                                                        pid: curPid,
                                                        id: editDocModal.id,
                                                        owner_id: project?.owner_id,
                                                        parish_id: effectiveParishId || '',
                                                        patch: {
                                                            event_year: f.event_year,
                                                            case_year_start: f.case_year_start,
                                                            case_year_end: f.case_year_end,
                                                            cipher: f.cipher,
                                                            issue: f.issue,
                                                            periodical: f.periodical,
                                                            date_label: f.date_label,
                                                            snippet: f.snippet,
                                                            text: f.text,
                                                        },
                                                    }),
                                                });
                                                if (!r.ok) {
                                                    const errText = await r.text().catch(() => '');
                                                    showToast(`Ошибка: ${errText || r.status}`, 'error');
                                                    setEditDocModal({ ...editDocModal, saving: false });
                                                    return;
                                                }
                                                showToast('Карточка обновлена', 'success');
                                                setEditDocModal(null);
                                                refreshData();
                                            } catch (err) {
                                                showToast(`Ошибка: ${err.message || err}`, 'error');
                                                setEditDocModal({ ...editDocModal, saving: false });
                                            }
                                        }} className="px-5 py-2 bg-stone-900 text-white rounded text-[11px] uppercase tracking-[0.14em] font-bold hover:bg-[#8b0000] disabled:opacity-50">
                                            {editDocModal.saving ? 'Сохранение…' : 'Сохранить'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Mobile Sheet Panel */}
                    <div className="mobile-panel">
                        <div 
                            className={`mobile-sheet-backdrop ${mobileSheetOpen ? 'open' : ''}`}
                            onClick={() => { setMobileSheetOpen(false); setSelId(null); window.history.pushState({}, '', `${BASE_PATH}/${curPid}`); }}
                        />
                        <div 
                            ref={sheetRef}
                            className={`mobile-sheet ${mobileSheetOpen ? 'open' : ''}`}
                        >
                            <div 
                                className="sheet-handle"
                                onTouchStart={handleSheetTouchStart}
                                onTouchMove={handleSheetTouchMove}
                                onClick={() => { setMobileSheetOpen(false); setSelId(null); window.history.pushState({}, '', `${BASE_PATH}/${curPid}`); }}
                            >
                                <div className="sheet-handle-bar"></div>
                            </div>
                            <div className="sheet-content">
                                {mobileSheetOpen && selId && catalog.find(i => i.id === selId) && (
                                    <MobileImageViewer 
                                        item={catalog.find(i => i.id === selId)} 
                                        pid={curPid}
                                        ownerId={project?.owner_id}
                                        onClose={() => setMobileSheetOpen(false)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    </div>
                    )}

                    {catalogOverlayState.mounted && (
                        <div className="fixed inset-0 z-[120] flex items-stretch justify-end">
                            <button
                                type="button"
                                aria-label="Закрыть окно каталога"
                                onClick={() => closeCatalogOverlay()}
                                className={`absolute inset-0 bg-[rgba(39,27,18,0.36)] backdrop-blur-[2px] transition-opacity duration-300 ${catalogOverlayState.open ? 'opacity-100' : 'opacity-0'}`}
                            />
                            <div
                                className={`relative flex h-full w-full flex-col overflow-hidden bg-[#e8e4dc] shadow-[-28px_0_70px_rgba(40,28,19,0.22)] transition-transform duration-300 ease-out md:w-[calc(100vw-28px)] xl:w-[min(100vw-40px,1780px)] ${catalogOverlayState.open ? 'translate-x-0' : 'translate-x-full'}`}
                            >
                                <div className="flex items-start justify-between gap-4 border-b border-stone-300 bg-[#fbf7ef]/96 px-5 py-3 backdrop-blur-sm">
                                    <div className="min-w-0">
                                        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">
                                            Каталог из {catalogOverlaySourceLabel}
                                        </div>
                                        <div className="mt-1 truncate text-sm font-semibold text-stone-700">
                                            {catalogOverlayState.title || 'Запись каталога'}
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => closeCatalogOverlay()}
                                        className="shrink-0 rounded-full border border-stone-300 bg-white px-4 py-2 text-[10px] font-bold uppercase tracking-[0.14em] text-stone-600 transition-colors hover:border-[#8b0000] hover:text-[#8b0000]"
                                    >
                                        Закрыть
                                    </button>
                                </div>
                                <div className="relative min-h-0 flex-1 bg-[#e8e4dc]">
                                    {!catalogOverlayState.item && catalogOverlayLoading && (
                                        <div className="absolute inset-0 z-10 flex items-center justify-center bg-[#f4efe7]/88 backdrop-blur-[1px]">
                                            <div className="rounded-[24px] border border-stone-300 bg-white/95 px-8 py-8 text-center shadow-[0_18px_55px_rgba(45,34,20,0.1)]">
                                                <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b0000]">Открываем каталог</div>
                                                <div className="mt-3 text-sm text-stone-500">Загружаем окно записи поверх текущего раздела.</div>
                                            </div>
                                        </div>
                                    )}
                                    {catalogOverlayState.item ? (
                                        <ImageViewer
                                            key={`overlay:${catalogOverlayState.itemId}:${catalogOverlayState.parishId || ''}:${catalogOverlayState.scrollToEntry || ''}:${catalogOverlayState.scrollToEntryIndex ?? ''}`}
                                            item={catalogOverlayState.item}
                                            pid={curPid}
                                            ownerId={project?.owner_id}
                                            canEditProject={canEditCurrentProject}
                                            onItemUpdate={updateCatalogItem}
                                            scrollToEntry={catalogOverlayState.scrollToEntry || ''}
                                            scrollToEntryIndex={typeof catalogOverlayState.scrollToEntryIndex === 'number' ? catalogOverlayState.scrollToEntryIndex : -1}
                                        />
                                    ) : (
                                        <iframe
                                            key={catalogOverlayState.src}
                                            title="Каталог Yarchiver"
                                            src={catalogOverlayState.src}
                                            onLoad={handleCatalogOverlayFrameLoad}
                                            className="h-full w-full border-0 bg-[#e8e4dc]"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <ToastContainer />
                    <ConfirmDialog />
                    {summaryEditorTarget && summaryEditorItem && (
                        <ImageViewer
                            key={`summary-editor:${summaryEditorTarget.itemId}:${summaryEditorTarget.fragmentIndex}`}
                            item={summaryEditorItem}
                            pid={curPid}
                            ownerId={project?.owner_id}
                            canEditProject={canEditCurrentProject}
                            onItemUpdate={updateCatalogItem}
                            editorOnly={true}
                            initialEditingFragmentIndex={summaryEditorTarget.fragmentIndex}
                            onEditorClose={closeSummaryEditor}
                        />
                    )}
                    {parentsEditorTarget && parentsEditorItem && (
                        <ImageViewer
                            key={`parents-editor:${parentsEditorTarget.itemId}:${parentsEditorTarget.entryId || parentsEditorTarget.entryIndex}:${(parentsEditorTarget.preferredStatuses || []).join(',')}:${parentsEditorTarget.matchField || ''}:${parentsEditorTarget.matchGroupKey || ''}`}
                            item={parentsEditorItem}
                            pid={curPid}
                            ownerId={project?.owner_id}
                            canEditProject={canEditCurrentProject}
                            onItemUpdate={updateCatalogItem}
                            onStructuredSave={notifyParentsDataUpdated}
                            editorOnly={true}
                            initialEditingStructuredPersonTarget={parentsEditorTarget}
                            onEditorClose={closeParentsEditor}
                        />
                    )}
                </div>
            );
        };

        // === MOBILE IMAGE VIEWER ===
        const MobileImageViewer = ({ item, pid, ownerId, onClose }) => {
            const currentUser = window.__currentUser;
            const [data, setData] = useState(null);
            const [zoom, setZoom] = useState(1.0);
            const [baseScale, setBaseScale] = useState(0.3);
            const [loading, setLoading] = useState(true);
            const [imgLoaded, setImgLoaded] = useState(false);
            const [loadProgress, setLoadProgress] = useState(0);
            const [blobUrl, setBlobUrl] = useState(null);
            const [imageStage, setImageStage] = useState('proxy');
            const [imageLoadFailed, setImageLoadFailed] = useState(false);
            const containerRef = useRef(null);
            const pageMarkupToggleAvailable = supportsPageMarkupToggle(pid);
            const [showPageMarkup, setShowPageMarkup] = useState(() => shouldShowPageMarkupByDefault(pid));

            // Загрузка данных
            useEffect(() => {
                setLoading(true);
                setImgLoaded(false);
                setZoom(1.0);
                setShowPageMarkup(shouldShowPageMarkupByDefault(pid));
                setBlobUrl(null);
                setImageStage('proxy');
                setImageLoadFailed(false);

                const hasCachedViewerData = item.image_id && item.highlights;
                const hasImmediateViewerImage = Boolean(item?.image_id || item?.hires_image || item?.hiresImageUrl);

                if (hasImmediateViewerImage) {
                    setData(normalizeViewerData(item, { pid, itemId: item.id, ownerId: ownerId || item.owner_id }));
                }

                if (hasCachedViewerData) {
                    setData(normalizeViewerData(item, { pid, itemId: item.id, ownerId: ownerId || item.owner_id }));
                    setLoading(false);
                } else {
                    const params = new URLSearchParams({ url: item.url, item_id: item.id, pid });
                    if (ownerId || item.owner_id) params.set('owner_id', String(ownerId || item.owner_id));
                    fetch(`${API_BASE}/image?${params}`).then(r=>r.json()).then(d => {
                        setData(normalizeViewerData(d, { pid, itemId: item.id, ownerId: ownerId || item.owner_id }));
                        setLoading(false); 
                    });
                }
            }, [item.id]);

            useEffect(() => {
                const initialCandidate = buildViewerImageCandidates(data)[0];
                if (initialCandidate?.url) {
                    setBlobUrl(initialCandidate.url);
                    setImageStage(initialCandidate.stage);
                    setImageLoadFailed(false);
                }
            }, [data?.hiresImageUrl, data?.proxyImageUrl, data?.originalUrl]);

            // Зум > 1× → апгрейд preview до оригинала
            useEffect(() => {
                if (zoom > 1.0 && imageStage === 'proxy-preview' && data?.proxyImageUrl) {
                    setBlobUrl(data.proxyImageUrl);
                    setImageStage('proxy-original');
                }
            }, [zoom, imageStage, data?.proxyImageUrl]);

            // Автомасштаб под ширину контейнера
            useEffect(() => {
                if (data && containerRef.current && imgLoaded) {
                    const containerWidth = containerRef.current.clientWidth - 32; // padding
                    const scale = containerWidth / data.originalWidth;
                    setBaseScale(scale);
                    setZoom(1.0);
                    
                    // Скролл к первому highlight
                    if (showPageMarkup && data.highlights?.length > 0) {
                        setTimeout(() => {
                            const h = data.highlights[0];
                            const scrollY = h.y * scale - 100;
                            containerRef.current?.scrollTo({ top: Math.max(0, scrollY), behavior: 'smooth' });
                        }, 300);
                    } else {
                        containerRef.current?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                    }
                }
            }, [data, imgLoaded, showPageMarkup]);

            // Прогресс загрузки
            useEffect(() => {
                if (loading || (data && !imgLoaded && !imageLoadFailed)) {
                    setLoadProgress(0);
                    const interval = setInterval(() => {
                        setLoadProgress(prev => prev >= 90 ? prev : prev + Math.random() * 15);
                    }, 200);
                    return () => clearInterval(interval);
                } else {
                    setLoadProgress(100);
                }
            }, [loading, data, imgLoaded, imageLoadFailed]);

            const openInYandex = () => {
                if (item?.url) window.open(item.url, '_blank');
            };

            const fitToWidth = () => {
                if (data && containerRef.current) {
                    const containerWidth = containerRef.current.clientWidth - 32;
                    const scale = containerWidth / data.originalWidth;
                    setBaseScale(scale);
                    setZoom(1.0);
                }
            };

            const finalScale = baseScale * zoom;

            return (
                <>
                    <div className="sheet-header">
                        <div className="sheet-title truncate" title={item.periodical}>{item.periodical}</div>
                        <div style={{fontSize: '12px', color: '#555', marginTop: '4px'}} className="truncate" title={item.issue}>{item.issue}</div>
                        {item.cipher && <div className="sheet-subtitle truncate">{item.cipher}</div>}
                    </div>
                    
                    <div className="sheet-controls">
                        <div className="sheet-controls-group">
                            <button onClick={() => setZoom(z => Math.max(0.5, z * 0.8))}>−</button>
                            <span className="sheet-controls-zoom">{Math.round(zoom * 100)}%</span>
                            <button onClick={() => setZoom(z => Math.min(4, z * 1.25))}>+</button>
                        </div>
                        
                        <button onClick={fitToWidth} className="sheet-controls-btn-text" title="Вписать по ширине">↔</button>
                        <button onClick={() => setZoom(1.0)} className="sheet-controls-btn-text">Сброс</button>
                        {pageMarkupToggleAvailable && (
                            <button
                                onClick={() => setShowPageMarkup(prev => !prev)}
                                className={`sheet-controls-btn-text ${showPageMarkup ? 'sheet-controls-btn-accent' : ''}`}
                                title="Показать или скрыть блоки разметки для этой страницы"
                            >
                                {showPageMarkup ? 'Разметка: вкл' : 'Разметка'}
                            </button>
                        )}
                        <a href={item.url} target="_blank" rel="noopener noreferrer" className="sheet-controls-btn-text sheet-controls-btn-accent" title="Открыть в Яндекс.Архиве"><IconExternal /></a>
                    </div>
                    
                    <div className="sheet-image-area" ref={containerRef}>
                        {(loading || (data && !imgLoaded && !imageLoadFailed)) && (
                            <div className="flex flex-col items-center justify-center py-16">
                                <div className="loader-paper"></div>
                                <div className="mt-4 text-sm text-stone-500">
                                    {loading ? 'Получение данных...' : 'Загрузка снимка...'}
                                </div>
                                <div className="progress-bar-container mt-3">
                                    <div className="progress-bar" style={{width: `${loadProgress}%`}}></div>
                                </div>
                                <div className="text-xs text-stone-400 mt-1">{Math.round(loadProgress)}%</div>
                            </div>
                        )}
                        {data && (
                            <div 
                                className="relative bg-white shadow-xl mx-auto"
                                style={{
                                    width: data.originalWidth * finalScale,
                                    height: data.originalHeight * finalScale
                                }}
                            >
                                {blobUrl && <img 
                                    src={blobUrl}
                                    className={`w-full h-full block img-fade ${imgLoaded ? 'loaded' : ''}`}
                                    referrerPolicy={shouldUseNoReferrerForViewerImage(blobUrl) ? "no-referrer" : undefined}
                                    onLoad={() => {
                                        setImgLoaded(true);
                                        setImageLoadFailed(false);
                                    }}
                                    onError={() => {
                                        const nextCandidate = getNextViewerImageCandidate(data, imageStage, blobUrl);
                                        if (nextCandidate?.url && nextCandidate.url !== blobUrl) {
                                            setBlobUrl(nextCandidate.url);
                                            setImageStage(nextCandidate.stage);
                                            setImgLoaded(false);
                                            return;
                                        }
                                        setImageLoadFailed(true);
                                        setImgLoaded(false);
                                    }}
                                    onContextMenu={e => e.preventDefault()}
                                    onDragStart={e => e.preventDefault()}
                                    style={{WebkitUserSelect: 'none', userSelect: 'none'}}
                                />}
                                {imageLoadFailed && (
                                    <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center bg-stone-50 text-stone-500">
                                        <div className="text-sm font-semibold text-stone-700">Не удалось загрузить изображение</div>
                                        <div className="mt-2 text-xs leading-5">
                                            Яндекс временно ограничил выдачу снимка. Можно открыть страницу в Архиве и попробовать чуть позже.
                                        </div>
                                    </div>
                                )}
                                {imgLoaded && showPageMarkup && data.highlights?.map((h, i) => (
                                    <div 
                                        key={i} 
                                        className="highlight-box"
                                        style={{
                                            left: h.x * finalScale,
                                            top: h.y * finalScale,
                                            width: h.width * finalScale,
                                            height: h.height * finalScale
                                        }}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </>
            );
        };

        // === IMAGE VIEWER ===
        const ImageViewer = ({ item, pid, ownerId, canEditProject, onItemUpdate, onStructuredSave = null, editorOnly = false, initialEditingFragmentIndex = null, initialEditingStructuredPersonTarget = null, onEditorClose = null, scrollToEntry = '', scrollToEntryIndex = -1 }) => {
            const DEFAULT_SNIPPET_PREVIEW_ZOOM = 1.25;
            const [data, setData] = useState(null);
            const [zoom, setZoom] = useState(1.0);
            const [baseScale, setBaseScale] = useState(1.0);
            const [loading, setLoading] = useState(true);
            const [imgLoaded, setImgLoaded] = useState(false);
            const [loadProgress, setLoadProgress] = useState(0);
            const [selectedFragmentIndex, setSelectedFragmentIndex] = useState(null);
            const [selectedStructuredEntryIndex, setSelectedStructuredEntryIndex] = useState(null);
            const [undoStack, setUndoStack] = useState([]);
            const [pendingAction, setPendingAction] = useState(false);
            const [editingFragmentIndex, setEditingFragmentIndex] = useState(null);
            const [editingTextDraft, setEditingTextDraft] = useState('');
            const [editingRecordFieldsDraft, setEditingRecordFieldsDraft] = useState(() => createEmptySnippetRecordFields());
            const [savingTextEdit, setSavingTextEdit] = useState(false);
            const [editingStructuredPersonTarget, setEditingStructuredPersonTarget] = useState(null);
            const [editingStructuredPersonDraft, setEditingStructuredPersonDraft] = useState(() => createEmptyStructuredPersonDraft());
            const [editingStructuredDeathCauseDraft, setEditingStructuredDeathCauseDraft] = useState('');
            const [editingStructuredEventDateDraft, setEditingStructuredEventDateDraft] = useState('');
            const [savingStructuredPersonEdit, setSavingStructuredPersonEdit] = useState(false);
            const [previewZoom, setPreviewZoom] = useState(DEFAULT_SNIPPET_PREVIEW_ZOOM);
            const [previewPan, setPreviewPan] = useState({ x: 0, y: 0 });
            const [isPreviewDragging, setIsPreviewDragging] = useState(false);
            const [columnAnchors, setColumnAnchors] = useState([]);
            const [selectedColumnIds, setSelectedColumnIds] = useState([]);
            const [showDeletedFragments, setShowDeletedFragments] = useState(false);
            const pageMarkupToggleAvailable = supportsPageMarkupToggle(pid);
            const [showPageMarkup, setShowPageMarkup] = useState(() => shouldShowPageMarkupByDefault(pid));
            const container = useRef(null);
            const hasAutoOpenedEditorRef = useRef(false);
            const hasInitialFocusRef = useRef(false);
            const editTextareaRef = useRef(null);
            const previewDragRef = useRef(null);
            const [blobUrl, setBlobUrl] = useState(null);
            const [imageStage, setImageStage] = useState('proxy');
            const [imageLoadFailed, setImageLoadFailed] = useState(false);
            const [viewerLoadError, setViewerLoadError] = useState('');
            const [previewImageLoaded, setPreviewImageLoaded] = useState(false);
            const lastViewerAutoRefreshAtRef = useRef(0);
            const hiresFileInputRef = useRef(null);
            const [hiresModalOpen, setHiresModalOpen] = useState(false);
            const [hiresBusy, setHiresBusy] = useState(false);
            const [hiresScriptBusy, setHiresScriptBusy] = useState(false);
            const [hiresCaptureScriptBusy, setHiresCaptureScriptBusy] = useState(false);
            const [hiresConsoleScript, setHiresConsoleScript] = useState('');
            const [hiresSignedUrlDraft, setHiresSignedUrlDraft] = useState('');
            const columnLayoutStorageKey = useMemo(() => `snippet-columns:${pid}:${item.id}`, [pid, item.id]);
            const editorParishId = useMemo(
                () => normalizeParentsParishId(item?.parish_id || initialEditingStructuredPersonTarget?.parishId || ''),
                [initialEditingStructuredPersonTarget?.parishId, item?.parish_id]
            );

            const applyDocUpdate = useCallback((payload, meta = null) => {
                setData(prev => prev ? ({
                    ...prev,
                    highlights: payload.highlights || [],
                    highlightFragments: payload.highlight_fragments || [],
                    deletedHighlightFragments: payload.deleted_highlight_fragments || prev.deletedHighlightFragments || [],
                    highlightMode: payload.highlight_mode || prev.highlightMode,
                    structuredEntries: payload.structured_entries || prev.structuredEntries || [],
                    structuredSummary: payload.structured_summary ?? prev.structuredSummary,
                    structuredSearchText: payload.structured_search_text ?? prev.structuredSearchText,
                    structuredHasManualEdits: payload.structured_has_manual_edits ?? prev.structuredHasManualEdits,
                    snippet: payload.snippet ?? prev.snippet,
                    text: payload.text ?? prev.text
                }) : prev);
                onItemUpdate?.(item.id, {
                    highlights: payload.highlights || [],
                    highlight_fragments: payload.highlight_fragments || [],
                    deleted_highlight_fragments: payload.deleted_highlight_fragments || [],
                    highlight_mode: payload.highlight_mode,
                    structured_entries: payload.structured_entries,
                    structured_summary: payload.structured_summary,
                    structured_search_text: payload.structured_search_text,
                    structured_has_manual_edits: payload.structured_has_manual_edits,
                    snippet: payload.snippet ?? item.snippet,
                    text: payload.text ?? item.text
                }, meta);
            }, [item.id, item.snippet, item.text, onItemUpdate]);

            const applyViewerPayload = useCallback((payload, itemPatch = null) => {
                const normalized = normalizeViewerData(payload, { pid, itemId: item.id, ownerId: ownerId || item.owner_id });
                // Не сбрасываем blobUrl/imgLoaded — если URL картинки не изменился (типичный случай при
                // авто-рефреше на focus/visibilitychange), картинка остаётся видимой, никакого мигания и
                // повторной сетевой загрузки. Если URL действительно изменился, useEffect ниже подхватит.
                setData(normalized);
                if (itemPatch) {
                    onItemUpdate?.(item.id, itemPatch);
                }
                return normalized;
            }, [item.id, item.owner_id, onItemUpdate, ownerId, pid]);

            const refreshViewerData = useCallback(async () => {
                const params = new URLSearchParams({
                    url: item.url,
                    item_id: item.id,
                    pid
                });
                if (ownerId || item.owner_id) params.set('owner_id', String(ownerId || item.owner_id));
                if (editorOnly) params.set('editor_only', '1');
                const response = await fetch(`${API_BASE}/image?${params.toString()}`);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const payload = await response.json();
                applyViewerPayload(payload, {
                    highlights: payload.highlights || [],
                    highlight_fragments: payload.highlight_fragments || [],
                    deleted_highlight_fragments: payload.deleted_highlight_fragments || [],
                    highlight_mode: payload.highlight_mode,
                    snippet: payload.snippet ?? item.snippet,
                    text: payload.text ?? item.text,
                    structured_entries: payload.structured_entries,
                    structured_summary: payload.structured_summary,
                    structured_search_text: payload.structured_search_text,
                    structured_has_manual_edits: payload.structured_has_manual_edits,
                    hires_image: payload.hires_image,
                    hires_image_mime: payload.hires_image_mime,
                    hires_image_width: payload.hires_image_width,
                    hires_image_height: payload.hires_image_height,
                    hires_image_source: payload.hires_image_source,
                    hires_image_updated_at: payload.hires_image_updated_at,
                    hires_page_url: payload.hires_page_url
                });
            }, [applyViewerPayload, editorOnly, item.id, item.owner_id, item.snippet, item.text, item.url, pid]);

            const showSnippetWorkbench = canEditProject && !STRUCTURED_PARTICIPANTS_PROJECT_IDS.has(pid) && isAllSnippetsMode(data?.highlightMode || item.highlight_mode);
            const showStructuredParticipantsPanel = STRUCTURED_PARTICIPANTS_PROJECT_IDS.has(pid);
            const showStructuredRecordFields = pid === 'mospriyut';
            const structuredEntries = data?.structuredEntries || [];
            const workbenchPlans = useMemo(
                () => getSnippetWorkbenchPlans(data?.highlightFragments || []),
                [data?.highlightFragments]
            );
            const planSets = useMemo(() => ({
                short: new Set(workbenchPlans.short),
                numeric: new Set(workbenchPlans.numeric),
                headers: new Set(workbenchPlans.headers),
                duplicates: new Set(workbenchPlans.duplicates)
            }), [workbenchPlans]);
            const bulkActions = useMemo(() => ([
                { key: 'short', label: 'Короткие', count: workbenchPlans.short.length, indices: workbenchPlans.short, description: 'короткие строки' },
                { key: 'numeric', label: 'Числа', count: workbenchPlans.numeric.length, indices: workbenchPlans.numeric, description: 'числовые блоки' },
                { key: 'headers', label: 'Шапка', count: workbenchPlans.headers.length, indices: workbenchPlans.headers, description: 'верхние служебные строки' },
                { key: 'duplicates', label: 'Повторы', count: workbenchPlans.duplicates.length, indices: workbenchPlans.duplicates, description: 'повторяющиеся фрагменты' }
            ]), [workbenchPlans]);
            const columnLayout = useMemo(
                () => mapSnippetColumns(data?.highlightFragments || [], columnAnchors, data?.originalWidth),
                [data?.highlightFragments, data?.originalWidth, columnAnchors]
            );
            const deletedColumnLayout = useMemo(
                () => mapSnippetColumns(data?.deletedHighlightFragments || [], columnAnchors, data?.originalWidth),
                [data?.deletedHighlightFragments, data?.originalWidth, columnAnchors]
            );
            const selectedColumnSet = useMemo(() => new Set(selectedColumnIds), [selectedColumnIds]);
            const selectedColumnIndices = useMemo(
                () => columnLayout.columns
                    .filter(column => selectedColumnSet.has(column.id))
                    .flatMap(column => column.indices)
                    .sort((a, b) => a - b),
                [columnLayout.columns, selectedColumnSet]
            );
            const visibleWorkbenchIndices = useMemo(() => {
                const allIndices = (data?.highlightFragments || []).map((_, index) => index);
                if (!selectedColumnIds.length) return allIndices;
                return allIndices.filter(index => selectedColumnSet.has(columnLayout.fragmentColumns[index]));
            }, [data?.highlightFragments, selectedColumnIds, selectedColumnSet, columnLayout.fragmentColumns]);
            const selectedColumnsLabel = useMemo(
                () => formatColumnSelectionLabel(selectedColumnIds),
                [selectedColumnIds]
            );
            const editingFragment = editingFragmentIndex !== null ? data?.highlightFragments?.[editingFragmentIndex] : null;
            const editingFragmentColumnId = editingFragmentIndex !== null ? columnLayout.fragmentColumns[editingFragmentIndex] : null;
            const editingFragmentEdited = isSnippetFragmentEdited(editingFragment);
            const editingFragmentEditedBy = editingFragment?.edited_by || {};
            const editingFragmentEditedAtLabel = formatSnippetEditTimestamp(editingFragment?.edited_at);
            const editingFragmentHasAudit = Boolean(editingFragment?.edited_at || editingFragment?.edited_by);
            const editingRecordFieldsBase = useMemo(
                () => normalizeSnippetRecordFields(editingFragment?.parsed_fields || editingFragment?.parsed_fields_original),
                [editingFragment]
            );
            const editingRecordFieldsChanged = useMemo(
                () => showStructuredRecordFields && !areSnippetRecordFieldsEqual(editingRecordFieldsDraft, editingRecordFieldsBase),
                [showStructuredRecordFields, editingRecordFieldsDraft, editingRecordFieldsBase]
            );
            const editingFragmentCropBox = useMemo(
                () => getSnippetImageCropBox(editingFragment, data?.originalWidth, data?.originalHeight),
                [editingFragment, data?.originalWidth, data?.originalHeight]
            );
            const editingPreviewViewport = useMemo(
                () => getSnippetPreviewViewport(editingFragmentCropBox, previewZoom, previewPan),
                [editingFragmentCropBox, previewZoom, previewPan]
            );
            const deletedFragments = data?.deletedHighlightFragments || [];
            const deletedWorkbenchEntries = useMemo(
                () => deletedFragments.map((fragment, index) => ({
                    fragment,
                    index,
                    columnId: deletedColumnLayout.fragmentColumns[index] || null
                })).reverse(),
                [deletedFragments, deletedColumnLayout.fragmentColumns]
            );
            const c4Column = useMemo(
                () => columnLayout.columns.find(column => column.id === 'c4') || null,
                [columnLayout.columns]
            );
            const keepOnlyC4Indices = useMemo(() => {
                if (!c4Column || !(data?.highlightFragments || []).length) return [];
                const keepIndices = new Set(c4Column.indices);
                return (data.highlightFragments || []).map((_, index) => index).filter(index => !keepIndices.has(index));
            }, [c4Column, data?.highlightFragments]);
            const selectedStructuredEntry = selectedStructuredEntryIndex !== null ? structuredEntries[selectedStructuredEntryIndex] : null;
            const editingStructuredEntry = editingStructuredPersonTarget !== null ? structuredEntries?.[editingStructuredPersonTarget?.entryIndex] : null;
            const editingStructuredPerson = editingStructuredEntry?.people?.[editingStructuredPersonTarget?.personIndex] || null;
            const editingStructuredEntryType = String(editingStructuredEntry?.type || '').trim().toUpperCase();
            const editingStructuredPersonEdited = isStructuredPersonEdited(editingStructuredPerson);
            const editingStructuredPersonOriginal = useMemo(
                () => getStructuredPersonOriginal(editingStructuredPerson),
                [editingStructuredPerson]
            );
            const editingStructuredPersonEditedBy = editingStructuredPerson?.edited_by || {};
            const editingStructuredPersonEditedAtLabel = formatSnippetEditTimestamp(editingStructuredPerson?.edited_at);
            const editingStructuredPersonHasAudit = Boolean(editingStructuredPerson?.edited_at || editingStructuredPerson?.edited_by);
            const editingStructuredEntryResolvedDeathCause = useMemo(
                () => getStructuredEntryResolvedDeathCause(editingStructuredEntry),
                [editingStructuredEntry]
            );
            const editingStructuredEntryOriginalDeathCause = useMemo(
                () => getStructuredEntryOriginalDeathCause(editingStructuredEntry),
                [editingStructuredEntry]
            );
            const editingStructuredEntryDeathCauseEditedBy = editingStructuredEntry?.death_cause_edited_by || {};
            const editingStructuredEntryDeathCauseEditedAtLabel = formatSnippetEditTimestamp(editingStructuredEntry?.death_cause_edited_at);
            const editingStructuredEntryDeathCauseHasAudit = isStructuredEntryDeathCauseEdited(editingStructuredEntry);
            const editingStructuredEntryEventDateRecord = useMemo(
                () => getStructuredEntryPrimaryDateRecord(editingStructuredEntry),
                [editingStructuredEntry]
            );
            const editingStructuredEntryOriginalDateRecord = useMemo(
                () => getStructuredEntryOriginalDateRecord(editingStructuredEntry),
                [editingStructuredEntry]
            );
            const editingStructuredEntryEventDateEditedBy = editingStructuredEntryEventDateRecord?.edited_by || {};
            const editingStructuredEntryEventDateEditedAtLabel = formatSnippetEditTimestamp(editingStructuredEntryEventDateRecord?.edited_at);
            const editingStructuredEntryEventDateHasAudit = isStructuredEntryEventDateEdited(editingStructuredEntry);
            const editingStructuredEntryCropBox = useMemo(
                () => getStructuredEntryCropBox(editingStructuredEntry, data?.originalWidth, data?.originalHeight),
                [editingStructuredEntry, data?.originalWidth, data?.originalHeight]
            );
            const editingStructuredPreviewViewport = useMemo(
                () => getSnippetPreviewViewport(editingStructuredEntryCropBox, previewZoom, previewPan),
                [editingStructuredEntryCropBox, previewZoom, previewPan]
            );
            const editingStructuredPersonDisplayName = formatStructuredPersonName(editingStructuredPerson) || 'Без имени';
            const editorBootstrapLabel = useMemo(() => (
                cleanStructuredValue(initialEditingStructuredPersonTarget?.matchLabel || '')
                || cleanStructuredValue(initialEditingStructuredPersonTarget?.personLabel || '')
                || 'Запись'
            ), [initialEditingStructuredPersonTarget]);
            const editingStructuredPersonChanged = useMemo(() => {
                const current = normalizeStructuredPersonDraft(editingStructuredPerson);
                const draft = normalizeStructuredPersonDraft(editingStructuredPersonDraft);
                return STRUCTURED_PERSON_FIELD_CONFIG.some(field => current[field.key] !== draft[field.key]);
            }, [editingStructuredPerson, editingStructuredPersonDraft]);
            const editingStructuredDeathCauseChanged = useMemo(() => (
                editingStructuredEntryType === 'DEATH'
                && normalizeStructuredEntryDeathCauseValue(editingStructuredDeathCauseDraft) !== editingStructuredEntryResolvedDeathCause
            ), [editingStructuredEntryType, editingStructuredDeathCauseDraft, editingStructuredEntryResolvedDeathCause]);
            const editingStructuredEventDateChanged = useMemo(() => (
                Boolean(getStructuredEntryPrimaryDateKind(editingStructuredEntry))
                && String(editingStructuredEventDateDraft || '').trim() !== getStructuredEntryPrimaryDateValue(editingStructuredEntry)
            ), [editingStructuredEntry, editingStructuredEventDateDraft]);
            const editingStructuredRecordChanged = editingStructuredPersonChanged
                || editingStructuredDeathCauseChanged
                || editingStructuredEventDateChanged;
            const hasHiresImage = Boolean(String(data?.hiresImage || item?.hires_image || '').trim());
            const hiresUpdatedLabel = formatSnippetEditTimestamp(data?.hiresImageUpdatedAt || item?.hires_image_updated_at || '');

            // Симуляция прогресса загрузки
            useEffect(() => {
                if (loading || (data && !imgLoaded && !imageLoadFailed)) {
                    setLoadProgress(0);
                    const interval = setInterval(() => {
                        setLoadProgress(prev => {
                            if (prev >= 90) return prev;
                            return prev + Math.random() * 15;
                        });
                    }, 200);
                    return () => clearInterval(interval);
                } else {
                    setLoadProgress(100);
                }
            }, [loading, data, imgLoaded, imageLoadFailed]);

            useEffect(() => {
                setLoading(true);
                setImgLoaded(false);
                setSelectedFragmentIndex(null);
                setSelectedStructuredEntryIndex(null);
                setUndoStack([]);
                setEditingFragmentIndex(null);
                setEditingTextDraft('');
                setEditingRecordFieldsDraft(createEmptySnippetRecordFields());
                setEditingStructuredPersonTarget(null);
                setEditingStructuredPersonDraft(createEmptyStructuredPersonDraft());
                setEditingStructuredDeathCauseDraft('');
                setEditingStructuredEventDateDraft('');
                setSelectedColumnIds([]);
                setShowDeletedFragments(false);
                setShowPageMarkup(shouldShowPageMarkupByDefault(pid));
                setBlobUrl(null);
                setImageStage('proxy');
                setImageLoadFailed(false);
                setViewerLoadError('');
                try {
                    const savedAnchors = JSON.parse(localStorage.getItem(columnLayoutStorageKey) || '[]');
                    setColumnAnchors(Array.isArray(savedAnchors) ? savedAnchors : []);
                } catch (e) {
                    setColumnAnchors([]);
                }
                hasInitialFocusRef.current = false;

                const hasCachedViewerData = item.image_id && item.highlights;
                const hasImmediateViewerImage = Boolean(item?.image_id || item?.hires_image || item?.hiresImageUrl);
                const needsFreshFragments = isAllSnippetsMode(item.highlight_mode) && !(item.highlight_fragments || []).length;

                if (hasImmediateViewerImage) {
                    setData(normalizeViewerData(item, { pid, itemId: item.id, ownerId: ownerId || item.owner_id }));
                }

                if (hasCachedViewerData && !needsFreshFragments) {
                    setData(normalizeViewerData(item, { pid, itemId: item.id, ownerId: ownerId || item.owner_id }));
                    setLoading(false);
                } else {
                    const params = new URLSearchParams({
                        url: item.url,
                        item_id: item.id,
                        pid: pid
                    });
                    if (ownerId || item.owner_id) params.set('owner_id', String(ownerId || item.owner_id));
                    if (editorOnly) params.set('editor_only', '1');
                    fetch(`${API_BASE}/image?${params}`).then(async (r) => {
                        if (!r.ok) {
                            let message = `HTTP ${r.status}`;
                            try {
                                const payload = await r.json();
                                message = payload?.error || message;
                            } catch (e) {}
                            throw new Error(message);
                        }
                        return r.json();
                    }).then(d => {
                        const normalized = normalizeViewerData(d, { pid, itemId: item.id, ownerId: ownerId || item.owner_id });
                        setData(normalized);
                        if (normalized) {
                            onItemUpdate?.(item.id, {
                                highlights: normalized.highlights || [],
                                highlight_fragments: normalized.highlightFragments || [],
                                highlight_mode: normalized.highlightMode,
                                snippet: normalized.snippet ?? item.snippet,
                                text: normalized.text ?? item.text,
                                structured_entries: normalized.structuredEntries,
                                structured_summary: normalized.structuredSummary,
                                structured_search_text: normalized.structuredSearchText,
                                structured_has_manual_edits: normalized.structuredHasManualEdits,
                                hires_image: normalized.hiresImage,
                                hires_image_mime: normalized.hiresImageMime,
                                hires_image_width: normalized.hiresImageWidth,
                                hires_image_height: normalized.hiresImageHeight,
                                hires_image_source: normalized.hiresImageSource,
                                hires_image_updated_at: normalized.hiresImageUpdatedAt,
                                hires_page_url: normalized.hiresPageUrl
                            });
                        }
                        setLoading(false);
                    }).catch(error => {
                        console.error('Failed to load viewer data', error);
                        setViewerLoadError(error?.message || 'Не удалось загрузить запись');
                        setLoading(false);
                    });
                }
            }, [item.id, pid, ownerId, columnLayoutStorageKey]);

            useEffect(() => {
                hasAutoOpenedEditorRef.current = false;
            }, [item.id, editorOnly, initialEditingFragmentIndex, initialEditingStructuredPersonTarget]);

            useEffect(() => {
                if (!showSnippetWorkbench || columnAnchors.length) return;
                const combinedFragments = [...(data?.highlightFragments || []), ...(data?.deletedHighlightFragments || [])];
                if (combinedFragments.length) {
                    setColumnAnchors(buildSnippetColumnAnchors(combinedFragments, data.originalWidth));
                }
            }, [showSnippetWorkbench, data?.highlightFragments, data?.deletedHighlightFragments, data?.originalWidth, columnAnchors.length]);

            useEffect(() => {
                if (!showSnippetWorkbench || !columnAnchors.length) return;
                try {
                    localStorage.setItem(columnLayoutStorageKey, JSON.stringify(columnAnchors));
                } catch (e) {}
            }, [showSnippetWorkbench, columnAnchors, columnLayoutStorageKey]);

            useEffect(() => {
                if (!selectedColumnIds.length) return;
                const available = new Set(columnLayout.columns.map(column => column.id));
                setSelectedColumnIds(prev => prev.filter(id => available.has(id)));
            }, [columnLayout.columns, selectedColumnIds.length]);

            useEffect(() => {
                const initialCandidate = buildViewerImageCandidates(data)[0];
                if (initialCandidate?.url) {
                    setBlobUrl(initialCandidate.url);
                    setImageStage(initialCandidate.stage);
                    setImageLoadFailed(false);
                }
            }, [data?.hiresImageUrl, data?.proxyImageUrl, data?.originalUrl]);

            // Зум > 1× → апгрейд preview до оригинала
            useEffect(() => {
                if (zoom > 1.0 && imageStage === 'proxy-preview' && data?.proxyImageUrl) {
                    setBlobUrl(data.proxyImageUrl);
                    setImageStage('proxy-original');
                }
            }, [zoom, imageStage, data?.proxyImageUrl]);

            useEffect(() => {
                if (!blobUrl) {
                    setPreviewImageLoaded(false);
                    return undefined;
                }
                let cancelled = false;
                const previewImage = new window.Image();
                setPreviewImageLoaded(false);
                previewImage.onload = () => {
                    if (!cancelled) setPreviewImageLoaded(true);
                };
                previewImage.onerror = () => {
                    if (!cancelled) setPreviewImageLoaded(false);
                };
                previewImage.src = blobUrl;
                return () => {
                    cancelled = true;
                };
            }, [blobUrl]);

            // Умный автомасштаб: адаптируется под соотношение сторон
            useEffect(() => {
                if (data && container.current && imgLoaded) {
                    const containerHeight = container.current.clientHeight - 60;
                    const containerWidth = container.current.clientWidth - 60;

                    const scaleByHeight = containerHeight / data.originalHeight;
                    const scaleByWidth = containerWidth / data.originalWidth;
                    const aspectRatio = data.originalHeight / data.originalWidth;

                    let fitScale;
                    if (aspectRatio > 1.4) {
                        fitScale = scaleByWidth;
                    } else if (aspectRatio > 1.1) {
                        fitScale = (scaleByHeight + scaleByWidth) / 2;
                    } else {
                        fitScale = Math.min(scaleByHeight, scaleByWidth);
                    }

                    setBaseScale(fitScale);
                    setZoom(1.0);
                }
            }, [data, imgLoaded]);

            const scale = baseScale * zoom;

            const scrollToFragment = useCallback((fragmentIndex, behavior = 'smooth') => {
                const fragment = data?.highlightFragments?.[fragmentIndex] || data?.highlights?.[fragmentIndex];
                if (!fragment || !container.current) return;
                const currentScale = baseScale * zoom;
                container.current.scrollTo({
                    top: Math.max(0, fragment.y * currentScale - container.current.clientHeight / 3),
                    left: Math.max(0, fragment.x * currentScale - 120),
                    behavior
                });
            }, [data, baseScale, zoom]);

            const scrollToStructuredEntry = useCallback((entryIndex, behavior = 'smooth') => {
                const entry = structuredEntries?.[entryIndex];
                const bbox = entry?.bbox;
                if (!bbox || !container.current) return;
                const currentScale = baseScale * zoom;
                container.current.scrollTo({
                    top: Math.max(0, Number(bbox.y || 0) * currentScale - container.current.clientHeight / 3),
                    left: Math.max(0, Number(bbox.x || 0) * currentScale - 120),
                    behavior
                });
            }, [structuredEntries, baseScale, zoom]);

            // Автоскролл к первому highlight
            useEffect(() => {
                if (hasInitialFocusRef.current || !container.current || !imgLoaded || baseScale <= 0) return;
                hasInitialFocusRef.current = true;
                if (showPageMarkup && data?.highlights?.length > 0) {
                    setTimeout(() => {
                        scrollToFragment(0);
                    }, 300);
                } else {
                    container.current.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                }
            }, [data, imgLoaded, baseScale, scrollToFragment, showPageMarkup]);

            useEffect(() => {
                if (selectedFragmentIndex !== null && imgLoaded) {
                    scrollToFragment(selectedFragmentIndex);
                }
            }, [selectedFragmentIndex, imgLoaded, scrollToFragment]);

            useEffect(() => {
                if (selectedStructuredEntryIndex !== null && imgLoaded) {
                    scrollToStructuredEntry(selectedStructuredEntryIndex);
                }
            }, [selectedStructuredEntryIndex, imgLoaded, scrollToStructuredEntry]);

            useEffect(() => {
                if (editingFragmentIndex === null) return;
                setPreviewZoom(DEFAULT_SNIPPET_PREVIEW_ZOOM);
                setPreviewPan({ x: 0, y: 0 });
                setIsPreviewDragging(false);
                previewDragRef.current = null;
                const focusTimer = setTimeout(() => {
                    editTextareaRef.current?.focus();
                    editTextareaRef.current?.setSelectionRange(editingTextDraft.length, editingTextDraft.length);
                }, 30);
                return () => clearTimeout(focusTimer);
            }, [editingFragmentIndex]);

            useEffect(() => {
                if (editingStructuredPersonTarget === null) return;
                setPreviewZoom(DEFAULT_SNIPPET_PREVIEW_ZOOM);
                setPreviewPan({ x: 0, y: 0 });
                setIsPreviewDragging(false);
                previewDragRef.current = null;
            }, [editingStructuredPersonTarget]);

            useEffect(() => {
                if (editingFragmentIndex === null && editingStructuredPersonTarget === null) return;
                const handleKeyDown = (event) => {
                    if (event.key === 'Escape') {
                        if (editingStructuredPersonTarget !== null) {
                            cancelEditingStructuredPerson();
                        } else {
                            cancelEditingFragment();
                        }
                    }
                };
                window.addEventListener('keydown', handleKeyDown);
                return () => window.removeEventListener('keydown', handleKeyDown);
            }, [editingFragmentIndex, editingStructuredPersonTarget]);

            const openInYandex = () => {
                if (item?.url) {
                    window.open(item.url, '_blank');
                }
            };

            const resetPreviewViewport = () => {
                setPreviewZoom(DEFAULT_SNIPPET_PREVIEW_ZOOM);
                setPreviewPan({ x: 0, y: 0 });
            };

            const handlePreviewWheel = (event) => {
                event.preventDefault();
                const direction = event.deltaY < 0 ? 1.12 : 1 / 1.12;
                setPreviewZoom(prev => clampNumber(prev * direction, 1, 3.5));
            };

            const handlePreviewPointerDown = (event) => {
                const activeViewport = editingFragment ? editingPreviewViewport : editingStructuredPreviewViewport;
                if (!activeViewport) return;
                event.preventDefault();
                const bounds = event.currentTarget.getBoundingClientRect();
                previewDragRef.current = {
                    pointerId: event.pointerId,
                    startClientX: event.clientX,
                    startClientY: event.clientY,
                    startPanX: previewPan.x,
                    startPanY: previewPan.y,
                    boundsWidth: bounds.width || 1,
                    boundsHeight: bounds.height || 1,
                    viewportWidth: activeViewport.width,
                    viewportHeight: activeViewport.height
                };
                setIsPreviewDragging(true);
                event.currentTarget.setPointerCapture?.(event.pointerId);
            };

            const handlePreviewPointerMove = (event) => {
                const dragState = previewDragRef.current;
                if (!dragState || dragState.pointerId !== event.pointerId) return;
                event.preventDefault();
                const deltaX = event.clientX - dragState.startClientX;
                const deltaY = event.clientY - dragState.startClientY;
                const sourceDeltaX = -(deltaX / dragState.boundsWidth) * dragState.viewportWidth;
                const sourceDeltaY = -(deltaY / dragState.boundsHeight) * dragState.viewportHeight;
                setPreviewPan({
                    x: dragState.startPanX + sourceDeltaX,
                    y: dragState.startPanY + sourceDeltaY
                });
            };

            const stopPreviewDrag = (event) => {
                const dragState = previewDragRef.current;
                if (!dragState) return;
                if (event?.pointerId !== undefined && dragState.pointerId !== event.pointerId) return;
                previewDragRef.current = null;
                setIsPreviewDragging(false);
                if (event?.currentTarget?.hasPointerCapture?.(event.pointerId)) {
                    event.currentTarget.releasePointerCapture(event.pointerId);
                }
            };

            const removeFragments = async (indices, successMessage, historyLabel) => {
                if (!indices.length) return;
                setPendingAction(true);
                try {
                    const r = await fetch(`${API_BASE}/highlight/remove`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({ pid: pid, item_id: item.id, indices })
                    });
                    if (!r.ok) {
                        showToast('Ошибка удаления', 'error');
                        return;
                    }
                    const d = await r.json();
                    applyDocUpdate(d);
                    setSelectedFragmentIndex(null);
                    setEditingFragmentIndex(null);
                    setEditingTextDraft('');
                    setEditingRecordFieldsDraft(createEmptySnippetRecordFields());
                    if ((d.removed_fragments || []).length) {
                        setUndoStack(prev => [...prev, {
                            label: historyLabel,
                            fragments: d.removed_fragments
                        }].slice(-10));
                    }
                    showToast(successMessage, 'success');
                } catch (e) {
                    showToast('Ошибка удаления', 'error');
                } finally {
                    setPendingAction(false);
                }
            };

            const startEditingFragment = (fragmentIndex) => {
                const fragment = data?.highlightFragments?.[fragmentIndex];
                setSelectedFragmentIndex(fragmentIndex);
                setEditingFragmentIndex(fragmentIndex);
                setEditingTextDraft(fragment?.text || '');
                setEditingRecordFieldsDraft(normalizeSnippetRecordFields(fragment?.parsed_fields || fragment?.parsed_fields_original));
            };

            const startEditingStructuredPerson = (entryIndex, personIndex) => {
                const entry = structuredEntries?.[entryIndex];
                const person = entry?.people?.[personIndex];
                if (!person) return;
                setSelectedStructuredEntryIndex(entryIndex);
                setSelectedFragmentIndex(null);
                setEditingStructuredPersonTarget({ entryIndex, personIndex });
                setEditingStructuredPersonDraft(normalizeStructuredPersonDraft(person));
                setEditingStructuredDeathCauseDraft(getStructuredEntryResolvedDeathCause(entry));
                setEditingStructuredEventDateDraft(getStructuredEntryPrimaryDateValue(entry));
            };

            useEffect(() => {
                if (!editorOnly || hasAutoOpenedEditorRef.current) return;
                if (loading || !data) return;
                if (initialEditingStructuredPersonTarget) {
                    const requestedEntryId = String(initialEditingStructuredPersonTarget?.entryId || '').trim();
                    let entryIndex = -1;
                    if (requestedEntryId) {
                        entryIndex = structuredEntries.findIndex(entry => String(entry?.entry_id || '').trim() === requestedEntryId);
                    }
                    const fallbackEntryIndex = Number(initialEditingStructuredPersonTarget?.entryIndex);
                    if (entryIndex < 0 && Number.isInteger(fallbackEntryIndex) && fallbackEntryIndex >= 0 && structuredEntries?.[fallbackEntryIndex]) {
                        entryIndex = fallbackEntryIndex;
                    }
                    const requestedEventType = String(initialEditingStructuredPersonTarget?.eventType || '').trim().toUpperCase();
                    if (entryIndex < 0 && requestedEventType) {
                        entryIndex = structuredEntries.findIndex(entry => String(entry?.type || '').trim().toUpperCase() === requestedEventType);
                    }
                    if (entryIndex < 0) {
                        showToast('Не удалось открыть редактор для этой записи', 'warning');
                        onEditorClose?.();
                        return;
                    }
                    const entryPeople = structuredEntries?.[entryIndex]?.people || [];
                    const personIndex = resolveStructuredPersonIndexForEditorTarget(entryPeople, initialEditingStructuredPersonTarget);
                    if (!entryPeople[personIndex]) {
                        showToast('Не удалось открыть редактор для этой записи', 'warning');
                        onEditorClose?.();
                        return;
                    }
                    hasAutoOpenedEditorRef.current = true;
                    startEditingStructuredPerson(entryIndex, personIndex);
                    return;
                }
                const fragmentIndex = Number(initialEditingFragmentIndex);
                if (!Number.isInteger(fragmentIndex) || fragmentIndex < 0) return;
                if (!data?.highlightFragments?.[fragmentIndex]) return;
                hasAutoOpenedEditorRef.current = true;
                startEditingFragment(fragmentIndex);
            }, [editorOnly, initialEditingFragmentIndex, initialEditingStructuredPersonTarget, data, structuredEntries, onEditorClose]);

            // Auto-scroll к конкретной entry внутри overlay-окна. Когда
            // пользователь нажимает кнопку «↗» в строке дашборда, мы знаем
            // entry_id (или index). Передаём через props ImageViewer-у
            // (если overlay рендерится локально в текущей вкладке) или через
            // query-param scroll_to_entry (если overlay загружается в iframe).
            const autoScrolledEntryRef = useRef(false);
            useEffect(() => {
                if (autoScrolledEntryRef.current) return;
                if (loading || !data || !structuredEntries || structuredEntries.length === 0) return;
                let requestedEntryId = String(scrollToEntry || '').trim();
                let requestedEntryIndex = Number.isInteger(scrollToEntryIndex) ? scrollToEntryIndex : -1;
                if (!requestedEntryId && requestedEntryIndex < 0) {
                    try {
                        const params = new URLSearchParams(window.location.search || '');
                        requestedEntryId = String(params.get('scroll_to_entry') || '').trim();
                        const rawIdx = Number(params.get('scroll_to_entry_index'));
                        if (Number.isInteger(rawIdx) && rawIdx >= 0) requestedEntryIndex = rawIdx;
                    } catch (e) {}
                }
                if (!requestedEntryId && requestedEntryIndex < 0) return;
                let targetIndex = -1;
                if (requestedEntryId) {
                    targetIndex = structuredEntries.findIndex(e => String(e?.entry_id || '').trim() === requestedEntryId);
                }
                if (targetIndex < 0 && requestedEntryIndex >= 0 && requestedEntryIndex < structuredEntries.length) {
                    targetIndex = requestedEntryIndex;
                }
                if (targetIndex < 0) return;
                autoScrolledEntryRef.current = true;
                setSelectedStructuredEntryIndex(targetIndex);
                setSelectedFragmentIndex(null);
                const entry = structuredEntries[targetIndex];
                const domId = entry?.entry_id ? `entry-${entry.entry_id}` : `entry-index-${targetIndex}`;
                let attempts = 0;
                const tryScroll = () => {
                    const el = document.getElementById(domId);
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        return;
                    }
                    if (attempts++ < 12) setTimeout(tryScroll, 150);
                };
                setTimeout(tryScroll, 100);
            }, [loading, data, structuredEntries, scrollToEntry, scrollToEntryIndex]);

            const cancelEditingFragment = () => {
                setIsPreviewDragging(false);
                previewDragRef.current = null;
                setEditingFragmentIndex(null);
                setEditingTextDraft('');
                setEditingRecordFieldsDraft(createEmptySnippetRecordFields());
                if (editorOnly) onEditorClose?.();
            };

            const cancelEditingStructuredPerson = () => {
                setIsPreviewDragging(false);
                previewDragRef.current = null;
                setEditingStructuredPersonTarget(null);
                setEditingStructuredPersonDraft(createEmptyStructuredPersonDraft());
                setEditingStructuredDeathCauseDraft('');
                setEditingStructuredEventDateDraft('');
                if (editorOnly) onEditorClose?.();
            };

            const saveFragmentText = async (fragmentIndex) => {
                const nextText = editingTextDraft.trim();
                if (!nextText) {
                    showToast('Текст не должен быть пустым', 'warning');
                    return;
                }
                setSavingTextEdit(true);
                try {
                    const requestBody = { pid, item_id: item.id, index: fragmentIndex, text: nextText };
                    if (editorParishId) requestBody.parish_id = editorParishId;
                    if (showStructuredRecordFields && editingRecordFieldsChanged) {
                        requestBody.parsed_fields = normalizeSnippetRecordFields(editingRecordFieldsDraft);
                    }
                    const r = await fetch(`${API_BASE}/highlight/text/update`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify(requestBody)
                    });
                    if (!r.ok) {
                        showToast('Не удалось сохранить правку', 'error');
                        return;
                    }
                    const d = await r.json();
                    applyDocUpdate(d);
                    setEditingFragmentIndex(null);
                    setEditingTextDraft('');
                    setEditingRecordFieldsDraft(createEmptySnippetRecordFields());
                    showToast('Запись обновлена', 'success');
                    if (editorOnly) onEditorClose?.();
                } catch (e) {
                    showToast('Не удалось сохранить правку', 'error');
                } finally {
                    setSavingTextEdit(false);
                }
            };

            const restoreOriginalFragmentText = async (fragmentIndex) => {
                setSavingTextEdit(true);
                try {
                    const r = await fetch(`${API_BASE}/highlight/text/restore`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({
                            pid,
                            item_id: item.id,
                            index: fragmentIndex,
                            ...(editorParishId ? { parish_id: editorParishId } : {})
                        })
                    });
                    if (!r.ok) {
                        showToast('Не удалось вернуть оригинал', 'error');
                        return;
                    }
                    const d = await r.json();
                    applyDocUpdate(d);
                    setEditingFragmentIndex(null);
                    setEditingTextDraft('');
                    setEditingRecordFieldsDraft(createEmptySnippetRecordFields());
                    showToast('Возвращён оригинальный OCR-текст', 'success');
                    if (editorOnly) onEditorClose?.();
                } catch (e) {
                    showToast('Не удалось вернуть оригинал', 'error');
                } finally {
                    setSavingTextEdit(false);
                }
            };

            const saveStructuredPerson = async () => {
                if (!editingStructuredPersonTarget) return;
                const shouldSavePerson = editingStructuredPersonChanged;
                const shouldSaveDeathCause = editingStructuredEntryType === 'DEATH' && editingStructuredDeathCauseChanged;
                const shouldSaveEventDate = editingStructuredEventDateChanged;
                if (!shouldSavePerson && !shouldSaveDeathCause && !shouldSaveEventDate) return;
                if (shouldSaveEventDate && !/^\d{4}-\d{2}-\d{2}$/.test(String(editingStructuredEventDateDraft || '').trim())) {
                    showToast('Укажите полную дату события', 'warning');
                    return;
                }
                setSavingStructuredPersonEdit(true);
                let lastPayload = null;
                try {
                    if (shouldSavePerson) {
                        const r = await fetch(`${API_BASE}/structured/person/update`, {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json'},
                            body: JSON.stringify({
                                pid,
                                item_id: item.id,
                                ...(editorParishId ? { parish_id: editorParishId } : {}),
                                entry_index: editingStructuredPersonTarget.entryIndex,
                                person_index: editingStructuredPersonTarget.personIndex,
                                fields: normalizeStructuredPersonDraft(editingStructuredPersonDraft)
                            })
                        });
                        if (!r.ok) {
                            showToast('Не удалось сохранить участника', 'error');
                            return;
                        }
                        lastPayload = await r.json();
                    }
                    if (shouldSaveDeathCause || shouldSaveEventDate) {
                        const entryFields = {};
                        if (shouldSaveDeathCause) {
                            entryFields.death_cause = normalizeStructuredEntryDeathCauseValue(editingStructuredDeathCauseDraft);
                        }
                        if (shouldSaveEventDate) {
                            entryFields.event_date = String(editingStructuredEventDateDraft || '').trim();
                        }
                        const r = await fetch(`${API_BASE}/structured/entry/update`, {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json'},
                            body: JSON.stringify({
                                pid,
                                item_id: item.id,
                                ...(editorParishId ? { parish_id: editorParishId } : {}),
                                entry_index: editingStructuredPersonTarget.entryIndex,
                                fields: entryFields
                            })
                        });
                        if (!r.ok) {
                            if (lastPayload) {
                                applyDocUpdate(lastPayload, {
                                    entryId: String(editingStructuredEntry?.entry_id || '').trim(),
                                    entryIndex: editingStructuredPersonTarget?.entryIndex
                                });
                            }
                            showToast(shouldSaveEventDate ? 'Не удалось сохранить точную дату' : 'Не удалось сохранить причину смерти', 'error');
                            return;
                        }
                        lastPayload = await r.json();
                    }
                    if (lastPayload) {
                        const savedEntryMeta = {
                            entryId: String(editingStructuredEntry?.entry_id || '').trim(),
                            entryIndex: editingStructuredPersonTarget?.entryIndex,
                            refreshHandled: true
                        };
                        applyDocUpdate(lastPayload, {
                            ...savedEntryMeta
                        });
                        onStructuredSave?.(item.id, savedEntryMeta);
                    }
                    setEditingStructuredPersonTarget(null);
                    setEditingStructuredPersonDraft(createEmptyStructuredPersonDraft());
                    setEditingStructuredDeathCauseDraft('');
                    setEditingStructuredEventDateDraft('');
                    showToast(shouldSaveEventDate && !shouldSavePerson && !shouldSaveDeathCause ? 'Точная дата обновлена' : 'Запись обновлена', 'success');
                    if (editorOnly) onEditorClose?.();
                } catch (e) {
                    if (lastPayload) {
                        applyDocUpdate(lastPayload, {
                            entryId: String(editingStructuredEntry?.entry_id || '').trim(),
                            entryIndex: editingStructuredPersonTarget?.entryIndex
                        });
                        showToast('Часть правок уже сохранена, но завершить обновление не удалось', 'warning');
                        return;
                    }
                    showToast('Не удалось сохранить участника', 'error');
                } finally {
                    setSavingStructuredPersonEdit(false);
                }
            };

            const restoreOriginalStructuredPerson = async () => {
                if (!editingStructuredPersonTarget) return;
                const shouldRestorePerson = editingStructuredPersonEdited;
                const shouldRestoreDeathCause = editingStructuredEntryDeathCauseHasAudit;
                const shouldRestoreEventDate = editingStructuredEntryEventDateHasAudit;
                if (!shouldRestorePerson && !shouldRestoreDeathCause && !shouldRestoreEventDate) return;
                setSavingStructuredPersonEdit(true);
                let lastPayload = null;
                try {
                    if (shouldRestorePerson) {
                        const r = await fetch(`${API_BASE}/structured/person/restore`, {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json'},
                            body: JSON.stringify({
                                pid,
                                item_id: item.id,
                                ...(editorParishId ? { parish_id: editorParishId } : {}),
                                entry_index: editingStructuredPersonTarget.entryIndex,
                                person_index: editingStructuredPersonTarget.personIndex
                            })
                        });
                        if (!r.ok) {
                            showToast('Не удалось вернуть исходные данные', 'error');
                            return;
                        }
                        lastPayload = await r.json();
                    }
                    if (shouldRestoreDeathCause || shouldRestoreEventDate) {
                        const r = await fetch(`${API_BASE}/structured/entry/restore`, {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json'},
                            body: JSON.stringify({
                                pid,
                                item_id: item.id,
                                ...(editorParishId ? { parish_id: editorParishId } : {}),
                                entry_index: editingStructuredPersonTarget.entryIndex
                            })
                        });
                        if (!r.ok) {
                            if (lastPayload) {
                                applyDocUpdate(lastPayload, {
                                    entryId: String(editingStructuredEntry?.entry_id || '').trim(),
                                    entryIndex: editingStructuredPersonTarget?.entryIndex
                                });
                            }
                            showToast(shouldRestoreEventDate ? 'Не удалось вернуть исходную точную дату' : 'Не удалось вернуть исходную причину смерти', 'error');
                            return;
                        }
                        lastPayload = await r.json();
                    }
                    if (lastPayload) {
                        const restoredEntryMeta = {
                            entryId: String(editingStructuredEntry?.entry_id || '').trim(),
                            entryIndex: editingStructuredPersonTarget?.entryIndex,
                            refreshHandled: true
                        };
                        applyDocUpdate(lastPayload, {
                            ...restoredEntryMeta
                        });
                        onStructuredSave?.(item.id, restoredEntryMeta);
                    }
                    setEditingStructuredPersonTarget(null);
                    setEditingStructuredPersonDraft(createEmptyStructuredPersonDraft());
                    setEditingStructuredDeathCauseDraft('');
                    setEditingStructuredEventDateDraft('');
                    showToast('Возвращены исходные данные участника', 'success');
                    if (editorOnly) onEditorClose?.();
                } catch (e) {
                    if (lastPayload) {
                        applyDocUpdate(lastPayload, {
                            entryId: String(editingStructuredEntry?.entry_id || '').trim(),
                            entryIndex: editingStructuredPersonTarget?.entryIndex
                        });
                        showToast('Часть исходных данных уже восстановлена, но операция завершилась с ошибкой', 'warning');
                        return;
                    }
                    showToast('Не удалось вернуть исходные данные', 'error');
                } finally {
                    setSavingStructuredPersonEdit(false);
                }
            };

            const removeSingleFragment = async (fragmentIndex) => {
                if (!await showConfirm('Удалить этот фрагмент?')) return;
                await removeFragments([fragmentIndex], 'Фрагмент удалён', 'Удалён один фрагмент');
            };

            const deleteStructuredEntry = async (entryIndex) => {
                if (!await showConfirm('Удалить эту запись? Она перестанет участвовать в дашборде и статистике.')) return;
                try {
                    const r = await fetch(`${API_BASE}/structured/entry/delete`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({
                            pid,
                            item_id: item.id,
                            ...(editorParishId ? { parish_id: editorParishId } : {}),
                            entry_index: entryIndex,
                        }),
                    });
                    if (!r.ok) {
                        showToast('Не удалось удалить запись', 'error');
                        return;
                    }
                    applyDocUpdate(await r.json());
                    if (selectedStructuredEntryIndex === entryIndex) setSelectedStructuredEntryIndex(null);
                    showToast('Запись удалена', 'info');
                } catch (e) {
                    showToast('Не удалось удалить запись', 'error');
                }
            };

            const undeleteStructuredEntry = async (entryIndex) => {
                try {
                    const r = await fetch(`${API_BASE}/structured/entry/undelete`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({
                            pid,
                            item_id: item.id,
                            ...(editorParishId ? { parish_id: editorParishId } : {}),
                            entry_index: entryIndex,
                        }),
                    });
                    if (!r.ok) {
                        showToast('Не удалось восстановить запись', 'error');
                        return;
                    }
                    applyDocUpdate(await r.json());
                    showToast('Запись восстановлена', 'success');
                } catch (e) {
                    showToast('Не удалось восстановить запись', 'error');
                }
            };

            const runBulkAction = async (action) => {
                if (!action.count) return;
                const confirmed = await showConfirm(`Убрать ${action.count} фрагм. (${action.description})?`);
                if (!confirmed) return;
                await removeFragments(action.indices, `Убрано: ${action.label.toLowerCase()}`, `Убраны ${action.label.toLowerCase()}`);
            };

            const restoreFragments = async (fragmentsToRestore, successMessage = 'Фрагменты возвращены', options = {}) => {
                if (!fragmentsToRestore?.length) return;
                setPendingAction(true);
                try {
                    const r = await fetch(`${API_BASE}/highlight/restore`, {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({ pid: pid, item_id: item.id, fragments: fragmentsToRestore })
                    });
                    if (!r.ok) {
                        showToast('Не удалось вернуть фрагменты', 'error');
                        return;
                    }
                    const d = await r.json();
                    applyDocUpdate(d);
                    if (options.consumeUndoStack) {
                        setUndoStack(prev => prev.slice(0, -1));
                    }
                    setSelectedFragmentIndex(null);
                    setEditingFragmentIndex(null);
                    setEditingTextDraft('');
                    setEditingRecordFieldsDraft(createEmptySnippetRecordFields());
                    showToast(successMessage, 'success');
                } catch (e) {
                    showToast('Не удалось вернуть фрагменты', 'error');
                } finally {
                    setPendingAction(false);
                }
            };

            const undoLastAction = async () => {
                const lastAction = undoStack[undoStack.length - 1];
                if (!lastAction?.fragments?.length) return;
                await restoreFragments(lastAction.fragments, 'Последнее действие отменено', { consumeUndoStack: true });
            };

            const restoreDeletedFragment = async (fragment) => {
                await restoreFragments([fragment], 'Фрагмент возвращён');
            };

            const toggleColumnSelection = (columnId) => {
                setSelectedColumnIds(prev => {
                    if (prev.includes(columnId)) {
                        return prev.filter(id => id !== columnId);
                    }
                    return [...prev, columnId].sort((left, right) => {
                        const a = parseInt(String(left).replace(/[^0-9]/g, ''), 10);
                        const b = parseInt(String(right).replace(/[^0-9]/g, ''), 10);
                        return a - b;
                    });
                });
            };

            const removeSelectedColumns = async () => {
                if (!selectedColumnIndices.length) return;
                const confirmed = await showConfirm(`Убрать все фрагменты ${selectedColumnsLabel}?`);
                if (!confirmed) return;
                await removeFragments(
                    selectedColumnIndices,
                    `Убраны ${selectedColumnsLabel}`,
                    `Убраны ${selectedColumnsLabel}`
                );
                setSelectedColumnIds([]);
                setSelectedFragmentIndex(null);
            };

            const keepOnlyColumn = async (columnId) => {
                if (columnId !== 'c4' || !c4Column || !keepOnlyC4Indices.length) return;
                const confirmed = await showConfirm('Оставить только фрагменты из колонки c4? Все остальные будут удалены, но действие можно будет отменить или вернуть фрагменты позже.');
                if (!confirmed) return;
                await removeFragments(
                    keepOnlyC4Indices,
                    'Оставлены только фрагменты c4',
                    'Оставлены только c4'
                );
                setSelectedColumnIds(['c4']);
                setSelectedFragmentIndex(null);
                setShowDeletedFragments(false);
            };

            const handleHiresUploadResponse = useCallback((payload) => {
                const patch = payload?.item_patch || null;
                applyViewerPayload(payload, patch);
                if (patch) {
                    showToast('Качественный снимок сохранён', 'success');
                }
            }, [applyViewerPayload]);

            const uploadHiresPayload = useCallback(async (requestBody) => {
                const response = await fetch(`${API_BASE}/item_hires_upload`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        pid,
                        item_id: item.id,
                        owner_id: ownerId || item.owner_id,
                        ...requestBody
                    })
                });
                const payload = await response.json().catch(() => ({}));
                if (!response.ok || payload?.error) {
                    throw new Error(payload?.error || `HTTP ${response.status}`);
                }
                handleHiresUploadResponse(payload);
                return payload;
            }, [handleHiresUploadResponse, item.id, item.owner_id, ownerId, pid]);

            const handleHiresFileSelection = async (event) => {
                const file = event.target.files?.[0];
                event.target.value = '';
                if (!file) return;
                setHiresBusy(true);
                try {
                    const dataUrl = await readFileAsDataUrl(file);
                    const meta = await loadImageDimensionsFromUrl(dataUrl);
                    await uploadHiresPayload({
                        image_data: dataUrl,
                        mime_type: file.type || 'image/jpeg',
                        width: meta.width,
                        height: meta.height,
                        source: 'manual_file_upload'
                    });
                    setHiresModalOpen(false);
                } catch (error) {
                    showToast(error?.message || 'Не удалось загрузить файл', 'error');
                } finally {
                    setHiresBusy(false);
                }
            };

            const removeHiresImage = async () => {
                const confirmed = await showConfirm('Убрать сохранённый hi-res и вернуться к загрузке страницы из Яндекса?');
                if (!confirmed) return;
                setHiresBusy(true);
                try {
                    const response = await fetch(`${API_BASE}/item_hires_delete`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            pid,
                            item_id: item.id,
                            owner_id: ownerId || item.owner_id
                        })
                    });
                    const payload = await response.json().catch(() => ({}));
                    if (!response.ok || payload?.error) {
                        throw new Error(payload?.error || `HTTP ${response.status}`);
                    }
                    applyViewerPayload(payload, payload?.item_patch || null);
                    showToast('Hi-res снимок удалён', 'success');
                } catch (error) {
                    showToast(error?.message || 'Не удалось удалить hi-res', 'error');
                } finally {
                    setHiresBusy(false);
                }
            };

            const copyYandexHiresScript = async () => {
                setHiresScriptBusy(true);
                try {
                    const response = await fetch(`${API_BASE}/item_hires_token`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            pid,
                            item_id: item.id,
                            owner_id: ownerId || item.owner_id
                        })
                    });
                    const payload = await response.json().catch(() => ({}));
                    if (!response.ok || payload?.error || !payload?.token) {
                        throw new Error(payload?.error || `HTTP ${response.status}`);
                    }
                    const script = buildYandexHiresConsoleScript({
                        uploadUrl: `${window.location.origin}${API_BASE}/item_hires_upload`,
                        token: payload.token,
                        expectedWidth: data?.originalWidth || item?.image_width || 0,
                        expectedHeight: data?.originalHeight || item?.image_height || 0,
                        manualSignedUrl: normalizeSignedYandexOriginalUrl(hiresSignedUrlDraft)
                    });
                    setHiresConsoleScript(script);
                    if (navigator?.clipboard?.writeText) {
                        await navigator.clipboard.writeText(script);
                        showToast('JS-код для страницы Яндекса скопирован', 'success');
                    } else {
                        showToast('Код готов. Скопируйте его вручную из окна ниже.', 'warning');
                    }
                } catch (error) {
                    showToast(error?.message || 'Не удалось подготовить helper для Яндекса', 'error');
                } finally {
                    setHiresScriptBusy(false);
                }
            };

            const copyYandexHiresCaptureScript = async () => {
                setHiresCaptureScriptBusy(true);
                try {
                    const response = await fetch(`${API_BASE}/hires_capture_agent_token`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            pid,
                            owner_id: ownerId || item.owner_id
                        })
                    });
                    const payload = await response.json().catch(() => ({}));
                    if (!response.ok || payload?.error || !payload?.token) {
                        throw new Error(payload?.error || `HTTP ${response.status}`);
                    }
                    const script = buildYandexHiresCaptureConsoleScript({
                        uploadUrl: `${window.location.origin}${API_BASE}/hires_capture_upload`,
                        token: payload.token
                    });
                    setHiresConsoleScript(script);
                    if (navigator?.clipboard?.writeText) {
                        await navigator.clipboard.writeText(script);
                        showToast('Скрипт авто-перехвата для консоли скопирован', 'success');
                    } else {
                        showToast('Скрипт готов. Скопируйте его вручную из окна ниже.', 'warning');
                    }
                } catch (error) {
                    showToast(error?.message || 'Не удалось подготовить скрипт авто-перехвата для Яндекса', 'error');
                } finally {
                    setHiresCaptureScriptBusy(false);
                }
            };

            useEffect(() => {
                if (editorOnly) return undefined;
                const triggerRefresh = () => {
                    const now = Date.now();
                    if (document.visibilityState === 'hidden') return;
                    if (now - lastViewerAutoRefreshAtRef.current < 1200) return;
                    lastViewerAutoRefreshAtRef.current = now;
                    refreshViewerData().catch(() => {});
                };
                window.addEventListener('focus', triggerRefresh);
                document.addEventListener('visibilitychange', triggerRefresh);
                return () => {
                    window.removeEventListener('focus', triggerRefresh);
                    document.removeEventListener('visibilitychange', triggerRefresh);
                };
            }, [editorOnly, refreshViewerData]);

            const showEditorBootstrapOverlay = editorOnly && !editingStructuredPerson;

            return (
                <div className={editorOnly ? 'contents' : 'h-full w-full flex flex-col overflow-hidden bg-stone-200'}>
                    {!editorOnly && (
                    <>
                    <div className="h-auto min-h-12 bg-white border-b flex items-center justify-between px-6 shrink-0 z-10 py-2">
                        <div className="text-sm pr-4 flex-1 min-w-0">
                            <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
                                <span className="font-bold truncate max-w-[300px]" title={item.periodical}>{item.periodical}</span>
                                <span className="text-stone-400">—</span>
                                <span className="text-stone-600 truncate max-w-[400px]" title={item.issue}>{item.issue}</span>
                            </div>
                            {item.cipher && <div className="text-[10px] text-stone-400 font-mono mt-1 truncate">{item.cipher}</div>}
                        </div>
                        <div className="flex items-center gap-2">
                            <button onClick={() => setZoom(z => Math.max(0.3, z * 0.8))} className="w-8 h-8 border rounded hover:bg-stone-50 flex items-center justify-center">−</button>
                            <span className="text-xs w-12 text-center font-bold">{Math.round(zoom * 100)}%</span>
                            <button onClick={() => setZoom(z => Math.min(5, z * 1.2))} className="w-8 h-8 border rounded hover:bg-stone-50 flex items-center justify-center">+</button>
                            <button onClick={() => {
                                if (data && container.current) {
                                    const h = container.current.clientHeight - 60;
                                    setBaseScale(h / data.originalHeight);
                                    setZoom(1.0);
                                }
                            }} className="px-2 py-1 text-[10px] border rounded hover:bg-stone-50" title="Вписать по высоте">↕</button>
                            <button onClick={() => {
                                if (data && container.current) {
                                    const w = container.current.clientWidth - 60;
                                    setBaseScale(w / data.originalWidth);
                                    setZoom(1.0);
                                }
                            }} className="px-2 py-1 text-[10px] border rounded hover:bg-stone-50" title="Вписать по ширине">↔</button>
                            <button onClick={() => setZoom(1.0)} className="px-2 py-1 text-[10px] border rounded hover:bg-stone-50">Сброс</button>
                            {pageMarkupToggleAvailable && (
                                <button
                                    onClick={() => {
                                        setShowPageMarkup(prev => {
                                            const next = !prev;
                                            if (!next) setSelectedFragmentIndex(null);
                                            return next;
                                        });
                                    }}
                                    className={`px-2 py-1 text-[10px] border rounded transition-colors ${showPageMarkup ? 'bg-[#8b0000] text-white border-[#8b0000] hover:bg-[#6f0000]' : 'hover:bg-stone-50'}`}
                                    title="Показать или скрыть блоки разметки для этой страницы"
                                >
                                    {showPageMarkup ? 'Разметка: вкл' : 'Разметка'}
                                </button>
                            )}
                            {canEditProject && (
                                <input
                                    ref={hiresFileInputRef}
                                    type="file"
                                    hidden
                                    accept="image/png,image/jpeg,image/webp"
                                    onChange={handleHiresFileSelection}
                                />
                            )}
                            <button onClick={() => (data?.hiresImageUrl || data?.proxyImageUrl || data?.originalUrl) && window.open(data?.hiresImageUrl || data?.proxyImageUrl || data?.originalUrl, "_blank")} className="p-2 border rounded hover:bg-stone-50 text-stone-500 hover:text-[#8b0000]" title={data?.hiresImageUrl ? 'Открыть сохранённый hi-res' : 'Открыть изображение через Yarchiver'}>🖼</button>
                            <button onClick={openInYandex} className="p-2 border rounded hover:bg-stone-50 text-stone-500 hover:text-[#8b0000]" title="Открыть на Яндексе"><IconExternal /></button>
                        </div>
                    </div>
                    <div className="flex-1 min-h-0 flex overflow-hidden">
                        <div ref={container} className="flex-1 overflow-auto p-8 relative scroll-smooth bg-[#e8e4dc] bg-texture">
                            {(loading || (data && !imgLoaded && !imageLoadFailed)) && (
                                <div className="absolute inset-0 flex flex-col items-center justify-center bg-[#f4f1ea]/90 backdrop-blur-sm z-20">
                                    <div className="loader-paper"></div>
                                    <div className="mt-4 font-display text-stone-600 text-sm uppercase tracking-widest">
                                        {loading ? 'Получение данных...' : 'Загрузка снимка...'}
                                    </div>
                                    <div className="progress-bar-container">
                                        <div className="progress-bar" style={{width: `${Math.min(loadProgress, 100)}%`}}></div>
                                    </div>
                                    <div className="mt-2 text-xs text-stone-400">{Math.round(loadProgress)}%</div>
                                </div>
                            )}
                            {data && (
                                <div className="relative shadow-2xl bg-white mx-auto" style={{width: data.originalWidth * scale, height: data.originalHeight * scale}}>
                                    {blobUrl && <img
                                        src={blobUrl}
                                        className={`w-full h-full block img-fade ${imgLoaded ? 'loaded' : ''}`}
                                        referrerPolicy={shouldUseNoReferrerForViewerImage(blobUrl) ? "no-referrer" : undefined}
                                        onLoad={() => {
                                            setImgLoaded(true);
                                            setImageLoadFailed(false);
                                        }}
                                        onError={() => {
                                            const nextCandidate = getNextViewerImageCandidate(data, imageStage, blobUrl);
                                            if (nextCandidate?.url && nextCandidate.url !== blobUrl) {
                                                setBlobUrl(nextCandidate.url);
                                                setImageStage(nextCandidate.stage);
                                                setImgLoaded(false);
                                                return;
                                            }
                                            setImageLoadFailed(true);
                                            setImgLoaded(false);
                                        }}
                                        onContextMenu={e => e.preventDefault()}
                                        onDragStart={e => e.preventDefault()}
                                        style={{WebkitUserSelect: 'none', userSelect: 'none'}}
                                    />}
                                    {imageLoadFailed && (
                                        <div className="absolute inset-0 flex flex-col items-center justify-center px-8 text-center bg-[#faf7f2] text-stone-500">
                                            <div className="text-sm font-semibold text-stone-700">Не удалось загрузить изображение</div>
                                            <div className="mt-2 text-xs leading-5 max-w-sm">
                                                Яндекс временно ограничил выдачу этого снимка. Можно открыть страницу в Архиве и попробовать немного позже.
                                            </div>
                                        </div>
                                    )}
                                    {imgLoaded && showPageMarkup && data.highlights?.map((h, i) => {
                                        const selected = selectedFragmentIndex === i;
                                        const columnSelected = selectedColumnSet.has(columnLayout.fragmentColumns[i]);
                                        const fragmentText = data.highlightFragments?.[i]?.text || '';
                                        return (
                                            <div key={`${h.x}-${h.y}-${i}`} className={`highlight-wrap ${selected ? 'is-selected' : ''}`} style={{
                                                left: h.x * scale,
                                                top: h.y * scale,
                                                width: h.width * scale,
                                                height: h.height * scale
                                            }}>
                                                <div
                                                    className={`highlight-box ${selected ? 'highlight-box-selected' : columnSelected ? 'highlight-box-column' : ''}`}
                                                    title={fragmentText}
                                                    onClick={() => setSelectedFragmentIndex(i)}
                                                />
                                                {canEditProject && <button
                                                    className="highlight-remove-btn"
                                                    title="Удалить этот фрагмент"
                                                    onClick={async (e) => {
                                                        e.stopPropagation();
                                                        await removeSingleFragment(i);
                                                    }}
                                                >×</button>}
                                            </div>
                                        );
                                    })}
                                    {imgLoaded && selectedStructuredEntry?.bbox && (
                                        <div
                                            className="absolute border-[1.5px] border-sky-700 bg-sky-500/10 shadow-[0_0_0_1px_rgba(255,255,255,0.8)] pointer-events-none"
                                            style={{
                                                left: Number(selectedStructuredEntry.bbox.x || 0) * scale,
                                                top: Number(selectedStructuredEntry.bbox.y || 0) * scale,
                                                width: Number(selectedStructuredEntry.bbox.width || 0) * scale,
                                                height: Number(selectedStructuredEntry.bbox.height || 0) * scale
                                            }}
                                        />
                                    )}
                                </div>
                            )}
                        </div>

                        {showSnippetWorkbench && (
                            <aside className="w-[360px] shrink-0 border-l border-stone-300 bg-[#f6f1e8] flex flex-col overflow-hidden">
                                <div className="px-4 py-4 border-b border-stone-200 bg-[#fbf8f2] sticky top-0 z-10 shrink-0">
                                    <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400 font-bold">Работа со сниппетами</div>
                                    <div className="mt-1 font-display text-xl text-stone-800">Кандидаты страницы</div>
                                    <div className="mt-2 text-[12px] text-stone-500 leading-5">
                                        Поиск и текст карточки собираются только из активных фрагментов.
                                    </div>
                                    <div className="mt-3 flex items-center gap-2 flex-wrap">
                                        <div className="px-2.5 py-1 rounded-full bg-white border border-stone-200 text-[11px] font-bold text-stone-600">
                                            {data?.highlightFragments?.length || 0} активных
                                        </div>
                                        <button
                                            onClick={() => setShowDeletedFragments(prev => !prev)}
                                            disabled={!deletedFragments.length}
                                            className={`px-2.5 py-1 rounded-full border text-[11px] font-bold transition-colors ${deletedFragments.length ? 'bg-white text-stone-600 border-stone-200 hover:border-[#8b0000] hover:text-[#8b0000]' : 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed'}`}
                                        >
                                            Удалённые {deletedFragments.length}
                                        </button>
                                        {c4Column && (
                                            <button
                                                onClick={() => keepOnlyColumn('c4')}
                                                disabled={!keepOnlyC4Indices.length || pendingAction}
                                                className={`px-2.5 py-1 rounded-full border text-[11px] font-bold transition-colors ${keepOnlyC4Indices.length && !pendingAction ? 'bg-[#fdf0eb] text-[#8b0000] border-[#e6c5bb] hover:bg-[#fff5f1]' : 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed'}`}
                                            >
                                                Только c4
                                            </button>
                                        )}
                                        <button
                                            onClick={undoLastAction}
                                            disabled={!undoStack.length || pendingAction}
                                            className={`px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wide border transition-colors ${undoStack.length && !pendingAction ? 'bg-white text-[#8b0000] border-[#8b0000] hover:bg-[#fff5f1]' : 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed'}`}
                                        >
                                            Вернуть последнее
                                        </button>
                                    </div>
                                    {undoStack.length > 0 && (
                                        <div className="mt-2 text-[11px] text-stone-400">
                                            Последнее действие: {undoStack[undoStack.length - 1].label}
                                        </div>
                                    )}
                                </div>

                                <div className="flex-1 overflow-y-auto">
                                    <div className="px-4 py-4 border-b border-stone-200">
                                        <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400 font-bold">Нумерация по странице</div>
                                        <div className="mt-2 text-[12px] text-stone-500 leading-5">
                                            Метки <span className="font-mono text-stone-700">c1</span>, <span className="font-mono text-stone-700">c2</span> и далее идут слева направо по устойчивым колонкам формы.
                                        </div>
                                        <div className="mt-3 flex flex-wrap gap-2">
                                            {columnLayout.columns.map(column => {
                                                const active = selectedColumnSet.has(column.id);
                                                return (
                                                    <button
                                                        key={column.id}
                                                        onClick={() => toggleColumnSelection(column.id)}
                                                        className={`rounded-full border px-3 py-1.5 text-[11px] font-bold transition-colors ${active ? 'bg-[#8b0000] text-white border-[#8b0000]' : 'bg-white text-stone-600 border-stone-200 hover:border-[#8b0000] hover:text-[#8b0000]'}`}
                                                    >
                                                        {column.label}
                                                        <span className={`ml-2 text-[10px] ${active ? 'text-white/80' : 'text-stone-400'}`}>{column.count}</span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                        {selectedColumnIds.length > 0 && (
                                            <div className="mt-3 rounded-2xl border border-[#d8b4ab] bg-[#fff7f3] p-3">
                                                <div className="text-[11px] font-bold text-stone-700">Выбрано: <span className="font-mono text-[#8b0000]">{selectedColumnsLabel}</span></div>
                                                <div className="mt-1 text-[11px] text-stone-500">{selectedColumnIndices.length} фрагм. в выделенных колонках</div>
                                                <div className="mt-3 flex gap-2">
                                                    <button
                                                        onClick={removeSelectedColumns}
                                                        disabled={!selectedColumnIndices.length || pendingAction}
                                                        className={`flex-1 rounded-xl px-3 py-2 text-[11px] font-bold uppercase tracking-wide border ${selectedColumnIndices.length && !pendingAction ? 'bg-[#8b0000] text-white border-[#8b0000] hover:bg-[#6f0000]' : 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed'}`}
                                                    >
                                                        Убрать {selectedColumnsLabel}
                                                    </button>
                                                    <button
                                                        onClick={() => setSelectedColumnIds([])}
                                                        className="rounded-xl px-3 py-2 text-[11px] font-bold uppercase tracking-wide border border-stone-200 bg-white text-stone-500 hover:border-stone-400"
                                                    >
                                                        Снять
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="px-4 py-4 border-b border-stone-200">
                                        <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400 font-bold">Массовые действия</div>
                                        <div className="mt-3 grid grid-cols-2 gap-2">
                                            {bulkActions.map(action => (
                                                <button
                                                    key={action.key}
                                                    onClick={() => runBulkAction(action)}
                                                    disabled={!action.count || pendingAction}
                                                    className={`rounded-2xl border px-3 py-3 text-left transition-all ${action.count && !pendingAction ? 'bg-white border-stone-200 hover:border-[#8b0000] hover:bg-[#fffaf6]' : 'bg-stone-100 border-stone-200 text-stone-300 cursor-not-allowed'}`}
                                                >
                                                    <div className="text-[11px] font-bold text-stone-700">{action.label}</div>
                                                    <div className="mt-1 text-[10px] text-stone-400">{action.description}</div>
                                                    <div className="mt-2 text-[11px] font-bold text-[#8b0000]">{action.count} фрагм.</div>
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {(showDeletedFragments || !data?.highlightFragments?.length) && (
                                        <div className="px-4 py-4 border-b border-stone-200 bg-[#fffdf9]">
                                            <div className="flex items-center justify-between gap-3">
                                                <div>
                                                    <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400 font-bold">Ранее удалённые</div>
                                                    <div className="mt-1 text-[12px] text-stone-500 leading-5">
                                                        Эти фрагменты можно вернуть и после перезагрузки страницы.
                                                    </div>
                                                </div>
                                                {deletedFragments.length > 0 && (
                                                    <button
                                                        onClick={() => setShowDeletedFragments(false)}
                                                        className="rounded-full border border-stone-200 bg-white px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-stone-500 hover:border-stone-300"
                                                    >
                                                        Скрыть
                                                    </button>
                                                )}
                                            </div>
                                            {deletedWorkbenchEntries.length > 0 ? (
                                                <div className="mt-4 space-y-2 max-h-[260px] overflow-y-auto pr-1">
                                                    {deletedWorkbenchEntries.map(({ fragment, index, columnId }) => {
                                                        const deletedBy = fragment.deleted_by || {};
                                                        const deletedAtLabel = formatSnippetEditTimestamp(fragment.deleted_at);
                                                        return (
                                                            <div key={`deleted-${fragment.x}-${fragment.y}-${index}`} className="rounded-2xl border border-stone-200 bg-white p-3">
                                                                <div className="flex items-start gap-3">
                                                                    <div className="flex-1 min-w-0">
                                                                        <div
                                                                            className="text-[12px] leading-5 text-stone-700"
                                                                            style={{display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden'}}
                                                                        >
                                                                            {fragment.text || fragment.original_text || 'Пустой фрагмент'}
                                                                        </div>
                                                                        <div className="mt-2 flex flex-wrap gap-1">
                                                                            {columnId && (
                                                                                <span className="px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wide border bg-[#fdf0eb] text-[#8b0000] border-[#e6c5bb] font-bold font-mono">
                                                                                    {columnId}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        <div className="mt-2 flex items-center gap-2 text-[10px] text-stone-500">
                                                                            {deletedBy.photo_url ? (
                                                                                <img src={deletedBy.photo_url} className="w-5 h-5 rounded-full border border-stone-200" />
                                                                            ) : (
                                                                                <div className="w-5 h-5 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-[9px] font-bold">
                                                                                    {(deletedBy.first_name || deletedBy.username || '×').slice(0, 1).toUpperCase()}
                                                                                </div>
                                                                            )}
                                                                            <span>
                                                                                Удалено {deletedAtLabel || 'недавно'}
                                                                                {(deletedBy.first_name || deletedBy.username) ? ` · ${deletedBy.first_name || deletedBy.username}` : ''}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <button
                                                                        onClick={() => restoreDeletedFragment(fragment)}
                                                                        disabled={pendingAction}
                                                                        className={`shrink-0 rounded-xl border px-3 py-2 text-[11px] font-bold uppercase tracking-wide ${pendingAction ? 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed' : 'bg-white text-[#8b0000] border-[#8b0000] hover:bg-[#fff5f1]'}`}
                                                                    >
                                                                        Вернуть
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <div className="mt-4 rounded-2xl border border-dashed border-stone-300 bg-white/70 px-4 py-6 text-center text-[12px] text-stone-400">
                                                    Пока ничего не удалено.
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div className="p-3 space-y-2">
                                        {selectedColumnIds.length > 0 && (
                                            <div className="px-1 pb-2 text-[11px] text-stone-400">
                                                Показаны {visibleWorkbenchIndices.length} из {(data?.highlightFragments || []).length} фрагментов
                                            </div>
                                        )}
                                        {visibleWorkbenchIndices.map(index => {
                                            const fragment = data?.highlightFragments?.[index];
                                            if (!fragment) return null;
                                            const selected = selectedFragmentIndex === index;
                                            const edited = isSnippetFragmentEdited(fragment);
                                            const columnId = columnLayout.fragmentColumns[index];
                                            const editedBy = fragment.edited_by || {};
                                            const editedAtLabel = formatSnippetEditTimestamp(fragment.edited_at);
                                            const canRestoreOriginal = edited && (fragment.original_text || '').trim();
                                            const badges = [];
                                            if (columnId) badges.push(columnId);
                                            if (planSets.short.has(index)) badges.push('короткий');
                                            if (planSets.numeric.has(index)) badges.push('числа');
                                            if (planSets.headers.has(index)) badges.push('шапка');
                                            if (planSets.duplicates.has(index)) badges.push('повтор');

                                            return (
                                                <div
                                                    key={`${fragment.x}-${fragment.y}-${index}`}
                                                    onClick={() => setSelectedFragmentIndex(index)}
                                                    className={`rounded-2xl border p-3 cursor-pointer transition-all ${selected ? 'bg-white border-[#8b0000] shadow-sm' : 'bg-white/80 border-stone-200 hover:border-stone-400'}`}
                                                >
                                                    <div className="flex items-start gap-3">
                                                        <div className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-[11px] font-bold ${selected ? 'bg-[#8b0000] text-white' : 'bg-stone-100 text-stone-500'}`}>
                                                            {index + 1}
                                                        </div>
                                                        <div className="flex-1 min-w-0">
                                                            <div
                                                                className="text-[12px] leading-5 text-stone-700"
                                                                style={{display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden'}}
                                                            >
                                                                {fragment.text || 'Пустой фрагмент'}
                                                            </div>
                                                            <div className="mt-2 flex flex-wrap gap-1">
                                                                {badges.map(badge => (
                                                                    <span key={badge} className={`px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wide border ${String(badge).startsWith('c') ? 'bg-[#fdf0eb] text-[#8b0000] border-[#e6c5bb] font-bold font-mono' : 'bg-stone-100 text-stone-500 border-stone-200'}`}>
                                                                        {badge}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                            {edited && (
                                                                <div className="mt-2 flex items-center gap-2 text-[10px] text-stone-500">
                                                                    {editedBy.photo_url ? (
                                                                        <img src={editedBy.photo_url} className="w-5 h-5 rounded-full border border-stone-200" />
                                                                    ) : (
                                                                        <div className="w-5 h-5 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-[9px] font-bold">
                                                                            {(editedBy.first_name || editedBy.username || '?').slice(0, 1).toUpperCase()}
                                                                        </div>
                                                                    )}
                                                                    <span>
                                                                        Исправлено {editedAtLabel || 'недавно'}
                                                                        {(editedBy.first_name || editedBy.username) ? ` · ${editedBy.first_name || editedBy.username}` : ''}
                                                                    </span>
                                                                </div>
                                                            )}
                                                            <div className="mt-2 text-[10px] text-stone-400">
                                                                x:{Math.round(fragment.x)} y:{Math.round(fragment.y)}
                                                            </div>
                                                        </div>
                                                        <div className="shrink-0 flex items-start gap-1">
                                                            {canEditProject && (
                                                                <button
                                                                    className="w-7 h-7 rounded-full border border-stone-200 text-stone-400 hover:text-[#8b0000] hover:border-[#8b0000] hover:bg-[#fff5f1]"
                                                                    title="Редактировать текст"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        if (editingFragmentIndex === index) {
                                                                            cancelEditingFragment();
                                                                        } else {
                                                                            startEditingFragment(index);
                                                                        }
                                                                    }}
                                                                >
                                                                    ✎
                                                                </button>
                                                            )}
                                                            <button
                                                                className="w-7 h-7 rounded-full border border-stone-200 text-stone-400 hover:text-[#8b0000] hover:border-[#8b0000] hover:bg-[#fff5f1]"
                                                                title="Удалить этот фрагмент"
                                                                onClick={async (e) => {
                                                                    e.stopPropagation();
                                                                    await removeSingleFragment(index);
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {!(data?.highlightFragments || []).length && (
                                            <div className="h-full min-h-[220px] rounded-2xl border border-dashed border-stone-300 bg-white/60 flex flex-col items-center justify-center px-6 text-center">
                                                <div className="text-sm font-display text-stone-700">Фрагменты закончились</div>
                                                <div className="mt-2 text-[12px] text-stone-400">Можно вернуть последнее действие или поднять любой фрагмент из блока ранее удалённых.</div>
                                            </div>
                                        )}
                                        {!!(data?.highlightFragments || []).length && selectedColumnIds.length > 0 && !visibleWorkbenchIndices.length && (
                                            <div className="h-full min-h-[180px] rounded-2xl border border-dashed border-stone-300 bg-white/60 flex flex-col items-center justify-center px-6 text-center">
                                                <div className="text-sm font-display text-stone-700">В выбранных колонках ничего не осталось</div>
                                                <div className="mt-2 text-[12px] text-stone-400">Сними фильтр по колонкам или верни последнее действие.</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </aside>
                        )}

                        {showStructuredParticipantsPanel && (
                            <aside className="w-[380px] shrink-0 border-l border-stone-300 bg-[#f6f1e8] flex flex-col overflow-hidden">
                                <div className="px-4 py-4 border-b border-stone-200 bg-[#fbf8f2] sticky top-0 z-10 shrink-0">
                                    <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400 font-bold">Распознанные участники</div>
                                    <div className="mt-1 font-display text-xl text-stone-800">События на странице</div>
                                    <div className="mt-2 text-[12px] text-stone-500 leading-5">
                                        Яндекс Архивы выделяют отдельные записи и участников события внутри каждой записи.
                                    </div>
                                    <div className="mt-3 flex items-center gap-2 flex-wrap">
                                        <div className="px-2.5 py-1 rounded-full bg-white border border-stone-200 text-[11px] font-bold text-stone-600">
                                            {structuredEntries.filter(e => !e?.is_deleted).length} событий
                                        </div>
                                        {structuredEntries.some(e => e?.is_deleted) && (
                                            <div className="px-2.5 py-1 rounded-full bg-stone-100 border border-stone-200 text-[11px] font-bold text-stone-500">
                                                {structuredEntries.filter(e => e?.is_deleted).length} удалено
                                            </div>
                                        )}
                                        {selectedStructuredEntry && (
                                            <button
                                                onClick={() => setSelectedStructuredEntryIndex(null)}
                                                className="px-2.5 py-1 rounded-full border border-stone-200 bg-white text-[11px] font-bold text-stone-500 hover:border-[#8b0000] hover:text-[#8b0000]"
                                            >
                                                Снять выделение
                                            </button>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-1 overflow-y-auto p-3 space-y-3">
                                    {structuredEntries.length > 0 ? structuredEntries.map((entry, index) => {
                                        if (entry?.is_deleted) {
                                            return (
                                                <div
                                                    key={entry.entry_id || `${index}-deleted`}
                                                    className="rounded-[22px] border border-dashed border-stone-300 bg-stone-50/70 p-3"
                                                >
                                                    <div className="flex items-center justify-between gap-3">
                                                        <div className="min-w-0 flex items-center gap-2">
                                                            <span className="w-7 h-7 shrink-0 rounded-full bg-stone-200 text-stone-500 flex items-center justify-center text-[11px] font-bold">{index + 1}</span>
                                                            <div className="min-w-0">
                                                                <div className="text-[10px] uppercase tracking-[0.16em] text-stone-500 font-bold">Запись удалена</div>
                                                                <div className="text-[12px] text-stone-500 truncate">{formatStructuredEntryType(entry.type)} · не учитывается в статистике</div>
                                                            </div>
                                                        </div>
                                                        {canEditProject && (
                                                            <button
                                                                onClick={(e) => { e.stopPropagation(); undeleteStructuredEntry(index); }}
                                                                className="shrink-0 px-3 py-1.5 rounded-full border border-stone-300 bg-white text-[10px] font-bold uppercase tracking-wide text-stone-600 hover:border-emerald-600 hover:text-emerald-700"
                                                                title="Восстановить запись"
                                                            >
                                                                ↺ Вернуть
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        }
                                        const selected = selectedStructuredEntryIndex === index;
                                        const orderedPeople = orderStructuredPeopleWithMeta(entry.type, entry.people);
                                        const entryDeathCause = getStructuredEntryResolvedDeathCause(entry);
                                        const entryDeathCauseEdited = isStructuredEntryDeathCauseEdited(entry);
                                        const entryDeathCauseEditedBy = entry?.death_cause_edited_by || {};
                                        const entryDeathCauseEditedAtLabel = formatSnippetEditTimestamp(entry?.death_cause_edited_at);
                                        return (
                                            <div
                                                key={entry.entry_id || `${index}-${entry.type}`}
                                                id={entry.entry_id ? `entry-${entry.entry_id}` : `entry-index-${index}`}
                                                onClick={() => {
                                                    setSelectedStructuredEntryIndex(index);
                                                    setSelectedFragmentIndex(null);
                                                }}
                                                className={`rounded-[22px] border p-4 cursor-pointer transition-all ${selected ? 'bg-white border-sky-700 shadow-sm' : 'bg-white/80 border-stone-200 hover:border-stone-400'}`}
                                            >
                                                <div className="flex items-start justify-between gap-3">
                                                    <div className="min-w-0">
                                                        <div className="flex flex-wrap items-center gap-2">
                                                            <span className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-[11px] font-bold ${selected ? 'bg-sky-700 text-white' : 'bg-stone-100 text-stone-500'}`}>
                                                                {index + 1}
                                                            </span>
                                                            <span className="font-display text-lg text-stone-800">{formatStructuredEntryType(entry.type)}</span>
                                                        </div>
                                                        <div className="mt-2 flex flex-wrap gap-2">
                                                            <span className="px-2.5 py-1 rounded-full bg-[#edf6ff] text-sky-800 border border-sky-200 text-[10px] font-bold uppercase tracking-wide">
                                                                {orderedPeople.length} участников
                                                            </span>
                                                            {entry.entry_id && (
                                                                <span className="px-2.5 py-1 rounded-full bg-stone-100 text-stone-500 border border-stone-200 text-[10px] font-mono">
                                                                    {entry.entry_id.split('_').pop()}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="shrink-0 flex items-start gap-2">
                                                        <div className="text-[10px] text-stone-400 text-right">
                                                            x:{Math.round(Number(entry?.bbox?.x || 0))}<br />
                                                            y:{Math.round(Number(entry?.bbox?.y || 0))}
                                                        </div>
                                                        {canEditProject && (
                                                            <button
                                                                onClick={(e) => { e.stopPropagation(); deleteStructuredEntry(index); }}
                                                                className="w-7 h-7 rounded-full border border-stone-200 bg-white text-stone-400 hover:text-[#8b0000] hover:border-[#8b0000] hover:bg-[#fff5f1] text-[16px] leading-none"
                                                                title="Удалить запись"
                                                            >
                                                                ×
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="mt-4 space-y-3">
                                                    {String(entry?.type || '').trim().toUpperCase() === 'DEATH' && (entryDeathCause || entryDeathCauseEdited) && (
                                                        <div className="rounded-2xl border border-stone-200 bg-[#fffaf2] px-3 py-3">
                                                            <div className="flex flex-wrap items-center gap-2">
                                                                <div className="text-[10px] uppercase tracking-[0.16em] text-stone-500 font-bold">
                                                                    Причина смерти
                                                                </div>
                                                                {entryDeathCauseEdited && (
                                                                    <span className="px-2 py-0.5 rounded-full border border-[#ead8b0] bg-[#fff7e8] text-[9px] font-bold uppercase tracking-wide text-stone-600">
                                                                        Исправлено
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <div className="mt-1 text-[12px] text-stone-700 leading-5">
                                                                {entryDeathCause || 'Причина вручную очищена'}
                                                            </div>
                                                            {entryDeathCauseEdited && (
                                                                <div className="mt-2 flex items-center gap-2 text-[10px] text-stone-500">
                                                                    {entryDeathCauseEditedBy.photo_url ? (
                                                                        <img src={entryDeathCauseEditedBy.photo_url} className="w-5 h-5 rounded-full border border-stone-200" />
                                                                    ) : (
                                                                        <div className="w-5 h-5 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-[9px] font-bold">
                                                                            {(entryDeathCauseEditedBy.first_name || entryDeathCauseEditedBy.username || '?').slice(0, 1).toUpperCase()}
                                                                        </div>
                                                                    )}
                                                                    <span>
                                                                        Исправлено {entryDeathCauseEditedAtLabel || 'недавно'}
                                                                        {(entryDeathCauseEditedBy.first_name || entryDeathCauseEditedBy.username) ? ` · ${entryDeathCauseEditedBy.first_name || entryDeathCauseEditedBy.username}` : ''}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {orderedPeople.map(({ person, index: personIndex }) => {
                                                        const displayName = formatStructuredPersonName(person) || 'Без имени';
                                                        const edited = isStructuredPersonEdited(person);
                                                        const editedBy = person?.edited_by || {};
                                                        const editedAtLabel = formatSnippetEditTimestamp(person?.edited_at);
                                                        return (
                                                            <div key={`${entry.entry_id || index}-${personIndex}`} className="rounded-2xl border border-stone-200 bg-[#fcfaf5] px-3 py-3">
                                                                <div className="flex items-start justify-between gap-3">
                                                                    <div className="min-w-0">
                                                                        <div className="flex flex-wrap items-center gap-2">
                                                                            <div className="text-[10px] uppercase tracking-[0.16em] text-sky-700 font-bold">
                                                                                {formatStructuredPersonStatus(person.status)}
                                                                            </div>
                                                                            {edited && (
                                                                                <span className="px-2 py-0.5 rounded-full border border-[#ead8b0] bg-[#fff7e8] text-[9px] font-bold uppercase tracking-wide text-stone-600">
                                                                                    Исправлено
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        <div className="mt-1 text-[13px] font-semibold text-stone-800 leading-5">
                                                                            {displayName}
                                                                        </div>
                                                                    </div>
                                                                    <div className="shrink-0 flex items-start gap-1">
                                                                        {person.sex && (
                                                                            <span className="px-2 py-0.5 rounded-full border border-stone-200 bg-white text-[9px] font-bold uppercase tracking-wide text-stone-500">
                                                                                {person.sex === 'FEMALE' ? 'Ж' : person.sex === 'MALE' ? 'М' : person.sex}
                                                                            </span>
                                                                        )}
                                                                        {canEditProject && (
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    startEditingStructuredPerson(index, personIndex);
                                                                                }}
                                                                                className="w-7 h-7 rounded-full border border-stone-200 bg-white text-stone-400 hover:text-[#8b0000] hover:border-[#8b0000] hover:bg-[#fff5f1] transition-colors"
                                                                                title="Редактировать участника"
                                                                            >
                                                                                ✎
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {(person.info || person.geo || person.other_status || person.age) && (
                                                                    <div className="mt-2 space-y-1">
                                                                        {person.info && <div className="text-[11px] text-stone-600 leading-5">{person.info}</div>}
                                                                        {person.geo && <div className="text-[11px] text-stone-500 leading-5">{person.geo}</div>}
                                                                        {person.other_status && <div className="text-[11px] text-stone-500 leading-5">{person.other_status}</div>}
                                                                        {person.age && <div className="text-[11px] text-stone-400">{person.age}</div>}
                                                                    </div>
                                                                )}
                                                                {edited && (
                                                                    <div className="mt-2 flex items-center gap-2 text-[10px] text-stone-500">
                                                                        {editedBy.photo_url ? (
                                                                            <img src={editedBy.photo_url} className="w-5 h-5 rounded-full border border-stone-200" />
                                                                        ) : (
                                                                            <div className="w-5 h-5 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-[9px] font-bold">
                                                                                {(editedBy.first_name || editedBy.username || '?').slice(0, 1).toUpperCase()}
                                                                            </div>
                                                                        )}
                                                                        <span>
                                                                            Исправлено {editedAtLabel || 'недавно'}
                                                                            {(editedBy.first_name || editedBy.username) ? ` · ${editedBy.first_name || editedBy.username}` : ''}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        );
                                    }) : (
                                        <div className="h-full min-h-[240px] rounded-2xl border border-dashed border-stone-300 bg-white/60 flex flex-col items-center justify-center px-6 text-center">
                                            <div className="text-sm font-display text-stone-700">Структурированных участников пока нет</div>
                                            <div className="mt-2 text-[12px] text-stone-400">
                                                Для этой страницы Яндекс Архивы пока не вернули отдельный structured-слой.
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </aside>
                        )}
                    </div>
                    </>
                    )}

                        {showEditorBootstrapOverlay && (
                            <div className="fixed inset-0 z-[89] bg-black/35 backdrop-blur-[2px] p-4 sm:p-6 flex items-center justify-center">
                                <div
                                    className="absolute inset-0"
                                    onClick={() => onEditorClose?.()}
                                />
                                <div className="relative w-full max-w-3xl rounded-[28px] border border-stone-300 bg-[#fdfbf7] shadow-2xl overflow-hidden">
                                    <div className="px-5 sm:px-6 py-4 border-b border-stone-200 bg-white flex items-start justify-between gap-4">
                                        <div className="min-w-0">
                                            <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400 font-bold">Ручная правка участника</div>
                                            <div className="mt-1 font-display text-2xl text-stone-800 truncate">
                                                {editorBootstrapLabel}
                                            </div>
                                            <div className="mt-2 text-[12px] leading-5 text-stone-500">
                                                {viewerLoadError
                                                    ? 'Не удалось быстро подготовить запись для редактирования.'
                                                    : 'Окно редактора уже открыто. Подтягиваю запись, найденного участника и фрагмент страницы.'}
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => onEditorClose?.()}
                                            className="shrink-0 w-10 h-10 rounded-full border border-stone-200 text-stone-400 hover:text-stone-700 hover:border-stone-400 hover:bg-stone-50 text-2xl leading-none"
                                            title="Закрыть"
                                        >
                                            ×
                                        </button>
                                    </div>
                                    <div className="px-5 sm:px-6 py-8 sm:py-10">
                                        {viewerLoadError ? (
                                            <div className="rounded-[24px] border border-[#ead8b0] bg-[#fffaf0] px-4 py-4 text-[13px] leading-6 text-stone-600">
                                                <div className="font-semibold text-stone-700">Запись не открылась автоматически</div>
                                                <div className="mt-2">{viewerLoadError}</div>
                                                <div className="mt-3 text-[12px] text-stone-500">
                                                    Можно закрыть окно и попробовать ещё раз. Если ошибка повторится, запись, вероятно, не имеет сохранённого structured-слоя.
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex flex-col items-center justify-center text-center">
                                                <div className="loader-paper"></div>
                                                <div className="mt-4 font-display text-stone-700 text-base">Готовлю редактор</div>
                                                <div className="mt-2 text-[12px] text-stone-500 max-w-lg leading-6">
                                                    Если у записи уже есть сохранённый structured-слой, окно откроется почти сразу. При первом обращении сервер может один раз дотянуть недостающие данные.
                                                </div>
                                                <div className="progress-bar-container mt-5 max-w-md w-full">
                                                    <div className="progress-bar" style={{width: `${Math.min(loadProgress, 100)}%`}}></div>
                                                </div>
                                                <div className="mt-2 text-xs text-stone-400">{Math.round(loadProgress)}%</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {editingStructuredPerson && (
                            <div className="fixed inset-0 z-[90] bg-black/45 backdrop-blur-[2px] p-4 sm:p-6 flex items-center justify-center">
                                <div
                                    className="absolute inset-0"
                                    onClick={cancelEditingStructuredPerson}
                                />
                                <div className="relative w-full max-w-6xl max-h-[calc(100vh-2rem)] sm:max-h-[calc(100vh-3rem)] bg-[#fdfbf7] border border-stone-300 shadow-2xl rounded-[28px] overflow-hidden flex flex-col">
                                    <div className="shrink-0 px-5 sm:px-6 py-4 border-b border-stone-200 bg-white flex items-start justify-between gap-4">
                                        <div className="min-w-0">
                                            <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400 font-bold">Ручная правка участника</div>
                                            <div className="mt-1 flex flex-wrap items-center gap-2">
                                                <span className="font-display text-2xl text-stone-800">{editingStructuredPersonDisplayName}</span>
                                                <span className="px-2.5 py-1 rounded-full bg-[#edf6ff] text-sky-800 border border-sky-200 text-[10px] font-bold uppercase tracking-wide">
                                                    {formatStructuredEntryType(editingStructuredEntry?.type)}
                                                </span>
                                                <span className="px-2.5 py-1 rounded-full bg-stone-100 text-stone-500 border border-stone-200 text-[10px] font-bold uppercase tracking-wide">
                                                    {formatStructuredPersonStatus(editingStructuredPerson?.status)}
                                                </span>
                                                {editingStructuredPersonHasAudit && (
                                                    <span className="px-2.5 py-1 rounded-full bg-[#fff7e8] text-stone-600 border border-[#ead8b0] text-[10px] font-bold uppercase tracking-wide">
                                                        Исправлено вручную
                                                    </span>
                                                )}
                                                {editingStructuredEntryType === 'DEATH' && editingStructuredEntryDeathCauseHasAudit && (
                                                    <span className="px-2.5 py-1 rounded-full bg-[#fff7e8] text-stone-600 border border-[#ead8b0] text-[10px] font-bold uppercase tracking-wide">
                                                        Причина исправлена
                                                    </span>
                                                )}
                                            </div>
                                            {editingStructuredPersonHasAudit && (
                                                <div className="mt-3 flex items-center gap-3 rounded-2xl border border-[#ead8b0] bg-[#fffaf0] px-3 py-2.5 w-fit max-w-full">
                                                    {editingStructuredPersonEditedBy.photo_url ? (
                                                        <img src={editingStructuredPersonEditedBy.photo_url} className="w-8 h-8 rounded-full border border-stone-200 shrink-0" />
                                                    ) : (
                                                        <div className="w-8 h-8 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-[11px] font-bold shrink-0">
                                                            {(editingStructuredPersonEditedBy.first_name || editingStructuredPersonEditedBy.username || '?').slice(0, 1).toUpperCase()}
                                                        </div>
                                                    )}
                                                    <div className="min-w-0">
                                                        <div className="text-[11px] font-semibold text-stone-600 truncate">
                                                            {editingStructuredPersonEditedBy.first_name || editingStructuredPersonEditedBy.username || 'Пользователь'}
                                                        </div>
                                                        <div className="text-[11px] text-stone-400">
                                                            {editingStructuredPersonEditedAtLabel || 'Дата не указана'}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <button
                                            onClick={cancelEditingStructuredPerson}
                                            className="shrink-0 w-10 h-10 rounded-full border border-stone-200 text-stone-400 hover:text-stone-700 hover:border-stone-400 hover:bg-stone-50 text-2xl leading-none"
                                            title="Закрыть"
                                        >
                                            ×
                                        </button>
                                    </div>

                                    <div className="flex-1 min-h-0 overflow-y-auto">
                                        <div className="p-5 sm:p-6">
                                            <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)_320px] gap-5 sm:gap-6 items-start">
                                                <section className="min-w-0">
                                                    <div className="flex flex-wrap items-center justify-between gap-3">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Запись на странице</div>
                                                        <div className="flex flex-wrap items-center gap-2">
                                                            <div className="flex items-center rounded-full border border-stone-200 bg-white shadow-sm">
                                                                <button
                                                                    onClick={() => setPreviewZoom(prev => clampNumber(prev / 1.12, 1, 3.5))}
                                                                    className="w-8 h-8 text-stone-500 hover:text-[#8b0000] hover:bg-[#fff5f1] rounded-l-full"
                                                                    title="Уменьшить"
                                                                >
                                                                    −
                                                                </button>
                                                                <div className="px-2 text-[11px] font-bold text-stone-600 min-w-[54px] text-center">
                                                                    {Math.round(previewZoom * 100)}%
                                                                </div>
                                                                <button
                                                                    onClick={() => setPreviewZoom(prev => clampNumber(prev * 1.12, 1, 3.5))}
                                                                    className="w-8 h-8 text-stone-500 hover:text-[#8b0000] hover:bg-[#fff5f1] rounded-r-full"
                                                                    title="Увеличить"
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                            <button
                                                                onClick={resetPreviewViewport}
                                                                className="rounded-full border border-stone-200 bg-white px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide text-stone-500 hover:border-[#8b0000] hover:text-[#8b0000]"
                                                            >
                                                                Центр
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="mt-3 rounded-[24px] border border-stone-200 bg-[#f6f1e8] p-3 sm:p-4">
                                                        {blobUrl && editingStructuredEntryCropBox && editingStructuredPreviewViewport && previewImageLoaded ? (
                                                            <div
                                                                className={`rounded-[18px] overflow-hidden border border-stone-200 bg-white shadow-sm touch-none ${isPreviewDragging ? 'cursor-grabbing' : 'cursor-grab'}`}
                                                                onWheel={handlePreviewWheel}
                                                                onPointerDown={handlePreviewPointerDown}
                                                                onPointerMove={handlePreviewPointerMove}
                                                                onPointerUp={stopPreviewDrag}
                                                                onPointerCancel={stopPreviewDrag}
                                                            >
                                                                <svg
                                                                    viewBox={`${editingStructuredPreviewViewport.x} ${editingStructuredPreviewViewport.y} ${editingStructuredPreviewViewport.width} ${editingStructuredPreviewViewport.height}`}
                                                                    preserveAspectRatio="xMidYMid meet"
                                                                    className="block w-full max-h-[38vh] bg-[#f8f3ea]"
                                                                >
                                                                    <image
                                                                        href={blobUrl}
                                                                        x="0"
                                                                        y="0"
                                                                        width={data.originalWidth}
                                                                        height={data.originalHeight}
                                                                        preserveAspectRatio="none"
                                                                    />
                                                                    <rect
                                                                        x={Math.max(0, Number(editingStructuredEntry?.bbox?.x || 0) - Math.max(10, Number(editingStructuredEntry?.bbox?.width || 0) * 0.03))}
                                                                        y={Math.max(0, Number(editingStructuredEntry?.bbox?.y || 0) - Math.max(10, Number(editingStructuredEntry?.bbox?.height || 0) * 0.05))}
                                                                        width={Number(editingStructuredEntry?.bbox?.width || 0) + Math.max(20, Number(editingStructuredEntry?.bbox?.width || 0) * 0.06)}
                                                                        height={Number(editingStructuredEntry?.bbox?.height || 0) + Math.max(20, Number(editingStructuredEntry?.bbox?.height || 0) * 0.1)}
                                                                        fill="rgba(255, 231, 107, 0.12)"
                                                                        stroke="rgba(14, 116, 144, 0.95)"
                                                                        strokeWidth="1.6"
                                                                        vectorEffect="non-scaling-stroke"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        ) : (
                                                            <div className="rounded-[18px] border border-dashed border-stone-300 bg-white/70 px-4 py-8 text-center">
                                                                <div className="flex flex-col items-center justify-center">
                                                                    <div className="loader-paper scale-[0.75] origin-center"></div>
                                                                    <div className="mt-4 text-[12px] font-semibold uppercase tracking-[0.14em] text-stone-500">
                                                                        Загружаем фрагмент
                                                                    </div>
                                                                    <div className="mt-2 text-[12px] leading-5 text-stone-400 max-w-sm">
                                                                        Подтягиваю снимок страницы и превью выделенной записи. Это может занять несколько секунд.
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="mt-3 text-[11px] leading-5 text-stone-500">
                                                            В рамке показана вся запись, из которой Яндекс выделил этого участника.
                                                        </div>
                                                        <div className="mt-2 text-[11px] leading-5 text-stone-400">
                                                            Превью можно увеличивать и двигать, чтобы свериться с оригиналом.
                                                        </div>
                                                    </div>
                                                </section>

                                                <section className="min-w-0">
                                                    <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Поля участника</div>
                                                    {getStructuredEntryPrimaryDateKind(editingStructuredEntry) && (
                                                        <div className="mt-3 rounded-[22px] border border-[#e7d5c2] bg-[#fffaf2] p-4">
                                                            <label className="block">
                                                                <div className="mb-1.5 text-[10px] uppercase tracking-[0.12em] text-[#8b0000] font-bold">
                                                                    {getStructuredEntryDateFieldLabel(editingStructuredEntryType)}
                                                                </div>
                                                                <input
                                                                    type="date"
                                                                    className="w-full rounded-2xl border border-stone-300 bg-white px-3 py-2.5 text-[13px] leading-5 text-stone-700 outline-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                                                    value={editingStructuredEventDateDraft}
                                                                    onChange={(e) => setEditingStructuredEventDateDraft(e.target.value)}
                                                                />
                                                            </label>
                                                            <div className="mt-2 text-[11px] leading-5 text-stone-500">
                                                                Это дата всей записи о событии. После сохранения она сразу участвует в дашборде, поиске и статистике интервалов между рождениями.
                                                            </div>
                                                            {editingStructuredEntryEventDateRecord?.source && (
                                                                <div className="mt-1 text-[10px] uppercase tracking-[0.1em] text-stone-400">
                                                                    Источник текущей даты: {editingStructuredEntryEventDateRecord.source === 'manual' ? 'ручная правка' : 'распознавание записи'}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
                                                        {STRUCTURED_PERSON_FIELD_CONFIG.map(field => (
                                                            <label key={field.key} className={`block ${field.key === 'geo' || field.key === 'other_status' || field.key === 'info' ? 'md:col-span-2' : ''}`}>
                                                                <div className="mb-1.5 text-[10px] uppercase tracking-[0.12em] text-stone-400 font-bold">{field.label}</div>
                                                                {field.type === 'select' ? (
                                                                    <select
                                                                        className="w-full rounded-2xl border border-stone-300 bg-white px-3 py-2.5 text-[13px] leading-5 text-stone-700 outline-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                                                        value={editingStructuredPersonDraft[field.key] || ''}
                                                                        onChange={(e) => setEditingStructuredPersonDraft(prev => ({
                                                                            ...prev,
                                                                            [field.key]: e.target.value
                                                                        }))}
                                                                    >
                                                                        {field.options.map(option => (
                                                                            <option key={option.value || 'empty'} value={option.value}>{option.label}</option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <input
                                                                        type="text"
                                                                        className="w-full rounded-2xl border border-stone-300 bg-white px-3 py-2.5 text-[13px] leading-5 text-stone-700 outline-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                                                        value={editingStructuredPersonDraft[field.key] || ''}
                                                                        placeholder={field.placeholder}
                                                                        onChange={(e) => setEditingStructuredPersonDraft(prev => ({
                                                                            ...prev,
                                                                            [field.key]: e.target.value
                                                                        }))}
                                                                    />
                                                                )}
                                                            </label>
                                                        ))}
                                                    </div>
                                                    {editingStructuredEntryType === 'DEATH' && (
                                                        <label className="mt-4 block">
                                                            <div className="mb-1.5 text-[10px] uppercase tracking-[0.12em] text-stone-400 font-bold">Причина смерти</div>
                                                            <input
                                                                type="text"
                                                                className="w-full rounded-2xl border border-stone-300 bg-white px-3 py-2.5 text-[13px] leading-5 text-stone-700 outline-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                                                value={editingStructuredDeathCauseDraft}
                                                                placeholder="от оспы"
                                                                onChange={(e) => setEditingStructuredDeathCauseDraft(e.target.value)}
                                                            />
                                                            <div className="mt-2 text-[11px] leading-5 text-stone-400">
                                                                Это поле относится ко всей записи о смерти и влияет на каталог, дашборд и статистику.
                                                            </div>
                                                        </label>
                                                    )}
                                                    <div className="mt-4 rounded-[24px] border border-stone-200 bg-white p-4">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Текущая сборка имени</div>
                                                        <div className="mt-2 text-[14px] font-semibold text-stone-700 leading-6">
                                                            {formatStructuredPersonName(editingStructuredPersonDraft) || 'Без имени'}
                                                        </div>
                                                    </div>
                                                </section>

                                                <aside className="min-w-0 space-y-5">
                                                    <div className="rounded-[24px] border border-stone-200 bg-white p-4">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Оригинальные данные</div>
                                                        <div className="mt-3 space-y-2">
                                                            {STRUCTURED_PERSON_FIELD_CONFIG.map(field => (
                                                                <div key={field.key}>
                                                                    <div className="text-[10px] uppercase tracking-[0.12em] text-stone-400 font-bold">{field.label}</div>
                                                                    <div className="mt-1 text-[12px] leading-5 text-stone-700 break-words">
                                                                        {editingStructuredPersonOriginal[field.key] || '—'}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            {editingStructuredEntryType === 'DEATH' && (
                                                                <div>
                                                                    <div className="text-[10px] uppercase tracking-[0.12em] text-stone-400 font-bold">Причина смерти</div>
                                                                    <div className="mt-1 text-[12px] leading-5 text-stone-700 break-words">
                                                                        {editingStructuredEntryOriginalDeathCause || '—'}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {getStructuredEntryPrimaryDateKind(editingStructuredEntry) && (
                                                                <div>
                                                                    <div className="text-[10px] uppercase tracking-[0.12em] text-stone-400 font-bold">
                                                                        {getStructuredEntryDateFieldLabel(editingStructuredEntryType)}
                                                                    </div>
                                                                    <div className="mt-1 text-[12px] leading-5 text-stone-700 break-words">
                                                                        {editingStructuredEntryOriginalDateRecord?.label || editingStructuredEntryOriginalDateRecord?.date || '—'}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="rounded-[24px] border border-stone-200 bg-white p-4">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">История правки</div>
                                                        {(editingStructuredPersonHasAudit || editingStructuredEntryDeathCauseHasAudit || editingStructuredEntryEventDateHasAudit) ? (
                                                            <div className="mt-3 space-y-3">
                                                                {editingStructuredPersonHasAudit && (
                                                                    <div className="flex items-center gap-3">
                                                                        {editingStructuredPersonEditedBy.photo_url ? (
                                                                            <img src={editingStructuredPersonEditedBy.photo_url} className="w-10 h-10 rounded-full border border-stone-200" />
                                                                        ) : (
                                                                            <div className="w-10 h-10 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-sm font-bold">
                                                                                {(editingStructuredPersonEditedBy.first_name || editingStructuredPersonEditedBy.username || '?').slice(0, 1).toUpperCase()}
                                                                            </div>
                                                                        )}
                                                                        <div className="min-w-0">
                                                                            <div className="text-[10px] uppercase tracking-[0.12em] text-stone-400 font-bold">Участник</div>
                                                                            <div className="text-[13px] font-semibold text-stone-700 truncate">
                                                                                {editingStructuredPersonEditedBy.first_name || editingStructuredPersonEditedBy.username || 'Пользователь'}
                                                                            </div>
                                                                            <div className="text-[11px] text-stone-400">
                                                                                {editingStructuredPersonEditedAtLabel || 'Дата не указана'}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {editingStructuredEntryDeathCauseHasAudit && (
                                                                    <div className="flex items-center gap-3">
                                                                        {editingStructuredEntryDeathCauseEditedBy.photo_url ? (
                                                                            <img src={editingStructuredEntryDeathCauseEditedBy.photo_url} className="w-10 h-10 rounded-full border border-stone-200" />
                                                                        ) : (
                                                                            <div className="w-10 h-10 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-sm font-bold">
                                                                                {(editingStructuredEntryDeathCauseEditedBy.first_name || editingStructuredEntryDeathCauseEditedBy.username || '?').slice(0, 1).toUpperCase()}
                                                                            </div>
                                                                        )}
                                                                        <div className="min-w-0">
                                                                            <div className="text-[10px] uppercase tracking-[0.12em] text-stone-400 font-bold">Причина смерти</div>
                                                                            <div className="text-[13px] font-semibold text-stone-700 truncate">
                                                                                {editingStructuredEntryDeathCauseEditedBy.first_name || editingStructuredEntryDeathCauseEditedBy.username || 'Пользователь'}
                                                                            </div>
                                                                            <div className="text-[11px] text-stone-400">
                                                                                {editingStructuredEntryDeathCauseEditedAtLabel || 'Дата не указана'}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {editingStructuredEntryEventDateHasAudit && (
                                                                    <div className="flex items-center gap-3">
                                                                        {editingStructuredEntryEventDateEditedBy.photo_url ? (
                                                                            <img src={editingStructuredEntryEventDateEditedBy.photo_url} className="w-10 h-10 rounded-full border border-stone-200" />
                                                                        ) : (
                                                                            <div className="w-10 h-10 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-sm font-bold">
                                                                                {(editingStructuredEntryEventDateEditedBy.first_name || editingStructuredEntryEventDateEditedBy.username || '?').slice(0, 1).toUpperCase()}
                                                                            </div>
                                                                        )}
                                                                        <div className="min-w-0">
                                                                            <div className="text-[10px] uppercase tracking-[0.12em] text-stone-400 font-bold">Точная дата события</div>
                                                                            <div className="text-[13px] font-semibold text-stone-700 truncate">
                                                                                {editingStructuredEntryEventDateEditedBy.first_name || editingStructuredEntryEventDateEditedBy.username || 'Пользователь'}
                                                                            </div>
                                                                            <div className="text-[11px] text-stone-400">
                                                                                {editingStructuredEntryEventDateEditedAtLabel || 'Дата не указана'}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div className="mt-3 text-[12px] text-stone-400 leading-5">
                                                                Эта запись пока не редактировалась вручную.
                                                            </div>
                                                        )}
                                                    </div>
                                                </aside>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="shrink-0 px-5 sm:px-6 py-4 border-t border-stone-200 bg-white flex flex-wrap items-center justify-between gap-3">
                                        <div className="text-[11px] text-stone-400">
                                            {formatStructuredEntryType(editingStructuredEntry?.type)} · {formatStructuredPersonStatus(editingStructuredPerson?.status)}
                                        </div>
                                        <div className="flex flex-wrap items-center gap-2">
                                            {(editingStructuredPersonEdited || editingStructuredEntryDeathCauseHasAudit || editingStructuredEntryEventDateHasAudit) && (
                                                <button
                                                    onClick={restoreOriginalStructuredPerson}
                                                    disabled={savingStructuredPersonEdit}
                                                    className={`rounded-xl px-3.5 py-2.5 text-[11px] font-bold uppercase tracking-wide border ${!savingStructuredPersonEdit ? 'bg-[#fff4ee] text-[#8b0000] border-[#e2b9ac] hover:bg-[#ffe9df]' : 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed'}`}
                                                >
                                                    Вернуть исходник
                                                </button>
                                            )}
                                            <button
                                                onClick={cancelEditingStructuredPerson}
                                                className="rounded-xl px-3.5 py-2.5 text-[11px] font-bold uppercase tracking-wide border border-stone-200 bg-white text-stone-500 hover:border-stone-400"
                                            >
                                                Отмена
                                            </button>
                                            <button
                                                onClick={saveStructuredPerson}
                                                disabled={savingStructuredPersonEdit || !editingStructuredRecordChanged}
                                                className={`rounded-xl px-4 py-2.5 text-[11px] font-bold uppercase tracking-wide border ${!savingStructuredPersonEdit && editingStructuredRecordChanged ? 'bg-[#8b0000] text-white border-[#8b0000] hover:bg-[#6f0000]' : 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed'}`}
                                            >
                                                Сохранить
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {!editorOnly && hiresModalOpen && (
                            <div className="fixed inset-0 z-[88] bg-black/45 backdrop-blur-[2px] p-4 sm:p-6 flex items-center justify-center">
                                <div
                                    className="absolute inset-0"
                                    onClick={() => setHiresModalOpen(false)}
                                />
                                <div className="relative w-full max-w-2xl max-h-[calc(100vh-2rem)] overflow-y-auto rounded-[28px] border border-stone-300 bg-[#fdfbf7] shadow-2xl">
                                    <div className="px-5 sm:px-6 py-5 border-b border-stone-200 bg-white">
                                        <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400 font-bold">Hi-res страницы</div>
                                        <div className="mt-1 font-display text-2xl text-stone-800">Собственный качественный снимок</div>
                                        <div className="mt-3 text-[12px] leading-6 text-stone-500">
                                            Если Яндекс отдает только мыльную миниатюру, можно сохранить свой hi-res для этой страницы. После этого каталог будет брать именно его.
                                        </div>
                                    </div>
                                    <div className="px-5 sm:px-6 py-5 space-y-5">
                                        <div className="rounded-2xl border border-stone-200 bg-white px-4 py-4">
                                            <div className="flex flex-wrap items-center gap-2">
                                                <span className={`px-2.5 py-1 rounded-full border text-[10px] font-bold uppercase tracking-wide ${hasHiresImage ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-stone-50 text-stone-500 border-stone-200'}`}>
                                                    {hasHiresImage ? 'Hi-res сохранён' : 'Hi-res пока нет'}
                                                </span>
                                                {data?.hiresImageSource && (
                                                    <span className="px-2.5 py-1 rounded-full bg-stone-50 text-stone-500 border border-stone-200 text-[10px] font-bold uppercase tracking-wide">
                                                        {data.hiresImageSource}
                                                    </span>
                                                )}
                                            </div>
                                            {hasHiresImage && (
                                                <div className="mt-3 text-[12px] text-stone-500 leading-6">
                                                    {hiresUpdatedLabel ? `Обновлено: ${hiresUpdatedLabel}. ` : ''}
                                                    Страница уже использует сохраненный hi-res вместо живого ответа Яндекса.
                                                </div>
                                            )}
                                        </div>

                                        <div className="grid gap-3 sm:grid-cols-3">
                                            <button
                                                onClick={() => hiresFileInputRef.current?.click()}
                                                disabled={hiresBusy}
                                                className={`rounded-2xl border px-4 py-4 text-left transition-colors ${!hiresBusy ? 'border-stone-200 bg-white hover:border-[#8b0000] hover:bg-[#fff9f6]' : 'border-stone-200 bg-stone-100 text-stone-300 cursor-not-allowed'}`}
                                            >
                                                <div className="text-[11px] font-bold uppercase tracking-[0.16em] text-stone-500">Файл</div>
                                                <div className="mt-2 text-sm font-semibold text-stone-800">Загрузить снимок с диска</div>
                                                <div className="mt-2 text-[12px] leading-5 text-stone-500">
                                                    Подходит PNG, JPEG или WebP. Нужен полный лист без обрезки.
                                                </div>
                                            </button>
                                            <button
                                                onClick={copyYandexHiresScript}
                                                disabled={hiresScriptBusy}
                                                className={`rounded-2xl border px-4 py-4 text-left transition-colors ${!hiresScriptBusy ? 'border-stone-200 bg-white hover:border-[#8b0000] hover:bg-[#fff9f6]' : 'border-stone-200 bg-stone-100 text-stone-300 cursor-not-allowed'}`}
                                            >
                                                <div className="text-[11px] font-bold uppercase tracking-[0.16em] text-stone-500">Helper</div>
                                                <div className="mt-2 text-sm font-semibold text-stone-800">Разовый JS для Яндекса</div>
                                                <div className="mt-2 text-[12px] leading-5 text-stone-500">
                                                    Открой страницу на Яндексе, вставь код в консоль браузера и дай ему автоматически найти оригинал и отправить hi-res сюда.
                                                </div>
                                            </button>
                                            <button
                                                onClick={copyYandexHiresCaptureScript}
                                                disabled={hiresCaptureScriptBusy}
                                                className={`rounded-2xl border px-4 py-4 text-left transition-colors ${!hiresCaptureScriptBusy ? 'border-stone-200 bg-white hover:border-[#8b0000] hover:bg-[#fff9f6]' : 'border-stone-200 bg-stone-100 text-stone-300 cursor-not-allowed'}`}
                                            >
                                                <div className="text-[11px] font-bold uppercase tracking-[0.16em] text-stone-500">Авто</div>
                                                <div className="mt-2 text-sm font-semibold text-stone-800">Авто-перехват для консоли</div>
                                                <div className="mt-2 text-[12px] leading-5 text-stone-500">
                                                    Вставь этот скрипт один раз в DevTools Console на вкладке Яндекса. Пока вкладка жива, hi-res будут ловиться автоматически по мере просмотра страниц.
                                                </div>
                                            </button>
                                        </div>

                                        <div className="rounded-2xl border border-stone-200 bg-white p-4">
                                            <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Signed URL</div>
                                            <div className="mt-2 text-[12px] leading-5 text-stone-500">
                                                Обычно helper пытается найти signed original URL сам. Если автоопределение не сработает, сюда можно вручную вставить ссылку вида <span className="font-mono text-[11px]">...type=original&amp;exp=...&amp;sig=...</span>.
                                            </div>
                                            <textarea
                                                value={hiresSignedUrlDraft}
                                                onChange={(event) => setHiresSignedUrlDraft(event.target.value)}
                                                placeholder="https://ya.ru/archive/api/image?id=...&type=original&exp=...&sig=..."
                                                className="mt-3 h-24 w-full rounded-2xl border border-stone-200 bg-[#fcfbf8] p-3 font-mono text-[11px] leading-5 text-stone-600 outline-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                            />
                                            {hiresSignedUrlDraft.trim() && !normalizeSignedYandexOriginalUrl(hiresSignedUrlDraft) && (
                                                <div className="mt-2 text-[11px] leading-5 text-amber-700">
                                                    Ссылка пока не похожа на signed original URL Яндекса. Нужен адрес с параметрами <span className="font-mono">exp</span> и <span className="font-mono">sig</span>.
                                                </div>
                                            )}
                                        </div>

                                        {hiresConsoleScript && (
                                            <div className="rounded-2xl border border-stone-200 bg-white p-4">
                                                <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Код для страницы Яндекса</div>
                                                <div className="mt-2 text-[12px] leading-5 text-stone-500">
                                                    В этом окне показывается либо разовый helper для консоли, либо скрипт длительного авто-перехвата для текущей вкладки Яндекса.
                                                </div>
                                                <textarea
                                                    readOnly
                                                    value={hiresConsoleScript}
                                                    className="mt-3 h-44 w-full rounded-2xl border border-stone-200 bg-[#fcfbf8] p-3 font-mono text-[11px] leading-5 text-stone-600 outline-none"
                                                />
                                            </div>
                                        )}

                                        {hasHiresImage && (
                                            <div className="rounded-2xl border border-[#ead8b0] bg-[#fffaf0] p-4">
                                                <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Возврат</div>
                                                <div className="mt-2 text-[12px] leading-5 text-stone-500">
                                                    В любой момент можно удалить сохраненный hi-res и вернуться к загрузке изображения напрямую из Яндекса.
                                                </div>
                                                <button
                                                    onClick={removeHiresImage}
                                                    disabled={hiresBusy}
                                                    className={`mt-3 rounded-xl px-3.5 py-2.5 text-[11px] font-bold uppercase tracking-wide border ${!hiresBusy ? 'bg-[#fff4ee] text-[#8b0000] border-[#e2b9ac] hover:bg-[#ffe9df]' : 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed'}`}
                                                >
                                                    Убрать hi-res
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    <div className="px-5 sm:px-6 py-4 border-t border-stone-200 bg-white flex items-center justify-end gap-2">
                                        <button
                                            onClick={() => refreshViewerData().catch(() => {})}
                                            className="rounded-xl px-3.5 py-2.5 text-[11px] font-bold uppercase tracking-wide border border-stone-200 bg-white text-stone-500 hover:border-stone-400"
                                        >
                                            Проверить cache
                                        </button>
                                        <button
                                            onClick={() => setHiresModalOpen(false)}
                                            className="rounded-xl px-4 py-2.5 text-[11px] font-bold uppercase tracking-wide border border-stone-200 bg-white text-stone-600 hover:border-stone-400"
                                        >
                                            Закрыть
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {editingFragment && (
                            <div className="fixed inset-0 z-[90] bg-black/45 backdrop-blur-[2px] p-4 sm:p-6 flex items-center justify-center">
                                <div
                                    className="absolute inset-0"
                                    onClick={cancelEditingFragment}
                                />
                                <div className="relative w-full max-w-5xl max-h-[calc(100vh-2rem)] sm:max-h-[calc(100vh-3rem)] bg-[#fdfbf7] border border-stone-300 shadow-2xl rounded-[28px] overflow-hidden flex flex-col">
                                    <div className="shrink-0 px-5 sm:px-6 py-4 border-b border-stone-200 bg-white flex items-start justify-between gap-4">
                                        <div className="min-w-0">
                                            <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400 font-bold">Ручная правка сниппета</div>
                                            <div className="mt-1 flex flex-wrap items-center gap-2">
                                                <span className="font-display text-2xl text-stone-800">Фрагмент {editingFragmentIndex + 1}</span>
                                                {editingFragmentColumnId && (
                                                    <span className="px-2.5 py-1 rounded-full bg-[#fdf0eb] text-[#8b0000] border border-[#e6c5bb] text-[10px] font-bold font-mono uppercase tracking-wide">
                                                        {editingFragmentColumnId}
                                                    </span>
                                                )}
                                                {editingFragmentHasAudit && (
                                                    <span className="px-2.5 py-1 rounded-full bg-[#fff7e8] text-stone-600 border border-[#ead8b0] text-[10px] font-bold uppercase tracking-wide">
                                                        Исправлено вручную
                                                    </span>
                                                )}
                                            </div>
                                            {editingFragmentHasAudit && (
                                                <div className="mt-3 flex items-center gap-3 rounded-2xl border border-[#ead8b0] bg-[#fffaf0] px-3 py-2.5 w-fit max-w-full">
                                                    {editingFragmentEditedBy.photo_url ? (
                                                        <img src={editingFragmentEditedBy.photo_url} className="w-8 h-8 rounded-full border border-stone-200 shrink-0" />
                                                    ) : (
                                                        <div className="w-8 h-8 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-[11px] font-bold shrink-0">
                                                            {(editingFragmentEditedBy.first_name || editingFragmentEditedBy.username || '?').slice(0, 1).toUpperCase()}
                                                        </div>
                                                    )}
                                                    <div className="min-w-0">
                                                        <div className="text-[11px] font-semibold text-stone-600 truncate">
                                                            {editingFragmentEditedBy.first_name || editingFragmentEditedBy.username || 'Пользователь'}
                                                        </div>
                                                        <div className="text-[11px] text-stone-400">
                                                            {editingFragmentEditedAtLabel || 'Дата не указана'}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <button
                                            onClick={cancelEditingFragment}
                                            className="shrink-0 w-10 h-10 rounded-full border border-stone-200 text-stone-400 hover:text-stone-700 hover:border-stone-400 hover:bg-stone-50 text-2xl leading-none"
                                            title="Закрыть"
                                        >
                                            ×
                                        </button>
                                    </div>

                                    <div className="flex-1 min-h-0 overflow-y-auto">
                                        <div className="p-5 sm:p-6 space-y-5">
                                            {showStructuredRecordFields && (
                                                <div className="rounded-[24px] border border-[#e7dcc5] bg-[#faf6ee] p-4 sm:p-5">
                                                    <div className="flex flex-wrap items-center justify-between gap-2">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Поля записи</div>
                                                        <div className="text-[11px] text-stone-400">Для mospriyut автозаполняются из текста</div>
                                                    </div>
                                                    <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3">
                                                        {MOSPRIYUT_RECORD_FIELD_CONFIG.map(field => (
                                                            <label key={field.key} className="block">
                                                                <div className="mb-1.5 text-[10px] uppercase tracking-[0.12em] text-stone-400 font-bold">{field.label}</div>
                                                                <input
                                                                    type="text"
                                                                    className="w-full rounded-2xl border border-stone-300 bg-white px-3 py-2.5 text-[12px] leading-4 text-stone-700 outline-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                                                    value={editingRecordFieldsDraft[field.key] || ''}
                                                                    placeholder={field.placeholder}
                                                                    onChange={(e) => setEditingRecordFieldsDraft(prev => ({
                                                                        ...prev,
                                                                        [field.key]: e.target.value
                                                                    }))}
                                                                />
                                                            </label>
                                                        ))}
                                                    </div>
                                                    <div className="mt-3 text-[11px] leading-5 text-stone-400">
                                                        Если текст ниже изменится, а эти поля ты не трогал, сервер пересоберёт их из обновлённой строки при сохранении.
                                                    </div>
                                                </div>
                                            )}

                                            <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,0.98fr)_minmax(0,1.02fr)_320px] gap-5 sm:gap-6 items-start">
                                                <section className="min-w-0">
                                                    <div className="min-w-0">
                                                        <div className="flex flex-wrap items-center justify-between gap-3">
                                                            <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Фрагмент на странице</div>
                                                            <div className="flex flex-wrap items-center gap-2">
                                                                <div className="flex items-center rounded-full border border-stone-200 bg-white shadow-sm">
                                                                    <button
                                                                        onClick={() => setPreviewZoom(prev => clampNumber(prev / 1.12, 1, 3.5))}
                                                                        className="w-8 h-8 text-stone-500 hover:text-[#8b0000] hover:bg-[#fff5f1] rounded-l-full"
                                                                        title="Уменьшить"
                                                                    >
                                                                        −
                                                                    </button>
                                                                    <div className="px-2 text-[11px] font-bold text-stone-600 min-w-[54px] text-center">
                                                                        {Math.round(previewZoom * 100)}%
                                                                    </div>
                                                                    <button
                                                                        onClick={() => setPreviewZoom(prev => clampNumber(prev * 1.12, 1, 3.5))}
                                                                        className="w-8 h-8 text-stone-500 hover:text-[#8b0000] hover:bg-[#fff5f1] rounded-r-full"
                                                                        title="Увеличить"
                                                                    >
                                                                        +
                                                                    </button>
                                                                </div>
                                                                <button
                                                                    onClick={resetPreviewViewport}
                                                                    className="rounded-full border border-stone-200 bg-white px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide text-stone-500 hover:border-[#8b0000] hover:text-[#8b0000]"
                                                                >
                                                                    Центр
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="mt-3 rounded-[24px] border border-stone-200 bg-[#f6f1e8] p-3 sm:p-4">
                                                            {blobUrl && editingFragmentCropBox && editingPreviewViewport ? (
                                                                <div
                                                                    className={`rounded-[18px] overflow-hidden border border-stone-200 bg-white shadow-sm touch-none ${isPreviewDragging ? 'cursor-grabbing' : 'cursor-grab'}`}
                                                                    onWheel={handlePreviewWheel}
                                                                    onPointerDown={handlePreviewPointerDown}
                                                                    onPointerMove={handlePreviewPointerMove}
                                                                    onPointerUp={stopPreviewDrag}
                                                                    onPointerCancel={stopPreviewDrag}
                                                                >
                                                                    <svg
                                                                        viewBox={`${editingPreviewViewport.x} ${editingPreviewViewport.y} ${editingPreviewViewport.width} ${editingPreviewViewport.height}`}
                                                                        preserveAspectRatio="xMidYMid meet"
                                                                        className="block w-full max-h-[38vh] bg-[#f8f3ea]"
                                                                    >
                                                                        <image
                                                                            href={blobUrl}
                                                                            x="0"
                                                                            y="0"
                                                                            width={data.originalWidth}
                                                                            height={data.originalHeight}
                                                                            preserveAspectRatio="none"
                                                                        />
                                                                        <rect
                                                                            x={Math.max(0, editingFragment.x - Math.max(12, editingFragment.width * 0.045))}
                                                                            y={Math.max(0, editingFragment.y - Math.max(14, editingFragment.height * 0.24))}
                                                                            width={editingFragment.width + Math.max(24, editingFragment.width * 0.09)}
                                                                            height={editingFragment.height + Math.max(28, editingFragment.height * 0.48)}
                                                                            fill="rgba(255, 231, 107, 0.14)"
                                                                            stroke="rgba(139, 0, 0, 0.95)"
                                                                            strokeWidth="1.6"
                                                                            vectorEffect="non-scaling-stroke"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            ) : (
                                                                <div className="rounded-[18px] border border-dashed border-stone-300 bg-white/70 px-4 py-8 text-center text-[12px] text-stone-400">
                                                                    Фрагмент изображения еще подгружается.
                                                                </div>
                                                            )}
                                                            <div className="mt-3 text-[11px] leading-5 text-stone-500">
                                                                В рамке показан исходный участок страницы, по которому был построен текущий сниппет.
                                                            </div>
                                                            <div className="mt-3 text-[11px] leading-5 text-stone-400">
                                                                Превью можно двигать мышью или трекпадом прямо внутри изображения.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>

                                                <section className="min-w-0">
                                                    <div className="min-w-0">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Текст сниппета</div>
                                                        <textarea
                                                            ref={editTextareaRef}
                                                            className="mt-3 w-full h-[min(42vh,360px)] min-h-[220px] rounded-[24px] border border-stone-300 bg-white px-4 py-4 text-[15px] leading-7 text-stone-800 outline-none resize-none focus:border-[#8b0000] focus:ring-2 focus:ring-[#8b0000]/10"
                                                            value={editingTextDraft}
                                                            onChange={e => setEditingTextDraft(e.target.value)}
                                                        />
                                                        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-[11px] text-stone-400">
                                                            <span>{editingTextDraft.trim().length} символов</span>
                                                            <span>{editingTextDraft.trim() ? editingTextDraft.trim().split(/\s+/).filter(Boolean).length : 0} слов</span>
                                                        </div>
                                                    </div>
                                                </section>

                                                <aside className="min-w-0 space-y-5">
                                                    <div className="rounded-[24px] border border-stone-200 bg-white p-4">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">Оригинальный OCR</div>
                                                        <div className="mt-3 text-[13px] leading-6 text-stone-700 whitespace-pre-wrap break-words">
                                                            {(editingFragment.original_text || editingFragment.text || '—')}
                                                        </div>
                                                    </div>
                                                    <div className="rounded-[24px] border border-stone-200 bg-white p-4">
                                                        <div className="text-[10px] uppercase tracking-[0.18em] text-stone-400 font-bold">История правки</div>
                                                        {editingFragmentHasAudit ? (
                                                            <div className="mt-3 flex items-center gap-3">
                                                                {editingFragmentEditedBy.photo_url ? (
                                                                    <img src={editingFragmentEditedBy.photo_url} className="w-10 h-10 rounded-full border border-stone-200" />
                                                                ) : (
                                                                    <div className="w-10 h-10 rounded-full bg-stone-300 text-stone-600 flex items-center justify-center text-sm font-bold">
                                                                        {(editingFragmentEditedBy.first_name || editingFragmentEditedBy.username || '?').slice(0, 1).toUpperCase()}
                                                                    </div>
                                                                )}
                                                                <div className="min-w-0">
                                                                    <div className="text-[13px] font-semibold text-stone-700 truncate">
                                                                        {editingFragmentEditedBy.first_name || editingFragmentEditedBy.username || 'Пользователь'}
                                                                    </div>
                                                                    <div className="text-[11px] text-stone-400">
                                                                        {editingFragmentEditedAtLabel || 'Дата не указана'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="mt-3 text-[12px] text-stone-400 leading-5">
                                                                Этот фрагмент пока не редактировался вручную.
                                                            </div>
                                                        )}
                                                    </div>
                                                </aside>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="shrink-0 px-5 sm:px-6 py-4 border-t border-stone-200 bg-white flex flex-wrap items-center justify-between gap-3">
                                        <div className="text-[11px] text-stone-400">
                                            Фрагмент {editingFragmentIndex + 1}{editingFragmentColumnId ? ` · ${editingFragmentColumnId}` : ''}
                                        </div>
                                        <div className="flex flex-wrap items-center gap-2">
                                            {editingFragmentEdited && (editingFragment.original_text || '').trim() && (
                                                <button
                                                    onClick={() => restoreOriginalFragmentText(editingFragmentIndex)}
                                                    disabled={savingTextEdit}
                                                    className={`rounded-xl px-3.5 py-2.5 text-[11px] font-bold uppercase tracking-wide border ${!savingTextEdit ? 'bg-[#fff4ee] text-[#8b0000] border-[#e2b9ac] hover:bg-[#ffe9df]' : 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed'}`}
                                                >
                                                    Вернуть OCR
                                                </button>
                                            )}
                                            <button
                                                onClick={cancelEditingFragment}
                                                className="rounded-xl px-3.5 py-2.5 text-[11px] font-bold uppercase tracking-wide border border-stone-200 bg-white text-stone-500 hover:border-stone-400"
                                            >
                                                Отмена
                                            </button>
                                            <button
                                                onClick={() => saveFragmentText(editingFragmentIndex)}
                                                disabled={!editingTextDraft.trim() || savingTextEdit}
                                                className={`rounded-xl px-4 py-2.5 text-[11px] font-bold uppercase tracking-wide border ${editingTextDraft.trim() && !savingTextEdit ? 'bg-[#8b0000] text-white border-[#8b0000] hover:bg-[#6f0000]' : 'bg-stone-100 text-stone-300 border-stone-200 cursor-not-allowed'}`}
                                            >
                                                Сохранить
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
            );
        };

        // === APP ===
        const App = () => {
            const [user, setUser] = useState(null);
            const [view, setView] = useState('landing');
            const [loading, setLoading] = useState(true);
            const [authProviders, setAuthProviders] = useState(DEFAULT_AUTH_PROVIDERS);

            useEffect(() => {
                fetch(`${API_BASE}/me`).then(r => r.json()).then(u => {
                    setAuthProviders(u.auth_providers || DEFAULT_AUTH_PROVIDERS);
                    if (u.authenticated) {
                        setUser(u.user); window.__currentUser = u.user;
                        // Авторизован — сразу в workspace
                        setView('workspace');
                    }
                    setLoading(false);
                });
            }, []);

            if (loading) return <div className="h-screen flex items-center justify-center bg-[#fdfbf7]"><div className="loader-paper"></div></div>;
            
            // Не авторизован — только логин
            if (!user) {
                return <LandingPage user={null} authProviders={authProviders} onSelect={() => {}} />;
            }
            
            if (view === 'workspace') {
                const pid = window.location.pathname.replace(BASE_PATH, '').split('/').filter(Boolean)[0];
                return <Workspace user={user} initialPid={pid} onBack={() => { setView('landing'); window.history.pushState({}, '', BASE_PATH); }} />;
            }
            
            return <LandingPage user={user} authProviders={authProviders} onSelect={() => {
                setView('workspace');
            }} />;
        };

        ReactDOM.createRoot(document.getElementById("root")).render(<App />);
